module.exports={
"label_emailtocloudcc_department":`지부`,
"label.wei.weiresearch":`투표`,
"message.error.appsecret.null":``,
"label.file.orderbylastmodifydate":`수정한 일자로 정렬하기`,
"label.minus":`-마이너스`,
"label.horizontalbar":`수평 바`,
"label.emailobject.emailsentfailed":`메일 전송 실패!`,
"assignedresource.check":``,
"label.finish":`완성`,
"label.document.history":`다운로드 이력`,
"label.customfields.number.numberLengthHelpText":`1.숫자의 길이와 소수 자릿수를 입력합니다.예를 들어 입력 길이는 8, 소수 자릿수는 2입니다. 수용 가능한 최대 자릿수는 12345678.90입니다"`,
"label.standard.buttonandlink.info":`표준 버튼과 링크를 변경하는 것이 CloudCC URL과 이 URL에 대한 모든 호출(예,CloudCC페이지, 브라우저 단축 아이콘이나 외부 시스템 )의 의미를 변경했습니다.CloudCC의 사용자 설정 페이지를 사용해 표준 버튼이나 링크의 CloudCC URL을 대체할 수 있습니다.`,
"front-epwechat-module-v1-contacts-desc":``,
"label.mr.caption.contact.result":`중복 검사 병합: 연락담당자 중복 데이터의 결과를 조회합니다`,
"label.ems.selectaccount":`계정 선택`,
"label.group.no.activity":`매칭하는 활동 그룹이 없습니다.`,
"label.call.for":`초대자`,
"label.newreportguide":`보고서 가이드라인 새로만들기`,
"component.telerecord.label.name":`성명`,
"vue.add.dashboard.component":``,
"label.chatter.sendEmailToGroupMember.check.V":``,
"UG.ST.002":`확인`,
"label.setting.intergrationmanage":``,
"label.field.apiname.validate":`0-6 간의 숫자 한개를 입력하세요`,
"label.emailmerge.list.deletefolder":`폴더 삭제`,
"vue_label_pool_received":`수령됨`,
"label_emailtocloudcc_step1_case1":`메일이 개별안 생성`,
"message.sumlength":`길이와 소수 자릿수가 18자리를 초과할 수 없습니다`,
"vue_label_approve_reassignapproval":`{name}이 승인을 {people}로 재분배함`,
"label.specify.time":``,
"vue_label_report_sortdown":`내림차순으로 정렬`,
"chatter.login.now":`업로드 중...`,
"label.import.page2.notsuited":`매핑되지 않음`,
"label.please.fill.out":``,
"label.recordtype.edit.description":`'사용 가능한 값' 리스트에서 하나를 선택하고, 이 기록 유형의 선택항목 리스트값으로 '선택된 값' 리스트에 추가합니다.주의: 선택항목 리스트에서 한 항목을 삭제하면 기존 기록에서 삭제되지 않습니다.마지막으로, 이 기록 유형의 기본 설정 선택항목 리스트값을 선택하십시오"`,
"label.customer.tab.new":`사용자 설정 메뉴 새로 만들기`,
"label.sameas":`및`,
"front-filter-module-v1-filter-a-week-ago":``,
"label.processsetting.disable.process.failed":``,
"label.summaryreport.2018.step4":`4단계: 보고서 기준을 선택합니다`,
"label.secrecyinfo":`비밀 정보 - 유포하지 마십시오`,
"label.custom.page.component.general.settings":`구성요소 일반 설정`,
"label.ccpeak.folder":`미보관 클래스 폴더`,
"vue_label_homepage_select_button_operation":`작업 항목 버튼 선택`,
"message.pleaseinputrightdistance":`정확한 간격 일수를 기입해 주세요`,
"label.mobile.phone.required.short":`필수 입력 항목`,
"vue_label_account_equityseructure":``,
"label.file.library.error1":`본 파일이 본 문서 라이브러리에 존재합니다`,
"fliter.nextmonth":`다음 달`,
"label.mr.descreption.oneGroupNote2":`그룹 업체 정보, 총`,
"label.allfolderdashboard":`모든 대시보드 폴더`,
"lable.opppdt.selPdt.bykeywords":`키워드대로`,
"setup_layout_label_selectedfield":`필드 선정`,
"label.file.preview.convert.firstpage.failure":`미리 보기에 오류가 발생해 미리보기 상세 정보를 클릭하거나 다운로드해서 확인하세요`,
"vue_label_systemSettings_companie":``,
"label.loginhis.recently":`최근 로그인 이력`,
"label.permission.visualpagepermission.edit":`사용자 설정 페이지 분배`,
"label.ccservice.validate.email":`대상API가 {0}의 {1}필드 대응값은 {2}이며 형식이 잘못되어 정확한 메일 주소를 입력하세요!`,
"label.sms.companyname.gm":`CHUANG MING인터텟 문자 인터페이스`,
"lable.opppdt.addpdt.table.discount":`할인(%off)`,
"Lead.Scoring.Setting.LevelSetting":`잠재 고객 열도 설정`,
"message.duplication.label.duplicationremark":`신규 또는 편집 기록 저장 시 중복 데이터를 조회하는 작업입니다.`,
"label.file.preview.error":`미리보기에 오류가 발생해 다운로드해서 확인하세요`,
"label.imgfield.type.input":`이미지 입력`,
"label.file.share.email.content1":`파일 명칭：#filename`,
"vue_label_notice_batchedit_fail":``,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`넷째 주일`,
"label.view.sortview.printview":`뷰 인쇄`,
"label.projectManagement.Addposttask":``,
"vue_label_commonobjects_view_fail":`기본 뷰 설정 실패`,
"label.dayinweek":`개 주일의`,
"label.layout.notexist":`레이아웃이 존재하지 않습니다`,
"label.brief.total":`기록{total}개`,
"label.dashboardSetup.tz.bb":`보고서로 이동`,
"label_emailtocloudcc_select3":`기록 소유인을 선택하세요`,
"label.input.least.string":`최소 {0}개 문자부호를 입력하세요`,
"label.app.step2":`2단계. 상세 정보를 입력합니다`,
"lable.account.LastWeek":`지난 주일`,
"label.notifications":``,
"label.tabpage.viewname":`뷰 명칭`,
"label.knowledge.language.italian":``,
"label.sendmail.step2.introduce":`원하는 메일 템플릿을 선택하세요.`,
"label_enable_or_no":``,
"pagecreator_button_save":`저장`,
"template.chart.cplb":``,
"label.knowledge.publish":``,
"label.name.required":``,
"component.chatter.label.myfans":`나의 팔로어`,
"label.rejectoperate":`조작 거절`,
"label.report.action.addtodashboard3":`대시보드 선택`,
"label.icon.101":`교과서`,
"label.data.exp.su.ok":`시스템에서 내보내는 중입니다`,
"label.appupload.component.type.layout":`페이지 레이아웃`,
"template.chart.yscb":``,
"label.tabularreport.selectorder":`보고서열의 보기 순서 확인`,
"email.title.one":`비밀번호 찾기`,
"label.case.copy.link":``,
"label.mr.descreption.oneGroupReData4":`그룹, 남아 있습니다`,
"label.newprocess5.error.des":`숫자만 입력할 수 있습니다`,
"label.partnerCloud.loginButton":``,
"label.interfaceconstraint.adminonly":`시스템 관리자만 해당 인터페이스를 사용할 수 있습니다`,
"label.campaign.channel.input.date":`2. 마케팅 채널에 유효기간을 설정해 주세요:`,
"label.clientwebsiteentranceprofile":`고객 사이트 입구 프로필`,
"UG.opportunity.011":`거래 불러오기`,
"label.page.copy.value.paste.template":`다음 템플릿에 병합 필드값을 복사 및 붙여놓습니다.`,
"label.notselect":`미선정`,
"label.weixin.input.password":`비밀번호를 입력하세요`,
"label.email.select.template":`템플릿 선택`,
"label_chatter_ok":`확인`,
"permissionService.error":``,
"label.webtocloudcc.sorry":`죄송합니다. 페이지에 이상이 발생했습니다. 다시 시도하거나 관리자에게 연락하세요!`,
"UG.opportunity.007":`담당자 역할`,
"label.manageAll.forapproval":`승인 대기`,
"label.imgfield.type.ref":`공식 이미지`,
"label.profile.setcustomtab":`사용자 설정 메뉴 설정`,
"label.tabpage.datatyoez":`데이터 유형`,
"label.partnerCloud.basicSetting.editPersonal":``,
"label.mr.caption.account":`중복 검사 병합: 고객 중복데이터를 조회하는 조건`,
"message.serviceterritoryMe.time.violation":``,
"pagecreator_page_message_publish_success":`페이지 발표 성공`,
"label.field.formula.timezonetip":`날짜 시간 유형 함수의 멀티타임 지원에 주의하십시오.공식에서 SYSDATE와 같은 시스템 함수를 사용하여 현재 시간을 가져오는 경우에는 CURRENT_DATE와 같은 대응한 멀티타임 지원 함수로 대체해야 합니다.`,
"label.marketseamemset.specialuser":`특수 멤버`,
"label.staticresource.message":`정지 리소스 상세 정보`,
"label.workflow.rulecondition":`규칙 조건`,
"component_salesperformance_label_nodata":`업무 기회를 추가한 다음 다시 돌아와서 실적표를 보십시오.`,
"label.customfields.textarea.tip":`사용자가 여러 행의 텍스트를 입력할 수 있어 최대 4000개 문자부호를 입력할 수 있습니다.`,
"font-evaluate-module-v1-template":``,
"label.step3.total5":`3단계, 총 5단계`,
"label.customfields.formula.percent.tip":`백분율을 계산하여 자동으로 숫자에 대해 백분부를 추가합니다`,
"label.sortdesc":`내림차순`,
"lable.PowerProcess.edit":``,
"label.dongshifang.description":`DONG SHI FANG 문자 인터페이스 정보를 배치해 귀사의 문자 업무 수요를 만족시킵니다.`,
"label.chatter.addressee":`수신자`,
"vue_label_systemSettings_obj2":``,
"label.selectreporttype.tip":`보고서에 포함되고 싶은 데이터 유형을 선택합니다`,
"label.version.enterprise":`기업 버전`,
"label.area.add":`구역 추가`,
"label.h5.bookmarked":``,
"label.step5.total7":`5단계, 총 7단계`,
"front-lightning-module-v1-title-quotation":``,
"label.search.onlymyrecords":`내가 보유한 프로젝트에 한정됨`,
"vue_label_commonobjects_noduplication":`{기록}에서 {필드}와 중복`,
"label.customerpage.edit":`사용자 설정 페이지 메뉴를 편집합니다`,
"message.please.choose.user":`사용자를 선택하세요`,
"label.approval.his.currentactor":`현재 승인자`,
"label.field.duplicate.error.msg3":`최대 3개 특유 속성 필드만 생성할 수 있습니다.`,
"label.page_url":``,
"label.permission.goback":`권한 세트 요약으로 돌아가기`,
"vue_label_commonobjects_view_kanban_notice2":`모든 기록을 확인하려면 리스트나 분할 화면 뷰를 사용하세요.`,
"label.group.no.recent.searchs":`매칭된 최근 그룹 보기 이력이 없습니다.`,
"label.event.fiducial.point":`정각`,
"label.integrations.mailchimp.addtolist":`CloudCC의 잠재고객과 연락담당자를 Mailchimp 수신인 리스트에 추가합니다`,
"label.workflow.configrule.introduce":`규칙명, 비고, 업무프로세스 규칙을 작동시키는 조건을 입력하십시오.다음 단계에서는 업무프로세스 조작을 이 업무프로세스 규칙과 관련시킵니다.`,
"label.icon.161":`가죽 상자`,
"label.recordtype.enable":`사용`,
"label_mailboxes_limit":``,
"label.notification.time3":`{0}시간 전`,
"label.setsharerule.step2":`2단계: 공유 조건을 선택합니다`,
"vue_label_homepage_somecomponents":`경고! 구성 요소를 추가한 후 높이가 초과되어 내용을 볼 수 없으며 일부 구성 요소를 삭제하세요.`,
"label.icon.63":`우물`,
"label.use.standard.sharerules":``,
"label.button.step2.select.required.field":`2단계: 필수 입력 필드를 선택합니다`,
"lable.Confirm.collect.potential.customers":``,
"label.version.sum.custompage":`개 사용자 설정 페이지`,
"label.file.ccchat.changefile":`파일 변경`,
"label.mobile.phone.phone.call":`전화하기`,
"label.appupload.managed.img":`피 관리`,
"vue_label_chatter_comment":`댓글`,
"label.central.european.time":`중부 유럽 시간`,
"label.three.quarter":``,
"label.service.newBuildDialog.filter.editor":``,
"pagecreator_systemstyle_funcpath":`/빌더/브랜드화 양식 라이브러리`,
"label_chatter_collect":`저장`,
"label.custom.page.component.window.settings":`구성요소 윈도우 설정`,
"component_chatter_file_label_title":`파일 업로드`,
"label.marketsea.button.discard":`폐기`,
"label.Batch.input":``,
"vue_label_campaign_market_members":`현재 마케팅 행사 멤버`,
"label.salescloud.salesdashboard":`세일즈 간판`,
"message.summaryconditionrepeated":`종합 조건이 중복되오니 다시 선택하세요!`,
"label.tianyancha.h5.companycode":`회사 코드`,
"label.quickbooks.description":`QuickBooks 계정 정보를 배치해 온라인 영수증 결제 상황을 팔로우업합니다.`,
"label.colombia.time":`콜롬비아 시간`,
"label.usermanage.unknown.license":`미지의 허가증임으로 사용자를 생성할 수 없어 시스템 관리자에게 연락하세요!`,
"label.operatedata.selectoperateandobject":`작업( 불러오거나 내보내기)을 선택하고 대상을 선택하십시오`,
"message.setup.field.picklist.valuerepeated":`리스트값은 중복이 될 수 없어 다시 입력하세요!`,
"label.editerror.list":`편집되지 않은 데이터 리스트`,
"pagecreator_page_message_save_success":`페이지 저장 성공`,
"label.icon.154":`컴퓨터`,
"label.emailsync.setting":`개인 메일 설정`,
"label.startuploadfile.step2":`3단계. "업로드 시작"버튼을 눌러 파일을 업로드합니다`,
"label.dashboard.notmeet.conditions":`조건에 맞는 정보가 없습니다. 아직 대시보드가 설치되지 않았습니다!`,
"label.temp.del.conf":`삭제하시겠습니까?`,
"label.sms.authkey":`인증 비밀번호`,
"lable.oppt.jieduan.choosejieduan":`종료 단계 선택`,
"label.tabpage.viewNamez":`뷰 명칭을 입력하세요`,
"label.totalQuotation":``,
"label.tabpage.hoursagoz":`시간 전`,
"label.receiveadminnews":`수신   관리자 뉴스 브리핑`,
"label.field.is.lookup":`필드가 조회 필드와 관련 여부`,
"label.any_changes":``,
"lable.products.to.assets":``,
"label.dashboard.compare":``,
"vue_label_chatter_notice1":`그룹을 삭제한 후 그룹에서의 모든 정보가 삭제되며 그룹 파일이 삭제되지 않습니다.`,
"label_tabpage_exitz":`로그아웃`,
"label.potentialcustomerflow":`잠재고객 프로세스`,
"label.longtext":`긴 텍스트 에어리어`,
"october":`10월`,
"label.customer.email":`메일`,
"label.partnerCloud.productSet.addChildren":``,
"label.defaultline.cannot.greater":`기본 행 수는 30을 초과할 수 없습니다`,
"front-detail-module-v1-view-report":``,
"label.knowledge.setting.hint.sixteen":``,
"label.page.use.merged.field":`병합 필드를 사용합니다`,
"label.salescloud.salescloud.continuerecover":`계속하면 삭제되며 복구가 불가능합니다 :`,
"front-project-module-v1-from-template-create":``,
"label.exportall":`모두 내보내기`,
"label.weixin.recalculate.shared.results":`공유 규칙 결과 다시 연산`,
"label.components.isTemplate":``,
"label_emailsync_status":`사용자 메일 상태 통계`,
"label.file.library.delete":`{librayrname} 삭제하시겠습니까?`,
"label.integrations.username":`사용자명`,
"front-lightningset-module-v1-detail-page-report-chart":``,
"label_tabular":``,
"label.approverecords":`승인 기록`,
"vue_label_helpcenter_topic":`lightning 버전의 사용 및 도움말`,
"label.h5.date.none":`-없음-`,
"lable.outlook.mcto.allrecord":`모든 기록`,
"label.readandwrite":`읽기/쓰기`,
"label.allfold":`모두 접기`,
"AD":`주소`,
"message.custom.field.donotdelete.reporttype":`해당 필드가 보고서 데이터 소스에 인용되었습니다`,
"label.escalation.setup.newaction.title":`업그레이드 조작 편집`,
"label.dashboard.snapshot.settings":`대시보드 스냅숏 설정`,
"label.attendance.inner":`내근`,
"chatter.ns":`새 메시지`,
"label.validate.nowork":`에러: 무효 필드이며 다시 선택하세요 잘못된 위치`,
"label.custom.EmptyCanvas":``,
"label.service.miniProgram.fillImageOrder":``,
"label.icon.16":`수리`,
"label.selected":`선택함`,
"component_chatter_link_label_name":`링크 명칭`,
"label.reportsSubscriptionPage.schedulereport.starttime":`시작 시간`,
"label.file.uploadNewVersion":`신버전 업로드`,
"chatter.group.theMembership":`멤버 관계`,
"label.knowledge.recommended.articles":``,
"label.appupload.install.parentobj":`소속 대상`,
"label.file.recent":`최근`,
"vue_label_helpcenter_quote":`견적서는 귀사 제품 및 서비스의 권장 가격을 표시한다. 업무 기회 및 제품에서 견적서를 생성할 수 있다. <br>자세 정보의 우상측에서 버튼을 통하여 업무기회를 견적서와 동기화시키거나 견적서를 업무기회와 동기화시킬 수 있다. 견적서와 업무기회가 통일될 때 견적서에 대한 모든 조정이 업무 기회 제품과도 동기화되며 반대로도 적용된다. 업무 기회마다 많은 관련 견적서가 있을 수 있어 어느한 견적서가 업무 기회와 동기화시킬 수 있다. <br>자세 정보 우상측에서 견적서를 pdf 로 생성하여 미리 볼 수 있으며 인쇄, 다운로드나 저장할 수 있도 있다.`,
"message.error.field.default":`기본값이 자연수여야 합니다`,
"label.campaignmember.main.importmember.contacts.desc":`파일의 데이터를 이 마케팅 행사 연락담당자에 불러옵니다`,
"vue_label_calendar_show_only_this_calendar":`본 캘린더만 보기`,
"vue_label_quot_syncfrom":`업무 기회 동기화`,
"label.data.expnode.e_desc2":`2. 템플릿으로 내보냅니다: 사용자가 템플릿을 선택해 데이터를 내보낼 수 있습니다.`,
"label.login.verification.mfa.desc1":`스마트 장치에 MFA 프로그램을 설치해야 계속 실행할 수 있습니다.스마트 디바이스에서 MFA를 지원하는 상용 앱으로는 YANG CONG, Google Authenticator가 있습니다.`,
"label.jiandangfenpei.desc":`현재 사용자 설정 페이지에 대한 프로필의 방문 권한을 분배합니다.시스템 관리자는 모든 사용자 설정 페이지에 접근할 수 있습니다.`,
"label_tabpage_thisrecord":`이 기록`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`누적 대금 수령 금액`,
"message.error.object.notvalidcurrency":`무효한 화폐 종류`,
"label.edit.discount":``,
"label.setup.mobile.offlinecache.setenable":`모바일기기 오프라인 기능 사용`,
"UG.ST.005":`알겠습니다. 더 이상 본 폐이지가 표시되지 않아 직접 들어갑니다.`,
"label.assignedapprover":`승인자가 분배됐습니다`,
"template.chart.htlx":``,
"scope":`범위 내에`,
"label.workmate.search":`동료 검색`,
"message.validation.isnotdigits":`정확한 숫자를 입력하세요`,
"label.ccpeak.use.class.time.page":`사용자 설정 페이지에서 이 종류를 호출하려면 PageClsInvoker 종류의 invoker()방식을 호출해야 합니다`,
"setup_mainpage_label_welcome27":`CloudCC 클라우드 플랫폼이 시스템 내에서 모든 대상 데이터 불러오기, 내보내기, 데이터 모두 삭제, 모두 이동 등 기능을 제공합니다.`,
"front-epwechat-module-v1-epwechat-integrate":``,
"label.file.publiclink":`공용 링크`,
"front-epwechat-module-v1-input-name":``,
"lable.Number.of.columns":``,
"message.error.dev.service.duplicateparameter":`서비스 파라미터가 중복되었습니다!`,
"label.projectManagement.percent.complete":``,
"label.chatter.nextSevenday":`향후 7일`,
"chatter.feed.myfollowers":`나의 팔로워`,
"label.bacchtransfer.pleaseselecttouser":`사용자로 이동을 선택하세요`,
"label_partner_workspace_member_memo":`선택한 프로필, 권한 세트의 모든 사용자가 이 파트너 클라우드에 접근할 수 있습니다.`,
"label.marketsea.chosen.member":`선택한 멤버`,
"label.marketsea.assignment.setup":`분배 설정`,
"label.myaccount":``,
"label.schedulejob.setup.schedule.executedate":`실행 시간`,
"label.uploadaccessory":`첨부파일 업로드`,
"Homepage.News.004":`뉴스 없음`,
"label.marketsea.name":`고객풀 명칭`,
"label.pending.task":`대기 업무`,
"label.report.details":`자세 정보`,
"UG.homepage.008":`현재 업무 상태를 파악하며(판매 브리핑, 랭킹, 세일즈 퍼널 등), 문제가 있는 업무 기회를 확인하여 미래 실적의 달성 상황을 예측하고 중요 업무를 처리하고 분배하여 현명하게 판단합니다.`,
"label.h5.similar.opportunity.clear.all":`모두 삭제`,
"label.tabpage.noz":`아니오`,
"label.report.recent.all.reports":`모든 보고서`,
"vue_label_lead_to_score":`채점을 클릭하여 뷰에서의 잠재 고객에게 채점합니다.`,
"vue_label_normal_receivable_sf":`대금 수령 게획`,
"label.layout.edittabdistribute":`메뉴 레이아웃 편집`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(field)`,
"label.salescloud.field.editoptionlist":`선택 항목 리스트 편집`,
"APPIntegration.Dropbox.01":`Dropbox에서 파일 선택`,
"label.campaign.channel.step2":`2단계: 마케팅 채널 잠재 고객 필드 기본값 설정`,
"label_partner_new_function":`기능 설명`,
"vue_label_chat_no_search_results":`검색 결과가 없습니다`,
"vue_label_commonobjects_detail_visitstate":`방문 상태`,
"label.sendemail.send.testemail":`이것은 테스트 메일입니다. 이 메일을 받을 수 있으면 이 메일을 사용할 수 있다는 것을 증명합니다.`,
"label.attendance.clear.position":`포지션 비우기`,
"chatter.write.n":`주석 편집...`,
"label_chatter_sendmail":`메일 전송`,
"label.remindertime":`알림 시간`,
"label.app.elegantgray":`그레이`,
"label.tabpage.ownedz":`공유`,
"label.select.approval":`승인자 선택`,
"UG.Lead.007":`구글 동기화`,
"chatter.emailSetUp":`나의 CCChat 알림 설정`,
"label.default.censor":``,
"vue_label_notice_uploadavatar_success":`프로필 업로드 성공`,
"label.sms.title":`문자 메시지 인터페이스 정보`,
"front-console-choose-contact":``,
"label.field.edit.des":`최대 평점이 별 아이콘의 수량을 결정하여 최대 평점은 100 입니다`,
"label.pw.big.letter":``,
"label.select.time.dimension":``,
"UG_Campaign_004":`마케팅 행사 불러오기`,
"label.dashboard.summary":`도량`,
"label.ems.yahoo":`야후`,
"label.leadscore.rule.name":`채점 규칙 명칭`,
"vue_label_calendar_object_name":`대상 명칭`,
"label.icon.69":`기계`,
"label.reporttotal":`합계`,
"lable.SalesCommitmentKanBan.theActualContract":`실제 계약 체결액`,
"label.project.member.data":``,
"label.cloudccclass.list.viewremark":`사용 설명 보기`,
"label.deleteObject.isNotAdministrator":`시스템 관리자가 아니어 대상을 삭제할 수 없습니다.`,
"lable.edit.queue.nameandemail":`대열 명칭과 메일 주소`,
"label.recordtype.tabname":`기록 유형`,
"label.file.is.ok":`확인하시겠습니까`,
"label.knowledge.language.german":``,
"label.layout.realityapprover":`실제 승인자`,
"label.ems.with7day":`7일 내`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`설정`,
"label.weixin.edit.polls":`투표 수정`,
"label.layout.mobile.default.tab":`핸드폰 기본 메뉴를 선택합니다`,
"vue_label_report_deletegroupcolumn":`열 그룹 삭제`,
"label.group.archived.success":`문서 보관 성공`,
"label.customfields.formula.returntype":`공식의 반환 유형`,
"label.file.followers":`팔로워`,
"label.textmessage.new.templates.message1":`문자 템플릿 명칭을 입력하세요!`,
"label.selected.field.length":`최대 10개 필드만 선정할 수 있습니다`,
"ObjectDetailed_ViewKeyInformation_Layout":`핵심 정보 편집`,
"label.paging.totalofpage":`총 {0}페이지`,
"label.ccchat.message.new.error41":`더 많은 사람과 회화를 하고 그룹을 사용해 봅니다.`,
"message.recordtype.detail.noselectlist":`볼 수 있는 옵션 리스트 없음`,
"label.conditiontag.lookup.title":`다음에 추가할 선택 항목 리스트값을 선택합니다`,
"label_partner_setup":`파트너 클라우드 설정`,
"front-epwechat-module-v1-android-packname":``,
"lable.custom.Current.CY":`현재 사용자 설정 연도`,
"label.newprocess2.desc":`할인이 0.3%보다 클 경우 '참'으로 판단됩니다.`,
"label.operatedata.selectobjectfields":`내보낼 대상의 필드를 선택하십시오`,
"report_reportdatasource_label":`보고서 데이터 소스`,
"label.chosesubject.others":`기타 행사`,
"label.list.desc2":`Web to CloudCC 페이지가 두가지가 있습니다: PC 버전과 모바일기기 버전. PC버전이 컴퓨터로 방문할 수 있어 모바일기기 버전은 핸드폰으로 방문할 수 있으며 예, 위쳇.`,
"vue_group_several_groups":`{totalSize}개 그룹`,
"label.page.button.linkurl":`버튼이나 링크 URL`,
"show.week":`주말 보기`,
"label.gotocalendar.new":`캘린더에서 이벤트 생성`,
"button.reset.advancedsearch":``,
"label.h5.chatter.feedandcomnum":`게시물 올리기와 댓글 달기`,
"lable.opppdt.addpdt.table.unitprice":`판매 가격`,
"label.dataimport.validate":`실행하는 인증을 선택합니다`,
"label.lead.score":`잠재고객 채점`,
"vue_label_help_product":`제품 및 가격 매뉴얼`,
"label.role.select":`역할이 선정되었습니다`,
"lable.opppdt.selPdt.searchproduct":`제품 찾기`,
"component_event_label_newevent":`이벤트 새로만들기`,
"front-invoice-online-payment-setup-configure-button":``,
"label.stdashbord.xsld.business.img2":`가능성이 1%-99%인 단계의 총 금액`,
"label.event.moveup.2week":`2주일을 앞당깁니다`,
"label.partnerCloud.priceOfManual.allCustomer":``,
"lable.account.dep":`'새로만들기'버튼을 클릭하여 새 회계 연도를 정의합니다`,
"label.dataimport.insertdata.error.null.update":`해당 기록의 $schemefield_name$ 값이 없어 업데이트될 수 없으며 해당 기록이 불러오기를 무시했습니다.`,
"label_component_helper_businesschange_0activity":`30일 내 행사가 없습니다`,
"lable.account.NextbbDays":`미래 60일`,
"label_scope_length":`범위 길이`,
"label.customfields.operation":`데이터 내보내기 조작을 운행합니다.`,
"serviceappointment.save.workorder":``,
"label.field.update.hide.editor":`공식 에디터 숨기기`,
"button.partner.new":`파트너 클라우드 새로만들기`,
"label.stdashbord.xsld.business.oppdetails":`업무상황 상세표`,
"message.pleasewaitingnextversion":`이 기능은 다음 버전으로 출시될 예정이니 기대해주세요!`,
"label_tabpage_potentialcustomersz":`잠재고객`,
"label_emailtocloudcc_step2":`2단계`,
"label.weixin.username":`이름`,
"label.quickbooks.viewlist.type":`유형`,
"front-kefu-moudle-v1-Select-seats":``,
"label.customsetting.manage":`관리`,
"label.tabpage.field":`필드`,
"label.custom.page.button.icon.URL":`버튼 아이콘 URL`,
"font-evaluate-module-v1-evaluation-link":``,
"vue_label_salesfunnel_notice3":`가능성이 1%-99%인 업무 기회의 총개수`,
"front-email-payment-describe":``,
"label.productsales.today.noevttskaddevt":`오늘 미처리한 이벤트나 만료된 업무가 없으며 우상측의 ' '를 클릭하여 이벤트를 추가할 수 있습니다!`,
"component.setup.iframe.label.memo":`설정 아이콘을 클릭하여 URL 주소를 입력하시오.`,
"front-email-payment-select-country":``,
"label.ems.starred":`별 표시 메일`,
"component_setup_label_object":`대상`,
"label.query.detail.viewpartneruser":`협력 파트너 사용자 보기`,
"this.year":`올해`,
"serviceresource.isactive.notactive":``,
"label.marketing.message.recipientisnull":`수신인을 입력하세요`,
"label.unfold":`펼치기`,
"label.service.assetBOM.view.tip":``,
"label.validate.function.funcExplain.ISCHANGED":`필드값이 지난 값과 같은지를 점검하며 다를 경우 TRUE로 반환하고 아니면 FALSE로 반환합니다`,
"label.validate.function.funcExplain.NOW":`현재 시각의 일자 시간으로 반환하기`,
"label.phoenix.islands.time":`피닉스 제도 시간`,
"vue_label_checkduplicate_complete_filter_rules":`모든 선별 조건을 기입하세요`,
"vue_label_report_rowcount":`행 통계`,
"chatter.p":`개인`,
"label.umeng.activity.distributetask":`님에게 업무가 분배되었습니다`,
"UG_quota_05":`업무기회와 쌍방향 동기화`,
"june":`6월`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`화요일`,
"vue_label_commonobjects_view_chart_upto5":`최대 5개 그룹을 전시할 수 있습니다.`,
"vue_label_opportunity_contactrole_searchallcontacts":`모든 연락담당자에서 검색`,
"label.custom.field.task.notice":`업무 알림`,
"label.weixin.insert.address":`삽입 위치`,
"label.attachementNew.desc":`첨부 파일을 문서 보관하고 해당 첨부 파일을 삭제할 수 없습니다`,
"setup_mainpage_label_welcome18":`CloudCC의 업체급 권한 설정을 통해 데이터와 모듈을 설정할 때 각 사용자의 사용 권한을 제어할 수 있습니다. 역할의 권한 설정은 사용자 직위, 그룹, 역할, 데이터 공유 규칙, 필드급 안보 제어가 포함되어 업체 내 인원, 부서 간의 데이터 공유를 실현합니다.`,
"front-kefu-instance-noarea":``,
"label.please.ChooseMax":``,
"label.businesschance":`업무기회`,
"label.verticalline-group":`수직 열-그룹 분류`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`가격 매뉴얼을 선택하세요`,
"vue_label_norm_addcomponent":`구성 요소 추가`,
"label.ServiceCloud.Installation.address":``,
"vue_label_report_groupcolumn":`열 그룹`,
"label.ccchat.person.invite.notallsucc":`{0}개 메일 주소가 저장되었으며 전송하지 않았습니다. 초대를 전송하려면 다음의 오류를 수정해 전송을 클릭합니다.`,
"label.customfields.optionlist.tip":`사용자가 정의한 리스트에서 값을 선택할 수 있도록 합니다.`,
"UG.activity.07":`임무 생성`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`최후 주일`,
"label.permission.accessname":`권한 그룹 명칭`,
"lable.custom.year.stadate":`사용자 설정 연도 시작일`,
"label.ems.inputmails":`메일 서버 수신（I）`,
"label.cpq.quote.transfer.order.already":``,
"label.sendletter.status":`마케팅 행사 멤버 상태`,
"vue_label_commonobjects_view_save_as_view":`뷰로 저장함`,
"message.mobilechooseatmostfive":`최대 5개 필드를 선택할 수 있습니다`,
"label.errormessage.batchedit.nopermission":`편집한 데이터 기록이 없습니다.`,
"label.dataoperate.tip":`진행할 조작을 선택해 조작 대상을 선택하세요`,
"label.enableoperate":`사용 가능 조작`,
"label.ems.usernamepassword.error":`메일주소 또는 비밀번호가 잘못되었습니다.`,
"label.campaignmember.selectmember.deletemember":`에서 멤버를 삭제합니다`,
"label.Tab":`메뉴`,
"label.emailobject.template.message1":`필드를 선택하여 '삽입'을 클릭합니다. 뒤에 '>' 라벨은 더 많은 사용 가능한 필드를 의미합니다.`,
"label.approvalstep3.tip":`기록이 이 단계로 들어오는 사용자를 지정합니다. 항목을 선택할 수 있고 승인 대리가 이 요청을 승인 허용 여부를 선택할 수 있습니다`,
"label.inusing":`사용됨`,
"label.edit.select.tre":`체크 상자 리스트`,
"label.appointmentconfirmail.wizard.title1":`{0}안녕하세요`,
"label.partnerCloud.financeSetting.setAlipay":``,
"lable.edit.queue.avobj":`사용 가능한 대상`,
"vue_label_checkduplicate_verify_all_characters":`모든 문자 인증`,
"label.huntingzone":`검색 범위`,
"label.request.approved":`이 요청이 이미 승인되었으며 중복 승인하지 마세요`,
"label.sharerule.msgerror":`서버 내부 오류 정보`,
"front-epwechat-module-v1-tick-unbound":``,
"label.console.step6":`6단계. 레이아웃 배치를 선택합니다`,
"label.multilang.micropost.vote":`{0}표`,
"message.error.appid.null":``,
"lable.product.delq":`질문 삭제`,
"label.h5.approval.leixing":`승인 유형`,
"label.edit.field.select.style1":`펼쳐 보기`,
"label.passwordPolicy.setup.alpandnum":`알파벳과 숫자의 조합을 사용해야 합니다`,
"label.ems.close2":`닫기`,
"label.report.reporttypetitle":`보고서 데이터 소스명`,
"label.umeng.approval.approvalsuccess":`승인이 제출됐습니다`,
"label.page.showamount":`페이지당 표시한 기록수:`,
"label.copy.asset.successfully":``,
"vue_label_homepage_bigscreen_dark":`짙은 색`,
"vue_label_email_selected_members":`선정된 멤버`,
"label.file.preview":`미리 보기`,
"label.partner.new.step3.name":`명칭`,
"label.forecast.settings.periods.ago":`개 주기 전`,
"label.evaluation.praise":``,
"label.cloudccsite.edit":`웹사이트 편집`,
"label.knowledgebase.advanced.filtering":``,
"label.knowledgebase.framework":``,
"vue_label_pool_ownedpool":`소속 고객풀`,
"label.exchange.sync.setting.license":`이 기능을 사용하면 일부 조직 데이터는 내부 배치나 클라우드 기반 형태로 Microsoft Exchange 서버에 저장되고 Microsoft Exchange 서버를 통해 처리될 수 있습니다. CloudCC.com은 Exchange나 Office 365 등 제3자 앱이나 시스템의 프라이버시와 보안에 대해 일절 책임을 지지 않습니다.`,
"front-console-conversation-btn2":``,
"label.projectManagement.thelastone":``,
"message.duplication.confirmscript.mergeoperation":`선택한 값을 통해 이 기록들을 한 기록으로 병합합니다. 주의: 병합 조작을 철회할 수 없으며 기록 병합을 계속하시겠습니까?`,
"lable.outlook.detail.nosyn":`동기화하지 않음`,
"label.iscopy":`카피 허용 여부`,
"message.matrixReportSetupStage.row":`[행 제목 지정] 소계 근거를 선택하시고, 두개 소계 근거 중 최소한 하나를 선택하세요.`,
"label.forecast.forehistory.possibility":`가능성`,
"label.timetrigger.validate":`입력한 값이 자연수여야 하며 해당 업무 프로세스의 종속 작동 시간에 부합 시 시스템이 자동으로 업무 프로세스의 조작을 실시합니다`,
"member.name.choice.field":``,
"label.undone_external page":``,
"UG_Lead_012":`고객 경로 불러오기`,
"component_chatter_label_fans":`팔로워`,
"label.systeminfo":`시스템 정보`,
"label.mr.descreption.oneGroupNote1":`최소 두개의 데이터를 체크하고 [선택된 정보 불러오기] 버튼을 클릭하여 데이터 병합 페이지로 들어가십시오.지금은 제`,
"label.wtd.changefields.selfields":`web to CloudCC 페이지에 포함시킬 필드를 선택하십시오:`,
"message.error.fileinfoid.null":`fileinfoid가 필수 요소입니다! 파일 정보id`,
"label_tabpage_cownerz":`소유인 변경`,
"setup_layout_button_save":`저장`,
"Dashboard.View.Createdbyme":`내가 생성한 대시보드`,
"label.escalation.setup.detail.order":`순번`,
"button.partner.start":`사용 시작`,
"label.htyj.remark1":`현재 버전이 계약서 대상에 지원되지 않습니다`,
"component.event.label.person":`피분배자`,
"label.appointmentconfirmail.wizard.subtitle3":`장소`,
"label.emailtocloudcc.filed.username":`이메일 사용자명`,
"label.vlidaterule.remark":`오류 조건과 해당 오류 메시지를 지정하여 인증 규칙을 정의합니다. 사용자는 오류를 수정하고 다시 시도할 수 있습니다.`,
"message.duplication.label.insertoption":`새로만들 때 조작`,
"front-web-module-v1-detail-comment-toast":``,
"label.import.page2.notsuitedfiledwillbenotimport":`주의: 시스템에서 매핑되지 않는 필드를 불러올 수 없음`,
"label.h5.similar.opportunity.enable":`유사 업무기회 사용`,
"label.allunfold":`모두 펼쳐보기`,
"component_setup_iframe_label_inputurl":`URL 주소를 입력합니다`,
"label.manage.all":`모두 관리`,
"label.mobile.side.tab.cs":`상용 기능`,
"label.datamanage.contact.information":`연락담당자 정보`,
"lable.outlook.edit.sel":`값 선택...`,
"label.imgfield.type.url.tip2":`예: http://www.cloudcc.com/images/logo.png&cimgSize=50,50.`,
"setup.layout.label.areasetup":`구역 특성 설정`,
"label.date":`일자`,
"vue_label_commonobjects_detail_openfilter":`필터 열기`,
"label.loginip.pagecue":`유효한 IP 주소 범위를 입력하십시오. 이 프로필을 보유한 사용자는 어떤 주소로 로그인할 수 있는지를 지정합니다.`,
"vue_label_email_not_valid":`입력한 메일 주소사 유효한 메일 주소가 아닙니다.`,
"label.page.step5.add.application":`5단계: 사용자 설정 응용 프로그램에 추가합니다`,
"label.dashboard.donot.delete":`이 대시보드 폴더의 대시보드가 존재해 삭제될 수 없습니다!`,
"label.visitAPPexchange":`Appexchange 방문(새 윈도우)`,
"label.generate.location":`고객 경위도 데이터 생성`,
"lable.quote.syncing.syncingbutton":`동기화`,
"label.pw.error.text":``,
"label_partner_setup_Enable":``,
"label.file.preview.unav":`미리보기 사용할 수 없음`,
"label.sms.tip":`출처: 인터넷`,
"setup.mainpage.label.welcome21":`CloudCC 클라우드 플랫폼에서 이메일 템플릿 사용자 설정 기능을 제공한다. 사용자가 통일적으로 사용하여 업무 효율을 제고한다.`,
"label.trigger.for.example":`예: 고객의 update 트리거에서 업무 기회를 업데이트하고, 업무 기회의 update 트리거에서 고객을 업데이트하고 동시에 고객의 update 트리거를 작동시킵니다. 트리거에서 조건부 제어를 하지 않는다면, 시스템은 최대 3회까지 이러한 순환 호출을 실행할 수 있습니다!`,
"setup.layout.button.layoutprop":`레이아웃 속성`,
"component.chatter.label.fans":`팔로어`,
"lable.PowerProcess.event.edit":``,
"label.detailintro":`명세 설명`,
"vue_label_report_nosearchresults":`검색 결과 없음`,
"error.name.repeat":``,
"label.emailEncoding":`메일 코드`,
"label.partnerCloud.financeSetting.enableAccount":``,
"label_emailtocloudcc_clear":`비우기`,
"setup_mainpage_label_welcome12":`사용자가 마우스로 클릭하여 프로그램밍 필요없이 시스템 안내의 절차에 따라 보고서를 작성한다. 시스템에서 리스트형 보고서, 결합 보고서, 행렬 보고서를 선택할 수 있다. 동시에 모든 필드의 보기 선택을 제공한다. 불필요한 필드 정보를 없앤다. 막대 차트, 꺾은 선 차트, 도넛 차트, 퍼널 차트, 원형 차트 등을 선택할 수 있으며 한눈에 확인할 수 있다.`,
"lable.SalesCommitmentKanBan.contractStartDate":`계약서 시작일`,
"front-starter-v1-potential-customer-tips-success":``,
"UG_Forcast_02":`예측이 지정된 단계의 예기 마케팅의 추산으로 예측 모드가 일정한 시간의 제품 수요와 마케팅 수입 상황을 확인해줍니다. 관리자가 예측을 통해 목표를 설정해 팀의 진전 상황을 평가합니다. 기구의 전체 예측이 마케팅 대표별로 모든 영업의 개요상황을 반응합니다. (영업이 파이프라인 단계부터 닫기 단계 간의 어느 단계에 처해 있는지와 무관함)`,
"label.escalation.setup.detail.ruleentries":`규칙 조항`,
"lable.SalesCommitmentKanBan.allComplete":`총 완성액`,
"label.appupload.install.apicanuse":`api 명칭 사용 가능합니다`,
"label.organiza.field":`조직 필드`,
"button.partner.workspace.manage":`관리`,
"lable.PowerProcess.setevent":``,
"label.emailobject.groupemail.msg2":`메일 주소가 없어 메일을 수신인에게 전송할 수 없습니다.`,
"label.h5.orderbyname":`이름으로 정렬하기`,
"vue_label_salesadvance_opportunities":``,
"label.appointment.disable.cancel":`예약 취소 금지 사용`,
"label.trigger.folder.edit":`트리거 페이지: 폴더 편집`,
"label.customfields.new.step2.opration.unique.info.v2":`'ABC'와 'abc'를 다른 값으로 간주합니다 (대소문자 구분)`,
"label.icon.40":`포지셔닝`,
"label.eventmenuandlink":`이벤트 버튼과 링크`,
"label.service.gantt.candidate":``,
"label.top.userphoto":`사용자 프로필 이미지`,
"label.appointmentconfirmail.wizard.btn2":`회의 취소`,
"label.print":`인쇄`,
"saveandreturn":`저장 및 반환하기`,
"lable.account.CurrentandNextCY":`현재와 다음 캘린더 연도`,
"label.group.no.recent1":`사용된 그룹을 확인하지 않았습니다.`,
"lable.Asset.conversion":``,
"label.emailtocloudcc.button.sure":`확인`,
"label.Path.List":``,
"label.please.rule.name":``,
"label.knowledge.category.hint.six":``,
"setup_mainpage_label_welcome28":`조작 안내: 페이지 좌측 메뉴를 클릭하여 → 설정 관리→ 데이터 관리→ 데이터 불러오기, 내보내기, 모두 이동, 모두 삭제.`,
"vue_label_commonobjects_view_chart_editchart":`차트 편집`,
"label.permission.detail.app.object":``,
"label.multilang.totalpage":`총`,
"label.marketsea.button.return":`반환`,
"Click.to.load.more":`더 많이 불러오기`,
"label.validate.globalvariable":`전체 변량`,
"label.marketsea.iseditseabymanager":`관리자가 소속 고객풀 변경 허용`,
"label.price.yuan":``,
"label.service.resource.uesr.tip":``,
"vue_label_help_viewusageguide":`lightning 버전의 사용 매뉴얼 보기`,
"label.autoRegister.changepwd.setpwd.too.long":`길이가 한계를 넘었습니다`,
"label.campagin.roi.fwsl":`방문량`,
"label.campaign.mobile":`모바일기기`,
"UG.Lead.012":`고객 경로 불러오기`,
"link.recordtype.detail.backtoobject":`사용자 설정 대상으로 돌아가기`,
"front-kefu-moudle-callcentrt-hasclose":``,
"label.category.5":`IT 첨단기술`,
"label.import.page1.selectwayofdealdata":`데이터 처리 방식을 선택하시오`,
"chatter.emailReceiveEmail":`CCChat 알림 받기`,
"vue_label_file_manage_lib_members":`파일 베이스 멤버 관리`,
"label.appupload.upload.overview":`개요`,
"label.service.miniProgram.inputNumber":``,
"label.emailtemplate.finishdetailinfo":`메일 템플릿의 상세 정보를 완성합니다`,
"label.weixin.fmu.before.day":`{0} 일을 앞당깁니다`,
"label.integrations.login":`로그인`,
"label.dashboard.setUpHomePage":`보기 페이지가 설정되어 있습니다`,
"label_partner_common_webSit":`도메인 네임`,
"front-epwechat-module-v1-unbound-user":``,
"label.partnerCloud.basicSetting.offline":``,
"label.start.loginip":`IP 시작 주소`,
"label.projectManagement.delete.subtasks":``,
"label.message.batchapp":`대량 승인`,
"message.duplication.label.ruletitle":`중복률 검사 필터 규칙`,
"label.all_networks":``,
"label.select_columns":``,
"vue_label_notice_uploadavatar_exceed":`업로드될 프로필 이미지가  2MB를 초과하면 안됩니다.`,
"message.error.get.failed":``,
"label.quickbooks.viewlist.duedate":`만료일`,
"label.ccchat.topic.search":`주제 검색`,
"label.forecast.shre.manager":`매니저 분배`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`목요일`,
"lable.product.pricebooks.copy":`기존 가격매뉴얼에서 복사하기`,
"label.instrumentPanel.minLabelname":``,
"front-market-form-createdsecond":``,
"label.submission_detail":``,
"label.customfields.checkbox.tip":`사용자가 '참'(선택)이나 '거짓'(선택하지 않음)값을 선택할 수 있습니다.`,
"label.escalation.setup.list.description":`조건이 있는 개별안이 규정 시간을 초과해 미처리 시 규칙 업데이트를 통해 자동 조작을 정의할 수 있습니다. 개별안을 업데이트할 때 사용자 자동 통지를 선택해 개별안을 다른 사용자에게 다시 분배합니다.`,
"UG.Forcast.05":`예측 설정:단계{0}/{1}`,
"label.data.import":`데이터 불러오기`,
"label.upload.error.cause":`업로드 실패, 사유는`,
"label.search.change.remark":`포그라운드 좌측 메뉴 검색 부분에 보는 대상 설정에 적용합니다`,
"serviceappointment.edit.status.limitwithstatus":``,
"label.department.operation":`조작`,
"label.textmessage.vonage.message3":`API비밀키와 API기밀을 찾으려면 Vonage API 계정을 로그인하고 계정의 '설정'으로 이월합니다. Vonage API계정의 전화 번호를 찾으려면 '제품'의 '번호'로 이월하고 '사용자 번호'를 클릭하여 보유하는 모든 전화 번호를 확인할 수 있습니다.`,
"label.privacystatement.dialog":`프라이버시 성명(새 윈도우)`,
"label.datamanage.import.leadfield":`다음 리스트의 불러올 파일에서 잠재고객으로 불러올 필드를 선택합니다. 조작을 완성한 후 다음을 클릭합니다:`,
"label.appupload.upload.install.failar":`설치 실패했습니다.`,
"label.viewall":`모두 보기`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat 저장한 게시물에 댓글 달기`,
"lable.custom.dp":`이 페이지에서 사용자 설정 연도를 설정할 수 있습니다`,
"label.mobile.more.share":`동료나 그룹과 공유`,
"lable.name.cannot.be.empty":``,
"label.autoRegister.changepwd.setpwd.password":`비밀번호`,
"label.multipleactivity.aevents":`개 이벤트`,
"label.many.dayline.lastday":`전날`,
"lable.Please.bind.the.QuickBooks.record.first":``,
"vue_no_related_dashboards":``,
"label.newdashboardpage.name":`대시보드 명칭`,
"vue_label_commonobjects_detail_network":`관계망`,
"label.tianyancha.reginstitute":`등록 기관`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":``,
"label.chat.file.upload.info":`파일 업로드`,
"label.appexchange.vlidaterule":`인증 규칙`,
"label.salescloud.salesdashboard.current.business":`현재 비즈니스 기회`,
"label.app.step4.homeisfrist":`메인 홈페이지가 첫번째 메뉴여야 하며 제거할 수 없습니다!`,
"label.weixin.micro.research.optionname":`조사 선택항목 명칭`,
"label.paging.totalofnbsp":`총 {0}개`,
"label.opportunity.perm.title":`방문 권한 요청`,
"front-kefu-moudle-v1-zhyzcw-reinput":``,
"label.unsaved_changes":``,
"label_partner_all_description":`내용`,
"lable.account.Next.CQ":`다음 캘린더 분기`,
"chatter.feed.menutype.feed.me":`나의 업데이트와 관련`,
"label.sourcetranstemp":`번역 소스 템플릿: 빈 번역 템플릿, 새 언어 파일을 제작할 수 있습니다`,
"label.apply.newuser.validate":`CloudCC 신규 사용자 등록, 인증번호:`,
"label.user.password.error":`아이디 비밀번호가 잘못되었거나 잘못된 사용자입니다!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":``,
"lable.PowerProcess.time.filed":``,
"label.file.default.value.is.integer":`정수만 입력할 수 있습니다`,
"label.processsetting.please.select.field":``,
"label.app.step3.introduce":`사용자 설정 프로그램 아이콘 파일 크기가 20K를 초과할 수 없습니다. 최적 효과를 위해 이미지 사이즈 최대치가 넓이 300 화소, 높이 55 화소입니다. 다른 사이즈의 이미지인 경우 시스템에서 크기를 조절해 왜곡될 수 있습니다. 또 저장한 후에야 새 이미지가 유효합니다.`,
"button_partner_save":`저장`,
"label.marketingmanagement":`마케팅`,
"label.isEnableVisualpage_new.leftlist":`사용 가능한 사용자 설정 페이지`,
"label.salescloud.teamrole.optionlist.choose.correct":`리스트에 같은 항목이 있어 수정하세요`,
"System_ChangeUser_Info_001":`소유인 변경 성공했으며 관련 기록의 방문 권한이 없어 클릭하여 전 페이지로 이동합니다.`,
"front-console-no-contact":``,
"component.assistant.label.overduetask":`업무 기회에 기한을 넘긴 임무가 포함됨`,
"label.roleofpartner":`협력 파트너 역할`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`님과 {0}`,
"front-template-V1-Please-select-a-picture":``,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`총 계약 체결 승낙률`,
"label.h5.similar.opportunity.step2.conment":`유사 업무 기회를 찾을 때 서로 매칭하도록 3과 10 필드 또는 관련 라스트를 선택하십시오`,
"label.projectManagement.alert.frequency.will.not.work":``,
"vue_label_fllscreen":``,
"label.customfields.selectcontainfieldlayout":`이 필드가 포함된 페이지 레이아웃을 선택합니다`,
"label.appointment.wizard.subtitle1-4":`45분`,
"label.tianyancha.businessverify.unagree":`동의하지 않음`,
"label.unique":`특유`,
"setup_mainpage_label_welcome10":`조작안내: 페이지 좌측 메뉴를 클릭하여→ 응용 프로그램 설정→ 생성→ 대상→ 대상명→ 사용자 설정 레이아웃.`,
"vue_label_account_subsidiary":``,
"label.dataimport.format.error":`형식이 잘못되어 MM/DD/YYYY나 YYYY-MM-DD의 형식을 사용하세요.`,
"label.email.new":`메일 새로 만들기`,
"label.log.descri":`조작 상세 내용`,
"vue_label_dashboard_componentname":`구성 요소 명칭을 입력하세요`,
"label.weixin.quick.reply":`빠른 답장`,
"label.productsales.payment.badversion":`현재 버전은 계약 대상을 지원하지 않습니다. 판매 대금 회수 실적을 볼 수 없습니다`,
"label.position":`위치`,
"label.Annex.Conditions":``,
"label_tabpage_endz":`종료`,
"label.setup.mobile.bottombutton.prompt":`안내: 설정 저장한 후 사용자가 모바일 단말기에서 설정한 홈페이지 설정을 커버하게 됩니다.`,
"lable.Edit.template":``,
"vue_label_report_onlydisplay2000":`2000개 데이터만 볼 수 있습니다.`,
"label.salescloud.salesdashboard.sign.account.top5":`계약 큰 거래처 top5`,
"label.weixin.ontime":`정시`,
"font-evaluate-module-v1-disappoint":``,
"chatter.sel.addre":`5명까지 수신인을 선택할 수 있습니다!`,
"label.mobile.phone.month.summary":`이번달 총정리`,
"label.partnerCloud.priceOfManual.selected":``,
"label.south.georgia.time":`사우스조지아 표준시`,
"label.create.ccdocument":`첨부파일 신규 추가`,
"label.chatter.to":`으로`,
"label.ems.minute":`분`,
"label.mobile.phone.submit.tome":`나에게 제출한 보고서`,
"label.approvalstep1":`1단계: 명칭과 설명을 입력합니다`,
"label.h5.similar.opportunity.last.months9":`최근 6-9개월`,
"Opportunity_Detailed_Phase_Label_003":`단계 변경`,
"lable.PowerProcess.time.input":``,
"label.stdashbord.xsld.business.yqzsr":`예상 총수입`,
"label.icon.64":`탐조등`,
"label.data.choses.i_desc":`필요에 따라 한개 대상을 불러오는 데이터를 선택합니다.`,
"label.integrations.mainlandchinaleads":`중국 대륙지역 잠재고객`,
"vue_label_notice_savemenu_success":`메뉴 저장 성공`,
"front-kefu-moudle-v1-xzhxzxkf-online":``,
"label_chatter_name":`명칭`,
"label.Viewon_Linkedin":``,
"lable.PowerProcess.chioce.event":``,
"component.chatter.file.label.maxsize":`파일 최대 용량은 20M`,
"label.validate.function.funcExplain.SECOND":`일자/시간 필드의 초로 돌아가기`,
"label.data.downpage.i.title.num4":`4. 불러올 대상자에 찾기 필드와 상세 필드가 있으면 해당 필드의 대응값은 ID이어여 한다.`,
"label.icon.139":`화폐`,
"label.app.step4.atleastone":`홈페이지 메뉴를 제거할 수 없습니다!`,
"label.weixin.input.telephone":`핸드폰 번호를 입력해주세요`,
"label.setup.mobile.bottombutton.remark":`각 조직이 업무 시나리오에 따라 조직급 홈페이지 초기 설정을 설정할 수 있습니다.`,
"label.file.searchs":`파일 검색`,
"vue_label_email_there_is_no_draft_yet":`원고가 없습니다.`,
"front-kefu-moudle-v1-bind-seats":``,
"label.customfields.lookupmuti.tip":`이 대상이 다른 대상과 연결하는 관계를 생성합니다. 관계 필드가 사용자가 찾기 아이콘을 클릭하여 팝업 리스트에서 값을 선택하는 것을 허용합니다. 다른 대상은 리스트 값의 소스입니다.`,
"label.integrations.password":`암호`,
"label.data.newtemplate.t_conditions":`템플릿 조건`,
"message.error.repeatsubmit":`이 제출은 중복된 제출이나 같은 페이지에 여러 개의 윈도우를 열어서 수정하는 상황입니다. 후자의 경우 최신 열린 윈도우에 제출해 주십시오.`,
"label.umeng.approval.approvalreassign":`#obj승인이 다시 분배됩니다#objname`,
"lable.edit.queue.selobj":`오류: 대열에 선택한 대상이 최소한 하나 있어야 합니다`,
"label.compact.layout.frame":`페이지 레이아웃 테두리`,
"label.sms.companyname.dsf.infor":`DONG SHI FANG 문자 메시지 인터페이스 정보`,
"template.report.individual.case.source":``,
"pagecreator.button.pcpage":`컴퓨터 단말기`,
"vue_label_commonobject_selectdatatime":`일자 시간 선택`,
"label.icon.181":`파일`,
"label.loginip.setup.please":`IP범위를 지정하세요`,
"vue_label_dashboard_?secondarygroup":`2급 그룹을 선택하세요`,
"lable.outlook.mcto.pleasedes":`연동하고 싶지 않는 메일을 입력하여 콤마로 간격을 시켜주세요.`,
"DetailedInfo_Activity_EmailMessage_01":`{0}이 {1}에게 메일 한개를 전송했습니다.`,
"label.sendmail.step4":`4단계: 메일을 제출해 처리하고 있습니다`,
"label.monitorsys.delete.source":`조작 내용`,
"label.monitorsys.log.datetime":`검색 범위 내의 시스템 중점 운영 감사일지를 다운로드합니다(Excel.xls 파일)`,
"component_chatter_label_myfans":`나의 팔로워`,
"label.tianyancha.h5.registereddate":`등록 시간`,
"label.multilang.feedtrack.operatecreate":`한 개{0} 기록을 생성하였습니다.`,
"label.console.step6.no":`리스트 배치 선택`,
"four":`4`,
"message.confirmsetpwdforuser":`사용자에 대해 비밀번호를 다시 설정하시겠습니까?`,
"label.cape.verde.time":`카보베르데 시간`,
"label.queue.new":`대열 새로만들기`,
"label.cloudccsite.start":`사이트 메인페이지 사용`,
"label.data.exp.way":`내보내기 방식`,
"label.lock.record.donot.delete":`기록이 잠겨 있어 삭제할 수 없습니다`,
"label_emailtocloudcc_filed_type":`유형`,
"frame_personinfo_label_minipic":`섬네일`,
"label.checkfield.choosetab":`중복 검사 필드 선택`,
"component.setup.tabs.label.default":`기본 페이지`,
"page.404.button.toknowmore":`더 많은 정보`,
"vue_label_SMS_message_sent_cannot_be_empty":`전송할 메시지 내용이 없습니다.`,
"label.lookupreplaceselectvalue":`선택항목 리스트값 조회 및 교체`,
"pagecreator_layout_button_new":`레이아웃 새로만들기`,
"label.mobile.more.upload":`신버전 업로드`,
"front-kefu-moudle-v1-Connection-failure":``,
"label.version.support.unlimited":`지원 제한 없음`,
"message.error.notmarketseamember":`고객풀 멤버가 아닙니다`,
"label.taskandincident":`업무와 이벤트`,
"label.report.export.print.title":`보고서 뷰 인쇄`,
"label.file.publicview.error2":`공용 링크 정보가 잘못되어 새 링크를 사용하십시오`,
"label_chatter_cancel":`취소`,
"front-web-module-v1-detail-comment-satisfied":``,
"label.knowledge.delete.topic":``,
"label.forecast.forehistory.all":`전부`,
"label.displaybutton":`표시 버튼`,
"label.icon.148":`로봇`,
"label_tabpage_ok":`확인`,
"label.checkfield.merge.mainrecord":`메인 기록`,
"label.notification.arketsea.restored":`{5}가 {2}{0}：{1}를 복구했습니다`,
"setup.mainpage.label.welcome31":`작업 메뉴얼: 본 페이지 좌측 메뉴를 클릭하여→관리 설정→새로 만들기→응용 프로그램`,
"front-kefu-moudle-v1-jtrrt-connect":``,
"vue_label_calendar_please_select":`디스플레이 필드를 선택하세요`,
"setup.layout.label.pagename":`페이지 레이아웃 명칭`,
"template.chart.schdywjhz":``,
"label.access_report":``,
"label.assignment.layout.section.optional":`선택 가능`,
"label_chatter_recently":`최근`,
"lable.chat.advanced.setting":``,
"label.knowledge.category.hint.eight":``,
"message.error.facebookuid.null":``,
"label.step5.total6":`5단계, 총 6단계`,
"label.is.cancel.delete":`삭제 취소 여부`,
"setup_mainpage_label_welcome11":`사용자 설정 보고서`,
"label.answers":``,
"label.approvalstep1.tip":`신 승인절차에 대해 명칭, 설명과 절차 번호를 입력합니다.`,
"template.chart.htjeph":``,
"label.campaigns.onsiteregistration":`현장 등록`,
"front-epwechat-module-v1-input-agentid":``,
"label.emailobject.wizard.desc2":`메일 수신확인 및 열기 횟수 팔로우업`,
"label.multilang.chatterdetial.vote":`{0}표`,
"label.customsetting.manage.value":`사용자 설정 데이터`,
"front-electronic-export-listCount":``,
"label.dashboard.create.prompt":`리스트 유형 보고서가 대시보드를 생성할 수 없습니다`,
"label_tabpage_askz":`질문이 무엇입니까`,
"label.ems.sentmail":`보낸 메일함`,
"label.reportlist.untop":`고정 취소`,
"label.owner.h5.plzchose":`소유인을 선택한 후 확인 버튼을 클릭하세요`,
"label.callcenter.addup.10.pieces":``,
"label.ccdocument.save":`파일 저장`,
"label.productcannotnull":`제품을 입력하세요`,
"label_tabpage_enabletomobile":`모바일기기에 사용 여부`,
"lable.account.CYAgo":`2개 캘린더 연도 전`,
"lable.Select.the.returned.high.seas.pool":``,
"tuesday":`화요일`,
"label.partnerCloud.basicSetting.partnerPayment":``,
"label.validate.function.funcExplain.WEEKDAY":`요일로 돌아가기,1이 일요일임, 7이 토요일임`,
"label.query.detail.manageexuser":`외부 계정 관리`,
"vue_label_systemSettings_environment":``,
"component_setup_tabs_label_delete":`삭제`,
"label.weixin.delete.ccchat":`이 게시물을 삭제하시겠습니까?`,
"label.lanxin.title":``,
"label.layout.editcondition.morethanten":`검색 조건이 10개를 초과할 수 없습니다`,
"label.project.hit.fourteen":``,
"label.createby":`최초작성자`,
"label.moreoperation":`더 많은 조작`,
"label.lock.tip":`편집할 수 없도록 기록을 잠그십시오`,
"label.check.input.condition.three":``,
"label.quote.dingjia":`정가`,
"label.currentuseremail":`현재 사용자의 메일 주소`,
"UG_homepage_004":`자동화`,
"chatter.link":`링크`,
"label.new.zealand.standard.time":`뉴질랜드 서머타임`,
"APPIntegration.Dropbox.setting.02":`금지 사용`,
"label.version.searchandmerge":``,
"label.allmenus.showmsg.nomenu":`검색한 메뉴를 찾을 수 없습니다!`,
"front-template-V1-Enable-disable":``,
"label.marketing.setting4":`등록 성공 및 사이트 기본값으로 돌아가기`,
"UG.Forcast.07":`예측 허용`,
"vue_label_systemSettings_correlation":``,
"label.cloudccsite.remark.length":`웹사이트 내용이 255개 문자를 초과할 수 없습니다`,
"label.favorite":`페이지 저장`,
"template.report.converted.leads":``,
"label.campaignmember.main.description":`이 페이지를 사용해 이 마케팅 행사의 멤버를 관리합니다. 신 멤버를 추가하거나 기존 멤버의 마케팅 행사 멤버 상태를 변경할 수 있습니다.`,
"label.salescloud.teamrole.account.organization":``,
"label.permission.modifyAppPermission.canselectapp":`선택 가능한 응용프로그램`,
"front-epwechat-module-v1-self":``,
"message.duplication.label.matchexactletters":`정확 매칭`,
"label.appointmentdetail.wizard.title18":`금요일 시간 계획`,
"label.area":`구역`,
"label.sso.saml.sp.username":`사용자명`,
"lable.outlook.new":`Exchange Sync배치 새로 만들기`,
"label.custom.field.close.conversion":`닫기- 전환 완료`,
"lable.outlook.detail.tmaping":`업무 필드 매핑`,
"label.emailobject.emaildetail.nextactivity.event":`이벤트 추가`,
"vue_label_commonobjects_detail_date":`완료일이 시작일보다 커야 합니다.`,
"vue_label_email_mark?as":`로 표시됨`,
"label.guestgroup":`고객 그룹`,
"label_emailtocloudcc_filed_server":`서버`,
"label.icon.186":`컨설팅`,
"label.department.user.edit":`편집`,
"label.custom.page.component.button.settings":`구성요소 버튼 설정`,
"label.partnerCloud.orderingPlatform.nextProduct":``,
"vue_label_appstore_cloud_platform":`cloud 공식 플랫폼`,
"label.page.previous":`이전 페이지`,
"label.direct.dashboard.week.report":`업무 주보 새로 만들기`,
"label.ServiceCloud.prompt.warning":``,
"label.emailtocloudcc.position":`직위`,
"vue_label_email_please_enter_the_message_content":`메일 내용을 입력하세요`,
"labal_About_to_jump":``,
"label_profile_mobile_setup_stand":`표준 페이지`,
"label.visualpage.component.n3":`3. 매개변수. 매개변수는 args 속성에 적습니다. args="name:'zhang', age:26" 큰따옴표와 작은따옴표에 주의하십시오.`,
"vue_label_report_operationmode":`보고서 운행 방식`,
"label.reportsSubscription.select.attached.file":``,
"label.afghanistan.time":`아프가니스탄 시간`,
"label.vlidaterule.formulatrue":`공식 결과가 '참'이면 '오류 정보'구역에서 정의한 텍스트가 나타납니다`,
"label.ccchat.person.invite.erroremail":`메일 주소 형식이 정확하지 않습니다.`,
"label.viewDashboard":`대시보드 리스트로 이동`,
"label.at":`에서`,
"label.notification.arketsea.beforeretrieve":`{0}：{1} 이 곧 {2}로 회수되어 남은 일수는 {6}일`,
"label.field.update.show.editor":`공식 에디터 보기`,
"label.weixin.polls.time":`투표 시간`,
"vue_label_commonobjects_detail_activity_nostarttime":`시작 시간 없음`,
"label.direct.dashboard.me.not.approval70":`내가 제출한 미심사 프로젝트`,
"label.data.setok.t_desc3":`, 조작합니다.`,
"label.view.edit.search.describe":`키워드 입력한 후 검색하기`,
"label.importsourcefiletip":`불러오기 전에 파일이 다음의 조건을 부합하는 지를 확보합니다:<span><ul><li>1.불러올 모든 언어에 명칭과 번역이 포함된 파일을 생성합니다. </li><li>2. 파일 상단에 언어 속성이 포함되어야 합니다.(중문 불러오기 지원되지 않음). 언어 속성, 예: Language=en_US。</li><li>3.불러올 파일이 정확한 코드 형식을 확보하며 지정된 바가 없으면 시스템에서 UTF-8코드를 사용합니다. </li><li>4.불러올 파일 끝부분에 엔터키로 줄바꿈을 확보합니다. </li></ul></span>`,
"UG.Case.01":`개인안`,
"label.weixin.report.filters":`필터`,
"vue_label_homepage_profilehomepageassignment":`프로필 홈페이지 분배`,
"label_tabpage_editview":`뷰 편집`,
"label.tabpage.allpotentialcustomers":`모든 잠재 고객`,
"label.sendemail.send.standbyemail":`(예비 발신함)`,
"errormessage.email.atleastonereceiver.z":`최소 하나의 수신자 주소를 선택하거나 입력하세요`,
"workflow.action.tasks.assignortype.ownertype":`소유인 유형`,
"label.list.userinterface.new.page.setup":`새버전 인터페이스`,
"chatter.seladress":`최소 한명의 수신인을 선택하세요`,
"Pagelayout_Setup_004":`최대 4개 필드만 배치할 수 있습니다`,
"label.mobile.home.page.tenbig.opp":`미래 30일에 10개 업무기회`,
"label.wtd.changefields.newpc":`PC 버전 페이지 생성합니다`,
"label.opportunity.perm.remark":`전용 업무 기회입니다. 업무 기회 소유인 "owneridccname" 에게 연락해<br> 방문 권한을 확보합니다.`,
"label.data.exp.tempdes":`템플릿 설명`,
"label.appointment.wizard.subtitle2-1":`부터`,
"lable.currencyManage.button.manageexchangeRate":`기한이 지난 환율 관리`,
"label.file.viewinfo":`파일 상세 정보 보기`,
"label.integrations.mailchimp.export.failed":`데이터 내보내는 데 실패하였으며 인터넷 연결을 확인한 후 다시 시도하세요`,
"pagecreator_page_button_edit":`편집`,
"label.icon.86":`서류가방`,
"label.exchange.sync.reset":`동기화 리셋`,
"label.customfields.lookupfilter":`찾기 필드에서 사용자가 사용할 기록을 제한할 수 있는 필터를 만들 수 있습니다`,
"label.component.hotdeal.nopermission":`CloudCC 관리자에게 연락하여 업무 기회 관련 데이터를 확보하세요`,
"label.address.province":`성/관할 구역`,
"lable.PowerProcess.3digit.input":``,
"label.asset":``,
"label.passwordPolicy.setup.nopwdremember":`기록하지 않음`,
"front-electronic-signature-setting-intro2":``,
"pagecreator.page.button.new":`페이지 새로 만들기`,
"label.tabpage.step2":`2단계: 선별 조건을 지정한다`,
"label_switch_two_column_or_responsive_layout":``,
"label.batchDelete":`모두 삭제`,
"chatter.edit.ct":`나의 연락처 편집`,
"UG_ST_003":`{0}을 생성하는 권한이 없으며 관리자에게 연락하시거나 '확인'을 클릭한 후 {0}인터페이스로 직접 이동합니다.`,
"label.timzone.tip.info2":`SimpleDateFormat을 사용해 Date에 대해 포맷을 진행합니다. SimpleDateFormat 클래스 예시에 대해 표준 시각대를 설정해야 합니다. 예:SimpleDateFormat myDateFormat=new SimpleDateFormat("YYYY-MM-DD、MM/DD/YYYY");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));혹은 TimeUtil이 제공한 툴로 예시를 획득합니다. SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("YYYY-MM-DD、MM/DD/YYYY",userInfo);`,
"label.ems.firstsynchistory":`최초 동기화시킨 메일 기간`,
"label.currency.invalid":`무효한 화폐 종류`,
"label.mask.custom":`사용자 설정`,
"lable.opppdt.addpdt.title":`제품 선택`,
"label.appointment.wizard.subtitle3-3":`수요일`,
"label.weixin.report.criteria":`그룹분류 조건`,
"label.appupload.upload.install.uninstall":`설치할 수 없습니다`,
"label.compact.layout.frame.split":`분할화면 보기`,
"label.email.attach.complete.info":`업로드 완성한 후 파일이 다음의 첨부파일 리스트에서 나타납니다`,
"label.Receivables":`대금 수령 계획`,
"label.linkedin.title.setting":``,
"label.companynotice":`회사 공고`,
"label.emailobject.discard":`취소`,
"label.selected.searchfield":`선택된 검색 결과 필드`,
"front-electronic-signature-explainDocusign":``,
"chatter.link.name":`링크 명칭`,
"label.low":`낮음`,
"label.verticalline":`수직 열`,
"label.approval.isallowed.reject.label":``,
"label.emailtocloudcc.button.enable":`작동`,
"label.dashboardSetup.showdw.d5":`정수 단위`,
"label.usermanage.not.authority":`이 작업을 수행할 충분한 권한이 없습니다`,
"label.customobjects.track.introduce0":`이 페이지에 {0}에서 '필드 팔로우업'관련 리스트에서 팔로우업할 필드를 선택할 수 있습니다. 언제든 사용자가 다음 선택한 필드, 예전 필드값, 새 필드값 및 일자, 시간 , 속성을 변경하는 것과 변경하는 사용자가 '필드 팔로우업'관련 리스트에 추가됩니다.`,
"canlendarmonth":`캘린더 월`,
"vue_label_dashboard_minimum":`최소치를 입력하세요`,
"label.salescloud.optionlist.inputname.linealone":`밑에서 한개나 여러개 선택항목 리스트값을 추가해 한 값이 한 행을 차지합니다`,
"message.error.organuzation.information.null":``,
"label.tabpage.maxfilez":`파일 최대 용량`,
"message.validation.apiname":`반드시 알파벳으로 시작해야 하며 알파벳 대소문자, 숫자, 밑줄, 최대길이 50, 최소  2자리만 포함할 수 있습니다.`,
"report.type.label.contractPayment":`계약서 및 대금 수령`,
"label.limiting.choose.three.files":``,
"label.reportTypeFocus":`보고서 데이터 소스 포커스`,
"Report_Delete_Confirm_Title":`확인하세요`,
"front-gantt-module-reorder-milestones":``,
"front-starter-v1-customer-tips-success":``,
"label.tabpage.isdeleteview":`이 뷰를 삭제하시겠습니까?`,
"label.favorite.title":`CloudCC 클라우드 플랫폼`,
"page.layout.sysinfo":`시스템 정보`,
"label.tabpage.pleaseSelectz":`선택하시오`,
"label.smsnotice":`문자 알림`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`행위 거절`,
"label.searchlayout.view.example.new":`예시 보기(새 윈도우)`,
"vue_label_homepage_notice2":`수동으로 홈페이지 레이아웃을 분배함으로써 직원이 더욱 효율적으로 일상 업무를 완성할 수 있습니다.`,
"label.import.index.chooseidorother":``,
"label.westem.european.summer.time":`서구 시간`,
"label.brackets":`괄호`,
"asset.serialnumber.unique":``,
"label.callcenter.access.keyID":``,
"label.calendar.month.view":`월별 뷰`,
"label.realdelete":`영구 삭제`,
"label.partnerCloud.orderingPlatform.amountPaid:":``,
"label.reportTypName":`보고서 데이터 소스 명칭`,
"lable.newtabpage.opensearchresult":`검색 결과 펼쳐보기`,
"front-kefu-moudle-v1-Session-duration":``,
"label.import.index.ignore":`무시`,
"label.customfields.url.tip":`사용자가 모든 유효 사이트를 입력할 수 있습니다. 사용자가 해당 필드를 클릭하면 사용자가 선택한 모드에 따라 브라우저의 새 윈도나 현 윈도에서 해당 URL을 열어줍니다. 시스템이 기본으로 브라우저의 새 윈도에서 해당 URL을 열러줍니다.`,
"label.projectManagement.editMilestone":``,
"front-gantt-module-v1-project-gantt-list":``,
"label.validate.remark":`사용자가 오류 데이터 저장에 대한 방지를 통해 인증 규칙이 데이터 질을 개선할 수 있습니다. 한개나 여러개 인증 규칙을 정의하여 이중에 오류 조건과 대응한 오류 메시지가 포함됩니다. 인증 규칙이 기록 저장 시 실행됩니다. 오류 조건에 부합하면 저장을 중단하여 오류 메시지를 볼 수 있습니다.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":``,
"label.channel.name":``,
"label.weixin.cloudcc.user.message":`CloudCC 사용자 정보`,
"label.icon.59":`작업장`,
"label.ccpeak.function":`방밥`,
"lable.opppdt.selPdt.leastten.fields":`최대 5개 필드만 선택할 수 있습니다`,
"label.deadline":``,
"label.product.sel":`가격 매뉴얼 선택`,
"vue_label_helpcenter_detail2":`모든 행사:참여하지 않더라도 방문 권한이 있는 모든 행사를 볼 수 있다.<br>    일자 범위 및 행사 유형으로 확인하고 싶은 행사 기록을 선별할 수 있다.<br>4、동태 <br>     모든 해당 기록을 볼 수 있는 인원이 해당 기록의 '동태'기능 밑에서 댓글을 남길 수 있으며 해당 기록의 모든 정보 변경, 최신 활동 및 다른 인원이 해당 기록에 남긴 댓글을 볼 수 있다. 이 기능은<br>     동료와의 네트워크에서의 업무 교류와 협업을 도와 주어 팀의 협력과 업무 효율성을 제고시킨다. <br> 게시물 발표<br>    1단계: 게시물 입력 상자를 클릭하여 게시물 내용을 입력한다. <br>    2단계: 필요에 따라 파일/링크 버튼을 눌러 파일/링크를 추가한다.<br>    3단계:'공유'를 클릭하여 게시물을 발표한다. <br>게시물 확인 <br>    게시물 성공적으로 발표한 후 밑에서 방금 올린 게시물을 볼 수 있다. 게시물은 다음과 같이 몇 부분으로 구성된다: 프로필, 성명, 게시물 내용 및 교류 방식(좋아요 누르기/댓글/편집/게시물 삭제).<br>게시물의 배열 및 찾기 <br>     '순서 배열'우측의 드롭다운 리스트를 클릭하여 게시물의 배열 방식을 변경할 수 있다. <br>     '최신 행사' 순서 배열: 게시물의 최신 교류 시간으로 순서를 배열한다. <br>     '최신 발표'순서 배열: 게시물의 발표 시간으로 순서를 배열한다.<br>    다른 유형의 게시물을 확인한다. <br>    글 게시물:게시물 발표 구간에 모든 내용을 확인할 수 있다. <br>     파일이 첨가된 게시물: 파일의 다운로드 버튼을 눌러 다운로드해서 확인할 수 있다. <br>    링크가 포함된 게시물: 게시물에 링크를 클릭하여 열 수 있다. <br>댓글 및 좋아요 누르기 <br>     댓글 남기기 <br>    1단계: 게시물 밑에서의 '댓글'을 클릭한다<br>    2단계: 텍스트박스를 열어 댓글 내용을 입력한다<br>    3단계:필요에 따라 댓글에서 파일이나 링크를 첨부할 수 있다. <br>    4단계:텍스트박스 밑에서의 '댓글'을 클릭하여 작업이 완성된다<br>    댓글 삭제 <br>    댓글을 남기는 사람이 댓글 내용을 삭제할 수 있다. 댓글 우측의 버튼을 눌러 드롭다운 리스트에서 '삭제'를 선택한다.`,
"pagecreator_layout_button_mergecell":`셀 병합`,
"Lead_Scoring_Setting_Rule_Setup_Active":`활성화시키겠습니까?`,
"label.query.detail.loginbypartneruser":`사용자 신분으로 파트너 클라우드 사이트에 로그인합니다`,
"label.view.selectrenderfields":`표시할 필드를 선택하십시오`,
"label.code.add":`QR코드 링크 정보 추가`,
"label.appointmentconfirmpage.wizard.title1":`회의가 이미 예약되었습니다`,
"label.timzone.tip.title":`일자 시간 유형 데이터 멀티타임을 지원합니다.new Date()또는 Calendar를 사용할 때에는 해당 멀티타임에 주의하여 처리하십시오.또한 TimeUtil 툴 클래스에는 멀티타임을 지원하는 툴킷 방법이 많이 제공됩니다.`,
"label.tag.addtags.visibility":`시각성`,
"label.appointmentconfirmpage.wizard.title3":`기존 예약을 취소하고 새 예약을 생성하시겠습니까?`,
"lable.outlook.detail.oldest":`최초`,
"label.account.custom.quarter.timeerror":`사용자 설정 분기 시작 일자나 사용자 설정 분기 완료 일자가 사용자 설정 분기 이력 시간 범위에 있어 확인 후 다시 설정하세요!`,
"label.sendsms.idea":`존경하는`,
"label.manageAll.pagenum2":`지금은 마지막 페이지입니다.`,
"serviceterritory.isactive.notactive":``,
"label.userinfo.newpwd.notnull":`새 비밀번호를 입력하세요!`,
"vue_label_dashboard_nolinkagedashboard":`연동 가능한 대시보드가 없음`,
"message.cannotdeleteapproval":`승인 과정을 삭제할 수 없습니다`,
"label.wtd.detail.m":`모바일 버전`,
"label.app.step4.introduce":`이 사용자 설정 응용프로그램에 포함될 메뉴를 선택합니다.`,
"label.ccchat.error.permission":`권한 없음`,
"UG_opportunity_009":`혹은`,
"label.Receivables.TheActualAmountOfMoney":`실제 대금 수령 금액`,
"label.callcenter.no.search":`관련 정보를 조회할 수 없습니다`,
"label.user.introduce":`사용자`,
"message.datalocked.addpdt":`해당 업무 기회는 잠겨 있어 제품을 추가할 수 없습니다.`,
"label.sendsms.step1":`1단계: 문자 메시지 수신인을 지정합니다`,
"label.brief.contracts":`계약서 수`,
"label.setup.mini.swap":``,
"label.emailobject.wizard.desc1":`개인 메일과 연동시켜 메일을 전송하여 기록으로 자동 동기화됩니다.`,
"label.login.verification.mfa.desc2":`특정 사유로(핸드폰 분실이나 MFA응용 삭제 등)인증을 진행할 수 없으면 관리자를 통해 MFA연동을 해제시킬 수 있습니다`,
"label.notification.receiveSms.message":`{!fromaddress}에서 온 메시지가 도착했습니다. 클릭하여 확인하세요`,
"label.emailmerge.mergeFolder.publicfolder":`미보관 공용 메일 병합 템플릿`,
"label.password.update.false":``,
"label_tabpage_systemz":`개 시스템`,
"label.dataimport.objectid.null":`대상 ID가 비어 있으며, 시스템에서 가져올 수 없습니다.`,
"label.currency.type":`화폐 종류 유형`,
"component_setup_button_appurl":`본 시스템URL`,
"label.appointmentconfirmail.wizard.title2":`예약 성공하였습니다{0}`,
"lable.product.please.enter":`입력하세요`,
"label.escalation.setup.title":`개별안 업그레이드 규칙`,
"label.create_failure":``,
"label.weixin.brand.model":`상표 모델`,
"label.layout.nameoftestobj2":`테스트 대상2 명칭`,
"vue_label_filters_number":``,
"label.file.following":`팔로잉`,
"vue_label_account_all_contracts":`고객 소유인의 모든 계약서 이동`,
"label.service.please.select.cycle.type":``,
"label.weixin.weipoll.optionname":`투표 선택항목 명칭`,
"label.data.newtemplate.null":`없음`,
"message.passwordPolicy.validate.complexReq1":`오류: 비밀번호는 숫자와 알파벳의 조합이어야 합니다`,
"label.forecast.shre.editmanager":`매니저 편집`,
"label.emailtemplate.tip":`다음에 선정한 폴더의 모든 메일 템플릿을 나열했습니다. '새로만들기'버튼을 눌러 새 텍스트나 HTML 메일 템플릿을 생성할 수 있습니다. 메일 전송할 때 이 메일 템플릿들을 사용할 수 있습니다. 역할 링크를 클릭하여 상세 정보를 볼 수 있습니다.`,
"label.tag.manage.button":`라벨 관리`,
"label.changepw":`비밀번호 변경`,
"label.sso.saml.sp.idsource.nameid":`신원이 '주제' 성명 NameIdentifier 요소에 있습니다`,
"label.salescloud.teamrole.addmember":`업무기회 그룹 멤버 추가 CloudCC`,
"label.h5.similar.opportunity.last.months6":`최근 3-6개월`,
"message.save.opportunity.role.save.failed":`연락담당자 역할 저장 실패`,
"vue_label_report_formulainformation":`공식 정보`,
"label.area.assignuser.remark":`사용자를 구역에 분배합니다`,
"label.multilang.viewlist.total":`총 {0}개 기록을 선정했습니다`,
"label.newprocessstep4":`4단계 메일 알림 템플릿을 선택하십시오`,
"label.permission.objectpermission.open":`열기`,
"label.service.gantt.close.list":``,
"label.standarduserfield":`표준 사용자 필드`,
"vue_label_commonobjects_detail_the_administrator":`해당 기록이 잠긴 상태이며 관리자에게 연락하세요.`,
"label.exchange.sync.account":`Exchange 서비스 계정 증명서`,
"label.mr.title.button.back":`돌아가서 조회조건을 다시 설정합니다`,
"label.notsetup.operation":`행 조건이 잘못되어 연산 문자를 설정하지 않았습니다!`,
"label.notifications_center":``,
"label.event.moveup.5hour":`5시간을 앞당깁니다`,
"report_label_pleaseinput":`검색 내용을 입력해 주세요`,
"label.batchadd.newbatchpage.errorlist":`개 데이터 추가 실패했습니다`,
"label.quickbooks.invoices":`영수증`,
"chatter.feed.usingchatter":`CCChat을 사용한 후 인원과 기록을 팔로우업할 수 있어 붙일 수 있습니다.`,
"label.all.marketing.activities":``,
"label.lookup.finish":`찾기 자동 완료`,
"label.weixin.unbind":`연동 해제`,
"front-console-closeTime":``,
"label.service.rest.time":``,
"label.mr.descreption.condition1":`중복데이터 조회 범위와 규칙을 입력하고 [중복 데이터 조회] 버튼을 클릭하여 조건에 맞는 중복데이터를 확보합니다.`,
"label.group.new":`소그룹 새로 만들기`,
"vue_label_SMS_sending_please_wait":`전송 중이니 잠시만 기다리세요`,
"label.Standardobj.tab":`표준 대상 메뉴`,
"label_chatter_pastEvents":`지난 행사`,
"label.chatter.priority":`선수위`,
"select.nullvalue":`--없음--`,
"setup_layout_group_pagecomponent":`페이지 요소`,
"label.dataimport.dataerror.check":`데이터에 오류가 발생해 데이터를 잘 확인하세요`,
"label.permission.detail.app.pagesetting.tip":`사용자 설정 페이지 권한의 설정을 실행합니다`,
"label.knowledge.language.polish":``,
"label.project.hit.two":``,
"label.customerapp":`사용자 설정 응용프로그램`,
"label.reportsSubscriptionPage.condition.value":`값`,
"label.tabpage.no2z":`2가 아님`,
"lable.system.administrator":``,
"homepage.layout.buttion":`페이지 레이아웃 분배`,
"label.notification.event.overlapEvent":`피분배자가 이미{begintime}-{endtime}에 {subject}를 분배하였으며 계속 생성하시겠습니까?`,
"label.customfields":`사용자 설정 필드`,
"label.data.downpage.e.title":`데이터 내보내기 단계:`,
"label.notification.serviceappointment.remove":``,
"label.campagin.roi.zhuangtai":`마케팅 행사 상태`,
"label.applt.updown":``,
"label.customfields.new.step1.tip":`사용자 설정 필드에 포함할 정보 유형을 지정합니다`,
"label.staticresource.upload.limit":`다음 형식의 파일만 업로드 가능합니다: png、jpg、gif、js、css、zip.`,
"chatter.edit.user.p":`사용자 프로필 이미지 변경하기`,
"label.icon.32":`컴퓨터`,
"vue_label_homepage_notice_cantset":`해당 프로필에 대해 프로필 홈페이지를 배치하지 않아 프로필의 기본 홈페이지를 수정할 수 없습니다.`,
"front-epwechat-module-v1-agree-unbound":``,
"label.version.chatter.cooperation":`회사 동료 그룹`,
"label.customer.tab.step1.selectstyle":`메뉴 양식을 선택하세요`,
"label.select.an.asset":``,
"label.search.sizer.field":`필터 필드 검색`,
"label.emailmerge.mergeFolder.lastone":`최소 한 개 템플릿을 선택하세요!`,
"label_tabpage_step2":`2단계: 필터링 조건을 지정합니다`,
"label.version.lead.automatic.allocation":`잠재고객 자동 분배`,
"label.projectManagement.update.succeeded":``,
"label_tabpage_bar":`개`,
"label.appupload.component.type.tab":`메뉴`,
"label.pigeonhole.sel.f":`문서 보관할 폴더를 선택하세요`,
"homepage.components.status":``,
"label.currency.edit.new":`화폐 종류 편집: 신규 화폐 종류`,
"label.input.new.password":``,
"chatter.group.membersName":`멤버명`,
"label.myinfo.modify":`나의 정보 편집`,
"label_tabpage_next":`다음`,
"vue_label_homepage_card_closedopportunities":`기한을 넘긴 업무 기회`,
"label.permission.edit":`속성 편집`,
"message.error.searchfield.objid.null":`검색 필드가 필요한 대상id는 필수 요소입니다.`,
"label.partnerCloud.productSet":``,
"label.emailtocloudcc.filed.emailto":`메일 발송`,
"label.service.miniProgram.uploadingImage":``,
"label.sso.saml.idp.description1":`연결된 응용 프로그램`,
"label.event.moveup.10minutes":`10분을 앞당깁니다`,
"label.quote.createby":`준비자`,
"label.workflow.baseontimeoparate":`시간에 의존한 업무 프로세스 조작`,
"label.searchall.r":`다시 검색`,
"vue_label_homepage_differentprofiles":`다른 프로필에 다른 홈페이지를 분배합니다`,
"label.campaign.channel.step1":`1단계: 기본 정보`,
"label.event.moveup.2hour":`2시간을 앞당깁니다`,
"font-evaluate-module-v1-cancle-reply":``,
"message.datalocked.delete":`기록이 잠겨 있습니다: 삭제하려는 기록이 잠겨 있습니다.이 작업을 실행해야 한다면 관리자에게 연락하십시오.`,
"label.sso.listOfKey":`비밀키 리스트`,
"label_chatter_newtask":`업무 새로만들기`,
"label_emailsync_form_seversetting":`설정`,
"label.partner.new.function":`기능 설명`,
"vue_label_notice_homepage_pleaceentername":`홈페이지 명칭을 입력하세요`,
"message.please.choose.opportunity":`업무기회를 선택하세요`,
"label_file_use_most_user":`저장공간을 가장 많이 사용한 사용자`,
"label.htyj.remark2":`계약실적을 볼 수 없습니다`,
"label.formula.message":`공식이 거짓으로 평가될 때 제출한 실패 알림 정보`,
"UG_Case_04":`개별안 분배`,
"label.displaycolumn":`열 보기`,
"vue_label_campaign_selected_member_status":`선정된 멤버 상태로 업데이트됨`,
"label.workflow.operate":`업무 프로세스 조작`,
"label_chatter_mail":`메일`,
"label.setup.mini.setting":``,
"vue_label_chat_invitetojoin":`“{invite}”를 단체방에 초대했습니다`,
"setup.object.field.dependency.label.linkedfieldvalue":`종속 필드값`,
"vue_label_email_update_template":`템플릿 업데이트`,
"label.email.template.private.mail":``,
"lable.Confirm .potential.customers":``,
"vue_label_leadpool":`잠재 고객풀`,
"label.ems.hostorpost.error":`서버나 포트 설정이 잘못되었습니다. 확인해 주십시오.`,
"label.search.saveok":`저장 성공`,
"label.custom.field.cannot.maping":`이 필드에 여러번 매핑할 수 없습니다`,
"label.projectManagement.dispatched":``,
"time":`시간`,
"label.choose_socialnetwork":``,
"label.vlidaterule.checkedtrue":`체크 상자 필드라면 직접 판단하여 큰따옴표를 추가할 필요없습니다`,
"label.appointmentconfirmail.wizard.btn1":`다시 예약하기`,
"front-kefu-moudle-v1-maxchars-input":``,
"setup.mainpage.label.welcome10":`작업 메뉴얼: 본 페이지 좌측 메뉴를 클릭하여 →응용 프로그램 설정 →새로 만들기 →대상자 →대상자명 →사용자 설정 레이아웃`,
"label.ems.company.setup.title":`회사 보낸 메일함 설정`,
"label.channel":`마케팅 채널`,
"label.textmessage.groupsms":`단체문자 전송`,
"label.asset.deleted.successfully":``,
"label.knowledgebase.new.workspace":``,
"label.ServiceCloud.diliweizhi":``,
"label.private_me":``,
"label.service.miniProgram.imageLink":``,
"label.area.assigned":`분배된 사용자`,
"label.weixin..xsld.name":`업무기회 명칭`,
"label.campaign.matchway.select.name":`이름`,
"label.installedsoft":`설치된 소프트웨어 패킷`,
"label.projectManagement.spare.time":``,
"label.user.select.custom.text.sendemail":`사용자 설정한 텍스트 형식을 선택해 메일을 전송합니다`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`승인 진행`,
"startdate.enddate.time.illegal":``,
"label.project.hit.eight":``,
"message.duplication.label.uncheck":`검증하지 않습니다`,
"label.allocation.role":`사용자 분배`,
"label.sendemail.lead.scoreinfo":`존경하는 #userName:\r\n    시스템에서는 잠재 고객 채점 규칙을 사용하며 선택한 잠재 고객 뷰 "#viewlabel” 의 모든 잠재 고객 채점을 완료했습니다.#timestr 시간이 걸렸습니다. \r\n시스템에 접속하여 뷰를 열어 보십시오\r\n    주의:\r\n 잠재 고객 채점 값이 보이지 않으면 뷰를 편집해 "잠재 고객 채점" 을 표시할 필드에 추가하여 채점 결과를 볼 수 있습니다.\r\n감사합니다!\r\n                                                          #orgName\r\n`,
"lable.oppt.jieduan.closejieduan":`업무기회 종료`,
"label.ems.verify":`인증`,
"message.error.startdate":`시작일이 종료일보다 작아야 합니다`,
"label.campaignmember.main.deletelead":`멤버 삭제- 기존 잠재고객`,
"label.partnerCloud.financeSetting.account":``,
"message.datalocked":`기록이 잠겨 있습니다: <br> 편집하려는 기록이 잠겨 있습니다. 조작을 계속하려면 관리자에게 연락하세요.`,
"lable.opppdt.selPbk.pricebook":`가격매뉴얼`,
"label.knowledgebase.restore.article":``,
"label.object.batchadd":``,
"label.what_happen":``,
"label.roleandunderling":`역할과 부하`,
"label.knowledge.language.russian":``,
"front-electronic-signature-explain-first":``,
"component.sendmail.label.subject":`주제`,
"month":`월`,
"label_chatter_save":`저장`,
"label.view.sortview.sectiontitle":`뷰는 선택한 순서대로 출력됩니다.`,
"label.mobile.home.page.major.project":`중점 프로젝트`,
"label.weixin.input.filename":`파일명을 입력하세요`,
"label.pagelayout.remark":`이 페이지를 사용해 각종 페이지 레이아웃을 생성할 수 있습니다`,
"label.service.miniProgram.store":``,
"label.recordtype.edit.selected":`선택한 값`,
"message.selectgroupcondition":`그룹 분류 조건을 선택하세요`,
"label.y.axis.cannot.empty":`Y축을 입력하세요!`,
"label.textmessage.vonage.connected.count":`연락됨`,
"setup.layout.label.readonly":`읽기 전용`,
"front-kefu-moudle-service-agent":``,
"message.login.mfaverification.page.invalid":`페이지가 무효되어 새로고침 하세요`,
"label.central.standard.time":`중앙 표준 시각대`,
"label.processnoticepic":`승인 과정 주의 이미지`,
"vue_label_helpcenter_calendar1.2":`캘린더 항목 보기 규칙: 캘린더 항목은 캘린더 그리드에서 나타나 캘린더 항목이 있는 그리드 존은 해당 기록이 있는 시간 범위를 가르킨다. 일, 요일, 가용성 뷰에서 시간 라인 윗부분에 24시간을 넘긴 캘린더 항목이 표시된다. 월별 뷰에 많은 캘린더 항목이 있으면 ' 더 많이'를 클릭하여 확인할 수 있다. 캘린더 항목이 좌측이나 우측에서 반달 모양으로 나타나면 해당 그리드의 전날이나 훗날에 해당 기록이 없는 것을 의미한다. 캘린더 항목이 좌측이나 우측에저 직각 원형 모양으로 나타나면 해당 그리드의 전날이나 훗날에 해당 기록이 있는 것을 의미한다. <br>빠른 캘린더 뷰 일자 선정하기:캘린더 페이지 우측의 작은 캘린더에서의 시간을 선택해 좌측 캘린더 뷰 보기의 일자 범위를 선정할 수 있다. 캘린더 페이지 우상측의 “<”와“>”아이콘을 클릭하여 빠르게 일자를 전환한다. 캘린더 뷰가 있는 시간이 현재 시간이 아닌 경우 캘린더 페이지 우상측의 '오늘'아이콘을 클릭하여 빠르게 오늘로 전환된다. <br> 리스트 뷰<br> 캘린더 뷰에서 리스트 뷰로 전환한다: 캘린더 뷰 우상측의 '캘린더'아이콘을 클릭하여 '차트'를 선택해 이벤트 리스트 뷰로 전환할 수 있다. <br> 리스트 뷰의 사용: 특정 이벤트나 대량 이벤트를 동시에 확인할 때 리스트 뷰를 연다. 리스트 뷰에 미리 설정된 리스트 뷰가 있어 리스트 뷰 좌상측의 '드롭다운 버튼' 아이콘을 클릭하여 방문 권한이 있는 모든 리스트 뷰를 볼 수 있다. 또 사용자 설정 이벤트 리스트 뷰를 통해 사용자의 요구를 만족시킬 수 있다. <br>2. 나의 캘린더와 기타 캘린더 <br> 나의 캘린더 <br>나의 캘린더에 나의 이벤트 캘린더와 대상자 캘린더가 포함된다. <br> 나의 이벤트 캘린더: 캘린더 뷰에서 당신이 피분배자로 나타난 모든 이벤트 기록. 나의 이벤트 캘린더는 제거, 편집이나 색깔 변경이 불가능하다.'나의 이벤트 캘린더'를 동료와 공유할 수 있다.`,
"label.approval.end":`절차 완료`,
"vue_label_report_notice_cannotdelete":`해당 폴더에 보고서가 포함돼 있어 삭제할 수 없습니다`,
"label.sso.saml.idp.loginurl":`신원 제공자 등록 URL`,
"label.emailtocloudcc.filed.port":`포트`,
"label.directdashboard.righttitle":`세일즈 분석 대시보드`,
"label.knowledge.case.suggest.article":``,
"label.version.maxcount":`,상한을 초과했습니다!`,
"label.weixin..xsld.yjqyrq":`예정 계약 체결 일자`,
"front-project-module-v1-unmarket-is-template":``,
"label.mobile.quickcreate.default.map":`출석`,
"chatter.click.p":`미리보기 클릭하기`,
"label.chat.topic.all.topic":`모든 주제`,
"label.channel.head":``,
"lable.edit.queue.emaildes":`알림을 보낼 때 (예를 들어, 개별안을 대열에 넣었을 때) 사용할 대열 이름과 메일 주소를 입력하십시오.메일 주소는 단일 주소가 될 수도 있고, 통신 그룹 리스트가 될 수도 있습니다.대열에 대한 대상 배정은 대열 멤버에게만 통지됩니다.`,
"label.tag.filter":`라벨 필터`,
"label_chatter_filterTimeLine":`시간 라인 선별하기`,
"label.dashboard.show.value":`값`,
"vue_label_normal_solution_sf":`솔루션`,
"label.customfields.location.tip":`사용자가 위치를 정의할 수 있습니다. 경도와 위도 구성요소가 포함돼 거리를 계산할 수 있습니다.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com, inc. 베이징 CloudCC 과학기술 유한회사가 저작권을 소유하고 있습니다.`,
"label.icon.33":`컴퓨터`,
"label.mr.title.opportunityName":`업무기회 명칭`,
"template.report.sales.month":``,
"chatter.group.lookingForPeople":`인원 찾기...`,
"label_tabpage_userz":`사용자`,
"label.reportsSubscriptionPage.email.formatselection":`메일의 보고서 형식을 선택하세요`,
"lable.product.plist":`가격표 요금`,
"label.multilang.activity.monthline":`{0}째 주`,
"label.ccchat.whose.name.contains2":`의 모든 행사그룹 멤버`,
"label.mobile.phone.day.report":`일보`,
"label.processsetting.set.files":``,
"label.systemlog.s":`성공`,
"label.tabpage.uploadsz":`업로드`,
"serviceterritory.member.time.conflict":``,
"label_chatter_startDate":`시작일`,
"label.search.at.least.two":`검색어가 두 문자보다 작을 수 없습니다`,
"label.approval.ressign.project":`분배 대기 중인 프로젝트`,
"lable.custom.Previous.CY":`지난 사용자 설정 연도`,
"label_chatter_link":`링크`,
"label.weixin.group.name":`명칭`,
"label.partnerCloud.basicSetting.domainName":``,
"lable.SalesCommitmentKanBan.targetContract":`목표 계약체결액`,
"label.currency.new":`새 회사 화폐 종류`,
"message.passwordPolicy.validate.complexReq3":`에러: 비밀번호는 숫자, 알파벳 대소문자의 조합과 부호여야 합니다`,
"label.icon.127":`의사`,
"label.customfields.fieldname.tip":`필드명이 내부 API 통합에 응용됩니다`,
"chatter.feed.menutype.feed":`요약`,
"label.home.standard.dashboard.role":`역할 정보가 없어 판매 승낙 간판을 볼 수 없습니다.`,
"label.customfields.fielddependency.button":`해당 버튼을 클릭하여 종속 선택항목 리스트에서 선택한 값을 포함하거나 선택한 값을 제외시킬 수 있습니다.`,
"label.recentprojects":`최근 방문한 기록`,
"label.appupload.logo.introduce":`AppExchange 소프트웨어 패킷 아이콘 파일 크기가 20K를 초과할 수 없습니다. 최적 효과를 위해 이미지 사이즈 최대치가 넓이 60 화소, 높이 60 화소입니다. 다른 사이즈의 이미지인 경우 시스템에서 크기를 조절해 왜곡될 수 있습니다. 또 저장한 후에야 새 이미지가 발효됩니다.`,
"label.integrations.northamericanleads":`북미 잠재고객`,
"label.sms.balance":`잔액(위안)`,
"label.ccchat.message.num":`개 메시지`,
"label.embed_website":``,
"label.trigger.check.error":`트리거 문법 검사 실패`,
"label.bmap.baidu.maps":`바이두 지도`,
"label.nextapproverauto":`다음 승인자의 자동 확인 방식`,
"label.customfields.date.tip":`사용자가 일자를 입력하거나 팝업식 캘린더에서 일자 선택을 허용합니다.`,
"button.partner.back":`뒤로가기`,
"label.layout.editcondition.tip":`조회 조건으로 하는 필드를 선택하십시오.최대 10개의 필드를 선택할 수 있습니다`,
"label.stacked.area":`스택 도형-구역`,
"font-evaluate-module-v1-case-closed":``,
"label_emailsync_status_log":`관련 일지`,
"label.version.area.and.sales":`구역관리와 영업팀`,
"label.service.booking.sessions":``,
"label.untransfile":`미번역 언어 파일`,
"label.textmessage.sentfail":`전송 실패`,
"label.emailtemplate.detailinfo":`메일 템플릿 상세 정보`,
"setup_mainpage_label_welcome13":`조작 안내: 상단 메뉴를 클릭하여→ 보고서→ 새로 만들기.`,
"label.ccchat.error.nullid":`ID를 입력하세요`,
"label.partnerCloud.partnerAccount.rebate":``,
"label.appupload.component.type.scheme":`필드`,
"front-kefu-moudle-phonein":``,
"label.emailmerge.list.description":`메일 병합 템플릿이 Microsoft Word 파일이며 그중의 병합 필드가 CloudCC 필드를 인용합니다. '템플릿 새로만들기'를 클릭하여 메일 병합 템플릿을 업로드할 수 있습니다`,
"vue_label_commonobjects_detail_select_first":`관련 항목을 선택하세요.`,
"label_emailsync_form_action":`조작`,
"label.customfieldrelation":`사용자 설정 필드와 관계`,
"label.ems.other.msg":`Cloudcc 관리자에게 연락하세요(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>)，메일 동기화 서비스를 사용합니다.`,
"label.appointment.wizard.subtitle4-3-4":`1시간`,
"label.service.miniProgram.isOpen":``,
"equal":`같음`,
"label.partnerCloud.financeSetting.merchantInformation":``,
"vue_label_calendar_displayed_field_name":`디스플레이 필드 명칭`,
"UG_opportunity_002":`마케팅 주기를 정의합니다. 배치 단계`,
"label.tag.addtags.button1":`확인`,
"label.explain":`설명`,
"label.icon.166":`정자`,
"label.exchange.sync.setting.use":`Exchange Sync 사용`,
"label.chatter.assignPerson":`피분배자`,
"lable.PowerProcess.event.condition":``,
"label.addattachment.step1":`1단계. 파일을 선택합니다`,
"label.account.fiscal.quarter.timeerror":`회계 분기 시작 일자나 회계 분기 완료 일자가 회계 분기 이력 시간 범위에 있어 확인 후 다시 설정하세요!`,
"label.URL":`URL 경로`,
"label.icon.134":`데이터`,
"label.forecast.customforecast.foredis.sq":`몇 천`,
"label.custom.field.number.decimal":`숫자 자릿수가 잘못되었습니다`,
"label.version.history.track.error":`현재 버전은 <=5 필드만 지원되며 더 많은 것을 선택할 수 없습니다.`,
"label.log.os":`조작 시스템`,
"label.partner.workspace.tab.option":`선택 가능한 메뉴`,
"label.partnerCloud.partnerAccount.accountWater":``,
"setup_layout_label_norelatedlist":`관련 리스트 없음`,
"label.import.page1.nextstep":`다음`,
"label.emailobject.view.attached":`첨부 파일 있음`,
"label.SalesCommitmentKanBan.allTask":`총 업무액`,
"label.eastem.daylight.time":`동부 서머타임`,
"label.create_engaging":``,
"label.area.adduser":`사용자 추가나 삭제`,
"label.timezone.importtimezone.user":`현재 사용자 표준 시각대를 사용합니다`,
"label.passwordPolicy.setup.pwdremember1":`비밀번호 1개 기억하기`,
"label.query.detail.openpartneruser":`협력 파트너 사용자 사용`,
"label.senduser":`발송인`,
"Pagelayout_Setup_001":`호버 페이지 레이아웃에 보는 관련 리스트를 선택합니다`,
"label.mobile.parameter.setup":`모바일기기 매개변수 배치`,
"message.device.not.bound.mfa":`연동되지 않은 MFA 장치`,
"setup.layout.label.buttonarea":`버튼 구역`,
"chatter.email.reply.like":`내가 좋아하는 게시물에 답장할 때`,
"label.chatter.day":`일`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat 좋아하는 게시물에 댓글 달기`,
"label.field.remark2":`페이지에 표시된 필드.`,
"label.ggReleaseRange.release":``,
"lebel.alreadyback":`되돌림`,
"label.appupload.install.appname":`응용프로그램 명칭`,
"label.selectnewadeckertag":`새 등급 구조 필드의 라벨을 선택하십시오`,
"label.cliententrancewebsiteadmin":`고객 입구 사이트 관리자`,
"label.checkbox.checked":`선택한`,
"UG.Case.03":`개인안 자동 업데이트`,
"vue_label_dashboard_group":`1급 그룹을 선택하세요.`,
"label.import.index.preparedata":`불러올 데이터를 준비한다`,
"vue_label_member_notice1":`JPG、GIF나 PNG 형식의 파일을 업로드할 수 있어 파일 최대 크기는 2M입니다`,
"message.modify.success":`수정 성공.`,
"label.userquotas":``,
"label.appointmentpage.wizard.subtitle3-1":`이름`,
"label.import.index.maxdata2":`2. 불러오기 전에 관련된 모든 기록을 확보한다. 예를 들어 현재 불러오는 대상자 및 담당자 간에 관계가 있으면 담당자를 먼저 불러오고 데이터를 불러온다. 관련된 기록 id 등 정보가 필요하면 먼저 보고서를 만들어 기록 명칭과 기록 id를 조의 렬 형태로 설정해 보고서를 내보낸다.`,
"label.pc.sectionpart":`PC 부분`,
"template.chart.wcldqzkh":``,
"label.save.the.block.pricing.information.of.the.current.price.manual":``,
"label.partnerCloud.financeSetting.payments":``,
"lable.account.ThisWeek":`이번주`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`배경색 선택`,
"label.planned.work":`계획한 업무`,
"label.passwordPolicy.setup.nolimit":`제한 없음`,
"label.vlidaterule.s":`사용자가 사용하는 화폐 종류를 사용하지 않으면 사용자의 화폐 종류를 회사 화폐 종류로 설정합니다.`,
"label.paging.totalofrecords":`총 {0}개 기록`,
"label.customobjects.behaviour":`행위`,
"vue_label_ccchat_notice_deletecommentsuccess":`댓글 삭제 성공`,
"label.lock.record.dele":`현재 기록이 잠겨 있어 삭제할 수 없습니다!`,
"label.data.expnode.e.desc3":`3.템플릿 제작: 사용자가 니즈에 따라 내보내야 하는 필드 및 조건을 템플릿으로 제작하여 다음은 편하게 사용할 수 있다.`,
"label.button.step3.create.page":`3단계: 페이지 생성합니다`,
"label.sharer":`공유자`,
"label.service.cycle.type":``,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`총 대금 수령 승낙률`,
"label.formuladate":`일자 형식:YYYY-MM-DD hh:mm:ss 혹은 MM/DD/YYYY hh:mm:ss 예:2007-12-25 12:25:30 혹은12/25/2007 12:25:30, today()，혹은 now();를 사용 가능합니다.`,
"front-template-V1-addImg":``,
"label.basecontrol":`기본 권한`,
"label.forecast.settings.lable1":`예측 데이터 집합`,
"message.error.file.null":``,
"label.multiply":`*곱셈`,
"message.duplication.label.targetobject":`목표 대상`,
"label.addattachment":`첨부파일 추가`,
"vue_label_dashboard_notice_editcertification":`구성 요소 {name} 를 편집하시겠습니까?`,
"label.notification.tip2":`새 알림이 없습니다`,
"lable.quote.syncingfrom.firstsync":`초보 동기화: 업무 기회를 견적서에 동기화합니다`,
"label.createtasktip":`업무를 생성해 한개나 여러개 업무 프로세스 규칙, 승인 과정이나 권리 과정과 관련시킵니다. 업무를 변경하면 모든 변경이 관련된 규칙, 승인과 권리 과정에 적용됩니다.`,
"label.leave":``,
"front-invoice-online-payment-setup-china":``,
"label.appointment.wizard.subtitle4-1-2":`30분`,
"label.projectManagement.the.person.not.be.informed":``,
"label.campagin.roi.name":`마케팅 행사 명칭`,
"label.import.page1.newcreate":`새로 만들기`,
"label.data.downpage.i.title.num2":`2. 불러오기 전에 불러올 파일의 필드 명칭이 CloudCC 시스템의 대상자 필드 명칭과 일치하는지 확인하세요`,
"label.callcenter.call.in":``,
"label.weixin.activity.phone":`행사: 전화`,
"label.forecast.customforecast.type.role":`역할로`,
"label.moscow.standard.time":`모스크바 표준시`,
"label.profile.setcustomobjectrecordtype":`사용자 설정 대상 기록 유형 설정`,
"lable.edit.queue.new":`대열 새로만들기`,
"label.newAPPexchange":`응용프로그램 새로만들기...`,
"message.custom.field.donotdelete.fieldupdate":`이 필드는 다른 업무 프로세스나 승인 과정의 필드 업데이트에 인용됩니다.`,
"label.chatter.state":`상태`,
"label.subject_line":``,
"template.report.folder.active":``,
"label.icon.114":`주택`,
"label.assignment.setup.newentries.step3":`3단계: 분배할 사용자를 선택하십시오`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`개인- 행동 열람`,
"label.weixin.optiontwo":`선택항목2`,
"label.sso.saml.idp.config.sp":`서비스 제공자`,
"System_TimeField_Description":`사용자가 현지 시간을 입력할 수 있습니다. 예, '2:40 PM', '14:40'과 "14:40:00"은 이 필드의 유효 시간입니다.`,
"label.knowledgebase.draft":``,
"label.chat.topic.no.more.suggestions":`다른 건의 사항 없음`,
"label.quote.product":`제품`,
"label.cryptographictext":`암호화 텍스트`,
"label.custom.unlock":``,
"label.assignment.setup.newentries.step2":`2단계: 이 규칙 항목의 조건을 선택하십시오`,
"label.tabularreport.selectline":`보고서에 포함될 열을 선택합니다`,
"label.exchange.sync.state.contact.m2":`최후 60분에 동기화된 기록:`,
"label.codeType":``,
"saturday":`토요일`,
"label.mask.type":`마스크 유형`,
"label.schedulejob.setup.schedule.Monthly":`매월`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`파일 중 필드 총 {{20}}개, 남은 {{20}}개가 매핑되지 않음`,
"label.projectManagement.delete.item":``,
"label.page.general.us.and.western.europe":`통용 영어와 서구 언어`,
"label.reportsSubscription.status":`구독 완료`,
"label.discount.baifenbi":``,
"font-evaluate-module-v1-web-page-evaluation-settings":``,
"message.error.searchwork":`검색어가 두 글자보다 작으면 안 됩니다.`,
"label.weixin.option.setting":`선택 항목 설정(최대 10개 설정)`,
"label.lead.score.prompt1":`잠재 고객 한명인 경우 잠재 고객을 생성하거나 편집할 때 자동으로 채점할 수 있지만 모두 불러오거나 인터페이스로 생성한 잠재 고객에게 수동으로 모두 채점을 해야 합니다.`,
"label.exception.must.try.throw":`이상은 블록에 던져야 합니다!`,
"label.activity.plan":`계획`,
"label.partnerCloud.productSet.editor":``,
"label.mobile.quickcreate.default.signinnew":`출석`,
"label.summaryreport.2018.step6.new":`6단계: 차트 유형 및 보고서 하이라이트 보기 선택하세요`,
"vue_label_homepage_owner":`의 홈페이지`,
"vue_label_dashboard_editfoldersuccessfully":`폴더 편집 성공`,
"label.quickbooks.view.overdueinvoices":`만료된 인보이스`,
"label.emailtocloudcc.redmessage4":`포트 정보를 입력하시오`,
"label.tabpage.equalz":`같다`,
"lable.quote.syncing.firstsync":`최초 동기화: 견적서를 업무기회로 동기화`,
"label.download.CloudCCAPP":``,
"label.icon.6":`화폐`,
"label.list.serial.number":``,
"label.profile.setstandardobjectrecordtype":`표준 대상 기록 유형 설정`,
"label.customize.memory.function.sorting.error":``,
"message.view.addtoallusers":`관련 인원이 볼 수 있음`,
"label.globaloperation.operationtype.record.phone":`기록 전화`,
"lable.opppdt.selPdt.searchresult":`조회 결과`,
"label.import":`불러  오기`,
"label.service.gantt.work.based.resources":``,
"label_partner_template_detailimage":`상세도`,
"label.cpq.product.feature.option.count":``,
"label.chatter.newtask":`임무 새로 만들기`,
"font-trade-module-v1-invoice-total-price":``,
"setup_mainpage_label_welcome29":`표준한 API 및 제3자 제품 통합`,
"label.data.exportall.all.btn":`모든 데이터 내보내기`,
"front-epwechat-module-v1-unbound-WeChat":``,
"label.salescloud.salesdashboard.performance.rankings":`전체- 판매 계약서 실적 랭킹`,
"label.import.page1.newcreateandupdate":`업데이트 및 새로 만들기`,
"component.chatter.post.button.file":`첨부 파일 추가`,
"label.partnerCloud.orderingPlatform.createOrder":``,
"label.lookup.multiple.data":`검색된 데이터가 많으며 수동으로 선택하세요`,
"button.partner.save":`저장`,
"label.service.add.timeslot":``,
"label.campaign.matchway.select.email":`메일`,
"front-sales-button-fromQB":``,
"label.icon.108":`화살표`,
"lable.outlook.edit.efmapping":`필드 매핑 편집`,
"label_tabpage_refreshz":`새로고침`,
"chatter.follow.cancel":`팔로잉 취소`,
"label.totals.sum":`총수 통계`,
"label.noRequest":`요구 없음`,
"vue_label_homepage_fixedcomponent":`표준 구성 요소 선택하세요.`,
"label.knowledge.delete.case":``,
"label.weixin..xsld.yjwc":`예상 수입`,
"label.customcomponent.page.index.console.btn":`개발자 콘솔`,
"label.sendsms.batch":`문자 단체 전송`,
"vue_label_chat_onlychosechat":`채팅을 개설한 사용자만 선택할 수 있습니다`,
"label.tabpage.page":`폐이지`,
"label.cyen.note":`화폐 종류를 사용합니다. 화폐 종류를 사용한 후 되돌릴 수 없는 점을 유의하세요.`,
"label.weixin.againsend":`다시 전송`,
"label.processnumber":`단계 번호`,
"label.emailobject.to":`수신인:`,
"label.event.today":`오늘의 이벤트`,
"label.dashboard.dispalyPosition":`포지션 보기`,
"message.error.recalculate.dupoperate":`재계산이 진행중이니 빈번하게 조작하지 마십시오!`,
"vue_label_email_linkrecordsuccess":`기록 연동 성공`,
"label.updateoutboundnews":`아웃바운드 정보 업데이트`,
"label_emailtocloudcc_exists2":`본 메일 주소가 이미 Email to Case로 설정되어 중복 설정할 수 없습니다`,
"label.tag.addtags.button2":`취소`,
"label.stdashbord.xsld.business.role":`이 역할이 예측 등급 구조의 사용한 사용자 역할에서 나옵니다`,
"label.commonnew":`일반 새로만들기`,
"label.validate.remark2":`사용 예시:`,
"label.reportsSubscriptionPage.condition.checkbox":`보고서에서 조건 추가`,
"label.globalselect":`전역 선택항목 리스트값 세트`,
"label.partnerCloud.partnerAccount.available":``,
"label_tabpage_nothingz":`없음`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":``,
"message.error.pleasecorrectdata":`다음 오류 정보를 점검하여 데이터를 수정하세요.`,
"label.hight.tip":`고급 선별을 사용하지 않을 때 다른 선별에 각 조건의 관계는 '및'이어 즉 1과 2의 공동 특징의 기록을 만족시킵니다.`,
"label.workflow.estimatecondition3":`기록을 만들거나 편집할 때`,
"AssetRelationship.time.limit.error":``,
"label.multilang.workflow.dayinmonth":`{0}개월마다의 {1}번째`,
"label.reportsSubscriptionPage.schedulereport.daily":`매일`,
"label.emailtocloudcc.step1.name":`기능 선택`,
"label.follow_up":``,
"label.price.list.price.cannot.be.empty":``,
"label.chatter.link":`링크`,
"label.ccpeak.condition.return.record":`조건에 따라 기록으로 돌아가며 자주 사용한 where 조건이 지원됩니다.`,
"pagecreator.layout.message.canntdelete":`현재의 레이아웃에서 삭제가 불가능합니다`,
"label.compact.layout.main":`주요 중요 정보 레이아웃`,
"label.testandupdate":`업데이트 확인`,
"button_partner_cancel":`취소`,
"label.activity":`행사`,
"label.knowledge.setting.hint.fourteen":``,
"vue_label_commonobjects_view_open_from_list":`리스트에서 열어 사용합니다.`,
"front-electronic-export-intro":``,
"label.chosen.all":``,
"label.file.extension":`파일 확장명`,
"vue_label_systemSettings_server_miniprogram":``,
"label.weixin.no.pending.wdgz.qin.today":`오늘은 업무 스케줄이 없습니다.`,
"label_tabpage_issuez":`질문`,
"label.staticresource.tip":`고정 리소스를 사용해 사용자 설정 페이지에서 인용하려는 콘텐츠를 업로드하며 zip, 이미지, 양식 차트, JavaScript프로그램과 다른 파일이 포함됩니다.`,
"label.approvalstep":`승인 단계`,
"label.china.standard.time":`중국 표준 시각대`,
"label.appexchange.download.tiaoguo":`건너뛰기`,
"label.callcenter.link.Amazon.connect":``,
"vue.dashboard.notRequired.notConformToTheRules":``,
"label.appointment.wizard.title1":`유휴 시간을 설정하세요`,
"label.chat.remove.bookmark":`저장 취소`,
"label.tabpage.advancedsearch":`고급 검색`,
"batch.ranf.f":`모두 이동 조작 실패!`,
"label.appointment.wizard.subtitle4-1-4":`1시간`,
"label.brief.account":`고객`,
"component.chatter.link.label.url":`링크 URL`,
"label_emailtocloudcc_redmessage8":`파라미터에 오류가 발생하여 관리자에게 연락하세요`,
"label.object.create.two.number.field":`대상마다 최대 2개 사용자 설정 자동 번호 필드를 생성할 수 있습니다`,
"label.salecommit.not.roleinformation":`역할 정보가 없어 세일즈 약속 간판을 볼 수 없습니다.`,
"label.defautline.cannot.less":`최소 기본 행수는 1입니다`,
"label.selectedproducts":`선정한 제품 수`,
"label.productsales.today.notskadd":`오늘 만료된 업무가 없어 우상측의 ' '를 클릭하여 업무를 추가할 수 있습니다!`,
"lable.account.year.stadate":`회계 연도 시작일`,
"label.mobile.phone.month.plan2":`이번달 계획`,
"label.ccpeakfolder":`종류 폴더`,
"setup_mainpage_label_welcome21":`CloudCC 클라우드 플랫폼이 사용자 설정한 메일 템플릿 기능을 제공합니다. 사용자들이 통일적으로 사용함으로써 업무 효율을 제고합니다.`,
"label.modify.layout":`레이아웃 편집`,
"report.label.folder":`폴더`,
"label.tianyancha.businessverify.rewritename":`고객명 다시 입력`,
"lable.currencyAdv.dao":`로`,
"label.mobilelayout":`모바일기기 레이아웃`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":``,
"label_partner_all_disable":`사용 금지`,
"label.ownerapproverfield":`소유인의 승인자 필드`,
"label.emailobject.template.message4":`메일 택스트에서 삽입한 필드에 널값이 존재해 편집한 후 다시 전송하세요!`,
"label.productsales.today.notsk":`오늘 만료된 업무가 없습니다!`,
"label.multilang.document.upload.success":`{0}개 파일 업로드 성공하였으며 {1}개 파일 업로드 실패했습니다`,
"label.manageAll.sta3":`승인 거절`,
"vue_label_calendar_week_view":`캘린더 - 주일별 뷰`,
"setup_layout_label_nocustompage":`사용자 설정 페이지 없음`,
"label.weixin.wdyj.jxdcl":`개인- 성과 달성률`,
"label.donot.update":`변경 권한이 없습니다!`,
"setup.mainpage.label.welcome14":`작업 흐름 설정, 승인 프로세스 관리`,
"UG_Campaign_002":`마케팅 행사 효과를 계획, 실시 및 모니터링합니다.`,
"label.layout2":`레이아웃2`,
"label.app.looup":`응용프로그램 찾기`,
"label.projectManagement.selectitem":``,
"label.field.relating.rule":`필드 관련 찾기 규칙`,
"vue_label_commonobjects_detail_selectname":`명칭부터 선택하세요.`,
"front-email-payment-Invoice-select-pay":``,
"label.customfields.formula.numberexample":`Fahrenheit（화씨 온도）= 1.8 * Celsius__c   32`,
"component_event_label_enddate":`*종료시간`,
"label.partnerCloud.partnerAccount.lineOfCredit":``,
"label.chatter.newpost":`최신 게시물`,
"label.report_dashboard":``,
"label.assigned":`피분배자`,
"Homepage_News_002":`현재 뉴스 구성요소 서비스를 사용할 수 없습니다`,
"label.approval.select.relatedobj":`관련 항목을 선택하면 한 유형을 선택해야 합니다`,
"label.service.miniProgram.isTop":``,
"message.error.object.datatoolang":`데이터 길이가 너무 길어 최대 길이는 {!length} 문자입니다.`,
"label.importsourcetip":`불러오기는 내보낸 파일을 수정하고 다시 시스템으로 불러옵니다.내보내기 전이라면 내보내기 페이지로 이동하십시오.`,
"label.select.deadlineplease.deadline":``,
"vue_label_account_equityrelationship":``,
"label.account.Calendar.month":`캘린더 월간`,
"label.appointment.wizard.subtitle3-4":`목요일`,
"font-evaluate-module-v1-smaller-500":``,
"label.reportsSubscriptionPage.email.tome":`나에게만 전송하기`,
"label.ccchat.person.invite.existpers":`팔로우업 중:`,
"label.appointment.wizard.subtitle1-3":`30분`,
"front-kefu-moudle-connected":``,
"label.campaignmember.main.duplicatelist.tip":`시스템이 이 설정에 따라 잠재고객과 마케팅 행사 멤버에 대해 중복 검사를 사용합니다.`,
"label.visualpage.such.tags.double":`등 라벨이 반드시 두개씩 나타납니다`,
"label.sendsms.batch.step2.introduce":`문자 메시지 템플릿대로 전송: 사용할 문자 메시지 템플릿을 선택하십시오.`,
"Account_News_Setting_002":`다음의 고객설정을 귀조직이 지정된 기본 고객행위로 사용합니다`,
"message.encryptchange.alert":`{{!fieldapi}}를 암호화 필드 (메모리 암호화)에서 암호화 텍스트 (암호화 표시) 로 전환할 것입니다. 전환되면 평문 형식으로 데이터 베이스에 저장됩니다. 표시할 때 프로필의 설정에 따라 평문이나 암호문으로 표시될 수 있어 필드를 검색할 수 있습니다. \\r 이 동작은 되돌릴 수 없습니다. 계속 진행하시겠습니까?`,
"label.mainpageset.description":`실제 사용 시나리오에 따라 조직 메인 홈페이지를 배치합니다. <br> 업체 업무와 무관한 구성요소를 기본 배치에서 금지사용이나 닫기를 설정할 수 있습니다. <br>사용: 사용한 모듈이 모든 멤버의 메인 홈페이지에서 볼 수 있습니다. <br>금지 사용: 금지 사용된 모듈이 모든 멤버의 메인 홈페이지에 나타나지 않으며 모바일기기 '나의 메인 홈페이지 배치'리스트에도 나타나지 않습니다. <br>닫기: 기본으로 조직의 모든 멤버의 메인 홈페이지에 나타나지 않으며 사용자가 모바일기기 '나의 메인 홈페이지 배치'를 통해 모듈을 사용할 수 있습니다.`,
"label_tabpage_linknamez":`링크 명칭`,
"label.companyname":`베이징 CloudCC 과학기술 유한회사`,
"label.currency.current":`현재 회사의 화폐 종류`,
"label.campaignmember.main.duplicatelist.html.title":`스캔 중복 제거 설정`,
"label.sendsms.batch.step3.plan":`교부 일자 계획`,
"label.profile":`프로필`,
"label.canceluploadfile.step":`'업로드 취소'버튼을 클릭하여 상단 구역의 모든 파일이 취소됩니다`,
"message.newreport":`보고서 새로만들기`,
"label.service.newBuildDialog.date.selection":``,
"label.lookup":`조회`,
"label.file.editinfo":`파일 상세 정보 편집`,
"component_assistant_label_nodata":`오늘 업무가 없으므로 잠시 후에 확인 바랍니다.`,
"label.tianyancha.businessverify.msg4":`본 기능은 제3자 데이터 조회 인터페이스가 제공한 서비스를 사용해 현재 무료 사용 가능하지만 CloudCC가 제3자가 향후 계속 무료 사용 여부를 확보할 수 없습니다. 제3자 서비스가 유료로 전환된 경우 CloudCC가 사용자에게 비용을 받는 권리가 있고 사용자가 이 기능을 사용 중단할 수 있습니다.`,
"label.noequal":`!=부등어`,
"vue_label_metric_column":``,
"label_reportType_chose_and_form":`보고서 데이터 소스 및 보고서 형식을 선택하십시오`,
"vue_label_pool_reasondescription":`{0}원인 내용`,
"label.isusing":`사용 여부`,
"label.passwordPolicy.setup.pwdremember5":`5개 비밀번호를 기억합니다`,
"label.cancel":`취소`,
"vue_label_helpcenter_detail1.1":`    lightning 버전의 데이터 상세 정보 페이지에서 단일한 기록의 기본 정보, 관련 행사, 상태를 확인할 수 있다. 모듈 우상측에서 관련 정보를 확대하거나 접을 수 있다. 관련 리스트를 통해 관련 데이터를 확인 및 관리할 수 있다. <br>1. 단일한 데이터의 확인 및 관리<br>우상측의 버튼을 통해 데이터를 편집, 복사, 삭제하거나 다른 사용자에게 권한을 공유할 수 있다. <br>사용자의 자세 정보를 확인하여 페이지에서 일부 필드에 대해 편집할 수 있고 데이터의 소유자나 기록 유형을 변경할 수 있다. <br>관련 리스트를 통해 관련 데이터를 확인 및 관리가 가능하다. 파일의 관련 리스트에서 기록한 파일을 올리거나 파일명을 클릭하여 관련 파일을 다운로드할 수 있다. <br>2. 관련 리스트 <br> 관련 리스트 빠른 연결을 통해서 팝업창을 통해 최대한 10개 관련 기록을 확인할 수 있다. 클릭하여 리스트 보기로 들어가 모든 관련 기록을 확인하여 내부 연동 편집이 가능하다. <br>밑에서 카드식으로 관련 기록을 확인 및 관리할 수 있다. <br>3、행사<br>    기록의 자세 정보 페이지에서  Lightning 버전에서 '미처리 행사'및'행사 이력 기록' 두가지 리스트가 나타나지 않는다. 행사 시간 라인이 나타난다. <br>행사 시간 라인에서 나타난 내용 <br>    행사 시간 라인이 현재 기록에서의 미래에서 과거로의 모든 행사가 표시된다. 기한을 넘긴 업무와 곧 다가올 업무, 이벤트는 행사 시간 라인의 ' 기한을 넘긴 업무와 곧 다가올 업무'모듈에서 나타난다. 과거나 현재의 이미 끝난 업무, 이벤트, 기록 전화, 이메일, 문자는 대응한 월별로 나타난다. <br>`,
"registration.page.preview":``,
"label.quickbooks.search":`검색`,
"label.setup.mobile.bottombutton.tab.show":``,
"lable.want.to.delete.tem":``,
"label.multilang.fielddtrack.dealkey":`{0}을 {1}에서 {2}로 변경합니다`,
"vue_label_pool_return":`반환`,
"vue_label_calendar_failed_to_share_calendar":`캘린더 공유 실패`,
"label.less":`<적다`,
"label.email.form.html":`HTML`,
"label.tag.nodata":`라벨 데이터 없음`,
"label.setarticlecon":`항목 조건 지정`,
"label.searchlayout.displayrow":`표시한 열`,
"label.change.task":`업무뷰로 전환하기`,
"lable.quote.editqtpdt.title":`견적서 명세 편집`,
"label.appointment.wizard.subtitle4-4":`사전 예약 가능한 최대 시간`,
"label.custom.page.button.css":`버튼 CSS`,
"label.input.documentmessage":`상세 정보를 입력합니다`,
"vue_label_commonobjects_detail_email_address":`수신자 주소`,
"label.chatter.filterTimeLine":`시간 라인 선별`,
"label.must.select.twoorthree.records":`2개나 3개 병합할 기록을 선택해야 합니다`,
"label.mobile.setup":`모바일기기 설정`,
"vue_label_commonobjects_detail_key_field":`키 필드`,
"label.chatter.relateitem":`관련 항목`,
"label.customobjects.tip":`사용자 설정 대상을 생성하면 사용자 설정 메뉴, 사용자 설정 관련 리스트, 보고서와 대시보드를 생성함으로써 사용자가 설정된 대상 데이터에 대해 교환 조작을 할 수 있습니다. CloudCC.com API를 통해 사용자 설정 대상 데이터를 방문할 수 있습니다.`,
"label.sso.saml.idp.config":`신원 제공자 설정`,
"label.knowledgebase.affect.article.version":``,
"message.error.record":`관련 기록이 없습니다!`,
"message.duplication.label.fieldname":`목표 필드`,
"setup.layout.button.cancel":`취소`,
"label_radar_map_function":``,
"label.campagin.roi.fss":`전송 수량`,
"label.emailobject.template.giveup":`포기`,
"label.apiname.exists":`Api 명칭이 존재합니다`,
"message.failtoreaddata":`데이터를 읽는 데 실패했습니다`,
"label.file.versionedit":`내용수정자`,
"template.report.lost.business.opportunity":``,
"label.ccchat.group.allowgd":`그룹 보관 허용`,
"label.fieldaccesslimit":`필드 방문 가능성`,
"label_target_model":``,
"message.validation.isnoturl":`올바른 URL을 입력하십시오`,
"servicecrew.member.time.conflict":``,
"label.knowledgebase.delete.details":``,
"vue_label_normal_bottom":`밑으로 설정`,
"label.custombutton.editerror":`편집 실패`,
"label.dashboardSetup.showdw.d6":`자동`,
"message.error.field.decimalPlaces":`소수 자릿수 입력 형식이 잘못되었습니다`,
"label.tabpage.busoppnamez":`업무 기회명`,
"label.insertfield.intro":`한 필드를 선택하고 '삽입'을 클릭합니다. 뒤에 '>'가 따른 라벨이 더 많은 사용 가능한 필드가 있음을 의미합니다.`,
"setup.layout.label.nocustompage":`사용자 설정 페이지 없음`,
"front-gantt-module-project-has-only":``,
"label.weixin.fmu.am":`오전{0}`,
"label.emailsync.status.connectaccounts":`메일 계정 연동`,
"label.customcomponent.check.name.same":`명칭이 이미 존재합니다`,
"label.validate.function.funcFormat.HOUR":`시간(일자)`,
"label.approvepagelayout4":`이전 행 레이아웃을 복사하기`,
"label.knowledge.category.hint.nine":``,
"label.report.sorting.column":`정렬 열`,
"label.hours":`시`,
"label.email.clearAllemail":``,
"font-evaluate-module-v1-satisfaction":``,
"label.service.hide.more.info":``,
"label.area.list.intro":`여기서 구역 정보를 조작할 수 있습니다`,
"label.sendemail.chat.addPostat":`존경하는#name:\n\n    안녕하세요!#userName 올린 게시물에 님을 소환했습니다.`,
"label.data.newtemplate.e_seltype.desc":`데이터 내보내는 방식은 두가지가 있습니다: </li><li class="titledesc1">1.CSV형식(기본)</li><li class="titledesc1">2.압축 형식. 데이터 내보내기 방식의 압축 형식은 두가지가 있습니다: </li><li class="titledesc1">2.1. 자동 생성한 압축 파일 비밀번호, 자동 생성한 비밀번호는 데이터가 내보내기 성공한 후 사용자 메일로 전송됩니다. </li><li class="titledesc1">2.2. 압축 파일 비밀번호를 수동으로 입력해 수동으로 입력한 비밀번호는 사용자 메일로 전송되지 않아 사용자가 본인이 입력한 비밀번호를 기억해야 하고 입력하지 않으면 비밀번호 없는 것으로 기본 설정됩니다.`,
"message.passwordPolicy.validate.minlengths":`에러: 비밀번호 길이가 최소`,
"message.save":`저장하시겠습니까?`,
"label.marketsea.notfollowdays1":`획득 후`,
"label.app.step1":`1단계. 유형을 선택합니다`,
"message.error.pageid.null":``,
"label.weixin.input.lookupfield":`키워드를 입력해 매칭된 투표를 검색합니다`,
"label.whChatAccount":`위쳇 아이디`,
"label.tabpage.groupingitem":`그룹 분류 항목`,
"label.callboard.introduce":`아래에 귀사의 모든 공지를 열거했습니다.`,
"label.financial.services.seminar":``,
"label.data.file.i_title.num1":`1. 불러오는 파일은 CSV 형식의 파일이어야 하며, CSV 파일은 제목을 포함해야 합니다. 제목이 없으면 가져올 수 없습니다.`,
"label.visualpage.filename.exist":`파일명이 존재합니다`,
"front-kefu-moudle-v1-new-chats":``,
"label.console.step5.tab":`메뉴 열기`,
"vue_label_opportunity_contactrole_edit":`연락담당자 역할 추가`,
"label.projectManagement.delete.return":``,
"registration.page.designs":``,
"label.console.step6.heigth":`높이`,
"label.objectRelationshipAtLeast":`관련 기록을 최소한 한개 가지고 있습니다`,
"label.knowledge.delete.viewstat":``,
"label.direct.dashboard.month.report":`업무 월보 새로만들기`,
"label_tabpage_lookatmorez":`더 많이 보기`,
"label.setup.rights.management":``,
"label.campaign.channel.clear.img":`이미지 지우기`,
"label.calendar":`캘린더`,
"label.biaoqingfaxian.username":`계정`,
"label.weixin.wdyj.jxht":`개인-판매실적-계약서`,
"label.emailtocloudcc.exists1":`본 이메일은 이미 Email to Lead로 설정되어 중복 설정이 불가능합니다.`,
"label.emailtocloudcc.filed.password":`이메일 비밀 번호`,
"label.what_create":``,
"vue_label_report_onlydisplaypart":`데이터 최대 50개만 표시되며 운행 후 모든 데이터가 표시됩니다.`,
"label.up":`위로`,
"label.addattachment.edit":`첨부 파일 편집`,
"label.ccchat.message.search.desc5":`검색어가 2개 문자 이하일 수 없습니다`,
"label.chose.nonotice":`알림 안내 필요없는 기록부터 선택하세요`,
"UG_activity_06":`고객 팔로우업하기`,
"label.set_contactsmarketing":``,
"pagecreator.layout.button.horizontal":`수평 분해`,
"label.brief.opportunity2":`기회 폐쇄 예상`,
"label.ems.nomsg":`미설정`,
"label.fieldupdate.tip":`필드 업데이트가 필드값을 자동으로 지정된 값으로 변경 허용합니다. 필드 업데이트는 업무 프로세스 규칙과 승인 과정과 관련된 조작입니다.`,
"label.sso.saml.sp.federationid":`연맹 ID`,
"label.import.page2.suited":`매핑됨`,
"message.error.appexchange.integrity":`업로드 소프트웨어 패킷 구성요소의 무결성을 확보하세요!`,
"label.fielddatatype":`필드 데이터 유형`,
"message.approval.cannotsubmit.detail2":`현재 기록은 아래 항목의 요건 중 하나를 만족시키거나 공식을 거쳐 참으로 평가되어야 하며, 아니면 대기 승인을 제출할 수 없습니다. 수정 후 다시 제출하시면 됩니다.`,
"vue_label_commonobjects_detail_cloud_as_a_user":`사용자로 파트너 클라우드에 로그인`,
"label.summaryreport.selectlinetogroup":`보고서 그룹분류의 근거 열을 선택하기`,
"label.tabpage.norecordtypez":`기록 유형 사용불가`,
"label.icon.141":`화폐`,
"label.addattachment.step3.intruduce":`업로드중이라면 진행 중인 업로드가 취소됩니다`,
"label.trigger.recursive.call.three":`트리거는 세 번으로 반복해서 호출할 수 있습니다. 세 번 이상 작동하면 시스템에 오류 알림이 뜹니다!`,
"maintenanceplan.workorder.type.asset.workorder":``,
"label.emailtocloudcc.select1":`선택하시오`,
"label.system.log":`시스템에서 감사 일지 배치`,
"vue_homepage_dashboard_not_support_fullscreen":`해당 브라우저에 풀 스크린이 적용되지 않습니다.`,
"label.projectManagement.nodata.resource":``,
"label.exchange.sync.state.contact":`연락담당자`,
"label.field.type":`필드 유형`,
"label.selected.object":`선택한 대상`,
"label.customfields.new.step2":`2단계. 상세 정보를 입력합니다`,
"label.monitorsys.delete.style":`조작 유형`,
"label.projectcondition":`프로젝트 조건`,
"potential.customers.field.default":``,
"message.password.nosame":`두번 입력한 비밀번호가 일치하지 않아 다시 입력하세요!`,
"label.validate.function.funcExplain.MONTH":`월별로 돌아가 1(1월)에서 12(12월)까지의 숫자입니다`,
"label.project.user.project.count":``,
"chatter.to":`변경`,
"vue_label_commonobjects_detail_activity_owntask":`업무 보유`,
"label.generate.mobile.page":``,
"label.escalation.setup.newentries.step1":`1단계: 이 규칙의 항목을 처리하는 순서를 설정합니다`,
"label.email_footer":``,
"label_partner_workspace_member_profile":`선택 가능한 프로필`,
"label.loginhis.between":`시작시간과 종료시간의 간격이 2개월을 초과할 수 없습니다`,
"label.user.verficationcode.error":`인증번호가 잘못되었습니다`,
"label.email_notifications":``,
"APPIntegration_Dropbox_01":`Dropbox에서 파일 선택하기`,
"label.projectManagement.Selectweek":``,
"wednesday":`수요일`,
"message.atleastonereceiver":`수신인 최소 한 명 있어야 합니다.`,
"label.applt.link.text":``,
"label.wait.for.a.moment":``,
"vue_label_chatter_only_group_members_look":`그룹 멤버만 방문 권한이 있으며 그룹 가입 신청을 시도하세요.`,
"label.knowledgebase.last.release":``,
"component.setup.label.pagesize":`1페이지 항목수`,
"label.paging.totalofpages":`총 {0}페이지`,
"label.globaloperation.successmessage":`성공 메시지`,
"label.logout":`로그아웃`,
"label.partner.common.enable":`파트너 클라우드 사용`,
"label.permission.objectpermission.goback":`권한 세트 대상 리스트로 반환하기`,
"label.approvalstep5.required":`필수 입력 항목`,
"component_chatter_label_to":`로`,
"message.please.choose.role":`역할을 선택하세요`,
"maintenanceasset.servicecontract.contractlineitem.illegal":``,
"label.projectManagement.Resource.usage.view":``,
"label.smsmainbody":`메시지 내용`,
"label.ccchat.error.nullname":`명칭을 입력하세요`,
"label.appupload.upload.version":`버전 번호`,
"label.data.setok.t_desc2":`데이터 템플릿 페이지로 돌아가기`,
"vue_label_pool_allocationstatus":`분배 상태`,
"label.tianyancha.orgapprovedinstitute":`비준 기관`,
"label.quickbooks.searchlist.startdate":`시작일`,
"label.setapp":`응용프로그램 설정`,
"chatter.about":`나에 관해`,
"label.layoutname":`페이지 레이아웃 명칭`,
"label.icon.160":`지구`,
"label.tabpage.Rolesz":`역할과 부하`,
"label.console.step5.introduce":`다음의 보기를 선택합니다`,
"label.customfields.totalsummary.gettogetherfield":`통합할 필드`,
"message.appexchange.addtopackage.profile":`한 소프트웨어 패킷에 한개 프로필 구성요소만 추가할 수 있습니다!`,
"vue_label_file_user_header_pic":`프로필`,
"font-trade-module-v1-invoice-detail-price":``,
"homepage.components.three":`3단계: 사용자 설정 구성요소 보기 내용을 입력합니다`,
"nine":`9`,
"label.marketsea.button.restore":`복구`,
"label.forecast.editshrepage.desc2":`일부 공유가 데이터에 대해 더 많은 방문 권한을 부여할 수 있고 방문 권한에 제한둘 수 없습니다`,
"label.cloudccsite.list":`사이트`,
"label.icon.35":`클라우드`,
"vue_label_pricebook_price":`표준 가격 추가`,
"label.version.sum.addressfield":`개 주소 필드`,
"label.projectManagement.Gotomilestone":``,
"label.dataimport.name.length":`에러 발생: name 길이가 한도를 초과했습니다.`,
"label_alculation_method":``,
"label.uploadfile":`파일 업로드`,
"label.ems.otheraccount":`다른 계정`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`해당 기회의 채팅에 가입하시겠습니까?`,
"message.error.chatter.img.nodata":`그림 파일이 존재하지 않습니다. 프로필 사진을 캡처할 수 없습니다!`,
"component.chatter.file.button.files":`파일 선택`,
"label.salescloud.teamrole.optionlist.choose.null":`역할 명칭을 입력하세요`,
"label.yourexportsuc":`내보내기 요청이 처리되었으며 메일을 확인하세요.`,
"pagecreator_systemstyle_label_modifycolor":`색깔 편집`,
"label_partner_setup_title":`설정`,
"label.chat.topic.topic":`주제`,
"file.error.nottype":`에러: 무효 형식이며 업로드 가능한 형식은 txt, doc, excel, ppt, pdf, jpg, jpeg입니다!`,
"label.all_time":``,
"homepage_componet_approval_label":`승인 센터`,
"label.partnerCloud.financeSetting.merchantNumber":``,
"label.user.resetpw":`비밀번호 초기화`,
"label.exchange.sync1":`Microsoft©Exchange 에서 사용자에 시뮬레이션 권한의 서비스 계정을 설정한 후 서비스 계정 증명을 입력함으로써  CloudCC 와 Exchange 서버의 통신을 허용합니다.`,
"label.import.index.editfield":`필드 매핑 편집`,
"and":`및`,
"label.partnerCloud.cloudInfrastructure":``,
"label.escalation.setup.newentries.createdate":`개별안 생성 시간으로`,
"Pagelayout.Setup.002":`이미 3개 관련 리스트를 선택하여 다시 선택하면 페이지 레이아웃에 영향을 줄 수 있다`,
"label.customfields.file.tip":`사용자가 1-N개의 파일을 업로드할 수 있도록 합니다`,
"label.tianyancha.businessverify.accname":`고객명 실시간 조회`,
"label.Additional.Conditions":``,
"label.emailtocloudcc.filed.type":`유형`,
"vue_label_homepage_fixedcomponents":`표준 구성 요소`,
"label.visualpage.delerror":`삭제에 실패했습니다. 나중에 다시 시도해 주십시오`,
"label.tabpage.filetypez":`파일 유형`,
"label.emailobject.search.input":`검색 내용을 입력하세요`,
"label.createprocessstep2":`2단계 항목 조건을 지정합니다`,
"label.weixin.inhead":`처리 중`,
"component.recdetail.label.title":`상세 정보`,
"label.weixin.telephone":`핸드폰 번호`,
"label.web.link":``,
"label.partnerCloud.paySuccess":``,
"label.case.adress.link":``,
"label.emailobject.view.connectopp":``,
"front-kefu-moudle-think-again":``,
"label.Button":``,
"chatter.pt.most":`최대 파일 크기는 20M입니다.`,
"label.service.newBuildDialog.numberdays.horizontal":``,
"label.ems.relatedobj":`관련 기록`,
"label.notification.insert.approval":``,
"label.setting.codeSet":``,
"vue_label_report_rowlevelformula":`행 수준 공식`,
"label.validate.function.funcFormat.TIMENOW":`현재 시간()`,
"label.copyright":`© 2008-2022 CloudCC Inc.회사가 저작권을 소유합니다. 모든 권리를 보류합니다. 고객 상담 전화: 400-642-2008`,
"component.setup.button.save":`저장`,
"label.emailsync.button.sure":`확인`,
"label.multilang.dupicatecheck.getdatalist":`{0}번째 그룹 중복 데이터, 총 {1}개 기록`,
"label.ccchat.person.invite.tochat":`회사동료그룹에 인원 초대`,
"label_partner_all_maxNum":`파트너 클라우드의 최대 데이터:`,
"label.checkfield":`필드 중복 검사 설정`,
"label.sales.dashboard.income":`수익 목표`,
"label.setup":`설정`,
"label.dashboardSetup.center":`중`,
"lable.quote.syncing.finished":`동기화가 완료되었습니다.`,
"vue_label_helpcenter_dashboard1":`    더욱 직관적으로 통계 데이터를 볼 수 있기 위해 CloudCC 마케팅 클라우드 Lightning 대시 보드는 강한 차트 제작 기능을 제공한다. <br>    CloudCC 마케팅 Lightning 버전 대시 보드는 다음과 같은 특징이 있다. <br>•다양한 데이터 소스를 사용한다. 한 대상자 뷰의 데이터를 데이터 소스로 선택할 수 있다.또한 보고서를 처리한 후의 데이터를 데이터 소스로 선택할 수 있다. <br>•13개의 차트 템플릿을 선택할 수 있다: 세일즈 퍼널, 바늘 계량기, 원형 차트, 2급 분류 막대 차트 등.  <br>•자유롭게 끌어 놓기로 차트 크기와 위치를 변경할 수 있다: 대시보드에서 다른 차트의 위치와 크기를 설정함으로써 중요 데이터와 보조 데이터를 구분할 수 있다. 편한 대로 설정하면 된다. <br>•대시 보드 전부 선별: 대시 보드가 시간 범위와 사용자를 통해 선별한다.선별 필드의 내부 차트 데이터 <br>•데이터 캐시: 대시 보드의 차트 데이터가 최초 생성할 때 데이터를 캐시할 수 있으며 2차 로이딩 시간을 절약한다. 。<br>•구성 요소 침투: 구성 요소를 클릭하여 대응한 보고서의 자세 정보나 대상자 대응 뷰의 기록 리스트로 넘어갈 수 있다. 。<br>•구성 요소 연동:같은 대시 보드 안에서 구성 요소가 자체와 같은 데이터 소스에서 온 다른 구성 요소와 연동시킬 수 있으며 구성 요소 내의 데이터 존을 클릭하여 설정한 다른 구성 요소가 이 데이터 존의 선별 조건대로 다시 데이터를 통계한다. <br>1. 대시 보드 새로 만들기 <br>    마케팅 대표나 영업부서의 관리자로서 대시 보드를 제작함으로써 마케팅 데이터를 전시할 수 있다.CloudCC 마케팅 클라우드 Lightning 버전이  많은 기능을 제공해 대시 보드를 제작할 수 있다. <br>    주의: Lightning 버전의 대시보드가 예전 버전의 대시보드와 호환되지 않는다. <br>     '대시 보드' 옵션 카트를 클릭하여 '대시 보드 새로 만들기'를 클릭하며 대시 보드 명칭을 입력해 저장할 폴더를 선택한다. 즉시 새 대시 보드로 들어갈 수 있다.  <br>    `,
"label.layout.availabletab.trackrecord":`기록 팔로우업`,
"label.campaignmember.main.deletecontact":`멤버 삭제- 기존 연락담당자`,
"lable.outlook.mcto.emaltoc":`CloudCC.com으로 메일이 전송되었을 때`,
"label.setup.mobile.offlinecache.savesuccess":`모바일기기 오프라인 캐시 설정 저장 성공`,
"label.timezone.default":`기본 표준 시각대`,
"label.noRules.have.been.enabled":``,
"label.ccchat.person.invite.existsend":`입력한 일부 메일 주소가 기존 사용자와 일치합니다.`,
"label.work":`업무`,
"actualstarttime.actualendtime.time.illegal":``,
"lable.product.stsp":`표준 가격 설정`,
"vue_label_normal_account_sf":`고객`,
"label.finishpic":`생성된 차트`,
"label.h5.similar.opportunity.step3":`3단계. 유사 업무 기회로 보는 필드를 선택합니다`,
"label.relateobjDefault":`디폴트 관련 기록`,
"label.customcomponent.check.tag.endwith":`구성요소가 &lt;/cc:component&gt;라벨로 끝으로 해야 합니다`,
"label.related.organization":``,
"label.recordtype.edit.selectvalue.orderby":`선택항목 리스트값 정렬`,
"vue_label_homepage_enter_name":`명칭을 입력하세요`,
"label.permission.group":`권한 그룹`,
"label.emailobject.send":`전송`,
"label.ralateuser":`관련 사용자`,
"label.validate.function.funcFormat.ADDMONTHS":`월 추가(일자, 번호)`,
"label.tablayoutedit.remark2":`포그라운드 메뉴 페이지에 나타나는 필드를 선택합니다`,
"setup_mainpage_label_welcome3":`CloudCC 클라우드 플랫폼에서 보고서를 제작하는 것은 사용자 설정 데이터 베이스(대상)로 실현하여 사용자 설정 대상은 데이터 차트이며 귀사 특유의 데이터를 저장합니다. 프로그램 개발 필요없이 차트 간의 관계를 구축할 수 있습니다.`,
"label.user.notallowed.login.scope":`로그인 허용 시간 내에 있지 않거나 로그인 IP가 제한되어 있습니다.`,
"label.tel.ten.case":`알림을 보낼 휴대전화 번호를 최대 10개까지 입력할 수 있습니다. 각 휴대전화 번호 사이에`,
"front-kefu-moudle-v1-user-info":``,
"label.aboutme":`나에 대해`,
"label.setfieldediting.tip":`승인 절차를 정의할 때, 다른 사용자에게 승인 요청을 분배할 수 있습니다.이 중의 한 선택항목은 사용자 필드를 사용하여 요청 사항을 자동으로 전송하는 것입입니다.이 선택항목을 승인 절차에 사용하려면 아래 선택항목 리스트에서 한 필드를 선택하십시오.또한, 기록이 승인 과정에 있을 때 항상 잠겨 있습니다-- 관리자만 편집할 수 있습니다.하지만, 현재 분배된 승인자를 선택해서 이 기록을 편집할 수도 있습니다.`,
"label.existing_dashboard":``,
"label.sendemail.spotsign":`존경하는 #name: 초대한 #activity행사 손님#customer 현장에서 출석하셨습니다.`,
"UG_solution_01":`솔루션 제공`,
"label.tianyancha.estiblishtime":`성립 시간`,
"label.pc.lightningpage":`경량급 앱(Beta)`,
"label.saveAndSync":`저장 및 동기화`,
"label.state.end":`종료됨`,
"label.sendemail.queue.assigninfo":`대열:[#queueName]가 #objectName ：#recordName 을 분배했습니다`,
"label.approvalprocessname":`승인 과정 명칭`,
"label.view.conditions.message":`{!conditions}으로 선별하기`,
"label.partnerCloud.financeSetting.alipayCorporate":``,
"label.forecast.detailforecast.de":`의`,
"label.savepayset.failure.nopay":``,
"label.step1.total6":`1단계, 총 6단계`,
"label.appointment.wizard.subtitle4-1-3":`45분`,
"label.emailobject.markasread":``,
"message.error.orgid.null":``,
"label.emailtemplate.mergefield":`필드값 병합`,
"label.weixin.recent.list":`최근 보는 리스트`,
"label.emailsync.form.email":`이메일`,
"label.funnel":`퍼널`,
"label.logintime.clear":`시간 지우기`,
"label.chatter.followed":`팔로잉`,
"label.ccpeak.function.field.spack":`함수의 필드 양쪽에 빈칸이 있어야 합니다`,
"label.setup.mobile.offlinecache.remark":`해당 기능을 사용한 후 조직내의 멤버가 모바일기기에서 인터넷이 없는 상태에 기록을 새로만들기, 보기, 편집, 삭제할 수 있습니다`,
"label.product.function":``,
"label.icon.14":`망치`,
"message.report.nodata":`보고서의 미반환 데이터`,
"label.please.ChooseMin":``,
"label.tabpage.releaseTourz":`안내 메뉴 발표`,
"vue_label_chat_opportunity":`기회 채팅`,
"vue_label_chatter_refucecertification":`{name}의 그룹 가입을 거절하시겠습니까?`,
"label.version.unlimited":`제한두지 않음`,
"label.processsetting.enable.prompt":``,
"label.page.display.property":`속성 보기`,
"label.service.appointmentList.thisOption":``,
"label.register.date":`등록 일자`,
"label.brief.contract.amount":`계약서 금액`,
"setup.object.field.dependency.label.actionfieldnotnull":`하나의 컨트롤 필드 값을 선택해 설정하세요`,
"UG_homepage_009":`CRM 방문`,
"label.icon.98":`폴더`,
"label.weixin.datacount":`데이터 병합`,
"label.mobile.hasbind":``,
"label.emailtemplate.choosemorecontacts":`더 많은 보낼 사람을 선택하십시오`,
"setup_layout_button_deleteitem":`선정된 항목을 제거`,
"vue_label_account_collection_plan":`미처리 대금 수령 계획`,
"label_chatter_maturiyDate":`만료일`,
"label.emailtocloudcc.license":`사용자 허가`,
"vue_label_checkduplicate_complete_check_rules":`완전한 중복 검사 규칙을 기입하세요`,
"chatter.up.type":`JPG、GIF나 PNG 파일을 업로드할 수 있습니다.`,
"label.attendance.nocheckout":`미퇴장`,
"label.setup.mobile.offlinecache.remark2":`선택한 메뉴는 모든 조직원의 모바일 기기에서 기본 오프라인 캐시 메뉴로 사용됩니다. 각 사용자는 다른 시나리오 필요에 따라 모바일 기기에 조직 설정의 메뉴 오프라인 캐시를 설정하거나, 다른 필요한 메뉴를 활성화할 수 있습니다.`,
"template.report.count.marketing.activities":``,
"label.multilingual.tip4":``,
"label.settings_area":``,
"label_assessment_content":``,
"label.top":`상단`,
"UG.Account.06":`고객 생성하기`,
"label.emailtocloudcc.step1.case2":`설정한 후, 해당 이메일에서 받은 메일이 자동으로 개인안으로 생성된다. 발송 메일로 담당자와 고객을 매칭하여 개인안을 관련 고객 및 담당자와 연결하여 케이스 서비스의 처리와 팔로우업에 도움이 된다.`,
"label.forecast.forehistory.best.remark":`뛰어난 능력 발휘 비고`,
"label.project.problem.date":``,
"label.forecast.customforecast.foredis.wzs":`완전수`,
"message.setup.field.name.value.notexists":`입력한 그룹 역할 리스트값이 존재하지 않아 다시 입력하세요!`,
"label.salescloud.teamrole.opportunity.organization":`그룹멤버가 이 업무기회에 대한 방문 등급이 조직 기본의 업무기회 방문 설정보다 높을 수 있습니다`,
"label.sms.message.input":`문자 내용을 입력하세요`,
"label.document.type.not.allow":`이 파일 형식은 지원되지 않습니다!`,
"label.customfields.totalsummary.tip":`관련 리스트에 필드의 총합값, 최소값, 최대값의 읽기 전용 필드를 표시하거나 관련 리스트에 모든 기록수를 표시합니다.`,
"label.tabpage.filesizez":`파일 크기`,
"label.import.page2.filedname":`파일 명`,
"label.same.analyze":`나의 계약서 충돌 분석`,
"label.service.gantt.refreshData":``,
"label.sendsms.batch.step2.sendbycontext":`사용자 설정 문자 메시지 내용대로 보냅니다`,
"UG_Account_05":`연락담당자 구조도`,
"label_emailtocloudcc_step1total3":`1번째 단계, 총 3단계`,
"label.weixin.no.history":`기록 이력이 없음`,
"label.datamanage.queryfield.error":`조회 필드에 오류가 발생했습니다`,
"label.emailmerge.mergeFolder.emailmerge":`메일 템플릿 병합`,
"label.workflow.estimatecondition":`평가 조건`,
"label.autonumberfield.wrong":`0-{0} 중의 숫자를 입력하세요`,
"label.data.setok.t.desc1":`이 템플릿으로 데이터를 내보내려면 클릭하세요`,
"label.data.downpage.i.title":`데이터 불러오는 단계:`,
"label.data.downpage.i_list.desc2":`데이터를 불러온 후 불러오기 성공 여부 알림 메일을 받을 겁니다.`,
"label.opportunity.jieduan":`현재 단계`,
"vue_label_commonobjects_view_sumby":`합계 방식`,
"label.knowledge.setting.hint.three":``,
"page.activity.history":`행사 이력`,
"label.cancelQuoteLineGroup":``,
"label.addattachment.batch.step3":`3단계. '완성' 버튼을 클릭하여 이전 페이지로 돌려줍니다.`,
"label.chat.topic.follow":`팔로우`,
"label.import.page1.uploadcsvfiled":`CSV파일을 끌어오거나 클릭하여 올리기`,
"label.batchtransfer.datetype.tip":`일자 필드에 대해 다음 형식으로 값을 입력합니다:`,
"vue_label_systemSettings_application_util":``,
"label.partner.workspace.member.selectedpermission":`선택한 권한 세트`,
"label.service.appointmentList.plansToEnd":``,
"label.industrialandcommercialverification.contactinformation":`구매나 상담에 관해 400-642-2008로 연락주세요.`,
"chatter.del.p":`이 게시물을 삭제합니다`,
"label.forecast.customforecast.replacefirst":`나의 선순위`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`채점 규칙 명칭`,
"label.weixin.appr.applicant":`발기인`,
"component_event_label_calendar":`캘린더 보기`,
"step":`단계`,
"label.attendance.setting.position.alert":`내근 인원이 포지션을 설정해야 합니다`,
"label.end":`완료`,
"label.mobile.change.owner.success":`신 소유인으로 변경됐습니다`,
"label.chinese":`중문`,
"label.textmessage.vonage.account":`계정 정보`,
"front-console-no-related-contact":``,
"label.dashboardSetup.seltype":`선택 가능한 구성요소 유형`,
"chatter.follow.user":`이 사용자를 팔로잉합니다`,
"label.textmessage.sentsuccess":`전송 성공`,
"label.australian.gentral.standard.time":`센트럴 서머타임(남호주)`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`계약 체결`,
"label.processsetting.basic.settings":``,
"label.escalation.setup.newentries.ifcondtions":`다음의 조건에 부합하면 이 규칙을 사용합니다`,
"label.lookup.nofound.data":`값이 없거나 선별 조건과 매칭되지 않습니다.`,
"vue_label_commonobjects_view_chart_chartname":`차트 명칭`,
"label.dashboard.show.percent":`%로 보기`,
"label.sso.saml.sp.userid":`사용자 ID`,
"label_tabpage_minutesagoz":`분 전`,
"vue_label_chatter_comment_content":`댓글 내용을 입력하세요`,
"label.campaign.channel.step6.mobilepc":`모바일기기와 컴퓨터 페이지 생성`,
"vue_label_homepage_editprofilepage":`명칭 편집`,
"label.tabpage.crecordtypez":`기록 유형 변경`,
"label.social.posts.type.null":``,
"label.projectManagement.groupbyuser":``,
"vue_label_email_new_template":`새 템플릿으로 저장하기`,
"label.ems.close":`취소`,
"label.ccdocument.noauthority.folder":`해당 폴더에 조작 권한이 없습니다!`,
"message.filterconditionerror":`<strong>에러：</strong>필터가 잘못된 선별 조건을 인용했습니다:`,
"label.User.Interface":``,
"label_tabpage_greaterz":`보다 크다`,
"vue_label_CCChat_unfollow":`팔로우 취소`,
"label.selectandcontinue":`선택 및 계속`,
"vue_label_commonobjects_detail_influence":`영향력`,
"label.total.have.priority":`의 우선`,
"label.manageAll.sta4":`소환`,
"label.setup.mobile.offlinecache.setup":`모바일기기 오프라인 캐시 설정`,
"vue_label_chatter_cancel_adding":`추가 취소`,
"vue_label_lead_select_existing":`기존 선택`,
"front-epwechat-module-v1-contacts-sync":``,
"label.appupload.component.type.recordtype":`기록 유형`,
"label.layout.hint":``,
"label.change":`변경`,
"setup_layout_label_detailpage":`상세 페이지`,
"label.imgfield.use.tip":`img(docid,width,height),이 함수는 그림을 출력하는 데 사용됩니다. docid는 문서 id, widthd은 이미지의 너비 설정( Integer 형식, 비워도 됨), height은 이미지 높이 설정( Integer 형식, 비워도 됨)입니다.`,
"pagecreator.systemstyle.button.edit":`양식 편집`,
"label.delete_externalpage":``,
"font-evaluate-module-v1-open-case":``,
"label_not_adjust":`조정 없음`,
"vue_label_title_ordernow":`바로 구매`,
"label.notification.serviceappointment.allocation":``,
"label.objectRelationshipDescription2":`의 보고서. 이에 관한 대상을 선택함으로써 다른 대상의 어떤 관련 기록이 보고서 결과에 돌아갈지를 정의할 수 있습니다.`,
"vue_label_calendar_notice_createfail":`캘린더 생성 실패`,
"label.ems.step1":`1단계`,
"label.ems.password":`비밀번호`,
"label.icon.143":`저금통`,
"label.select.year":``,
"label.termsforusage.dialog":`사용 조항(새 윈도우)`,
"label.tag.addtags.create":`새로 만들기`,
"label.emailobject.groupemail.msg4":`메일 주소가 없어 수신인에게 전송할 수 없습니다`,
"label.version.sum.autonumberfield":`개 자동 번호 필드`,
"label.projectManagement.unallocated.time":``,
"PageLayout.Search.MultiSearch.002":`검색 필드 확대 보기(단일 필드 검색)`,
"label.icon.150":`가상현실`,
"label.SMS.edit":`문자 메시지 통지 편집`,
"Opportunity.Detailed.Phase.Label.003":`단계 변경`,
"vue_label_helpcenter_all":`1.전체 검색<br>  전체 검색은 빠르게 내용을 검색할 수 있는 툴이다. <br> 페이지 윗부분 메뉴의 검색창에서 키워드를 입력한다. 입력하는 과정에 시스템이 입력하는 내용대로 관련 내용을 추천해 준다. <br> '검색'을 클릭하거나 엔터키를 클릭하여 검색 결과 페이지를 연다. <br>검색 결과 페이지에서 좌측의 대상자를 선별하여 해당 대상자의 검색 결과 리스트를 확인할 수 있다. 결과 리스트에서 최대 10개 기록을 추천해 준다. '더 많이 보기'를 클릭하여 해당 대상자의 리스트 페이지로 이동해 더 많은 검색 결과를 볼 수 있다. <br>주의: 시스템에서 기본으로 '견적서''고객''잠재 고객''업무 기회''마케팅 행사''계약서''제품''서비스 요청서''업무''이벤트'등 10개 대상자를 검색한다. <br>2. 빠른 새로 만들기  <br> 메뉴의 ' '를 클릭하여 드롭다운 리스트에서 새로 만들고 싶은 대상자를 선택한다. <br>3. 개인 센터 <br> 메뉴 우측의 프로필을 클릭하여 개인 센터 창구를 열어 다음과 같은 기능을 제공해 준다.<br> 개인 설정 페이지 빠른 이동, 모두 불러오기 및 휴지통. <br> 시용 기간이면 '바로 구매'를 클릭하면 cloudcc의 구매 페이지로 이동한다. <br> 한 버전을 클릭하면 빠르게 전환할 수 있다 <br> 로그아웃 <br>4. 메뉴 <br> 메뉴에서 일부 메뉴 대상자를 추천해 주어 하나의 메뉴를 클릭하여 빠르게 페이지로 이동할 수 있다. 모든 메뉴와 설정할 자주 사용 메뉴를 확인할 수 있다. <br>전부 메뉴: '더 많이' 를 클릭하여 드롭다운 리스트 밑에서 '전부 메뉴'를 클릭한다. <br> 나의 메뉴를 설정하기: 메뉴 우측의 버튼을 눌러 사용자 설정한 메뉴 창구를 열어 전부 메뉴에서 전시할 자주 사용 메뉴를 설정한다. <br>5. 응용 사용 센터 <br> 메뉴 우측의 아이콘을 클릭하여 빠르게 시스템 관리자가 배치해 준 기타 응용 프로그램 서비스로 전환할 수 있다. <br>주의: 응용 프로그램은 기능 모듈(예. 잠재 고객 관리, 업무 기회, 계약서 관리 등)의 집합이며 특정한 업무 수요를 만족시킨다.`,
"label.summaryreport.2018.step5.new":`5단계: 보고서 기준을 선택합니다`,
"label.weixin.id":`번호`,
"chatter.pu.mess":`개 게시물과 댓글`,
"label.weixin.lookup.record":`기록 찾기`,
"label.ServiceCloud.statistics.by.address":``,
"label.jixiaoswitchoff":``,
"label.savealipay.failure":``,
"template.chart.khdqfb":``,
"front-email-payment-immediate-payment":``,
"label.dashboard.unit5":`단위: 억`,
"label.tabpage.greaterz":`보다 크다`,
"vue_label_calendar_stop_sharing_calendar":`캘린더 공유 정지`,
"label.projectManagement.allhours":``,
"label.currency":`화폐 종류`,
"label_vue_create_edit_obj_create_event_dialog_title":``,
"front-template-V1-templateSetting":``,
"label.dashboard.away.condition":``,
"label.replacelayout":`페이지 레이아웃 교체`,
"label.permission.detail.system.setting.tip":`응용프로그램에 적용하는 작업을 수행합니다.예 "모든 데이터를 수정할 수 있는 권한"`,
"label.customfield.delete.prompt":`사용자 설정 필드 라벨`,
"label.add":`추가`,
"label.deputationalsoapprove":`파견 대리인도 이 요청을 승인할 수 있습니다.`,
"label.leave_nosave":``,
"label.tianyancha.title":`TIAN YAN CHA`,
"vue_label_pool_restore":`복구`,
"chatter.feed.menutype.feed.markcom":`저장한 게시물`,
"label.query.data.error":`관련 리스트 데이터를 조회할 수 없습니다`,
"label.pc.ui.2018.unpin":`상단 고정 취소`,
"label.partner.template.memo":`약술`,
"label.weixin.cannot.gain.userinformation":`사용자의 정보를 가져올 수 없습니다`,
"label.stdashbord.xsld.department":`부서`,
"label.service.ganttBaiduMap.scheduled.starttime":``,
"label.documentforms":`파일`,
"label.operator.insert":`연산자 삽입`,
"label.processsetting.select.five.fields":``,
"label.weixin.password":`비밀번호`,
"vue_label_chatter_share_followers":`팔로잉 인원과 공유하기`,
"label.brief.baifang":`출석 방문`,
"label.emailobject.track.unopen":`열리지 않았습니다`,
"label.sendmail.immediately":`바로 전송`,
"label.partnerCloud.payTheAmount":``,
"label.integrations.mailchimp.connect":`CloudCC를 계정과 연결합니다`,
"label.datamove.record.sucessfully":`개 기록 이동 성공!`,
"lable.outlook.edit.allocation":`사용자와 프로필 분배`,
"label.chosesubject.talk":`약속 잡기`,
"label.escalation.setup.entrydetail.escalation.time":`업그레이드 시간`,
"label.projectManagement.must.be.less.than.24.hours":``,
"setup_mainpage_label_welcome15":`CloudCC 플랫폼 업무 프로세스 규칙이 세일즈, 마케팅 등 각종 대상의 지원 과정을 자동화시킵니다. 미리 정의한 규칙에 따라 사용자에게 분배하거나 한 사용자에서 다른 사용자로 전환할 수 있습니다. 업무 프로세스의 주요 장점은 기록을 업데이트 시 불필요한 조작을 없애 업무 효율을 제고시켜 표준화 업무 방식과 조작 비용을 절감함으로써 업무 처리 수준을 제고하여 제어 프로세스를 최적화시킨 것입니다. 모든 대상의 무한 승인이 지원되며 메일, 문자 알림, 업무, 필드 업데이트 등 기능이 제공됩니다.`,
"label.mobile.phone.week.plan2":`이번주 계획`,
"label.add.newAsset":``,
"vue_label_salesadvance_losts":``,
"vue_label_report_editcolumn":`열 편집`,
"vue_label_homepage_assignedtasks":`업무 분배됨`,
"label.posting_from":``,
"year":`년`,
"label.autoRegister.changepwd.setpwd.tip.letter":`최소 한개 알파벳이 있습니다`,
"label.version.nonsupport.feature.staticresource":`이 기능은 지원하지 않습니다!기능 업그레이드 후 사용하세요!`,
"label.toleadmyclientandlinkman":`나의 고객과 연락담당자 불러오기`,
"label.appupload.install.processcrash":`충돌 처리`,
"label.profile.setstandardtab":`표준 메뉴 설정`,
"template.chart.khhyfx":``,
"label.reportTypcrtC":`관련 대상（C）관련 대상을 선택하여 클릭하세요`,
"vue_label_report_mayormaynothave":`상위 대상에 관련 해당 대상의 기록이 있거나 없음`,
"label.service.gantt.plan.recommendation":``,
"label.version.sum.lookupfield":`개 조회 필드`,
"label.builder":`페이지 빌더`,
"label.sharerule.remark":`이 기록의 공유를 지정합니다. 사용자, 역할, 역할 및 부하, 구역, 구역 및 부하 구역에 대응한 사용자와 이 기록 및 관련 데이터를 공유할 수 있습니다. 일부 공유가 데이터에 더 많은 방문 권한만 부여할 수 있어 방문 권한에 제한둘 수 없습니다.`,
"vue_label_email_benn_added":`메일 주소가 추가됨`,
"label.version.allow.sum":`상한에 도달했습니다! 필요하면 CloudCC 버전을 업그레이드하세요!`,
"label.icon.130":`화폐`,
"label.custom.new":`새로 만들기`,
"label.see_allfields":``,
"front-marketing-module-v1-share-poster":``,
"label.service.one":`필터가 미정의 선별 조건을 인용했습니다:`,
"lable.outlook.edit.alprec":`1순위 선택 CloudCC.com`,
"Account_News_Setting_001":`고객설정`,
"label.mr.caption.opportunity.result":`중복 병합: 업무 기회 중복 데이터를 조회한 결과입니다.`,
"label.forbidden":`금지 사용`,
"label.query.detail.openpartner":`협력 파트너로 사용`,
"label.session_date":``,
"label.forecast.customforecast.submit.deyuce":`의 예측`,
"label.emailtocloudcc.filed.server":`서버`,
"label.emailtocloudcc.tip2":`삭제 후, 본 메일을 통해 Email to CloudCC 기능을 작동하지 못해 삭제하시겠습니까?`,
"pagecreator_layout_message_delete_fail":`레이아웃 삭제 실패`,
"front-lightning-module-v1-dashborad-export-PDF":``,
"lable.quote.syncing.syncingto":`견적서 내역이 업무기회 제품에 동기화되었습니다.`,
"message.error.view.lastview.update":`마지막 공공 리스트 뷰를 삭제할 수 없습니다</br>모든 사용자가 볼 수 있는 마지막 리스트 뷰를 혼자만 볼 수 있는 뷰로 변경할 수 없습니다`,
"label.weixin.select.one":`최소 한 개를 선택합니다`,
"label.projectManagement.Pleaseenterprojectname":``,
"label.data.downpage.e_list.desc1":`이 페이지에 나타나는 데이터가 내보내기 성공한 파일이며 메일 정보에 따라 내보내는 파일을 다운로드하세요.`,
"label_tabpage_notexceed25":`선택한 기록이 25개 초과할 수 없습니다`,
"label.campaign.channel.step5.remark":`등록 페이지의 설정을 완성했습니다`,
"label.setup.mobile.bottombutton.profile.prompt":``,
"label.stdashbord.xsld.business.knx":`가능성`,
"label.setemailtip":`메일 통지를 생성함으로써 한개나 여러개 업무 프로세스 규칙과 승인 과정을 관련시킵니다. 메일 통지가 변경되면 모든 수정과 관련된 모든 규칙, 승인에 적용됩니다.`,
"report.button.go":`이동`,
"lable.the.united.arab.emirates":``,
"label.writer. name.file":``,
"label.validate.function.funcExplain.ADDMONTHS":`입력한 date（일자 필드）에서 num(달수)를 추가하여 새 일자로 돌아갑니다. 원래 월 일수가 해당 달의 마지막 일이거나 새 일자의 월 일수가 원래 입력한 일자 월 일수보다 적을 때 월 일수가 해당 월의 마지막 날의 새 일자로 돌아갑니다.`,
"vue_label_chatter_enter_shared_content":`공유 내용을 입력하세요.`,
"message.lookup.condition":`조건 검색에 1개 이상의 문자를 입력해야 합니다`,
"vue_label_commonobjects_detail_customers":`외부 사용자 영구 금지 사용의 고객은 모든 고객과 관련된 모든 외부 사용자를 영구 금지할 것이며 이들이 관련된 모든 커뮤니티, 그룹, 소그룹, 권한 집합 및 공유 규칙에서 삭제됩니다. 해당 계정과 관련된 역할과 그룹이 삭제되어 휴지통에도 나타나지 않습니다. 확인하시겠습니까?`,
"label.emailobject.view.all":`전부`,
"vue_label_file_size_limit_new":``,
"front-gantt-module-please-reorder-milestones":``,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`메일`,
"label.namespaceprefix":`명칭 공간 앞자리`,
"label.ems.delete.success":`삭제 성공`,
"label.partnerCloud.financeSetting.setWechatPay":``,
"front-epwechat-module-v1-input-token":``,
"setup_object_field_dependency_button_setdependency":`필드 종속 설정`,
"chatter.group.request01":`개 요청`,
"message.error.field.number.length":`길이 입력 형식이 잘못되었습니다`,
"label.tabpage.lessz":`보다 적다`,
"vue_label_notice_uploadavatar_format":`프로필 이미지는 JPG/PNG/GIF 격식만 가능합니다.`,
"label.project.hit.thirteen":``,
"frame_personinfo_label_usethisimage":`응용 프로그램 주변에서 해당 섬네일의 변형 이미지를 사용합니다.`,
"label.startuploadfile.step":`안 그러면 업로드 실패한 파일이 위에 구역에  나타나 안내 정보가 뜹니다. 모두 삭제해야 다시 파일을 선택할 수 있습니다`,
"component_assistant_label_overduetask":`업무 기회에는 기한을 넘긴 업무를 포함합니다`,
"label.partnerCloud.financeSetting.information":``,
"label.appupload.install.package.component":`소프트웨어 패킷 구성요소`,
"label.emailobject.emaildetail.nextactivity.task":``,
"vue_label_chatter_edit_post":``,
"label.appupload.upload.logo":`아이콘`,
"label.role.selecteduser":`선정된 사용자`,
"label.letter.assign":`초대장 내용을 지정합니다`,
"label.forecast.shrepage.title":`공유 상세 정보 예측하기`,
"lable.Generate.service.appointment":``,
"label.productsales.nodata":`데이터 없음`,
"vue_label_email_Please_select_at_least_one_email":`최소 1개 메일을 선택하세요`,
"label.data.downpage.i_title.num4":`4. 가져오려는 대상에 검색 필드와 마스터 디테일 필드가 있다면 이 필드의 대응값이 ID여야 하며, 그렇지 않으면 유효하지 않습니다.`,
"label.new.exchagecurrency":`신규 환율`,
"label.layout.listtip":`다음은 다른 프로필의 페이지 레이아웃 분배를 볼 수 있습니다`,
"label.icon.2":`지갑`,
"label.chat.topic.delete.prompt3":`이 주제를 삭제하시겠습니까?`,
"UG_Lead_008":`명함 스캔`,
"label.multilang.databatchadd.fail":`{0}개 데이터 추가 실패`,
"front-kefu-moudle-v1-chzx-confirm":``,
"label.import.page1.matchlabel":``,
"label.dashboardSetup.showdw.d3":`백만`,
"label.version.ifnecessary":`필요하시면 CloudCC 버전을 업그레이드하세요!`,
"label.confirm.delete.default.tab":`기본 로그인 메뉴를 삭제하시겠습니까?`,
"label.emailtemplate.mergefields.tip":`메일 내용을 디자인할 때 내용에 텍스트 대신 병합 필드를 추가할 수 있습니다. 메일이 사용될 때 시스템에서 텍스트로 전환됩니다. 예{!Contact.name}, 메일을 사용할 때 원문에 연락담당자의 이름으로 전환됩니다.`,
"vue_label_chatter_decline_members_join":`멤버의 그룹 가입을 거절합니다.`,
"label.role.no":`역할 없음`,
"label.service.gantt.resources":``,
"label.knowledge.language.simplified":``,
"label.eidt.queue.length.cannot.than":`명칭 길이가 50을 초과할 수 없습니다`,
"label.mobile.quickcreate.default.tasks":`업무`,
"label.discount.yuan":``,
"message.error.delete.pending":`기록이 승인중이니 삭제할 수 없습니다<br><a href='javascript:history.back();'>클릭하기</a> 이전 페이지로 돌아가기`,
"chatter.show.mostnews":`메시지 더 많이 보기`,
"label.optionlist":`선택항목 리스트`,
"template.chart.cpdj":``,
"label.user.usernamepassword.error":`사용자명이나 비밀번호가 잘못되었습니다`,
"label.file.sharetype.check":`확인자`,
"label.completed.generated.page":``,
"label.martrixcross":`행렬 교차`,
"label_tabpage_entercusnamez":`고객명을 입력하세요`,
"lable.account.NextwDays":`향후 30일`,
"label.list.userinterface.dashboard.hint":`새 대시보드 그래프는 휴대전화, 태블릿 등 단말기에 표시할 수 있도록 지원하며 빠르게 구현할 수 있습니다.`,
"message.fieldtrack.operatecreate":`생성됨`,
"label.service.gantt.available.plan":``,
"label.activity.setting":`행사 설정`,
"label.tag.manage.record":`기록 수`,
"label.customcomponent.page.edit.title":`사용자 설정 구성 요소 편집`,
"label.import.index.creationrecord":`기록 새로 만들기`,
"label.tabpage.printz":`인쇄`,
"label.appointment.wizard.subtitle4-1-5":`1.5시간`,
"label.partnerCloud.orderingPlatform.discountUnit":``,
"label.weixin.micro.message.profile.associated":`위챗 공식 계정과 회사 프로필 관계`,
"label.cpq.opportunity.pricebook.change":``,
"vue_label_opportunity_business_opportunity":`완료되고 고객을 획득한 업무 기회에서 현재 업무 기회의 한개나 여러개의 같은 필드 기록이 포함됩니다.`,
"message.standardreport":`표준 보고서`,
"vue_label_account_outstanding_business":`다른 사용자의 미처리 업무기회 이동`,
"vue_label_commonobjects_detail_field":`선별 필드 선택`,
"pagecreator_page_button_delete":`삭제`,
"label.leadconvers.permisson":`{!objectname}의 {!operator}권한이 없으며 시스템 관리자에게 연락하세요!`,
"vue_label_systemSettings_customcode":``,
"button.partner.cancel":`취소`,
"label.whChatBindingState":`위챗 계정 연동 상태`,
"label.appointmentconfirmail.wizard.subtitle6":`전화번호`,
"label.recycle.dis.tip2":`사용자는 휴지통 비우기나 귀조직의 휴지통 비우기 버튼을 클릭하여 휴지통을 비울 수 있습니다. 휴지통을 비우는 데 시간이 걸립니다. 시스템에서는 작업이 끝난 후 이메일을 보냅니다.`,
"batch.transfer.succ":`모두 이동 성공한 데이터 항목수:`,
"label.chat.add.bookmark":`저장`,
"label.mr.object.contact":`연락담당자`,
"component_setup_label_parentobject":`상급 대상`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`화요일`,
"vue_label_report_list":`리스트 제목에서 나타나는 필드를 선택하세요`,
"label.checkbox.false":`아님`,
"label.chatter.followers":`팔로어`,
"label.mr.loadReDate":`선정한 정보 로딩`,
"label.versiontype.Essential":`기초 버전`,
"front-project-module-v1-input-actual_working_hours":``,
"label.visualpage.staticresource.p2":`2. 주의. 지원된 정지 리소스 파일 형식이 png、jpg、gif、js、css가 있습니다`,
"label.query.clone.detail.choose":`복사할 명세 기록을 선택하세요`,
"component.assistant.label.30daysnoact":`30일 이내의 행사 없음`,
"label.tianyancha.businessverify.relation":`매핑됨`,
"vue_label_email_havent_received_the_email_yet":`받은 메일이 없습니다.`,
"label.isEnableVisualpage_new.title":`사용자 설정 페이지 방문 사용`,
"lable.SalesCommitmentKanBan.allContractAmount":`총 계약액`,
"label.searchall":`모두 검색`,
"label.h5.similar.opportunity.select.all":`모두 선택`,
"label.area.tree.intro":`여기서 직관적으로 구역 간의 관계를 볼 수 있습니다`,
"label.select.up.three.fields":``,
"label.leadscore.doing":`채점 중이며 중복 채점하지 마세요`,
"message.choosereportobj":`보고서 대상을 선택하세요`,
"button_partner_start":`사용 시작`,
"label.quote.print":`견적서 인쇄`,
"label.workflowoperateselect":`3단계: 업무 프로세스 조작을 지정합니다`,
"label.greate":`> 크다`,
"lable.setting.qrcodeOrbarcode.rule":``,
"label.partnerCloud.orderingPlatform.discounts":``,
"label.ems.save2draft":`휴지통 저장`,
"vue_label_homepage_editname":`홈페이지 명칭 편집`,
"label.ccdocument.save.error":`저장 실패했으며 에러 코드는`,
"label.samoa.standard.time":`사모아 제도 표준 시간`,
"label.tianyancha.businessverify.msg7":`3:데이터 서비스 범위:`,
"vue_label_commonobjects_view_up_to_data":`해당 동작은 최대 200개 데이터에만 가능합니다.`,
"label.manage":``,
"label.tooltip":`보고서 데이터 소스가 사용되어 대상 관계를 편집할 수 없습니다!`,
"vue_label_calendar_edit_calendar":`캘린더 편집`,
"label.attendance.keywords":`키워드를 입력하세요`,
"label.otherinfo":`다른 정보`,
"System_TAB_SeeViewAmount":`총수 보기`,
"label.recordtype.remark":`내용`,
"label.object.cannot.delete":`다른 대상과 다음의 관계로 관련돼 있어 이 대상을 삭제할 수 없습니다`,
"label.setup.mobile.bottombutton.saveprompt":`홈페이지 4개를 선택하세요`,
"label.department.lastpage":`마지막 페이지입니다`,
"label.emailtemplate.mergefield.use":`병합 필드를 복사해 메일 정문에 붙혀놓기`,
"vue_label_salesfunnel_notice8":`현재 단계에서 다음 단계로의 전환율`,
"lable.opppdt.addpdt.table.product":`제품`,
"vue_label_helpcenter_report2.2":`2단계: 원하는 그룹 분류 방식을 선택한다: 일, 월, 년, 회계 분기, 회계 년, 설정된 분기, 설정한 년. <br>•보고서에서 열 통합<br>    1단계: 보고서 미리보기의 헤더에서 통합하고 싶은 '열'을 찾아 '드롭다운 버튼'을 눌러 '통합'을 클릭한다.  <br>     2단계:열을 통합하는 법 : 총계, 평균값, 최대치, 최소치. <br>•보고서의 데이터를 오름차순, 내림차순으로 배열<br>    보고서 미리 보기 헤더의 임의 필드 옆의 '↑''↓'를 클릭한다. 보고서의 데이터는 이 필드의 오름차순, 내림차순으로 배열된다. <br>•자세 정보 행 표시 및 숨김 <br>    그룹 분류 후 보고서 미리 보기 우상 측의 '자세 정보 행' 버튼을 통해 자세 정보 행을 표시하거나 숨길 수 있다. '자세 정보 행'은 자동으로 닫은 것으로 된다. <br>•자동 업데이트 미리보기 작동과 닫기 <br>    보고서 미리 보기 우상 측의 '업데이트 자동 미리 보기'를 통해 자동 업데이트 미리 보기를 작동하거나 닫기를 설정할 수 있다. 작동 후, 모든 조작이 데이터에 관한 영향이 보고서 미리 보기에서 자동으로 나타난다. •보고서 기록을 선택하려면 필터를 선택한다 <br>     필터는 표준 필터와 필드 필터로 나뉜다. <br>    이중에 표준 필터는 '역할'필터, '나에게 보여준다' 필터와 '일자'필터가 포함된다. <br>    A.'역할'필터, 현재의 역할과 직계 부하 역할로 데이터를 구분해 역할 명칭을 클릭하면 다른 역할로 전환된다. <br>    B.'나에게 보여준다'필터, '나에게 보여준다'및 '모두에게 보여준다'로 데이터를 구분해 '나에게 보여준다'는 소유인이 현재 사용자의 데이터인 것을 나타낸다. '모두에게 보여준다'는 현재 사용자가 권한이 있는 모든 데이터를 확인할 수 있다. <br>    C. '일자 범위'필터는 일자를 통해 한 시간단위의 모든 데이터를 구분한다. 예를 들어 '생성일''완료일' <br>    이 중에 필드 필터는 필드 필터와 고급 필터가 포함된다. <br>    `,
"label.validate.function.funcFormat.YEAR":`연도(일자)`,
"label.service.gantt.timeScale":``,
"label.data.dataexptemplate.desc1":`1. 데이터 내보내는 파일이 두가지 방식이 있어 하나는 CSV 형식이며 하나는 압축 형식입니다. 기본은 CSV 형식입니다.`,
"template.chart.btjbkhqk":``,
"label.role.assign.select":`<b>선택한 사용자</b>리스트에서 사용자를 제거하면 해당 사용자를 위에 선택한 역할에 분배합니다.`,
"label.event.lookupmulti.assigner":`피분배자`,
"label.appexchange.fieldupdata":`업무 프로세스 필드 업데이트`,
"label.lookup.page.notexists":`페이지가 존재하지 않습니다`,
"label.appupload.install.error.choice3":`충돌한 구성요소를 병합해 같은 구성요소로 병합합니다`,
"vue_label_commonobjects_detail_team":`그룹 관리`,
"label.approvereqiest":`요청 승인`,
"message.error.id.replace":`{0}와 관련된 캘린더 정보가 없습니다`,
"font-evaluate-module-v1-general":``,
"vue_label_report_whatweek":`요일`,
"vue_label_chatter_img_upload":`JPG、GIF나 PNG 파일을 업로드할 수 있으며 파일의 최대 크기는 2M입니다.`,
"label.checkbox":`체크 상자`,
"label.visualpage.component.n5":`5.예. 전용:&lt:component:c1 args="name:sqlName,age=18, sex='man'" /&gt; 사용:&lt;cc:component>&lt;cc>String myName = name; int myAge = age; String sex = sex;&lt;/cc>&lt;/cc:component>`,
"chatter.updat":`업로드 시간`,
"label.ems.emailaccount":`메일 계정`,
"label.autoRegister.changepwd.setpwd.tip1":`CloudCC 계정으로 비밀번호를 설정합니다`,
"label.import.step1.matchway":``,
"label.manageAll.sel.one4":`내가 거절한 프로젝트`,
"label.tabpage.lookatmorez":`많이 보기`,
"label_tabpage_addadvancedoptions":`고급 선택항목 추가`,
"message.validation.accept":`올바른 형식을 입력하십시오`,
"label.handlingnooperate":`데이터가 처리 중입니다. 다른 작업을 하지 마십시오. 그렇지 않으면 처리가 실패할 것입니다.`,
"label.mobile.buttom.homepage":`메인 홈페이지`,
"lable.account.LastaDays":`지난 7일`,
"label.user.notexists":`사용자가 존재하지 않습니다!`,
"front-electronic-signature-isclose":``,
"label.optional.groups":``,
"pagecreator.layout.label.layoutname":`레이아웃 명칭`,
"label.error404":`방문한 페이지가 존재하지 않습니다<br />잠시 후에 다시 오십시오...`,
"label.eventtrigger":`이벤트 트리거`,
"label.projectManagement.next.page":``,
"vue_label_SMS_chosen":`선택함`,
"label.part.cannot.empty":`단락을 입력하세요!`,
"label.call.center.jilu":`통화 기록`,
"front-kefu-moudle-v1-tenant-reinput":``,
"label.projectManagement.you.want.to.delete.this.data":``,
"label.projectManagement.nocharge":``,
"System_TAB_SeeViewPageAmount":`페이지수 보기`,
"label.password.query.error":`사용자 조회에 오류가 발생했습니다`,
"message.chooseatleastone":`최소 한개 값을 선택하세요`,
"label.sortasc":`오름차순`,
"label.stdashbord.xsld.business.jinezhb":`금액 차지율`,
"label.attendance.add":`출석 체크 추가`,
"vue_label_account_invoices":`고객 소유인의 모든 영수증을 이동`,
"label_delete _model":``,
"label.folder.sort。discreption":`폴더가 선택한 순서로 출력합니다.`,
"label.partnerCloud.financeSetting.merchantPlatform":``,
"label.equal":`= 같다`,
"lable.PowerProcess.Workorder":``,
"front-docusign-setting-error-tips":``,
"template.report.lead.status":``,
"label.create.remark":`비고 신규 추가`,
"font-evaluate-module-v1-one-points":``,
"label.validate.function.funcExplain.DATETIMEVALUE":`년, 월, 일 및 GMT 시간으로 돌아가기(일자/시간 필드)`,
"label.report.select.group.mode":`그룹분류 방식을 선택합니다`,
"label.h5.editmydetails":`개인 정보 편집`,
"front-epwechat-module-v1-authorize":``,
"label.tabpage.kanban":`간판 설정`,
"label.emailobject.emaildetail.button.addtocontact":`연락담당자로 추가`,
"lable.opppdt.selPbk.description":`이 업무기회에 가격매뉴얼을 선택합니다. 한개 가격 매뉴얼에서만 제품을 추가할 수 있습니다. 선택한 가격 매뉴얼을 변경하면 해당 업무 기회에 모든 기존 제품이 삭제됩니다.`,
"component.event.button.save":`저장`,
"vue_label_homepage_homepage_assigned_success":`홈페이지 분배 성공`,
"message.duplication.label.blankmatch":`공백값 매칭 여부`,
"label.icon.24":`구급 상자`,
"label.mobile.same":``,
"label.file.library.managemembers.addmember":`멤버 추가`,
"chatter.sp":`게시물 보기`,
"label.user.notlogin.range":`로그인 시간 범위에 없습니다!`,
"label.step3.total7":`3단계, 총 7단계`,
"label.user.fullname":`풀 네임`,
"label.button.menubar":``,
"#label.importfilestep3":`3단계: 파일을 선택하고 업로드합니다#`,
"label.appointment.wizard.subtitle6":`내용`,
"message.lostnextapprover":`제출이 해당 사용자 필드가 확인한 다음 승인자가 필요하며 이 값은 비어 있습니다.자세한 사항은 관리자에게 연락해 주십시오.`,
"label.sso.saml.sp.logoutUrl":`신원 제공자 싱글 로그아웃 URL`,
"label.weixin.isgoon":`회원 정보가 존재하여 계속 하면 기존 이 핸드폰 번호와 연동한 위쳇 계정이 Aid-Max 위쳇 공식 계정을 사용할 수 없습니다. 계속하시겠습니까?`,
"vue_label_notice_homepage1":`12자리 내의 정확한 목표값을 입력하세요.`,
"label.umeng.activity.event.will":`곧`,
"label.insertURL":``,
"label.partnerCloud.orderingPlatform.administrator":``,
"vue_label_systemSettings_emailtemplate":``,
"template.dashboard.market.analysis":``,
"message.deleteapproval.tip":`이와 데이터 기록 관련이 없는 승인 과정만 삭제할 수 있습니다.`,
"pagecreator_page_message_delete":`현재 선택한 페이지를 삭제하시겠습니까?`,
"component.telerecord.label.message":`메세지`,
"front-email-payment-Invoice-preview-opening":``,
"noless":`크거나 같다`,
"label_emailtocloudcc_button_back":`취소`,
"lable.Please.select.a.template":``,
"front-lightning-module-v1-details-page-chart-relevant":``,
"label.object.page.head":`머릿글`,
"label.notification.time1":`방금`,
"label.weixin.optionnine":`선택항목9`,
"label.approval.content.tolang":`입력한 내용 길이가 한계를 초과하여 다시 입력하세요!`,
"label.leadconvers":`잠재고객 전환`,
"label.compact.layout.frame.tabseq":`TAB 페이지 순서 보기:`,
"label.permission":`권한 세트`,
"vue_label_notice_new_success":`새로 만들기 성공`,
"label.money":`화폐`,
"label.ccchat.person.invite.unsuppem":`입력한 메일 주소가 {0}에 지원되지 않습니다`,
"message.profile.del":`이 프로필은 시스템 관리자 프로필이므로 삭제할 수 없습니다!`,
"vue_label_report_savelocation":`위치 저장`,
"label.knowledgebase.select.lighting.target":``,
"label.visualpage.labelname":`페이지 라벨명`,
"label.notification.ccchat2":`['좋아요' 누른 사용자명]님의 게시물에 '좋아요'를 눌렀습니다`,
"label.htyj.wanchenglv":`완성률`,
"label.weixin.report.generatedchart":`차트 생성됨`,
"label.customer.tab.please.label":`메뉴 라벨을 입력하세요`,
"label.template.lookup":`템플릿 보기`,
"label.attendance.setting.wucha":`오차범위가 200미터 이내`,
"vue_label_opportunity_product_addproduct":`제품 추가`,
"label.data.setok.t.desc3":`작업이 진행된다`,
"label.emailobject.template.public":`공개`,
"label.setsubmit":`설정 제출`,
"chatter.feed.menutype.feed.companycom":`모든 게시물`,
"label.Generate.Document":`파일 생성`,
"label.knowledge.setting.hint.six":``,
"label.dashboard.show.total":`총수 보기`,
"attachment.select.warning.001":`문서 보관을 체크한 첨부 파일의 문서 보관 버튼이 사용 불가능하며 첨부 파일을 다시 선택하세요.`,
"message.schedulejob.error.delete":`Job 라이브러리를 삭제하는 중 오류가 발생했습니다.`,
"setup.layout.group.pagecomponent":`폐이지 구성 요소`,
"label_partner_new_step3_meno":`입력 내용을 확실하지 않습니까? 걱정하지 마세요. 언제든 변경이 가능합니다.`,
"label.partnerCloud.orderingPlatform.mutex":``,
"label.subtotalrely":`소계 근거`,
"label.file.library.selectFile2Lib":`파일 추가`,
"label.lock.record":`기록이 잠겨 있습니다(`,
"label.multilang.addcustomreporttypestage2.description":`이 데이터 소스가 {0}과 관련된 보고서를 생성합니다. 이와 관련된 대상을 선택함으로써 다른 대상의 어떤 관련 기록이 데이터 소스 결과로 반환하는지를 정의할 수 있습니다.`,
"message.duplication.errorinscript.greaterthan10":`최대 10개 병합할 기록을 선택할 수 있습니다!`,
"label.encd":`암호화 표시`,
"UG.Account.03":`중복된 고객 검색 및 병합`,
"label.salescloud.teamrole.main2":`주요`,
"label.email.to":`수신인`,
"label.members.sign.notify":``,
"template.report.individual.case.priority":``,
"vue_label_report_selectfolder":`폴더 선택`,
"label_partner_all":`전부 파트너 클라우드`,
"lable.custom.year":`사용자 설정 연도`,
"label.ispigeonhole":`첨부파일 보관`,
"label.campaignmember.selectmember.steptotal":`2단계, 총 2단계`,
"label.userphoto.save":`저장`,
"label.knowledgebase.published.version.online":``,
"template.report.customer.level.statistics":``,
"label.mobile.phone.day.plan":`내일 계획`,
"label.icon.95":`교육`,
"label.recordphone":`기록 전화`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`고급 화폐 관리 사용을 금지하면 만료된 환율을 사용할 수 없게 됩니다. 업무기회, 업무기회 제품과 이 두가지 대상과 관련된 보고서의 화폐가 특정 일자 범위 내의 환율에 매핑되지 않습니다. 모든 화폐 필드가 고정된 환율에 적용됩니다.`,
"label.service.gantt.is.candidate":``,
"label.ruleofchecktask":`업무 인증 규칙`,
"label.whole.page.show":`전체 화면 표시`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expression)`,
"label.ccdocument.template.set":``,
"label.icon.103":`일정`,
"lable.no.products.to.assets":``,
"label.fristname":`명`,
"label.appointmentconfirmail.wizard.subtitle5":`발기자/조직자`,
"label.partner.workspace.myspace":`나의 작업 공간`,
"label.tabpage.optionsz":`선택 항목`,
"component_chatter_link_button_save":`발표`,
"label.validate.function.funcFormat.NOW":`현재()`,
"label.discountPlanEditor":``,
"label.weixin.fmu.pm":`오후{0}`,
"front-gantt-module-milestone-sorting":``,
"label.partnerCloud.maximumNumber":``,
"label.mobile.place.record.interval.setup":``,
"label.visiblelinenumber":`볼 수 있는 행수`,
"front-kefu-moudle-nopower-calluser":``,
"label.field":`필드`,
"label.projectManagement.groupbydate":``,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":``,
"label.operation.monitoring.history":`작업 모니터링 이력`,
"label.data.dataexpalltype.all_desc1":`1. 모든 압축파일을 내보내면 비밀번호가 자동으로 생성되거나 수동으로 입력할 수 있습니다. 자동 생성한 비밀번호는 데이터가 내보내기 성공한 후 사용자 메일로 전송됩니다. 수동 입력한 비밀번호는 사용자 메일로 전송되지 않아 사용자가 본인이 입력한 비밀번호를 기억해야 하고 입력하지 않으면 비밀번호 없는 것으로 기본 설정됩니다.`,
"front-web-module-v1-detail-comment-proposal":``,
"label_partner_workspace_member_selectedpermission":`선택한 권한 세트`,
"vue_label_helpcenter_view1":`lighting 버전의 뷰에서 직관적이고 융통성 있게 방문 권한이 있는 데이터를 확인 및 관리할 수 있다. 뷰를 통해 데이터의 분류, 다양한 전시 방식, 생성 , 수정, 삭제 등 많은 기본 기능을 이룰 수 있다. 빠르게 보고서, 차트를 볼 수 있고 데이터를 분석할 수 있다. <br>1 관리 뷰 <br> 뷰의 좌하측 드롭다운 메뉴에서 확인하고 싶은 뷰를 선택할 수 있고 고정된 설정으로 기본 뷰를 선택할 수 있다. <br>리스트 뷰를 통해 메뉴를 통제할 수 있고 뷰를 새로 만들기, 편집, 삭제할 수 있거나 순서를 배열할 수 있다. 우상측의 필터 기능을 통해 빠르게 뷰를 편집하고 만들 수 있다.<br>2 다양한 뷰를 통해 데이터 확인 <br> 다양한 방식으로 데이터를 확인할 수 있다. 우상측에서 리스트, 간판, 분할 화면으로 데이터를 볼 수 있다. <br>리스트 뷰에서 일부 유형의 필드가 한개나 여러개 데이터에 대해 수정 작업을 할 수 있다. 편집 필요한 셀을 두번 클릭하거나 편집 버튼을 클릭하면 팝업창에서 데이터를 편집할 수 있다. 여러개 데이터를 편집하려면 여러개 데이터를 선정하고 편집의 팝업창에서 ' 선정한 데이터에 적용'을 선택한다. <br> 리스트 뷰에서 좌상측에서 전시될 열을 직접 편집해  헤더에서 헤더를 클릭하여 순서를 배열하거나 드롭다운 리스트를 통해 지정될 열을 선택한다. <br> 간판 뷰로 설정한 후 그룹으로 데이터를 볼 수 있고 그룹마다의 합계치를 확인한다. 간판 뷰의 설정에서 간판 뷰의 그룹분류 근거, 합계 근거 및 합계 방식을 편집할 수 있다. 한번에 4개 필드를 선택해 전시할 수 있다.드래그 앤드 드롭으로 데이터의 그룹 분류를 변경할 수 있다. <br>`,
"component.task.label.priority":`선순위`,
"label.datamanage.field.error":`대상 필드 검색에 오류가 발생했습니다`,
"label.console.step3":`3단계. 조작공간 마크의 이미지 소스를 선택합니다`,
"label.ems.emailsyncsetup":`메일 동기화 설정`,
"label_tabpage_placeenterz":`입력하세요`,
"label.getontocolumn":`열로 이동:`,
"label.file.down.e":``,
"vue_label_notificationcenter_unreadonly":`읽지 않는 내용만 표시`,
"label.login.access.change":`변경`,
"label.globaloperation.operationtype.send_e-mail":`메일 전송`,
"label.dashboard.refresh.hint":`대시보드 새로 고침이 모든 소스 보고서를 다시 실행하기 때문에 시간이 걸릴 것입니다. 계속 진행하시겠습니까?`,
"front-kefu-moudle-open-free":``,
"label.lanxin.setting.appsecret":``,
"label.payment.manage.order":`구독 관리`,
"label.chatter.maturiyDate":`마감 일자`,
"message.mobilechooseatmostthree":`핸드폰 포그라운드 메뉴에 최대 3개 필드를 선택할 수 있습니다`,
"label.customfields.formula.tip":`정의한 공식으로 값의 읽기 전용 필드를 파생합니다. 소스 필드가 변경되면 해당 공식 필드가 업데이트됩니다.`,
"lable.PowerProcess.start.time":``,
"label.mr.title.button.group2":`그룹 중복 데이터, 총`,
"label.atlantic.standard.time":`대서양 표준 시각대`,
"label.account.LengthofTime":`지속 시간`,
"label.ccchat.message.search.desc2":`의 메시지`,
"label.pigeonhole.desc":`첨부파일 보관은 미보관한 첨부 파일에만 유효합니다. 보관된 첨부 파일에는 유효하지 않습니다.<br/>첨부파일이 보관되면 삭제할 수 없습니다.`,
"label.partnerCloud.orderingPlatform.sure":``,
"label.default.value.is.positive.integer":`기본값이 자연수이어야 합니다!`,
"label.partnerCloud.selectOne":``,
"label.dashboard.more.condition":``,
"component.event.label.enddate":`*마감 시간`,
"label.forecast.settings.type":`예측 유형`,
"com.cloudcc.login.error.message.licensenotstart":`허용이 시작되지 않았습니다`,
"lable.list.queue":`대열`,
"label.mobile.app.isdisablum":`출석 시 사진첩에서 사진 선택 금지 여부`,
"label.service.gantt.filter":``,
"label.potentialcustomeronline":`온라인 잠재고객`,
"label.campaignmember.main.deletecontactdesc":`한 번에 모든 연락담당자를 마케팅 행사에서 모두 삭제합니다`,
"label.list.desc1":`web to CloudCC 기능을 통해 web 페이지를 생성하며 web 방문을 통해 CloudCC 시스템으로 데이터를 획득합니다.`,
"label.generatepage.title.desc3":`이름은 유일해야 하며 이름은 알파벳으로 시작해야 하며 알파벳 대소문자, 숫자, 밑줄만 포함할 수 있으며 길이는 30 이상일 수 없습니다.`,
"label.emailtocloudcc.step2total3":`2단계, 총 3단계`,
"label.movablemenu":`행사 버튼`,
"label.partnerCloud.partnerAccount.topUp":``,
"label.data.standobject":`표준 대상`,
"label.frequency":`빈도`,
"label.schedulejob.setup.schedule.end":`완료`,
"label.chat.topic.following":`팔로잉`,
"label.martrixreport.2018.step2":`2단계: 통계할 정보를 선택합니다`,
"label.event.moveup.11hour":`11시간을 앞당깁니다`,
"label.forecast.customforecast.directorcommit":`산하의 승낙액`,
"vue_label_homepage_card_view":`카드 뷰`,
"vue_labenl_applauncher_notice_closecertification":`닫은 후 데이터가 없어질 수 있으니 닫으시겠습니까?`,
"component_setup_button_weburl":`외부 URL`,
"label_emailtocloudcc_button_addemailaddress":`업체 메일 추가`,
"vue_label_campaign_added_campaign_members":`마케팅 행서 멤버 추가 성공`,
"label_tabpage_rtemptyz":`기록 유형이 비어 있을 수 없습니다`,
"label.martrixreport.2018.step5":`5단계: 차트 유형과 보고서 하이라이트 보기를 선택합니다`,
"label.moverecord":`기록 이동`,
"pagecreator_layout_label_layoutdesc":`레이아웃 내용`,
"label.knowledge.setting.data.nine":``,
"label.icon.90":`사람`,
"label.weixin.micro.research.name":`위쳇 연구조사 명칭`,
"label.ccchat.micropost.allowedit":`사용자가 게시글과 댓글을 편집할 수 있도록 합니다`,
"vue_label_homepage_fixed_components":`표준 구성 요소`,
"label.version.document":`문서 라이브러리`,
"label_assessment":``,
"label.appupload.component.type.lookuplayout":`검색 레이아웃`,
"label_chatter_loadmore":`더 많은 로딩`,
"component_setup_tabs_label_memo":`Tab 라벨 명칭을 설정합니다`,
"label.icon.167":`나침반`,
"vue_label_chatter_enter_content_sharing":`공유 내용과 공유 그룹을 입력하세요.`,
"vue_label_notice_modify_success":`수정 성공`,
"label.sharerules":`규칙 공유`,
"label.field.api.exists":`필드 API가 존재합니다`,
"label.icon.83":`칠판지우개`,
"label.file":`개 파일`,
"vue_label_report_foldernameisrequired":`폴더명은 필수 기입 항목입니다`,
"label.emailobject.wizard.btn2":`이미 관련되었으며 메일 전송하기`,
"label.data.downpage.i_title.num3":`3. 불러오기 전 관련된 모든 기록을 불러온 것을 확보합니다. 예: 현재 불러오는 대상이 연락담당자와 찾기 관계가 있으면 먼저 연락담당자를 불러오고 데이터를 불러오세요.`,
"label.email.original.content":``,
"vue_label_campaign_add_to_campaign":`마케팅 행사로 추가`,
"label.dashboard.new":`대시보드 새로만들기`,
"label.console.detail":`콘솔 보기`,
"label.view.desc":`날짜 필드는 '어제', '오늘', '내일', '지난달', '이달', '다음달', '다음주', '이번주', '다음주', 'YYYY-MM-DD, MM/DD/YYYY' 포맷을 사용할 수 있습니다.`,
"label.emailobject.template.insert.continue":`계속 추가`,
"label.notification.appointment.overlapEvent":`해당 시간이 이미 예약되었으며 다시 선택하세요.`,
"label.console.step6.top":`상단에 고정합니다. 리스트가 항상 보입니다.`,
"label.data.file.the_trigger":`트리거 실행`,
"message.report.error.operation":`조작이 실패하였습니다. 보고서를 다시 설정하십시오!`,
"vue_label_helpcenter_detail3":`<br>    좋아요 및 좋아요 취소 <br>    게시물이나 게시물의 댓글에 대해 좋아요를 누를 수 있다. 좋아요를 누른 후 해당 게시물의 좋아요 인원수를 확인할 수 있으며 좋아요 누르기를 취소할 수도 있다. <br>게시물 편집 및 삭제<br>    게시물의 발표자가 게시물을 다시 편집하거나 삭제할 수 있다. <br>    1단계:게시물 우측의 버튼을 눌러 드롭다운 리스트에서 편집이나 삭제를 선택한다. <br>    2단계: 연 후에 편집/삭제 확인이라는 팝업창이 뜬다. <br>    3단계:저장/ 확인을 클릭한다. 작업이 완성된다. <br>5、승인 이력<br>승인 대기한다. <br>    새 기록을 만든 후 심의 요청 돌려보내거나 심의를 거절당할 때 '승인 대기중'버튼이 나타난다. <br>    1단계: '승인 대기중'버튼을 클릭하여 시스템에서 해당 기록과 제출 작업자가 승인 프로세스에 설정한 조건에 부합하는 지에 대해 판단하여 다 부합한 경우 승인이 성공한다. <br>    승인 프로세스 설정에서 다음의 승인 절차가 필요하면 수동으로 승인자를 선택하여 '승인 대기중'나타난 후에 2단계를 실행한다.<br>    2단계:다음 승인자를 선택해 제출 작업을 완성한다. <br>승인 이력 <br>    A.제출 전:<br>    '승인 프로세스 미리 보기'를 클릭하여 시스템에서 해당 기록과 제출 작업자가 승인 프로세스에서 설정한 프로젝트 및 최초 제출자의 조건에 부합하는 지를 판단해 다 부합하는 경우 승인 프로세스가 진행된다. <br>    B.제출 후:<br>    승인 이력에서 해당 기록의 승인 이력 절차 및 현재 승인 상태, 다음의 승인 절차를 미리 볼 수 있다. <br> 승인 요청 돌려보내기 <br>    해당 승인 절차에서 승인 요청 돌려보내는 조건을 설정했다면 제출 후에 언제든 철회 가능하다. <br>    1단계: 기록 자세 정보 페이지에서 '승인 요청 돌려보내기'를 클릭한다 <br>    2단계: 승인 요청 돌려보내는 페이지를 열어 '승인 요청 돌려보내기'를 클릭하여 작업이 완성된다.`,
"Opportunity_Detailed_Phase_Label_004":`일`,
"PageLayout_Search_MultiSearch_001":`최대 3개 필드만 선택할 수 있습니다`,
"vue_label_systemSettings_set_business":``,
"label.compact.layout.frame.select":`페이지 레이아웃 테두리를 선택하세요`,
"label.tabpage.rolez":`역할`,
"label.weixin.appr.currentauditor":`피분배자`,
"label.knowledgebase.verification.status":``,
"UG_Case_05":`개별안 생성`,
"label.service.marking.completed":``,
"label.notification.ccchat1":`[@보낸 사용자명] 님을 소환했습니다`,
"label.knowledgebase.no.action.available":``,
"label.tabpage.newlybuildz":`새로 만든 사용자 설정 보고서 데이터 소스`,
"label.appupload.install.error.choice2":`스프트웨어 패키지와 충돌하는 로컬 구성요소 이름을 바꿉니다`,
"label_tabpage_as":`예`,
"Opportunity.Detailed.Phase.Label.Popup.001":`일자 들어가기`,
"vue_label_homepage_singlepage":`페이지당 최대 10개 구성 요소만 추가 가능합니다.`,
"font-evaluate-module-v1-fair-and-bad":``,
"label.partnerCloud.orderingPlatform.orderInformation":``,
"label.custom.lead.conversion.notice":`잠재고객 전환 통지`,
"label.re.upload":`다시 업로드하기`,
"label.knowledgebase.top.window":``,
"label.h5.allmarkedasread":`읽지 않음으로 표시하기`,
"vue_label_SMS_open_record_from_start_activation":`사용할 수 있도록 리스트에서 기록을 열어주세요.`,
"label.customer.tab.step2":`프로필에 추가`,
"label.campaign.channel.input.owner.select2":`이 마케팅 채널 초대인`,
"component.task.button.save":`저장`,
"front-kefu-moudle-v1-phone-type":``,
"label.wedge-shapearrows":`쐐기형 꼬리 화살표`,
"vue_label_homepage_todaysevent":`오늘 이벤트`,
"label.data.exp.way.sel":`데이터 내보내기 방식을 선택하십시오`,
"label.setting.intergrationlist.status1":`해당 통합이 설지되지 않았습니다`,
"button_partner_workspace_disable":`사용 취소`,
"label.customfields.reference":`공식, 선택항목 리스트, 찾기 등 다른 필드에 인용될 수 있습니다.`,
"label.publicgroups.new":`공용그룹 새로 만들기`,
"label.data.setok.e_desc3":`내보낸 데이터를 다운로드합니다.`,
"vue_label_commonobjects_view_chart_countmode":`합계 방식`,
"label.service.appointmentList.earliest.allowedStart":``,
"label.data.choses.e.desc":`필요에 따라 모든 데이터나 단일한 대상자의 데이터를 선택해서 내보낼 수 있습니다.`,
"label.multilang.common.fieldlist.fieldremark":`{0}페이지에서 보는 필드에 응용합니다.`,
"label.umeng.activity.event":`이벤트`,
"label.project.hit.ten":``,
"label.c_d_least":`"C"기록마다 최소 한개 관련 "D"기록이 있어야 합니다.`,
"label.emailobject.wizard.btn1":`개인 메일 연동`,
"lable.product.pricebooks.info":`가격매뉴얼 상세 정보`,
"component_telerecord_label_message":`메시지`,
"lable.total.of.estimates":``,
"label.stdashbord.xsld.business.oppcounts":`기회 수량`,
"vue_label_commonobject_duplicatewith":`{0}에서의 {1}과 중복됩니다.`,
"label.setpicandreport":`차트 설정`,
"label.category.2":`통용`,
"label.emailtocloudcc.reauthorization":`권한 다시 부여한다`,
"label.chatter.vote":`투표`,
"label_emailtocloudcc_edit":`편집`,
"label.pleaseinput":`입력`,
"vue_label_homepage_user_particular_application":`사용자가 특정 응용 프로그램을 사용 시의 홈페이지, 분배가 표준 홈페이지를 커버합니다.`,
"label.allianceID":`연맹ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":``,
"label.appointmentpage.wizard.notif2":`이름을 입력하세요`,
"label_emailsync_status_email":`메일 조작`,
"label.icon.179":`사람`,
"UG_Contract_03":`계약서 생성`,
"label.cy.new":`새 화폐 종류`,
"label.version.setup.controllist":`시스템 설정 제어 리스트`,
"label.vlidaterule":`인증 규칙`,
"label.customer.tab.name":`메뉴명`,
"label.recentview.seloption1":`최근 보기 이력`,
"vue_label_report_notice_nameisrequired":`보고서 제목은 필수 기입 항목입니다`,
"label.createapproveprocessstep":`<li>1. 읽기 도움말 주제</li><li>2. 메일 템플릿을 생성합니다</li><li>3. 문자 메시지 템플릿을 생성합니다 </li><li>4.이동 기점 안내나 표준 안내를 사용해 승인과정을 생성합니다</li><li>5. 승인 이력 관련 리스트를 전체 페이지 레이아웃에 추가합니다</li><li> 6. 과정을 사용해 사용자에게 적용합니다.</li>`,
"label.gotocalendar":`캘린더로 이동`,
"label.import.page1.pleaseselectobj":`대상자를 먼저 선택하시오`,
"label_tabpage_messagez":`메시지를 입력하세요`,
"vue_label_homepage_profilepage":`프로필 홈페이지`,
"label.tabpage.choose":`선택`,
"label.campaignmember.setup.lead.field":`잠재고객 필드`,
"label.setalipay.null":``,
"label.custom.Current.and.NextCQ":`현재 및 다음 사용자 설정 분기`,
"label.knowledgebase.needto.publish.articles":``,
"pagecreator.layout.message.save.success":`레이아웃 저장 성공`,
"homepage.componet.approval.label":`승인 센터`,
"label.last_submission":``,
"lable.outlook.detail.prefo":`1순위 선택 Exchange`,
"label.projectManagement.new.subtask":``,
"label.service.appointmentList.checkThe":``,
"message.error.searchlayoutselectdefields":`삭제할 수 없어 검색 레이아웃의 첫 번째 필드여야 합니다.`,
"label.ems.normal":`정상`,
"vue_label_notice_pleaseselectobject":`대상을 선택하세요.`,
"component.sendmail.button.send":`발송`,
"label.relevant.records":``,
"label.weixin.login.CloudCC":`CloudCC로 로그인`,
"label.tag.addtags.private":`개인용`,
"label.appointment.disable.remark":`죄송합니다. 해당 기능이 금지 사용되었으며 예약을 다시 하거나 취소하면 메일에서：{메일 주소}책임자에게 연락하세요.`,
"label.campaignmember.main.addMember1":`멤버 추가`,
"message.error.objectnofound":`미정의 대상:`,
"label.employeenum":`직원 번호`,
"label.search.applyfilter":`응용 필터`,
"label.version.history.track.nonsupport":`무한 버전만 필드 팔로우업 이력 기능을 지원합니다.`,
"label.ccpeak.direction.for.use.time":`CloudCC 플랫폼 타이밍 종류 사용 설명(2.0버전)`,
"label.ems.settings":`설정`,
"label_tabpage_arecordtypez":`사용 가능한 기록 유형`,
"vue_label_pool_assign1":`{0}{1}`,
"label.customcomponent.direction.for.use":`플랫폼 사용자 설정 구성요소 사용 설명(2.0버전)`,
"label.appupload.appname":`소프트웨어 패킷 명칭`,
"label.cpq.order.status.no.active":``,
"label.dashboard.maxlength":`최대 255개 문자까지 입력해주세요`,
"label.customize.memory.function.sorting.title2":``,
"label.report.chose.obj":`대상자 관계 및 보고서 데이터 소스 선택`,
"label.partner.step3":`3단계: 기본 정보`,
"message.report.type.error.fail":`보고서 데이터 소스에 오류가 발생했습니다!`,
"pagecreator.page.message.publish.fail":`페이지 발표 실패`,
"label.minimun":`최소치`,
"label.state":`상태`,
"label.customcomponent.referencetype":`인용 유형`,
"label.nameandemailtemplate":`다음의 상자에서 과정명을 입력해 메일 템플릿을 선택하며 승인자에게 알립니다(선택 가능).`,
"label.customobjects.track.introduce":`이 페이지에서 선택 허용`,
"label.campaign.matchway.label":`매칭 방식:`,
"label.redistribution":`다시 분배`,
"label.groupmanage":`조직 관리`,
"label.icon.157":`카메라`,
"label.quickbooks.viewlist.total":`합계`,
"label.file.copy.file.fail":`복사에 실패했습니다. 수동으로 복사하십시오.`,
"label.outline.selectfield":`개요에 선택된 필드:`,
"label.datetime.maxsize":`조회한 주기가 3개월을 초과할 수 없습니다`,
"label.dashboard.CustomDashboardMyHomePage":`나의 메인 홈페이지 대시보드 설정하기`,
"label.data.customobject":`사용자 설정 대상`,
"vue_label_SMS_noselected":`선택한 기록 없음`,
"label_tabpage_value":`값`,
"label.quote.qianming":`서명`,
"label.view.source":`소스 코드 보기`,
"label_popup_infoz":`안내`,
"label.emailtocloudcc.redmessage8":`파라미터가 오류 발생하여 관리자에게 연락하세요`,
"label.tianyancha.Search.business":`공상 등록 정보를 검색합니다`,
"vue_label_systemSettings_server":``,
"vue_label_homepage_dashboard_components":`대시보드 구성 요소`,
"label.search.listview":`리스트 뷰`,
"label.service.gantt.distribution.success":``,
"label.icon.4":`지갑`,
"label.partnerCloud.orderingPlatform.calculate":``,
"label.forecast.edittotal.ycyx":`예측 우선`,
"vue_label_commonobjects_detail_to_precise_search":`정확 검색으로 이동`,
"label.order.number":`순번`,
"setup.mainpage.label.welcome7":`작업 메뉴얼: 본 페이지 좌측 메뉴를 클릭하여→ 응용 프로그램 설정→새로 만들기→대상자→대상자명→필드 설정`,
"label.weixin.user.binding":`사용자 연동`,
"label.custom.canvas.size":``,
"label.projectManagement.recent.projects":``,
"vue_label_helpcenter_lead":`Cloud CC를 통해 잠재 고객을 팔로우업하고 관리한다. 배치된 규칙대로 잠재 고객에게 채점을 하고 잼자 고객을 분배한다. 적당한 시기에 잠재 고객을 고객, 연락담당자 및 관련 업무 기회로 전환한다. <br>채점<br> 뷰의 우상측에서 모두 채점 버튼을 통해 해당 뷰의 잠재 고객에게 채점을 한다. <br>분배 <br> 잠재 고객을 생성하거나 편집할 때 페이지 밑에서 분배를 선택해 기존 규칙대로 잠재 고객을 대응한 인력에게 분배한다. <br>전환 <br> 적당한 시기에 상세 페이지의 우상측의 전환 버튼을 눌러 잠재 고객을 고객, 연락담당자로 전환해 동시에 대응한 업무 기회와 업무를 생성하여 향후의 거래 기회를 팔로우업한다.`,
"label.enabledprocess":`사용된 승인 과정`,
"label.emailobject.noemail":`메일이 없으며 메일 보내세요!`,
"label.validate.remark3":`다른 필드 값에 따라 제한적으로 필드 필요 여부를 결정합니다`,
"vue_label_salesadvance_retention":``,
"label.product.managep":`가격매뉴얼 관리`,
"font-evaluate-module-v1-not-report":``,
"label.emailmerge.mergepage.step1":`1. 병합할 기록을 선택합니다:`,
"front-epwechat-module-v1-epwechat-describe":``,
"label.partner.template.detailimage":`상세도`,
"label.recycle.clearall":`귀조직의 휴지통 비우기`,
"chatter.error.nottype":`오류: 잘못된 형식입니다. 업로드 가능한 파일 형식은 JPG, GID, PNG입니다!`,
"pagecreator.button.cancel":`취소`,
"front-market-form-quired-ziduan":``,
"vue_label_report_columnname":`열 명칭`,
"message.notdelete.type":`다음 프로필이 이 기록 유형을 기본값으로 사용해 이 기록 유형을 삭제할 수 없습니다.`,
"label.ccpeak.folder.all.time":`모든 타이머 클래스 폴더`,
"label.quickbooks.searchlist.total3":`{0}개 미관련된 추산 기록이 검색되어 총금액이 {1}입니다`,
"label.forecast.detailforecast.quantity":`수량 예측`,
"label.knowledge.language.british":``,
"label.vlidaterule.example.messagelocation":`이 오류 메시지는 머리말이나 페이지의 특정 필드 아래에 나타날 수 있습니다`,
"front-kefu-moudle-chf-success":``,
"vue_label_jihui_yi":``,
"label.import.step1.null":``,
"label.console.step5.tab.subtab":`서브메뉴로 합니다`,
"batch.edit.permission":`편집 권한 없음`,
"label.weixin.fmu.before.min":`{0}분을 앞당깁니다`,
"chatter.up.file":`파일을 업로드하는 데에 시간이 걸리며 파일 크기에 달려 있습니다. 파일 업로드 기다리세요.`,
"setup.layout.group.field":`필드`,
"label.chat.unlike":`좋아요 취소`,
"vue_label_dashboard_updatefrequency":`업데이트 빈도`,
"label.trigger.folder.new":`트리거 페이지: 폴더 새로 만들기`,
"label.process.des.app":`현재 기록의 상세 정보를 보려면 우측 링크를 클릭하세요.`,
"vue_label_pool_assignselect":`분배자 선택`,
"label.lookup.user":`인원 찾기`,
"label.mobilescreentablayoutedit.remark2":`모바일기기 포그라운드 메뉴 페이지 선별에서 보는 필드를 선택합니다`,
"label.data.exp.objtemp":`다음 조건으로 이 대상을 내보내는 템플릿을 제작합니다`,
"label.weixin.moreselect.error":`10개 기록만 선택할 수 있습니다`,
"label.icon.25":`상처 싸매기`,
"lable.sample.text":``,
"label.most.setup.obj":`대상을 최대 10개까지 설정할 수 있습니다`,
"label.weixin.coming":`미래`,
"label.editdescription":`비고 편집`,
"label.multipleactivity.multiple":`여러개 사용자`,
"label.sso.saml.idp.entityid":`엔티티 ID`,
"label.SMS.pho.filed":`전화번호 필드`,
"message.serviceabsence.violation":``,
"label.forecast.settings.type.clist":`제품 계열 사용`,
"label.state.noend":`미완료`,
"label.sourcetemp":`소스 번역 템플릿`,
"vue_label_chatter_name_link":`명칭과 링크를 입력하세요`,
"label.emailobject.attach":`첨부 파일 추가`,
"label.everyother":`간격`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`채팅 계정이 개설되지 않아 계정을 바로 개설하시겠습니까?`,
"pagecreator_layout_button_delete":`레이아웃 삭제`,
"label.transfer.temporarily":`호출`,
"label.service.dispatchingUnits.search.services":``,
"customer.message.fail.chat":``,
"label.apiname.toolong":`Api 명칭 길이가 한계를 초과했습니다`,
"label.empty.filter":``,
"label_tabpage_personalCenterz":`개인 센터`,
"label.minutes":`분`,
"label.multipleactivity.atasks":`개 업무`,
"label_tabpage_deleteview":`뷰 삭제`,
"pagecreator_layout_message_save_success":`레이아웃 저장 성공`,
"label.reportlineorder":`보고서 열 순서`,
"label.total.forecast.have.priority":`의 모든 예측 우선. 하지만 다른 부하의 예측 우선을 받아들입니다`,
"label.custom.quarter.subtitle":`사용자 설정 분기`,
"label.icon.79":`인쇄`,
"label.hiddenoperate":`조작 숨김`,
"label.project.hit.six":``,
"label.visualpageaction.errordesc":`요청한 조작을 실행한 권한이 없습니다. 방문하시려면 기록 소유인이나 관리자에게 연락하세요.`,
"label.chat.unmute":`방해 금지 취소`,
"label.zhaiyao":`요약`,
"vue_label_commonobjects_detail_bcc":`숨은 참조`,
"label.customcomponent.page.index.table.version":`API 버전`,
"UG.quota.06":`견적 새로 만들기`,
"label.icon.152":`로봇`,
"label.partnerCloud.partnerAccount.account":``,
"label.file.sharewith":`공유자`,
"label.data.dataexptemplate.desc2":`2. 내보내기 방식의 압축 형식이 두가지가 있습니다:하나는 자동으로 압축 파일 비밀번호를 생성합니다. 자동 생성한 비밀번호는 데이터를 내보내기 성공한 후 사용자 메일로 전송됩니다. 또 하나는 수동으로 압축 파일 비밀번호를 입력합니다. 수동 입력한 비밀번호는 사용자 메일로 전송되지 않아 사용자가 본인이 입력한 비밀번호를 기억해야 하고 입력하지 않으면 비밀번호 없는 것으로 기본 설정됩니다.`,
"vue_label_dashboard_newfoldersuccessfully":`폴더 새로 만들기 성공`,
"label.campaignmember.main.importmember":`마케팅 행사 멤버 대량 불러오기`,
"label.htyj.completed":`완료`,
"label.reportTypeLabel":`보고서 라벨`,
"label.customer.tab.label":`메뉴 라벨`,
"label.dashboard.component":`구성요소`,
"label.safetystatement.dialog":`안보 성명(새 윈도우)`,
"label.forecast.settings.data":`예측 일자`,
"label.knowledgebase.modifiedby":``,
"label.batchadd.remark":`여러개 기록을 추가할 수 있습니다`,
"button.partner.delete":`삭제`,
"Pagelayout_Setup_005":`명칭을 첫째 자리에 설정해야 합니다`,
"label.forecast.edit.wcpxl":`제품 계열 없음`,
"lable.PowerProcess.seq.input":``,
"pagecreator.layout.message.delete.fail":`레이아웃 삭제 실패`,
"label.emailobject.edit":`편집`,
"label.weixin.million":`만위안`,
"setup.mainpage.button.manageobject":`대상자 관리`,
"label.weixin.participants.perfect.information":`참여자에게 정보 보완을 요청할 지 여부`,
"vue_label_campaign_campaign_members":`마케팅 행사 멤버 추가`,
"label.ccchat.person.invite.emplaceholder":`메일 주소를 입력하고 반구절점으로 구분합니다.`,
"label.mobile.phone.new":`신규 추가`,
"font-evaluate-module-v1-small-program-evaluation-settings":``,
"UG.opportunity.005":`다종 판매 프로세스`,
"vue_label_report_polymerization":`통합`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`{0}번째 행의 조건이 잘못되어 필드 유형이 매칭되지 않습니다!`,
"label.knowledgebase.delete.draft":``,
"label.mr.descreption.condition3":`규칙 - 완전히 매칭하는지 여부: 이 옵션을 선택하면 같은 필드의 데이터를 보고 중복된 데이터를 조회합니다.이 옵션을 선택하면 앞의 몇개 문자에 따른 입력이 비활성화됩니다.`,
"Lead.Auto.Scoring.Setting":`잠재 고객 자동 채점 설정`,
"label.marketing.channel.default":``,
"front-project-module-v1-select-projecttemplate":``,
"front-email-payment-select-area":``,
"lable.PowerProcess.message":``,
"label.weixin.free.get.captcha":`인증번호 무료 획득`,
"label.projectManagement.please.select.task.or.question":``,
"label.pacific.daylight.time":`태평양 서머타임`,
"label.sendsms.batch.step1.introduce":`다음 뷰의 하나를 선택합니다(이 문자의 수신인 포함).`,
"label.same.analyze.account.name":`고객 명칭`,
"Homepage.Contract.FieldMissed.DoesntSupport":`계약서에서  "qdrq" 와 "htje" 필드를 찾을 수 없어 데이터가 없습니다.`,
"label.partnerCloud.orderingPlatform.noProduct":``,
"label.totalsummary":`누적 합계`,
"label.partner.workspace.tab":`메뉴`,
"label.entitlement.process.name.unique":``,
"report.label.norole":`관련 권한이 없으며 시스템 관리자에게 연락하시오!`,
"label.password.old.error":`입력한 구 비밀번호가 잘못되었습니다`,
"lable.account.quarter.stadate":`회계 분기 시작일`,
"label.salescloud.contactrole.choose.correct":`중복된 연락담당자를 선택해 수정하세요`,
"label.schedulejob.setup.schedule.day":`일`,
"label.communalusergroup":`공공 사용자 그룹`,
"label.Display.Fields":``,
"label.marketsea":``,
"label_partner_setup_address":`파트너 클라우드 주소`,
"label.industrialandcommercialverification.label.url":`링크`,
"lable.data.exp.newtemp":`데이터 내보내기 및 템플릿 제작`,
"label.pc.ui.2018":`세로 메뉴`,
"label.version.free":`무료버전`,
"label.dataimport.contact.length":`에러: 연락담당자 이름 길이가 한계를 넘었습니다.`,
"label.cy.vlidate":`화폐 종류를 사용한 후 되돌릴 수 없으며 화폐 종류 관리 기능을 사용하시겠습니까?`,
"label.recycle.all":`전부 휴지통`,
"label.message.changeaccount.isnot":`연락담당자가 협력 파트너 사용자를 사용하여 고객 정보를 변경할 수 없습니다`,
"label.searchlayout.exactsearch":`안내: 검색 필드 뒤의 체크 상자를 체크하여 해당 필드에 대해 정밀 검색할 수 있습니다.`,
"label.file.size.limit":``,
"label.mobileapp.modelsetting1":`모바일기기 추천 기능 모듈 설정`,
"template.report.overall.sales.opportunities":``,
"label.password.update.success":`비밀번호 변경 성공!`,
"label.import.page3.gobackhome":`메인화면으로 이동`,
"label.phone":`전화`,
"label.detail.vlidaterule":`인증 규칙 보기`,
"label.weixin.input.usernames":`사용자명을 입력하세요`,
"label.icon.85":`변압기`,
"vue_label_systemSettings_partner":``,
"label.processsetting.new.process":``,
"Lead_Scoring_Setting_Rule_Setup_01":`잠재 고객 채점 규칙 리스트`,
"setup.layout.component.area":`구역`,
"label.createnewpwdinformuser":`새 비밀번호를 생성하여 사용자에게 즉시 통지합니다`,
"label.pwinfo":`비밀번호 정보`,
"label.imgfield.type.url":`이미지 인용`,
"label.attendance.sxccheckincy":`마케팅 행사 멤버 출석`,
"lable.PowerProcess.condition.input":``,
"label.partnerCloud.partnerAccount.topUpFailure":``,
"label.document.size.too.long":`파일 크기가 한계를 초과했습니다`,
"label.link":`방문 링크`,
"label.partnerproduct.sort.repeat":``,
"label.data.setok.e_desc2":`데이터 내보내기 리스트 페이지`,
"front-project-module-v1-plase-input-project-name":``,
"label.export":`내보&nbsp;&nbsp;내기`,
"label.icon.45":`보일러`,
"label.autoRegister.changepwd.title":`로그인 비밀번호를 설정합니다`,
"label_clear_adjust":`조정 삭제`,
"front-kefu-moudle-return-visit":``,
"label.ems.compose":`메일 쓰기`,
"Pagelayout_Setup_002":`3개 관련 리스트를 선택했으며 계속 선택하면 페이지 레이아웃에 영향을 줄 수 있습니다`,
"label.service.gantt.skill.screening":``,
"label.partnerCloud.basicSetting.enable":``,
"label.workbanch.setup.description":`다음 뷰를 나의 작업공간에서 보기 여부를 설정할 수 있습니다.`,
"label.category.1":`전부`,
"label.foldername":`폴더 명칭`,
"label.forecast.settings.shuliang":`수량 예측`,
"label.emailmerge.newtemplate.word":`word 파일을 업로드하십시오!`,
"message.error.type":`type를 입력하고 public 공공 유형이나 인원 private를 전송하세요!`,
"label.manualallocation":`수동 분배`,
"label.addattachment.step2":`3단계. '파일 업로드' 버튼을 클릭하여 파일을 업로드 합니다`,
"label.company":`회사`,
"label_emailsync_status_export":`Excel_csv 형식의 파일로 내보내기`,
"label.eventreminder":`이벤트 알림`,
"label.emailtemplate.lookup":`메일 템플릿 보기`,
"label.customsetting.touse.getCustomSetting":`'등급 구조'유형의 사용자 설정 데이터를 검색해 대응한 apiName과 권한(id가 프로필id나 사용자id)의 한개 데이터로 돌아갑니다Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":``,
"label.appointment.wizard.subtitle4":``,
"label.donot.close.your.browser":`이 과정에 다른 링크를 클릭하거나 Web 브라우저를 닫지 마세요`,
"label.multilang.customforcast.target":`{0}의 목표`,
"setup_layout_label_newarea":`구역 새로 만들기`,
"component.timeline.button.more":`더 많은 절차`,
"label.appointmentdetail.wizard.title3":`지속 시간`,
"label.help.new.features.pc":`PC 새 기능 조작 매뉴얼`,
"label.mr.record":`기록`,
"label.trigger.wgd":`미보관 트리거`,
"label.icon.72":`도구 상자`,
"setup.layout.label.detailpage":`상세 페이지`,
"frame.personinfo.label.usethisimage":`응용 프로그램 주변에 해당 축소도의 변형도가 사용된다.`,
"label.multilingual.confirm.open":``,
"label.recordcreater":`기록 작성자`,
"label.afterfinish":`완성한 후 '저장 및 새로만들기'를 클릭하여 더 많은 사용자 설정 필드를 생성할 수 있습니다. 생성을 완성한 후 '저장'을 클릭합니다`,
"label.companyinformation":`회사 정보`,
"step1":`1단계`,
"label.sales.page.dashboard.add":`홈페이지 대시보드 추가`,
"label.processsetting.process.enabled.failed":``,
"label.document.history.date":`일자`,
"label.linkedin.title":``,
"label.foldervisitlimit1":``,
"april":`4월`,
"label_emailsync_form_disconnect":`연동 취소`,
"label.appointment.wizard.subtitle4-2-6":`2일`,
"vue_label_notice_follow_success":`팔로잉 성공`,
"label.startuploadfile.success":`"업로드 시작"버튼을 클릭하여 프로그래스바가 100%에 도달하면 파일이 업로드 성공하여 위에 구역에 없어집니다`,
"message.accesstoken.acquisition.failed":``,
"label.quickbooks.fieldlabel.fistname":`명`,
"label.appointment.wizard.subtitle1-5":`1시간`,
"2018UI.Homepage.DataNoAccess.Info":`이 기록에 대해 방문 권한이 없으며 클릭하여 뒤로 이동합니다.`,
"label.batchaddattachments":`첨부파일 모두 추가`,
"label.ems.next":`다음`,
"label.quote.zhekou":`할인`,
"lable.product.notdel":`의 삭제, 다른 가격 매뉴얼의 기록과 연결되어 있기 때문입니다.관련 기록은 아래와 같습니다.`,
"label.ems.action":`조작`,
"message.error.chart.type":`차트 유형을 입력하세요!`,
"label.conditiontag.lookup.value":`값`,
"label.chatter.allactivity":`모든 행사`,
"label.summaryreport":`종합 보고서`,
"label.textmessage.vonage.action":`조작`,
"label.ccpeak.must.result":`as별명만 결과에서 추출할 수 있습니다`,
"label.data.newtemplate.savetemp.desc":`편하게 사용할 수 있도록 템플릿 명칭과 템플릿 내용을 자세히 입력하세요.`,
"label.projectManagement.search.for.users":``,
"component.milestones.label.title":`이정표`,
"vue_label_applauncher_description_accountpool":`고객풀을 사용하여 조직 내 고객의 팔로우업 상태를 관리하며 인력이 거래를 성사시킬 수 있도록 격려한다.`,
"label.import.index.startimport":`불러오기 시작`,
"page.field.masterinput2":`마스터 슬레이브 입력`,
"label.mobile.change.owner.permission":`신 소유인이 해당 유형의 기록에 대해 읽기 권한이 있어야 합니다`,
"label_partner_common_enable":`파트너 클라우드 사용`,
"label.log.browser":`브라우저`,
"label.app.step4":`4단계. 메뉴를 선택합니다`,
"lable.quote.syncing.opportunity":`업무기회`,
"label.forecast.customforecast.foredis.jqz":`정확치`,
"label.forecast.forecastroleuserpage.title":`예측 매니저 분배`,
"label.starting.quarter":``,
"label-combination-record":``,
"label.here":`여기`,
"label.weixin.underfind.error":`알 수 없는 오류`,
"label.cloudccclass.list.tip.time":`개발자가 CloudCC.com 플랫폼에서 타이머 클래스를 개발할 수 있도록 허용되며 이 타이머 클래스들이 타이머 프로그램에 적용됩니다.`,
"label.data.setok.t_desc1":`이 템플릿으로 데이터를 내보내려면 클릭하세요`,
"label.service.gantt.break.rules":``,
"label.weixin.no.pending.ywjh.qin":`미래 30일에 업무기회 데이터가 없습니다`,
"label.view.atleastone":`선택항목 리스트에 최소 1개 값이 있어야 합니다`,
"label.attendance.sxccheckin":`마케팅 행사 현장 출석`,
"label.custom.split":``,
"front-kefu-moudle-v1-yesorno-delete-templete":``,
"label_chatter_theme":`주제`,
"label.partner.new.step1":`1단계: 원하는 템플릿을 선택합니다`,
"vue_label_commonobjects_view_settings":`간판 뷰 설정`,
"UG_Contract_02":`계약서는 각자 간의 서명적인 협의입니다. 많은 회사들이 계약서를 통해 다른 회사와의 업무 왕래 조항을 정의합니다. CloudCC를 통해 고객과 업무기회 간의 계약서를 생성하고 이에 대해 파일을 제공합니다. 승인 프로세스를 통해 계약서를 팔로우업합니다. 업무 프로세스 알림을 사용해 계약서 연장 기간을 알려줍니다.`,
"label.setup.mobilesetup.isenableh5newandedit":`단말기가 H5를 사용해 새로 편집 여부`,
"label.attendance.edit":`출석 체크 수정`,
"label.service.miniProgram.fillImageLink":``,
"label.b.c.without":`'B'기록에 관련 'C'기록이 있거나 없을 수 있다.`,
"label.sso.key":`승인 번호`,
"label.star_click":`클릭하여 리셋`,
"vue_label_SMS_name_or_phone_number_lookup":`기록 명칭 검색`,
"label.case.copre.text":``,
"label.salescloud.forbidden.confirm":`그룹 세일즈 사용 계속 금지하시겠습니까?`,
"vue_label_chat_conformactivation":`개설 확인`,
"label.emailtocloudcc.redmessage9":`데이터 베이스에 오류 발생, 관리자에게 연락하시오`,
"label.sahreto":`에게 공유`,
"label.recordtype.sort":`기록 유형은 저장된 순서대로 표시됩니다.`,
"label.allreport":`모든 보고서`,
"front-gantt-module-drag-and-drop-subtask":``,
"label.permission.objlist.nopermission":`방문 권한 없음`,
"label_file_num":`수량`,
"chatter.mostword":`최대 500개 글자까지 입력 가능하니 삭제 후 다시 발표해 주세요`,
"label.h5.chatter.comment":`논평 본문`,
"vue_label_calendar_notice_havecreated":`캘린더를 생성하였습니다.`,
"label.tabpage.loadz":`로딩 중이니 잠시만 기다리세요.`,
"chatter.w.p":`업무전화`,
"label.chat.topic.name.desc":`주제 명칭의 대소문자와 간격만 변경할 수 있습니다`,
"label_partner_template_name":`템플릿 명칭`,
"label.mobile.phone.required.examines.people":`검토인은 필수 입력 항목입니다`,
"message.error.view.notexists":`뷰가 존재하지 않습니다</br> 다른 사용자가 이 뷰를 수정했을 수 있습니다.<a href='javascript:history.back();'를 클릭하여</a>뒤로 가기`,
"label.custom_time":``,
"label_partner_workspace_member_all":`모두`,
"lable.custom.year.name":`사용자 설정 연도 명칭`,
"label.account.previous.M":`지난달`,
"vue_label_commonobjects_detail_locking":`잠기기`,
"label.brief.lead":`잠재고객`,
"label.linkedin.setting.appsecret":``,
"label.query.detail.closepartner":`협력 파트너 사용 금지`,
"label.isEnableVisualpage_new.rightlist":`사용된 사용자 설정 페이지`,
"front-epwechat-module-v1-unbound-item3":``,
"label.exchange.sync.setting.info":`Microsoft Exchange에서 사용자에게 아날로그 권한이 있는 서비스 계정을 만든 후, 서비스 계정의 증빙을 입력하여 CloudCC가 Exchange 서버와 통신할 수 있도록 합니다.서비스 계정의 증빙을 저장했는데도 사용자가 기록을 동기화할 수 없다면, Exchange Sync가 올바르게 설정되어 있는지 확인하십시오.`,
"label.emailobject.groupemail.fail.title":`CloudCC 메일 모두 전송 실패 메일 주소`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":``,
"label.visualpage.list.vpname":`사용자 설정 페이지 명칭`,
"label.mask.length.error.message":`암호화된 텍스트 필드 길이가 255를 초과할 수 없습니다`,
"label.h5.approval.actorname":`발기인`,
"label.knowledgebase.view.translation":``,
"label.ems.edit":`편집`,
"vue_label_commonobjects_view_reset_width":`열 넓이 재설정`,
"label.version.feature.controllist":`기능 제어 리스트`,
"label.setuppagelayout":`페이지 레이아웃`,
"vue_label_commonobjects_view_new_view":``,
"label_tabpage_queuez":`대열`,
"label.direct.dashboard.wait.me.approval":`나의 승인 대기중인 프로젝트`,
"message.report.error.noRelatedField":`보고서에 관련된 필드가 없어 삭제될 수 있음으로 시스템 관리자에게 연락하세요.`,
"label.ccchat.person.invite.notme":`본인의 메일 주소로 초대를 전송할 수 없습니다.`,
"label.weixin.jieduan.finish":`현 단계를 완료로 표시합니다`,
"vue_label_commonobjects_detail_?enter_subject":`주제를 입력하세요`,
"label_starting_month":`시작 월별`,
"label.address_linetwo":``,
"message.error.select.contiguous.item":`선택한 관련 항목이`,
"vue_label_pricebook_enterbookname":`가격 매뉴얼 명칭을 입력하세요`,
"label.cycleworkflowoperate":`주기적인 업무 프로세스 조작`,
"label.ems.withoneday":`당일`,
"component.todaytask.label.notask":`오늘 마감 업무가 없습니다. - 이 틈에 커피 한잔 즐기시죠.`,
"label.tianyancha.id":`회사 ID`,
"label.user.illegal.login":`불법 로그인입니다!`,
"label.withgathercondition":`통합 조건에 따라`,
"label.foldervisitlimit":`방문 권한`,
"label.ccchat.search.conversation":`이 대화를 검색하기`,
"lable.annual.project.report":``,
"template.chart.qzkhzhfx":``,
"label.my":`나의`,
"label.sendsms.batch.chosetemplate":`대량 문자 메시지 보내기: 템플릿을 선택하거나 문자 내용을 편집합니다`,
"label.callcenter.enterprise.number":``,
"label_last_modified_by_time":``,
"message.fieldtrack.operaterecord":`<b>operatefield</b>를 <b>operateold</b>에서 <b>operatenew</b>로 변경합니다`,
"label.mobile.more.openin":`열기 방식`,
"label.multilingual.tip2":``,
"label.datamanage.lead.novalue":`주의: 이번 불러오기 작업은 "잠재 고객 명칭" 필드에 값을 부여하지 않았습니다. 연락담당자 기록은 불러오지 않습니다!`,
"label.custom.revoke":``,
"label_chatter_leaveword":`댓글`,
"vue_label_ccchat_group_deletedgroup":`해당 그룹이 삭제됨`,
"label.tabpage.operationz":`필드 작업이 필요합니다`,
"label.user.organization.permit.overdue":`조직 허가증이 기간이 만료되어 관리자에게 연락하세요!`,
"label.log.datetimeoruser.value":`조회시간, 사용자명을 입력하세요!`,
"lable.product.stsp.noavailable":`사용할 수 있는 표준 가격이 없습니다`,
"label.appservice.cannot.delete.app":`사용자 설정 응용프로그램을 삭제할 수 없습니다.일부 프로필은 이 사용자 설정 응용프로그램을 기본 응용 프로그램으로 사용하고 있습니다.`,
"component.event.label.newevent":`이벤트 새로 만들기`,
"label.view.sortview.exportview":`뷰 내보내기`,
"label.uploadfilemaxsize":`업로드 가능한 최대 파일 크기가`,
"label.event.weekview":`주일 뷰`,
"label.conversion_rate":``,
"label.partnerCloud.partnerAccount.useWechat":``,
"UG_Forcast_05":`예측 설정: {0}/{1}단계`,
"label.service.gantt.jobresour":``,
"vue_label_campaign_fromopprotunities":`{dsrjine}개 진행 중인 업무 기회에서 옴`,
"label.app.skyblue":`하늘색`,
"label.chinacloudcc":`중국 클라우드 컴퓨팅`,
"label.connectOtherFinalNumber":`대상 한계 도달<br />최대 네 개의 대상을 사용자 설정 보고서 데이터 소스와 연결할 수 있습니다.`,
"label.redistributionrequest":`승인 요청을 다시 분배합니다`,
"label.knowledge.category.button.one":``,
"label.campagin.pcandmo":`PC와 모바일기기`,
"label.project.milestone.date":``,
"assetbom.transfer.notpermission":``,
"label.marketing.setting1":`마케팅 채널`,
"label.select.file":`파일 선택`,
"message.error.object.contactadministrators":``,
"label.custom.quarter.title":`사용자 설정 분기`,
"label.knowledge.case.settings":``,
"front-service-cloud-transfer-title":``,
"label.group.search.searchthisfeed":`검색 내용을 입력하시오`,
"label.report.action.addtodashboard5":`새 대시보드로 추가`,
"label.mobile.side.tab.remark2":`슬라이딩 메뉴를 설정할 때 자주 사용한 항목을 앞에서 설정합니다. 통화 기록, 메뉴 항목이 CloudCC 모바일기기 Android버전에만 적용됩니다`,
"contain":`포함`,
"label.select.template":`템플릿 선택`,
"label.addattachment.step3.weixin":`3단계. "완성"버튼을 클릭하여 이전으로 반환합니다`,
"lable.Order.successfully":``,
"label.user.title":`직무`,
"label.weixin.check.agreement":`관련 협의를 체크하세요`,
"label.SMS.pfi":`핸드폰번호 필드`,
"label.weixin.micro.research":`리서치`,
"label.projectManagement.assigned.work":``,
"label.document.login.error":`로그인이 실패하였습니다. 다시 한 번 로그인을 시도해 주세요.`,
"label.mobile.phone.examines.people":`검토인`,
"label.safetyset":`안보성 설정`,
"label_function_tip":``,
"label.app.sort":`응용프로그램 정렬`,
"component.sendmail.label.cc":`참조`,
"label.titlename":`제목`,
"label.event.moveup.3day":`3일을 앞당깁니다`,
"label.condition":`조건`,
"label.description.message":`비고 글자수가 500개를 넘을 수 없습니다.`,
"label.ems.detailedsettings":`상세 배치`,
"label.repeat.condition.field.prompt":`'버튼 앞의 몇개 문자부호'필드에서 숫자 한개를 입력하세요!`,
"label.validate.function.funcExplain.OR":`모든 파라미터가 참인지를 점검하며 TRUE 나  FALSE로 돌아갑니다 모든 파라미터가 거짓인 경우에만FALSE로 돌아갑니다.`,
"label.salecommit.allow.prediction.query":`[설정]>[나의 개인 정보]>[개인 정보]에서 예측 허용 선택항목을 체크하지 않아서 세일즈 약속 간판을 볼 수 없습니다.`,
"front-kefu-moudle-soft-phone":``,
"label.view":`뷰`,
"front-gantt-module-quick-create-task":``,
"label.all_forms":``,
"front-lightning-module-v1-dashborad-statistical-dimension":``,
"label.forecast.settings.data.chanpin":`제품 일자`,
"label.appointment.wizard.subtitle4-2-7":`3일`,
"front-web-module-v1-detail-comment-please":``,
"label_chatter_nextSevenday":`미래 7일`,
"homepage.components.desctiption":`이 페이지는 홈페이지 레이아웃에 표시된 구성 요소를 만들거나 편집할 수 있도록 합니다.`,
"label.customcomponent.page.index.table.namespace":`명명 공간 앞자리`,
"label_emailtocloudcc_exists":``,
"label_tabpage_save":`저장`,
"label.mergeRechecking":``,
"vue_label_helpcenter_view2":`분할 화면 뷰에서 데이터마다의 상세 정보를 전환하고 확인할 수 있다. <br>3.마케팅 데이터의 빠른 분석 <br> 뷰의 우상측에서 뷰 내부 차트를 열어 뷰 내부의 데이터에 대해 간단한 가시화 분석을 할 수 있다. 뷰의 데이터와 관련된 대시 보드 및 보고서 리스트를 보고 깊이 있는 분석을 할 수 있다. <br> 우상측의 차트 버튼을 클릭하여 뷰 데이터로 만든 간단 차트를 확인, 생성, 편집할 수 있거나 현재 뷰와 관련된 대시 보드를 볼 수 있다. <br> 1단계: 우상측의 차트 버튼을 클릭하여 페이지 내부 차트를 펴서 권한에 따라 현재 차트를 확인하고 관리할 수 있으며 뷰 데이터와 관련된 대시 보드 리스트를 확인할 수 있다. <br>2단계: 설정 버튼을 눌러 권한에 따라 차트를 생성, 편집, 삭제할 수 있다. 수직 막대 차트, 수평 막대차트, 원형 차트 및 퍼널 차트 4가지의 차트를 만들 수 있다. <br>? 보고서 버튼을 눌러 현재 뷰와 관련된 보고서를 볼 수 있다. <br>4. 뷰에서 데이터를 관리한다 <br>? 뷰에서 권한에 따라 뷰의 우상측의 버튼이나 데이터 옆을 클릭하여 데이터를 생성, 편집, 삭제 및 소유인 변경 등 동작이 가능하다. <br>? 라벨로 데이터 관리를 협조한다. 우측의 버튼을 통해 라벨 관리 리스트를 열어 라벨대로 뷰의 데이터를 선별할 수 있다. 라벨 관리를 클릭하여 라벨 베이스를 관리할 수 있다. 데이터를 선정한 후 우상측의 라벨 추가 버튼을 사용해 데이터에 대해 대량 라벨 추가할 수 있다.`,
"label.app.ismobile":`모바일기기에 응용하기`,
"chatter.group.changeTheGroupPicture":`그룹 프로필 사진 변경`,
"label.mr.descreption.reDataList2":`개 기록에서 조회한 모두 조건을 만족하는 중복 데이터`,
"vue_label_chatter_agree_join":`가입 동의`,
"label.planned.nextrun":`다음 계획 운행`,
"Homepage.News.003":`고객 데이터가 없으며 뉴스 표시가 안되며 고객이 생성된 후 여기서 고객 뉴스를 볼 수 있습니다.`,
"label.summaryreport.selectpictype":`차트 유형 선택 및 기타 차트 선택항목`,
"label.app":`응용프로그램`,
"label.trigger.name":`트리거 명칭`,
"vue_label_email_private_template":`개인 템플릿`,
"label.appointmentpage.wizard.subtitle1":`일자와 구체적인 시간을 선택하세요. 초대자의 표준 시각대는 {0}`,
"label.partnerCloud.orderingPlatform.payment":``,
"label.stdashbord.xsld.title":`세일즈 퍼널`,
"vue_label_pool_poolname":`고객풀 명칭`,
"label.ServiceCloud.fuwuyuyue.distributionMap":``,
"front-lightning-module-v1-dashborad-target-value":``,
"label.reportsSubscriptionPage.email.keywords":`키워드 입력한 후 검색하기`,
"label.appointmentconfirmail.wizard.subtitle1":`이벤트 명칭`,
"label.limited_scanning":``,
"label.weixin.nomore":`더 이상 없음`,
"february":`2월`,
"label.view.filterbyowner":`소유인으로 선별하기`,
"label.contentType":`파일 확장명`,
"label.customobjdel.master.hsiang":`대상에 마스터 디테일 관계 필드가 있어 삭제할 수 없습니다.`,
"lable.Removal.succeeded":``,
"label.weixin.end.incorrect":`종료일 형식이 잘못됐습니다`,
"label.email.cc.recipients":`참조 수신인`,
"label.taskevent.list":`업무 이벤트 리스트`,
"label.formula":`공식`,
"label.h5.new.errorheader":`이 페이지의 오류를 점검합니다`,
"label.emailobject.template.private":`사유`,
"label.visualpage.component.n4":`4. 변수. 변수를 직접 사용할 수 있어 작은따옴표가 없어야 합니다`,
"label.newemailnotice.step1":`1단계: 대상을 선택합니다`,
"label.chatter.file":`파일`,
"vue_label_checkduplicate_rules":`중복 검사 규칙 설정`,
"label.appointment.wizard.subtitle1-6":`1.5시간`,
"label.customReportType":`사용자 설정 보고서 데이터 소스`,
"vue_label_email_with_accessories":``,
"label_efine_assessment_cycle":``,
"label_emailtocloudcc_button_sure":`확인`,
"label.forecast.userenablepage.isusing":`사용자 사용`,
"lable.goal.description":``,
"message.error.serviceresource.relatedrecordid":``,
"label.weixin.addbus.information":`차량 정보 추가`,
"label.emailtocloudcc.button.view":`보기`,
"label.detail.workflow":`업무 프로세스 보기`,
"label.standardfilter":`표준 필터`,
"label.mobile.phone.results":`실적`,
"chatter.feed.unavailabled":`미사용`,
"label.view.sortview":`뷰 정렬`,
"label.availabilityobject.wizard.title":`유휴시간`,
"Main_Menu_Mobiledownload":`에 적용함`,
"chatter.sticker":`팔로우업 중`,
"label.workflow.intruduce":`업무 프로세스 규칙을 생성으로 조직의 업무 프로세스를 배치합니다. 업무 프로세스 포함 내용:`,
"label.customfields.richtext.tip":`사용자가 텍스트, 그림과 링크를 추가할 수 있도록 합니다.`,
"label.new.cy.select":`선택항목 리스트에서 새 화폐 종류를 선택합니다`,
"template.chart.schdzqzkhzhqk":``,
"label.forecast.customforecast.cpxl":`제품 계열`,
"front-electronic-signature-open-service":``,
"label.datamanage.import.field":`필드 불러오기`,
"chatter.email.sendMessageToMe":`나한테 메시지를 보낼 때`,
"message.cannotusebefore":`승인 과정의 사용을 작동시킬 때까지 이 승인 과정을 사용할 수 없습니다.`,
"label.textmessage.vonage.api.secret":`API기밀`,
"label_chatter_newEvent":`이벤트 새로만들기`,
"label.ji.year":``,
"label.sendmail.step2":`2단계: 메일 템플릿을 선택하십시오`,
"label.console.step5.record":`기록 열기`,
"label.customfields.totalsummary.gettogetherfield.isnull":`통합할 필드를 선택하세요`,
"vue_label_commonobjects_detail_current_recorder":`신 소유인이 해당 프로젝트 관련 기록의 소유인이 되어 이 기록은 현재 기록자가 소유합니다.`,
"label.SMS":`문자 통지`,
"label.reconfigure.bundle":``,
"front-kefu-select-region":``,
"chatter.feed.deletefeeds":`해당 게시물과 주석을 삭제하시겠습니까?`,
"label.customsetting.manage.introduce.h":`사용자 설정이 등급 구조라면 사용자, 프로필에 데이터를 추가할 수 있습니다.예를 들어, 특정 사용자인지, 특정 프로필인지, 일반 사용자가 응용프로그램을 실행 중인지에 따라 값을 다르게 표시할 수 있습니다.`,
"label.product.name":`제품 명칭`,
"vue_label_commonobjects_view_saveas":`다른 이름으로 저장`,
"label.group.my.archived":`나의 문서 보관 그룹`,
"vue_label_pool_coflictmethods":`기존 마케팅 방식 거부`,
"label.appupload.upload":`업로드`,
"lable.SalesCommitmentKanBan.signedTaskRate":`계약체결 업무율`,
"label.dashboardStandard":`표준 대시보드`,
"label.niboer.time":`네팔 시간`,
"label.emailtocloudcc.filed.email":`메일`,
"market.name.social.post":``,
"evaluation.detail.notfound":``,
"label.layoutoftestobj":`테스트 대상 레이아웃`,
"label.example":`예시`,
"label.campaign.channel.step6.remark6":`여기를 방문하세요`,
"chatter.emailLike":`좋아요`,
"label.knowledge.category.button.two":``,
"label.alluser":`모두 사용자`,
"addadvancedconditions":`고급 선택항목 추가`,
"message.selectgsummarycondition":`통계 조건을 선택하세요`,
"message.duplication.label.sectionremar2":`주의: 모든 관련 기록에 포함된 비고, 첨부 파일 및 행사들은 새로운 병합 기록과 연결됩니다.`,
"vue_label_helpcenter_product&pricebook":`제품은 판매하고 있는 모든 프로젝트, 서비스 및 이의 표준 가격의 기초 목록이다. 가격 매뉴얼을 통해 특정 사용자에 대해 제품 및 관련 리스트 가격의 설정 집합을 새로 만들 수 있다.`,
"message.duplication.label.isprofile":`권한 통과 여부`,
"component_setup_label_milestonesfield":`이정표 필드`,
"setup_layout_label_required":`필수 입력`,
"component_chatter_label_title":`최신 게시물`,
"label.assignment.setup.detail.order":`순번`,
"vue_label_pool_unassigned":`미분배`,
"UG_Lead_007":`Google 동기화`,
"label.knowledge.record":``,
"label_tabpage_filetypez":`파일 유형`,
"label.ccpeak.if.error.message":`오류 메시지로 돌아가면: 사용`,
"label.intialsubmitter":`최초 제출인`,
"label.wei.icon":`아이콘`,
"label.mask.show.last.4":`마스크 끝자리 4개 보기`,
"lable.PowerProcess.time.trigger":``,
"july":`7월`,
"label.usestandardwizard":`표준 설정 안내 메뉴 사용`,
"label.two.quarter":``,
"label.size":`크기`,
"label.integrations.mailchimp.massage4":`Mailchimp가 배치되지 않았습니다. 통합 설정으로 Mailchimp에 권한을 부여하세요`,
"label_emailtocloudcc_step2total3":`2번째 단계, 총 3단계`,
"vue_label_chat_customer_group_strategy":`고객 채팅`,
"label.searchvalue":`찾으려는 값`,
"label.sendemail.birthday.title":`생일 알림`,
"label.projectManagement.planned.days":``,
"label.service.gantt.workhours":``,
"label.notification.approval5":`대리 승인: [제출자]가 [대상] 승인을 요청하고 있습니다`,
"label.service.miniProgram.bindAddressDesc":``,
"chatter.error.wt":`에러: 정확하지 않은 파일 유형!`,
"vue_label_calendar_my_calendar":`나의 캘린더`,
"label.customername":`고객명`,
"label.salescloud.salesdashboard.huikuan.rankings":`전체- 판매 대금회수 실적 랭킹`,
"message.query.opportunity.contactrole.error":`업무기회 연락담당자 기본 역할 조회 실패하여 관리자에게 연락하세요`,
"noequal":`부등어`,
"label.document.searchcustominfo":`매칭하는 파일을 찾으려면 키워드를 입력하십시오`,
"label.account.PreviousFQ":`지난 회계 분기`,
"label.file.f":`파일`,
"label.dashboard":`대시보드`,
"label.report.folder":`보고서 폴더`,
"batch.edit.permission.list":`데이터 리스트 편집 권한 없음`,
"label.file.orderbyowner":`소유인대로 정렬합니다`,
"label.exchange.sync.account.password":`서비스 계정 비밀번호`,
"pagecreator.button.publish":`발표`,
"label.modify":`편집`,
"label.exchange.sync4":`상태`,
"label.remark.information":`비고 정보`,
"label.service.without.major.event":``,
"label.knowledgebase.release.status":``,
"label.tabpage.ok":`확인`,
"label_screening_assessment_content":``,
"label_partner":`파트너 클라우드`,
"label.user.detail":`사용자 보기`,
"front-kefu-moudle-or-this":``,
"label.unselect.object":`선택 가능한 대상`,
"label.quote.contactfax":`팩스`,
"label.weixin.appmanage.alert":`{0}을 누르면 나의 응용에서 제거할 수 있고 {1}을 누르면 나의 응용에 추가할 수 있습니다.`,
"vue_label_dashboard_thisfolder":`공용 대시보드를 폴더에 추가하기`,
"label.delete":`삭제`,
"label.appexchange.installedpage.message1":`CloudCC.com AppExchange에서 응용프로그램을 열람하고 직접 CloudCC.com 환경으로 다운로드할 수 있습니다.`,
"label.mobile.phone.required.summary":`총정리는 필수 입력 항목입니다`,
"label.batchadd.newbatchpage.addtr":`최대 30건 기록을 추가할 수 있습니다.`,
"label.partnerCloud.partnerAccount.lockLine":``,
"label.emailsync.status.connectstatus":`연동 상태`,
"label.campaignmember.main.importmember.lead":`멤버 불러오기- 기존 잠재고객`,
"message.username.isnull":`사용자명을 비워둘 수 없습니다!`,
"label.forecast.tree.enableuser":`사용자 사용`,
"label.multilang.view.viewmessage":`이 뷰가 모바일기기에 사용되어 최대 10개 필드를 선택할 수 있으며 현재 {0}개:`,
"friday":`금요일`,
"label.sendemail.activity.neweventtitle":`새 이벤트 알림`,
"label.page.addtabto.user":`사용자의 기존 개인 설정에 메뉴를 추가합니다`,
"front-kefu-moudle-v1-connect-phone":``,
"label.wei.pollis":`로 투표`,
"lable.opppdt.editPdt.title":`업무기회 제품 편집`,
"label.permission.objectpermission.recordfenpei":`기록 유형 분배`,
"pagecreator.layout.message.delete.success":`레이아웃 삭제 성공`,
"label.dataimport.isdupecatcher":`중복률 검사 필터 실행`,
"label.deletelayout.tip":`페이지 레이아웃을 삭제하려면 다른 페이지 레이아웃을 선택해 대체해야 합니다.`,
"label.projectManagement.No.matching.data":``,
"pagecreator_page_message_delete_success":`페이지 삭제 성공`,
"label_tabpage_equalz":`같다`,
"label.ems.emailsetup":`메일 설정`,
"label.decimaldigits":`소수 자릿수`,
"component.chatter.button.delete":`삭제`,
"label.isallowreport":`보고서 허용 여부`,
"label.view.appliedMobile.message":`이 항목을 체크합니다. 3단계. 최대 6개 보기 필드를 선택할 수 있습니다`,
"label.must.positive.integer":`자연수여야 합니다.`,
"label.preview.print.template":``,
"label.schedulejob.setup.schedule.start":`시작`,
"UG.Case.04":`개인안 분배`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`호버 상세 정보 사용`,
"vue_label_email_alltemplates":`모든 템플릿`,
"label_report_chose_obj":`대상 관계 및 보고서 데이터 소스를 선택하십시오`,
"label.partnerCloud.productSet.del":``,
"label.quote.shrdz":`수령인 주소`,
"page.approval.history":`승인 이력`,
"lable.outlook.detail.prefc":`1순위 선택 CloudCC.com`,
"label.translation.unable.display.view":`뷰를 볼 수 없습니다`,
"label.encrypt.change":`암호화 필드 전환`,
"button.partner.workspace.login.logo.upload":`이미지 업로드`,
"label.batchadd.mustinput2":`필수 입력 항목이며 필수 입력 항목을 입력하지 않으면 해당 기록이 저장되지 않습니다`,
"label.dataimport.update.error.check":`데이터 업데이트하는 데 오류가 발생하여 데이터를 점검하세요`,
"label.staticresource.name.already.exists":`정지 리소스의 유일한 명칭이 존재합니다!`,
"label.appupload.upload.install.success":`설치 성공`,
"label.conditiontag.lookup.true":`참`,
"label.quickbooks.viewlist.customer":`고객`,
"label.field.edit.change2":`최대 평점이 최소 1입니다`,
"label.fianalrejectoperate":`최종 거부 조작`,
"label.ccpeak.wgd":`미보관 클래스`,
"label.reportsSubscriptionPage.condition.emailreport":`총결산 보고서`,
"label.detailinf":`상세 정보`,
"label.eastem.standard.time":`동부 표준 시간`,
"chatter.group.manager":`관리자`,
"label.manage_columns":``,
"label.daylight.time":`서머타임`,
"label.weixin.mycar.information":`나의 차량 정보`,
"label.ccpeak.help":`클래스 도움말`,
"lable.outlook.detail.match":`매칭 조건`,
"label.version.nonsupport.approval":`승인과정은 잠시 지원하지 않습니다!`,
"label.custom-tailor":`고객 맞춤형`,
"label.showoperate":`조작 표시`,
"label.view_edit":``,
"label.lead.score.prompt2":`잠재 고객에게 채점하는 범위를 선택하세요. [잠재 고객 채점]버튼을 클릭하여 시스템이 활성화된 채점 규칙으로 선택한 잠재 고객에게 채점합니다.`,
"label.datamanage.savetemplate.error":`템플릿을 저장할 수 없습니다!`,
"label.source":`출처`,
"label.multilang.customfieldsetup.reference":`이 필드가 {0}에 인용되었습니다:`,
"chatter.poll.option7":`선택항목 7`,
"label.login.access.day":`일`,
"label.icon.66":`기구`,
"label.tabpage.kanbansetup":`간판 설정`,
"label_emailtocloudcc_step1_lead2":`배치한 후 메일함에서 받은 메일이 자동으로 잠재고객 기록을 생성하여 모든 비즈니스 기회를 빠짐없이 확보합니다.`,
"label.partnerCloud.partnerAccount.numericValue":``,
"label.permission.detail.app.object.tip":`대상 및 필드의 방문 권한과 메뉴 가용성에 관한 설정`,
"label.emailobject.template.subject":`주제:`,
"template.report.month.customer":``,
"label.weixin.formerly":`과거`,
"label.contract":`계약서`,
"label.help":`도움말`,
"vue_label_homepage_setdefault":`기본 홈페이지로 설정하기`,
"label.icon.52":`발전`,
"label.customfields.file.count":`파일 개수`,
"UG_Account_07":`고객 불러오기`,
"label.addattachment.ntko":`온라인 편집`,
"label.service.ganttBaiduMap.assign.service":``,
"vue_label_file_my_file":`나의 파일`,
"label.custom.page.hide":`숨기기`,
"label.addexistoperate":`기존 조작 추가`,
"label.already.startdate":`시작된 시간`,
"label.partnerCloud.financeSetting.alipay":``,
"label.dashboard.summary.editPageFooter":`페이지푸터 편집`,
"label.category.8":`소비품`,
"label.forecast.customforecast.foretype.best":`평상시보다 잘하십니다`,
"message.validation.isnull":`값을 입력하세요`,
"label.savewxpay.failure":``,
"label.file.stop.sharing.desc1":`에 종료됨`,
"label.opportunity.setting.showstage。read.info":`체크한 후 업무기회 단계를 수동으로 편집할 수 없습니다`,
"UG_Campaign_003":`마케팅 행사 생성`,
"label.edit.field.select.showoptions":`모든 옵션 보기`,
"message.inputplatformpwd":`플랫폼 관리자 비밀번호를 입력하기`,
"vue_label_systemSettings_mobel_set":``,
"label.projectManagement.thefirstone":``,
"label.data.newtemplate":`데이터 내보내기 템플릿 만들기`,
"label.monitorsys.delete.log":`시스템 중점 조작 감사 일지`,
"label.template":`템플릿`,
"Lead.Auto.Scoring.Setting.001":`잠재 고객이 저장되거나 편집될 때 자동 채점된다.(모두 불러오기 및 포트 새로 만들기가 이에 포함 안 된다)`,
"label.operatesuccess":`조작 성공`,
"label.send":`전송`,
"chatter.yp":`게시물 숨기기`,
"label.overall_responses":``,
"vue_label_systemSettings_server_report":``,
"label.icon.113":`주택`,
"label.partnerCloud.basicSetting.domainSet":``,
"label.login.access.text":``,
"vue_label_report_addrowlevelformula":`행 수준 공식 추가`,
"message.duplication.label.mergeTitle":`'나의' 병합`,
"label.event.add":`이벤트 추가`,
"vue_label_homepage_bigscreen_light":`연한 색`,
"setup.chatter.enabled":`아직 사용되지 않아 관리자에게 연락하여 게시물을 사용하시오.`,
"label.inputreceiver":`최대 5개 통지를 보낼 메일주소를 입력할 수 있어 메일 주소 간에 ";" 로 간격을 줍니다.`,
"label.custom.page.custom.page":`사용자 설정 페이지`,
"label.data.exp.csv":`CSV 형식`,
"label.searchlayout.view.example":`예시 보기`,
"label_tabpage_fullscreenz":`풀스크린`,
"label.tabpage.last":`이전`,
"lable.outlook.mcto.accepemail":`수신 가능한 메일 주소`,
"front-electronic-signature-isopen":``,
"vue_label_commonobjects_detail_earlier":`이전 이력 조회`,
"label.name.cannot.greater.str":`명칭이 255개 문자를 초과할 수 없습니다`,
"label.weixin.activity.email":`행사: 메일`,
"label.tabpage.unequalz":`같지 않다`,
"label_calendar_year":``,
"label.appupload.upload.installor":`설치자`,
"label.jixiaoswitchon":`실적 펼쳐보기`,
"label.user.congratulations.send.finish":`축하드립니다. 대량 메일 발송 신청 작업이 완료되었습니다.`,
"label.customsetting.touse.getListCustomSetting2":`'리스트'유형의 사용자 설정 데이터를 조회하여 대응한 apiName과 Name의 데이터를 반환합니다Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`마스터 기록 유형을 이미 다른 기록 유형이 분배된 프로필에 분배할 수 없습니다.`,
"label.tippage.li3":`삭제된 보고서에 기반한 모든 대시보드 구성 요소를 무력화합니다`,
"label.weixin.no.name":`주제 없음`,
"label.tabpage.viewz":`뷰 인쇄`,
"label.create_contacts":``,
"vue_label_homepage_operationitem":`버튼 작업 항목을 선택하세요`,
"label.pc.ui.2018.switch.version":`버전 전환`,
"label.salescloud.teamrole.main":`주요 연락담당자 여부`,
"label.reportsSubscription.format.report":``,
"label.forecast.customforecast.total":`총액`,
"label.quickbooks.fieldlabel.lastname":`성`,
"label.appointment.wizard.title2":`회의 상세 정보`,
"label.project.template.one":``,
"label.timetrigger.workflow":`이 업무 프로세스를 사용 시`,
"label.projectManagement.creator":``,
"label.customfields.formula.selectreturnfieldtype":`공식의 반환 필드를 선택하세요`,
"label.list.userinterface.dashboard.enable":`새 대시보드 구성요소 사용`,
"label.email.delete.html.format":`모든 HTML 형식이 삭제되며 확인하시겠습니까?`,
"label.appupload.install.modifyapi":`충돌하는 api 명칭을 수정합니다:`,
"label.chat.add.topics":`주제 추가`,
"label.savepartner.fail":``,
"label.pc.query.new":`최신 보기`,
"message.duplication.label.editfiltertitle":`중복율 검사 필터 편집`,
"label.task":`업무`,
"label.emailobject.emaildetail.title.toaddress":`전송:`,
"label.setup.mobile.bottombutton.select":`모바일 단말기에 나타나는 홈페이지 4개를 선택하세요`,
"label.loginip.pagecue.invalido":`무효 Internet 주소`,
"label_tabpage_listshow":`리스트 보기`,
"component.newrecords.label.10records":`기록 10개`,
"label_chatter_file":`파일`,
"pagecreator.systemstyle.label.detailcolor":`명세 글자 색깔`,
"label.forecast.userenablepage.title":`사용자 예측`,
"front-project-module-v1-actual_working_hours":``,
"vue_label_systemSettings_Security":``,
"label.processsetting.two.select.key.fields":``,
"label.page.display1":`기록`,
"label.appointmentpage.wizard.subtitle1.2":`초청자의 시각대는{0}`,
"label.ggReleaseRange.searchTeam":``,
"chatter.group.searchGroup":`그룹 검색`,
"label_card_type":``,
"label.appupload.managed.tip":`피관리는 일부 속성만 편집할 수 있는 것을 의미합니다.`,
"label.changemyshow":`나의 보기 변경`,
"label.custom.CustomQuarter":`사용자 설정 분기`,
"label.tobedelete":`삭제할`,
"label.newPage.unuse":`페이지를 열 수 없습니다.`,
"label.product.pricebooks":`가격매뉴얼`,
"label.mobile.layout":`모바일 페이지 레이아웃`,
"label.multilang.file.items":`{0}개 프로젝트:`,
"label.app.step4.tabused":`선정한 메뉴`,
"label_ccchat_create_account":``,
"message.startusingprocess":`이 승인 과정을 사용하면 승인 절차를 추가하거나 삭제할 수 없습니다.일부 승인 절차 속성은 편집할 수 없습니다.계속하시겠습니까?`,
"vue_label_email_please_add_a_theme":`주제를 추가한 후 템플릿으로 저장하세요.`,
"label.please.create.a.target.record.first.":``,
"label.processsetting.set.objandfile":``,
"label.newreport.group.data":`개 그룹`,
"label.notcreatenew":`전환 시 신규 업무 기회를 생성하지 마십시오.`,
"lable.custom.CurrentandPreviousCY":`현재 및 지난 사용자 설정 연도`,
"front-epwechat-module-v1-input-androidschema":``,
"label.projectManagement.unfinished.quantity":``,
"label.visualpage.idandname":`페이지 id와 name 명명:`,
"label.approvingprojects":`승인 대기 프로젝트`,
"label.partnerCloud.financeSetting.weChat":``,
"label.quickbooks.viewlist.view":`보기`,
"label.knowledge.category.hint.ten":``,
"report_type_label_productPricebooks":`제품과 가격매뉴얼`,
"label.fenbeitong.description":`FENBEITONG 출장 신청 보고서를 체크 및 사용으로 직원의 출장 신청 및 출장비 결제를 도와줍니다.`,
"label.ccchat.upload.change":`무엇을 변경했습니까? (선택 가능)`,
"label.emailsync.status.log":`관련 일지`,
"label.addnew":`신규 추가`,
"UG_contact_05":`연락담당자 생성`,
"label.appupload.componet.queryerror":`구성 요소를 조회하는 중 오류가 발생했습니다. 관리자에게 연락하십시오.`,
"label.salescloud.setting":`그룹 판매 설정`,
"label.recurrencetimetriggeroperate":`주기성 시간 트리거 조작`,
"label.event.moveup.4day":`4일을 앞당깁니다`,
"No.Hisitory.Activity":`이력 행사가 없습니다`,
"label.validate.function.funcFormat.MINUTE":`분(일자)`,
"label.recentview.seloption3":`나의 최근 수정`,
"label.login.access.nopermission":`--방문 권한이 없음--`,
"label.taskmenuandlink":`업무 버튼과 링크`,
"label.forecast.customforecast.foredis.sbw":`수 백만`,
"lable.PowerProcess.created.event":``,
"label.stdashbord.xsld.funnelchat":`세일즈 퍼널 이미지`,
"label.step1.total7":`1단계, 총 7단계`,
"label.sendsms.batch.chosepersion":`문자 대량 발송: 문자 수신인을 선택하십시오`,
"Lead.Scoring.Setting.Rule.Setup.Value":`점수`,
"label.ccdocument.isdel.folder":`해당 폴더를 삭제하시겠습니까?`,
"label.discard_change":``,
"label.knowledgebase.assign":``,
"PersonalInfo_LoginHistory_001":`웹 브라우저 인증 메일 등록 링크`,
"label.globalselect.deletedvlaue":`전체 값 세트가 삭제되었습니다`,
"label.ems.lookup2":`찾기`,
"label.dataimport.system.unable.determine":`시스템에서 유실 부분을 확인할 수 없습니다`,
"label.weixin.invitation.consultant":`초대 고문`,
"label.salescloud.salesdashboard.phone.rankings":`전화 랭킹`,
"label.knowledgebase.plan.release":``,
"label.integrations.first.half":``,
"label.icon.123":`구급상자`,
"label.leadscore.isactivity":`활성화 여부`,
"front-epwechat-module-v1-corpid":``,
"label.createnewcustomer":`새 고객 생성`,
"front-lightning-module-v1-details-page-chart-tittle":``,
"label.customobjects.fieldsrelation":`사용자 설정 필드와 대응 관계`,
"label.dashboardSetup.left":`좌`,
"label.mobile.app.sectionpart":`모바일기기 부분`,
"setup.mainpage.label.welcome25":`작업 매뉴얼: 본 페이지 좌측 메뉴를 클릭하여→관리 설정→안보성 통제→설정 공유.`,
"label.custombutton.edit.error":`에러: 해당 명칭이 이미 사용되거나 전에 사용된 적이 있어 다른 명칭을 선택하세요.`,
"label.icon.48":`선풍기`,
"label.tabularreport.step2":`2단계: 보고서 열을 선택합니다`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`둘째 주일`,
"UG_quota_01":`고객 견적 관리`,
"label.customcomponent.btn.usewhere":`어디에다 사용하시겠습니까?`,
"label.quickbooks.searchresault.email":`메일`,
"label.emailobject.appointment.urltext2":`적당한 시간을 선택합니다`,
"label.tianyancha.field.relation.error":`TIAN YAN CHA 필드와 고객 필드의 매핑 관계를 설정하세요`,
"APPIntegration_Social_facebookerror":`합법적인 facebook.com의 URL이어야 됩니다.`,
"label.notification.arketsea.transfer":`{5}가 {0}：{1}를 {2}에서 {3}으로 이동시켰습니다`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`총대금 수령 업무율`,
"UG.Account.04":`피동 고객 검색 선별`,
"this.week":`이번주`,
"label.email.track.attachment.num.control1":`현재 업로드된 파일의 개수가 10개가 넘어 업로드할 수 없습니다.`,
"label.exchange.sync.state.event":`이벤트`,
"vue_label_systemSettings_websitesetting":``,
"vue_label_file_replace_reason":`교체 이유`,
"label.version.feature":`기능`,
"E":`메일`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`통지 템플릿`,
"label.chosesubject.meet":`회의`,
"UG.ST.003":`{0}를 새로 만드는 권한이 없으며 관리자에게 연락하시오. 확인을 누른 후 바로 {0}인터페이스로 이동한다.`,
"label.authorization.failure":``,
"label.newprocessstep3":`3단계 승인자 필드와 기록 편집성 속성을 지정합니다`,
"lable.outlook.mcto.mostrecord":`가장 많은 행사를 보유한 기록`,
"vue_label_normal_select":`선정`,
"label.partner.workspace.login.buttontext":`버튼 텍스트`,
"template.chart.ydschdtj":``,
"label.ServiceCloud.zichanmingcheng":``,
"label.productsales.oppor.nooverdue":`잘하셨습니다. 당분간 만료된 업무기회가 없습니다`,
"label.appointment.wizard.subtitle3-5":`금요일`,
"label.payment.the.current.version":`현재 버전`,
"label.reportlist.top":`상단 고정`,
"label.emailobject.emaildetail.prompt":`안내`,
"label.weixin.endst":`종료시간이 시작시간보다 늦어야 합니다`,
"report_label_knowcreatehighlevelreport":`고급보고서 제작 더 알기`,
"label.quickbooks.view.openestimates":`진행중인 추산`,
"label.url.cannot.empty":`URL을 비울 수 없습니다!`,
"label.emailnoticetemplate":`메일 알림 템플릿`,
"calendar.tips.task":``,
"label_partner_all_operate":`조작`,
"message.duplication.label.cancelbutton":`취소`,
"vue_label_SMS_addcontact":`연락담당자 추가`,
"label.martrixreport.setsumfield2":`행렬 보고서에 통계열로 사용될 필드를 선택합니다`,
"approval_request_email_body":`안녕하세요, 아래 항목에 대한 승인을 요청합니다：\n      다음 링크를 클릭합니다：\n`,
"label.emailobject.emaildetail.field.record":`기록`,
"label.tab.page":`페이지`,
"label_tabpage_prepagez":`페이지 보기`,
"label.iran.daylight.time":`이란 표준 시각대`,
"label.event.nextweek":`다음주`,
"fliter.lastmonth":`지난 달`,
"label.group.no.recent.search":`매칭된 최근 보는 그룹이 없습니다.`,
"label.h5.act.confirm":`확인`,
"label_tabpage_mypotentialcustomers":`나의 잠재고객`,
"label.tabpage.queuez":`대열`,
"label.batch.edit.description":`편집할 필드를 선택하며 최소 1개 필드, 최대 5개 필드를 선택해야 합니다.`,
"label.batchadd.newbatchpage.deltr":`최소 한 행을 유지하세요`,
"label.industrialandcommercialverification.instructions2":`현재 사용하는 버전은 무료 버전이며 인터페이스에 하루 최고 검색횟수는 1만번이며 검색 횟수를 늘릴려면 서비스를 구매해야 합니다. 서비스를 구매한 후 공급업체에게 token를 획득한 후 본 페이지에서 배치하여 공급업체는 관련된 유료 서비스를 제공합니다.`,
"label.rejectrequestbehaviour":`이 절차의 모든 거부 조작<strong>과</strong> 모든 최종 거부 조작을 실행합니다.(최종 거부)`,
"label.batchCopy":``,
"label.service.two":`일부 선별 조건이 정의되었으며 \'고급선별조건'\에 인용되지 않았습니다.`,
"label.data.import.setup.detail.remark":`다음의 선택항목을 선택하면, 데이터를 가져올 때 실행합니다`,
"vue_label_file_delete_lib":`파일 베이스 삭제`,
"label.integerdigit":`소수점 왼쪽 숫자의 자릿수`,
"label.profile.standardobjcontrol":`표준 대상 권한`,
"label.reportrecords":`개 기록`,
"label.noplan":`미래 7일에 일정이 없습니다`,
"label.visualpage.ytype":`대시보드`,
"label.branch":`;`,
"label.knowledgebase.new.article":``,
"label.Addressbook":`주소록`,
"label.delete.reward.groups":``,
"label.appexchange.uninstallpage.message1":`이 소프트웨어 패킷에 모든 구성요소 영구 삭제(예시가 다음과 같음)`,
"chatter.group.everyone":`모든 사용자`,
"label.cooperation":`협력`,
"label.uploadfail":`업로드 실패`,
"to":`로`,
"button_partner_delete":`삭제`,
"attachment_select_warning_001":`보관을 체크한 첨부파일, 보관 버튼을 사용할 수 없어 첨부파일을 다시 선택하세요.`,
"label.step4.total4":`4단계, 총 4단계`,
"label.login.access.avalid":`오늘 무효됩니다`,
"label.defaultview2":`기본 뷰`,
"vue_label_commonobjects_detail_style":`구매 스타일`,
"label.selectfield":`필드 선택`,
"label.report.select.column.collect":`통합할 열을 선택합니다`,
"lable.currencyAdv.newdaterate.existeddate":`해당 시간이 존재합니다`,
"pagecreator_systemstyle_button_new":`양식 새로만들기`,
"label.ccchat.person.invite":`동료 초대`,
"label.sendemail.recycle.clear":`휴지통 비우기`,
"label.usermanage.view.notexist":`뷰가 존재하지 않습니다`,
"setup_chatter_enabled":`비활성화되어 있습니다. 관리자에게 연락하여 게시물 기능을 사용하십시오.`,
"UG.Contract.01":`계약서 관리`,
"label.martrixreport.2018.step4":`4단계: 보고서 기준을 선택합니다`,
"message.errorinscript":`실행 스크립트에 문제가 생겼습니다!`,
"label.knowledgebase.modification.date":``,
"label.projectManagement.the.maximum.number.of.fees.is.10":``,
"label.list.isActiveNewApproval":`새 시작페이지 승인 페이지 사용 여부`,
"label.mobile.main.page.icon.setup":`모바일기기 바탕화면 아이콘 설정`,
"label.select.customer":``,
"label.sharerule":`공유 설정`,
"label.fiscal.FY":`회계 연도`,
"label.appupload.component.type.customfield":`사용자 설정 필드`,
"label.emailobject.emailsend.sendindividually":`개별 전송`,
"label.new_formname":``,
"label.appointment.wizard.notif1":`종료 시간이 시작 시간보다 늦어야 합니다`,
"front-console-conversation-evaluate-desc":``,
"homepage.components.lasttime":`최후 수정 시간`,
"vue_label_commonobjects_view_chart_deletechart":`차트 삭제`,
"label.multilang.document.upload.fail":`파일이 {0}개 업로드되었습니다. {1}개 파일이 업로드 실패했습니다.`,
"UG_contact_03":`한 곳에서 연락담당자를 팔로우업합니다. 마케팅 신호`,
"label.marketsea.istoseafromother":`다른 고객풀이 이월 허용`,
"label.datamanage":`데이터 관리`,
"label.globaloperation.operationtype.create.data":`기록 생성`,
"label.customer.tab.step2.see":`메뉴 시각성`,
"label.wtd.changefields.desc":`사용자가 차트를 제출한 후 사이트에서 지정된 반환 URL을 보일 겁니다. 예. '감사합니다' 페이지.`,
"label.ems.eamilinfo":`메일 정보`,
"label.recordtypeselect.new":`새 기록 유형`,
"vue_label_report_output":`공식 출력 유형`,
"label.emailnotice":`메일 통지`,
"label.icon.196":`휴지`,
"label.emailsync.status.disabel":`금지 사용`,
"label.tabpage.isdeleterecord":`선정된 기록을 삭제하시겠습니까?`,
"message.selectoneoftypes":`다음 유형의 하나를 선택하세요`,
"label.import.index.createid":``,
"vue_label_systemSettings_social2":``,
"label.ccpeak.sel.time":`이 폴더의 타이머 클래스`,
"label.data.downpage.i_list.desc1":`불러오는 중 데이터 형식이 올바르지 않거나, 트리거나 인증 규칙에 인증 실패하여 불러오지 못한 데이터는 현재 페이지에 csv 파일을 생성합니다.성공적으로 불러온 데이터는 현재 페이지에 표시되지 않습니다.`,
"label_adjust_forecast":`예측 사항 조정`,
"vue_label_normal_lead_sf":`잠재 고객`,
"vue_label_report_notice1":`보고서에서 저장되는 않은 변경이 포함되어 보고서를 닫으면 변경이 유실됩니다. 밑에서의 ' 저장 및 닫기' 버튼을 눌러 변경이 저장됩니다.`,
"label.notfiledpublicreport":`미보관 공용 보고서`,
"one":`1`,
"UG.Lead.008":`명함 스캔`,
"label.archived":`문서 보관됨`,
"label.standardabstractfield":`표준 요약 필드`,
"vue_label_notice_add_fail":`추가 실패`,
"label.sendemail.registIMUser.addresserror":`메일 수신인 주소가 잘못되었습니다`,
"label.ccdocument.toolbar.switch":`툴바 전환`,
"first":`첫째`,
"label.icon.147":`마우스`,
"vue_label_jihui_er":``,
"label.ccchat.micropost.isedit":`게시물과 댓글 수정`,
"label.department.next":`다음 페이지`,
"front-kefu-moudle-confirm-disable-phone-user":``,
"label.reportsSubscription.time.meets.subscription.frequency":``,
"lable.account.NextpDays":`미래 120일`,
"UG_opportunity_007":`연락담당자 역할`,
"label.encrypt":`암호화`,
"label.knowledge.category.hint.three":``,
"label.customcomponent.usewhere.info":`다음은 이 구성요소에 대한 인용입니다. 인용 라벨을 클릭하여 정의를 확인합니다.`,
"vue_label_import_addandupdate":`추가 및 업데이트`,
"label.email.all.members":``,
"component_task_button_save":`저장`,
"label.file.deleted.unavailable.desc":`해당 파일이 삭제되어 없거나 미리보기 할 수 없습니다`,
"label.emailsync.status.viewlog":`일지 확인`,
"label.marketsea.othersetup":`기타 설정`,
"label.data.exp.newtemppage":`템플릿 제작 페이지`,
"vue_label_lead_score_successsful":`채점 성공`,
"label.sendemail.activity.newtask":`존경하는 #belongtoidccname안녕하세요：\r\n  동료분 #createbyidccname #createdate에 님에게 새 업무를 분배했습니다. 내용이 다음과 같습니다：\r\n  주제：#subject\r\n  만료일：#expireDate\r\n  관련 항목：#relatedstr\r\n  내용：#remark\r\n  상세 정보는 다음 링크를 방문하시길 바랍니다：\r\n #path\r\n                        #orgNameCRM시스템`,
"component.event.label.soon":`즉시`,
"label.forecast.shrepage.getlist":`예측 등급 구조로 돌아가기`,
"UG.solution.02":`솔루션은 고객의 관련 문제를 해결하는 기구 내부 해결방안이다.`,
"label.weixin.data.approval":`기록이 승인중입니다`,
"label.build.pagelist":`페이지 빌더 페이지 리스트`,
"label.customsetting.type.hiberarchy":`등급 구조`,
"label.forecast.ccfh":``,
"label.Current.Window":`기존 윈도우`,
"label.appointmentdetail.wizard.title20":`일요일 시간 계획`,
"label.emailaddress":`메일 주소`,
"label.qetting_notifications":``,
"Homepage.News.001":`뉴스`,
"label.runreport":`보고서 실행`,
"label.customer.tab.step3":`3단계 사용자 설정 응용 프로그램에 추가합니다`,
"label.dashboard.snapshot.refresh":`새로고침`,
"label.approvepagelayout3":`레이아웃 배치`,
"vue_label_SMS_send_messages":`메시지 전송`,
"label.executestate.old":`실행됨`,
"label.approvalstep3":`3단계 분배한 승인자를 선택합니다`,
"label.step3.total6":`3단계, 총 6단계`,
"front-kefu-moudle-v1-delete-templete":``,
"label.data.downpage.e.title.num3":`3. 사용자가 필요에 따라 템플릿을 제작하여 내보낼 수 있으며 데이터를 내보낼 때 템플릿 내보내기를 누른 후 빠른 내보내기 작업이 가능하다.`,
"label.attendance.outer":`외근`,
"setup_layout_button_selectall":`모두 선택`,
"chatter.photo.img":`파일 최대 크기가 2M입니다.`,
"front-dynamiclayout-module-v1-required":``,
"label.mytask":`나의 업무`,
"label.edit.customerinfo":`회사 프로필 업데이트`,
"label.processsetting.process.explain":``,
"label.emailobject.subject":`주제`,
"label.mobileapp.scansetting.message":`실제 사용 시나리오대로 스캔된 명함을 이미지 형식으로 기록의 관련 리스트 '비고 및 첨부 파일'에서의 저장 여부를 선택합니다. <br>사용: 체크한 후 기록을 저장하는 동시에 명함이 자동으로 기록의 첨부 파일에 저장됩니다. <br>금지 사용: 체크한 후 기록만 저장됩니다.`,
"front-epwechat-module-v1-android-autograph":``,
"label_component_helper_potentialcustom":`오늘 분배된 잠재고객`,
"label.projectManagement.nodata.week.work":``,
"label_tabpage_rolez":`역할`,
"label.importsourcestep4":`3단계: 파일을 불러옵니다`,
"label.icon.50":`나침반`,
"lable.service.prompt":`필드 개수가 한계를 넘어 생성할 수 없습니다`,
"label.campaign.channel.input.page":`웹 페이지를 지정하여 일반적으로 행사 페이지를 감사 페이지로 설정할 수 있습니다.`,
"UG.homepage.001":`더 짧은 시간 안에 더 많은 거래를 성사시킨다`,
"label.step4.total6":`4단계, 총 6단계`,
"label.partner.required":`에러:도메인 명을 입력하세요`,
"label.tag.manage.title":`라벨 관리-{0}`,
"label.data.downpage.i_title.num1":`1. 시스템은 일반적인 CSV 형식만 지원합니다.`,
"label.custom.quarter.end":`사용자 설정 분기 종료일`,
"label.layout.distribute":`페이지 레이아웃 분배`,
"label.version.allsms":`단체 문자 전송`,
"label.tolead":`불러오기`,
"label.texttemplate.usemergefields":``,
"label.emailobject.sure":`확인`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`모바일기기에 H5 새로만들기 편집 사용 여부`,
"label.tabpage.messagez":`메세지를 입력하세요`,
"label.mobile.phone.write.day.report":`일보 쓰기`,
"label.data.setok.e.desc2":`데이터 리스트 페이지 내보내기`,
"label.emailsync.message":`안내`,
"label.sales.page.mubiao":`목표 달성`,
"label.ccdocument.list":`최신 파일 보기`,
"label.tabpage.userGuidez":`사용자 매뉴얼`,
"label.report.fields":`보고서에 사용 가능한 필드`,
"vue_label_checkduplicate_at_same_time":`모두에 적합하기`,
"label.sms.phone":`문자 메시지 게이트웨이 고객 상담 전화`,
"UG_ST_004":`관리 데이터가 없습니다 -》데이터 불러오기 권한, 관리자에게 연락하세요. '확인'을 클릭한 후 {0}인터페이스로 이동합니다.`,
"label.mobile.nobindmobile":``,
"label.partnerCloud.basicSetting.intro":``,
"label.trigger.targetobject":`목표 대상`,
"label.ems.emailsyncperiod":`메일 동기화 시간 간격`,
"lable.Transformation.mode":``,
"label.emailobject.new.template":`템플릿 생성`,
"label.System.Setting":``,
"label.emailtocloudcc.button.addemailaddress":`기업 메일 주소 추가`,
"lable.a.total.of.invoices":``,
"label.multilang.customforcast.forecasthistory":`{0}의 예측 이력`,
"label.role":`역할`,
"advancedconditions":`고급 선별 조건`,
"label.tabpage.beginz":`시작`,
"label.campagin.roi.khzhsl":`고객 전환 수량`,
"chatter.poll.option5":`선택 항목5`,
"label.weixin.horse.club.registered":`AID-MAX 회원 가입`,
"frame_personinfo_label_resizeimage":`섬네일을 조절하여 드래그 앤드 드롭으로 프로필 사진 위의 점선을 조절하세요.`,
"label.file.share.select.warning":`이에 대해 공유를 설정했습니다!`,
"label.event.this.week":`이번주의 이벤트`,
"label.data.import.object.label":`대상 라벨`,
"label.visualpage.folder":`미보관 페이지 폴더`,
"vue_label_report_saveandclose":`저장 및 닫기`,
"label.newdashboardpage.saveto":`저장`,
"label.partnerCloud.financeSetting.developerIDTwo":``,
"lable.PowerProcess.created.ago.please":``,
"label.chatter.myfollowers":`나의 팔로어`,
"label.campaignmember.main.duplicatelist.title":`마케팅 행서 멤버: 스캔으로 중복율 검사 설정`,
"label.group.no.recent2":`검색 그룹에 가입했습니다`,
"label.icon.110":`책`,
"label.merge.my.account":`나의 고객 병합`,
"setup.layout.button.quicksave":`빠른 저장`,
"pagecreator.page.message.canntdelete":`현재 페이지에서 삭제 불가능합니다`,
"label.report.printable.view":`뷰를 인쇄할 수 있습니다`,
"ccchat_fieldtrack_fieldchange":`{0}에서 {1}로 변경하기`,
"label.email.bcc":`비밀 메일 참조`,
"label.sso.saml.sp.idpcert":`신원 제공자 인증서`,
"label.step2.total2":`2단계, 총 2단계`,
"lable.product.pricebooks.isn":`사용한 가격 매뉴얼`,
"labal.emailtemplate.namemassage":`메일 템플릿의 유일한 명칭이 존재되어 다시 편집하세요`,
"only.one.field":``,
"label.weixin.appr.audittime":`승인 시간`,
"pagecreator.page.button.delete":`삭제`,
"front-kefu-moudle-v1-Session-start-time":``,
"label_chatter_state":`상태`,
"vue_label_systemSettings_lightningcustom":``,
"label.searchs":`검색`,
"label.mobile.phone.not.read":`미검토`,
"label_chatter_allweather":`전천후`,
"label.enter.number":`0-6 간의 정수를 입력하세요`,
"front-epwechat-module-v1-addressbook-desc":``,
"label.emailfield":`메일 필드`,
"pagecreator_button_next":`다음`,
"label.more.select.merge.records":`병합할 기록을 최대 3개까지만 선택할 수 있습니다`,
"lable.edit.queue.selobjct":`선택한 대상`,
"label.reportsSubscription.editsubscribe":``,
"label.selectfieldtoautotransmit":`자동 전송 승인에 사용한 필드를 선택합니다`,
"label.ccpeak.need.topass":`유입 필요`,
"label.checkfield.merge":`병합`,
"front-lighting-module-v1-detail-file-downlaodInfo":``,
"vue.please.enter.a.chart.name":``,
"label.data.dataexptemplate.desc3":`3.내보내기 방식이 내보내는 데이터에만 적용되며 내보내기 템플릿에 적용되지 않습니다. 내보내기 템플릿의 파일 형식이 CSV형식입니다.`,
"label.setup.mobile.homepageshortcuts.setting":`모바일기기 홈페이지 단축키 설정`,
"label.ems.connect.success":`메일 검사 성공`,
"label.applet.text":``,
"label.knowledgebase.parent.window":``,
"label_file_size":`공간 차지`,
"label.allocation.department":`사용자 분배`,
"label.browser":`브라우저`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`수요일`,
"label.integrations.description1":`현재 뷰의 모든 데이터 내보내기`,
"label.project360":``,
"label.choose_formtype":``,
"label_emailsync_status_connectstatus":`관련 상태`,
"label.bmap.beijing.city":`베이징시`,
"label.mask.encryption.scheme":`암호화 형식`,
"label.imgfield.type":`이미지 유형`,
"label.person.target.responsible":``,
"label.appexchange.installedpage.installdate":`설치 일자`,
"label.partnerCloud.orderingPlatform.partnerUsers":``,
"label.profile.customfieldsafety":`사용자 설정 필드급 안보성`,
"label.no.target.models.available.":``,
"label.process.execute.tip":`요청이 처리되었으며 대량 승인은 시간이 걸리며 시스템은 처리가 완료된 후 이메일로 알려드립니다.`,
"label.app.step2.introduce":`다음의 필드를 입력함으로써 사용자 설정 응용프로그램을 정의합니다.`,
"label.loginip.cue":`로그인 Ip 범위를 미지정합니다. 모든 Ip 주소에서 온 사용자가 로그인할 수 있게 허용합니다.`,
"label.step1.select.tablayout":`1단계: 메뉴 레이아웃을 선택합니다`,
"mainpage.setup.chosecomponent.leastone":`메인 페이지에서 최소한 하나의 구성 요소를 배치해야 합니다.`,
"label.custom.quarter.name":`사용자 설정 분기 명칭`,
"chatter.ptup.link":`링크 붙이기`,
"label.compact.layout.frame.error2":`상세 정보와 관련 리스트는 왼쪽 화면에 있어야 합니다`,
"vue_label_salesfunnel_notice7":`가능성이 100%인 업무 기회 총개수/ 가능성이 0%이나 100%인 업무 기회의 총개수`,
"label.multilang.datamanage.dataimport.lostmsg":`제목의 길이는 &nbsp;{0}&nbsp;，하지만 데이터의 길이는 &nbsp;{1}&nbsp;，시스템에서 어느 &nbsp;{2}&nbsp; 필드가 없어졌는지 확인할 수 없습니다.`,
"label.owner.notnull":`소유인을 입력하세요`,
"label.logintime.pagecue.invalidt":`시작시간이 종료시간보다 작어야 합니다.`,
"vue_label_file_checked_num_limit":`선택한 파일 개수가 한계를 초과했습니다`,
"front-email-payment-repayments":``,
"template.report.today.prospects":``,
"label.weixin.appr.status":`승인 상태`,
"label.knowledge.language.japanese":``,
"label.event.reminder.lead.time":`이벤트 미리 알림 기간`,
"lable.custom.dep":`'새로 만들기'버튼을 클릭하여 새 사용자 설정 연도를 정의합니다`,
"Dashboard_View_Createdbyme":`내가 생성한 대시보드`,
"label.file.upload.fail":`파일 업로드에 실패했습니다`,
"label.manager":`책임자`,
"label.stdashbord.xsld.business.jine":`금액`,
"label.tag.manage.tag":`라벨`,
"chatter.nlk":`싫어요`,
"label.file.search.people":`인원 검색`,
"message.error.domain.format":``,
"label.firstisdefault":`첫 번째 값을 기본값으로 설정합니다`,
"label.discount":`할인`,
"label.mobile.phone.have.read":`검토 완료`,
"label.field_selected":``,
"label.payment.renew.now":`바로 충전`,
"label.multilang.lookfiltercondition.notsetup":`제{0}행 조건이 잘못되었습니다. 연산자가 설정되지 않았습니다!`,
"label.projectManagement.Selectionday":``,
"label.user.organization.permit.licensenotstart":`조직 허가가 아직 사용 시간 전이며 허가 사용한 후 다시 시도하세요`,
"label.download.save.attachment":``,
"lable.outlook.mcto.must":`메일 형식이어야 합니다`,
"vue_label_notice_unfollow_success":`팔로우 취소 성공`,
"label.taskinfo":`업무 정보`,
"label.other.SMS":`다른 핸드폰 번호`,
"label_partner_workspace_login_logo":`쪽 머릿부분 마크`,
"label.weixin.data.lock":`기록이 잠겨 있습니다`,
"label.Yaxis":`Y축`,
"lable.edit.queue.selobjdes":`이 대열에 분배될 대상을 선택합니다. 그후 이 대상의 기록들이 이 대열에 소속됩니다.`,
"label.campagin.roi.dcfezb":`출석 점유율`,
"label.marketseamemset.maximum":`최대 수량`,
"label.owner":`소유인`,
"label.reportsubscribe.error.noview":`'다음 사용자의 시각으로 보고서를 운행하기'에서 운행 보고서의 시각을 선택하세요`,
"label.icon.133":`폴더`,
"vue_label_file_share_files":`파일 공유`,
"label.searchlayoutfilterfields.remark":`메뉴 조회나 포그라운드 좌측 메뉴 조회 시 보는 필터링 조건 필드를 선택합니다`,
"vue_label_help_contract":`계약서 및 대금 수령 계획`,
"component.chatter.button.message":`메세지`,
"label.marketsea.recyclereminddays2":`일 알림(획득한 후 미팔로우업 일수보다 적어야 함)`,
"label.webtocloudcc.input.information":`해당 정보를 입력하세요!`,
"vue_label_chatter_exit_group":`그룹 탈퇴`,
"vue_label_lead_notcreatetask":`업무 생성하지 않기`,
"front-lightning-module-v1-dashborad-date-dimension":``,
"setup.layout.label.fieldlist":`사용 가능한 필드`,
"label.leadscore.charname":`필드명`,
"label.forecast.customforecast.mybest":`나의 수준 이상 실력 발휘`,
"setup_mainpage_label_welcome24":`CloudCC 클라우드 플랫폼이 시스템 내에서 모든 대상 데이터의 안보성 방문 설정을 제공하여 각종 규칙과 조건을 설정함으로써 데이터 공유와 방문 권한을 제어합니다.`,
"label.queue":`대열`,
"label.icon.159":`칩`,
"label.path":`인용 경로`,
"label.app.message.failtoget":`응용 프로그램 리스트 열기 실패`,
"label.returntoprocess":`승인 과정 리스트로 돌아가기`,
"vue_label_commonobjects_detail_more_data":`더 많은 데이터가 없음`,
"label.number":`숫자`,
"label.product.find":`가격 매뉴얼 찾기`,
"label.legend":`도표 범례`,
"label.partner.workspace.member.profile":`선택 가능한 프로필`,
"label.service.gantt.sum.appointments":``,
"label.partnerCloud.financeSetting.paymentAllowed":``,
"label.integrations.upgrate":`업그레이드`,
"label.timzone.tip.info3":`Calendar 클래스를 사용해 일자를 처리 시 Calendar 예시에 대해 표준 시각대를 설정해야 하며 Calendar 대상을 획득하는 방법은 다음과 같이 2개를 선택할 수 있습니다.Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))와 Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`메일 계정 추가`,
"label.partneruser":`협력 파트너 사용자`,
"label.validate.globalvariable.user.roleId":`역할 ID`,
"pagecreator.layout.button.mergecell":`셀 병합`,
"label.evacuantvalue":`제외한 값`,
"label.setup.mini.msg":``,
"label.icon.178":`사람`,
"vue_label_pricebook_notice_cantbedeleted":`가격 매뉴얼 조항을 삭제할 수 없으며 이미 적용된 기록이 있기 때문입니다. 가격 매뉴얼 조항을 미사용으로 표시할 수 있습니다.`,
"vue_label_appstore_application_recommendation":`인기 응용 프로그램 추천`,
"label.version.createlimit":`현 CloudCC 버전이 {0}이며 {1}개 {2}만 생성할 수 있으며 한계에 도달했습니다! 필요하시면 CloudCC 버전을 업그레이드 하세요!`,
"message.duplication.label.sectionremar1":`병합 후 기록에 남겨질 값을 선택하십시오.하이라이트 표시된 행은 필드에 충돌하는 데이터가 포함되어 있다는 의미입니다.선택한 메인 기록은 읽기 전용과 숨긴 필드값을 보류합니다.`,
"label.icon.1":`클라우드`,
"label.salescloud.salesdashboard.sales.performance":`전체- 세일즈 계약서 실적`,
"System_AddressFieldType_Post":`우편번호`,
"setup_object_field_dependency_label_mustone":`최소 한개 종속 필드값을 설정하세요`,
"label.appointmentdetail.wizard.title6":`장소`,
"label.layout.testobj2":`테스트 대상2`,
"label.searchlayout.dupcacher.field":`메뉴의 중복 병합 링크를 클릭하여 보이는 중복 검사 필드.`,
"label.attendance.persons.title":`출석 체크에 적용한 인원을 선택하세요`,
"template.report.product.sales":``,
"label.editCustomReportType":`사용자 설정 보고서 데이터 소스 편집`,
"label.multilang.ui.setup.profile.alltime":`모든 시간은 {0}입니다.`,
"label.service.dispatchingUnits.noservice.booking":``,
"label.validate.remark4":`숫자를 특정한 범위 안에 확보합니다. 예, 할인이 30%보다 큽니다`,
"front-kefu-moudle-v1-Waiting-time":``,
"label.weipagelayout.remark":`위쳇 페이지 및 모바일기기 레이아웃에 적용합니다`,
"vue_label_wang_er":``,
"label.pw.text":``,
"message.error.user.data.null":``,
"chatter.like.p":`이 게시물 좋아요`,
"label.page.double.column.style.cloudcc":`쌍열 양식이 내용의 같은 페이지에 삽입되는 데 자주 사용한 CloudCC 기능을 제공하며 예를 들면 '검색'과 '최근 항목'.`,
"label.h5.iscloseaccount":`로그아웃 확인 여부`,
"label.dataimport.insertdata.id.error":`형식이 잘못되어 숫자와 알파벳의 조합을 사용하세요.`,
"label_tabpage_sum":`합계`,
"front-epwechat-module-v1-addressbook-sync":``,
"label.setup.mobile.offlinecache.mostsave":`플랫폼에서 최대 10개 기본 사용한 모바일기기 오프라인 메뉴를 설정할 수 있습니다`,
"label.weixin.quickcreate":`빠른 새로만들기`,
"label.forecast.edittotal.de.mubiao":`의 목표`,
"label.icon.144":`보장`,
"label.icon.155":`그림`,
"label.In.the.search":``,
"message.validation.isnotdateISO":`합법적인 일자를 입력합니다 (ISO)`,
"label.service.appointmentList.send.successfully":``,
"label.dynamicpage.error.exist":`동태 페이지의 레이아웃 데이터가 없습니다`,
"vue_label_SMS_otherpeople":`외 {0}명`,
"label.cloudccsite.url":`사이트 URL`,
"label.tabpage.contactsz":`연락담당자`,
"vue_label_commonobject_notice_clickthename":`업로드될 파일을 다운로드하려면 파일명을 클릭하시오.`,
"vue_label_file_new_lib":``,
"label.chatter.card":`카드`,
"chatter.feed.menutype.user.allusercom":`모든 인력`,
"label.exchange.sync2":`설정`,
"template.report.year.income":``,
"label.partner.template.detail":`기능 설명`,
"label.setup.service.template":``,
"label.dataimport.insertdata.id.length":`형식이 잘못되어 길이가 20자리보다 적어 기록을 점검한 후 수정하세요.`,
"label.partnerCloud.financeSetting.collaborator":``,
"label.processskipwizard":`승인 과정 이동 기점 안내`,
"label.weixin.inputbusnumber":`차량 번호를 입력하세요`,
"label.dashboardSetup.d1":`중단점 1 값`,
"template.report.conversions.number.industry":``,
"vue_label_chat_group_chat":`단체 채팅방`,
"label.file.publicview.error":`해당 파일이 삭제되거나 존재하지 않거나 미리 볼 수 없습니다`,
"label.customfields.location.locationHelpText":`"본사"와 같이 위치명을 입력하세요.설명성과 특정성을 갖추고, 하나의 기록에 여러 개의 주소가 있을 수 있는 점을 기억하세요. 예를 들면, "서해안 판매 사무실"과 "동해안 판매 사무실".`,
"message.duplication.label.blankmatchtip":`공백값이 매칭에 참여 여부를 설정하여 기본은 false입니다.`,
"message.appexchange.addtopackage":`한개나 여러개 구성요소를 선택해 이 소프트웨어 패키지에 추가하세요!`,
"label.ems.return2query":`계정 추가 찾기 페이지로 돌아가기`,
"label_model_name":``,
"label.apiname.retainapi":`name은 시스템 보류 명칭입니다. 다른 필드 Api 명칭을 사용하십시오!`,
"lable.Cancel.the.search":``,
"label.custom.viewport":``,
"label.weixin.polls.type":`투표 유형`,
"label.opportunity.setting.showstage.label":`자동 추진`,
"label_component_helper_businesschange_expiredtask":`업무기회에 이미 지나간 업무가 포함됩니다`,
"label.operator":`연산 부호`,
"label.ccpeak.use.class.time.listmap":`List<Map> 세트에 도입으로 방문합니다`,
"component_timeline_label_past":`지난 행사`,
"label.mobile.phone.submit":`내가 제출한 보고서`,
"message.recordtype.new.subtip":`신 기록 유형에 명칭과 비고를 입력합니다. 신 기록 유형에 다음 선택한 기존 기록 유형의 모든 선택 항목 리스트값이 포함됩니다. 신 기록 유형을 저장한 후 선택 항목 리스트값을 설정할 수 있습니다.`,
"UG_product_05":`제품 불러오기`,
"label.validate.globalvariable.user.id":`사용자 ID`,
"label.umeng.activity.distribute":`분배한`,
"label.weixin.avote":`투표 발기`,
"label.weixin.already.sign":`출석 완료`,
"label.emailmerge.mergepage.generator":`생성`,
"label.batchtransfer.transferto":`로 이동`,
"label.tianyancha.industry":`업종`,
"label.addattachment.name":`파일명`,
"label.customfields.formula.date.tip":`날짜를 계산합니다. 예를 들어, 다른 날짜에 일정 일수를 추가하거나 빼거나 합니다.`,
"label.partnerCloud.orderingPlatform.noPayment":``,
"label.emailobject.failedtosend":`전송 실패`,
"label.knowledge.setting.data.three":``,
"label.weixin.input.maxlength.langtext":`최대 32000개 문자를 여기서 입력할 수 있습니다`,
"vue_label_calendar_delete_calendar":`캘린더 삭제`,
"vue_label_commonobjects_detail_filter":``,
"setup.layout.group.custompage":`사용자 설정 페이지`,
"component_sendmail_label_subject":`주제`,
"label_tabpage_maxfilez":`최대 파일 크기가`,
"label.logintime.pagecue":`이 프로필을 보유한 사용자가 로그인할 수 있는 일자와 시간을 선택합니다. 주의: 모든 시간이 지정된 표준 시각대의 정확한 시간을 사용합니다. 사용자가 다른 표준 시각대에 있어도 로그인 시간이 이 정확한 시간을 사용합니다.`,
"label.salescloud.salesdashboard.datetime":`계약서 체결 예정 시간`,
"label.format":`형식`,
"label.newfoundland.daylight.time":`뉴펀들랜드 서머 타임`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":``,
"message.chooseatleastoneforshare":`최소 한 명 공유 사용자를 선택하세요`,
"label.multilang.datamanage.importobjfield":`{0}째 열`,
"label.denglu":`로그인`,
"label.popup.infoz":`안내`,
"label.schedulejob.setup.schedule.onday":`매월`,
"label.appointmentdetail.wizard.title16":`수요일 시간 계획`,
"label.userphoto.dragtoadjust":`드래그 앤드 드롭으로 사이즈를 조정함으로써 섬네일을 조정합니다`,
"label.product.series":`제품 계열`,
"message.view.kanban.not.set.group.summary.field":`뷰 간판에서 그룹분류 통합 필드를 설정하지 않았습니다`,
"page.un.activities":`미처리 행사`,
"label.exchange.sync3":`배치`,
"label.login.activityExpired":`사용자 활약도가 만료되었습니다. 시스템 관리자에게 연락하십시오.`,
"component_chatter_file_button_files":`파일 선택`,
"message.onlydelete.type":`활동하지 않는 기록 유형만 삭제할 수 있습니다. 기록 유형의 금지 사용으로 삭제를 허용합니다.`,
"message.recordtype.selectlayouttouse":`사용할 페이지 레이아웃을 선택하십시오`,
"label.knowledgebase.unable.restore.draft":``,
"label.shangqing.name":`비즈니스 정보`,
"label.weixin.target.payment":`대금 회수 목표`,
"label.chatter.sendEmailToGroupMember.check":``,
"front-kefu-moudle-v1-input-single-login-area":``,
"vue_label_zhang_yi":``,
"label.icon.190":`드라이기`,
"label.quickbooks.fieldlabel.company":`고객 명칭`,
"vue_label_email_are_you_sure_to_delete":`메일을 삭제하시겠습니까?`,
"Pagelayout.Setup.005":`명칭을 첫순위로 설정하시오`,
"label.object.name.two":``,
"label.tabpage.completez":`선택한 상태를 완료됨으로 표시한다`,
"label.setup.mobile.bottombutton.saveerror":`모바일 단말기 1급 페이지 설정 저장 실패`,
"label.report.action.addtodashboard8":`대시보드 폴더 선택하기`,
"label.data.downpage.i_list.desc3":`사용자가 다운로드한 후 파일의 마지막 열에 불러오기 실패 사유를 볼 수 있습니다.`,
"label.layout":`레이아웃`,
"label.marketsea.button.assign":`분배`,
"UG.solution.03":`솔루션 생성`,
"label.ccchat.person.invited":`동료 초대`,
"label.ccchat.person.invite.address":`수신인`,
"label.displaytype1":`상세 정보 페이지 링크`,
"label.tianyancha.h5.ziranrengudong":`자연인 주주`,
"lable.SalesCommitmentKanBan.targetReceipts":`목표 대금 수령 금액`,
"message.error.getitems.type":`getItems:type가 필수 요소입니다`,
"label.addattachment.list":`다음의 파일이 업로드되었습니다`,
"label.datamanage.export.false":`내보내는 데 오류가 발생했습니다`,
"pagecreator.systemstyle.label.buttonfontcolor":`버튼 표시`,
"label.emailtocloudcc.redmessage1":`정확한 메일 주소를 입력하시오`,
"label.weixin.polls.closed":`투표가 마감되었습니다. 마감시간`,
"label.icon.165":`모자`,
"vue_label_report_detailsonly":`상세정보만 제한됩니다`,
"component.salesperformance.label.100finish":`완료됨`,
"november":`11월`,
"label.data.file.generatejwd":`실행이 주소에 따라 경위도 서비스를 생성합니다`,
"label.salescloud.opportunity.access":`업무기회 방문 권한`,
"label.isremider.remider":`알림`,
"vue_label_total":``,
"label.email.prompt.using.lightning.link":``,
"label.knowledgebase.cancel.attached.articles":``,
"label.version.custom.xslc":`세일즈 절차를 사용자 설정할 수 있습니다`,
"component_setup_button_save":`저장`,
"label.ems.cc":`참조 추가`,
"label.edit.user":`사용자 업데이트`,
"label.emailtocloudcc.select2":`유형을 선택하시오.`,
"label.industrialandcommercialverification.fieldnumber":`매핑 필드:4개`,
"label.ccchat.havenot.joined.group":`행사 그룹에 가입하지 않았습니다.`,
"pagecreator_page_label_pagename":`페이지 명칭`,
"setup.layout.button.save":`저장`,
"label.campaignmember.main.updatestatus":`마케팅 행사 멤버 상태 대량 업데이트`,
"label.tab.web.edit":`Web 메뉴 편집`,
"label.ring_chart":``,
"label.usermanage.resetpwd.error":`비밀번호를 리셋하는 데 실패했습니다.존재하지 않는 사용자`,
"label.Xaxisscope":`X축 범위`,
"label.app.new":`응용프로그램 새로만들기`,
"message.modifythereport":`대시보드는 이 보고서를 사용합니다. 수정하면 이 보고서를 인용한 대시보드가 무효될 수 있습니다.`,
"label.component.helper.businesschange.0activity":`30일 동안 행사 없음`,
"label.weixin.fmu.noon":`점심{0}`,
"label.enter.rule.name":``,
"lable.Confirm.recovery.potential.customers":``,
"lable.PowerProcess.type.created":``,
"front-lightning-module-v1-dashbord-rectangle-size":``,
"label.projectManagement.new.service.appointment":``,
"label.multilang.totalpage2":`총`,
"pagecreator.systemstyle.label.styledesc":`양식 내용`,
"chatter.up":`업로드 중`,
"2018UI_Homepage_DataDeleted_Info":`데이터가 삭제되었으며 뒤로 이동하기를 클릭합니다.`,
"label.knowledge.draft.recordid":``,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`모든 통합 보기`,
"vue_label_file_num_limit_tip":`파일 개수가 설정된 양을 초과하여 파일을 교체하려면 이미 업르도된 파일을 삭제하세요`,
"vue_label_commonobjects_view_refreshat":`{timeInterval}전에 새로고침 되었습니다`,
"laebe.data.exp.save.success":`이 템플릿으로 데이터를 내보내려면 템플릿으로 내보내기 버튼을 반환하세요.`,
"label.mr.caption.contact":`중복 검사 병합: 연락담당자 중복 데이터의 조건 조회`,
"label.webtocloudcc.submit.error":`제출 실패`,
"label.multilang.datadelete.delmessage":`기록（{0}개）잠겨 있어 삭제할 수 없습니다:`,
"label.quickbooks.searchlist.total2":`{0}개 미관련된 결제 기록이 검색되어 총금액이 {1}입니다`,
"label.createnew":`새로 만들기...`,
"component.milestones.label.choicestate":`상태 확인`,
"lable.outlook.edit.exist":`필드명이 존재하여 유일한 필드명을 입력하세요.`,
"vue_label_dashboard_eachother":``,
"label.new.role":`역할 새로만들기`,
"message.error.operationType":`서비스를 호출할 때 정의되지 않는 논리기호를 발견했습니다.`,
"label.fenbeitong.name":`FENBEITONG`,
"label.choose.person":`전송할 인원을 선택하세요`,
"label.attendance.thanks":`참여해 주셔서 감사합니다!`,
"label.invoice.message.statusupdatefailed":`Invoice 상태 업데이트가 실패했으며 잠시후 다시 시도하세요`,
"template.chart.yzhqzkhlyfx":``,
"chatter.feed.menutype.user.alluser":`모든 인원`,
"UG_Forcast_04":`시용 시작`,
"label.appupload.upload.tips.profile":`주의: 해당 소프트웨어 패키지에 '프로필' 구성요소가 추가돼 있어 다시 추가할 수 없습니다.(한 소프트웨어 패키지에 한개 프로필 구성요소만 추가 가능합니다).`,
"lable.PowerProcess.leave.the.process":``,
"template.report.sales.cycle.opportunities":``,
"vue_label_calendar_please_fill_in_the_calendar":`캘린더 명칭을 기입하세요.`,
"label.salescloud.unit.wanyuan":`단위(위안)`,
"label.fileAPI":`파일 유일 명칭`,
"label.weixin.link":`연동하기`,
"label.service.seconds":``,
"label.encd.visible":`암호화 필드값이 보입니다`,
"label.tianyancha.regstatus":`운영 상태`,
"label.event.moveup.18hour":`18시간을 앞당깁니다`,
"label.upper.bound":``,
"label.please.insertURL":``,
"label.approval.notallowed.reject":``,
"label.permission.fieldpermission":`필드 권한 설정`,
"label.customcomponent.page.index.title":`사용자 설정 구성요소`,
"label.quickbooks.viewlist.number":`번호`,
"lable.list.queue.sendemail":`멤버에게 메일을 전송합니다`,
"label.productsales.today.noevtadd":`오늘 처리되지 않은 이벤트가 없습니다. 오른쪽 상단에 있는 ' ' 를 눌러서 이벤트 추가를 할 수 있습니다!`,
"label.report.line.daixuan":`선택 대기 중인 보고서`,
"label.reportsSubscription.select.start.endtime":``,
"template.chart.schdyscb":``,
"label.sendemail.chat.addPostatsubject":`CloudCC CCChat 게시물에서 나를 소환했습니다`,
"label.RelatedList":`관련 리스트`,
"label.knowledgebase.delete.translation.associated.with.draft":``,
"vue_label_chatter_submitted_review":`가입 신청을 제출하였으며 관리자의 승인을 기다리세요.`,
"label.layout.list2":`리스트2`,
"label.manage.area":`관리 구역`,
"label.manageapproveprocess":`승인 과정 관리`,
"workflow.action.tasks.assignortype.created":`최초작성자`,
"label.custombutton.nonsupport.operation":`현재 버전에서는 조작 표준 버튼과 링크를 지원하지 않습니다`,
"label.ip":`IP 주소`,
"label.chat.topic.desc.error.info":`주제 설명은 1000문자를 초과할 수 없습니다.더 짧은 주제 설명을 사용해 보세요.`,
"label_tabpage_cue":`메시지 알림`,
"label.integrations.mailchimp1":`통합 권한 부여한 후 조직 멤버가 잠재고객과 연락담당자를 Mailchimp로 불러올 수 있습니다.`,
"label.email.track.required":`필수 입력 정보`,
"label.set.case":``,
"label.weixin.newspaper.coverage.number":`보험 신고서 번호`,
"vue_label_approve_submitreason":`원인 제출`,
"message.oppdt.noenabledpricebook":`사용한 가격 매뉴얼이 없습니다!`,
"label.partner.workspace.setup":`설정`,
"label.version.nonsupport.feature":`이 기능은 지원하지 않습니다!필요하시면 CloudCC버전을 업그레이드 해주세요!`,
"com.cloudcc.login.error.message.licenseexpired":`허용의 기한을 넘겼습니다.`,
"label.emailsync.form.signin":`로그인`,
"label.campaign.channel.input.to.chooselanguage":`언어를 선택하세요`,
"label.tabpage.gotit":`알겠습니다`,
"front-console-no-contact-tip":``,
"label.approval.apiname":`API 및 관리 소프트웨어 패키지에 사용되는 유일한 명칭.이름은 알파벳으로 시작해야 합니다. 알파벳 숫자 문자와 밑줄만 사용하십시오.명칭은 밑줄을 그어 마무리하거나 연속적으로 두개 밑줄을 칠 수 없습니다`,
"label_emailtocloudcc_filed_ssl":`안전 연결`,
"component_sendmail_label_fromuser":`발송인`,
"front-kefu-moudle-v1-new-online-chats":``,
"label.searchlayout.merge.duplicated.results":`중복률 검사 병합 사용 여부`,
"label.weixin.input.maxlength.remark":`최대 500문자를 입력할 수 있도록 여기에 입력하십시오`,
"component.telerecord.label.related":`관련 항목`,
"label.note":`주석`,
"message.duplication.label.nletters":`개 문자부호`,
"label.productsales.payment.phb":`대금 회수 랭킹`,
"label.forecast.editshrepage.desc":`Forecast:이 기록의 공유를 지정합니다. 사용자, 특정 역할의 사용자나 특정 역할 밑의 역할의 모든 사용자와 이 기록과 관련 데이터를 공유할 수 있습니다.`,
"vue.dashboard.setPenetrationSuccessful":``,
"label.tabpage.noOperationz":`이 내용은 고정된 항목이며 작업이 불가능합니다!`,
"label.email.jump":``,
"label.appointmentpage.wizard.btn1":`예약 확인`,
"label.umeng.approval.pass":`#approver이 #obj 신청을 통과했습니다`,
"label.project.hit.twelve":``,
"two":`2`,
"label.approvedinfo":`승인 정보`,
"label.import.step1.choosecsv":``,
"vue.please.select.the.expansion.method":``,
"UG.homepage.005":`마케팅 지능`,
"Account.News.Setting.003":`일반 설정`,
"label.quickbooks.button.actions":`조작`,
"lable.list.queue.email":`대열 메일`,
"label.name.lastname":`성`,
"message.confirm":`확인하시겠습니까?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`떠나는 일자`,
"label.knowledge.setting.title":``,
"label.helptocreateprocess":`의 유효와 무효 승인 과정. 승인 과정을 생성하려면 신 승인 과정 생성을 클릭하여 '이동 기점 안내 사용'을 선택해 몇단계로 승인 과정을 설정할 수 있습니다. 혹은 '표준 안내 사용'을 선택해 모든 승인 옵션을 배치합니다.`,
"label.batcheditor.remark":`여러 건의 기록을 편집할 수 있습니다`,
"label.page":`페이지`,
"label.newfolder":`새 폴더 생성`,
"label.version.interceptor.api":`인터페이스 API`,
"label.sms.toaddress":``,
"front-kefu-moudle-noopen-callcenter":``,
"label.data.exp.zip":`압축 형식`,
"lable.account.LastcDays":`지난 60일`,
"label.import.index.starttime":`시작 시간`,
"label.dashboardall":`모든 대시보드`,
"label.create_socialpost":``,
"label.searchlayoutedit.remark":`포그라운드 좌측 메뉴 검색이나 메뉴 검색을 눌렀을 때 표시할 필드와 버튼을 선택하십시오`,
"message.servicecrew.violation":``,
"label.email.attrach.file":`파일 추가`,
"report.label.folderandreport":`보고서와 폴더`,
"label.list.userinterface.sales.setup":`시스템 세일즈 페이지 설정`,
"label.martrixreport.2018.step1":`1단계: 합계 정보 계산에 적용한 그룹분류 방식을 선택합니다`,
"label.campaignmember.selectmember.memberstatus":`마케팅 행사 멤버 상태`,
"label.textmessage.vonage.api.key":`API 비밀키`,
"label.tabpage.next":`다음`,
"UG_Lead_006":`웹사이트 방문자`,
"label.salescloud.salesdashboard.visit.rankings":`방문 랭킹`,
"label.myevent":`나의 이벤트`,
"label.activity.history":`이력`,
"label_tabpage_kanban":`간판 설정`,
"label.weixin.allapp":`모든 응용`,
"label.query.clone.detail.choose.choosed":`선택한 명세 대상`,
"message.error.view.errvalid":`에러:뷰의 유일한 명칭 필드에 밑줄과 알파벳 숫자 문자만 포함될 수 있습니다. 유일하며 알파벳으로 시작해 빈칸이 불포함되어 밑줄로 끝으로 할 수 없으며 두개 연속적인 밑줄이 포함될 수 없습니다.`,
"label.customfields.searchrelation.dependobject.tip":`이 대상과 관련된 다른 대상을 선택하십시오`,
"label.appointment.wizard.subtitle4-4-3":`3주일`,
"label.setup.mobile.offlinecache.saveerror":`모바일기기 오프라인 캐시 설정 저장 실패`,
"label.planned.started":`시작됨`,
"label.page.step4.of.step5":`4단계, 총 5단계`,
"label.tabpage.value":`값`,
"label.reportlist.allfolder":`모든 폴더`,
"label.callcenter.sure.disable.center":``,
"vue_label_commonobjects_detail_activity_tocalendar":`캘린더로 이동`,
"label.setup.mobile.bottombutton.recovery.default":``,
"label.appointmentdetail.wizard.title15":`화요일 시간 계획`,
"label.icon.15":`수리 명세서`,
"component_sendmail_label_touser":`수신인`,
"template.report.all.owner":``,
"front-Partner-email-tips":``,
"vue_label_systemSettings_mobelhomepagesetting":``,
"label.service.newBuildDialog.aswellas":``,
"label.name":`명칭`,
"label.tag.search.taglist":`라벨 리스트`,
"label.partnerCloud.priceOfManual.theOnly":``,
"label.knowledge.field.update":``,
"label.emailobject.save":`저장`,
"label.top.changeVersion":`수평형`,
"label.recordtype.edit.unselected":`사용 가능한 값`,
"label.knowledgebase.additional.articles":``,
"label.lead.score.confirm":`잠재고객에 대한 채점 범위를 선택하세요. [잠재고객 채점]버튼을 클릭하여 시스템이 활성화된 채점 규칙으로 선택한 잠재고객에게 채점합니다. <br><br> 채점 과정이 시간을 오래 걸릴 수 있어 채점 완성 후 확인 메일을 받을 겁니다. <br><br>`,
"label.projectManagement.pleaseselectadate":``,
"label.appointment.wizard.subtitle5":`회의 명칭`,
"label_setup_failed":``,
"label.chatter.collect":`저장`,
"label.appointment.cancelappointment":`예약 취소`,
"front-console-response":``,
"message.delete":`삭제하시겠습니까?`,
"label.dataimport.type.selected":`불러오기 유형을 선택하세요`,
"label.new.target":``,
"vue_label_report_autoupdatepreview":``,
"label.knowledgebase.guidance":``,
"label.chatter.mail":`이메일`,
"label.login.verification.scan.code.acquisition":`스캔으로 획득:`,
"label.customsetting.changefieldtype":`필드 유형 변경`,
"label.data.dataexpalltype.all_desc2":`2. 내보내는 데이터가 많아 시간이 걸립니다. 내보내기 완성한 후 시스템에서 내보내기 성공 메일을 보내드립니다.`,
"label.opportunity.contactisnull":`고객 정보가 비어 있어 표시할 수 없습니다`,
"pagecreator_layout_button_upload":`레이아웃 업로드`,
"label.dashboard.noRecord":`기록 없음`,
"label.SMS.template":`문자 템플릿명`,
"label.c.d.without":`'C'기록에 관련 'D'기록이 있거나 없을 수 있다.`,
"UG.Case.05":`개인안 새로 만들기`,
"front-epwechat-module-v1-edit-selfapp":``,
"label.role.createrole.tip":`이 페이지에 표시된 기존 역할 등급 구조에 따라 계속 구성할 수 있습니다.새 역할을 삽입하려면 <b>역할 추가</b>를 클릭합니다.`,
"label.grouping":`그룹분류`,
"vue_label_email_upload_new_file":`파일 업로드`,
"label.notification.event3":`님의 이벤트가 곧 [시작시간]에 시작됩니다`,
"labe_benchmark_objects":``,
"component.chatter.button.collect":`저장`,
"front-QBtoCC-sinchronies":``,
"message.submitpage.sms":`축하합니다! 문자 메시지 전송 요청 성공!`,
"label.imgfield.width":`넓이`,
"label.send_email":``,
"label.queue.list":`대열 리스트`,
"label.tabpage.fieldoptions":`유형 필드를 기록하여, 선택 항목 리스트 필드와 선택 항목 리스트(중복 선택)필드, 최대한 10개 키워드를 입력할 수 있어 영어 콤마로 띄어 관계를 표현한다. 예:'베이징, 상하이, 광저우'`,
"component.chatter.post.button.save":`발표`,
"chatter.group.groupDescriptionInformation":`그룹 내용 정보`,
"label_setup_mobilesetup_isenableh5newandedit":`모바일 기기에 H5 편집 새로만들기 사용 여부`,
"lable.Confirm.recallpotential.customers":``,
"label.knowledge.setting.hint.seven":``,
"label.emailtocloudcc.redmessage2":`정확한 메일 비밀 번호를 입력하세요.`,
"message.validation.equalTo":`같은 값을 입력합니다`,
"vue_label_help_golbal":`전체 메뉴`,
"vue_label_chatter_delete_group_title":`그룹 삭제`,
"label.user.login.success":`로그인 성공했습니다.`,
"label.chatham.standard.time":`차탐 서머타임`,
"label.vlidaterule.example.percent":`할인 백분율은 30%를 초과할 수 없습니다`,
"label.group.field":`그룹분류 필드 지정`,
"label.trigger.operation.sharetab":`트리거 조작 공유 차트:`,
"label.mobile.phone.write.month.report":`월보 쓰기`,
"label.statusofconvers":`상태 전환됨`,
"label.version.emailtemplate.track":`메일 템플릿`,
"label.customobjects.onlytrackforupdate":`변경 사항만 팔로우업하기`,
"label_tabpage_enterviewname":`1단계: 뷰 명칭을 입력하세요`,
"label.processsetting.three.enable":``,
"label.service.show.more.info":``,
"front-epwechat-module-v1-input-iosschema":``,
"label.dataimport.datatype.error":`데이터 유형이 잘못되어 데이터와 제목이 일치하는지를 점검하세요`,
"label.staticresource":`정지 리소스`,
"label.weixin.customize":`개성화`,
"label.product.edit.sel":`선택한 것을 편집합니다`,
"label.appointmentpage.wizard.notif5":`무효한 핸드폰 번호 형식`,
"label.marketsea.basicsetup":`기본 설정`,
"label.workflow.supplyintruduce":`1. 업무 프로세스 규칙 적용을 유발하는 조건<br/>2. 기록이 조건과 일치할 때 실행하는 즉시 작업.예를 들어 새로운 업무기회가 만들어지면 CloudCC가 자동으로 고객그룹에 이메일을 보내 알림을 할 수 있습니다<br/>3.시간에 의존한 작업은 기록이 조건과 맞을 때 정렬해 시간 트리거에 따라 실행됩니다.`,
"label_report_line_tuozhuai":`마우스로 끌어당기거나 두 번 클릭하여 보고서 열을 선택하고 순서를 조정하십시오`,
"label.add.new.rule":``,
"label.marketing.setting2":`채널 설정`,
"vue_label_chatter_delete_some_group":`"{groupInfoList}"그룹 삭제하시겠습니까?`,
"label.appupload.uploading.wait":`잠시만 기다려주세요.`,
"label.linecondition.error":`행 조건이 잘못되었습니다. 필드 형식이 매칭하지 않습니다!`,
"chatter.group.request":`요청`,
"label.recordtype.tabname.remark":`이 페이지를 사용해 귀조직의 기록 유형을 유지합니다. 기록 유형에 따라 다른 페이지 레이아웃과 선택 항목 리스트값을 볼 수 있습니다. 기록 유형을 사용하려면 '기록 유형' 필드를 페이지 레이아웃에 추가하세요.`,
"setup_mainpage_label_welcome4":`조작 안내: 페이지 좌측 메뉴를 클릭하여→ 응용 프로그램 설정 →생성 →대상.`,
"vue_label_salesadvance":``,
"vue_label_campaign_of_existing_campaign_members":`현재 마케팅 행사 멤버 상태 설정하세요`,
"label.report.object.detail.no.permission":``,
"label.weixin.untreated":`미처리`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`승인자에게 자동 분배됩니다.`,
"label.marketseamemset.containself":`생성 기록이 포함됩니다`,
"vue_label_report_drill":`드릴 다운`,
"label.order.products.to.assets":``,
"label.recordtype.list":`기존 기록 유형`,
"lable.outlook.detail.conflict":`충돌 행위`,
"pagecreator.page.label.layoutpreview":`레이아웃 미리 보기`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":``,
"label.convers":`전환`,
"serviceappointment.worktype.isnot.father.worktype":``,
"lable.tianyancha.h5.relatedcom":`관련 회사`,
"label.reportsSubscriptionPage.schedulereport":`보고서 시간 배정`,
"label.workbanch.setup.showinworkbanch":`나의 작업공간에 보기 여부`,
"label_emailsync_connectaccount":`메일 계정 연동`,
"label.usermanage.license.not.qualified":``,
"component_setup_label_displayfield":`표시 필드`,
"setup_layout_label_buttonarea":`버튼 구역`,
"label.weixin.input.content":`내용을 입력하세요`,
"label.operatedata.importsuc":`불러오는 데 성공했습니다. 불러오는 것을 보려면 대상을 여십시오.`,
"label_tabpage_yes1z":`1입니다`,
"front-electronic-signature-describe":``,
"label.event.this.month":`이번달의 이벤트`,
"label.document.replaces":`교체`,
"label.email.cc":`참조`,
"chatter.feed.sticker":`게시물 팔로우업`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`차트를 추가하세요.`,
"label.cpq.main.quote.transfer.order":``,
"label.partnerCloud.partnerAccount.topUpSuccess":``,
"label.appexchange.uninstallpage.uninstall":`삭제`,
"label.campagin.roi.channel":`마케팅 채널`,
"label.multilang.versioncontrol.checkversion":`현재 CloudCC 버전은 {0}이 {1}개 {2}를 만들 수 있습니다. 상한에 도달했습니다!필요하면 CloudCC 버전을 업그레이드 해주세요!`,
"label.emailobject.my.template":`나의 템플릿만 보기`,
"label.edittimetrigger":`시간 트리거 편집`,
"label.setup.mobile.homepageshortcuts.saveerror":`모바일기기 홈페이지 단축키 설정 저장 실패`,
"label.address.street":`도로`,
"label.workflow.estimatecondition2":`기록 생성 시에만`,
"label.wei.expiresdate":`마감 시간`,
"label.quickbooks.viewlist.date":`일자`,
"label.page.select.field.type":`필드 유형 선택`,
"label.tabpage.mypotentialcustomers":`나의 잠재 고객`,
"label.file.library.editlib":`문서 라이브러리 상세 정보 편집`,
"label.weixin.message.operateexception":`메시지 알림`,
"label.visualpage.staticresource.p1":`1.호출 방식. 정적 리소스 도입 버튼을 통해 선택한 정적 리소스를 도입합니다.`,
"label.icon.175":`비행기표`,
"chatter.edit.r":`댓글 작성...`,
"label.examinationandapproval.flow":`승인 프로세스`,
"label.mr.descreption.reDataList5":`그룹 데이터.`,
"label.edit.field.select.showstyle":`보기 형식`,
"label.reportsSubscriptionPage.condition.and":`또한`,
"label.please.associations":``,
"label.service.dispatchingUnits.displays.service.appointments":``,
"label.addcurrent":`기존 추가`,
"label.search.change":`검색 가능한 대상 설정`,
"message.schedulejob.error.modify":`설정된 시간표에 기반하여 주어진 작업은 영원히 촉발되지 않을 것입니다. 데이터를 검토한 후 다시 제출해 주십시오.`,
"label.chatter.sendEmailToGroupMember.subject.L":``,
"label.weixin.micro.oldid":`위쳇 공식 계정 최초 ID`,
"label.employees.only.invitation.code":``,
"lable.PowerProcess.event.msg":``,
"label.file.share.email.content2":`공유 정보: 님에게 공유한 현재 파일의 #sharerole권한`,
"label.querydetailservice.datalayout.notexist":`기록과 대응한 레이아웃이 없습니다`,
"label.group.items":`그룹분류 프로젝트`,
"label.istouse":`사용 가능 여부`,
"front-electronic-signature-explain":``,
"label.partner.template.thumbnail":`썸네일`,
"registration.page.selected.fields":``,
"label.reportTypeCategoryLabel":`데이터 소스`,
"vue_label_email_You_have_not_activated_the_mailbox":`메일을 개설하지 않았습니다.`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`업무 완성 비율`,
"label.forecast.detailforecast.program":`항목 예측`,
"label.page.display":`페이지마다 보기`,
"label.passwordPolicy.setup.minute":`분`,
"label.emailtocloudcc.step1total3":`1단계, 총 3단계`,
"label.file.title":`제목`,
"label.callcenter.private.key":``,
"com.cloudcc.login.error.message.loginerror":`사용자 이름이나 암호가 잘못되었습니다`,
"UG_Lead_004":`Web 차트`,
"label_tabpage_recordsz":`기록`,
"label.shangqing.discovery":`비즈니스 정보 발견`,
"vue_label_notice_change_success":`변경 성공`,
"label.ems.other":`기타`,
"loading":`데이터 로딩중`,
"label.committedtoapprove":`제출된 승인 요청`,
"label.category.4":`금융`,
"template.report.folder.customer.situation":``,
"label.quickbooks.searchresault.phone":`전화`,
"label.ccpeak.ccobj.save":`CCobject를 데이터 베이스에 저장합니다. 호출 방법`,
"label.knowledge.delete.linked":``,
"label.forecast.settings.future2":`미래 2개 주기`,
"message.error.displaytype.detail":`보기 유형을 입력하세요. 일: day，월: month，주일: week，가용성: availability！`,
"front-template-V1-search-template-name":``,
"label.sendsms.batch.step3.introduce":`모든 문자의 행사를 저장합니다`,
"UG.Forcast.08":`이전`,
"label.inputnameandintro":`명칭과 설명을 입력하십시오`,
"label.redistributioned":`다시 분배됨`,
"label.service.dispatchingUnits.left.right.total":``,
"label.projectManagement.Pleaseentertheactualworkinghours":``,
"label.exporttemplate":`템플릿 내보내기`,
"label.data.downpage":`데이터 다운로드 페이지`,
"message.please.choose.contact":`연락담당자를 선택하세요`,
"message.error.dataformat.error":`데이터 형식에 오류 발생`,
"label.customsetting.changefieldtype.losevalue":`선택한 데이터 형식으로 변경하면 이 필드의 기존 데이터를 모두 잃어버립니다.`,
"label.sendemail.chat.chattype":`메인 게시물 유형:`,
"label.ccdocument.upload.error":`파일 업로드하는 데 오류가 발생했습니다!`,
"label.quickbooks.view.all":`전부`,
"label.data.downpage.e_title":`데이터를 내보내는 단계:`,
"lable.data.lock":`데이터가 잠겨 있어 조작하기 전에 해제하세요.`,
"label.locked":`잠겨 있습니다`,
"label.customfields.beforedeletedata":`해당 사용자 설정 필드를 삭제하기 전에 클릭하여 "|"데이터 관리"|"를 설정하세요.`,
"label.productsales.oppor.noapproach":`예상 체결일 <30일의 업무기회는 없습니다.`,
"label.input.notmore.than.number":`{0}보다 작거나 같은 숫자를 입력하세요`,
"label.list.userinterface.isenable":`인트라넷 편집 사용`,
"label.listofshare":``,
"label.emailsync.status.role":`역할`,
"label.staticresource.useful.realtion":`이 정지 리소스의 위치를 사용합니다`,
"label.sharerule.tip":`이 페이지는 귀사의 공유 설정을 표시합니다.이 설정은 모든 사용자가 다른 모든 사람의 데이터에 접근할 수 있는 권한 등급을 지정합니다.`,
"label.qrcodelogin.message.expired":`무효한 QR코드`,
"label.marketing.setting3":`마케팅 채널 설정`,
"vue_label_statistical_field":``,
"message.view.addtomyhomepage":`시작 페이지 작업공간에 추가`,
"label.customfields.percent.tip":`사용자가 백분율 숫자(예: 10")를 입력할 수 있도록 하여 숫자에 백분부를 자동으로 추가합니다."`,
"component_newrecords_label_10records":`10개 기록`,
"Lead_Scoring_Warning_001":`잠재 고객이 한명인 경우 시스템에서 잠재 고객을 새로 만들거나 편집할 때 자동으로 채점되며 모두 불러오거나 인터페이스로 생성한 잠재 고객인 경우 수동으로 모두 채점해야 합니다.`,
"label.project.planing":``,
"label.data.exp.pwdverif":`비밀번호에 알파벳이나 숫자만 사용 가능합니다`,
"coderules.notEnable":``,
"label.weixin.wdyj.jxhk":`개인- 판매 성과-대금 회수`,
"label.data.expnode.e_desc3":`3.템플릿 제작: 사용자가 필요에 따라 내보내는 필드와 조건을 템플릿으로 만들어 다음은 편하게 사용할 수 있습니다.`,
"chatter.group.join":`가입`,
"vue_label_systemSettings_monitoring":``,
"front-kefu-moudle-v1-yesorno-delete-folder":``,
"label.exchange.sync.state.info":`시스템 상태를 점검하여 기록이 Exchange와 CloudCC 간의 동기화를 확보합니다.`,
"lable.outlook.mcto.emaildes":`메일 전송할 잠재고객이나 연락담당자의 모든 메일 주소를 입력하여 콤마로 간격을 줍니다. 다음의 지정한 메일 주소로 전송한 메일만 관련 기록의 행사 이력에 추가될 수 있습니다.`,
"label.ems.save":`저장`,
"vue_label_dashboard_maximumvalue":`최대치를 입력하세요`,
"label.passwordPolicy.setup.norestriction":`요구 없음`,
"label.multilang.customforcast.total":`{0}의 합계`,
"label_partner_all_memo":`리스트에서 귀조직의 모든 파트너 클라우드를 볼 수 있습니다. URL를 클릭하여 로그인 페이지로 직접 이동합니다.`,
"Account.News.Setting.002":`다음의 고객 설정을 귀사의 지정된 기본 고객 행위로 사용된다`,
"label.essential":`필수`,
"label.nonotice":`더 이상 알림 받지않기`,
"vue_label_calendar_calendar_deleted_successfully":`캘린더 삭제 성공`,
"message.huanxinagent.disable":``,
"label.goto":`이동`,
"label.chat.topic.add.favorite":`즐겨 찾기에 추가`,
"label.trigger.targetobj":`목표 대상`,
"label.form_fields":``,
"this.month":`이번달`,
"vue_label_homepage_select_view":`뷰 선택`,
"label.weixin.input.subject":`주제를 입력하세요`,
"label.ems.emailType":`메일 유형`,
"vue_label_file_safe_type_file":`파일에 예민 정보가 포함되지 않는 점을 확인하세요. 특정 사용자나 기록과 파일을 공유하세요.`,
"label.version.case.automatic.upgrade":`Case 자동 업그레이드 및 분배`,
"label.input.invalid.credit.card.number":`합법적인 신용카드 번호를 입력하세요`,
"component_timeline_label_future":`후속 절차`,
"label.emailtemplate.cannotsupporthtml":`HTML 형식은 지원되지 않습니다`,
"label.appupload.install.error.info2":`{1}  “{0}”           이 기존 구성요소와 충돌합니다.`,
"label.custom.field.maping":`이 필드에 매핑합니다`,
"encd":`암호화 텍스트(암호화 표시)`,
"label.service.newBuildDialog.filter.logic":``,
"label.customerinfo":`회사 프로필`,
"vue_label_applauncher_notice_activepoolsuccess":`고객풀 사용 성공`,
"label.partner.workspace.member.choicepermission":`권한 세트 선택`,
"front-gantt-module-this-task-of-other-tasks":``,
"label_chatter_publish":`발표`,
"label.forecast.settings.mrfw":`기본 범위 기점`,
"label.Named.Filter":``,
"label.department.email":`메일 주소`,
"label.updatingfield":`업데이트할 필드`,
"label_partner_template_detail":`기능 설명`,
"front-epwechat-module-v1-unbound-item":``,
"vue_label_file_lib_name":``,
"label.notification.arketsea.distribution":`{5}가 {2}{0}：{1}를 님에게 분배했습니다`,
"vue_label_norm_removecomponent":`구성 요소 삭제`,
"component.event.label.begindate":`*시작 시간`,
"chatter.note":`개 주석을 받았습니다`,
"label.forecast.settings.type.all":`전체 예측을 사용합니다`,
"label.compact.layout.frame.full":`전체 화면`,
"label.approvalstep3intro":`다음의 선택항목을 사용해 승인 요청이 분배될 사용자를 지정합니다`,
"label.notification.approval6":`[피파견자 명칭] [제출자]가 요청한 [대상][대상명]의 승인 신청을 대신 승인했습니다.`,
"setup.object.field.dependency.label.actionfieldvalue":`필드값 컨트롤`,
"label.multilang.page2":`페이지`,
"vue_label_email_submitted":`제출 통과`,
"label.Standard.button":`표준 버튼`,
"vue_label_report_emailchoose":`이메일 선택 항목`,
"page.field.masterinput.list":`마스터 슬레이브 입력 데이터 리스트`,
"label.martrixdown":`행렬 아래로 이동`,
"vue_label_helpcenter_opportunity":`뷰의 우상측에서 세일즈 퍼널 아이콘을 클릭하여 세일즈 퍼널을 확인할 수 있다. <br>직관적인 프로그래스 바를 통해 모든 업무 기회의 진도를 팔로우업하며 버튼을 눌러 현재 완성 단계를 표시하거나 현재 단계를 조정할 수 있다. 업무 기회를 추진하면서 어려움을 맞이할 때 프로그래스 바를 확대해서 현재 단계의 더욱 중요한 정보 및 안내 말씀을 확인할 수 있다. <br> 업무 기회 그룹의 관련 리스트를 통해 해당 업무 기회 데이터를 권한이 없는 인원에게 공유할 수 있으면 협업할 수 있다. <br>업무 기회 아래의 연락담당자 역할 관련 리스트에서 고객의 연락담당자에게 기회의 역할을 부여하고 관계망을 통해 관련 담당자의 등급 관계를 볼 수 있어 레이다 차트로 연락담당자가 현재 기회의 가치를 평가하고 상황을 팔로우업하며 관건 인물을 위치시키며 연락담당자의 역학, 방문 상태, 관계 수준 , 구매 스타일 및 방문 횟수를 확인할 수 있다. <br>업무 기회 제품 관련 리스트를 통해 해당 업무 기회에 대해 같은 가격 매뉴얼의 제품을 추가할 수 있어 제품의 판매 가격, 개수를 편집할 수 있다.`,
"label.sso.ssoKeyMan":`통합인증 비밀키 관리`,
"label.forecast.edit.desc":`한 사용자가 다음 기간의 할당액을 설정합니다`,
"label.weixin.newspaper.coverage.time":`위험 보고 시간`,
"label.pleaseselectpro":`제품을 선택하세요`,
"label.bottonandlink":`버튼과 링크`,
"label.donot.know.error":`알 수 없는 오류가 발생하여 관리자에게 연락하십시오`,
"label.account_noordab":``,
"label.partnerCloud.orderingPlatform.toPay":``,
"label.many.dayline.nextday":`다음 날`,
"lable.showmorerecords":`더 많은 기록 보기`,
"front-lightning-module-v1-details-page-chart-record-type":``,
"label.ccpeak.query.record":`조회 기록:`,
"pagecreator.systemstyle.message.save.fail":`양식 저장 실패`,
"label.weixin.share.file":`파일 공유`,
"errormessage.email.relatedorreceivermusthaveone.z":`수신자와 관련 항목은 최소 하나를 선택하시오`,
"chatter.save.f":`저장 실패`,
"button.partner.create":`생성`,
"label.marketseamemset.lead.title2":`모든 멤버의 잠재 고객 보유량의 상한을 설정하세요. 제한이 고객풀과 무관합니다`,
"label.service.major.event.new":``,
"label.version.custom.site":`사용자 설정 사이트`,
"label.permission.visualpagepermission":`분배된 사용자 설정 페이지`,
"lable.product.zongjia":`총가격`,
"label.viewchart":`차트 보기`,
"label.alaska.daylight.time":`알래스카 서머타임`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":``,
"component_assistant_label_todaylead":`오늘 분배된 잠재고객`,
"label.sendemail.chat.addComentsfavorite":`존경하는 #name:\n\n    ;안녕하세요！#userName이 님이 저장한 게시물에 댓글을 달았습니다.`,
"label.smstemplate.tip":`선택한 폴더의 모든 메시지 템플릿을 전시했습니다. '새로 만들기'버튼을 클릭하여 새 택스트나 HTML 메시지 템플릿을 생성할 수 있습니다. 메시지를 전송할 때 템플릿을 사용할 수 있습니다. 역할 링크를 클릭하여 더 많은 정보를 볼 수 있습니다.`,
"label.documentname":`파일 명칭`,
"label.icon.162":`경치`,
"label.salescloud.wanyuan":`위안`,
"label.view.desc1":`유형 필드, 선택 항목 리스트 필드, 선택항목 리스트(복수응답) 필드를 기록합니다. 최대 10개의 키워드를 입력하시길 권합니다. 예를 들어 "베이징, 상하이, 광저우"와 같은 영어 콤마로 간격을 시켜 혹은 관계를 설정하십시오.`,
"label.searchlayout.lookup.newfield":`"조회" 다이얼로그 박스에서 버튼 새로만들기 보기 필드를 클릭합니다.`,
"label.emailobject.bcc":`숨은 참조:`,
"label.manageAll.pagenum1":`지금은 첫 페이지입니다.`,
"vue_label_appstore_crm_used_companies":`상장 업체들이 모두 사용하고 있는 crm`,
"label.document.replace":`대체`,
"label.assignment.setup.newrule.title":`새로만든 개별안 분배 규칙`,
"component.chatter.label.mygroup":`나의 팀`,
"lable.currencyAdv.exchangedate":`일자 범위`,
"label.quickbooks.button.viewinqb":`QuickBooks에서 보기`,
"UG.homepage.004":`자동화`,
"label.currencyName":`화폐 종류 명칭`,
"Homepage_News_001":`뉴스`,
"front-lightning-module-v1-details-page-chart-refresh-button":``,
"label.list.projectSetting.isenable":`프로젝트 타이머 사용( 이정표, 업무, 하급 업무, 문제 포함)`,
"setup.layout.message.relatedlistbutton":`관련 리스트에서의 표준 버튼을 선택하세요`,
"vue_label_homepage_homepageassignment":`응용 프로그램 홈페이지 분배`,
"label.pending":`처리 대기`,
"component.timeline.label.today":`오늘`,
"front-kefu-moudle-free-hasexpire":``,
"homepage.layout.customlayout":`사용자 설정 메인 홈페이지 레이아웃`,
"label.service.miniProgram.content":``,
"label.defaultline.must.int":`기본 행수는 자연수여야 합니다`,
"label.mirror_issues":``,
"label.edit.select.two":`택일형 선택 상자 리스트`,
"label.emailmerge.mergeFolder.tip":`템플릿 병합에 시간이 필요하며 병합 과정에 다른 링크를 클릭하거나 Web 브라우저를 닫거나 페이지를 새로고침하지 마세요!`,
"label.ServiceCloud.zichan.distributionMap":``,
"label.selectfile":`파일 선택`,
"vue_label_account_equitymanage":``,
"label.email.clearAll":``,
"label.selecting.parent.assets":``,
"component.setup.tabs.label.delete":`삭제`,
"label.visualpage.top.must.is":`페이지 헤더의 필수 내용은:`,
"label.SalesCommitmentDashboard":`판매 승낙 대시보드`,
"chatter.group.changeTheRole":`역할 변경`,
"label.dataimport.insertdata.error":`새 데이터 삽입 시 오류가 발생해 데이터를 다시 점검하세요`,
"label.partner":`파트너 클라우드`,
"label.process.async.execute.tip":``,
"label.service.newBuildDialog.additional.conditions":``,
"label.name_copy":``,
"label.integrations.install":`권한 부여`,
"label.edit.ccpeakfolder.time":`타이머 클래스: 폴더 편집`,
"label.knowledgebase.filing.time":``,
"vue_label_chatter_success_exit_group":`그룹 탈퇴 성공`,
"font.market.module.v1.save.name":``,
"label.a.b.without":`A기록이 있을 것 같거나 'B'기록이 없다`,
"label.chat.topic.desc":`내용`,
"label.field.editoptionlist.introduce":`다음에 선택 항목 리스트값 명칭을 입력합니다.   이 체크 상자를 선택함으로써 이 값을 기본값으로 사용합니다`,
"label.versiontype.Enterprise":`기업 버전`,
"message.selectrulecondition":`규칙 조건을 지정하세요!`,
"label.custombutton.unknown.operation":`알 수 없는 조작`,
"label.pricecannotnull":`가격을 비워둘 수 없습니다`,
"component_salesperformance_label_target":`목표`,
"pagecreator.page.message.delete.success":`페이지 삭제 성공`,
"label.help.new.features":`신기능 조작 매뉴얼`,
"label.weixin.vehicle.owner.information":`차량 소유자 정보`,
"label.exchange.sync.state.user.info":`사용자의 동기화 상태를 점검하여 사용자 기록이  Exhange 와 CloudCC에 동기화된 것을 확보합니다. 사용자가 Exhange 와 CloudCC에서의 동기화에 문제가 생긴 경우 사용자의 동기화 과정을 다시 설정할 수 있습니다. 다시 설정이 CloudCC for Exchange만 사용한 정보를 지울 수 있으며 Microsoft Exchange 서버나 CloudCC에서의 데이터를 삭제하지 않습니다.`,
"label.batcheditor":`모두 편집`,
"report.label.knowcreatehighlevelreport":`고급 보고서 제작 이해하기`,
"label.dataimport.title.length":`제목 길이는`,
"label_model_description":``,
"label.tabpage.ctbtsftcz":`뒤를 클릭하여 선택한 내용을 검색한다`,
"label.channel.activity.member.owner":``,
"label.ems.serverinfo":`서버 정보`,
"tjinvilid":`조건이 불법적입니다`,
"label.nameofreport":`보고서명`,
"label.ifapproverreject":`승인자가 이 요청을 거절하면 어떻게 됩니까?`,
"label.wtd.changefields.title.desc2":`모바일기기 Web to CloudCC 의 기록이 잠재고객과 연동시키려면 현재 대상에서 잠재고객을 찾는 필드를 생성하여 필드 API가 lead_wtd입니다.`,
"label_emailsync_form_connecttime":`관련 시간`,
"label.visualpage":`사용자 설정 시간`,
"label.customlink":`사용자 설정 링크`,
"label.lead.score.doing.remark":`요청이 처리되어 잠재고객에 대한 채점이 시간이 걸리며 완성한 후 메일로 통지를 보내드립니다.`,
"label.h5.act.details":`행사 상세 정보`,
"label.profile.setrecordtype":`기록 유형 설정`,
"label.processsetting.process.enabled.successfully":``,
"label.campaign.url.overtime":`해당 링크가 기한이 만료되었습니다`,
"label.structureChart.notFiled":``,
"label.h5.chatter.something":`무슨 말씀 하시겠습니까?`,
"label.pm":`오후`,
"template.chart.rwlx":``,
"label.icon.42":`구름`,
"label.project.hit.one":``,
"label.martrixreport.2018.step3":`3단계: 보고서 열을 선택합니다`,
"label.wtd.changefields.newmo":`모바일 버전 페이지 생성`,
"label.downloadTheTemplate":`템플릿 다운로드`,
"label_chatter_assignPerson":`피분배자`,
"label_emailtocloudcc_license":`사용자 허가`,
"label.willdeletedlayout":`삭제할 페이지 레이아웃`,
"label.projectManagement.delete.question":``,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`명함 스캔이 인증 규칙을 사용 여부`,
"label.salescloud.opportunity.addandedit.contactrole.note":`주의: 공백 연락담당자를 더블 클릭하면 공백 기록을 하나 더 만들 수 있습니다`,
"label.step6.total6":`6단계, 총 6단계`,
"label.knowledge.setting.hint.one":``,
"label.usefieldautoassign":`표준 또는 사용자 설정 등급 구조 필드를 사용하여 승인자를 자동으로 분배합니다:`,
"label.partnerCloud.orderingPlatform.orderAmount":``,
"chatter.fieldtrack.operateupdate":`1개를 변경했습니다`,
"chatter.del.com":`댓글 삭제`,
"report.reportdatasource.label":`보고서 데이터 소스`,
"label.text":`텍스트`,
"label.marketsea.select.member":`선택 가능한 멤버`,
"label.typeofreceivers":`수신인 유형`,
"label.knowledgebase.affect.existing.translations":``,
"label.marketing.invitationmail":`저희 행사에 참여해 주신 것을 환영합니다. 초대장 링크는:`,
"label.version.quotation.management":`견적 관리`,
"label.dataimport.insertdata.error.unique":`새 데이터를 삽입할 때 $fieldName$는 유일한 구속을 위반합니다.`,
"label.emailmerge.list.newtemplate":`템플릿 새로만들기`,
"label.salescloud.salescloud.allteam":`업무 기회의 모든 그룹`,
"vue_label_commonobjects_detail_record_changes":`필드 기록 변경`,
"label.file.delete.info":`파일 삭제`,
"vue_label_calendar_name":`캘린더 명칭`,
"label.version.support":`지원`,
"label.event":`이벤트`,
"label.searchlayout.lookup.searchdialog":`'찾기' 필드에서 찾기 링크를 클릭하여 나오는 '찾기' 대화상자.`,
"label.data.downpage.e_list.desc2":`데이터를 성공적으로 내보냈을 때, 데이터를 성공적으로 내보냈다는 알림 메일을 받을 것입니다.`,
"label.partnerCloud.productSet.delIsTrue":``,
"label.tianyancha.businessverify.msg2":`본 <협의>가 님이(다음에 사용자로 지칭함)CloudCC과 간의 공상 데이터 인증 기능 사용에 관한 협의입니다. 본<협의>에는 CloudCC와 사용자 간의 공상 데이터 인증 기능에 관한 사용과 서비스 권리 의무 등 내용을 담습니다. 본 <협의>는 CloudCC 에서 수시로 업데이트가 가능하며 업데이트된 협의가 발표되어 기존 협의 조항을 대체하며 개별 알림을 보내지 않습니다.`,
"label.customobjects.cancleselectallfield":`모든 필드 선택 취소`,
"image.up.maxsize":`업로드할 파일 크기가 한계를 넘어 2M을 초과할 수 없습니다.`,
"label.icon.8":`파일`,
"label.donot.delete":`삭제 권한이 없습니다!`,
"label.version.profile.and.layoutpage":`프로필과 페이지 레이아웃`,
"chatter.coll.s":`이 게시물 저장 취소`,
"label.icon.163":`지구`,
"label_chatter_myfollowers":`나의 팔로워`,
"label.multilang.customforecast.refuse":`{0}의 모든 예측 우선을 거절하며 다른 부하의 예측 우선을 받아들입니다.`,
"label.tabpage.findz":`찾기`,
"label.smstemplate.detailinfo":``,
"label.knowledge.setting.hint.nineteen":``,
"label.mr.tip":`{0}번째 행의 규칙을 입력하세요.`,
"label.icon.132":`보장`,
"label.customobjects.track.introduce2":`'필드 팔로우업' 관련 리스트에서 팔로우업한 필드. 사용자가 언제든 수정한 다음에 선택한 필드, 구 필드값과 신 필드값, 일자, 시간, 변경 특성과 변경하는 사용자가 모두 '필드 팔로우업' 관련 리스트에 추가됩니다.`,
"label_emailtocloudcc_redmessage5":`상태가 미상하여 관리자에게 연락하세요`,
"label.must.select.field":`행 조건이 틀렸습니다. 한개 필드를 선택해야 합니다!`,
"label.tag.manage.modifiedby":`최종수정자`,
"label.translation.start1":`하나의 언어를 선택합니다(여러 언어의 번역자라면).`,
"label.ccchat.topic.searchs":`주제 검색`,
"label.mask.custom.example":`{AAAA}{****}{AAAA}는 5번째 문자부호부터 8번째 문자부호까지 암호 설정 보기를 의미합니다.`,
"setup_object_field_dependency_label_addtolist":`선정된 값 추가`,
"label.view.total.record":`총 0개의 기록을 선택합니다`,
"label.service.without.right":``,
"template.chart.wxqzkhyy":``,
"vue_label_dashboard_pleaseenterabreakpoint1value":`브레이크포인트 1 값을 입력하세요`,
"message.pleaseinputmouthdistance":`정확한 간격 월을 입력하세요`,
"label.forgetPsd.tip":`비밀번호를 잊으시면 관리자에게 연락하세요`,
"label.projectManagement.planned":``,
"lable.Product.conversion.asset.operation":``,
"label.search_forms":``,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat 메인 홈페이지 댓글`,
"label_tabpage_viewNamez":`뷰 명칭을 입력하세요`,
"label_chatter_addresser":`발송인`,
"Opportunity_Detailed_Phase_Change_Text_001":`업무기회 단계 변경`,
"label.what":`번째`,
"vue_label_systemSettings_set_android":``,
"label.sell":`판매`,
"template.report.folder.case":``,
"label.customfields.profilefieldsafety":`프로필의 필드급 안보성`,
"label.industrialandcommercialverification.label.token":`토큰`,
"label.finished":`완료`,
"label.sendmail.step3.introduce1":`현재 선정함`,
"vue_label_calendar_other_calendars":`기타 캘린더`,
"label.donot.know.validate.field":`미지의 검증 필드`,
"label.exportdetail":`상세 정보 내보내기`,
"label.step.filter":`선별 조건을 지정합니다`,
"label.campaignmember.main.hasMember":`기존 멤버`,
"label.updown.suess":``,
"label.ems.browse":`찾기`,
"front-email-payment-Invoice-login-account-describe":``,
"label.copyCustomReportType":`사용자 설정 보고서 데이터 소스 복사`,
"label.visualpage.write.class":`페이지에서 Class 코드를 편집하며 코드의 문법이 Java와 같습니다`,
"label.setsharerule.tip":`공유 규칙을 사용해 설정 조건에 부합한 데이터를 지정한 역할과 공유합니다. <br>주의: 역할 및 산하"특정 역할의 모든 사용자와 역할 이하 모두 포함".`,
"label.report.action.addtodashboard9":`대시 보드 리스트 페이지`,
"label.cloudccsite.remark":`웹사이트 내용`,
"label_tabpage_noz":`아님`,
"chatter.up.limit":`업로드한 파일이 너무 크니 한계를 초과하지 마십시오`,
"label.leadmarketsea.grouplist.title":`잠재 고객풀 그룹 분류 설정`,
"label.pc.user.help":`사용자 매뉴얼`,
"label.partnerCloud.orderingPlatform.relyOn":``,
"label.appointmentpage.wizard.subtitle2":`시간 선택하기`,
"label.deleteoneormore":`한개나 여러개 삭제`,
"january":`1월`,
"label.delete.profile":`프로필 삭제`,
"label.appointment.wizard.subtitle1-7":`2시간`,
"label.icon.188":`화장품`,
"vue_label_file_already_in_lib":`파일 베이스에서 존재함`,
"label.icon.151":`가상현실`,
"label.withvalue":`값으로`,
"label.tianyancha.businseeverify.opererror":`공상 기업 데이터 사용 실패하여 다시 시도하거나 시스템 관리자에게 연락하세요!`,
"label.tabpage.individual":`택일형 선택`,
"label.layout.editdistribute":`페이지 레이아웃 분배 편집`,
"label.smstemplate.lookup":``,
"pagecreator.systemstyle.button.delete":`양식 삭제`,
"label.customer.tab.step2.same.option1":`기본 열기`,
"label.knowledgebase.no.results.knowledge":``,
"label.data.exp.newtemporexp":`데이터 내보내기 방식을 선택하거나 템플릿 제작하기`,
"vue_label_chatter_refuse_join":`가입을 거절합니다`,
"Homepage.News.002":`뉴스 모듈 서비스 사용 불가능합니다`,
"label.log.requesttype":`요청 방식`,
"vue_label_dashboard_generatefromreport":`보고서에서 생성`,
"label.knowledge.create.version":``,
"label.emailtocloudcc.description2":`기업 이메일 주소를 연동한다`,
"label.partnerCloud.partnerAccount.recharge":``,
"label.customobjects":`사용자 설정 대상`,
"label.schedulableprg.endtime":`종료일이 시스템 현재 일자보다 커야 합니다`,
"message.error.viewreport.confirmdelete":``,
"label.marketing.social.seting":``,
"chatter.follow.stop":`사용자 팔로우 취소`,
"label.notification.arketsea.return":`{5}가 {0}：{1}를 {2}로 반환했습니다`,
"label.conditionsofnextapprover":`선택한 승인 요청에 한개나 여러개 요청이 다음 승인자를 지정했습니다. 다음의 검색 창자를 사용해 다음 승인자를 지정합니다.`,
"label.partner.all.state":`상태`,
"mobel_web_closed":``,
"label.icon.65":`기구`,
"label.stdashbord.xsld.business.jinehj":`금액 합계`,
"label.selectobject":`대상 선택`,
"label.account.CurrentFQ":`현재 회계 분기`,
"label.workflow.estimaterule":`평가 규칙`,
"label.list.userinterface.shownewrecordssetup":`최신 기록 설정`,
"label.tianyancha.businessverify.msg3":`1: 비용:`,
"label.weixin..xsld.jieduan":`단계`,
"label.first.quarter":``,
"Opportunity.Detailed.Phase.Label.002":`현재 상태가 이미 {0}일 유지된다`,
"label_tabpage_page":`페이지`,
"label_emailsync_status_time":`시간`,
"label.pleaseselectaapprover":`승인자를 선택하세요`,
"label.emailtocloudcc.redmessage5":`상태가 불분명합니다. 관리자에게 연락하시오.`,
"label.four.quarter":``,
"label_chatter_relateList":`관련 리스트`,
"label.customfields.new.step2.opration.exid.info":`이 필드를 외부 시스템의 유일한 기록 식별자로 설정합니다`,
"label.projectManagement.nodata.overdue.tasks":``,
"label.sendemail.activity.task.statuscompleted":`존경하는 #createbyidccname안녕하세요：\r\n  #createdate에 #belongtoidccname에게 분배한 업무의 상세 정보가 다음과 같습니다：\r\n  주제：#subject\r\n  만료일：#expireDate\r\n  관련 항목：#relatedstr\r\n  내용：#remark\r\n  상세 정보는 다음 링크를 방문하십시오：\r\n #path\r\n #belongtoidccname이 완성으로 표시했습니다. \r\n                      #orgNameCRM시스템`,
"label.sso.saml.idp.config.issuer":`수여자`,
"label.cannot.delete":`개) 삭제할 수 없습니다`,
"label.pigeonhole.sel_f":`문서보관 폴더 선택`,
"label.customfields.text.tip":`사용자가 임의 알파벳과 숫자 조합을 입력할 수 있습니다.`,
"message.error.user.service.common":`조작이 실패하여 시스템 관리자에게 연락하세요!`,
"label.datamanage.account.information":`고객 정보`,
"vue_label_homepage_deleteprofilepage":`프로필 홈페이지 삭제`,
"label.sendmail.step3.introduce3":`명 수신인이 이 문자를 수신합니다.`,
"label.pc.ui.2018.recentitem":`최근 프로젝트`,
"label.report.loading":`로딩 중`,
"vue_label_globalsearch_adjustment":``,
"label_report_line_yixuan":`선택한 보고서 열`,
"label.h5.similar.opportunity.only.view":`보기`,
"label.marketactivitymember":`마케팅 행사 멤버`,
"label.recycle.execute.tip":`요청을 처리했으며 휴지통을 비우는 데 시간이 걸려 시스템에서 처리한 후 메일로 알려드리겠습니다.`,
"label.permission.detail.system.setting":`시스템 권한 설정`,
"label.RecordType":`기록 유형`,
"label.custom.error.between":`사용자 설정 연도 시작일이나 사용자 설정 연도 종료일이 사용자 설정 연도 이력 시간 범위 안에 있어 확인 후 다시 설정하세요!`,
"vue_label_dashboard_selectview":`뷰 선택`,
"label.tianyancha.businessverify.cancel":`공상 데이터 인증 사용 취소`,
"label.partnerCloud.financeSetting.MD5":``,
"label.multilang.messagedetail.new.error":`이름에 {0}이 포함된 Chat 사용자를 찾을 수 없습니다:`,
"label.callcenter.pleaseenter.private.key":``,
"label.umeng.activity.youdistribute":`분배한`,
"label.weixin.nickname":``,
"label.customerinfo.mailusername":`메일 발신 사용자명`,
"label.partnerCloud.orderingPlatform.discountPlan":``,
"lable.account.year":`회계 연도`,
"T":`시간`,
"System.Email.Template.Title":`CloudCC CRM 플랫폼을 사용하는 것을 환영합니다`,
"label.login.type":`로그인 유형`,
"label.notification.evaluation":``,
"label.turntolist":`리스트로 이동`,
"label.sort":`정렬하기`,
"vue_label_commonobject_notice_clickcross":`업로드된 파일을 교체하려면 【X】버튼을 누른 후 다시 업로드하세요.`,
"label.Select.maximumecords.operate":``,
"label.submission_rate":``,
"label.datadelete.record.sucessfully":`개 기록 삭제 성공!`,
"label.version.standard.dashboard":`대시보드`,
"label.task.postunsolve":`지나간 미완성 업무`,
"label.Receivables.name":`대금 수령 계획 명칭`,
"label_tabpage_noOperationz":`이 내용이 고정된 항목이며 조작할 수 없습니다!`,
"label.attendance.onrecord":`최소 한개 기록을 선택합니다`,
"label.partner.error2":`에러:도메인 네임이 알파벳과 숫자로만 조합됩니다`,
"label.account.map":`고객 지도`,
"label.dashboardSetup.reference.legend":``,
"label.Yaxisscope":`Y축 범위`,
"label.hierarchy.tree.tip":`메뉴의 자기 탐색 필드에서 한 기록이 생성한 등급 구조 차트를 선택합니다. 등급 구조 보기가 다음과 같습니다:`,
"label.permission.objlist.columnsize":`총 필드수`,
"label.setup.mobile.bottombutton.savesuccess":`모바일 단말기 홈페이지 설정 저장 성공`,
"label.mobile.side.tab.selected":`선정됨`,
"label.partner.donotdel.cause":`의 삭제 조작, 다음과 같은 협력 파트너 사용자와 관련되어 있기 때문입니다`,
"label.ccchat.message.new.error4":`안내:`,
"vue_label_systemSettings_setorganization":``,
"label.umeng.approval.approvalmes4obj1":``,
"UG_opportunity_010":`거래 생성`,
"label.tag.addtags.public":`공용`,
"System.TAB.SeeViewPageAmount":`페이지수 확인`,
"label.filterconditions":`선별 조건`,
"front-personalEmailBox-module-v12-clear-not-associated":``,
"label.assign":`분배`,
"label.layout.clone.tip":`가존 레이아웃을 선택해 복사할 수 있습니다`,
"label.choose.relatedlist":`이동할 리스트를 선택하십시오`,
"label_chatter_recordcall":`통화 기록됨`,
"label.product.proofOne":``,
"label.layout.availablefield.relatedlist":`사용 가능한 필드/관련 리스트`,
"label.campaignmember.main.updateleadstatus":`상태 업데이트-기존 잠재고객`,
"label.custom.buttonandlink":`버튼이나 링크를 설정하기`,
"label.view.manage":`뷰 관리`,
"label.search.exp":`다음 기능을 사용할 대상을 선택하고 "저장" 을 누르십시오:`,
"vue_label_appstore_apply_to":`적용됨`,
"label.dashboard.message.refreshfail":`대시보드 새로 고침 실패`,
"UG_Case_02":`개별안이 고객문제에 반응하고 문제를 해결하는 것을 도와줍니다. 개별안이 Cloud CC에 기능이 훌륭한 기록이며 고객문제를 팔로우업할 수 있을 뿐더러 전체 고객 뷰를 볼 수 있습니다.`,
"label.project.hit.three":``,
"label.tianyancha.businessverify.tip":`공상 데이터 인증을 체크하여 사용자가 업체 고객 자료를 입력할 때 정확한 고객 공상 등록 정보를 입력할 수 있도록 도와줍니다.`,
"label_emailsync_status_disconnect":`연동 취소`,
"label.rule.disabled.successfully":``,
"label.custombutton.queryerror":`조회가 실패했으며 다시 시도하세요`,
"label.customfields.deletecannotresume":`대응한 데이터가 영구 삭제되며 복구할 수 없습니다.`,
"label.account.current.M":`이번달`,
"label.under.approve.data":`승인 중인 기록(`,
"vue_label_title_remainingdays":`남은 일수`,
"label.partnerCloud.orderingPlatform.refundable":``,
"label.lookup.iscover":`편집에 동기화 허용 여부`,
"label.recordtype.detail.selectlist":`편집 가능한 옵션 리스트`,
"label.sso.isActiveYes":`네`,
"label.service.appointmentList.canceltheSuccess":``,
"label.escalation.setup.newentries.createfirst":`개별안 생성 시간에 따라 최초 개별안 수정한 후 금지사용됩니다`,
"label.new.ccpeakfolder":`종류: 폴더 새로만들기`,
"lable.currencyAdv.exchagecurrency.after":`이후`,
"label.majoranddetailrelation":`마스터-디테일 정보 관계`,
"label.appointment.wizard.subtitle4-2-1":`1시간`,
"label.projectManagement.working.hours":``,
"label.forecast.customforecast.button.forehistory":`예측 이력`,
"label.mymasterplate":`나의 템플릿`,
"component.setup.tabs.label.memo":`Tab라벨 명칭 설정`,
"label.customfields.longtextarea.tip":`사용자가 여러 줄의 텍스트를 입력할 수 있습니다. 최대 32,000개의 문자를 입력할 수 있으며, 대상당 최대 10개의 이 형식의 필드만 지원합니다.`,
"label.service.miniProgram.fillJumpLink":``,
"label.british.summer.time":`그리니지 시`,
"label.nogreate":`<= 같거나 보다 작다`,
"label.assignment.setup.detail.sameuser":`같은 사용자`,
"mesage.error.profile.delate.user":`프로필에 사용자가 분배되어 있어 프로필을 삭제할 수 없습니다.`,
"label.tabpage.cownerz":`소유인 변경`,
"label.multilang.dupicatecheck.processedcount":`중복데이터로, {0}그룹이 처리되었으며, 남은 {1}그룹 데이터가 아직 처리되지 않았습니다.`,
"vue_label_report_notice_leavecertification":`페이지에서 나가시겠습니까- 입력한 데이터가 저장되지 않습니다.`,
"label.master.required":`기록에 필수 입력 항목을 입력하지 않았습니다`,
"label.chatter.follow":`팔로우`,
"label.dataimport.insertdata.error.repeat":`이 기록이 기존 데이터 베이스의 데이터와 중복되어 이 기록을 불러오지 않았습니다.`,
"label.sms.cgid":`채널 그룹 번호`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`대상 필드`,
"label.forecast.editshrepage.quanxian":`권한 공유 방문 등급`,
"label.weixin.interactive.log":`대화식 일지`,
"label.batchedit.remark":`여러 개 기록에 대해 편집할 수 있습니다`,
"label.user.permissions.message":`사용자 정보 설정 권한이 없습니다.`,
"label.mobile.phone.month":`월별`,
"chatter.sel.u":`@할 사용자를 선택하거나 @[사용자명]을 입력합니다`,
"label.service.gantt.assigned.work":``,
"UG_ST_001":`안내`,
"label.edit.select.one":`드롭다운 리스트`,
"label.forecast.shrepage.desc0":`페이지에서 {0}에 대해 공유 방문할 수 있는 사용자, 역할 및 구역을 볼 수 있습니다.`,
"label.multilingual.confirm.close":``,
"label.setting.intergrationlist.integration":`통합`,
"label.leadscore.rule.list":`잠재 고객 채점 규칙 리스트`,
"component_telerecord_button_save":`저장`,
"label.weixin.save.log":`일지 저장`,
"label.validate.function.funcExplain.DAY":`한 달 중 어느 날로 돌아갑니다. 1과 31 사이의 숫자입니다.`,
"label.appointmentdetail.wizard.title1":`회의명`,
"label.multilang.feedtrack.dealkey":`{0}을 {1}에서 {2}로 변경합니다`,
"label.optional.features":`선택 가능한 기능`,
"vue_label_email_no_email":`메일 주소 없음`,
"label.sendemail.chat.messagecontent":`메시지 내용:`,
"label.tabpage.lessequalz":`작거나 같거나`,
"setup.layout.label.setupfield":`필드 속성 설정`,
"label.approved.receiveApprovalEmail.option1":`내가 승인자나 파견 승인자라면`,
"label.chatter.relateList":`관련 리스트`,
"component.sendmail.label.fromuser":`발신자`,
"label.projectManagement.problem.status":``,
"label.weixin.fmu.before.hour":`{0}시간을 앞당기기`,
"chatter.feed.menutype.feed.mark":`내 소장한 게시물`,
"label.addQuoteLineGroup":``,
"label.report.action.addtodashboard6":`추가`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`현재와 지난 캘린더 분기`,
"label.tabpage.emptyz":`비우기`,
"less":`보다 적다`,
"label.h5.selectmostphotos":`사진 최대 9장까지만 선택할 수 있습니다.`,
"UG.activity.04":`Outlook/Gmail메일 주소 메일 기록`,
"template.chart.qbhtje":``,
"label.tabpage.endz":`완료`,
"label.partner.workspace.member":`멤버`,
"label.filter.error.filedvaluetoolong":`오류: 필드값이 최대치를 초과했습니다.`,
"label.months":`월별`,
"button.partner.workspace.disable":`사용 취소`,
"label.visualpage.checkpinyin.grammar":`맞춤법 문법을 확인하세요`,
"label.dashboardSetup.geshihua":`포맷`,
"label.belongto":`소속`,
"label.upload.cannot.empty":`업로드 파일을 추가하세요!`,
"label.number.MaxCheck":``,
"pagecreator.page.message.save.fail":`페이지 저장 실패`,
"label.edit.SMS":`문자 통지 편집`,
"UG_Lead_002":`다양한 방법으로 제품이나 서비스가 관련한 '잠재고객'을 식별할 수 있도록 합니다.`,
"label.quickcreate.active.quickcreate":`빠른 새로만들기 사용`,
"label.recordtypeselect.tip":`나중에 이 페이지를 건너뛰려면 개인 설정 페이지에서 기록 유형 설정을 변경하세요.`,
"label.form_content":``,
"workflow.action.tasks.assignortype.related":`관련 사용자`,
"vue_label_allsearch_set_more_items":`검색창 좌측의 드롭다운 리스트에서 더 많은 검색 항목을 설정해 계속 검색할 수 있습니다`,
"label.tianyancha.businessverify.title":`공상 인증`,
"label.errormessage.batchedit.norecord":`데어터가 없습니다.`,
"label.permission.appname":`응용 프로그램 명칭`,
"label.report.action.addtodashboard7":`취소`,
"label.generated.transfer.product":``,
"vue_label_commonobjects_detail_you":`귀하`,
"label.user.captcha":`사용자 인증번호 인증`,
"label.notification.event4":`님이 [피분배자]에게 분배한 이벤트가 곡 [시작시간]에 시작됩니다`,
"label.version.setup":`시스템 설정`,
"setup.object.layout.message.selectedlayoutandrecordtype":`레이아웃 및 기록 유형을 선택하세요`,
"label.role.add":`역할 추가`,
"label.versiontype.Unlimited":`무한 버전`,
"label.partnerCloud.financeSetting.developerID":``,
"front-invoice-online-payment-setup-global":``,
"vue_label_commonobjects_view_basis":`분류 근거`,
"label.decimaldigits.tip":`소수점 오른쪽 숫자의 자릿수`,
"vue_label_commonobjects_detail_selected":`선정된 단계로 표시됨`,
"label.data.export.page":`데이터 내보내기 페이지로 이동합니다`,
"message.error.serviceresource.servicecrewid":``,
"label.loginttime.alltime":`모든 시간은`,
"label.requiredinfo":`필수 입력 정보`,
"label.forecast.edit.di":`제`,
"vue_label_calendar_failed_to_remove_calendar":`캘린더 제거 실패`,
"pagecreator_systemstyle_button_delete":`양식 삭제`,
"label.import.page3.continueimport":`계속 불러오기`,
"label.page.width":`전체 페이지 넓이`,
"label.campaignmember.selectmember.addmember":`에서 멤버 추가`,
"label.finalreject":`최종 거부`,
"label.isend":`종료 여부`,
"front-console-conversation":``,
"label.mr.theLastGroupOfThisPage":`이 페이지의 마지막 그룹입니다. [ 뒤로 이동하여 중복 데이터 리스트 보기]를 클릭하여 중복 데이터를 볼 수 있습니다.`,
"label.data.dataexpalltype.all_desc":`현재 사용자가 볼 수 있는 모든 대상의 데이터를 내보냅니다.`,
"label_emailtocloudcc_redmessage7":`시스템 배치에 오류가 발생하여 관리자에게 연락하세요`,
"label.forecast.shrepage.classdes.all":`완전 접근 권한 - 사용자는 예상 데이터를 보고 커버할 수 있습니다.사용자는 공유 접근 권한을 다른 사용자에게도 확장할 수 있습니다.`,
"market.contacts":``,
"label.weixin.polls.voter":`투표 참여자 리스트`,
"template.report.industry.distribution.customers":``,
"front-electronic-signature-setup":``,
"vue_label_chatter_removecertification":`그룹 멤버"{name}"를 제거하시겠습니까?`,
"label.appointment.wizard.subtitle1-2":`15분`,
"label.sso.saml.idp.config.custattr":`사용자 설정 속성`,
"label_tabpage_totalTeamz":`공유 그룹`,
"lable.outlook.detail.assigned":`분배된 사용자와 프로필`,
"label.department.user.delete":`삭제`,
"label.customcomponent.check.label.same":`라벨명이 존재합니다`,
"label.partner.error1":`에러: 도메인 길이가 한계를 초과했습니다`,
"label.escalation.setup.entrydetail.escalation.notify":`통지`,
"component_todaytask_label_choicestate":`상태 선택`,
"label.customfields.fielddependency.new.step1":`<b>1단계：</b> 한 제어필드나 종속필드를 선택합니다. 완성 시 '계속'을 클릭합니다.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`누구나 볼 수 있고 이 그룹에 가입 신청할 수 있습니다.`,
"label.custom.pixel":``,
"label.quicksave":`빠른 저장`,
"label.approved.persion":`파견 승인자`,
"lable.info.queue.member":`대열 멤버`,
"label.addattachment.step2.weixin":`2단계. '파일 업로드'버튼을 클릭하여 파일을 업로드합니다`,
"label.forecast.customforecast.title":`예측`,
"mainpage_setup_chosecomponent_leastone":`메인 홈페이지에 최소 한 개 구성요소가 필요합니다.`,
"label.appointmentconfirmpage.wizard.title2":`이번 예약에 관한 상세 일정을 이미 메일로 보내드렸습니다.`,
"label.useallselectedapprover":`모든 선정한 승인자의 <strong>일치</strong> 승인한 것을 요구합니다.`,
"label.ccpeak.current.line.return":`현재 행에서 반환하여 다음으로 실행하지 않습니다!`,
"label_new_target_model":``,
"label.saving":`저장중...`,
"label.mobile.phone.write":`쓰기`,
"label.applt.updown.text":``,
"label.partner.common.manageSetup":`파트너 클라우드 관리 설정`,
"label.quickbooks.new":`고객 새로 만들기`,
"message.error.color":`color를 입력하세요!`,
"label.project.template.two":``,
"label.approval.input.des1":`점진적 승인, 최상 등급이:`,
"label.x.axis.cannot.empty":`X축을 입력하세요!`,
"label.solomon.isiands.time":`솔로몬제도 시간`,
"label.login.access.duedate":`방문 권한 지속 시간`,
"label.service.dispatch.booking.order":``,
"label_shareme_forecast":`공유된 예측 사항`,
"label.custom.page.cuspage.height":`페이지 고도(화소)`,
"label.quote.line.group.":``,
"label.data.downpage.i_title.num6":`데이터를 불러오기 전에 5개 기록이 포함된 테스트 파일부터 불러오며 불러올 파일의 정확도를 확보합니다.`,
"label.\u2019s":`의`,
"label.version.contact.management":`계약서 관리`,
"label.document.history.user":`사용자`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`정확한 금액 숫자를 입력하세요. 소수점 둘째자리까지 가능합니다.`,
"label.weixin.target.contract.jine":`계약서 목표액`,
"lable.common":``,
"front-kefu-moudle-sendemail-success":``,
"label.service.no.operation.time":``,
"label.info":`정보`,
"label.ccchat.zw":`점심`,
"label.assignment.setup.newentries.title":`규칙 조항 편집`,
"label.weixin.report.timeline":`시간 프레임`,
"UG.quota.04":`견적서 인쇄`,
"label.social.user.exception":``,
"label.import.index.failed":`실패`,
"label.common.settings":``,
"label.nullvalue":`널값`,
"PageLayout_Search_MultiSearch_002":`검색 필드 펼쳐보기(싱글 필드 검색)`,
"message.myselfreport":`나의 개인 설정 보고서`,
"label.productsales.today.noevttskaddtsk":`오늘 처리되지 않은 이벤트나 만료된 업무가 없습니다. 오른쪽 상단에 있는 ' ' 를 누르면 업무 추가를 할 수 있습니다!`,
"lable.oppdt.noconditionrecrods":`조건에 맞는 기록이 없습니다.`,
"label.campaignmember.selectmember.deletelead":`마케팅 행사: 잠재고객에서 멤버를 삭제합니다`,
"label.marketingactivity":`마케팅 행사`,
"vue_label_pool_self-built":`자동 생성`,
"message.textareamaxlength":`길이가 4000을 넘으면 안 됩니다.`,
"label.valadate.must.value":`값을 입력하세요`,
"label.tabpage.groupsVisiblez":`일부 사용자 그룹만 확인 가능`,
"component.button.cancel":`취소`,
"label.emailobject.list.inbox":`수신함`,
"label.app.step1.error.labelexist":`에러: 라벨이 존재합니다`,
"front-calendar-V1-Unable-to-display":``,
"label.forecast.settings.prompt1":`최소 1개 예측 선택항목을 선택합니다: 수익이나 수량.`,
"front-kefu-moudle-callout-missphone":``,
"label.tabpage.editz":`편집`,
"vue_label_chatter_label_new_team":`그룹 새로 만들기`,
"label.version.formulafield":`공식 필드`,
"label.partner.step1":`1단계: 템플릿을 선택합니다`,
"label.weixin.perfect.url":`정보 URL 보완`,
"label.appointmentconfirmail.wizard.subtitle4":`내용`,
"label.step7.total7":`7단계, 총 7단계`,
"setup.object.layout.label.selectedprofile":`선정된 프로필`,
"label.payments.paytip5":`정확한 수량을 입력하세요`,
"label.visualpage.open.type":`개방식 사용자 설정 페이지 유형입니다`,
"lable.Sort.field.tips":``,
"label.nosharerules":`공유 규칙을 미지정합니다.`,
"label.service.miniProgram.bindSetOwner":``,
"report_label_highlevelreport":`고급 보고서가 최대 4개 대상 관련한 보고서를 생성할 수 있도록 도와줍니다`,
"S":`텍스트`,
"label.lastmodifyby":`최종수정자`,
"label.customerinfo.mailaddress":`발신 메일 주소`,
"vue_label_pool_converted":`전환 완료`,
"UG.ST.004":`데이터 관리-》데이터 불러오기 권한이 없으며 관리자에게 연락하여 확인을 누른 후 바로 {0}페이지로 이동한다.`,
"label.view.application.mobile.terminal.filed":`이 뷰는 모바일 기기에 적용되었습니다.필드는 최대 10개까지 선택합니다.현재`,
"chatter.feed.limitentity500":`최대 500명의 인원과 기록을 팔로우업할 수 있습니다`,
"label.starttime":`시작 시간`,
"chatter.emailToMe":`다음과 같은 상황이 발생했을 때 CCChat 알람을 보내 주십시오`,
"label.custom.Current.and.PreviousCQ":`현재 및 지난 사용자 설정 분기`,
"label.my.logout":`나의`,
"label.quickbooks.searchlist.enddate":`종료일`,
"label.ccservice.validate.length":`대상API가 {0}의 {1}필드 대응값은 {2}이며 길이가 한계를 초과하여 다시 설정하세요!`,
"label.integrations.installed":`권한 부여됨`,
"label.integrations.mailchimplist":`Mailchimp 리스트`,
"label.checkfield.matchothers":`기타 기록 매칭`,
"label.umeng.activity.event.distributewillbegin":`#name의 이벤트#에게 분배한 #event 곧#time후 시작합니다`,
"pool.notice.gotolightning":`이 기능을 사용하려면 Lightning 버전으로 이동하세요`,
"label.batchtransfer.pleaseselecttransferreddata":`이동 데이터를 선택하세요`,
"label.mr.title.mailingAddress":`우편주소`,
"vue_label_approve_no_response":`미반응`,
"component.event.label.title":`곧 진행될 이벤트`,
"label.mobile.setup.confirm":`모바일기기 기본 메뉴 아이콘의 위치를 변경하고 있습니다. 변경이 완료되면 이전 메뉴에 설정된 모든 모바일기기 메뉴 아이콘이 삭제됩니다. 메뉴에 모바일기기 아이콘을 다시 설정하지 않는 한 시스템은 기본 설정된 목록에서 무작위로 선택합니다.`,
"label.tianyancha.approvaltime":`비준 시기`,
"label.download_merge_file":``,
"label_display_quota":`정액 보기`,
"label.publishreadonly":`공용 읽기 전용`,
"label.campagin.roi.query.roi":`마케팅 행사 ROI`,
"label.dashboardSetup.lookup":`대시보드 찾기`,
"vue_label_notificationcenter_nomessages":`읽지 않은 메시지가 없음`,
"label.create.object":`대상 새로만들기`,
"label.social.campaign.null":``,
"label.console.step6.left":`왼쪽으로 고정합니다. 리스트를 항상 보이게 합니다.`,
"label.line":`열`,
"label.bottonandlink.introduce":`다음은 버튼과 링크 리스트입니다.버튼이나 링크를 추가하려면 페이지 레이아웃을 편집하십시오.<br/>버튼은 자세한 정보 페이지, 관련 리스트, 리스트 뷰에 표시됩니다:<br/>      1.상세 정보 페이지의 버튼이나 링크를 설정하려면 페이지 레이아웃을 편집하십시오.<br/>      2.해당 리스트에 있는 버튼이나 링크를 설정하려면 페이지 레이아웃에 있는 해당 리스트의 속성을 편집해 주십시오.<br/>      3.리스트 뷰의 버튼이나 링크를 설정하려면 "검색 레이아웃" 에서 리스트 뷰 레이아웃을 편집하십시오.<br/>`,
"label.layout.list1":`리스트1`,
"label.mr.title.customerName":`고객 명칭`,
"label.user.text":`정문`,
"label.nolastestrecord":`최신 기록이 없습니다`,
"label.emailobject.appointment.urltext1":`저의 일정입니다. 확인해 주세요.`,
"label.chat.topic.my.favorites":`나의 즐겨찾기`,
"label.select.dashboar.cd0":`그룹분류 필드를 비워둘 수 없습니다`,
"label.data.downpage.e_title.num2":`2. 대상별로 내보낼 데이터를 선택하면, 데이터 내보내기 방식을 선택해야 합니다.데이터 내보내기 방법: 사용자 설정 내보내기, 템플릿으로 내보내기, 템플릿 내보내기.`,
"message.error.user.service.login.unconn":`서버에 에러가 발생해 잠시만 기다리세요`,
"label.escalation.setup.newentries.title":`규칙 조항 편집`,
"label.import.step1.above2000":``,
"label.ccchat.person.allowinvite":`동료 초대 허용`,
"label.input.number.between":`{0}과 {1} 사이의 숫자를 입력해 주세요.`,
"label.forecast.shrepage.wpfmanager":`파견 예측 책임자`,
"label_server_is_time_out":``,
"label.indochina.standard.time":`인도 표준 시간`,
"label.cpq.quote.sync.opportunity.failure":``,
"label.emailobject.send100emails":`죄송합니다. 매일 메일 100개만 전송이 가능하며 다시 선택하세요!`,
"label.dashboard.snapshot.end":`마감`,
"label.jiandangfenpei.rightlist":`분배된 프로필`,
"label.input.string.length.between":`길이가 {0}과 {1}사이의 문자열을 입력하십시오`,
"label.multilang.lookfiltercondition.select":`{0}번째 행 조건이 잘못되었습니다. 필드를 선택해야 합니다!`,
"label.datamanage.lead.namenull":`주의: '잠재고객 명칭"필드에 값을 부여하지 않으면 기록을 불러올 수 없습니다!`,
"label.forecast.detailforecast.button.saveandfresh":`저장 및 새로고침`,
"label.venezuela.time":`베네수엘라 시간`,
"label.same.analyze.miaoshu1":`더 많은 규칙이 필요하면 사용"`,
"label.twomb":``,
"label.event.moveup.7hour":`7시간 앞당깁니다`,
"label.weixin.forgot.password":`비밀번호를 잊으셨습니까?`,
"label.import.page1.diledsizelimited":`2. 올리는 파일의 최대 용량은 100M임`,
"label.file.foldername":`폴더명`,
"label.multilingual.open":``,
"label.dashboard.snapshot.refresh.failed":`대시보드 캐시 새로고침 실패`,
"label.marketsea.memberfieldselectone":`뷰 필드와 멤버 뷰 필드의 최소 한개를 선택하세요`,
"label.trigger.createdate":`시간 생성`,
"label.ccpeak.operation.sharetab":`공유 탭 조작:`,
"label.partner.message.admin.access":`시스템 관리자만 로그인할 수 있습니다`,
"label.emailsync.status.email":`작업 이메일`,
"chatter.error":`오류: 업로드할 파일을 먼저 선택하십시오!`,
"label.role.viewinlist":`리스트 뷰로 보기`,
"label.tag.addtags.title":`라벨`,
"setup.mainpage.label.welcome6":`사용자가 프로그램밍 지식과 코드 개발 필요 없이  CloudCC 시스템에서 모든 대상자에 대해 각종 필드를 설정할 수 있다. 필드 유형에 검색 관계, 단일 선택 필드, 중복 선택, 공식, 자동 순번, URL , 전화, 팩스, 이메일, 체크 상자, 날짜, 시간, 숫자, 글, 글자 상자, 선택 항목(택일형, 중복형), 화폐 등이 포함된다.`,
"label.delete.rule.successfully":``,
"label.field.duplicate.error.msg6":`필드값이 중복됩니다. 기록이 존재합니다:`,
"label.stdashbord.xsld.business.jhzsl":`기회 총량`,
"label.compact.layout":`중요 정보 레이아웃`,
"label.checkfield.merge.introduce":`병합 후 기록에 남겨질 값을 선택하십시오.`,
"earlieststarttime.duedate.time.illegal":``,
"label.dataimport.validate.prompt":`인증 규칙 안내`,
"message.setuptip":`생성 후, 삭제할 수 있습니다.`,
"template.report.customer.collection.statistics":``,
"vue_label_homepage_dashboardcomponents":`대시보드 구성 요소 편집`,
"setup.mainpage.label.welcome30":`CloudCC 플랫폼은 진정한 클라우드 캘큐레이팅 플랫폼이며 개방적인 특성, 표준의 집성 방식, 융통성이 있는 맞춤형 작업이 각종 업종에 적용되며 제3자 소프트웨어를 통합하여 업체 데이터 실시간 관리를 실시해 최대하게 고객의 전면적이고 깊이 있는 관리 니즈에 만족시킨다. CloudCC 플랫폼은 모든 업체의 응용 프로그램이나 시스템과 호환되어 SAP, Kingdee，YonYou등 제3자 소프트웨어가 포함된다. 융통성이 있는 SOA구조 아래의 표준 Web Service방식을 채택해 파괴성 없고 기술 의뢰성 및 공급 업체 독점성이 없다.`,
"label.SMS.new.det":`문자 메시지 알림을 생성으로 하나 이상의 업무 프로세스 규칙, 승인 과정과 관련시킵니다. 문자 메시지의 알림을 변경하면 어떤 변경도 이와 관련된 모든 규칙, 승인에 적용됩니다.`,
"lable.product.page.previous":`뒤로 이동하기`,
"label.recordtype.labelname":`기록 유형 라벨`,
"message.error.system.service.failure":`서비스 실행이 실패하였으며 시스템 관리자에게 연락하세요!`,
"label.visualpagefolder":`페이지 폴더`,
"label.username":`사용자명`,
"label.data.downpage.i.title.num5":`5. 데이터의 정확도를 심의하세요`,
"label.permission.manage":`분배 관리`,
"label_emailsync_status_user":`사용자`,
"label.weixin.voting.least.two":`투표 옵션이 최소 2개입니다.`,
"label.tabpage.thisrecord":`이 기록`,
"label.icon.119":`칠판`,
"label.partner.common.webSit":`도메인 네임`,
"label.email.form.html2":`['텍스트만'으로 전환]`,
"label.appupload.upload.noversion":`업로드된 버전이 없습니다`,
"label.appointmentpage.wizard.subtitle1_2":`초대인의 표준 시각대는 {0}입니다`,
"MR":`중복 선택 찾기`,
"label.partnerCloud.orderingPlatform.availableBalance":``,
"label.schedulejob.setup.schedule.st3":`3번째`,
"label.reportsSubscriptionPage.email.general":`간략`,
"label.setsharerule.step4":`4단계: 권한을 선택합니다`,
"front-epwechat-module-v1-info-desc":``,
"message.duplication.label.isactive":`사용 여부`,
"pagecreator_systemstyle_label_linkcolor":`링크 컬러`,
"label.import.page1.alertfiledsize":`올리는 파일은 100MB를 초과할 수 없음!`,
"tomorrow":`내일`,
"label.publicdashboard":`미보관 공용 대시보드`,
"label.knowledgebase.same.taborworkspace":``,
"homepage.layout":`메인페이지 레이아웃`,
"label.emailobject.trackemailopening":`수신확인`,
"label.unlock.tip":`잠금을 해제하면 편집할 수 있습니다`,
"lable.account.NextzDays":`미래 90일`,
"vue_label_report_throw":`폐기`,
"label.icon.102":`일정`,
"label.payments.paytip2":`유료 버전으로 업그레이드하여 '확인'을 클릭한 후 윈도를 닫아 CRM 시스템을 새로고침 하세요.`,
"label.customfields.email.tip":`사용자에게 메일 주소를 입력할 수 있도록 하여 인증을 통해 정확한 형식인지 확인합니다. 한 연락담당자와 잠재 고객에 대해 이 필드를 지정하면 사용자가 '메일 보내기'를 눌렀을 때 주소를 선택할 수 있습니다.주의, 사용자 설정 메일 주소는 대량 메일에 사용할 수 없습니다.`,
"label.test_visitors":``,
"label.workflow.immediatelyoperate":`즉시 업무 프로세스 조작`,
"label.approvalstep4.tip":`승인 페이지는 승인자가 실제 승인하거나 요청을 거절하는 곳입니다.다음의 선택항목을 사용해 이 페이지에 표시할 필드를 선택하십시오.`,
"label.ccchat.person.invite.failsend":`아래 초대가 전송되지 않았습니다. 관리자에게 연락하십시오.`,
"label.import.index.obj":`대상자`,
"label.multilang.leadscore.countnum":`{0}번:`,
"label.report.error.typefind":`그룹 정보로 보고서 유형을 찾을 수 없습니다`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`그룹분류 데이터를 사용할 수 없습니다!`,
"lable.Create.new.template":``,
"label.knowledgebase.display.error":``,
"label.emailobject.template.message2":`메일 택스트에서 삽입한 필드가 관련된 기록과 매칭되지 않아 값을 취하는 데에 실패할 수 있습니다.`,
"label.productsales.today.taskcomplete":`완성으로 설정`,
"label.emailobject.selectone":`메일의 수신인으로 최소 한개 기록을 선택하세요`,
"button_partner_workspace_saveas_memo":`현재 파트너 클라우드를 다른 '템플릿'으로 저장합니다.`,
"vue_label_help_detail":`상세 기록`,
"label.tabpage.minutesagoz":`분 전`,
"label_tabpage_characterz":`스타트 문자`,
"message.error.accesstoken.null":``,
"label.textMessageObject.send100":`죄송합니다. 매일 문자 100개만 전송할 수 있으며 다시 선택하세요!`,
"vue_label_commonobjects_detail_record_call":`기록 전화 새로 만들기`,
"label.campaignmember.main.addlead":`멤버 추가- 기존 잠재고객`,
"setup_mainpage_label_welcome30":`CloudCC 플랫폼은 진정한 클러우드 캘큐레이팅 플랫폼이며 플랫폼의 개방적인 속성, 표준한 통합 방식, 융통성이 있는 맞춤형 디자인이 각 업종에 적용되며 제3자 소프트웨어와 결합해 업체 데이터 관리의 실시간 통합이 이루어져 최대한 고객의 전면적이고 심도 있는 관리 니즈를 만족시킵니다. CloudCC 플랫폼이 모든 업체 응용 프로그램이나 시스템과 통합할 수 있어 SAP,Kingdee,Yonyou 등 제3자 소프트웨어가 포함됩니다. 융통성이 있는 SOA 구조 하의 표준 Web Service 방식이 파괴성, 기술 의존성이나 공급업체 고정이 없습니다.`,
"label.file.library.deleteprompt":`문서 라이브러리 멤버{0} 삭제하시겠습니까?`,
"label.wtd.changefields.title":`Web to CloudCC 설정`,
"label.sendmail.step1":`1단계: 포함할 수신자를 지정합니다`,
"label.cpq.newquote.createorder.checkbox.selected":``,
"label.emailtocloudcc.name":`명칭`,
"message.error.object.nullbinding":`binding 내용이 없습니다`,
"B":`체크 상자`,
"label.pc.endtime":`허가증의 만기가 이미 30일 미만입니다. 정상적인 사용을 방해하지 않기 위해서 즉시 비용을 충전해 주십시오.`,
"label.visualpage.section.start":`시작점에 라벨로`,
"label.partnerCloud.basicSetting.available":``,
"label.data.exportall.all_desc":`현재 사용자가 볼 수 있는 모든 대상의 데이터를 내보냅니다.`,
"label.editor.layout":`검색 레이아웃 편집`,
"label.send.chatter":`게시물 발표`,
"label.h5.chatter.reply":`빠른 답장`,
"component_chatter_post_button_file":`첨부파일 추가`,
"label.emailobject.emaildetail.button.reply":`답장하기`,
"label.eidt.queue.title.desc":`명칭은 유일해야 하여 알파벳으로 시작해야 하며 알파벳 대소문자, 숫자, 밑줄만 포함할 수 있고 길이는 40 이상일 수 없습니다.`,
"label.campaign.channel.input.url":`5. 사용자가 가입 후 볼 수 있는 정보를 설정해 감사 페이지, 이벤트 홍보 전단지나 입장권이 될 수 있습니다:`,
"label.compact.layout.assign.tip":`이 표는 기록 유형에 따라 중요 정보 레이아웃 분배를 보여줍니다.`,
"vue_label_fall":``,
"label.trigger.save.failed":`데이터가 없어 저장 실패했습니다`,
"label.appupload.upload.tips.report":`주의: 나의 개인 설정 보고서와 '미보관 공용 보고서"의 보고서, 구 보고서가 소프트웨어 패킷에 추가될 수 없으며 이 리스트에서 볼 수도 없습니다.`,
"label.tianyancha.businessverify.rewriteall":`모든 데이터를 다시 입력합니다`,
"label.campaign.channel.step6.remark4":`주의: 잠재고객 소유인이 현재 마케팅 행사 소유인이나 마케팅 채널 초대자입니다.`,
"front-kefu-moudle-called-num":``,
"label.approvalstep4":`4단계: 승인 페이지 레이아웃에 나타난 필드를 선택합니다`,
"label.login.verification.please.scan":`스마트폰에 있는 MFA 앱으로 코드를 스캔해주세요`,
"label.invoice.message.statusupdated":`Invoice 상태 업데이트 되었습니다`,
"label.pc.ui.2018.subject":`주제`,
"label.area.notexist.userinfo":`없는 사용자 그룹`,
"label.newuser":`사용자 새로만들기`,
"label.chat.micropost.share":`게시물 공유`,
"label.locatedupcurrentvalue":`현재 값 위에 있는 값`,
"vue_label_systemSettings_course":``,
"chatter.group.public":`공용`,
"label.reportsSubscription.entrance":`구독`,
"front-kefu-moudle-v1-online-at":``,
"label.rejectbehaviourselect":`이 절차의 거부 작업<strong>만</strong> 수행하고 승인 요청을 가장 가까운 승인자로 되돌려 보냅니다.(1단계를 되돌려줍니다)`,
"vue_label_commonobjects_view_currentviewset":`현재의 기본 뷰 설정을 취소하여 가타 뷰를 기본 뷰로 설정할 수 있습니다.`,
"lable.currencyAdv.and":`와`,
"label.appexchange.installedpage.publish":`발표자`,
"label.tab.profile.ismobile":`모바일기기에 응용합니다`,
"label.data.setok.t.desc2":`데이터 템플릿 페이지로 이동`,
"label.email_required":``,
"label.tabpage.fullscreenz":`전체 화면`,
"chatter.sticker.set":`게시물 팔로우업 설정`,
"label.mobile.phone.year":`연도`,
"label.projectManagement.next.page.before":``,
"pagecreator_button_pcpage":`컴퓨터`,
"label.dashboard.xsld.percent":`비율`,
"label.ccpeak.service.checkerror":`문법 점검 실패`,
"label.icon.26":`폴더`,
"label_partner_common_webSit_memo":`귀조직 파트너 클라우드의 기본 도메인 네임이:`,
"label.unselectfile":`파일을 선택하지 않았습니다`,
"label.take.notice":`주의`,
"message.error.filename.null":`fileName이 필수 요소입니다!`,
"vue_label_SMS_nophone":`전화 번호가 없음`,
"label.area.assignuser":`사용자 분배`,
"label.icon.176":`안내`,
"label.icon.21":`화폐`,
"message.error.system.service.deletedeny":`데이터가 관련되어 있어 삭제할 수 없습니다!`,
"label.compact.layout.main.tip":`이 대상의 기록이 CloudCC에서 리스트 항목으로 나타날 때 사용할 중요 정보 레이아웃을 선택하십시오.`,
"label.emailtocloudcc.delete":`삭제`,
"label.dashboardSetup.showdw.d2":`천만`,
"front-kefu-moudle-hqyyjlsb-admin":``,
"label.partnerCloud.basicSetting.userCounts":``,
"front-kefu-moudle-calling-num":``,
"label.alldocument":`모든 파일`,
"coderules.nullvalue1":``,
"lable.automatically.shared":`자동 공유`,
"label.batchadd.newbatchpage.save.emptyselect":`필수 선택 항목이 비어 있어 확인하세요`,
"vue_label_homepage_card_30dayswithout":`30일 연락 안된 업무 기회`,
"label.multilang.dupicatecheck.onegroupnote":`최소 두개의 데이터를 체크하고 버튼[선택된 정보 로딩]을 클릭하여 데이터 병합 페이지로 들어가십시오.현재 {0}번째 그룹 기업정보로, 총 {1}건이 기록되어 있습니다.`,
"UG.activity.03":`일정 예약`,
"label.pc.oldpage":`구버전 인터페이스`,
"label.exchange.sync.state.task.m2":`최후 60분에 동기화된 기록:`,
"label.setmovable":`행사 설정`,
"label.sendemail.send.loginfail":`이메일에 로그인할 수 없습니다. 이메일 정보를 다시 설정해 주세요`,
"label.copy.quote.lines":``,
"label.copying.reward.to.groups":``,
"label.ems.connect.error":`서버에 연결 실패하여 점검하세요.`,
"lable.account.Tomorrow":`내일`,
"label.manageAll.sta2":`승인 통과`,
"label.create_form":``,
"label.ems.saveDetail.error.msg":`저장할 수 없어 이메일 계정, 비밀번호 등을 확인하십시오.`,
"label.service.gantt.distribution.recommendation":``,
"label.email.track.attachment.size.control2":`업로드 파일 크기가 10M을 초과해 업로드 할 수 없습니다.`,
"lable.product.pricebooks.add":`가격매뉴얼에 추가`,
"label.login.time":`로그인 시간`,
"label.tabpage.yes1z":`1임`,
"label.SalesCommitmentKanBan":`판매 승낙 간판`,
"label_partner_workspace_myspace":`나의 작업 공간`,
"chatter.like":`개 '좋아요'를 받았습니다`,
"lable.PowerProcess.number.input":``,
"chatter.coll":`저장`,
"label.campaign.channel.img.remark":`주의: 이미지 크기는 2M 이상일 수 없습니다`,
"label.field.duplicate.error.msg7":`중복된 데이터`,
"vue_label_pool_discard":`폐기`,
"label.service.gantt.total.planned.duration":``,
"label.weixin.click.loadmore":`더 많이 보기`,
"label.help.new.features.yd":`모바일기기 새 인터페이스 조작 매뉴얼`,
"label":`라벨`,
"label.quickbooks.viewlist.total1":`합계 {0}개 인보이스 항목, 총 {1} 입니다`,
"front-kefu-moudle-v1-input-publicKey":``,
"label.approval.allowed.reject":``,
"label.visualpage.folder.notdel":`이 폴더에 파일이 존재해 삭제될 수 없습니다.`,
"label.projectManagement.charging":``,
"label.ccservice.validate":`대상API가 {0}의 {1}필드 대응값은 {2}이며 형식이 잘못되어 정확한 숫자를 입력하세요!`,
"message.unbind.mfadevice.no.permission":`MFA 설비의 연동을 해제할 권리가 없어 관리자에게 연락하세요`,
"label.partner.new.step3.meno":`무엇을 입력할 지 확실하지 않으십니까? 걱정하지 마세요. 나중에 수시로 변경하실 수 있습니다.`,
"label.import.page3.importsucceedtip":`불러오기 시작, 완료 후 자동으로 연동된 메일 주소로 발송된다`,
"label.customsetting.visible.protect":`보호됨`,
"label.publishreadandwrite":`공용 읽기/쓰기`,
"vue_label_file_add_most_once":`단번에 최대 추가`,
"label.salescloud.teamrole.optionlist.group":`업무기회그룹 멤버와 고객 그룹 멤버로 역할을 배분합니다.`,
"label.appointment.wizard.subtitle7":`장소`,
"label.task.dateminus":`마이너스`,
"label.data.exp.zippwd":`압축 파일 비밀번호 수동 입력`,
"UG_Forcast_09":`다음 단계`,
"message.duplication.label.allselectlink":`[모두 선택]`,
"label.file.ccchat.selectfromcloudcc":`CloudCC에서 파일을 선택하십시오`,
"label.ems.addaccount3":`계정 추가`,
"front-epwechat-module-v1-schedule-sync":``,
"label.h5.manage":`응용프로그램 관리`,
"setup.layout.label.nobutton":`선택할 수 있는 버튼이 없음`,
"label_component_hotdeal":`인기 거래`,
"template.dashboard.contract.analysis":``,
"vue_label_dashboard_editcomponent":`구성 요소 편집`,
"label.quotationInformation":``,
"label.data.file.validation_rules":`인증 규칙 실행`,
"label.ccpeak.construction.shareobj":`한 대상의 공유 차트 대상을 구성하려면 대상 API 명칭 및 공유 표시를 불러와야 합니다:`,
"label.wei.pollinformation":`투표 기본 정보`,
"label.quickbooks.viewlist.total3":`합계 {0}개 지급 항목, 총 {1} 입니다`,
"label.paging.totalofpagesnoid":`총 {0}페이지`,
"label.unlock":`잠금 해제`,
"front-invoice-online-payment-information":``,
"label.permission.systempermission":`분배된 시스템 권한`,
"message.error.object":`호출 서비스 시 대상이 정의되지 않는 것을 발견했습니다.`,
"font-trade-module-v1-invoice-intro":``,
"label.userinfo.pwdexpired":`현재 비밀번호가 만료되었습니다.보안상의 이유로 비밀번호를 변경해야 합니다.`,
"label.userphoto.photo":`프로필 사진`,
"label.tabularreport.filterrecord":`기록을 보기로 사용하는 조건을 선택합니다`,
"label.partnerCloud.orderingPlatform.rechargeIt":``,
"label.icon.120":`컴퓨터`,
"label.projectManagement.select.new.type":``,
"vue_label_commonobjects_detail_customer_details":`고객 상세 정보 로딩 중`,
"label.ems.status":`상태`,
"label.validate.function.description":`인증 규칙에서 java 문법에 맞는 임의의 함수를 사용할 수 있습니다. 표현식은 불 값으로 반환해야 합니다. <br>CloudCC에서 제공하는 특정 함수도 사용할 수 있습니다: isNew(),isChanged(필드 Api 명칭__c),priorValue(필드 Api 명칭__c),priorValue()object유형을 반환하고 맞는 필드 유형으로 변환해야 합니다`,
"label.escalation.setup.newaction.step2":`2단계: 개별안을 자동으로 분배할 사용자를 선택하십시오`,
"label.forecast.customforecast.searchforecast":`예측 조회`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":``,
"vue_label_commonobjects_view_notice_deletefailreason":`id가 {0}인 데이터 삭제가 실패하였으며 실패 이유는 {1} 입니다.`,
"page.field.masterinput.remark":`사용 중인 마스터 슬레이브 입력에 대해 프론트 메뉴의 새로운 기록에 적용할 때 입력한 관련 리스트 기록`,
"lable.SalesCommitmentKanBan.contractName":`계약서 명칭`,
"front-gantt-module-add-milestone":``,
"label.callcenter.save.error":`중복 저장하지 마십시오`,
"label.workflow.selectobj":`1단계: 대상을 선택합니다`,
"label.validate.function.category.all":`-- 모든 함수 종류 --`,
"label.multilang.uploadifupage.select":`총 {0}개의 파일을 선택했습니다`,
"label.weixin.dragsort":`나의 응용에 아이콘을 드래그 앤드 드롭으로 다시 정렬할 수 있습니다`,
"N":`숫자`,
"label.knowledge.article.translation.completed":``,
"label.weixin.myapp":`나의 응용`,
"label.icon.138":`화폐`,
"vue_label_chat_create_discussion_now":`토론 새로 만들기`,
"label.knowledge.recover.article":``,
"label.ccpeak.use.class.time.map":`Map 집합에 유입으로 방문`,
"front-email-payment-error-tips":``,
"label.service.gantt.ziyuan":``,
"label.upload.error":`실패하였습니다`,
"label.staticresource.upload.error":`정지 리소스 업로드하는 데 오류가 발생했습니다!`,
"com.cloudcc.login.error.message.loginfail":``,
"pagecreator_button_back":`이전`,
"label_tabpage_skip":`이동`,
"label.pw.old":``,
"pagecreator.layout.label.modifylayout":`레이아웃 에디터`,
"vue_label_chatter_share_group":`그룹과 공유하기`,
"label.app.edit":`응용프로그램 편집`,
"label.user.Email.repeat":``,
"label.field.quilt":`이 필드가`,
"label.projectManagement.Groupuser":``,
"label.deleteall":`모두 삭제`,
"label.appexchange.download.tiaoguo.mes":`다음 충돌 구성 요소를 설치하는 것을 건너뜁니다:`,
"label.sendemail.recycle.operatehello":`#username 안녕하세요:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`최대 20개의 템플릿을 선택할 수 있습니다!`,
"label.campaignmember.main.deleteleaddesc":`마케팅 행사에 전부 잠재고객 한번에 모두 삭제`,
"Opportunity_Detailed_Phase_Label_Popup_003":`체류 시간`,
"vue_label_file_no_title":`제목 없음`,
"label.data.dataexpalltype.all.desc":`현재 사용자의 모든 보기 권한이 있는 대상자의 데이터를 내보내기`,
"label.dashboard.unit2":`단위: 백만`,
"label.list.userinterface.isrelatedlist":`관련 리스트 호버 사용`,
"label.role.tree":`조직 역할 등급 구조가 다음과 같다:`,
"label.campagin.roi.zcsl":`등록 수량`,
"message.error.forecast.setupchange":`다른 사용자가 데이터를 삭제하거나 변경해 시도 방문한 데이터를 찾을 수 없습니다.`,
"label.sendemail.changeowner.dataname":`파일 명칭이 :#dataname인 파일`,
"label.salescloud.opportunity.contactrole.optionlist":`업무기회 연락담당자 역할 선택 항목 리스트값`,
"setup_mainpage_label_welcome1":`관련 권한이 필요합니다`,
"UG_activity_02":`업무 분배`,
"label.tabpage.erraddressz":`메일 주소 형식에 오류가 발생하여 정확한 메일 주소 입력하세요.`,
"label.weixin.nicheng":`위쳇 닉네임`,
"label.forecast.settings.mrsz":`기본 숫자 예측`,
"label.campaign.channel.download.size3":`작은 사이즈: 300*300 픽셀`,
"label.icon.73":`공작기계`,
"label.ServiceCloud.suoxuchanpin":``,
"label.escalation.setup.newrule.description":`규칙명을 입력하여 사용된 체크상자를 선정하며 이 규칙을 자동 개별안 업데이트에 적용합니다. 이 규칙을 사용하면 현재의 개별안 업데이트 규칙을 금지합니다.`,
"label.data.import.setup.whichfield.cloudccid":`CloudCC 아이디`,
"label.validate.function.funcExplain.PRIORVALUE":`object유형으로 돌아가 대응한 필드 유형으로 전환해야 합니다`,
"Lead.Scoring.Warning.001":`하나의 고객 시스템에서 잠재 고객 새로 만들기, 편집 때 자동으로 채점된다. 단 모두 불러오기나 포트로 새로 만드는 잠재 고객에 대한 모든 채점은 수동으로 진행된다.`,
"label.tianyancha.businessverify.msg9":`본 <협의>의 해석권이 베이징 CloudCC에 있습니다.`,
"label.compact.layout.tip":`관건 정보 레이아웃은 자세한 정보를 기록하기 위한 키 필드를 상세 페이지에 표시할 때 사용합니다.`,
"label.visualpage.btype":`보고서`,
"label.textmessage.vonage.settings":`설정`,
"label.field.not.exites":`존재하지 않습니다!`,
"label.payment.switch.version":`버전 전환 중`,
"label.ems.hour":`시간`,
"label.weixin.cannot.edit":`이 파일 형식은 편집할 수 없습니다!`,
"chatter.pt.limit":`최대 파일 크기는`,
"label.quote.detailinfo.add":`보고서 명세 추가`,
"component.setup.label.displayfield":`필드 보기`,
"vue_label_report_reportfolder":`보고서 소속 폴더`,
"label.gbkencoding":`중국어 간체(GBK)`,
"front-kefu-moudle-v1-Transfer-to":``,
"label.file.stop.sharing.desc2":`공유`,
"label.textmessage.messageCannoutuse":`현재 사용할 수 없으며 시스템 관리자에게 연락하여 문자 기능을 사용하세요`,
"component_newrecords_label_type":`저장 종류`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`가격매뉴얼 새로만들기`,
"vue_label_newfile":`파일 새로 만들기`,
"label.reportTypcrtB":`관련대상(B) 관련대상을 선택하시려면 누르십시오`,
"label.knowledgebase.type":``,
"label.report.select.format":`보고서 형식을 선택합니다`,
"component.todaytask.label.title":`오늘의 임무`,
"message.undelete":`삭제 취소하시겠습니까?`,
"label.ccdocument.trace.retention":`흔적 보류 기능`,
"label.publicgroup.tip":`공개된 그룹은 사용자의 집합입니다. 이에 각 사용자, 다른 그룹, 특정 역할과 범위 내의 사용자가 포함될 수 있습니다.`,
"label.forecast.settings.lable2":`요약 예측 기본 뷰`,
"label.projectManagement.positive.integer":``,
"label.projectManagement.one.work.list":``,
"label.or":`|| 혹은`,
"label.projectManagement.no.person.in.charge":``,
"vue_label_commonobjects_detail_an_email":`메일을 전송합니다.`,
"front-electronic-signature-field-mapping":``,
"label.marketsea.name.error":`고객풀 명칭을 입력하세요`,
"component.setup.button.appurl":`본 시스템 URL`,
"label.mr.title.button.group1":`번째`,
"chatter.contact":`연락처`,
"vue_label_pool_hasfixed":`고정 협력 채널이 있음`,
"lable.list.queue.des":`대열을 통해 사용자 그룹이 더욱 효율적으로 업무량을 관리할 수 있습니다. 대일이 라우팅부터 사용자 그룹 멤버 처리하는 위치까지 기록할 수 있습니다. 기록이 대열에 보존돼 있어 사용자가 이들을 처리하거나 이들을 다른 대열로 이동할 때까지 보존돼 있습니다.대열마다 지원한 대상을 지정할 수 있어 대열에서 기록을 검색 허용하는 사용자를 지정할 수 있습니다.`,
"label.reportsSubscriptionPage.condition":`설정 조건`,
"label.transwork":`번역 작업 공간`,
"label.batch.batchopration.resel":`이동 데이터를 다시 선택해 "OK" 버튼을 눌러 뷰 리스트 페이지로 바로 이동합니다.`,
"label.cloudccsite.new":`웹사이트 새로만들기`,
"label.button.select.page.required.field":`페이지의 필수 입력 필드를 선택합니다`,
"label.pagelayout":`페이지 레이아웃`,
"label.weixin.trace.record":`기록 팔로우업`,
"label.emailtocloudcc.clear":`비우기`,
"label.checkfield.find":`중복 검사`,
"message.view.count.title0":`현재 페이지 통합`,
"label.reportsSubscriptionPage.schedulereport.frequency":`빈도`,
"setup.mainpage.label.welcome5":`사용자 설정 필드`,
"label.implementation.details":`실행 상세 정보`,
"label.attendance.history":`출석 체크 이력`,
"label.is.pigeonhole":`파일 문서 보관 여부`,
"lable.account.CurrentandPreviousFYt":`현재 및 지난 2개 회계 연도`,
"label.forecast.customforecast.tab.opportunity":`판매 기회 하급 메뉴`,
"label.version.business.track":`비즈니스 기회 팔로우업`,
"label.profilelayoutedit.selectrecordtype.tip":`이 사용자 프로필을 위해 기록 유형을 선택하십시오.해당 기록 유형 필드를 이 프로필과 연결된 페이지 레이아웃에 추가해야 이를 상세 정보 페이지와 편집 페이지에 표시할 수 있습니다.`,
"label.campagin.roi.zclzb":`등록량 점유율`,
"label.validate.function.funcFormat.WEEKDAY":`평일(일자)`,
"label.view.sort.message":`{!sort}로 정렬하기`,
"page.field.masterinput.sort":`마스터 슬레이브 입력은 저장된 순서대로 보여줍니다`,
"label.selected.field":`선택한 조회 필드`,
"label.product.proofTwo":``,
"vue_label_report_filtercondition":`선별 조건`,
"label.forecast.shrepage.desc1":`이 페이지에서 열거한`,
"label.file.copy.link":`링크 복사`,
"vue_label_chat_movedto":`{name}이 {label}를 {newField}으로 변경한다`,
"label.layout.new.built":`새로 만든 부분`,
"label_tabpage_crecordtypez":`기록 유형 변경`,
"label.report.searchcustominfo":`사용자 설정 보고서를 조회하는 데 매칭하는 키워드를 입력하십시오`,
"chatter.feed.menutype.user":`인원`,
"label.recordtypeselect":`기록 유형을 선택합니다`,
"label.partner.new.step3":`3단계: 명칭과 URL을 입력합니다`,
"label.newCustomReportType":`사용자 설정 보고서 데이터 소스 새로만들기`,
"label.service.gantt.day.timescale":``,
"label.displaytype3":`리스트 버튼`,
"label.weixin.discharge.rate":`배기량`,
"label.weixin.menu.message":`메뉴 정보`,
"label.mask.show.all.characters":`모든 부호 마스크 보기`,
"label.quickbooks.fieldlabel.billingaddress":`영수증 발행 주소`,
"Dashboard.View.All":`모든 대시보드`,
"setup_mainpage_label_welcome22":`조작 안내: 페이지 좌측 메뉴를 클릭하여→ 설정 관리→ 통신 템플릿→ 메일 템플릿`,
"chatter.group.groupInformation":`그룹 정보`,
"front-epwechat-module-v1-input-secret":``,
"lable.Set.value.prompt":``,
"label.appupload.upload.from":`에서`,
"label.weixin.postunsolve":`만료`,
"label.cooperation.all":`모두 협동`,
"lable.PowerProcess.close.time":``,
"lable.opppdt.selPdt.leastone.fields":`최소한 한 필드를 선택하십시오`,
"label.emailtocloudcc.help":`정확한 메일 주소 비밀 번호나 권한 부여 코드를 입력하세요. 이메일 서비스가 IMAP/SMTP서비스가 작동되어야 제3자 디바이스로 등록할 수 있다면 먼저 메일로 본 서비스가 작동되어 있는 지를 확인하고 관련된 권한 부여 코드를 복사해서 비밀 번호 상자에 입력하세요.`,
"label.attendance.offwork.time":`퇴근 시간`,
"front-gantt-module-v1-project-gantt":``,
"label.chuangming.description":`CHAUNG MING 문자 인터페이스 정보를 배치해 귀사의 문자 업무 수요를 만족시킵니다.`,
"label.custom.lead.notice.account.name":`안녕하세요! 잠재고객이 전환으로 님을 고객, 연락담당자와 업무기회의 소유인으로 지정합니다. 고객명칭:`,
"label.emailobject.failedtosend1":`전송 실패 사유: 메일 인증이 무효되어 개인 메일을 다시 연동하세요!`,
"vue_label_ccchat_notice_updaterecordsuccess":`본 기록 업데이트 완료`,
"label.dayinmonth":`개월의`,
"label.sendemail.chat.follow":`존경하는 #name:\n\n    안녕하세요！#userName이 님을 팔로우했습니다.`,
"label.emailsync.form.emialpassword":`비밀 번호`,
"component_task_label_subject":`주제`,
"label.projectManagement.please.enter.a.positive.integer":``,
"lable.account.NexteDays":`미래 7일`,
"label.appupload.upload.managed":`최대 1개 관리 소프트웨어 패킷을 생성할 수 있습니다!`,
"label.data.dataexpalltype.all.desc1":`1. 모든 압축 파일을 내보내면 비밀 번호가 자동 생성되거나 수동으로 입력할 수 있다. 자동 생성한 비밀 번호가 데이터를 내보내기 성공한 후 사용자 메일로 발송된다. 수동으로 입력한 비밀 번호는 사용자 메일로 발송되지 않아 본인이 직접 입력한 비밀 번호를 기억해야 한다. 입력하지 않는 경우 비밀 번호가 없는 것으로 설정된다.`,
"label.step1.total3":`1단계, 총 3단계`,
"label.escalation.setup.detail.section":`규칙 상세 정보`,
"front-gantt-module-drag-task-sorting":``,
"label.isEnableVisualpage.new.title":`사용자 설정한 폐이지 방문 사용`,
"label_tabpage_yesz":`네`,
"label.emailobject.emaildetail.button.replyall":`모두 답장하기`,
"label.knowledge.setting.data.one":``,
"label.manageAll.sel.one3":`내가 승인한 프로젝트`,
"UG_contact_01":`연락담당자를 어떻게 충분히 활용하시겠습니까?`,
"font-trade-module-v1-invoice-name":``,
"label.central.daylight.time":`센트럴 서머타임`,
"label.chatter.pastThirtyday":`지난 30일`,
"vue_label_commonobjects_detail_activity_ownevent":`이벤트 보유`,
"label.user.modify":`사용자 편집`,
"label.uploadTemplate":`템플릿 업로드`,
"setup_mainpage_label_welcome14":`업무 프로세스 맞춤 제작, 승인 과정 관리`,
"label.workmate":`동료`,
"label.displaycolumns":`보는 열`,
"label.emailnoticeintro":`메일 통지는 업무 프로세스 규칙을 촉발할 때 보내는 메일입니다.`,
"label.knowledge.category.button.five":``,
"template.report.business.opportunities.type":``,
"vue_labenl_applauncher_moreapp":`더 많은 응용 프로그램`,
"label.captcha.expired":``,
"template.chart.bnqzkhslmb":``,
"chatter.up.user.pic":`프로필 사진 업로드`,
"label.timezone.importtimezone.gmt":`그리니지 표준 시간 사용`,
"label.step.type":`검색한 멤버 유형을 선택합니다`,
"Dashboard.View.RecentlyView":`최근 확인 이력`,
"label.reportinthisfolder":`이 폴더의 보고서`,
"label.product.vies":`제품 뷰`,
"pagecreator_systemstyle_message_delete_fail":`양식 삭제 실패`,
"label.multipleactivity.singleUser":`한개 사용자`,
"vue_label_email_enter_subject":`주제 입력`,
"label_tabpage_alltabs":`모든 메뉴`,
"label.publicgroup.groupname":`소그룹명`,
"template.report.sales.performance":``,
"label.newWindow":`새 윈도우`,
"label.forecast.editopp.forecastedit":`편집 예측`,
"label.data.import.setup.whichfield":`솔루션의 어떤 필드를 매칭시키시겠습니까?`,
"label.noadd_dashboard":``,
"label.subtotal":`소계`,
"front-email-payment-weichat":``,
"label.attendance.position.alert":`표시부터 선택하세요`,
"chatter.follow.me":`팔로워`,
"label.mobile.more.details":`파일 상세 정보 편집`,
"Dashboard_SelectBoardToDisplay":`대시보드 옵션 카드의 대시보드 열기를 선택하세요`,
"front-gantt-module-v1-search-project":``,
"label.paging.totalofpagereport":`총 {0}페이지 ({1}개)`,
"label.from.phone":``,
"lable.Signatory":``,
"label.campagin.roi.query.roi2":`마케팅 행사 마케팅 채널 ROI`,
"label.tabpage.selectcontentz":`내용을 선택하세요`,
"label.multilang.lookfiltercondition.valuetypenotmate":`{0}번째 행 조건이 잘못되어 값 유형이 매칭되지 않습니다!`,
"label.interfaceconstraint.disabled":`해당 인터페이스가 금지 사용되었으며 시스템 관리자에게 연락하세요`,
"third":`3번째`,
"label.quickbooks.viewlist.status":`상태`,
"label.emailtocloudcc.select3":`기록 소유인을 선택하시오`,
"label.projectManagement.week.work":``,
"vue_label_pool_nodemand":`니즈 없음`,
"label.version.two.developapi":`2차 개발 API`,
"label.icon.82":`프린터`,
"label.batchadd.newbatchpage.suclist":`개 데이터 추가 성공`,
"label.checkfield.chooseatlast":`최소한 두 개를 선택해 주세요.`,
"label.quotation.deleteTip":``,
"label.generatepage.title.desc2":`저장 버튼을 누른 후 web 페이지와 방문 가능한 web URL링크를 생성합니다.`,
"label.licence.total":`허가증 총수`,
"Y":`찾기 관계`,
"label.wuzibiekesitan.time":`우즈베키스탄 시간`,
"label.component.hotdeal.nodata":`업무 기회 관련 데이터 없음`,
"label.data.exp.save":`템플릿 저장`,
"label.appupload.upload.tips.dashboard":`주의: 나의 개인 대시보드와 '미보관 공용 대시보드'의 대시보드가 소프트웨어 패킷에 추가될 수 없으며 이 리스트에도 나타날 수 없습니다. 관련된 구 보고서가 업로드되지 않습니다.`,
"lable.PowerProcess.new.PowerProcess":``,
"label.loginhis.search.download":`로그인 이력이 많아 다운로드를 검색할 때 최근 2개월의 이력 기록만 다운로드가 허용됩니다.`,
"label.tabpage.deleteview":`뷰 삭제`,
"label.chatter.recently":`최근`,
"label.industrialandcommercialverification.title":`공상 인증`,
"message.nextapproverlost":`지정한 다음 승인자가 비어 있습니다.`,
"front-kefu-moudle-v1-mfsysy-time":``,
"label.role.assign.tip":`<b>선택 가능한 사용자</b>리스트에 표시된 사용자를 선택해 역할에 분배합니다`,
"label.addattachment.step2.intruduce":`1단계와 2단계의 조작을 반복해 여려개 파일을 추가합니다`,
"vue_label_pool_returnreasondiscription":`반환 사유 내용`,
"label.weixin.report.range":`지속 시간`,
"label.wei.weiresearchtab":`투표 선택항목`,
"vue_label_report_setdrill":`드릴 다운 설정`,
"page_404_button_back":`뒤로 이동하기`,
"label.customfields.autonumber.tip":`시스템은 정의한 보기 형식에 생성한 일련 번호를 사용합니다.이 번호는 각 새 항목마다 자동적으로 증가합니다.`,
"label.ccpeak.return.allrecords":`모든 기록으로 돌아갑니다.`,
"label.ccchat.notmember.active.group2":`명칭에 불포함`,
"label.uniquename":`유일한 명칭`,
"label.emailtocloudcc.filed.ssl":`안전 연결`,
"chatter.emailFollowMe":`나를 팔로우할 때`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":``,
"label.projectManagement.actualworkinghours":``,
"label.quickbooks.fieldlabel.taxresale":`세수 리셀`,
"label.icon.12":`수리`,
"label.data.exp.dataexptemp":`데이터 내보내기 템플릿`,
"component_setup_tabs_label_add":`신규 추가`,
"label.appointmentdetail.wizard.title10":``,
"label.multilingual.close":``,
"message.error.username.notexist":`미지의 사용자명이어 다시 입력하세요!`,
"label.batchadd.newbatchpage.des2":`필드가 자동번호 유형일 경우 입력할 필요 없으며 저장 시 시스템에서 자동으로 번호를 생성해 줍니다.`,
"vue_label_SMS_search":`잠재 고객이나 연락담당자 검색`,
"label.appupload.successWithUrl":`현재 다음의 URL을 설치해 소프트웨어 패킷을 설치할 수 있습니다.`,
"UG_Forcast_06":`예측 허용된 사용자를 선택하세요`,
"vue_label_dashboard_secondarygroup":``,
"label.weixin..xsld.total":`퍼널 총액`,
"label.setup.mobile.bottombutton.recovery.default.fail":``,
"label.addrecurrencetimetrigger":`주기성 시간 트리거 추가하기`,
"label.emailsync.connectaccount":`이메일 주소 연동`,
"label_fiscal_years":``,
"label.icon.164":`버스`,
"label.batchadd.mustinput":`가짐`,
"message.newtabpage.nokeywords":`최소 한개 필드의 키워드를 입력하거나 고급 검색 조건을 사용하세요!`,
"label.login.verification.mfa.desc3":`계정을 여러 사람이 공유하고 사용하면, MFA를 연동한 후에 다른 MFA를 연동하지 않은 사람은 로그인할 수 없습니다.해결책은 다른 사람도 MFA 앱을 설치하여 이 페이지의 QR 코드를 스캔하게 하거나, 이 QR 코드의 이미지를 저장하여 다른 사람이 추가로 코드를 스캔할 수 있도록 하는 방법입니다.단, 보안상의 최선의 실천으로 볼 때, 여러 명의 계정 공유를 취소하는 것을 권고 드립니다.`,
"label.partnerCloud.basicSetting.initialize":``,
"label.address.county":`구/현`,
"label.validate.function.funcFormat.TODAY":`오늘()`,
"label.sso.addAKey":`비밀키 추가`,
"label.myusergroup":`나의 사용자 그룹`,
"label.import.index.time-consuming":`시간 소모`,
"label_tabpage_systems":`총 *개 시스템`,
"batch.sendemail.s":`,메일 전송 성공했습니다.`,
"label.appointment.wizard.subtitle4-1-1":`15분`,
"label.projectManagement.delete.milestone":``,
"label.umeng.chatter.praise":`게시물에 '좋아요'를 받았습니다`,
"font-evaluate-module-v1-evdetails":``,
"label.group.filter.resources.and":``,
"label_emailtocloudcc_description":`업체 메일을 예, sales@company.com, info@company.com, support@company.com를 여기에 추가하여 시스템이 받은 메일을 통해 잠재 고객이나 개별안 기록을 자동 생성하여 왕래 고객을 팔로우업할 수 있도록 확보합니다.`,
"label.chat.topic.delete.prompt2":`주의: 같은 커뮤니티에 같은 명칭의 주제가 삭제되지 않습니다.`,
"message.error.group.authorization":`해당 소그룹에 대한 설정 권한이 없습니다`,
"label.attendance.wz":`장소`,
"vue_label_activity_notice_logacal_success":`전화를 기록하였습니다.`,
"label.emailtocloudcc.step1.case1":`케이스로 메일 발송`,
"label.h5.chatter.praisenum":`받은 '좋아요'`,
"label_time_statistics_basis":``,
"label.onlyadmincanedit":`관리자<strong>만</strong> 승인 과정에서 기록을 편집할 수 있습니다.`,
"label.fieldtoolongmassage":`필드`,
"label.sales.team.shared":`업무기회 그룹 공유`,
"label_emailsync_status_department":`부서`,
"label.mobile.quickcreate.default.sellingfunnel":`세일즈 퍼널`,
"label.tabpage.closez":`닫기`,
"homepage.components.two":`2단계: 사용자 설정 구성요소가 나타나는 위치를 선택합니다`,
"label.everyday":`매일`,
"lable.Product.to.asset.BOM":``,
"label.appointment.wizard.subtitle4-3":`피초대자가 회의 시작 간격을 선택할 수 있습니다`,
"label.customobjects.standardfieldslist":`표준 필드 리스트`,
"label.customfields.suretodelete":`네. 해당 사용자 설정 필드를 삭제하겠습니다.`,
"component.chatter.label.to":`으로`,
"label.emailsync.form.seversetting":`설정`,
"label.service.gantt.enabled.resources":``,
"label.tianyancha.h5.weibo":`웨이보`,
"template.chart.dddje":``,
"label.pc.trigger.apiname":`Api Name이 존재하여 다시 시도하세요`,
"label.icon.34":`설정`,
"label.schedulejob.setup.schedule.prgname":`프로그램 명칭`,
"label.weixin.free.registration":`회원가입이 무료입니다.`,
"label.placeholder":`검색 키워드를 입력하세요`,
"label.emailobject.manage.template":`메일 템플릿 관리`,
"label.knowledge.article.existsdata":``,
"label.campaign.channel.lookup.ticket":`입장권 보기`,
"label.searchlayout.relation.searchfield":`관련 리스트의 검색 필터 필드를 검색합니다.`,
"label.recordid.cannot.empty":`기록 ID를 입력하세요`,
"label_partner_workspace_member_choice":`프로필 선택`,
"vue_label_campaign_amount":`수입 금액`,
"label.niue.time":`니우에 섬 시간`,
"front-homepageobject-module-v1-workload-ranking":``,
"message.error.datainvalid":`오류: 무효한 데이터입니다.`,
"vue_label_helpcenter_salesfunnel":`새 버전의 세일즈 퍼널을 통해 업무 기회의 팔로우업상황을 분석하여 마케팅 과정에 데이터 참고를 제공합니다. <br> 좌상측의 기록을 역할이나 소유인 등 조건으로 선별해 대응 조건 아래의 모든 업무 기회를 확인하며 분석합니다. 세일즈 퍼널 차트의 단계를 클릭하여 해당 단계의 모든 기록을 확인합니다.`,
"vue_label_transferownernotice":`해당 항목과 관련된 기록의 소유인을 공동 변경하기`,
"label.monitorsys.operator":`운영자`,
"label.please.codeNorm":``,
"label.campaign.channel.step6.remark2":`직원 초대 기능 사용`,
"market.potential.customers":``,
"label.customfields.phone.tip":`사용자가 모든 전화번호를 입력할 수 있도록 허용합니다. 자동으로 전화번호 형식으로 전환됩니다.`,
"label.currency.edit":`화폐 종류 편집: 회사 화폐 종류 변경`,
"label.emailobject.emaildetail.button.markasunread":`읽지 않음으로 표시하기`,
"label_partner_template_memo":`요약`,
"label.chat.message.search.all":`모든 메시지 검색`,
"label_tabpage_hoursagoz":`시간 전`,
"label.customcomponent.developer.help":`사용자 설정 구성 요소 개발자 도움말`,
"setup_mainpage_label_welcome":`CloudCC PaaS 플랫폼에 오신 것을 환영합니다. 플랫폼 본체 기능은 다음과 같습니다.`,
"label.h5.similar.opportunity.list":`결과에 한개나 여러개 님의 업무기회와 같은 필드의 획득한 고객 업무기회가 포함됩니다. 업무 기회를 책갈피로 설정해 이들을 업무기회 상세 정보 페이지의 유사 업무기회 관련 리스트에 추가합니다.`,
"vue_label_record_count":``,
"label.icon.29":`시범`,
"pagecreator.page.label.pagelayout":`페이지 레이아웃`,
"label.ggReleaseRange.searchRole":``,
"label.campagin.member.field.setup":`마케팅 행사 멤버 필드 설정`,
"augest":`8월`,
"label.salescloud.massloss.content":`소그룹 세일즈 금지사용이 사용자의 기본 업무 기회 소그룹과 업무기회의 모든 기존 그룹이 삭제되며 복구 불가능합니다.`,
"label.customfields.new.step2.opration.unique.info":`중복값 불허용`,
"vue_label_email_optional_members":`선정 가능한 멤버`,
"label.emailobject.attachment.download":`다운로드`,
"label.recordamount":`기록수`,
"front-kefu-moudle-call-recorder":``,
"label.more.info":`상세 정보`,
"vue_label_commonobjects_view_secondsbefore":`{seconds}초 전`,
"label.emailsync.status.action":`작업`,
"label.customfields.totalsummary.collectedfields":`합계 대상`,
"label.knowledge.setting.hint.two":``,
"label.login.access.yujidao":`예상`,
"label.assignment.setup.detail.description":`규칙 조항을 생성해서 그 중 지정한 조건에 따라 기록이 자동으로 사용자에게 분배됩니다.`,
"message.error.marketsea.null":`고객풀이 없습니다`,
"lable.account.Current.CY":`현재 캘린더 연도`,
"vue_label_salesadvance_lost":``,
"label.file.ownedbyme":`내 소유`,
"label.component.helper.nodata":`현재 주의 사항이 없으며 잠시 후 확인하세요`,
"label.weixin.appr.pending.auditor":`대기 승인자`,
"UG_opportunity_004":`복합 업무 유형`,
"label.leadscore.setup":`잠재고객 채점 설정`,
"label.addtimetrigger":`시간 트리거 추가`,
"label.mr.title.match":`매칭 여부`,
"label.projectManagement.Newmilestone":``,
"label.preview":`미리보기`,
"label.tabpage.issuez":`문제`,
"label.img.max.size":`업로드 이미지가 너무 커 최대 500K를 넘지 않아야 합니다.다시 올려주세요.`,
"label.mainpageset":`메인 홈페이지 구성요소 배치`,
"label.user.login.false.lock":``,
"UG_solution_02":`솔루션이 고객이 직면한 관련 문제를 해결하는 기구 내부 해결방안입니다.`,
"vue_label_approve_put_away":``,
"label.profile.existing":`기존 프로필`,
"label.ems.logininfo":`로그인 정보`,
"label.weixin.location.service":`포지션 서비스가 지원되는 대상`,
"label.multilang.datamoveaction.totaldata":`총 {0}건의 조건에 부합한 기록이 있으며, 매번 최대 100건까지 이동 가능합니다!`,
"label.ccdocument.cannot.update.set":``,
"vue_label_fliter_addfliter":`필터 추가`,
"label.custom.page.or.trigger":`(사용자 설정 페이지나 트리거)`,
"label.tag.filter1":`모든 선택한 라벨에 동시에 부합합니다`,
"UG.homepage.006":`설문 조사, 실시간 채팅, 이메일, 업무 증빙서류, SNS 게시물과 마케팅 행사(잠재 고객, 시비스 지원 및 행사)를 통해 전방위적으로 고객 행사를 이해한다.`,
"SCORE":`평점`,
"label.file.library.managemembers2":`문서 라이브러리 멤버 관리`,
"label.email.template.public.SMS":``,
"label.leadscore.donot":`잠재고객에 대해 채점할 수 없습니다`,
"label.gaode.map":``,
"pagecreator_button_preview":`미리 보기`,
"UG_contact_04":`혹은`,
"label.ccchat.person.invite.eminfo":`{0}이 님을 CloudCC 회사동료그룹의 {1}에 초대했습니다 - 귀사의 전용 협업 공간! 회사동료그룹을 사용해 동료와 얘기 나누며 프로젝트에 대해 소그룹을 생성하고 파일을 공유합니다.`,
"setup_object_field_dependency_label_actionfieldvalue":`제어 필드값`,
"lable.Product.options":``,
"front-electronic-signature-add-autofill-field":``,
"label.customfields.totalsummary.selectcollectedfields":`통합할 대상을 선택합니다`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":``,
"label.forecast.shrepage.pagetitle":`사용자, 역할 및 구역 공유`,
"label.login.access.mark":`지원하는 문제를 해결하려면 로그인 및 데이터 접근 권한을 관리자에게 부여할 수 있습니다.`,
"lable.outlook.edit.zdyout":`사용자 설정 Exchange 필드 매핑`,
"label.approveoperate":`승인 조작`,
"label.tabpage.linknamez":`링크 명칭`,
"label.report.error.deletehavedashboard":`보고서가 이미 대시보드를 생성하였으며 삭제할 수 없습니다`,
"label.summaryreport.2018.step1":`1단계: 통합 정보의 그룹분류 방식을 선택하십시오`,
"label.campaignmember.main.leadtomember.title":`필드 매핑 배치`,
"label.select.dashboar.type":`대시보드 유형을 선택하세요!`,
"message.setup.field.picklist.valueexists":`해당 선택 항목 리스트값이 존재합니다`,
"label.loading":`데이터 로딩중...`,
"label.payments.paytip1":`현재 시스템 버전이 시용 버전이 아니며 '확인'을 클릭한 후 새로고침 하거나 다시 로그인 하세요.`,
"label.view.appliedMobile":`모바일기기에 사용 여부`,
"label.multilang.forcast.financialyear":`{0}번째 회계 연도`,
"front-web-module-v1-detail-comment-opinion":``,
"UG_Forcast_10":`완성`,
"label.optionlistset":`옵션 리스트 옵션`,
"label.visualpage_list.vpname":`사용자 설정 페이지 명칭`,
"vue_label_calendar_failed_to_delete_calendar":`캘린더 삭제 실패`,
"label.json.string.null":`내용 없음`,
"message.serviceappo.time.violation2":``,
"label.productsales.today.noevttsk":`오늘 미처리한 이벤트나 만료된 업무가 없습니다`,
"label_tabpage_emptyz":`비우기`,
"front-kefu-moudle-no-create":``,
"label.wedge.shaped.tail.arrow.cannot.empty":`쐐기형꼬리 화살표를 입력하세요!`,
"label.continue.shopping":``,
"label.turntomain":`메인 내용으로 건너뛰기`,
"component.assistant.label.nodata":`오늘 이벤트가 없으며 잠시 후 확인하세요.`,
"label.payments.paytip4":`정확한 수량을 입력하세요`,
"label.appupload.upload.versionName":`버전 명칭`,
"label.chatter.endData":`마감 일자`,
"front-kefu-moudle-buytr-tip":``,
"label.repw":`중복 비밀번호`,
"label.tabularreport.intro":`리스트 보고서는 가장 간단하고 빠른 데이터 나열 방식입니다.`,
"label.selectoperatetype":`조작 유형 선택`,
"setup.layout.label.required":`입력 필수`,
"label.default.designee":``,
"label.ccdocument.cannotdel.folder":`이 폴더에 파일이 존재합니다. 이 폴더는 삭제할 수 없습니다!`,
"label.escalation.setup.newentries.inputentries":`규칙 조항을 입력합니다`,
"label.emailobject.addnewtemplate":`새 템플릿 생성`,
"label_chatter_content":`내용`,
"label.htyj.mubiao":`목표`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`금요일`,
"label_tabpage_fieldoptions":`유형 필드, 선택항목 리스트 필드와 선택항목 리스트(복수) 필드를 기록합니다. 최대 10개의 키워드를 입력하시길 권합니다. 예를 들어 "베이징, 상하이, 광저우"와 같은 영어 콤마로 간격을 시켜 혹은 관계를 설정합니다.`,
"label.mobiletablayoutedit.remark2":`핸드폰 포그라운드 메뉴 페이지에 보는 필드를 선택합니다`,
"label.sendemail.chat.addComentsat":`존경하는 #name:\n\n    안녕하세요！#userName이 올린 게시물의 댓글에 님을 소환했습니다.`,
"Z":`공식`,
"label.multilang.batchdeleteaction.movesuccess":`총 {0}개 기록 삭제 성공!`,
"label.textmessage.vonage.message2":`Nexmo API 계정을 설정함으로써 사용자가 CloudCC 플랫폼에서 Vonage API계정을 방문하고 택스트 소식을 전송 및 받을 수 있습니다.`,
"label.file.use.document":`저장 공간 사용 상황`,
"UG.Lead.011":`고객 경로 생성`,
"label.view.name":`뷰 명칭`,
"label.data.downtemplate":`템플릿 다운로드`,
"vue_label_appstore_get_now":`즉시 획득`,
"label.controlfield":`제어 필드`,
"label.dataimport.type.insert":`삽입`,
"label.customfields.multiselect.tip":`사용자가 정의한 리스트에서 여러개 값을 선택할 수 있도록 허용합니다.`,
"label.weixin.approval.qxzjl":`기록을 선택하세요`,
"component.salesperformance.label.70finish":`완료됨- 미처리（>70%）`,
"Lead_Auto_Scoring_Setting":`잠재 고객 자동 채점 설정`,
"pagecreator_layout_message_canntdelete":`현재 레이아웃은 삭제할 수 없습니다`,
"vue_label_report_exprotpage":`내보내는 페이지수: {page}페이지`,
"label.campaign.channel.step4":`4단계: 마케팅 채널 등록 페이지에 필수 입력 필드를 설정합니다`,
"label.app.launcher":`응용프로그램 론처`,
"vue_label_campaign_selectedmember":`{member}개 마케팅 행사 멤버를 선택함`,
"label.mobile.quickcreate.default.approvals":`승인 대기`,
"label.view.step4":`4단계. 가시성을 제한합니다`,
"label.exchange.sync.state.user":`사용자 동기화 상태`,
"label.forecast.customforecast.tab.forecast":`하위 메뉴 예측`,
"label.theUserLoginForTheFirstTime":`사용자 최초 로그인`,
"label.workflowoperate.tip":`규칙 조건에 부합 시 작동한 업무 프로세스 조작을 지정합니다`,
"font-evaluate-module-v1-ten-points":``,
"label.knowledge.delete":``,
"front-console-see-contacts":``,
"label.h5.similar.opportunity.add.to.favorites":`책갈피에 추가`,
"front-epwechat-module-v1-install-app":``,
"setup_layout_message_relatedlistbutton":`관련 리스트에서 보는 표준 버튼을 선택합니다.`,
"label.salescloud.massloss.title":`대량의 데이터가 손실될 수 있습니다`,
"front-console-conversation-btn1":``,
"label.custom.canvasScale":``,
"label.lead.score.doing":`잠재고객에 대해 채점중`,
"message.approval.step.validation.invalid.number":`정확한 숫자를 입력하세요`,
"chatter.lk":`좋아요`,
"label.dashboardSetup.showmaxval":`최대 수치 보기`,
"label.keywords":`키워드`,
"vue_label_helpcenter_SMS":`문자 기능 개설<br>구매한 CRM 시스템의 countrycode가 USA라면 귀사의 시스템 내부에서 문자 기능을 갖추고 있다. 조직 관리자가 시스템 응용 프로그램 vonage 게이트웨이에서 귀사가 vonage 시스템에서 구매한 전화 번호를 입력하여 마케팅 클라우드 응용 프로그램의 메뉴에서 문자 기능을 사용할 수 있다. <br>메세지 박스 <br>    메세지 상자는 2 부분으로 나눈다. 좌측은 문자 왕래가 있는 잠재 고객이나 연락담당자 기록, 한 기록의 우측을 클릭하면 왕래 상황을 볼 수 있다. 본인이나 부하의 기록을 볼 수 있다. <br> 단체 문자 <br>    문자 메뉴, 잠재 고객 및 연락담당자 리스트, 마케팅 행사 멤버에서 단체 문자를 보낼 수 있다. CRM 내부의 잠재 고객이나 연락담당자에게만 문자를 보낼 수 있으며 문자를 편집한 후 '발송'을 클릭하여 수신자 수를 떠나서 하나의 단체 기록이 생성되다. 혹은 '개별 발송'을 선택해 개별 발송한 문자는 문자 템플릿에서 병합 필드를 삽입할 수 있다.`,
"label.emailobject.createnewavailability":`일정 예약 링크 생성`,
"front-kefu-moudle-buytr-send-email":``,
"front-kefu-moudle-v1-Put-away-the-chat":``,
"label.marketseamemset.lead.maxuser":`멤버의 최대 잠재 고객수`,
"label.forecast.forecastroleuserpage.shre.manager":`관리자만 이 예측을 공유할 수 있습니다`,
"label.file.noselect":`파일을 선택하지 않았습니다`,
"label.notification.task3":`[피분배자]에게 분배한 업무 상태가 [새 상태]로 변경되었습니다`,
"label.dependfield":`종속 필드`,
"lable.SalesCommitmentKanBan.receipts":`대금 수령`,
"label_partner_workspace_member_search":`검색`,
"label.share.originally.posted":`최초 게시자`,
"label.autonumber":`자동 번호`,
"label.view.sortview.name":`뷰 명칭`,
"label.h5.add.activity":`행사 추가`,
"label.textmessage.vonage.phone.number":`전화 번호`,
"label.partnerCloud.financeSetting.enterApiKey":``,
"label.industrialandcommercialverification.enablestatus":`사용 상태`,
"label.reportTypeFocusD1":`어떤 기록(행) 유형이 이 보고서 데이터 소스에서 생성되는 보고서 포커스가 될지를 지정합니다.`,
"vue_label_report_four-levelseriesobjecttree":`4급 탠덤 대상 계통수`,
"label.mobile.default.catalogue":`기본 목록`,
"label.partnerCloud.partnerAccount.again":``,
"label.summaryreport.step2.new":`2단계: 통합 정보의 그룹분류 방식을 선택합니다`,
"label.tabpage.cancel":`취소`,
"label.multilang.datamovelist.datamove":`여러 개{0}을 한 사용자에서 다른 사용자로 이동합니다`,
"label.conferloginandvisitlimit":`로그인 접근 권한을 부여합니다`,
"vue_label_help_viewhelpcenter":`CloudCC 도움 센터 보기`,
"label.leadscore.norule":`채점 규칙이 없어 채점 규칙부터 생성하거나 생성된 채점 규칙을 활성화시키세요`,
"label.tabpage.exitz":`나가기`,
"label.DeploymentStatus":`개발 상태`,
"label.layout.saving":`레이아웃 저장중...`,
"label.emailobject.emaildetail.field.object":`대상`,
"label.customfields.searchrelation.fieldtag.tip":`뷰, 페이지 레이아웃 뷰, 보고서 뷰, 리스트 뷰에서 사용할 라벨을 입력하십시오`,
"message.huanxin.bindtenant.notfound":``,
"label.referpersonalias":`제출인 별명`,
"label.icon.31":`컴퓨터`,
"label.appupload.upload.install.thispackage":`이 소프트웨어 패킷`,
"label.appointment.wizard.subtitle1-1":`사용자 설정`,
"pagecreator_page_message_save_fail":`페이지 저장 실패`,
"label.lastset":`최후 대로`,
"label.version.support.limited":`제한 지원`,
"vue_label_homepage_kanban":`간판`,
"label.layout.editsearchdistribute":`페이지 검색 레이아웃 편집`,
"template.dashboard.customer.analysis":``,
"label.continue_editing":``,
"label.version.sum.customtab":`개 사용자 설정 메뉴`,
"label.validate.function.funcExplain.TIMEVALUE":`일자/시간 필드의 시간 부분으로 돌아가기(시분초)`,
"label.import.page1.selectobjfromdata":`불러올 데이터의 대상자를 선택하시오`,
"label.partnerCloud.basicSetting.success":``,
"label.customfields.fielddependency.cannotcreat":`종속 관계를 만들 수 없어 선택한 필드가 직접적이나 간접적으로 자체와 종속됩니다`,
"label.umeng.activity.youhaveatask":`새 업무가 하나 있습니다`,
"label.file.folder.create":`폴더 새로 만들기`,
"vue_label_campaign_member_status":`멤버 상태`,
"lable.opppdt.addpdt.table.date":`일자`,
"label_partner_workspace_login_buttontext":`버튼 텍스트`,
"label_other_mistakes":``,
"label.must.be.configured":``,
"label.customize.memory.function.sorting.enable":``,
"setup.layout.label.areaname":`구역 명칭`,
"label_chatter_pastThirtyday":`지난 30일`,
"setup_mainpage_label_welcome25":`조작 안내: 페이지 좌측 메뉴를 클릭하여→ 설정 관리→ 안보성 제어→ 공유 설정`,
"label.ccchat.person.invite.succsend":`동료그룹 가입 신청 보내기`,
"label.select.time.range":``,
"label.partnerCloud.orderingPlatform.djustQuantity":``,
"label.manageAll.sta1":`승인 중`,
"label.cy.select":`화폐 종류를 선택하세요`,
"chatter.lam":`메시지`,
"label.partner.setup.title":`설정`,
"component.setup.label.displaybutton":`보기 버튼`,
"component.salesperformance.label.target":`목표`,
"label.campagin.channel":`등록 채널의 값을 입력하세요`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(field)`,
"UG.homepage.009":`CRM 방문`,
"label.file.item":``,
"label.file.library.addmembprompt":`이미 관리 멤버가 되어 중복으로 추가할 수 없습니다.`,
"label.bmap.releasePosition":`게시물 올린 위치`,
"setup_object_layout_label_selectedprofile":`선택한 프로필`,
"label_emailsync_message":`안내`,
"label.view_submissions":``,
"lable.tianyancha.repeated":`중복 선택`,
"label.import.index.introduce":`간단한 세 단계를 통해 데이터를 시스템에 가져옵니다`,
"label.time.operation.new":`타이머 작업 새로만들기`,
"label.projectManagement.Pleaseentersettlementtype":``,
"label.icon.169":`관람차`,
"vue_label_commonobjects_detail_related_listview":`리스트 보기`,
"label.view.step1":`1단계. 뷰 명칭을 입력하세요`,
"label.summaryreport.intro":`통합 보고서가 데이터 소계와 다른 통합 정보를 동시에 나열합니다`,
"vue_label_file_input_correct_name":`정확한 명칭을 입력하세요`,
"System_Email_Template_Title":`CloudCC CRM 플랫폼을 사용하신 것을 환영합니다`,
"label.tianyancha.province":`성 약칭`,
"label.deleteall.sure":`모두 삭제하시겠습니까?`,
"label.passwordPolicy.setup.uppercasealpandnum":`알파벳 대소문자와 숫자를 포함해야 합니다`,
"front-lightning-module-v1-details-page-chart-select":``,
"setup_mainpage_label_welcome8":`드래그 앤드 드롭 방식 인터페이스 맞춤 제작`,
"lable.outlook.edit.lastupc":`최후 업데이트한 연락담당자`,
"label.weixin.registered":`등록`,
"vue_label_file_history_version":`과거 버전`,
"vue_label_campaign_earned":`대기 수입 금액`,
"label.staticresource.useful.realtion.tip":`다음은 이 정지 리소스에 대한 페이지 인용입니다`,
"vue_label_file_libraray":`파일 베이스`,
"label.department.phone":`핸드폰 번호`,
"label.emailtemplate.edit":`메일 템플릿 편집`,
"label.processsetting.key.information.tips":``,
"label.summaryreport.step7":`7단계: 차트 유형과 보고서 하이라이트 표시를 선택합니다`,
"label.chat.topic.remove.favorite":`즐겨찾기에서 삭제`,
"label.campagin.roi.ksrq":`시작일`,
"label.data.downpage.e_title.e_btn":`내보내기 페이지로 들어가 내보내기 시작합니다`,
"label.approvaldatamove.dname":`현재 승인자`,
"lable.Partial.attributes":``,
"template.report.enabled.products":``,
"lable.outlook.detail.cto":`CloudCC.com이 Exchange 로`,
"label.sendemail.activity.newtasktitle":`새 업무 통지`,
"label.validate.function.funcFormat.DAY":`일(일자)`,
"label.log.datetime.value":`조회 시간을 입력하세요!`,
"label.import.index.updaterecord":`기록 업데이트`,
"label.registration.page.invitation":``,
"pagecreator_systemstyle_label_detailcolor":`명세 글자 색깔`,
"label.tabname.cannot.empty":`메뉴명을 입력하세요!`,
"label.data.newtemplate.savetemp":`다른 템플릿으로 저장하기를 체크할 수 있습니다. 이번 데이터 내보내기에서 선택한 필드와 조건을 데이터 내보내기 템플릿으로 삼아 템플릿 페이지에 저장할 수 있습니다. 나중에 편리하게 사용할 수 있도록 템플릿 명칭과 템플릿 설명을 자세히 기입하세요.`,
"label.ems.body":`본문`,
"enc":`암호화 텍스트(저장 암호화)`,
"label.profile.mobile.setup.commonSaler":`일반 판매`,
"label.continueselectproduct":`제품 계속 선택`,
"label.event.new":`이벤트 새로만들기`,
"label.renametabandtaglib":`메뉴와 라벨 리네임`,
"label.qrcodelogin.message.exception":`서비스 시스템에 이상이 발생해 관리자에게 연락하십시오`,
"label.service.gantt.locationToGantt":``,
"label.mr.theLastGroup":`이게 마지막 그룹입니다.[중복 데이터 리스트로 돌아가기]를 클릭하여 중복데이터를 살펴보세요.`,
"label.report.export.format.content":`해당 보고서의 헤더, 그룹 및 자세 정보를 내보냅니다. 상세 정보 최대 내보내기`,
"label.version.accountandcontact":`고객과 연락담당자`,
"label.partnerCloud.financeSetting.enterMd5Key":``,
"label.login.access.quater":`주일`,
"vue_label_commonobjects_view_searchthisview":`본 리스트를 검색하기`,
"label.import.step1.allobj":``,
"front-efficient-project-management":``,
"label.includedvalue":`포함된 값`,
"label.service.newBuildDialog.past.days":``,
"vue_label_report_sortup":`오름차순으로 정렬`,
"label.appointment.wizard.subtitle3-2":`화요일`,
"label.dashboard.trend":``,
"label.schedulejob.setup.schedule.st2":`두번째`,
"label.view.sortview.number":`기록 수`,
"lable.Please.enable.order":``,
"label.datamanage.immediately.import":`바로 불러오기`,
"label.delete.condition":`비우기`,
"label.dashboard.chooseDispalyOnTheHomePage":`보기 메인 홈페이지를 선택합니다`,
"asset.accountid.contactid.required":``,
"label.mask.character":`마스크 문자`,
"lable.account.Previous.FY":`지난 회계 연도`,
"chatter.attachment":`첨부파일`,
"label.view_only":``,
"label.tianyancha.name":`기업 명칭`,
"label.service.gantt.avg.traveltime":``,
"vue_label_pool_move":`이동`,
"label.import.index.beforeexport":``,
"label.view.delete":`뷰 삭제`,
"template.detail.info.link":`상세 정보 링크`,
"label.sendemail.send.setfail":`메일 정보 설정 실패했으며 정확한 메일 정보를 배치하세요`,
"label_emailtocloudcc_redmessage11":``,
"label.campaigns.memberalert":`최소 멤버 한명을 선택하세요`,
"label.schedulejob.setup.schedule.frequency":`빈도`,
"component.newrecords.label.all":`전부 보기`,
"label.mr.caption.opportunity":`중복 검사 병합 : 업무기회 중복데이터를 조회하는 조건입니다.`,
"chatter.group.onlyMembers":`멤버만 볼 수 있는 그룹입니다.그룹 소유인은 그룹 멤버를 추가할 권리가 있습니다.`,
"label.recordtype.edit.selectvalue.show":`선택항목 리스트값을 저장한 순서대로 표시합니다`,
"message.textmaxlength":`길이가 255를 넘을 수 없습니다.`,
"label.reportsSubscriptionPage.visibility":`다음 사용자의 시각으로 보고서 운행하기`,
"label.umeng.chatter.addcoments":`님의 클라우드 게시물에 1개 새댓글이 있습니다`,
"chatter.up.f":`업로드에 실패해 오류를 알 수 없습니다.`,
"label.icon.146":`키보드`,
"lable.custom.CY.Ago":`두개 사용자 설정 연도 전`,
"label.tabpage.step3":`3단계 디스플레이 필드를 선택하세요`,
"label.checkfield.introduce":`대상에서 중복 검사를 할 수 있는 필드를 설정하여 데이터 리스트에서 설정된 필드에 따라 데이터에 대해 중복 검사를 할 수 있습니다.`,
"label.tag.addtags":`라벨 추가`,
"label.service.newBuildDialog.characterlimit":``,
"font-evaluate-module-v1-evquestions":``,
"label.knowledge.only.update.draft":``,
"label.partnerCloud.basicSetting.defaultCounts":``,
"label.chat.topic.delete":`삭제`,
"label.workflow.contentcondition":`조건이 충족되었습니다`,
"vue_label_commonobjects_view_sortby":`{field}로 정렬하기`,
"label.passwordPolicy.setup.pwdremember24":``,
"front-kefu-moudle-free-account":``,
"label.marketsea.isautorecycle":`자동 회수 사용`,
"label.addattachment.view":`파일 보기`,
"vue_label_helpcenter_contact":`상세 정보에서 연락담당자 옆의 계통수 버튼을 클릭하여 연락 담당자의 구조도를 볼 수 있어 연락담당자의 등급 관계를 볼 수 있고 모든 담당자의 일부 필드 정보를 볼 수 있다.`,
"label.taskevent":`업무 이벤트`,
"label.industrialandcommercialverification.message":`오늘 무료 검색 횟수가 모두 사용되었습니다`,
"label.object.already.delete":`대상이 삭제되었습니다.`,
"label.project.hit.four":``,
"label.taskpagelayout":`업무 페이지 레이아웃`,
"label.version.sum.locationfield":`개 지리적 포지션 필드`,
"front-sales-button-toQB":``,
"label.app.oceanblue":`바다색`,
"label.operating":`조작중...`,
"label.customfields.formula.dateexample":`Reminder Date（알림 일자）= CloseDate - 7`,
"label.happen_delete":``,
"label.service.appointmentList.plansToStart":``,
"label.persmets.operate.licence":``,
"label.mobile.quickcreate.default.activities":`캘린더`,
"label.australian.eastem.standard.time":`동부 서머타임(뉴사우스웨일스)`,
"label.emailobject.remove":`삭제`,
"label.weixin.vote":`투표 참여`,
"label.reportsSubscriptionPage.condition.aggregate":`합계`,
"front-kefu-moudle-has-unbind":``,
"chatter.group.newGroup":`그룹 새로 만들기`,
"label.tabpage.systems":`총 *개 시스템`,
"label.textmessage.vonage.connect":`Vonage로 연결됨`,
"label.campaign.channel.input.ticket":`입장권 발송`,
"label.ccpeak.query.sharetab":`공유 탭 조회`,
"label.reporttype":`보고서 데이터 소스`,
"message.duplication.label.isprofiletip":`체크 시 중복률을 검사할 때 현재 사용자가 볼 수 있는 데이터에 대해 검사합니다. 그렇지 않으면, 모든 데이터를 검사합니다.`,
"label.tianyancha.businessverify.xieyi":`사용자 허가 협의`,
"font-evaluate-module-v1-select-person":``,
"vue_label_chatter_all_groups":`모든 그룹`,
"label.recordtype.profile.setdefault":`기본 설정`,
"label.mr.descreption.nocondition":`조건에 부합한 중복 데이터가 없습니다.`,
"label.tabpage.askz":`질문이 무엇입니까?`,
"label.marketsea.selectMember":`멤버 선택`,
"template.report.stage.possibility.analysis":``,
"label.data.selectderivedobject":`내보내는 대상을 선택합니다`,
"label.customfields.formula.explain":`설명: 현재 숫자, 백분율 등 필드의 4단 연산, 필드의 관련값 찾기를 지원합니다.예시: 숫자 형식 공식jine*knxing&nbsp;&nbsp;&nbsp;&nbsp;필드 관련값 찾기：khmc__r.dianhua`,
"vue_label_notice_change_fail":`변경 실패`,
"label.customobjects.trackoldandnewvalues":`이전 값과 새 값을 팔로우업합니다`,
"label.h5.leftprompt":`편집된 내용이 아직 전송되지 않아 나가시겠습니까?`,
"label.select.field":`선택 가능한 필드`,
"label.customobjects.layoutedit":`페이지 레이아웃 분배`,
"label.false":`거짓`,
"UG_Forcast_07":`예측 허용`,
"vue_label_chatter_team_member":`그룹 멤버`,
"label.tabpage.retypez":`기록 유형을 변경할 때 항목 리스트 값이 자동 변경되지 않습니다. 같은 곳에서 기록의 항목 리스트 값을 업데이트하는 것을 추천합니다.`,
"front-epwechat-module-v1-single-desc":``,
"label.closeandconverted":`닫기-전환 완료`,
"label.service.confirmed":``,
"label.partner.workspace.member.cloudcc":`CloudCC 프로필`,
"label.star.click":`리셋`,
"label.icon.135":`화폐`,
"button_partner_workspace_login_logo_upload":`이미지 업로드`,
"message.error.sql.constraint.recordnotsingle":`외부 ID 설정 실패했습니다! 사유: 기존 데이터에 이 필드의 중복 데이터가 존재합니다`,
"label.ccchat.person.invite.errorpwd":`최소 8개의 문자를 사용하고 숫자와 문자의 조합을 포함합니다`,
"label_tabpage_isdeleterecord":`선택한 기록 삭제 여부`,
"label.weixin.prompt.message":`안내 메시지`,
"vue_label_chatter_view_original_post":`최초 게시물 확인`,
"label.multilingual.tip3":``,
"label.dataimport.error.datetime":`에러 발생: 일자 시간`,
"label_tabpage_addcondition":`조건 추가`,
"label.query.detail.manageexcludeuser":`외부 사용자 관리`,
"label.tianyancha.creditcode":`통일 사회 신용 코드`,
"label.cy.enter":`귀사 사용한 화폐 종류가 새 화폐 종류로 전환한 환율을 입력합니다`,
"label.textmessage.vonage.message1":`Vonage를 연결함으로써 사용자가 CloudCC플렛폼에서 문자를 전송 및 받을 수 있습니다. 그 전에 사용자가 Vonage계정을 등록하고 전화번호를 구매해야 합니다.`,
"front-marketing-module-v1-share-invitation":``,
"label.file.items":`개 항목`,
"label.otherwise":`그렇지 않으면`,
"label.permission.detail.system":`시스템`,
"message.success.task.emailsend":`전송 메일 정보 저장 성공`,
"label.the.reward.group":``,
"setup.layout.label.relatedlistsetup":`관련 리스트 설정`,
"label.empty":`비우기`,
"label.weixin.cloudcc.user.binding":`CloudCC 사용자 연동`,
"label.file.what.change":`전송할 변경(선택 가능)`,
"label.search":`검색`,
"label.mobile":`핸드폰`,
"template.report.month.potential.customer":``,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`명함 스캔에 검증 규칙이 적용 여부`,
"lable.outlook.list.des":`Exchange Sync 배치 정의가 특정 사용자 그룹의 CloudCC for Exchange 설정에 응용해야 합니다`,
"label.appupload.install.error.info":`{0}“{1}”을 {2}가 사용했으며 현재 {0}에 대해 재명명하세요.`,
"label.tabpage.addoptionsz":`항목 추가`,
"label.arabian.standard.time":`아라비아 표준 시각`,
"label.thefirst":`첫째 열`,
"label_partner_workspace_login_footertext":`바닥글 텍스트`,
"lable.Disabled.successfully":``,
"label.confirm.del":`승인 중인 기록이며 삭제를 확인하세요.`,
"vue_label_normal_reregister":`다시 로그인`,
"label_file_img":`이미지`,
"label.salescloud.salesdashboard.sales.behavior":`마케팅 행위`,
"label.startdate":`시작일`,
"label.field.duplicate.error.msg5":`다음의 오류 정보를 확인하여 수정한 후 다시 시도하세요.`,
"setup.main2018.label.managesetup":`설정 관리`,
"label.forecast.editshrepage.title":`공유 새로만들기`,
"UG.solution.01":`솔루션을 제공한다`,
"label.knowledgebase.data.recovery.successfully":``,
"label.pc.ui.2018.myccchat":`나의 CCChat`,
"label.attachement":`비고 및 첨부파일`,
"message.mobilechooseatmostten":`최대 10개 필드만 선택할 수 있습니다`,
"label.campagin.roi.bhzeywjh":`총 업무기회수`,
"label.autoresponserule":`자동 반응 규칙`,
"label.attendance.yuyue":`예약되지 않아 현장에서 등록하시겠습니까?`,
"label.insert":`삽입`,
"label.service.ganttBaiduMap.shutDown":``,
"label.icon.194":`텔레비전`,
"message.serviceterritory.violation":``,
"label.appointment.disable.function":`금지 사용된 기능`,
"lable.currencyManage.manageexchangeRate.dis":`회사의 유통기한이 지난 환율을 관리하려면 '유통기한이 지난 환율 관리' 클릭해 주십시오.유통기한이 지난 환율은 업무기회, 업무기회제품, 그리고 이 두 대상에 관한 보고서에 적용합니다.`,
"vue_label_file_upload_tip_newmsg":``,
"label.event.next.week":`미래 1주일의 이벤트`,
"label.datamanage.import.contactfield":`다음 표에서, 불러온 파일에서 각 연락담당자에 불러올 필드를 선택합니다.작업을 완료한 후 다음 단계를 누르십시오:`,
"label.projectManagement.time.allocated":``,
"label_tabpage_isdeleteview":`이 뷰를 삭제하시겠습니까?`,
"label.pc.ui.2018.search":`검색 내용을 입력해 주세요`,
"label.role.createrolelevel":`역할 등급 구조 생성`,
"label.tabpage.editview":`뷰 편집`,
"label_partner_common_manageSetup":`파트너 클라우드 관리 설정`,
"label.service.gantt.noservice.resource":``,
"message.numbertoolarge":`숫자가 최대치를 초과했습니다`,
"label.sendsms.success":`메시지 전송 성공`,
"UG.opportunity.009":`혹은`,
"label.ccpeak.construction.dataobj":`한 데이터 대상을 구축하려면 대상 API 명칭을 올려야 합니다:`,
"front-lighting-module-v1-detail-file-uploadInfo":``,
"label.import.page2.newnotmatchfiled":``,
"label.ems.inputmailss":`메일 접수 서버`,
"label.knowledgebase.data.published.successfully":``,
"label_emailtocloudcc_position":`직위`,
"label.data.exp.customexp":`사용자 설정 내보내기`,
"component_chatter_post_button_user":`인원 추가`,
"label.new.visualpagefolder":`사용자 설정 페이지: 폴더 새로 만들기`,
"label.forecast.shrepage.classdes":`방문 권한 등급 설명`,
"label.task.overdue.unfinished":`만료된 미완성 업무`,
"label.ccchat.micropost.isedit.setting.info":`게시물이나 댓글의 저작자, 기록 소유인, ccchat 운영자와 해당 커뮤니티의 운영자가 해당 텍스트를 수정하는 권한을 보유합니다.`,
"label.recordname":`기록명`,
"label.posted_your":``,
"label.globaloperation.operationtype.custom.page":`사용자 설정 페이지`,
"label_tabpage_busoppnamez":`업무기회명`,
"front-epwechat-module-v1-schedule-desc":``,
"label.escalation.setup.newentries.lastmodifydate":`지난 개별안 수정 시간에 따라`,
"setup_layout_label_nofield":`선택 가능한 필드 없음`,
"label.sendemail.registIMUser.logininfo":`로그인 가능한 파트너 클라우드 포털이:<br>`,
"label.weixin..xsld.kehu":`고객`,
"label.display_thank":``,
"label.group.no.my.group":`매칭된 나의 그룹이 없습니다.`,
"label.partnerCloud.newBuildSite.enterDomain":``,
"label.step1.total2":`1 단계, 총 2단계`,
"label.ccpeak.delete.record":`기록 삭제:`,
"label.customer.tab.step1.introduce":`새 사용자 설정 메뉴에 대해 사용자 설정 대상을 선택해 다른 상세 정보를 입력합니다`,
"label_tabpage_newInterfacez":`새 버전 인터페이스`,
"setup.mainpage.label.manageuser":`사용자 관리`,
"label.partnerCloud.partnerAccount.completed":``,
"label.projectManagement.kanban":``,
"label.operate":`조작`,
"label.service.dispatchingUnits.selected.time.range":``,
"component_setup_label_pagesize":`페이지당 표시 건수`,
"font-evaluate-module-v1-email-evaluation-settings":``,
"label.service.dispatchingUnits.skills":``,
"label.editrecurrencetimetrigger":`주기적 시간 트리거 편집`,
"vue_label_file_edit_lib":`파일 베이스 편집`,
"label.campaignmember.selectmember.deleteconc":`마케팅 행사: 연락담당자에서 멤버를 삭제합니다`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`월요일`,
"front-detail-module-v1-by":``,
"label.mobile.home.page.date.signed":`예상 체결일`,
"label.apply.send.success":`전송 성공!`,
"label.app.choseimg":`마크 선택`,
"label.customsetting.visible":`가시성`,
"label.sendemail.activity.task.distributetaskcompleted":`#belongtoidccname에게 분배한 업무가 완성으로 표시됐습니다`,
"label.dashboard.snapshot.refreshing":`새로고침 중`,
"label.document.name.already.exists":`파일의 유일한 이름이 이미 존재합니다!`,
"label.ccchat.person.invite.needlastname":`성을 입력하세요`,
"pagecreator_page_button_copy":`복사`,
"label.appointmentpage.wizard.subtitle1-2":`지난주`,
"label.validate.function.funcFormat.MILLISECOND":`밀리초(일자)`,
"label.profile.allowtocreateview":`뷰 생성`,
"message.error.recordid":`기록id를 입력하세요`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`상급 역할로 돌아갑니다`,
"label.translation.start3":`필요하면 대상을 선택합니다. 예, 업무 프로세스 업무에 대상(계정, 연락담당자 등)을 통해 번역 전문 용어를 선별합니다.`,
"label.ccpeak.send.email":`메일 알림 전송:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`만료일이 없음`,
"label.permission.objectpermission.objpermission":``,
"label.version.custom.report":`표준 보고서(사용자 설정 페이지)`,
"label.title.qrcodeOrbarcode":``,
"label.emailtocloudcc.step2.name":`이메일 귀속 설정`,
"label.reportsSubscription.edited.successfully":``,
"label_tabpage_kanbansetup":`간판 설정`,
"label.tianyancha.regcapital":`초기자본금`,
"front-epwechat-module-v1-web-single":``,
"label.visualpage.display.top":`머리말 표시하기, false-머리말 표시하지 않기`,
"label.customfields.fielddependency.selectcell":`아래 표에서 최소 하나의 셀을 선택하십시오.`,
"label.paging.addmember.totalofpages":`총 <span id='recordCount'></span>  <span id='recordRange'></span>개   `,
"label.email.saveing":``,
"label.userinfo.doublepwd.notnull":`중복 비밀번호는 비워둘 수 없습니다!`,
"label.appointment.wizard.subtitle4-4-2":`2주일`,
"label.chatter.BCC":`숨은 참조`,
"label.emailtocloudcc.description":`기업 이메일을, 예를 들어 sales@company.com, info@company.com, support@company.com를 여기에 추가하여 시스템에서 받은 메일을 자동으로 잠재 고객이나 개인안 기록으로 생성하여 거래 고객을 팔로우업한다.`,
"label.sendemail.send.atlastone":`최소 1명 수신인이 있어야 합니다`,
"label.mobile.phone.subordinate":`산하 포함 여부`,
"label.data.choses.e_desc":`필요에 따라 모든 데이터를 내보내거나 대상별로 내보낼 데이터를 선택할 수 있습니다.`,
"chatter.new":`메시지`,
"vue_label_help_back":`뒤로 돌아가기`,
"label.skipwizardintro":`이동 기점 안내가 몇분 안에 원스톱 승인 과정을 생성해 드립니다.`,
"label.weixin.fmu.before.week":`{0}주일 앞당깁니다`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat  님의 게시물을 좋아합니다`,
"lable.currencyAdv.andafterdate":`와 그 후의 일자`,
"label.sometoprocess":`일부 유형의 기록만 이 승인 과정을 사용할 수 있다면 다음에 조건을 입력하세요. 예. 본부 직원의 비용 보고서만 이 승인 과정을 사용해야 합니다.`,
"label.campaignmember.main.updateleaddesc":`모든 기존 잠재고객의 상태를 한 번에 업데이트 합니다`,
"label_partner_common_roleSetup":`파트너 클러우드 역할과 사용자 설정`,
"label.console.step5.no":`기록을 표시할 방법을 선택하십시오`,
"label.salescloud.teamrole.optionlist.account":``,
"Report.Delete.Confirm.Title":`확인하세요`,
"label.onclick":`클릭`,
"label.weixin.input.identifying.code":`인증번호를 입력하세요`,
"label.knowledge.translate":``,
"label.log.ip":`IP`,
"front-electronic-export-goResult":``,
"label.escalation.setup.newaction.otheremail.otheremail":`다른 메일`,
"label.icon.104":`일정`,
"label.partnerCloud.exceedTwo":``,
"label_tabpage_thevalurofz":`의 값`,
"front-lightning-module-v1-details-page-chart-maximum":``,
"label.data.downpage.i.title.num6":`데이터를 불러오기 전에 5개 기록이 포함된 테스트 파일을 먼저 불러오고 준비된 불러올 파일을 차질없이 확보한다.`,
"label.ccpeak.update.record":`기록 수정:`,
"label.dataimportandexport":`데이터 불러오기와 내보내기`,
"label.tabpage.notexceed25":`선택한 기록 최대양은 25개`,
"label.starting":`진행중`,
"label.knowledge.language.spanish":``,
"label_emailtocloudcc_set":`메일 정보 설정`,
"message.oneormoreneedsreport":`대시보드가 이 보고서를 사용합니다. 이 보고서를 인용한 대시보드 구성요소를 삭제하고 다시 시도하세요.`,
"label.attendance.xccheckin":`현장 출석`,
"label.emailmerge.editfolder.title":`메일 병합 템플릿 폴더`,
"template.report.year.customer":``,
"label.partner.common.webSit.memo":`귀조직 파트너 클라우드의 기본 도메인 명이:`,
"label.partnerCloud.financeSetting.onlinePayment":``,
"Pagelayout.Setup.001":`뜬 페이지 레이아웃에서 표시되는 관련 리스트를 선택합니다`,
"front-kefu-moudle-time-length":``,
"label.deleteObject":`대상이 삭제되었습니다.`,
"label.setup.mobile.homepageshortcuts.select":`홈페이지 상단 구역에 나타나는 4개 단축키 기능을 선택합니다`,
"setup.mainpage.label.welcome26":`데이터 관리- 모두 처리 기능`,
"label.ServiceCloud.yuyuebainhao":``,
"label.emailobject.emaildetail.button.addtolead":`잠재 고객으로 추가`,
"label.event.single.view":`개인 뷰`,
"lable.product.pricebooks.ustand":``,
"label.emailtocloudcc.department":`지점`,
"component_assistant_label_30daysnoact":`30일 내에 행사가 없습니다`,
"label.weixin.no.pending.qzkh.qin":`현재 잠재고객 데이터가 없습니다`,
"label.vlidaterule.formula":`잘못된 조건 공식`,
"label.tianyancha.h5.contact":`연락처 정보`,
"label.button":`버튼`,
"message.checkemail":`<strong>에러：</strong> 메일 입력이 잘못되어 점검하세요`,
"lable.account.previous.CY":`지난 캘린더 연도`,
"label.icon.13":`수리`,
"chatter.coll.c":`저장 취소`,
"label.knowledge.category.hint.four":``,
"label.tianyancha.phonenumber":`연락처`,
"label.tablayoutedit.remark":`프런트 메뉴 페이지에 표시할 필드와 사용자 설정 페이지를 선택하십시오`,
"label.shareusers":`공유 사용자`,
"label.endtime":`종료시간`,
"label.length":`길이`,
"label.umeng.activity.event.begin":`후 시작합니다`,
"label.tabpage.alltabs":`전부 메뉴`,
"label.exact.query":`상세 조회`,
"label.weixin.skip":`바로 이동`,
"label.ems.cancel":`취소`,
"label.trigger":`트리거`,
"label.exchange.sync.setting":`Exchange Sync 설정`,
"label.product.pricebooks.name":`가격 매뉴얼 명칭`,
"label.relation.list.total":`선택 합계`,
"label.step2.total7":`2단계, 총 7단계`,
"label.martrixreport.2018.step6.new":`6단계: 차트 유형 및 보고서 하이라이트 보기 선택합니다`,
"label.standard.buttonandlink.override":`커버`,
"front-console-conversation-btn4":``,
"vue_label_dashboard_range":`범위`,
"label.app.sort.show":`응용프로그램이 저장된 순서로 배열됩니다`,
"label.salescloud.teamrole.choose.correct":`중복된 사용자를 선택했으며 수정하세요`,
"label.schedule_post":``,
"front-kefu-moudle-server-request-num":``,
"label.h5.logout":`로그아웃`,
"label.weixin.horse.club.member.message":`AID-MAX 회원 메시지`,
"label.field.addoptionlist.introduce":`다음에 한개나 여러개 선택항목 리스트값을 추가해 값 한개가 한 행을 차지합니다`,
"setup_layout_label_setupfield":`필드 속성 설정`,
"label.chatter.nextStep":`후속 절차`,
"label.quickbooks.searchlist.total1":`{0}개 미관련된 영수증 발행 기록이 검색되어 총금액이 {1}입니다`,
"label.tianyancha.h5.regcapital":`등록 자본`,
"label.icon.184":`컨설팅`,
"label.dashboard.message.refreshtoomush":`대시보드 캐시 새로 고침이 빈번하여 잠시후 시도하세요`,
"label.umeng.approval.reject":`#approver가 #obj 신청을 거절했습니다`,
"label.h5.chatter.newmessage":`새 메시지를 입력합니다`,
"message.error.relationid":`relationid를 입력하세요!`,
"label.setup.mobile.offlinecache.selectdefault":`기본으로 사용한 오프라인 메뉴를 선택합니다`,
"label.setup.mobile.homepageshortcuts.saveprompt":`단축키 4개의 기능을 선택하세요`,
"label.projectManagement.Selectmonth":``,
"label.version.ultimate":`플래그십 버전`,
"label.validate.remark5":`일자 필드를 정확한 시간 순서로 강제합니다. 예를 들어 시작일이 종료일보다 작아야 합니다.`,
"label.version.nowis":`현재 CloudCC 버전은`,
"front-kefu-moudle-CRM-set":``,
"label.mr.title.customerAddress":`고객 주소`,
"label_emailtocloudcc_step1_name":`기능 선택하기`,
"label.time.operation.edit":`타이머 과제 수정`,
"label_tabpage_operationz":`필드, 조작을 입력하세요`,
"label.translation.start4":`번역열을 더블클릭하여 새 값을 입력합니다.`,
"vue_label_systemSettings_request":``,
"label.maintenance.notice":`정례 유지 통지`,
"label.customfields.txet.textlength.tip":`아래서 텍스트 필드의 최대 길이를 입력하여 텍스트 필드의 길이는 255를 초과할 수 없습니다`,
"label.ccdocument.select.template.open":`템플릿을 선택해서 여십시오`,
"vue_label_display_date_field":``,
"label_partner_workspace_tab":`메뉴`,
"lable.account.LasthDays":`지난 120일`,
"chatter.using.sticker":`게시물 팔로우업 사용`,
"message.save.dataerror":`오류: 데이터 길이가 너무 길거나 기타 문제로 인한 저장 오류가 발생했습니다. 데이터를 수정하고 다시 저장해 주십시오.`,
"vue_label_commonobjects_view_chart_newchart":`차트 생성`,
"label.chat.micropost.a.group":`그룹`,
"lable.currencyManage.advcurrencyunEnabled":`고급 화폐 관리 미사용`,
"label.appexchange.workflow":`업무 프로세스 규칙`,
"vue_label_calendar_show_details_and_add_events":`상세 정보 및 이벤트 추가`,
"label.salescloud.optionlist.inputname":`아래서 선택항목 리스트값의 명칭을 입력합니다`,
"label.dashboard.folder":`대시보드 폴더`,
"label.knowledgebase.permanently.remove.articles":``,
"label.emailtocloudcc.titel":`CloudCC로 메일 발송`,
"label.visualpage.sel":`이 폴더의 사용자 설정 페이지`,
"label.planned.all.work":`모두 계획한 업무`,
"label.weixin.agree.agreement":`관련 협의에 동의합니다`,
"label.forecast.customforecast.qsn":`시작 연도`,
"label.appupload.managed":`피관리`,
"template.report.folder.sale.index":``,
"UG_opportunity_011":`거래 불러오기`,
"label.validate.function.funcFormat.SECOND":`초(일자)`,
"UG_homepage_005":`스마트 마케팅`,
"label.clicktoreturn":`뒤로가기`,
"label.collectionofview":`의 뷰 세트`,
"com.cloudcc.login.error.message.nonuser":`사용자가 존재하지 않습니다`,
"vue_label_systemSettings_emailsetting":``,
"vue_label_email_mark_as":`로 표시됨`,
"label.tabpage.customernamez":`고객명`,
"label.appupload.install.apicannotsame":`새 api명칭이 원래의 값과 달라야 합니다`,
"label.task.all.undealt":`모든 미처리 업무`,
"front-lightning-module-v1-dashborad-statistical-indicators":``,
"UG.quota.02":`견적서는 고객과 공급 업체 간의 지정된 시간 및 지정된 가격으로 지정된 제품에 대해 거래를 진행하는 법적 조항이다.`,
"label.approve":`승인`,
"vue_label_calendar_remove_calendar":`캘린더 제거`,
"label.mr.title.contactName":`연락담당자 이름`,
"label.projectManagement.resource":``,
"label.rejectbehaviour1":`승인자가 돌아갈 단계를 수동으로 선택할 수 있게 허용됩니다.( 이전 N단계로 돌아가기)`,
"label.publicgroup.relationship":`그룹 멤버 관계`,
"Lead.Scoring.DetailedPage.Popup.Title":`잠재 고객 관찰`,
"label.owner.edit":`소유권 편집`,
"label.campaign.channel.ticket.mark":`주의: 핸드폰 갤러리에 QR코드를 캡처해서 저장하거나 QR코드를 핸드폰에 저장하고, 이 QR코드로 행사장에 입장합니다.`,
"label.opportunity.setting.showstage.info":`모바일기기 상세 정보 페이지에 업무기회 단계 빠른 조작 구역 보기 여부`,
"label.emailobject.wizard.desc3":`메일 템플릿을 사용하여 시간이 많이 절약됩니다`,
"label.cpq.quote.no.product.add":``,
"label.customer.tab":`사용자 설정 메뉴`,
"Opportunity_Detailed_Phase_Label_Popup_002":`떠나는 시간`,
"component_telerecord_label_name":`이름`,
"label_component_helper_nodata":`현재 주의 사항이 없으며 잠시 후 점검하세요`,
"label.dashboardSetup.d2":`중단점2 값`,
"setup.mainpage.label.welcome4":`작업 매뉴얼: 본 페이지 좌측 메뉴를 클릭하여→응용 프로그램 설정→새로 만들기→대상자`,
"label.step4.total5":`4단계, 총 5단계`,
"label.payment.the.remaining.days":`계정 유효기간이 {0}일 남았습니다`,
"label.encoding":`코드`,
"label.setting.intergrationlist.status2":`해당 통합이 이미 설치되었습니다`,
"label.new":`새로 만들기`,
"label.search.searchsetup":`설정 검색`,
"label_tabpage_printz":`인쇄`,
"report.type.label.customService":`고객 지원`,
"label.notification.addEmailObject.message":`{!fromaddress}에서 온 메일이 도착했습니다. 클릭하여 확인하세요`,
"label.icon.68":`기계`,
"UG.Lead.003":`SNS`,
"label_mobile_default_field_service_home":``,
"label.select.one.group":``,
"front-kefu-moudle-trkey-nopower":``,
"label.chatter.cancel":`취소`,
"label.weixin.report.optiondisplay":`보고서 선택항목 보기`,
"front-kefu-moudle-v1-System-version":``,
"lable.product.pricebooks.editall":`모두 편집`,
"label.group.no.recent3":`혹은`,
"label.knowledge.article.delete":``,
"label.relateobj":`관련 항목`,
"workflow.action.tasks.assignortype.type":`유형`,
"label.layout.selectedfields":`필드 선정`,
"label.role.assign.operate":`다른 사용자를 이 역할에게 분배합니다：<br><ul><li>드롭다운 리스트에서 선택하여 사용 가능한 사용자를 볼 수 있습니다.</li><li>좌측에서 한 사용자를 선택해 <b>선정된 사용자</b> 리스트에 추가합니다.</li></ul>`,
"label.field.insert":`필드 삽입`,
"label.icon.11":`사람`,
"label.group.no.recent4":`그룹 만들기`,
"front-epwechat-module-v1-input-corpid":``,
"setup_object_field_dependency_label_actionfieldnotnull":`한개 제어필드 값을 선택해 설정하세요`,
"setup.mainpage.label.welcome19":`작업 안내: 본 페이지 좌측 메뉴를 클릭하여 → 관리 설정 → 사용자 관리 → 사용자, 역할, 프로필`,
"label.escalation.setup.list.rulename":`규칙 명칭`,
"label.ems.addaccount":`계정 바로 추가`,
"label.reportsSubscription.details.only":``,
"vue_label_commonobjects_view_groupby":`그룹 분류 근거`,
"label.email.form.text":`텍스트만`,
"label.weixin.loginname":`로그인 네임`,
"label.forecast.settings.sr":`수입`,
"label.chatter.sendEmailToGroupMember.subject.F":``,
"label.ccchat.enter.subject":`투표 주제를 입력하세요`,
"label.customer.tab.introduce":`사용자 설정 대상 메뉴의 외형과 기능이 시스템에서 제공한 표준 메뉴와 비슷합니다`,
"message.login.mfaverification.wrong":`보안카드에 오류가 발생했습니다!`,
"component.newrecords.label.name":`명칭`,
"label.salescloud.opportunity.addandedit.contactrole":`연락담당자 역할 추가 및 편집`,
"label_emailtocloudcc_button_next":`다음 단계`,
"label.console.step5":`5단계. 기록 보기를 선택합니다.`,
"setup.main2018.label.norole":`시스템 관리의 관련 권한이 없음`,
"template.chart.ywjhqd":``,
"label.instrumentPanel.breakpointOneLabelname":``,
"label.qrcode":`QR코드`,
"label_tabpage_no2z":`아님2`,
"label.log.search.date.range":`조회주기가 {c}개월보다 클 수 없습니다!`,
"label.console.step7":`7단계: 프로필 분배합니다`,
"label.australian.central.standard.time":`중앙 표준 시각(노던준주)`,
"label_tabpage_deleteviewfailed":`뷰 삭제 실패`,
"vue_label_commonobjects_view_searchview":`뷰 검색`,
"message.error.object.notexists":`대상이 존재하지 않습니다`,
"label.tablecell":`셀`,
"vue_label_notice_edit_success":`편집 성공`,
"label.customer.language":`기본 언어`,
"label.csrf":``,
"label.forecast.customforecast.submit.zhi":`로`,
"label.sso.saml.idp.config.desc2":`신원 제공자 사용을 클릭하여 CloudCC.com 조직을 신원 제공자로 사용할 수 있습니다.`,
"label.export_data":``,
"component.todaytask.label.all":`모두 보기`,
"label.h5.chatter.record":`기록 팔로우업`,
"front-vew-email-verification":``,
"laber.marketsea.del.error":`고객풀이 차지되어 있어 삭제할 수 없습니다`,
"vue_label_notice_homepage_entername":`수정 명칭을 입력하세요`,
"UG.Forcast.01":`예측`,
"front-email-payment-tips":``,
"setup.mainpage.label.welcome2":`사용자 설정 데이터 베이스(대상자)`,
"APPIntegration.Social.facebookerror":`합법적인 facebook.com의 URL이어야 합니다`,
"label.profile.mobile.setup.stand":`표준 메인 홈페이지`,
"label.custom.CY":`사용자 설정 연도`,
"label.knowledgebase.publishing.conditions":``,
"label.tianyancha.description":`TIAN YAN CHA 공상 데이터 인증을 사용해 사용자가 업체 고객 자료를 입력 시 사용자가 고객의 공상 등록 정보를 정확하게 입력하도록 도와줍니다. 해당 서비스는 TIAN YAN CHA에서 제공되며 중국 대륙 지역에서 등록된 공상 업체 데이터가 지원됩니다.`,
"label.appexchange.uninstallpage.title":`이 소프트웨어 패킷을 삭제하면:`,
"label.currencyRate":`환율`,
"setup_layout_label_areashow":`영역 명칭 표시 위치`,
"label.setup.case.setting":``,
"vue_label_commonobjects_view_fixed_at_most":`최대 3열만 고정이 가능합니다`,
"template.report.month.income":``,
"label.sms.companyname":`회사명`,
"label.sendemail.registIMUser.waitmessage":`로그인할 수 있는 파트너 클라우드 포털이 없으며 잠시후 관리자의 통지를 기다리세요. 지정한 주소를 방문하면 로그인 페이지로 이동할 수 있습니다. 상술한 사용자명과 비밀번호로 로그인하면 됩니다.`,
"label.custom.field.task.object":`안녕하세요! 님에게 분배될 업무가 있습니다. 업무 주제:`,
"message.pleaseselectdayinweek":`요일 중 하루를 선택하세요.`,
"label.chat.topic.favorites":`즐겨찾기`,
"UG.Campaign.004":`마케팅 행사 불러오기`,
"label.approval.preview":`절차 승인 미리 보기`,
"label.knowledgebase.assign.articles.to.people.or.queues":``,
"pagecreator_systemstyle_message_save_success":`양식 저장 성공`,
"label.outline":`개요`,
"label.read.only.field":``,
"front-gantt-module-v1-early-warning":``,
"label.file.ccchat.selectfrompc":`컴퓨터에서 파일을 선택합니다.`,
"vue_label_systemSettings_social":``,
"label_report_year_last_year":``,
"lable.PowerProcess.Meet.the.conditions":``,
"label.changemydisplay.list.title":`나의 보기 변경`,
"UG_Forcast_03":`계획을 사용해 업무 전략을 실시합니다. <br>즐겁게 예측하세요!`,
"label.sendemail.chat.sendmessage":`존경하는 #name:\n\n    안녕하세요！#userName이 님에게 메시지를 보냈습니다.`,
"label.huanxinconfig.secretid.lost":``,
"label.icon.49":`발전`,
"chatter.feed.button.publish":`발표`,
"label.power":`^곱하기`,
"label.partnerCloud.financeSetting.informationThree":``,
"label.emailtocloudcc.step1.lead2":`설정한 후 본 이메일에서 받은 이메일이 자동으로 잠재 고객 기록으로 생성되어 빠짐 없이 비즈니스 기회를 확보한다.`,
"label.knowledgebase.delete.draft.succeeded":``,
"label.dashboardSetup.title":`구성요소 에디터`,
"label.trigger.operation.email.template.map":``,
"label.dependencesearchfilter":`관련 조회 필터`,
"label.selected.search.length":`선택된 검색 필드가 10개를 초과할 수 없습니다`,
"label.profile.commonusercontrol":`일반 사용자 권한`,
"lable.Microsoft.YaHei":``,
"label.appupload.component.type.app":`응용 프로그램`,
"label.customsetting.manage.position":`위치`,
"vue_label_systemSettings_bindweb":``,
"label.loginservice.license.notexist":`허가증이 존재하지 않습니다`,
"label.icon.43":`방울`,
"UG_homepage_003":`360도 뷰`,
"label.file_format":``,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`일요일`,
"vue_label_chatter_post_has_delete":`게시물이 삭제됨`,
"report_label_searchresult":`검색 결과`,
"label.tabpage.justsz":`방금`,
"Lead_Scoring_Setting_LevelSetting":`잠재 고객 활약도 설정`,
"setup.object.field.dependency.label.selectedfieldvalue":`이미 선택한 필드값`,
"label.search.morelistview":`더 많은 리스트 뷰`,
"vue_label_homepage_won":`수주계약 성공`,
"label.notification.last30days":`최근 30일`,
"vue_label_helpcenter_pool":`고객과 잠재 고객 풀을 사용해 마케팅 데이터를 관리한다.  <br>고객풀 설정 <br> 시스템에서 고객풀을 생성해 고객풀의 관리자와 멤버를 설정하여 기한을 넘긴 자동 회수 규칙을 배치하며 그룹 내부의 기회 팔로우업 상황을 관리한다. 그룹 멤버들이 적극적으로 팔로우업하는 것을 격려한다. <br>데이터 수동 관리 <br> 고객풀 관리자가 고객풀에서 기록을 분배, 회수, 폐기, 이동 등 작업을 할 수 있어 고객풀의 기록을 통일적으로 관리한다. <br> 고객풀 멤버들이 고객풀에서의 미분배한 업무를 수령하거나 본인이 맡고 있는 기록을 확인한다.`,
"label.emailsync.status.export":`Excel_csv 파일로 내보내기`,
"label.service.miniProgram.slideshowTitle":``,
"label.service.miniProgram.slideshowName":``,
"label.fieldupdate.selectobj":`이 필드에 대상 선택을 업데이트하여 '다음'을 클릭합니다. 필드 업데이트가 같은 유형의 업무 프로세스 규칙, 승인 과정과 관련시킬 수 있습니다.`,
"label.ccpeak.take.notice.sharetab":`주의: 공유 차트 식표현의 필드에 __c"！"를 추가할 필요없습니다`,
"label.log.startdate.after.endate":`시작시간이 종료시간보다 클 수 없습니다!`,
"label.rememberme":`사용자명 기억하기`,
"label.partner.all.maxNum":`파트너 클라우드의 최대 데이터:`,
"component.setup.iframe.label.inputurl":`URL주소 입력하세요`,
"label.h5.systemmessage":`시스템 메시지`,
"label.delete.date":`일자 삭제`,
"front-email-payment-select-month-tips":``,
"front-kefu-moudle-bind-userinfo":``,
"label.appointment.wizard.notif2":`일정 예약을 생성하기 전에 예약 시간을 미리 설정해야 합니다`,
"label.custom.field.maping.number":`잠재 고객 숫자 자릿수가 매핑 필드 자릿수보다 많을 수 없습니다`,
"label.event.dayview":`일별 뷰`,
"label.replace":`교체`,
"label.knowledgebase.search.knowledge.articles":``,
"component_event_label_soon":`바로`,
"label.imgfield.upload":`이미지 업로드`,
"message.printable.view":`인쇄 가능한 뷰`,
"vue_label_notice_uploadavatar_notice1":`업로드할 프로필 이미지가 2MB를 초과하면 안됩니다`,
"label.visualpage.developer.help":`사용자 설정 페이지 개발자 도움말`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`통합 인증 설정`,
"vue_label_calendar_step_1":`1단계: 대상 캘린더에 대해 명명합니다.`,
"component.telerecord.button.save":`저장`,
"setup_mainpage_button_manageobject":`대상 관리`,
"label.marketingactivityinfluence":`마케팅 행사 영향`,
"label.quote.bjjsxx":`견적 수락 정보`,
"label.appupload.upload.install.retry":`다시 설치하기`,
"label.layout.assignrules":`분배 규칙`,
"UG.Lead.006":`웹사이트 방문객`,
"label.workmate.searchs":`동료 검색`,
"label.visualpage_list.no":`사용자 설정 페이지 방문 권한 없음`,
"label.service.miniProgram.slideshowintroduce":``,
"label.multilang.messagedetail.search.desc":`{0}이 포함된 메시지를 찾을 수 없습니다:`,
"label.mobile.phone.read.note":`비고를 입력하세요`,
"label.passwordPolicy.setup.isUsingGotp":`2차 인증 로그인 사용`,
"message.datetypeerror":`<strong>에러：</strong> 일자가 정확하지 않습니다`,
"label.searchlayout.listview.button":`리스트 뷰에 나타나는 버튼.`,
"label.sectionpart":`일부`,
"label.partnerCloud.basicSetting.userSetting":``,
"System_Data_Import_Warning_MaxCount":`귀조직이 매번 {0}개 데이터만 불러올 수 있어 이미 한계를 초과하여 조정한 후 다시 불러오세요.`,
"label.datamove.qualified.record":`개 조건을 부합한 기록, 매번 최대 100개를 이동할 수 있습니다!`,
"component_task_label_priority":`선순위`,
"vue_label_report_me":`나`,
"label.college.duplicate.option":``,
"label.pw.letter":``,
"label.file.sharedwithme":`나와 공유`,
"label.translation":`번역`,
"lable.currencyAdv.exchagecurrency.before":`이전`,
"label.file.share":`공유`,
"label.page.next":`다음 페이지`,
"label.autoRegister.changepwd.setpwd.notmatch":`두번 입력한 비밀번호가 일치하지 않습니다`,
"label.tabpage.include":`포함`,
"front-email-payment-thanks":``,
"vue_label_help_helponthispage":`본 페이지의 도움말`,
"label.approvepagelayout":`승인 페이지 레이아웃`,
"vue_lightning_help_zero_distance_communication":``,
"vue_label_normal_case_sf":`개인안`,
"label.report.line.tuozhuai":`마우스를 끌거나 두번 클릭하여 보고서 열을 선택해 순서를 조정한다`,
"template.dashboard.management":``,
"label.customcomponent.params.info.n1":`component라벨의 args속성의 값을 사용해 args는 json 형식이며, 예: args="name:'zhang',age:26", cc코드에서 String myName = name; int myAge = age;를 사용합니다`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`계약서 체결 서약률`,
"label.add.status":`상태 추가`,
"label.loss.customers":`종료/ 고객 이탈`,
"vue_label_chatter_involving_me":``,
"label.update.input":`입력을 수정하세요`,
"label.import.step1.commonobj":``,
"label.appupload.upload.tips.document":`주의: "내 개인 폴더" 와 " 빨간 폴더" 의 파일을 패키지에 추가할 수 없으며 이 리스트에 표시할 수도 없습니다.`,
"label.appupload.install.complete":`완성`,
"label.console.edit":`편집 조작공간`,
"setup.object.field.dependency.label.removefromlist":`선정된 값을 제거한다`,
"label.textmessage.groupsms.no.phone":`핸드폰 번호 없음`,
"label.account.Current.and.NextFQ":`현재와 다음 회계 분기`,
"label.sso.saml.sp.idtype.userid":`성명에 사용자 대상에서 온 사용자 ID가 포함됩니다`,
"label.data.import.setup.operate.update":`기존 기록을 갱신하고, 새로운 기록을 삽입하지 않습니다.`,
"front-kefu-moudle-v1-jcaws-call-serve":``,
"label.version.bacheditordel":`대량 편집/삭제/이동`,
"lable.even.higher":``,
"label.datetime.error":`일자 형식이 정확하지 않습니다`,
"vue_label_commonobjects_detail_customer_hierarchy":`고객 등급 구조`,
"label.startuploadfile":`업로드 시작`,
"label.appointment.wizard.subtitle3-1":`월요일`,
"label.weixin.relevance":`관련된 업무기회`,
"label.datamanage.field.mapping.information":`필드 매핑 설정`,
"label.brief.lastweek":`지난주`,
"label.nextstep":`다음`,
"label.listtoshow":`아래에 리스트가 표시되어 있습니다. {0}을 표시했습니다`,
"label.partner.ishave":`에러: 도메인 네임이 존재합니다`,
"label.service.miniProgram.name":``,
"label.view.filterbyaddition":`부가필드로 선별하기(선택 가능):`,
"label.projectManagement.nodata.task":``,
"label.chooseemailtemplate":`메일 템플릿을 선택합니다`,
"label.page.step4.add.profile":`4단계: 프로필에 추가합니다`,
"label.ems.mailtype":`메일 유형`,
"label.weixin.no.pending.projects.vg":`잘하셨습니다. 승인 대기중인 항목이 없습니다`,
"label.tabpage.saveviewfailed":`뷰 저장 실패`,
"label.chat.file.upload.cancel":`업로드 취소`,
"com.cloudcc.login.error.message.notenabled":`사용자가 개설되지 않았습니다`,
"label.data.import.setup.operate.insertandupdate":`기존 기록 업데이트 및 새 기록 삽입합니다`,
"label_target_type":``,
"label.notification.event2":`[피분배자]에게 분배한 이벤트가 확인되었습니다`,
"chatter.feed.menutype.feed.news":`나의 팔로잉 콘텐츠`,
"label.import.page1.suitedwayofcustomer":`고객 방식을 매칭함`,
"label.import.page2.CloudCCfiled":`CloudCC 필드`,
"label.custom.quarter.start":`새로 만들기`,
"label.page.including.tab":`메뉴 포함`,
"label.mobile.phone.day.plan2":`오늘 계획`,
"template.report.lead.conversion.statistics":``,
"label.show.type":`표시 유형`,
"label.weixin.no.pending.wdgz.qin.week":`이번주에 업무가 없습니다`,
"2018UI.Homepage.DataDeleted.Info":`데이터가 이미 삭제되었으며 클릭하여 뒤로 돌아갑니다.`,
"label.vlidaterule.message":`오류 정보`,
"label.approval.remark":`승인 의견`,
"label.field.duplicate1":`특유`,
"label.batchtransfer":`모두 이동`,
"label.quickbooks.view.allinvoices":`모든 인보이스`,
"vue_label_commonobjects_detail_lead_selectedstatus":`선정된 상태로 표시됨`,
"label_home_page_source":`데이터 소스를 선택하시오`,
"front-kefu-moudle-v1-opencall-please":``,
"setup_layout_label_asc":`오름차순`,
"label.use_tikect":``,
"label.tag.setup":`라벨 설정`,
"label.existinglayout":`기존 페이지 레이아웃`,
"label.productsales.today.noevt":`오늘 처리되지 않은 이벤트는 없습니다!`,
"message.error.view.date.validerr":`합법적인 일자 형식(YYYY-MM-DD、MM/DD/YYYY)이나 특수 일자 문자를 입력합니다`,
"label.mr.descreption.oneGroupReData3":`중복 데이터로 처리되었습니다`,
"label.tianyancha.businessverify.msg1":`공상 기업 데이터 인증 기능을 사용해 사용자는 반드시 본 《사용자 허가 협의서》(이하 협의)의 각 조항을 충분히 읽고 이해해야 합니다. 베이징 CloudCC 회사의 책임 면제(이하 CloudCC)관련 조항 및 사용자에 대한 권리 제한 조항을 포함합니다.신중하게 이《협의》를 읽고 동의 여부를 선택해 주십시오.`,
"label.custom.CQ":`사용자 설정 분기`,
"label.version.custom.dashboard":`표준 대시보드(사용자 설정 페이지)`,
"vue_label_commonobjects_detail_dragtoupload":`파일을 여기에 끌어 놓거나 <em>를 클릭하여 업로드합니다 </em>`,
"label.tabpage.addadvancedoptions":`고급 선택 항목 추가`,
"front-kefu-moudle-v1-Launch-page":``,
"label.emailobject.tabname":`메일`,
"label.weixin.addmore":`더 많이 추가`,
"message.error.view.operator.validerr":`지원되지 않는 조작 문자`,
"label.another_page":``,
"label.reportTypeFocusD2":`예시: 보고서가 협력 파트너가 있는 업무기회의 연락담당자에 관하면`,
"label.icon.47":`기압계`,
"label.task.today":`오늘의 업무`,
"label.service.gantt.weekend.highlight":``,
"label.customcomponent.referencetagname":`라벨 명칭`,
"label.senderemail":`발송인 메일 주소`,
"label.defaultvalue":`기본값`,
"label_tabpage_Sdfez":`일 전`,
"pagecreator.page.label.pagename":`페이지 명칭`,
"vue_label_report_pagenumber":`범위 내의 페이지값`,
"label.emailsync.connectaccount.description":`개인 이메일을 여기에서 추가하여 시스템에서 자동으로 메일의 발송 주소를 통해 시스템에서의 잠재 고객, 담당자와 매칭시켜 메일 내용을 해당 기록으로 동기화시켜 고객과의 소통 진도를 팔로우업한다.`,
"label.schedulableprg.chooseweek":`매주의 요일 날짜를 선택해 주세요.`,
"lable.edit.queue.membercanuse":`사용 가능한 멤버`,
"lable.Quick.find":``,
"label.daynuminmonth":`개월의`,
"message.error.state":`state가 필수 요소입니다!`,
"label.introduction.the.form":``,
"label.batchtransfer.pleaseselectcomefromuser":`사용자로부터 이동을 선택하세요`,
"front-dashboard-module-implemented":``,
"label.custombutton.newerror":`새로만들기 실패`,
"label.version.allow.size":`상한에 도달했습니다! 필요하면 CloudCC 버전을 업그레이드하세요!`,
"label.weixin.account.loginpage":`고객 로그인 페이지`,
"message.pleaseselectfieldtype":`필드 유형을 선택하세요`,
"component.setup.label.parentobject":`상급 대상자`,
"System.TAB.SeeViewAmount":`총액 보기`,
"label.event.lastmonth":`지난달`,
"label.taskrecordtype":`업무 기록 유형`,
"label.layout.selectedpages":`페이지 선정`,
"label.appointmentdetail.wizard.title19":`토요일 시간 계획`,
"label_chatter_endData":`종료일`,
"label.appupload":`소프트웨어 패킷`,
"label.knowledgebase.article.link":``,
"label.licence.enddate":`허가증 만료 시간`,
"chatter.fieldtrack.record":`기록`,
"label.reportsSubscriptionPage.schedulereport.weekly":`매주`,
"label.forecast.editshrepage.title2":`공유 편집`,
"label.attendance.onwork.time":`출근 시간`,
"label.appointment.wizard.subtitle1-8":`3시간`,
"pagecreator.layout.button.upload":`레이아웃 업로드`,
"label.input.notless.than.number":`{0}보다 크거나 같은 숫자를 입력하십시오`,
"setup.mainpage.label.welcome13":`작업 메뉴얼: 톱 메뉴를 클릭하여 →보고서 →새로 만들기.`,
"label.forecast.settings.data.opp":`업무기회 종료일`,
"vue_label_display_checkbox_field":``,
"label.summaryreport.2018.step5":`5단계: 그래프 종류와 보고서 하이라이트 표시를 선택하십시오`,
"front-lightning-module-v1-dashborad-one-statistic":``,
"label.home.standard.dashboard.forcase":`예측 허용을 설정하지 않아 판매 승낙 간판을 볼 수 없습니다.`,
"page.field.track":`필드 팔로우업`,
"label.dataimport.format.datetime.error":`형식이 잘못되어 yyyy/MM/dd HH:mm:ss나 yyyy-MM-dd HH:mm:ss 형식을 사용하세요.`,
"lable.opppdt.selPbk.title":`가격매뉴얼 선택`,
"pagecreator_systemstyle_label_stylename":`양식 명칭`,
"label.projectManagement.nodata.project":``,
"label.start_below":``,
"label.campaignmember.main.delete":`마케팅 행사 멤버 대량 삭제`,
"label.modifyall":`모두 수정`,
"label.homepage":`홈페이지`,
"vue_label_pool_adoptedbyme":`내가 수령한 것`,
"label.email.clearItem":``,
"label.callcenter.login.Amazon.connect":``,
"label.import.page1.selectimportfiled":`불러올 파일을 선택하시오`,
"message.error.id":`id를 입력하세요!`,
"label.ggReleaseRange.searchUsers":``,
"label.changemypwd":`나의 비밀번호를 변경합니다`,
"label.ccpeak.reference.parameters":`직접 인용 가능한 파라미터:`,
"chatter.share.success.tip":`성공! 이 게시물을 공유로`,
"label.message.checkfailed":`문법 검사가 실패하였으며 해당 종류의 명칭이 이미 사용중입니다!`,
"label.shangqing.introduction":`최근 잠재 고객 및 고객의 핫이슈에 대한 통합 정리로 영업 인력이 더욱 전면적으로 고객을 파악합니다`,
"label.allemailnotice":`모든 메일 알림`,
"vue_label_report_copy":`보고서 복사`,
"label.exchange.sync.state.setting":`설정 배치`,
"label.merge.result.error1":`다음 기록이 잠겨 있어 \"병합\" 을 할 수 없습니다.`,
"label.process.des":`현재 기록의 상세 정보를 보려면 좌측 링크를 클릭하세요`,
"label.textmessage.vonage.create.lead.setting":`시스템 주소록에 입력되지 않는 메시지를 받을 때 잠재 고객으로 생성됩니다`,
"label.views":``,
"label.notification.tip1":`알림이 없습니다`,
"label.forecast.detailforecast.returnforecast":`예측으로 돌아가기`,
"label.knowledgebase.target.framework.name":``,
"label.brief.close.opportunities":`수주계약 기회수`,
"label.appointment.wizard.subtitle4-2":`일정 최후 알림 시간`,
"vue_label_systemSettings_set_record":``,
"pagecreator_page_message_publish_fail":`페이지 발표 실패`,
"vue_label_homepage_name":`홈페이지 명칭`,
"label.weixin.no.pending.wdgz.qin.month":`이번달 이번주에 업무가 없습니다`,
"label.campagin.register.page":`마케팅 행사 멤버 등록 페이지`,
"label.campaign.channel.edit":`마케팅 행사: 마케팅 채널 편집`,
"label.folder":`폴더`,
"label.umeng.chatter.follow":`님을 팔로우했습니다`,
"label.sso.theKeyToEdit":`비밀키 편집`,
"label.deletelayout":`페이지 레이아웃 삭제`,
"label.same.analyze.miaoshu":`위 조건의 관계는 다음과 같습니다. "업무기회 명칭" 또는 "고객 명칭" 또는 ("연락담당자 핸드폰" 및 "연락담당자 메일").`,
"label.ccpeak.sel":`이 폴더의 클래스`,
"label.tabpage.addtoworkbench":`첫 페이지 작업 공간에서 추가`,
"label.forecast.shrepage.classdes.r":`읽기 전용- 사용자가 예측 데이터를 볼 수 있습니다.`,
"homepage.custompagename":`사용자 설정 페이지 명칭`,
"label.sendemail.batchapprovalinfo":`#name 안녕하세요:\r\n     실행한 모두 승인 작업이 완성됐습니다. 승인 성공 #successnum개,승인 실패#errornum개.`,
"front-email-payment-Invoice-alipay-describe":``,
"setup.object.field.dependency.label.configured":`배치된 내용`,
"label.potentialcustomers":`잠재고객`,
"label.timetrigger.button":`시간 트리거 버튼 추가가 다음 상황에 사용할 수 없습니다:`,
"label.category.10":`변호사`,
"label.selectall":`모두 선택`,
"message.field.id.not.null":`필드 ID를 입력하세요`,
"CloudCCCRM.ST.Info.TypeIn.001":`입력하세요`,
"label.author":`창작자`,
"label.import.step1.csvonly":``,
"label.assignment.setup.newrule.name":`규칙 명칭`,
"label.campaignmember.selectmember.chosestatusdesc":`멤버를 추가할 마케팅 행사를 선택해 멤버 상태를 제정합니다. 새 마케팅 행사를 생성하려면 이 과정에서 나가야 합니다.`,
"label_tabpage_operation":`조작`,
"label_tabpage_datatyoez":`데이터 유형`,
"UG_product_04":`제품 생성`,
"label_emailtocloudcc_step1_case2":`배치한 후 메일함에서 받은 메일이 자동으로 개별안을 생성해 발신함대로 연락담당자와 고객을 매칭시켜 개별안과 관련된 고객과 연락담당자와 연결시키고 Case 서비스를 처리 및 팔로우업할 수 있도록 합니다.`,
"workflow.action.tasks.assignortype.role":`역할`,
"vue_label_notice_refreshi_success":`새로 고침 성공`,
"label.notification.arketsea.abandon":`{5}가 {2}{0}：{1}를 폐기시켰습니다`,
"label.icon.36":`컴퓨터`,
"chatter.group.cancelToJoin":`가입 취소`,
"label.publicgroups.edit":`공용그룹 편집`,
"message.duplication.label.letternum":`문자 자릿수 매칭`,
"label.brief.lost.opportunities":`계약서 파기된 기회수`,
"setup.layout.label.nofield":`선택할 수 있는 필드 없음`,
"label.dataimport.isSharingRule":`공유 규칙 실행`,
"vue_label_opportunity_contactrole_synctocontacts":`정보를 연락담당자와 동기화시킵니다`,
"attachment_button_massdownload":`대량 다운로드`,
"label.weixin.agreement.remark":`이 위쳇 서비스는 Aid-Max가 고객 사고 발생 시 자문 서비스의 보조툴이며 보험회사의 보험금 지급 최종 근거가 아니어 고객의 배상 청구는 보험회사의 실제 요구에 따라 처리됩니다`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/빌더/레이아웃 라이브러리`,
"label.ccdocument.online.edit":`문서 온라인 편집`,
"label.partner.setup.Enable":``,
"label.log.state":`조작 상태`,
"label.lower.bound":``,
"label.timezone.isenable":`사용자 다종 표준 시각대를 사용하여 사용자가 본인의 표준 시각대를 설정해 일자와 시간이 사용자의 표준 시각대로 나타납니다.`,
"label.martrixreport.setrowtitle":`열 제목을 지정하기`,
"label.bottom":`밑바닥`,
"label.multilang.ccchat.groupnotcontainsname":`명칭에 {0}이 포함된 활동 그룹의 멤버가 아닙니다`,
"label.step1.of.step5":`1단계, 총 5단계`,
"message.report.error.FieldListIsAmbiguous":`보고서 필드에 공식 필드가 다음의 필드를 인용하므로 이상이 발생하여 해당 공식 필드를 삭제하세요. 공식 인용한 필드:`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`{0}에서 {1}로 변경된다`,
"label.report.export.print.content":`해당 보고서의 헤더, 그룹 및 앞의 2000개 데이터를 내보냅니다`,
"message.thanksusing":`CloudCC.com을 사용하신 것을 감사합니다!`,
"label.reportexport.allobject":`모든 대상 내보내기`,
"label.projectManagement.working.hours.per.day":``,
"label.partnerCloud.financeSetting.enterCollaborator":``,
"label.defineReportRecords":`보고서 기록 세트를 정의합니다`,
"greate":`보다 큼`,
"label.sure_discard":``,
"label.escalation.setup.newaction.notifyowner":`개별안 소유인에게 알리기`,
"label.icon.28":`박사모`,
"lable.PowerProcess.see.page":``,
"message.error.object.relogin":`로그인이 실패하였으며 다시 시도하세요`,
"label.chatter.activity":`행사`,
"label.query.clone.detail.choose.canChoose":`선택 가능한 명세 대상`,
"chatter.using.object":`대상의 게시물 팔로우업을 사용해 대상 유형의 기록을 팔로우업할 수 있습니다.사용자가 팔로우업하는 필드를 선택하십시오. 이 필드가 사용자가 팔로우업한 기록에 변경될 때 사용자는 게시물 업데이트를 볼 수 있습니다.`,
"UG.opportunity.001":`마케팅 업무를 어떻게 모니터링하시겠습니까?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":``,
"vue_label_email_current_email":`해당 템플릿을 삽입하면 현재 메일을 커버하게 됩니다.`,
"label.h5.approval.page.layout":`다음 방식으로 승인 페이지 레이아웃을 설정할 수 있습니다: <br>설정 -> 생성 -> 업무 프로세스와 승인 -> 승인 과정<br>대응한 승인 과정을 선택하고, 승인 과정 이름을 클릭하여 <br>편집 선택->승인 페이지 레이아웃<br>승인 페이지 레이아웃 설정을 할 수 있습니다.`,
"component.hots.label.title":`인기 거래`,
"mail.foldername.notOnly":``,
"label.customer.tab.step1":`1단계: 상세정보를 입력합니다`,
"label.delete.persion":`삭제자`,
"chatter.changed0":`{0}을 {1}에서 {2}로 변경하기`,
"homepage.components.type":`구성요소 유형`,
"label.norfolk.isiands.time":`노퍽 시간`,
"label.product.pricebooks.view":`가격매뉴얼 뷰`,
"label.forecast.customforecast.director":`직접 산하`,
"label.emailtocloudcc.step3total3":`3단계, 총 3단계`,
"label.cloudccsite.end":`웹사이트 홈페이지 금지 사용`,
"label.login.verification.mfa.device":`가상 MFA 장치 인증`,
"chatter.follow":`팔로우업`,
"label.month's":`월의`,
"label.sendmail.step1.introduce":`다음 뷰의 하나를 선택합니다(이 메일의 수신인이 포함됨).`,
"label.shangqing.title":`비즈니스 설정`,
"label.rejectrecords":`기록 거절`,
"label.selectupdatevalue":`변경될 목표값을 선택하세요`,
"vue_label_pricebook_disabled":`가격 매뉴얼이 금지 사용됨`,
"component.chatter.label.title":`최신 게시물`,
"label.partner.all.workspace":`작업 공간`,
"label.querydetailservice.delete.message":`데이터가 삭제되거나 존재하지 않습니다`,
"label.objectRelationshipWithout":`관련 기록이 있거나 없습니다`,
"nocontain":`불포함`,
"label.partnerCloud.financeSetting.accountSettings":``,
"label.file.sharetype.owner":`소유인`,
"label.open.multilingual":``,
"label.searchresult.field":`결과 검색 필드`,
"label.tabpage.selectdate":`날짜 선택`,
"label.h5.logouting":`로그아웃`,
"label.quickbooks.fieldlabel.payment":`결제 방식`,
"label.chatter.leaveword":`메세지`,
"label.customfields.majoranddetailrelation.tip":`이 대상( 하위급 또는 상세 정보 ")과 다른 대상( 상위급 또는 "메인") 사이의 특수 상하급 관계 유형을 만듭니다. 이 중: <br>●모든 상세 정보 기록의 관계 필드는 필수 입력 항목입니다.<br>●관계 필드의 값이 저장되면 변경할 수 없습니다. </li><br>●상세 정보 기록의 소유권과 공유는 메인 기록으로 결정됩니다. </li><br>●사용자가 메인 기록을 삭제할 때 모든 상세 정보 필드 기록을 삭제합니다. </li><br>●메인 기록에 상세 정보 기록을 통합할 수 있는 누적 통합 필드를 만들 수 있습니다.</li><br> 관계 필드는 팝업 리스트에서 값을 선택하기 위해 사용자가 찾기 아이콘을 클릭할 수 있도록 합니다. 메인 대상은 리스트에 있는 값의 소스입니다."`,
"label.batchapproveorrefuse":`모두 승인/거부 승인 요청`,
"label.copy.success":``,
"vue_label_show_record_count":``,
"label.ems.delete.false":`삭제 실패`,
"label.new.Product.Goals":``,
"label_chatter_BCC":`비밀 문서 참조`,
"label.knowledgebase.data.archived.successfully":``,
"label.chuangming.title":`CHUANG MING 문자 게이트웨이`,
"label.notification.arketsea.recovery":`{5}가 {0}:{1}를 {2}로 회수되었습니다`,
"label.partnerCloud.orderingPlatform.paymentAmount":``,
"label.martrixreport.2018.step5.new":`5단계: 보고서 기준을 선택합니다`,
"label.testing":`점검 중...`,
"chatter.poll.option4":`선택항목4`,
"lable.outlook.detail.otc":`Exchange에서 CloudCC.com으로`,
"label.startuploadfile.batch.step2":`2단계. '업로드 시작'버튼을 눌러 파일을 업로드합니다`,
"lable.outlook.edit.outdes":`Exchange에서 생성한 사용자 설정 필드를 입력하세요. 이 사용자 설정 Exchange 필드를 CloudCC.com 필드 앞에서 매핑하여 CloudCC.com이 처음 동기화할 때 Exchange 필드의 존재 여부를 인증합니다.`,
"hour":`시간`,
"label.appointmentpage.wizard.notif4":`무효한 메일 형식`,
"label.import.index.state":`상태`,
"label.integrations.mailchimp.massage6":`현재 페이지에서 선택한 데이터를 선정한 Mailchimp 리스트로 내보냅니다.`,
"label.file.share.email.subject":`#sharedBy가 #orgname에서 파일을 공유했습니다`,
"label.assignment.setup.newentries.noassignment":`소유인을 재배치하지 않습니다.`,
"label.dashboard.unit1":`단위: 만`,
"label.forecast.customforecast.foretype.commit":`약속 금액`,
"label.type":`유형`,
"label.partner.workspace.login.logo":`머리글 마크`,
"pagecreator_systemstyle_button_edit":`양식 편집`,
"label.displaytype2":`상세 정보 페이지 버튼`,
"email.one":``,
"label.partnerCloud.orderingPlatform.unavailable":``,
"vue_label_email_save_the_signature_successfully":`서명 저장 성공`,
"label.reportsSubscriptionPage.email.detailed":`상세`,
"chatter.group.query":`조회`,
"label.translation.unsupported.format":`지원하지 않는 형식입니다. 다언어 불러오기는 property 형식만 지원합니다.`,
"message.operateexception":`메시지 알림(문제가 있으면 시스템 관리자에게 연락하십시오).`,
"label.sendemail.chat.praiseFeedcomment":`존경하는 #name:\n\n    안녕하세요!#userName이 님의 댓글(#href)에 좋아요를 눌렀습니다.`,
"label.recycle.clearmy":`휴지통 비우기`,
"label_tabpage_choose":`선택`,
"#label.importstep2tip":`여러개 파일을 업로드하려면 모든 파일을 압축하여 불러올 수 있습니다. #`,
"label.batchedit":`대량 편집`,
"label.integrations.mailchimp.export":`Mailchimp로 내보내기`,
"label.cloudccsite.name":`웹사이트 명칭`,
"serviceterritory.serviceappointment.iscontain.contain":``,
"label.sum":``,
"setup.mainpage.label.welcome29":`표준 API 및 제3자 제품 통합`,
"label.tabpage.nothingz":`없음`,
"label.weixin.actual.contract.jine":`실제 계약서 금액`,
"label.tabpage.emailaddressz":`발신자 주소`,
"label.dashboard.unit4":`단위: 천만`,
"label.dashboard.data.labels":`데이터 라벨`,
"label.import.page2.oneonone":``,
"homepage.components.name":`구성요소 명칭`,
"template.report.task.theme":``,
"component.setup.label.setupsaveok":`구성 요소 설정 저장 성공`,
"front-epwechat-module-v1-add-selfapp":``,
"label.to.save.the.current.page.information.button.":``,
"vue_label_file_not_support_preview":`해당 파일이 미리 보기가 불가능하며 다운로드한 후 확인하세요`,
"label.object.reached.limit":`대상이 개수 상한에 도달했습니다`,
"label.partnerCloud.basicSetting.online":``,
"label.app.step1.error.nameexist":`공용 그룹 명칭이 존재합니다`,
"label.workflowandapprove":`업무 프로세스와 승인`,
"label.recordtypeselect.change.tip":`기록의 기록 유형을 변경할 때 기존 선택 항목 리스트값이 자동으로 변경되지 않습니다. 같은 곳에서 기록의 기존 선택 항목 리스트값을 변경하는 것을 추천합니다.`,
"label.summaryreport.step6":`6단계: 보고서 기준을 선택합니다`,
"Pagelayout.Setup.004":`최대 4개 필드만 배치된다`,
"label.file.attached":`첨부`,
"front-invoice-online-payment-setup-configure":``,
"label.approvaldatamove.submitdate":`제출 일자`,
"label.emailobject.time.from":`발신자:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`이 기록에 있는 $schemefield_name$ 필드가 데이터베이스에 존재합니다. 더 이상 삽입하지 않습니다. 해당 기록에 불러오는 것을 무시했습니다.`,
"assetbom.copy.notpermission":``,
"lable.outlook.mcto.autoallocation":`자동으로 이들이 관련된 CloudCC.com기록에 분배됩니다`,
"label.dataimport.but.datalength":`,하지만 데이터의 길이는`,
"label.setuserstocommit":`다음의 선택항목을 사용해서 초기 승인 요청을 제출할 수 있는 사용자를 지정합니다.`,
"component_telerecord_label_related":`관련 항목`,
"front-lighting-module-v1-detail-file-lockInfo":``,
"pagecreator_layout_button_edit":`레이아웃 편집`,
"label.app.step3.tabcanuse":`사용 가능한 메뉴`,
"label.ems.delete.sure":`이 메일 계정 정보를 삭제하시겠습니까?`,
"label.email.show":`보기`,
"label.checkbox.unchecked":`선정하지 않음`,
"message.error.operation":`조작이 실패했습니다. 시스템 관리자에게 연락하십시오!`,
"label.template.set.folder.only.upload.type.file":``,
"label.knowledgebase.select.publish.status":``,
"label.recordtype.tabname.edit":`선택한 기록 유형에 새 명칭을 입력해 '저장'을 클릭합니다`,
"label.tabpage.exportview":`뷰 내보내기`,
"label.dataimport.insert.sharetab":`공유탭을 삽입하는 데 실패했습니다.`,
"vue_label_dashboard_penetrateto":`로 침투됨`,
"label.weixin.group.member":`인원`,
"vue_label_systemSettings_customadd":``,
"UG_Account_03":`중복 고객 검사 및 병합`,
"label.singapore.standard.time":`싱가포르 시간`,
"label.weixin.captcha":`인증번호`,
"Account_News_Setting_004":`뉴스 사용`,
"label_emailtocloudcc_select1":`선택하세요`,
"label_ring_ratio":``,
"label.industrialandcommercialverification.button.save":`저장`,
"label.approvalstep5.tip":`승인 페이지가 승인자가 요청을 승인하거나 승인 거절하는 공간입니다. 다음의 선택 항목을 사용해 이 페이지에서 보는 필드의 편집 속성을 선택합니다.`,
"label.import.page1.maxrecord{{30000}}":`1. 한번에 최대한 불러올 수 있는 기록은 {{30000}}개`,
"setup_object_layout_label_profileoptions":`분배 가능한 프로필`,
"label.emailtemplate.type":`템플릿 유형`,
"label.searchlayout.tab.field":`메뉴에 표시한 필드.`,
"chatter.news":`메시지`,
"label.pw.small.letter":``,
"label.notification.group3":`공용 그룹 가입에 거절되었습니다`,
"label.ccchat.day.before.yesterday":`그제`,
"component.chatter.post.label.title":`붙이기`,
"label.tianyancha.type":`법인 유형`,
"label.detail.searchlayout":`검색 레이아웃 보기`,
"vue_label_pool_deleteconfirm":`선택한 ?{??1??}개 데이터를 삭제하시겠습니까?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1.csv 파일만 호환되며 최대 용량은{{100}}mb , 한번에 최대한 불러오는 기록은 {{30000}}개, 한도를 초과하면 여러개 파일을 나누어 불러올 수 있다.`,
"label.h5.similar.opportunity.lookup":`유사 업무기회 조회`,
"template.report.customer.list.opportunity":``,
"component_setup_iframe_label_memo":`설정 아이콘을 클릭하고 내장된 URL 주소를 입력하십시오.`,
"label.version.allemail":`메일 단체 전송`,
"lable.product.editp":`가격 편집`,
"label.weixin.plate.number":`차량번호`,
"font-evaluate-module-v1-disabled-successfully":``,
"label.multilingual.tip1":``,
"label.japan.standard.time":`일본 표준시`,
"lable.product.notdel.use":`의 삭제 시도, 다음 기록과 관련이 있어 금지 사용을 추천합니다.`,
"label.appointment.wizard.subtitle4-2-4":`4시간`,
"label.queue.edit":`편집`,
"label.partnerCloud.financeSetting.informationTwo":``,
"label.partnerCloud.partnerOrdering.permission":``,
"vue_label_commonobjects_detail_company_hierarchy":`회사 등급 구조`,
"label.forecast.settings.sl":`수량`,
"label.partner.workspace.tab.memo":`이 파트너 클라우드에서 사용할 수 있는 메뉴를 선택해 시스템 표준 메뉴와 사용자 설정 메뉴를 선택할 수 있습니다.`,
"label.mr.mainRecord":`메인 기록`,
"setup_mainpage_label_welcome20":`메일, 문자 템플릿`,
"front-email-payment-select-date-tips":``,
"label.dependencelisttag":`관련 리스트 라벨`,
"label.umeng.activity.eventof":`의 이벤트`,
"label.sales.dashboard.collection":`대금 수령 목표`,
"report_label_folder":`폴더`,
"label.assignment.setup.newentries.step1":`1단계: 이 규칙 조항의 순서를 설정합니다`,
"label.quote.shrname":`수령인 성명`,
"label.newreport.group.sum":`그룹수 통계`,
"label.number.MinCheck":``,
"label.chatter.save":`저장`,
"vue_label_email_all_email_templates":`모두 메일 템플릿`,
"message.summaryconditionnototal":`취합 조건은 누적 취합 필드를 선택할 수 없습니다!`,
"label.callboard":`공고`,
"label.step2.total5":`2단계, 총 5단계`,
"vue_label_homepage_custom_homepage_page":`사용자 설정 홈페이지`,
"label.data.newtemplate.e_seltype":`데이터 내보내기 방식을 선택합니다`,
"label.data.dataexpalltype.all.desc2":`2. 모든 데이터를 내보내는 데 시간이 걸립니다. 내보내기 성공 후 시스템에서 내보내기 성공 메일을 발송하겠습니다.`,
"lable.account.CalenderYear":`캘린더 연도`,
"message.error.data":`전송할 데이터가 없으며 전송 파라미터를 확인하세요`,
"label.from_user":``,
"label.parentdepartment":`상위 부처`,
"template.dashboard.product.analysis":``,
"label.tabpage.unpacketz":`그룹 분류 데이터가 없음!`,
"label.icon.107":`소통`,
"label.monitorsys.operator.username":`사용자`,
"label.serchreport":`보고서 검색`,
"label.payment.upgrade":`업그레이드`,
"setup_layout_button_ok":`확인`,
"label.please.select.channel":``,
"template.chart.txdrw":``,
"chatter.group.accept":`수신`,
"pagecreator_systemstyle_message_canntdelete":`현재 양식은 삭제할 수 없습니다`,
"label_tabpage_ctbtsftcz":`클릭하여 선택한 내용 검색`,
"label.datamanage.select.accountfield":`(불러온 고객에 맞는 필드를 선택합니다)`,
"label.schedulejob.setup.list.title":`타이머 작업`,
"label.visualpage_list.title":`사용한 사용자 설정 페이지 방문`,
"label.mr.selectTwoData":`병합할 데이터를 최소 두 개 이상 선택해 주세요.`,
"label.customer.tab.step2.different":`다른 프로필에 다른 메뉴 가시성을 응용합니다`,
"label.mobile.side.tab.can":`사용 가능`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`CloudCC 계정이 연동되어 계속하면 이 CloudCC 계정과 연동된 위쳇 번호가 CloudCC 시스템을 사용할 수 없습니다. 계속하시겠습니까?`,
"label.applet.to.case":``,
"lable.outlook.detail.cmaping":`연락담당자 필드 매핑`,
"label.theUserActiveTime":`사용자 활약기`,
"label.event.moveup.9hour":`9시간을 앞당깁니다`,
"vue_label_pool_other":`기타`,
"label.fieldname":`필드명`,
"vue_label_notice_add_success":`추가 성공`,
"label.conditiontag.lookup.insertbutton":`선택한 것을 삽입하기`,
"label.identifying":`표식`,
"label.tabpage.uploadingz":`업로드 중`,
"label.view.introduce":`뷰 편집`,
"vue_label_dashboard_sortingmethod":`정렬 방식을 선택하세요.`,
"label.quote.number.introduce":`제품의 수량 및 할인을 입력 후 "저장"을 클릭하세요.`,
"front-kefu-moudle-which-missphone-case":``,
"label.sendemail.chat.response":`게시물 댓글:`,
"label.productsales.refreshTime":`지난 새로고침 시간`,
"lable.SalesCommitmentKanBan.phase":`단계`,
"label.version.sum.object":`개 대상`,
"label.defineReportStep2":`2단계`,
"message.duplication.label.returnDuplications":`중복률 검사 필터 리스트로 돌아갑니다`,
"label.lookover":`보기`,
"label.quickbooks.button.copy2":`CloudCC에서 QuickBooks로 동기화하기`,
"label.checkbox.true":`이다`,
"label.profilename":`프로필 명칭`,
"label.finalapproveoperate":`최종 승인 조작`,
"label.SMS.detailed":`문자 알림은 업무 프로세스 규칙을 작동할 때 보내는 문자입니다.`,
"label.lasttimemodifier":`지난 수정자`,
"label.sso.summary":`종합`,
"label.customfields.encd.tip":`사용자가 알파벳과 숫가 조합을 입력할 수 있어 보기 형식으로 저장되며 보안 형식으로 볼 수 있어 검색 가능합니다.`,
"vue_label_report_formulacolumn":`행 수준 공식열`,
"vue_label_systemSettings_transfer":``,
"lable.product.ecm":`시세에 정확한 금액을 입력합니다`,
"label.partner.setup":`파트너 클라우드`,
"label.same.analyze.miaoshu2":`"기능`,
"label.mobile.phone.day.summary":`오늘 총정리`,
"label.ccchat.person.error.illdomain":`에러: 존재성 도메인 형식이 잘못되었습니다`,
"label.knowledgebase.edit.as.draft":``,
"message.duplication.label.newfilterule":`중복율 검사 필터 규칙 새로만들기`,
"vue_label_salesfunnel_notice1":`업무 기회 통계`,
"label.partnerCloud.partnerAccount.order":``,
"label.account.Current.and.PreviousFQ":`현재와 지난 회계 분기`,
"label.customfields.formula.dateandtimeexample":`Next（다음 값）= NOW()   1`,
"label.area.unassign":`미분배 사용자`,
"label.at.my":`나의 @내용`,
"vue_label_calendar_notice_stopsharingfail":`공유 정지 실패`,
"label.data.file.validation.rules":`인증 규칙 집행`,
"label.escalation.setup.entrydetail.escalation.hour":`시간`,
"vue_label_ccchat_notice_pleaseentercontent":`게시물 텍스트 및 옵션을 입력하세요`,
"label.forecast.edit.error1":`에러: 무효 화폐 종류입니다`,
"label_emailtocloudcc_exists1":`본 메일 주소가 이미 Email to Lead로 설정되어 중복 설정할 수 없습니다`,
"label.trigger.send.email":`트리거에서 메일 알림을 보냅니다:`,
"label.setmysafetysignagain":`나의 안보 표시 다시 설정하기`,
"label.callcenter.pleaseenter.access.keyID":``,
"chatter.poll.option10":`선택 항목10`,
"vue_label_systemSettings_mobelbottonsetting2":``,
"label.quickbooks.searchs":`검색`,
"label.section":`단락`,
"label.customfields.fielddependency.new.tip":`종속관계를 생성하며 해당 관계는 사용자가 다른 필드에서 선택한 값이 선택항목 리스트나 다답형 리스트의 값에 대해 실시간 필터링할 수 있게 합니다.<ul ><li> 필터링을 추진하는 필드는 제어 필드라고 합니다.최소 1개 값,최대 300개 값의 표준 및 사용자 설정 체크 상자와 선택항목 리스트가 제어 필드가 될 수 있습니다. </li><li>이의 값에 선별된 필드가 '종속 필드'라고 합니다. 사용자 설정 선택항목 리스트와 다답형 리스트가 종속 필드가 될 수 있습니다.</li></ul>`,
"label.customobjects.track.introduce3":`주의: 변경 부분의 필드만 팔로우업하며 필드값을 팔로우업 시 '변경됨'만 볼 수 있습니다`,
"front-kefu-moudle-all-hidden-phone":``,
"vue_label_calendar_share_calendar_with_others":`타인과 캘린더 공유하기`,
"label.case.copre":``,
"label.conditiontag.lookup.pagetitle":`선택항목 리스트값을 선택합니다`,
"UG.opportunity.004":`다종 업무 유형`,
"label.event.moveup.1day":`1일을 앞당깁니다`,
"label.industrialandcommercialverification.enablestatus1":`공상 데이터 인증 사용`,
"label.ccpeak.newrecord.getorpost":`기록 신규 추가: CCObject 대상을 사용해 CCObject가 두가지의 구축 방법이 있습니다`,
"frame.personinfo.label.resizeimage":`생략도를 조정하세요. 프로필 사진 위의 점선을 끌어 조절하세요.`,
"label.optional.searchresultfield":`선택 가능한 검색 결과 필드`,
"UG.Contract.02":`계약서는 각자 간의 서면적인 협의서이다. 많은 회사에서 계약서를 통해 다른 회사와의 업무 거래의 조항을 규정하고 있다.  CloudCC를 통해 고객과 업무 기회의 게약서를 체결해 문서 파일을 제공한다. 승인 절차를 통해 게약서를 팔로우업한다. 작업 흐름 알림을 통해 게약서의 비전을 알린다.`,
"label.group.activity":`행사 그룹`,
"label.tabpage.characterz":`시작 문자 부호`,
"label.globalsearch.tip":`검색 내용을 입력하세요`,
"label.campaign.channel.download.size2":`중 사이즈: 500*500화소`,
"label.step3.total4":`3단계, 총 4단계`,
"label.partnerCloud.payForFailure":``,
"label.ggReleaseRange.editSuccess":``,
"label.summaryinforelyon":`종합 정보 근거`,
"label.productsales.htyj":`계약 실적`,
"label.newpagelayout":`새버전 레이아웃`,
"front-gantt-module-input-task-name":``,
"label.c_d_without":`"C"기록에 관련 "D"기록이 있거나 없습니다.`,
"label.licence":`허가증`,
"setup.layout.button.selectall":`모두 선택`,
"label.app.step1.error.appnameexist":`에러: 응용프로그램 명칭이 존재합니다`,
"label.cpq.quote.item.no.record":``,
"label.knowledgebase.noaffect.existing.translations":``,
"label.schedulejob.setup.schedule.editjob":`타이머 업무 편집`,
"lable.PowerProcess.Tips":``,
"label.campaignmember.selectmember.step2":`2단계: 추가할 멤버를 선택합니다`,
"vue_label_calendar_stopsharing":`공유 캘린더 사용을 중지하시겠습니까?`,
"vue_label_notice_savemenu_fail":`메뉴 저장 실패`,
"message.error.getitems.id":`getItems:id를 입력하세요`,
"label.return.currencylist":`리스트 뒤로가기: 화폐 종류 관리`,
"label.wtd.detail.p":`PC 버전`,
"label.knowledgebase.publish.now":``,
"label.appupload.install.explain":`설치 설명`,
"label.visualpage.folder.all":`모든 페이지 폴더`,
"message.passwordPolicy.validate.complexReq2":`오류: 비밀번호는 숫자와 알파벳 대소문자의 조합이어야 합니다`,
"label.umeng.chatter.at":`님을 소환했습니다`,
"label.mobile.phone.month.report":`월보`,
"label.describableEditeSelectedFields":`사용자 설정 보고서를 새로 만들 때 보고서 열에 기본으로 나타난 필드를 선택합니다`,
"component.event.label.subject":`주제`,
"label.knowledgebase.edit.draft":``,
"label.customer.tab.step1.selectoneobject":`기존 사용자 설정 대상을 선택합니다`,
"label_partner_step2":`2단계: 템플릿을 확인합니다`,
"label_starting_annual":`시작 연도`,
"X":`텍스트 에어리어`,
"label.customer.tab.style":`메뉴 양식`,
"vue_label_commonobjects_detail_book":``,
"chatter.email.referredToMe":`게시물에 나를 소환할 때(즉 @)`,
"label.enable.both.barcode.qrcode":``,
"front-market-form-quired-choose":``,
"noinclude":`불포함`,
"label.sms.template.select":`문자 템플릿을 선택하세요`,
"label.weixin.optionten":`선택항목10`,
"message.duplication.label.matchlastletters":`뒤의 n개 문자가 매칭합니다`,
"label.webtocloudcc.submit.success":`제출 성공`,
"label.sales.dashboard.number":`번째`,
"label.custom.field":`이 사용자 설정 필드를`,
"label.dataimport.of.field":`개 필드.`,
"label.view.new":`새 뷰 생성`,
"UG_activity_03":`일정 예약`,
"label.customfields.image.tip":`사용자의 이미지 업로드가 허용됩니다`,
"label.startexport":`내보내기 시작`,
"vue_label_commonobjects_view_chart_verticalbar":`수직 막대 차트`,
"label.ccchat.person.invite.allexist":`초청한 모든 사람은 이미 동료 그룹을 사용하고 있습니다`,
"label.fielddependence":`필드 종속성`,
"label.scan.tip":`IE7, IE8, Chrome 또는 Firefox 브라우저를 사용하거나 해상도 1024×768 이상의 사용을 권장합니다`,
"label.wei.weiactor":`투표 참여자`,
"label.service.miniProgram.quantity":``,
"vue_label_homepage_new_homepage_page":`새 시작 페이지`,
"label.apply.telphone.validate.error":`핸드폰 인증번호가 잘못되었습니다.`,
"component.assistant.button.newevent":`이벤트 새로 만들기`,
"System_TimeField_Format_Warning":`유효시간이 아닙니다`,
"chatter.feed.publishfeed":`붙이기`,
"label.setting.intergrationlist":`통합 응용 프로그램`,
"label.object.prefix":`대상 접두어`,
"label.tippage.confirmed":`네. 사용자 설정 보고서 데이터 소스 및 모든 종속 보고서를 삭제하겠습니다`,
"label_emailsync_form_signin":`로그인`,
"label.delete.cancel":`삭제 취소`,
"label.dashboard.myHomePage.des":`응용프로그램마다 나타나는 대시보드를 선택하세요`,
"lable.account.FY.Ago":`두개 회계 연도 전`,
"label.umeng.approval.reassign":`#approver가 #obj 신청을 다시 분배했습니다`,
"label.data.exp.zippwd2":`압축 파일 비밀번호 자동 생성`,
"label.tabpage.contentz":`내용을 입력하세요`,
"label.callcenter.batch.add.number":``,
"label.tabpage.deleteviewsuccess":`뷰 삭제 성공`,
"setup_layout_group_field":`필드`,
"label.appupload.component.addobj.scheme.label.suoshu":`소속 대상`,
"front-project-module-v1-market-is-template":``,
"label.service.gantt.one.esource.types":``,
"label.emailtocloudcc.search":`검색`,
"label.mobile.home.page.myyj":`나의 실적`,
"vue_label_normal_invoice_sf":`영수증`,
"label.permission.detail.app.fenpei.tip":`응용프로그램 메뉴 위에 보이는 응용프로그램의 설정을 지정합니다`,
"label.login.access.month":`월별`,
"label_tabpage_retypez":`기록의 기록 유형을 변경할 때 기존 선택 항목 리스트값이 자동으로 변경되지 않습니다. 같은 곳에서 기록의 기존 선택 항목 리스트값을 업데이트하는 것을 추천합니다.`,
"label.ems.private.company.message":`사유 클라우드 버전에 회사 메일 온라인 편집이 지원되지 않습니다`,
"label.dataimport.length.check":`길이가 18자리가 넘으니 본 기록을 잘 검토하여 수정해 주십시오.`,
"label.batchtransfer.type1":`기존 고객 소유인에게 속하지 않는 미처리 업무 기회를 이전합니다`,
"vue_label_calendar_are_you_sure_to_remove":`캘린더를 삭제하시겠습니까?`,
"label.icon.117":`책가방`,
"vue_label_systemSettings_downloadapp":``,
"label.approval.project":`승인 대기 프로젝트`,
"template.organization":`조직급`,
"label.weixin.return.research":`리서치 정보 페이지로 돌아가기`,
"label.ccchat.person.invite.addsay":`선택 가능한 메시지 추가...`,
"UG.Case.02":`개인안을 통해 고객 문제에 피드백 주고 문제를 해결할 수 있습니다. 개인안이 Cloud CC에 기능이 많은 기록이며 고객 문제를 팔로우업할 수 있을 뿐더러 완전한 고객 뷰를 볼 수 있습니다.`,
"label_emailtocloudcc_step1":`1단계`,
"workflow.action.tasks.assignortype.owner":`소유인`,
"label.data.import.page":`데이터 불러오기 페이지로 이동`,
"label.cache":`캐시`,
"label.custom.page.cuspage.width":`페이지 너비(픽셀)`,
"label.customcomponent.referencetag":`인용 라벨`,
"label.tabpage.search":`검색`,
"label.knowledge.searcharticle.casefields":``,
"setup_layout_message_relatedlistfield":`관련 리스트에 표시할 필드를 선택하십시오. 선택한 필드를 다시 정렬할 수도 있습니다.`,
"label.relationobject.type":`관련 대상 유형`,
"UG_Account_02":`일부 업체가 다른 업체에 서비스를 제공하거나 사용자와 직접 협업을 할 수 있으며 NGO 기구에 서비스를 제공할 수도 있습니다.`,
"UG_homepage_006":`설문조사, 채팅, 메일, 업무 증표를 통해 SNS 게시물과 마케팅 행사(예, 잠재고객, 서비스 지원 및 행사)를 이해해 전방위적으로 고객 행사를 파악합니다.`,
"chatter.poll.option1":`선택항목1`,
"label.ccdocument.fieldforld":`파일 소속 폴더 명칭`,
"label.wei.result":`투표결과`,
"label.recentview.new":`최신`,
"label.martrixreport.setsumfield":`행렬식 보고서에 사용된 합계 행의 필드를 선택하세요`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`월요일`,
"label.marketsea.button.recycle":`회수`,
"label.standard.buttonandlink.info2":`이 표준 버튼이나 링크를 대체할 CloudCC URL의 사용자 설정 페이지를 선택하십시오.`,
"label.reportsSubscription.select.two.months":``,
"label.standard.buttonandlink.page":`표준 CloudCC 페이지`,
"vue_label_commonobjects_view_chart_horizontalbar":`수평 막대 차트`,
"label.Remove":`제거`,
"label.mobile.phone.receivable":`대금 회수`,
"label.appupload.uploaddetail.goback":`소프트웨어 패킷 리스트로 반환하기`,
"label.select.role":`역할을 선택하세요`,
"label.file.sharetype":`공유 유형`,
"label.app.chosetab":`메뉴 선택`,
"label.case.other.phone":``,
"chatter.edit.cancel":`변경이 취소되었습니다.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":``,
"message.error.system.service.permissiondeny":`죄송합니다. 해당 서비스의 사용 권한이 없어 시스템 관리자에게 연락하세요!`,
"label.chatter.mygroups":`나의 그룹`,
"label.umeng.approval.approvalpass":`#obj 승인 요청이 통과했습니다 #objname`,
"label.chatter.owner":`소유인`,
"vue_label_commonobjects_view_kanban_view":`간판 뷰`,
"message.please.choose.group.role":`그룹 역할을 선택하세요`,
"label.icon.136":`화폐`,
"label_tabpage_selectdate":`일자 선택`,
"chatter.emailInformation":`일반 정보`,
"front-lightning-module-v1-dashborad-bubble-size":``,
"label.stdashbord.xsld.business.wan":`만`,
"label.datamanage.field.notexist":`대상에 대응하는 필드가 존재하지 않습니다.`,
"UG.Forcast.04":`시용 시작`,
"UG.contact.02":`다양한 채널로 연락담당자의 관심을 모인다. 통화, 메일, SNS`,
"vue_label_pool_selecttransferinto":`이월할 고객풀 선택`,
"label.quote.xingming":`이름`,
"label.customerinfo.userlicencenum":`사용자 허가증 수`,
"label.group.no.my.archived":`매칭한 보관된 그룹을 찾을 수 없습니다.`,
"label.weixin.add.activity.tel":`행사 전화 추가`,
"label.partner.setup.address":`파트너 클라우드 주소`,
"label.data.file.i_title.num3":`3. 시스템이 불러올 데이터를 서버로 미리 읽어두어 시스템이 불러오기 프로그램을 작동합니다. 불러오기 결과가 메일로 사용자에게 알리며 이 페이지에서 기다릴 필요 없습니다.`,
"label_sum_up":``,
"label.searchall.title":`전역 검색`,
"label.bind.chooseone":``,
"label.campaign.channel.input.owner.select1":`현재 마케팅 행사 소유인`,
"front-kefu-moudle-v1-Expand-chat":``,
"label.component.hotdeal":`인기 거래`,
"component_event_label_title":`곧 진행될 이벤트`,
"No.planed.activity":`계획 중인 행사가 없습니다`,
"label.searchlayout.result.field":`결과에 나타난 필드를 검색합니다.`,
"label.leadscore.value":`점수`,
"vue.dashboard.linkage.is.set.successfully":``,
"PersonalInfo.LoginHistory.001":`브라우저 인증 메일 주소 링크`,
"front-gantt-module-v1-problem-number":``,
"label.page.step5.of.step5":`5단계, 총 5단계`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat 메시지 알림`,
"label.Linkedin_accounts":``,
"label.qrcode.useful.life":`QR 코드 유효기간`,
"deleterow":`행을 삭제합니다`,
"label.forecast.settings.future1":`미래 1개 주기`,
"message.error.group.operation":`소그룹 문서 보관 오류 발생`,
"label_tabpage_loadz":`페이지를 불러오는 중입니다. 잠시만 기다려주세요...`,
"label.brackets.left":`(좌측 괄호`,
"label.source.code":``,
"setup_layout_label_areasetup":`구역 속성 설정`,
"component.assistant.label.todaylead":`오늘 분배된 잠재 고객`,
"label.qrcode_signin":``,
"label.calendarshare":`캘린더 공유`,
"IMG":`이미지`,
"label.use.rule.when.both":``,
"label.ccpeak.addshare.record":`공유 차트 기록 신규 추가: 신규 추가 기록에서 볼 수 있습니다.`,
"label.enable.email.tracking":`메일 팔로우업 사용`,
"label.top.plsinput":`이 리스트를 검색합니다...`,
"vue_label_helpcenter_case":`개인안은 고객의 피드백이나 문제이다. 지지 대리가 개인안을 심의할 수 있어 더 좋은 서비스를 제공할 수 있도록 한다. 마케팅 대표가 개인안을 통해 마케팅 절차에 대한 영향을 파악한다. 개인안에 대해 피드백을 주면 고객의 만족도를 제고시켜 브랜드 이미지를 상승시킬 수 있다.`,
"label.useonly":`전용`,
"label.displaytype":`보기 유형`,
"label.most.user.group":`사용자는 최대 100개의 사용자 그룹에 가입할 수 있습니다.100개 가입하셨습니다`,
"label.umeng.activity.yourevent":`이벤트`,
"label.forecast.shrepage.classdes.w":`읽기/쓰기 - 사용자는 예측 데이터를 보고 커버할 수 있습니다.`,
"label.defaultaccess":`기본 방문 권한`,
"label.partner.new.step2":`2단계: 템플릿을 확인합니다`,
"component_setup_iframe_label_title":`사용자 설정 페이지`,
"label.sso.saml.sp.idenitytype":`SAML 신원 유형`,
"label.dashboard.this.folder":`이 폴더의 대시보드`,
"label.data.newtemplate.e.seltype.desc":`데이터를 내보내는 방식이 2가지가 있다:</li><li class`,
"label.forecast.customforecast.submit.tip1":`에서 제출 여부`,
"label.version.workflow.and.approval":`업무 프로세스와 승인 자동화`,
"label.tianyancha.tip":`입력에 오류가 발생하여 다시 입력하세요!`,
"label.report_details":``,
"template.report.folder.contract.product":``,
"label.all":`소유`,
"label.version.area.long.rich":`{0}개 리치 텍스트나 긴 텍스트 에어리어 필드`,
"label.enc":`저장 암호화`,
"vue_label_pricebook_enterproductname":`제품명을 입력하세요`,
"label.edit.quote.line":``,
"label.edit":`편집`,
"M":`마스터 디테일 정보 관계`,
"front-kefu-phonenumber-exists":``,
"label.standardplatformuser":`표준 플랫폼 사용자`,
"label.custom.page.configuration":`사용자 설정 페이지 배치`,
"url.error.contact.null":``,
"label.sethelp":`설정 도움말`,
"setup.mainpage.label.welcome23":`안보성 설정`,
"label.sales.page.dashboard.fenxi":`판매 분석 대시보드`,
"label.limit":`권한`,
"maintenanceasset.asset.contractlineitem.illegal":``,
"UG.contact.04":`혹은`,
"Opportunity.Detailed.Phase.Label.004":`일`,
"label.emailobject.receive":`수신자`,
"label.brief.new":`신규 추가`,
"label.marketsea.button.adopt":`수령`,
"label.select.up.to.three.fields":``,
"vue_label_allsearch_noresults":`자주 사용한 검색 항목을 검색했으며 {userInput}와 매칭된 결과가 없습니다.`,
"Report_CantDelete_Info":`{1}대시보드가 {0}보고서를 인용했으며 삭제할 수 없습니다!`,
"label.chile.summer.time":`칠레 시간`,
"label.partnerCloud.menu.selectedMenu":``,
"vue_label_report_onlysummary":`합계만`,
"front-template-V1-Applicable-object":``,
"label.invoice.message.sendfailed":`Invoice 전송이 실패했으며 잠시 후 다시 시도하세요`,
"front-kefu-moudle-v1-use-free":``,
"label.rule.updated.successfully":``,
"label.owner.lastone":`최소 한 가지 조건을 유지합니다`,
"label.appointment.wizard.subtitle1":``,
"template.report.opportunities.closed.month":``,
"label.tabpage.choosecontent":`값 내용을 선정하세요`,
"template.chart.jbnddxl":``,
"label.fieldsecurity.detail":`필드 안보성 상세정보`,
"label.knowledgebase.data.deleted.successfully":``,
"label.sso.saml.idp.config.nameidfmt":`명칭 ID 형식`,
"label.emailobject.prompt":`안내`,
"label.marketsea.isgetbyself":`멤버 수령 허용`,
"label.winxin.cancelprompt":`현재 작업이 저장되지 않아 나가시겠습니까`,
"label.appexchange.installedpage.message2":`응용프로그램과 구성요소가 소프트웨어 패킷으로 설치됩니다. 모든 사용자 설정 응용프로그램, 메뉴, 사용자 설정 대상, 사용자 설정 페이지와 트리거가 처음에 '개발 중'인 것으로 표시되어 사용자에게 배치되지 않습니다. 그러므로 배치하기 전에 이들을 테스트하고 설정할 수 있습니다. 설정의 다른 기능을 사용해 구성요소를 개별 배치하거나 배치를 클릭하고 한개 구성요소로 배치할 수 있습니다.`,
"vue_label_import_importtype":`불러오기 유형`,
"label.data.importef.des":`불러오기 실패한 파일이 서버에 48시간 동안 저장되다가 48시간 후 자동 삭제됩니다.`,
"chatter.email.reply":`내 게시물에 답장할 때`,
"label.stdashbord.xsld.business.sdl":`계약 파기율`,
"labal.emailtemplate.namemessage":`메일 템플릿의 유일한 명칭이 존재하여 다시 편집하세요`,
"vue_label_email_Please_select_file":`파일을 선택하세요`,
"label.event.modify":`이벤트 편집`,
"label.projectManagement.isnmber":``,
"lable.outlook.detail.emailst":`메일 설정`,
"label.partnerCloud.priceOfManual.isUsed":``,
"setup_mainpage_label_welcome26":`데이터 관리- 모두 처리 기능`,
"label.file.version":`버전`,
"pagecreator_systemstyle_label_bordercolor":`테두리 색깔`,
"label.approval.isallowed.reject.prompt":``,
"label.myinfo":`나의 정보`,
"front-template-V1-fontSize":``,
"lable.outlook.edit.alpreo":`1순위 선택 Exchange`,
"front-email-payment-card-number":``,
"label.cpq.quote.pricebook.no.change":``,
"vue_label_file_size_limit_tip":`파일 크기가 한계를 초과했습니다`,
"lable.PowerProcess.worktime":``,
"label.monthly.month.report":``,
"front-kefu-moudle-v1-sydq-buyuser":``,
"label_tabpage_Rolesz":`역할과 산하`,
"chatter.f.n":`해당 기록을 팔로우업합니다`,
"UG.Forcast.02":`예측은 지정된 단계의 예측 판매에 대한 계산이며 예측 모드는 일정 기간의 제품 니즈 및 판매 수입 상황을 확정해줄 수 있습니다. 관리자는 예측을 통해 목표를 세우고 팀의 진전도를 평가할 수 있습니다. 기구의 전체 예측은 판매 대표에 따라 모든 판매 거래의 개요 상황을 반영합니다.(판매 거래가 고객 경로 단계에서 폐쇄 단계까지의 어느 단계에 속하는 것과 상관없음.)`,
"label.productsales.contract.phb":`계약서 랭킹`,
"label.umeng.insert.approval.submit":``,
"message.duplication.label.matchfirstletters":`앞에 n개 문자가 매칭합니다`,
"label.partnerCloud.partnerAccount.toPay":``,
"label.model.un":``,
"label.save.c1":`web to CloudCC의 명칭이 중복될 수 없습니다!`,
"week":`주일`,
"Pagelayout.Setup.003":`Name 필드는 필수 선택 항목입니다`,
"label.query.detail.openpartnermessage":`고객을 협력  파트너로 사용하면 isPartner 필드에서 필터링한 보고서와 목록에 나타납니다.또한, 협력 파트너 사용자는 해당 고객과 관련된 연락처로부터 생성할 수 있습니다.확인하시겠습니까?`,
"label.validate.function.funcFormat.DATEVALUE":`일자값(일자)`,
"label.apply.send.false":`전송 실패했습니다.`,
"label.recordtype.edit.selectvalue":`선택 항목 리스트값`,
"label.chosesubject":`주제 선택`,
"label.validate.function.funcExplain.YEAR":`날짜의 연도 반환은 1900과 9999 사이의 숫자입니다.`,
"component.chatter.button.more":`더 많은 자세 정보 확인`,
"label.top.class.smallest":`최소 등급이 1입니다`,
"label.startingvalue":`초기 번호`,
"label.multi.layout.remark":`포그라운드 마스터 슬레이브 입력 및 모두 신규 추가 시의 레이아웃에 응용합니다`,
"label.role.availableuser":`선택 가능한 사용자`,
"label.weixin.iebrowser":`현재 사용한 브라우저 버전은 IE6이며 IE6은 마이크로소프트사가 2001년에 발표한 것이어 버전이 오래 되었습니다. CloudCC 시스템은 신기술로 개발되어 모든 기능이 정상적으로 사용하는 것을 확보하지 않습니다. 제때 브라우저를 업데이트하세요.`,
"Homepage_News_004":`뉴스 없음`,
"vue_label_normal_task_sf":`업무`,
"label.version.nonsupport.trigger":`트리거가 지원되지 않습니다!`,
"pagecreator_page_label_pagelayout":`페이지 레이아웃`,
"label_tabpage_step3":`3단계: 표시할 필드를 선택하십시오`,
"label.canOnlyUploadCSVFormatFile":`csv 형식의 파일만 업로드 가능합니다.`,
"label.b.c.least":`'B'기록마다 최소한 하나의 관련 'C'기록이 있어야 된다.`,
"label.list.userinterface.sales.enable":`세일즈 메인 홈페이지 랭킹 데이터 보기 권한 사용`,
"label.umeng.approval.approvalreject":`#obj승인 요청이 거부 당했습니다#objname`,
"vue_labenl_normal_notice_share_fail":`공유 실패`,
"label_emailtocloudcc_tip":`안내`,
"label.h5.touchselect":`클릭하여 선택하기`,
"label.tabularreport":`리스트 보고서`,
"label.app.defaulttab":`기본 메뉴`,
"label.validate.function.category.Datetime":`일자와 시간`,
"vue_label_pricebook_editdetail":`가격 매뉴얼 조항 편집`,
"vue_label_commonobjects_view_no_selected_record":`기록 미선택`,
"chatter.changed":`곧`,
"label.asset.bom.based":``,
"label.appointmentdetail.wizard.title8":`시작 간격`,
"label.area.query.user.error":`구역에 대한 사용자 데이터를 조회할 수 없습니다. 영역 ID가 비어 있습니다.`,
"page.field.masterinput":`마스터 슬레이브 입력 설정`,
"chatter.selads":`수신인 선택`,
"label.data.exp.please.savebutton":`"다른 템플릿으로 저장" 을 선택하십시오.`,
"label.members.activity":``,
"label.weixin.click.searchs":`기록 찾기`,
"label.input.least.two":`최소 두 개의 문자를 입력하십시오`,
"label.marketing.seting":``,
"label.approveprocess.tip":`승인은 매우 복잡한 업무과정이며 실행하기 전에 정보를 수집하고 계획을 해야 합니다. 시작하기 전에 다음 가이드라인을 준수하시길 바랍니다.`,
"front-email-payment-Invoice-login-account":``,
"label.selectmulti.mes":`선정한 수신인 수가 한계를 초과했습니다.`,
"label.workflow.gotolist":`업무 프로세스 리스트로 돌아가기`,
"label.profile.fieldsafety":`필드급 안보성`,
"front-project-module-v1-no-selectemplat":``,
"label.sendemail.queue.assigntitle":`대열 분배 대상 기록 통지 메일`,
"label.approval.mobile.comments.placeholder":`비고를 입력하세요. 최대 글자수는 1000자입니다`,
"vue_label_report_given":`지정됨`,
"vue_label_dashboard_groups":``,
"label.service.gantt.popoverTip":``,
"label.mr.title.characters":`앞의 여러개 부호대로`,
"label.passwordPolicy.setup.day":`일`,
"label_tabpage_personvisible":`관련 사용자 보기 허용`,
"ct":`다종 화폐 종류`,
"label.chatter.newEvent":`이벤트 새로 만들기`,
"vue_label_systemSettings_id":``,
"label.page.preview.web.tab":`Web 메뉴 미리 보기`,
"label_emailsync_button_sure":`확인`,
"front-template-V1-Modification-time":``,
"vue_label_homepage_edit_fixed_components":`표준 구성 요소 편집`,
"label.apply":`응용`,
"Main.Menu.Mobiledownload":`적용`,
"vue_label_salesfunnel_notice6":`가능성이 100%인 업무 기회의 총금액`,
"label.chosesubject.sendemail":`메일 전송`,
"label.changemydisplay.chagetab.des":`모든 프로그램에 표시할 메뉴를 선택하십시오.`,
"label.attendance.setting.checkUser":`다른 출석 체크에 존재합니다.`,
"label.list.projectSetting.setup":`프로젝트 관리 설정`,
"label.app.introduce2":`근무 방식과 매칭하는 응용프로그램을 설정하거나 표준 및 사용자 설정 메뉴 그룹분류를 통해 응용프로그램을 구성할 수 있습니다`,
"label_emailsync_form_emialpassword":`비밀번호`,
"label.Lightning.Setting":``,
"label.print.preview":`미리 보기 인쇄`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":``,
"label.mobile.phone.report.type":`보고서 유형`,
"lable.account.CalenderWeek":`캘린더 주일`,
"label_emailtocloudcc_step3total3":`3번째 단계, 총 3단계`,
"label_tabpage_emailaddressz":`발송인 메일 주소`,
"label.data.is_woking":`작업중`,
"label.knowledge.cancelattach.case":``,
"label.sendemail.chat.chatcontent":`메인 게시물 내용:`,
"label.timezone.set":`구역 설정`,
"label_tabpage_uploadingz":`업로드중`,
"front-epwechat-module-v1-home-url":``,
"label.reportsSubscription.select.subscription.frequency":``,
"label.validate.function":`함수`,
"label.partnerCloud.orderingPlatform.quantity":``,
"label.compact.layout.chatter":`게시물`,
"label.sso.saml.sp.description2":`외부 환경에서 CloudCC 시스템을 로그인할 수 있도록 통합 인증을 배치합니다.`,
"label.ccchat.message.new.error1":`이름에 {0}이 포함된 Chat 사용자를 찾을 수 없습니다`,
"label.file.share.email.content3":`CloudCC CRM 시스템에 로그인 후 상세 정보를 확인하세요`,
"label.file.cancel.sharing":`공유 취소`,
"label.changemydisplay.showalltabs.add":`기본 보기에 메뉴 추가`,
"label_chatter_incident":`이벤트`,
"label.file.folder.delete3":`{foldername}를 삭제하시겠습니까?`,
"label_tabpage_delsuccessz":`삭제 성공`,
"label.view_contact":``,
"label.deactivate":`사용 금지`,
"label.Horizontal.Date":``,
"label.forecast.tree.title":`예측 등급 구조`,
"vue_label_dashboard_dategruop":``,
"label.version.nonsupport.custompage":`사용자 설정 페이지를 지원하지 않습니다!`,
"label.tabpage.personvisible":`관련 인원 확인 가능`,
"message.error.unknown":`미지의 에러;`,
"label.down":`아래로`,
"label.multilang.customforcast.financialyear":`{0}번째 회계 연도`,
"label.dataimport.type.error":`유형이 틀렸습니다. 본 기록을 잘 검토하여 수정해 주십시오.`,
"label.batchadd.newbatchpage.save.num":`숫자 형식이 잘못되었습니다`,
"front-Dev-V12.2.8-calendar-endField":``,
"label.tabpage.rtemptyz":`기록 유형은 필수 입력 항목입니다`,
"vue_label_dashboard_maximum":`최대치를 선택하세요`,
"label.expiredate":`만료일`,
"label_emailtocloudcc_button_view":`보기`,
"label.event.future":`미래 이벤트`,
"label.mobile.app.layout":`모바일기기 레이아웃`,
"label.emailobject.contacts":`명 연락담당자`,
"label.approvalstep2.tip":`지정된 기록이 이 단계에 도착하기 전에 어떤 조건에 부합 여부.`,
"label.usefollowtoset":`다음의 선택항목을 사용해 승인 요청이 분배되는 사용자를 지정합니다.`,
"label.dashboard.summary.editPageHeader":`머리글 편집`,
"label_partner_workspace_tab_memo":`이 파트너 클라우드에서 사용할 메뉴를 선택하십시오. 시스템 표준 메뉴와 사용자 설정 메뉴를 선택할 수 있습니다.`,
"front-lightning-module-v1-details-page-chart-title-supports":``,
"label.enable.generate.location.service":`고객 주소에 따라 고객 경위도 데이터 생성 서비스 사용`,
"label.loginsystem":`로그인 시스템`,
"label.email.template.edit.template":``,
"vue_label_commonobjects_detail_share":`수입 배당금액`,
"label.icon.142":`주택`,
"label.maintype":`메인 유형`,
"label.step2.total4":`2단계, 총 4단계`,
"label.select.intended.tablayout":`만들고 싶은 Web 메뉴의 페이지 레이아웃을 선택하십시오`,
"label.custom.unit":``,
"label.mr.title.phone":`전화`,
"label.compact.layout.frame.showtype":`표시 방법:`,
"label.associations":``,
"label.potentialcustomers.name":`잠재고객 명칭`,
"label.edit.profile":`프로필 업데이트`,
"label.tabpage.allvisible":`모든 사용자가 볼 수 있음`,
"label.login.verification.confirmation.enabled":`사용 확인`,
"vue_label_norm_recordselected":`{selectNum}개 데이터를 선택함`,
"label.partner.workspace.member.selectedprofile":`선정한 프로필`,
"label.divide":`/나눗셈`,
"label.version.case.control":`Case 관리`,
"label.attendance.nocheckin":`미출석`,
"vue_label_helpcenter_report2.1":`2. 그룹 분류 행 삭제 ：<br>    A.좌측 '그룹 행' 리스트에서 삭제하고 싶은 '행 그룹' 필드를 찾아 필드창의 “×”를 클릭한다. <br>    B.혹은 우측 미리 보기 보고서 헤더에서 삭제하고 싶은 '행 그룹'필드를 찾아 '드롭다운 버튼'을 클릭하여 '그룹 행 삭제'를 클릭한다.<br>    그룹 분류 열 삭제 ：<br>    A. 왼쪽 '그룹 열' 리스트 중에 삭제하고 싶은 '그룹 열'필드를 찾아 필드 창의“×”를 클릭한다. <br>    B.혹은 우측 미리 보기 보고서 헤더에서 삭제하고 싶은 '그룹 열'필드를 찾아 드롭다운 버튼을 눌러 '그룹 열 삭제'를 클릭한다. <br>•설정한 일자 차원 그룹 분류 기록 <br>    1단계: 일자 필드로 그룹 분류 기록에 따라 일자를 설정할 수 있다. 먼저, 원하는 보고서 그룹 분류의 일자 필드를 선택해 미리 보기 보고서  헤더의 필드 옆에 '드롭다운 버튼'을 클릭하여 '일자 그룹 분류 근거'를 클릭한다. <br>    2단계: 원하는 그룹 분류 방식을 선택한다: 일, 월, 년, 회계 분기, 회계 년, 설정된 분기, 설정한 년. <br>•보고서에서 열 통합<br>    1단계: 보고서 미리보기의 헤더에서 통합하고 싶은 '열'을 찾아 '드롭다운 버튼'을 눌러 '통합'을 클릭한다.  <br>    `,
"label.payment.renew":`충전 결제`,
"vue_label_file_wrong_type":`파일의 업로드 유형이 잘못되었으며 현재 업로드한 파일 형식이 {type}! 입니다.`,
"UG_opportunity_005":`복합 마케팅 프로세스`,
"label.knowledge.language.korean":``,
"label.customobjects.inputrecordtagandformat":`기록의 라벨과 형식을 입력하세요`,
"label.h5.chatter.commentednum":`받은 댓글`,
"label.quickbooks.button.unlink":`연동 취소`,
"label.step5.total5":`5단계, 총 5단계`,
"label.projectManagement.Selweek":``,
"label.optional.searchfield":`선택 가능한 검색 필드`,
"label.mobile.quickcreate.default.signin":`출석`,
"label.visualpage.unable.parse":`해석할 수 없는 표기`,
"mesage.error.role.delete":`역할에 하급 역할이 분배되어 있어 삭제할 수 없습니다.`,
"label.role.user":`역할의 사용자`,
"button_partner_workspace_saveas":`다른 이름으로 저장`,
"label.file.no.public.link.created":`공용 링크 미생성`,
"label.login.access.shenyu":`잔여`,
"label.ccchat.group.section":`소그룹`,
"label.weixin.object.notnull":`주제를 입력하세요`,
"label.accmarketsea.add.title":`고객풀 새로 만들기`,
"label.sales.funnel.layout":`세일즈 퍼널 레이아웃`,
"pagecreator.page.button.edit":`편집`,
"label_tabpage_entercontent":`내용을 입력하세요`,
"component_event_label_begindate":`*시작 시간`,
"label.file.versionhref":`신버전 페이지로 이동&gt;&gt;`,
"label_chatter_send":`전송`,
"setup_layout_label_buttonlist":`버튼 선택`,
"label.custom.Current.and.NexttCQ":`현재 및 향후 3개 사용자 설정 분기`,
"pagecreator_page_label_pagedesc":`페이지 설명`,
"label.appupload.upload.uploader":`업로드자`,
"label.console.step5.tab.primary":`메인 메뉴로`,
"vue_label_globalsearch_expandlist":``,
"label.forecast.edit.userqu":`의 목표`,
"label.step1.total5":`1단계, 총 5단계`,
"label.multilang.dupicatecheck.onegroupredata":`중복률 검사 병합 진도: 총 {0}그룹:`,
"vue_label_systemSettings_repeat":``,
"label.mobile.side.tab.error1":`나타나는 자주 사용한 기능, 응용프로그램 메뉴를 선택하세요`,
"label.knowledgebase.reduction":``,
"label.standard.buttonandlink.override.usedefault":`커버되지 않음(기본 사용)`,
"dateandtime":`일자/시간`,
"label.group.activate.info":`그룹 사용`,
"label.triggertotask":`업무 트리거`,
"label.emailobject.save.template":`템플릿으로 저장하기`,
"label.audit.objInfo":`승인 상세 정보`,
"label.callcenter.successfully.logged.account":``,
"label_new_customer_target":``,
"label.campaign.channel.step5":`5단계: 마케팅 채널 등록 페이지 미리보기 및 소스 코드 보기`,
"label.log.type":`조작 유형`,
"front-template-V1-noTemplate":``,
"label_report_line_daixuan":`선택 대기중인 보고서 열`,
"label.tianyancha.businessverify.relation.tip":`TIAN YAN CHA에서 반환한 필드를 고객 필드에 편집합니다`,
"label.default.value":`이 값을 메인 선택 항목 리스트의 기본값으로 설정합니다`,
"label.weixin.campaign.attendance":`마케팅 행사 출석`,
"message.duplication.label.check":`검증`,
"label.salescloud.salescloud.yes2forbidden":`네. 그룹 세일즈 금지 사용합니다.`,
"lable.currencyAdv.exchagecurrency.rate":`환율 범위`,
"lable.Hide.title":``,
"label.finishedreport":`생성된 보고서`,
"vue_label_account_business":`고객 소유인의 완료된 업무 기회를 이동`,
"vue_label_pool_assigned":`분배됨`,
"label.report.export.error":`내보내는 데 이상이 발생하여 다시 시도하세요.`,
"label.layout.availablefield":`사용 가능한 필드`,
"label.licence.remainder":`허가증 잔여 수량`,
"label.approval.idea.required":`승인 의견이 필수 기입 항목입니다`,
"front-kefu-moudle-needhand-createcase":``,
"label.dashboard.snapshot.Data.change":`데이터 소스가 변경되었습니다. 다시 배치하십시오.`,
"label.partner.workspace.login.footertext":`바닥글 텍스트`,
"vue_label_chatter_upload_link_type":`링크 유형 게시물의 업로드를 선택함`,
"front-dialog-module-v1-error-detail":``,
"label.emailobject.sendgroupemail":`단체 메일 전송`,
"lable.newtabpage.allviews":`전부 뷰`,
"label.khdd":`고객 포지션`,
"vue_label_dashboard_sortfield":`정렬 필드`,
"label.form.sample":``,
"component_setup_button_cancel":`취소`,
"vue_label_salesfunnel_notice5":`가능성이 1%-99%인 업무 기회의 금액*가능성`,
"pagecreator_systemstyle_label_modifystyle":`양식 에디터`,
"UG_homepage_001":`더 짧은 시간에 더 많은 거래를 성사시킵니다`,
"label.campaign.pc":`컴퓨터`,
"label.visualpage.lightning":``,
"label.knowledge.category.hint.two":``,
"label.south.africa.standard.time":`남아프리카 표준시`,
"label.service.gantt.reservation.number":``,
"label.weixin.report.period":`시간대`,
"label.leadtomap.exp":`조직의 모든 잠재고객 설정 필드를 사용자 설정 고객, 연락담당자나 업무기회 필드에 매핑합니다. 잠재고객을 전환할 때 이 매핑을 사용합니다.`,
"label.currency.d":`회사의 화폐 종류를 귀사에서 지원하는 또 다른 화폐 종목으로 변경할 수 있습니다.시스템에는 정의된 모든 화폐의 환율을 기반으로 변경하며 이번 변경 사항을 반영합니다.`,
"label.forecast.detailforecast.oppyclb":`업무기회 예측 종류`,
"label.reportsSubscriptionPage.email.selected":`선택한 멤버`,
"vue_label_homepage_componentname":`구성 요소 명칭 입력하세요.`,
"lable.account.Previous.FYt":`지난 2개 회계 연도`,
"label.appupload.success":`업로드 완료`,
"label.customer.newtab":`사용자 설정 페이지 메뉴 새로 만들기`,
"label.value.notnull":`값을 입력하세요`,
"label.case.miniprogram.layout":``,
"label.partnerCloud.partnerAccount.twoDecimal":``,
"UG.Lead.004":`Web 차트`,
"label.umeng.activity.event.eventwillbeginnew":`이벤트 알림:#event，시작시간#begintime`,
"label.projectManagement.subtasks":``,
"vue_label_checkduplicate_repeat_conditions":`중복 조건 판단`,
"label.subject":`주제`,
"label_search_otherusers_forecast":`다른 사용자의 예측 사항 검색`,
"label_tabpage_namemandatory":`뷰 명칭을 입력하세요`,
"label.timezone.importtimezone":`데이터 가져오는 날짜 시간 필드 시각대 설정`,
"label.mobile.buttom.team.init":`채팅 사용자 초기 설정`,
"label.checkfield.choosefield":`중복 검사 필드를 선택하세요`,
"label.b_c_least":`"B" 기록에 최소 한개 관련된 "C"기록이 있어야 합니다.`,
"label.knowledge.setting.hint.five":``,
"label.h5.similar.opportunity.step2":`2단계. 매칭 조건을 지정합니다`,
"label.page.style.imbedded.cloudcc":`전체 화면 양식을 이용하면 CloudCC.com 창의 화면을 최대한 볼 수 있습니다.`,
"label.sendemail.marketactivity.invitecode":`마케팅 행사#campaignname의 초대번호`,
"label.block.pricing":``,
"message.error.field.number.zero":`길이의 입력 형식이 잘못되어 0일 수 없습니다`,
"pagecreator.systemstyle.message.save.success":`양식 저장 성공`,
"pagecreator_systemstyle_label_styledesc":`양식 설명`,
"APPIntegration_Dropbox_setting_01":`사용`,
"label_emailtocloudcc_redmessage2":`정확한 메일 암호를 입력하세요`,
"label.user.special.operations":`운영 전용이며 현재 사용할 수 없어 관리자에게 연락하세요!`,
"pagecreator_page_label_layoutpreview":`레이아웃 미리보기`,
"APPIntegration_Dropbox_setting_03":`Dropbox를 사용해 첨부 파일에서 직접 dropbox에서 파일을 선택할 수 있습니다.`,
"label.sure_leave":``,
"label.applt.copylink":``,
"label_tabpage_allpotentialcustomers":`모든 잠재고객`,
"label.rulestrikedate":`규칙 작동 일자`,
"label_tabpage_justsz":`방금`,
"label.customize.memory.function.sorting.title":``,
"message.duplication.label.mergebutton":`병합`,
"chatter.group.cancelRequest":`신청 취소`,
"label.campaign.channel.step6.remark":`등록 페이지가 확인되면 생성 버튼을 클릭하면 등록 페이지가 생성됩니다`,
"label.appupload.upload.install.abort":`설치 완료`,
"label.emailobject.proposetimes":`일정 예약`,
"label.probability.cannot.empty":`가능성을 비워둘 수 없고 반드시 숫자여야 합니다`,
"vue_label_homepage_editkanban":`간판 편집`,
"lable.Related.template":``,
"label.cloudccclass.list.cls.time":`타이머 클래스`,
"component.task.label.enddate":`마감 시간`,
"label.sendmail.step3":`3단계: 승인과 확인`,
"label.projectManagement.Gridview":``,
"label.emailobject.time":`전송 시간`,
"label.applt.address":``,
"label.searchfield":`필드 조회`,
"vue_label_calendar_please_enter_the_name":`성명을 입력하세요`,
"label.list.userinterface.default.page.setup":`시스템 기본 인터페이스`,
"label.detail.2018":`상세 정보`,
"label.webtocloudcc.success":`정보가 성공적으로 제출되었습니다. 참여해주셔서 매우 감사합니다. 저희는 성심성의껏 서비스하겠습니다!`,
"component_telerecord_label_title":`기록 전화`,
"label.setting.sureDelete.rules":``,
"vue_label_email_current_theme":``,
"lable.Order.product":``,
"UG_product_02":`제품이 마케팅이나 구매의 제품이나 서비스를 참고합니다.`,
"label.appexchange.task":`업무 프로세스 업무`,
"label.selectprocesscondition":`단계 조건을 지정합니다`,
"label.mobile.quickcreate.default.scan":`스캔`,
"label.tabpage.prepagez":`페이지마다 보기`,
"label.query.error":`조회에 오류가 발생했습니다`,
"label.tabularreport.2018.step1":`1단계: 보고서 열을 선택합니다`,
"pagecreator.systemstyle.label.modifystyle":`양식 에디터`,
"label.app.step3":`3단계. 사용자 설정 프로그램 마크의 이미지 소스를 선택하십시오`,
"label_tabpage_rowsz":`행 삭제`,
"label.validate.function.funcExplain.SUBSTITUTE":`텍스트 문자열의 old_text를 new_text로 대체합니다.텍스트 문자열에서 지정한 텍스트를 바꾸려면 SUBSTITUTE를 사용하십시오`,
"vue_label_checkduplicate_select_data_to_merge":`데이터를 선택해 병합하기`,
"vue_label_commonobjects_view_chart_displaymode":`확대 방식`,
"label.industrialandcommercialverification.servicesetiings":`서비스 설정`,
"label.refresh":`새로고침`,
"label.taskfield":`업무 필드`,
"label.notification.approval4":`[제출자] [대상] 승인을 요청하고 있습니다`,
"label.group.isusing":`사용`,
"label.language.settings":``,
"front-kefu-moudle-please-login":``,
"label.page.double.line.cloudcc":`2열 및 CloudCC 측면 메뉴가 포함됨`,
"folder.error.delete":`1. 해당 폴더에 보고서가 포함돼 있어 삭제할 수 없습니다! 2. 해당 폴더에 숨긴 보고서가 포함돼 있어 삭제할 수 없습니다!숨긴 보고서는 삭제 대상에 따라(설정-생성-대상에 이미 삭제된 대상) 생성된 보고서이며 해당 대상이 삭제돼 있지 않아 해당 보고서가 숨겨집니다.`,
"eight":`8`,
"label.marketseamemset.user":`멤버`,
"label.recordnum":`번호 기록`,
"page.404.button.back":`뒤로 돌아가기`,
"label.mobile.phone.month.plan":`다음달 계획`,
"label.marketseamemset.account.title2":`영향 모든 멤버의 고객 보유량의 상한을 설정하세요. 제한이 고객풀과 무관합니다`,
"vue_label_chatter_current_avatar":`현재 프로필`,
"label.mobile.side.tab.remark3":`Shift 키를 누르거나 드래그를 눌러서 인접한 항목을 선택하십시오. Ctrl 키를 누르면 인접하지 않은 여러 항목을 선택할 수 있습니다.`,
"component.sendmail.label.touser":`수신자`,
"label.homeitems.noobject":`주제 없음`,
"template.report.overall.sales":``,
"label.partner.donotdel":`완성할 수 없음`,
"label.service.miniProgram.bindCopyDesc":``,
"UG_Contract_01":`계약서 관리`,
"UG_quota_06":`견적 생성`,
"vue_label_report_deletereport":`보고서 삭제`,
"front-epwechat-module-v1-input-appname":``,
"label_tabpage_deleteviewsuccess":`뷰 삭제 성공`,
"component_chatter_label_mygroup":`나의 그룹`,
"label.campagin.roi.leixing":`마케팅 행사 유형`,
"label.dashboard.myHomepageDashboard":`나의 홈페이지 대시보드`,
"UG_solution_04":`솔루션 불러오기`,
"label.knowledge.setting.hint.four":``,
"label.campaign.channel.add.field":`버튼을 클릭하여 필드를 추가합니다`,
"label.eastem.european.time":`동부 유럽 시간`,
"label.partner.workspace.member.partner":`CloudCC Partner 프로필`,
"label.campaignmember.main.backtocampaign":`마케팅 행사로 돌아가기`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`절대`,
"label.task.unsolve":`모든 미처리 업무`,
"label.multilang.chatterservice.vote":`{0}표`,
"label.console":`콘솔`,
"label.emailsync.message1":`연동을 취소하면 해당 이메일 내용이 담당자, 잠재 고객에게 동기화될 수 없습니다. 취소하시겠습니까?`,
"pagecreator.systemstyle.label.stylename":`양식 명칭`,
"setup_mainpage_label_welcome16":`조작 안내: 페이지 좌측 메뉴를 클릭하여 → 응용 프로그램 설정→ 생성→ 업무 프로세스, 승인 과정, 업무, 메일 알림, 필드 업데이트 등.`,
"message.duplication.label.editfilterule":`중복율 검사 필터 규칙 편집`,
"Account.News.Setting.004":`뉴스 사용`,
"label_tabpage_saveviewsuccess":`뷰 저장 성공`,
"label.forecast.forehistory.replacecommit":`승낙액 교체`,
"pagecreator_button_cancel":`취소`,
"label.knowledge.article.nomatch":``,
"vue_label_combined_field":``,
"label.batchadd.save.prompt":`개 기록`,
"label.tabpage.summaryway":`합계 방식`,
"label.check.input.condition.two":``,
"mail.apiCode.notOnly":``,
"UG.quota.01":`고객 견적서 관리`,
"label.approved.receiveApprovalEmail.option3":`내가 파견 승인자인 경우만`,
"label.stdashbord.xsld.business.img5":`가능성이 0%인 단계의 총금액`,
"vue_label_chat_movedfromto":`{name}이 {label}를 {oldField}에서 {newField}로 변경했습니다.`,
"label.customfields.new.step2.opration":`일반 선택항목`,
"label.dashboardSetup.isurl":`링크 추가 여부`,
"label.forecast.settings.mrfwqj":`기본 범위 기간`,
"label.campaign.channel.field":`필드`,
"label.weixin.optionthree":`선택항목3`,
"label.safetystatement":`안보 성명`,
"label.useskipwizard":`이동 기점 안내메뉴 사용`,
"label.projectManagement.completion":``,
"label.customfields.fielddependency.new.step2":`<b>2단계：</b>다음의 페이지에서 선별 규칙을 편집하며 이런 규칙들을 통해 제어필드의 값이 종속 필드의 값을 제어합니다.`,
"setup.mainpage.label.welcome8":`드래그 앤드 드롭식 인터페이스 맞추기`,
"label.emailobject.list.outbox":`발신함`,
"label.app.default.login.tab":`기본 로그인 메뉴`,
"label.follow_emails":``,
"vue_label_homepage_application_page":`응용 프로그램 홈페이지`,
"label.confirm.template":`템플릿 확인`,
"lable.product.not":`완성할 수 없습니다`,
"label.multilang.feedtrack.dispalyinfo":`최대 {0}개 필드를 선택할 수 있습니다`,
"label.weixin.plz.inputsrhkey":`검색 키워드를 입력하세요`,
"label.projectManagement.service.appointment":``,
"label.list.userinterface.watermark.enable":`PC와 APP홈페이지, 뷰, 기록 상세정보, 보고서, 대시보드에 워터 마크 사용`,
"label.confirmDelete":``,
"label.sso.description":`사용자는 사용자 이름과 인증 코드에 따라 로그인 없이 CloudCC 시스템에 접근할 수 있습니다. <br>시스템 이동 URL：：http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 . <br>위의 링크를 사용할 때 ，"http://localhost:8080"은 귀사의 방문 링크로 교체하세요. "admin@dev.com"은 귀사의 사용자명으로 교체하세요. <br>"dcc5c192facd7c08e124fbe93d8950b9"는 귀사의 인증 코드로 교체하세요.`,
"errormessage_email_atleastonereceiver_z":`최소 1개 수신인 주소를 선택하거나 입력하세요`,
"C":`누적 합계`,
"label.service.major.event.edit":``,
"label.icon.9":`수리`,
"label.visualpage.notvalidate.check":`유효한 사용자 설정 페이지가 아니며 도움말 파일을 참고하여 페이지 맞춤법을 점검하세요`,
"label.audit.todo.from":`부터:`,
"label.directboss":`직계 상사`,
"label.manageAll.selpage":`현재 페이지수`,
"label.console.step6.all":`전체 화면, 고정 취소합니다. 안내 메뉴를 선택할 때만 리스트를 볼 수 있습니다`,
"vue_label_pool_expiredate":`만료 기간`,
"lable.no.matching.record":``,
"label.standard.redirecterror":`표준버튼이 사용자 설정 페이지로 이동 실패`,
"label.Platform.Setting":``,
"lable.outlook.edit.havenewc":`최신 활약한 연락담당자`,
"label.partnerCloud.partnerAccount.choosePayment":``,
"label.weixin.optionsix":`선택 항목6`,
"lable.SalesCommitmentKanBan.allCommitments":`파이프라인`,
"page_404_button_toknowmore":`더 많이 알아보기`,
"label.customfields.number.tip":`사용자가 모든 숫자를 입력할 수 있습니다. 앞의 0이 삭제됩니다.`,
"label.import.index.processimport":`불러오기`,
"label.quote.phone":`전화번호`,
"label.insert.approval":``,
"label.tabpage.printview":`뷰 인쇄`,
"lable.product.price":`가격`,
"front-kefu-moudle-call-detail":``,
"label.umeng.approval.apply":`신청`,
"label.background.the.form":``,
"chatter.f":`팔로워`,
"label.quickbooks.searchresault.company":`고객`,
"vue_label_systemSettings_platformutils":``,
"front-quotation-v1-nofilles-tocreate":``,
"label.category.6":`의료`,
"label.attendance.choose.positon":`랜드마크 선택`,
"label.batchadd.newbatchpage.save.pho":`전화 형식이 잘못되었습니다`,
"UG.Account.01":`고객이 누구십니까?`,
"label.marketseamemset.addspecialuser":`특수 멤버 추가`,
"label.query.detail.forbidpartneruser":`협력 파트너 사용자 금지사용`,
"label.stdashbord.xsld.business.ydzhl":`수주율`,
"vue_label_SMS_mymessagebox":`나의 메시지함`,
"label.knowledgebase.data.publishing.failed":``,
"label.wholestate":`전체 상태`,
"label.selectedline":`선정된 열`,
"label.validate.function.funcExplain.LEFT":`텍스트 문자열 왼쪽부터 세는 지정된 수량의 문자로 돌아가기`,
"label.emailmerge.edittemplate.detail":`메일 병합 템플릿 정보`,
"vue_label_checkduplicate_checkduplicate":`중복 검사`,
"label.knowledgebase.assign.articles":``,
"label.tabpage.recordsz":`기록`,
"label.field.img.validate.error":`$User 후의 변수명 스펠링 오류 또는 불법 $User 인용, 스펠링을 확인하세요!`,
"workorderlineitem.worktype.isnot.father.worktype":``,
"label.ccchat.group.name.noexist":`입력한 그룹명이 없어 다시 입력하세요`,
"label.weixin.sign.type":`출석(퇴장)유형 오류`,
"label.nowvaluereplace":`기존의 것으로 교체하기`,
"report_label_report":`보고서`,
"label.knowledge.setting.plus":``,
"label.event.moveup.2day":`2일을 앞당깁니다`,
"label.translation.start":`번역 작업 공간 사용 시작`,
"lable.PowerProcess.created.time":``,
"label.ems.step2":`2단계`,
"label.tabpage.groupingemptyz":`그룹분류 항목은 필수 입력 항목이다.`,
"pagecreator.layout.button.new":`레이아웃 새로 만들기`,
"label.tabpage.listshow":`리스트 보기`,
"label.partnerCloud.productSet.optionName":``,
"label.service.without.cycle":``,
"label.chatter.sendEmailToGroupMember.subject.V":``,
"label_target_model_dimension":``,
"component.task.label.subject":`주제`,
"label.custom.field.login.query.information":`시스템에 들어가서 자세한 정보를 찾아보세요!`,
"label.validate.function.funcExplain.NOT":`FALSE를 TRUE로 변경하거나 TRUE를 FALSE로 변경합니다`,
"pagecreator_layout_button_horizontal":`가로 분해`,
"lable.Returned.to.successful":``,
"label.campaign.channel.ticket.title":`입장권`,
"label.ruleName.supportMaximum.50Characters":``,
"label.email.track.attachment.size.control1":`현재 메일 첨부파일의 누적 크기가 20M을 초과하였으며 업로드할 수 없습니다.`,
"template.report.folder.opportunities":``,
"label.knowledge.setting.data.eight":``,
"mail.id.notNull":``,
"vue_label_normal_product_sf":`제품`,
"vue_label_report_superiortothisrelationship":`상위 대상에서 해당 대상으로의 관계`,
"label.leadscore.operation":`조작자`,
"label.customfields.formula.percentexample":`Discount（할인）= (Amount - Discounted_Amount__c) / Amount`,
"component.setup.iframe.label.inputurlmemo":`인용될 페이지 URL주소를 입력하세요`,
"label.icon.177":`배지`,
"label.tabpage.myz":`나의`,
"label.leadmarketsea.add.title":`잠재 고객풀 새로 만들기`,
"label.partnerCloud.partnerAccount.thePage":``,
"label.visualpage.some.size":`코드 용량: 최대 300KB 문자부호에 지원되며 약 300000바이트.`,
"label.setwxpay.null":``,
"label.icon.74":`공작기계`,
"font-evaluate-module-v1-evbad":``,
"System.TimeField.Format.Warning":`유효한 시간이 아닙니다`,
"label.captcha":`인증번호`,
"label.payment.assessment":`다른 버전 평가`,
"message.error.not.taskevent":`업무 이벤트 대상이 아님`,
"font-evaluate-module-v1-evaluation":``,
"vue_label_commonobject_view_updatedago":`{timeInterval}에서 새로고침 됨`,
"label.sendemail.birthday.newevent":`존경하는 {!ownerName}：\r\n  {!objectLable}{!recordName}의 생일이 3일 후입니다. 유의하세요!\r\n                        {!orgName}`,
"label.laststep":`이전`,
"message.duplication.label.matchoption":`선택항목 매칭`,
"label.setupmultplerecordtype":`다종 기록 유형`,
"vue_label_account_unprocessed_oppprtunities":`미처리 업무 기회`,
"KeyInformationLayout.DefaultLayout.Name":`시스템 기본 설정`,
"label.partner.all":`모든 파트너 클라우드`,
"label.datamanage.export.error":`데이터 내보내기 실패했습니다!`,
"label.standard.buttonandlink":`표준 버튼이나 링크`,
"label.reportsSubscriptionPage.email":`메일 보고서`,
"message.nogrammarfaultinformula":`공식에 문법 오류가 없습니다.`,
"front-kefu-moudle-nofind-instance":``,
"label.is.delete.data":`삭제한 데이터에 승인중인 기록이 포함되어 있습니다. 삭제하시겠습니까?`,
"label.partner.error":`오류: 도메인 네임 형식이 잘못되었습니다`,
"label.notification.time2":`{0}분 전`,
"label.ccchat.person.invite.needfirstname":`이름을 입력하세요`,
"label.mr.title.URL":`웹사이트`,
"chatter.norecord":`볼 수 있는 기록이 없습니다.`,
"label.readwrite":`판독 기록`,
"label.partnerCloud.orderingPlatform.orderPayment":``,
"label.accesslimittype":`방문 권한 등급`,
"label.preciew_tab":``,
"label.attachment":`첨부파일`,
"label_tabpage_helpNavigationz":`도움말과 안내 메뉴`,
"label.dataimport.select":`이 정보를 체크하여 데이터를 불러올 때 실행합니다`,
"chatter.en.info":`정보를 입력해 서로에 대해 더 많이 알아보세요`,
"label.ccservice.validate.date":`대상API가 {0}의 {1}필드 대응값은 {2}이며 형식에 오류가 발생하여 정확한 일자나 시간 형식을 입력하세요!`,
"label.social.posts.send":``,
"label.emailobject.time.to":`수신자:`,
"label.defineReportStep1":`1단계`,
"savefail":`저장 실패`,
"label.mr.descreption.title":`중복 데이터 병합`,
"label.share.info.by":`이다`,
"label.list":`리스트`,
"label.event.select":`선택됨`,
"message.accountmap.cannotfind":`고객 주소를 찾을 수 없어 고객 주소를 업데이트하세요`,
"label.choosefield":`승인 페이지 필드`,
"label.forecast.settings.title":`예측 설정`,
"label.setup.log.datetime":`검색 시간 범위 내의 행동 로그 다운로드(Excel.xls 파일)`,
"button_partner_new":`파트너 클라우드 새로만들기`,
"label.umeng.approval.dlsp.reject":`#approvalname대신 거절함 #actorname요청한#objAPIName#recordname승인 신청`,
"label.tabpage.totalTeamz":`공유 팀`,
"label.lead.score.prompt3":`평점 과정이 시간이 오래 걸릴 수 있으며 평점이 완성된 후 확인 메일을 받으실 겁니다.`,
"label.schedulejob.setup.schedule.name":`업무 명칭`,
"vue_label_report_advanced":``,
"label.emailsync.form.connecttime":`연동 시간`,
"front-gantt-module-v1-project-status":``,
"label.field.for.example":`예`,
"label.marketsea.manager.notnull":`관리자를 입력하세요`,
"label.click.here":`&lt&lt 뒤로 이동하기`,
"UG.solution.04":`솔루션을 불러오기`,
"label.validate.function.funcExplain.IF":`조건이 참인지를 점검하며 조건이 TRUE 라면 한 값으로 돌아가 조건이 FALSE 라면 다른 값으로 돌아갑니다`,
"label.profile.settab":`메뉴 설정`,
"front-email-payment-weichat-tips":``,
"label.task.next.week":`미래 1주일의 업무`,
"label.operatedata.selectobjectfields.tip":`최소 한 개 내보낼 필드를 선택합니다.<font color="red">리치 텍스트 필드를 내보낼 수 없습니다.</font>`,
"label.recalculate.alert":`다시 연산할 공유 규칙을 선택하세요`,
"label.marketsea.noopportunitydays":`일 업무 기회 미생성 (획득 후 미팔로우업 일수보다 커야 함)`,
"label.chat.likeperson":`개인`,
"label.selectedFields":`선택 가능한 필드 개수`,
"label.App":``,
"label.file.type":`파일 유형`,
"permissionService.error1":``,
"front-detail-module-v1-chart-display":``,
"label.audit.status":`승인 상태`,
"UG.activity.05":`기록 전화`,
"label.connectOtherObject":`(다른 대상과 관련시키려면 누르십시오)`,
"lable.currencyManage.unEnabledadvcurrency":`고급 화폐 관리 사용 금지`,
"label.ccpeak.getthree.function":`3개 방법이 있으며 또한`,
"label.weixin.new.weitoupiao":`위챗 투표를 새로 만들어 위챗 플랫폼 이벤트에서 투표 정보를 얻어 투표에 참여할 수 있습니다.`,
"label.tag.manage.prompt":`라벨 이미 존재합니다!`,
"label.goon":`계속`,
"label.addworkflowoperate":`업무 프로세스 조작 추가`,
"label.weixin.click.search":`기록 검색 클릭`,
"vue_label_report_deletecolumn":`열 삭제`,
"label.ordercondition":`정렬 조건`,
"message.error.group.notallow":`소그룹이 문서 보관에 허용되지 않습니다`,
"label.unread":``,
"vue_label_report_notice_namerequired":`열 명칭은 필수 기입 항목입니다`,
"label.tabpage.entercontent":`내용을 입력하세요`,
"label.schedulejob.setup.schedule.startdate":`시작일`,
"component_assistant_button_newtask":`업무 새로 만들기`,
"vue_label_report_notice_filter1":`고급 선별 사용 시 수동으로 선별 조건을 <br?/>다음의 고급 선별창에서 입력해야 하며 형식은 다음과 같습니다.`,
"value":`값`,
"label.icon.70":`수리`,
"label.knowledgebase.delete.draft.t":``,
"label.setup.mini.bind":``,
"component_timeline_button_more":`단계 더보기`,
"label_emailtocloudcc_redmessage4":`포트 정보를 입력하세요`,
"label.field.input.number":`정확한 숫자를 입력하세요`,
"front-invoice-online-payment-setup-title":``,
"front-kefu-moudle-called-user":``,
"label.currency.disable":`금지 사용한 화폐 종류`,
"label.user.alias":`별명`,
"UG_quota_04":`견적서 인쇄`,
"label.chatter.delete":`삭제`,
"label.addtocurrentcustomer":`기존 고객에 추가하기`,
"message.error.recordid.null":`recordid가 필수 요소입니다!`,
"label.merge.records":`기록 병합`,
"report_label_norole":`권한이 없어 시스템 관리자에게 연락하세요!`,
"label.pqrs":`.`,
"label.email.attach.button":`"첨부"버튼을 클릭합니다`,
"label.tabpage.selrecordtypez":`기록 유형 선택`,
"label.ServiceCloud.purchase.date":``,
"label.customreporttype.delete.prompt":`다음 보고서를 삭제하세요. 삭제 진행 중입니다`,
"label.brief.total.page":`총 {total}페이지`,
"label.reportsSubscription.unsubscribe":`구독 취소`,
"label.ccpeak.take.notice.exp.order":`주의: exp와 ordering 조건의 필드 API 명칭 뒤에 반드시 __c 를 추가해야 합니다""`,
"report_type_label_quote":`견적`,
"label.file.norecord":`보는 항목이 없습니다.`,
"vue_label_checkduplicate_all_processed":`모든 데이터가 처리됨`,
"label.next":`다음 단계`,
"label.icon.10":`폴더`,
"label.lanxin.title.setting":``,
"label.h5.chatter.business":`관련된 업무 기회`,
"lable.are.you.sure.to.delete.this.view":``,
"vue_group_no_operation_permission":`조작 권한 없음`,
"label.knowledge.archive.article":``,
"vue_label_lead_":`활성화된 채점 규칙이 없어 시스템 관리자에게 연락하세요.`,
"label.fiscal.error.between":`회계 연도 시작일이나 회계 연도 종료일이 회계 연도 이력 시간 범위 안에 있어 확인 후 다시 설정하세요!`,
"label.stdashbord.xsld.business.qdzje":`수주계약 총금액`,
"label.calendar.day.view":`일 뷰`,
"label.emailtocloudcc.tip":`안내`,
"label.schedulejob.setup.schedule.st1":`첫째`,
"label_tabpage_addtoworkbench":`시작 페이지 작업 공간에 추가`,
"label.umeng.approval.waitapproval":`승인 대기`,
"label.justcheckingwebsite":`사이트만 인증합니다`,
"homepage.components":`메인 홈페이지 구성요소`,
"label.audit.remark":`승인 비고`,
"label.searchs.labelname":``,
"label.remarkofreport":`보고서 비고`,
"label.weixin.isno":`여부`,
"label.currencyCode":`화폐 종류 코드`,
"label.service.resources":``,
"label.clone_form":``,
"label.weixin.view.information":`뷰 정보 표시`,
"UG_activity_05":`기록 전화`,
"chatter.feed.menutype.user.recentuser":`최근 보는 인원`,
"label.marketsea.notfollowdays2":`일 미팔로우업합니다`,
"label.tabpage.namemandatory":`뷰 명칭은 필수 입력 사항입니다`,
"message.demo.nosupport":`다음 버전에서 이 기능을 선보입니다.`,
"label.mail.merge.template":`메일 템플릿 병합 중...`,
"label.sendemail.marketactivity.sign":`마케팅 행사 출석 알림`,
"setup_layout_group_relatedlist":`관련 리스트`,
"label.pc.ui.2018.all.tabs":`모든 메뉴`,
"label.field.lost.right.bracket":`오른쪽 괄호가 없습니다`,
"label.datamanage.contact.novalue":`주의: 이번 불러오기가 '연락담당자 이름'필드에 값을 부여하지 않아 연락담당자 기록을 불러오지 않을 것입니다!`,
"label.version.unlimited.edition":`무한 버전`,
"vue_label_dashboard_selectsortfield":`순서 배열 필드를 선택하세요`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":``,
"thursday":`목요일`,
"label.nextapprover":`다음 승인자`,
"setup_mainpage_label_manageuser":`사용자 관리`,
"label.saveandcontinue":`저장 및 계속`,
"label.top.userCenter":`개인 센터`,
"component.chatter.file.button.save":`발표`,
"label_emailsync_setting":`개인 메일 설정`,
"label.usableshareuser":`사용 가능한 공유자`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`입력 순서가 아닌 알파벳 순으로 값을 정렬합니다. 모든 값을 알파벳 순으로 표시합니다`,
"label.list.button":`프로필 분배`,
"chatter.up.m":`업로드한 파일이 너무 크니 20M을 넘지 마십시오.`,
"label.knowledgebase.filters":``,
"label.sso.saml.sp.idtype.username":`성명에 사용자의 cloudcc 사용자명이 포함됩니다`,
"vue_label_file_size_limit":`파일 크기가 {size}Mb를 초과하면 안됩니다`,
"label.appupload.install.error.choice4":`충돌된 구성요소를 뛰어넘어 충돌된 구성요소를 설치하지 않습니다`,
"label.currencyDecimalDigits":`소수 자릿수`,
"label.weixin.customer.details":`고객 상세 정보`,
"component.timeline.label.7daysahead":`이전 7일`,
"label.sendsms.batch.step1":`1단계: 포함할 정보 수신자를 지정합니다`,
"label.brief.opportunity1":`업무기회`,
"label.datamanage.click.importbutton":`<b>바로 불러오기</b>버튼을 클릭하여 데이터를 CloudCC시스템으로 불러옵니다.`,
"label_filter_benchmark_objects":``,
"label.area.record.notexist":`기록이 존재하지 않습니다`,
"label.event.overdue.unfinished":`만료된 미완성 이벤트`,
"label.file.publicview.errortype":`이 파일 유형이 미리보기에 지원되지 않습니다`,
"label.setup.mobile.bottombutton.profile.setting":``,
"label.campaignmember.main.addleaddesc":`이 시장 활동에 모든 잠재 고객을 한꺼번에 추가합니다`,
"vue_label_approve_actual_operator":`실제 오퍼레이터`,
"label.version.essential":`기초 버전`,
"lable.SalesCommitmentKanBan.commitments":`파이프라인`,
"label.chatter.pastEvents":`과거 행사`,
"vue_label_calendar_choose_calendar_type":`캘린더 유형 선택하기`,
"label.service.dispatchingUnits.batch.send":``,
"chatter.poll.option8":`선택 항목8`,
"label_tabpage_summaryway":`통합 방식`,
"front-kefu-moudle-trindex-copy-num":``,
"lable.quote.syncing.syncfinish":`동기화 완료`,
"label.home.task.finish":`업무 완성`,
"label.toleadfield":`잠재고객 필드 매핑`,
"label.everyone":``,
"label.multilang.databatchadd.success":`{0}개 데이터 추가 성공`,
"label.quote.createdate":`생성일자`,
"email.template.nopermission":``,
"label.report.action.addtodashboard2":`대시보드 추가`,
"label.campaign.name":`마케팅 행사 명칭`,
"label.check.input.condition":`문법이 틀렸습니다. 입력한 필터링 조건을 확인하십시오`,
"front-epwechat-module-v1-upload-file":``,
"label.batchadd.newbatchpage.button.add":`행 추가`,
"label.partnerCloud.footer":``,
"lable.Enter.template.name":``,
"label_tabpage_last":`이전`,
"label.setup.mobile.bottombutton.setting":`모바일 단말기 홈페이지 설정`,
"label_emailtocloudcc_filed_emailto":`로 메일 전송`,
"label.data.downpage.e_title.num3":`3.사용자는 원하는 대로 데이터 내보내기 템플릿을 만들 수 있으며, 데이터를 내보낼 때 템플릿 내보내기를 선택하면 편리하게 내보낼 수 있습니다.`,
"startwith":`스타트 문자부호`,
"vue_label_normal_cancel":`취소`,
"label.reportTypcrtD":`관련대상 (D) 관련대상 선택을 클릭하세요`,
"label.globalselect.disabledvalue":`무효값`,
"vue_label_commonobjects_view_notice_deletecertification":`선택한 {?selectNum?}개 데이터를 삭제하시겠습니까?`,
"front-epwechat-module-v1-bound-role":``,
"label.partnerCloud.financeSetting.gaofilter":``,
"label.quote.sprname":`수취인 이름`,
"lable.asset.successfully":``,
"label.projectManagement.service.appointment.work.noedit":``,
"lable.tianyancha.h5.inputandsearch":`키워드를 입력해 관련 회사를 조회합니다`,
"label.customcomponent.check.tag.firstrow":`첫 번째 행이`,
"label.knowledgebase.published.translations":``,
"vue_label_wang_yi":``,
"label.step3.total3":`3단계, 총 3단계`,
"label.stdashbord.xsld.business.img6":`가능성 100% 단계의 개수/(가능성 100% 단계의 개수 가능성 0% 단계의 개수)`,
"component_button_cancel":`취소`,
"label.delete.false.not.exists":`데이터가 없어 삭제 실패했습니다.`,
"label.appupload.install.error.choice1":`설치 금지`,
"label.Days.After.Horizontal.Date":``,
"setup_layout_button_additem":`선정된 항목을 추가`,
"UG.contact.05":`연락담당자 생성`,
"label.form.title":``,
"label.horizontalbar-group":`수평 바-그룹분류`,
"component_sendmail_label_title":`메일 전송`,
"label.passwordPolicy.setup.neverexpires":`영원히 효력을 잃지 않습니다.`,
"label.sso.saml.idp.config.desc1":`CLoudCC.com을 신원 제공자로 사용하여 기타 사이트에서 통합 인증을 사용할 수 있으며 통합 인증 응용 프로그램이 지원된 적용 서비스 제공자를 정의합니다. 다시 로그인 필요없이 다른 서비스 제공자로 전환이 가능합니다.`,
"label.chat.topic.desc.null":`본 주제에 대한 정보를 알고 계십니까?오른쪽 상단의 드롭다운 메뉴에서 상세 정보 편집을 선택하십시오.`,
"label.movablecustomerfield":`행사 사용자 설정 필드`,
"label.trigger.folder":`미보관 트리거 폴더`,
"label.selectuploadfile":`업로드할 파일을 선택하세요!`,
"front-email-payment-card-tips":``,
"label.tabpage.addcondition":`조건 추가`,
"label.number.MinAndMaxCheck":``,
"vue_label_dashboard_dashboard":`대시보드 재명명 성공`,
"label.objectDeleteList":`대상 삭제 리스트`,
"lable.service.gantt.and":``,
"label.emailtocloudcc.step2":`2단계`,
"label.chatter.postup":`붙이기`,
"label.personalsetting":`개인 설정`,
"message.please.choose.permission":`방문 권한을 선택하세요`,
"label.mobile.move":`모바일기기`,
"label.Choose":``,
"label_chatter_vote":`투표`,
"label.weixin.user.select.one":`한개 사용자를 선택합니다`,
"pagecreator.page.label.modifypage":`폐이지 에디터`,
"label.select.partOrField":``,
"vue_label_helpcenter_chat":`1. 인스턴트 메신저<br> 채팅은 기업 위쳇을 대체할 수 있어 CRM시스템에서 업무를 볼때 회사 동료에게 택스트 정보, 파일 등을 전송할 수 있다. 각 부서에서 부서 단체 채팅방이 필요할 때 부서 지도자가 채팅에서 단체 채팅방을 개설해 부서 인원을 초대할 수 있다. <br>2. 고객, 업무 기회 기록에 대한 단체 채팅<br> 고객이나 업무 기회 기록 상세 페이지를 열어 우상측의 '채팅'버튼을 눌러 채팅에서 해당 기록에 관한 단체 채팅방을 만들 수 있다. 단체 채팅방을 만든 사람이 기록의 소유인이 아닌 경우, 기록 소유인이 자동으로 단체방으로 초대된다. 다른 사람도 기록 상세 페이지 우상측의 '채팅'버튼을 누르거나 단체방 조직자의 초대를 받아 단체방에 들어갈 수 있다. <br>3 단체방에서 기록을 팔로우업한다. <br> 4.2의 방식대로 고객, 업무 기회 기록에 대해 단체방을 만들어 단체방에서 카드 전송의 방식으로 기록을 팔로우업할 수 있다. 사용자가 카드의 기록에 대해 확인 권한이 있으면 카드를 클릭하여 해당 대상자의 상세 페이지로 넘어간다. <br>단체방에서 기록 필드 변화를 팔로우업한다. <br> 기록에 '필드 추적'관련 리스트가 배치되고 추적 필요한 필드가 배치된다면 추적될 필드가 변화가 생길 때 단체방의 채팅 비서가 필드 변경 정보를 담은 카드를 단체방으로 전송한다. <br>단체방에서 기록 소유인의 변화를 팔로우업한다,<br> 기록 소유인이 변화가 생겼을 때 단체방의 채팅 비서가 소유인 변경 정보를 담은 카드를 단체방으로 전송한다. <br>단체방에서 행사를 팔로우업한다. <br> 기록 단체방을 만들어 해당 기록에 관한 업무나 이벤트를 새로 만들었다면 단체방의 채팅 비서가 업무나 이벤트의 기본 정보를 담은 카드를 단체방으로 전송한다. <br>단체방에서 기록과 관련된 리스트의 새 기록을 팔로우업한다.<br>기록 단체방을 만들어 기록의 관련 리스트 기록을 새로 만들었다면 단체방의 채팅 비서가 새 기록의 기본 정보를 담은 카드를 단체방으로 전송한다. 예를 들어, 고객 기록의 연락담당자 관련 리스트에서 한 연락담당자가 새로 추가된다면 고객 단체방에서 '연락 담당자 새로 만들기'카드를 받아 해당 카드에서 새 기록의 기본 정보를 볼 수 있다.`,
"label.tianyancha.business":`공상 기업 정보`,
"chatter.group.groupMembersToFind":`그룹 멤버 찾기`,
"label.pc.ui.2018.pin.top":`상단 고정`,
"label.forecast.forehistory.submitor":`제출인`,
"vue_label_email_send_emails_separately":`메일 개별 전송 성공`,
"vue_label_homepage_select_display_field":`전시 필드 선택`,
"label.partnerCloud.partnerAccount.accountBalance":``,
"label.sendemail.template":`메일 템플릿 선택하기`,
"label.service.violated":``,
"label.manageAll.title":`승인 센터`,
"label.forecast.settings.qy":`예측 공유 사용`,
"label.detailofshare":`공유된 상세 정보`,
"label.multilang.passwordpolicy.chechlength":`에러: 비밀번호의 최소 자릿수는 {0}개 문자입니다`,
"label.visualpage.filesave.error":`파일 저장 실패했으며 다시 시도하세요`,
"vue_label_campaign_please_select_member_status":`멤버 상태 선택하세요.`,
"homepage.components.sort":`구성요소 정렬`,
"label.brief.thismonth":`이번달`,
"label_emailsync_connectaccount_description":`개인 메일을 추가하여 시스템이 메일의 전송 및 수신 주소로 시스템의 잠재고객, 연락담당자와 자동 매칭시켜 메일 내용을 해당 기록과 동기화시키며 고객과의 교류 진도를 팔로우업할 수 있도록 합니다.`,
"label.sms.csid":`서명 번호`,
"label.ccdocument.remark":`파일 내용`,
"label.forecast.customforecast.disdw":`단위 표시`,
"label_tabpage_field":`필드`,
"label.logintime.all":`하루 종일`,
"UG_Account_06":`고객 생성`,
"label.login":`로그인`,
"label.dupicate.data.error":`병합 데이터 조회에 이상이 발생해 확인하세요!`,
"label.monitorsys.recent.logs":`최근 로그 200개를 기본으로 표시합니다`,
"message.chooseatleastonefield":`최소 한개 필드를 선택하세요`,
"lable.PowerProcess.name1":``,
"label.processdetail":`정의 상세 정보 처리하기`,
"label.upload.file.size.limit":``,
"label.forecast.userenablepage.desc":`예측 사용한 사용자가 '사용한 사용자' 리스트에서 나타납니다. 사용 가능한 사용자를 사용하려면 '사용한 사용자'리스트에서 추가합니다. 사용자를 금지하려면 삭제합니다.`,
"label.visualpage.type.detailembed":`페이지 유형이 detailEmbed 사용자 설정 페이지 사용 규범입니다`,
"label.textmessage.vonage.configurations":`배치`,
"label.report.select.chart.and.item":`차트와 하이라이트 보기 항목을 선택합니다`,
"label.data.downpage.i.title.num1":`1. 시스템에서 통용 CSV형식만 사용 가능하다.`,
"label.mobileapp.scansetting":`모바일기기 스캔 모듈 설정`,
"chatter.emailFollow":`팔로우`,
"label.weixin.businformation":`차량 정보`,
"label.import.index.recentrecord":`최근 불러온 기록`,
"label.case.update":`변경`,
"label.isEnableVisualpage.new.desc":`사용 가능한 설정 페이지를 선택해 이미 사용된 설정 페이지 리스트에 추가하여 저장한 후 해당 프로필이 이미 사용된 설정 페이지를 방문 가능합니다.`,
"label.emailobject.wizard.title":`개인 메일과 연동하기`,
"vue_label_ccchat_notice_deletepostsuccess":`게시물 삭제 성공`,
"label.deleteQuoteLine":``,
"label.integrations.export.failed.Mailchimp":``,
"label.increase":` 플러스`,
"label.setup.mobile.homepageshortcuts.setunable":`홈페이지에서 해당 모듈을 보지 않기`,
"label.ccchat.person.invite.toolong":`최대 255개 문자인 텍스트를 입력할 수 있습니다`,
"label.knowledge.setting.help":``,
"label.is_pigeonhole":`파일 보관 여부`,
"message.atleastonecommitter":`적어도 한 명의 제출인이 있어야 합니다.`,
"label.emailobject.wizard.desc4":`예약 가능한 시간을 삽입하여 단체 초대가 더 편리해집니다.`,
"APPIntegration_Dropbox_setting_02":`금지 사용`,
"template.report.open.opportunities":``,
"label.goonwork":`계속 업무하기`,
"label.isiands.time":`섬 시간`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":``,
"label.summaryreport.2018.step2":`2단계: 통합할 정보를 선택합니다`,
"pagecreator.systemstyle.message.delete.success":`양식 삭제 성공`,
"label.standarduser":`표준 사용자`,
"label.reportsSubscription.succeeded":``,
"lable.Select.a.template":``,
"label.file.library.addfile2libsuccess":`{0}개 파일이 업로드되었습니다!`,
"label.searchfield.instruction":`검색 필드는 전역 검색하거나 대상별로 검색하기 위한 필드입니다.기본으로 선택하지 않으면 선택한 검색 결과 필드에 따라 검색합니다`,
"U":`URL`,
"label.Time.slot.overlap":``,
"vue_label_chat_opportunity_details":`기회 상세정보`,
"label.knowledge.category.hint.seven":``,
"label.chatter.list":`리스트`,
"front-email-payment-Invoice-preview":``,
"label_emailsync_message1":`연동 취소한 후 해당 메일 내용을 연락담당자, 잠재고객과 동기화시킬 수 없어 취소하시겠습니까?`,
"label.summaryreport.step5":`5단계: 보고서 각 열의 순서를 확인합니다.`,
"component_newrecords_label_name":`명칭`,
"label.appointment.wizard.subtitle4-4-5":`두달`,
"component_salesperformance_label_title":`판매 실적`,
"label.ccchat.person.invite.says":`말했다:`,
"label.fax":`팩스`,
"label.knowledge.modify.article":``,
"label.componenteditor.Limit.number.components":``,
"label.multilang.forecast.shrepage.desc":`이 페이지에서 {0}에 대해 공유 방문을 보유한 사용자, 역할 및 구역을 나열합니다.`,
"label.chat.micropost.write.comment":`메시지 편집`,
"Lead.Scoring.Setting.Rule.Setup.Active":`활성화시키겠습니까?`,
"label.ccpeakfolder.time":`타이머 클래스 폴더`,
"label.partnerCloud.financeSetting.filter":``,
"label.knowledge.delete.topicassignment":``,
"label.file.orderbyname":``,
"vue_label_chat_activelater":`잠시후 개설`,
"chatter.reply":`답장`,
"label.setup.profile.accordtext":`보기 텍스트는`,
"label.encd.plaintext":`일반 텍스트 보기`,
"label.h5.approval.cannotreassignmark":`대리 승인 프로젝트가 다시 분배될 수 없으며 승인 프로젝트를 다시 선택하세요`,
"label.version.area.lookup":`{0}개 택스트 에어리어나 선다형 필드 검색`,
"approval.request.email.body":`다음은 승인할 항목입니다 ：\n  링크를 클릭하여 승인하기 ：\n`,
"label.user.mass.emails.select":`대량 메일 보내기: 템플릿 선택`,
"lable.quote.syncing.title":`견적과 업무기회 동기화`,
"vue_label_dashboard_dashboardaccess":`대시보드 방문 권한`,
"label_emailtocloudcc_filed_owner":`기록 소유인`,
"label.brief.page":`페이지`,
"label.isEnableVisualpage_new.desc":`사용 가능한 사용자 설정 페이지를 선택하여 사용 가능한 사용자 설정 페이지 리스트에 추가합니다. 저장 후 이 프로필은 사용 가능한 사용자 설정 페이지를 방문할 수 있습니다.`,
"label.service.shift.view":``,
"label.emailsync.addnewaccount":`새 계정 추가`,
"label.forecast.settings.prompt":`예측 공유를 사용하지 않으면 수동 공유 접근이 모두 삭제됩니다.`,
"front-electronic-signature-explain-second":``,
"label.emailtocloudcc.redmessage3":`서버 주소를 입력하시오.`,
"message.confirmgiveupedit":`이 페이지에서 나가면 모든 저장되지 않는 변경이 유실됩니다. 계속 하시겠습니까?`,
"label.gantt.plan.success":``,
"label.monitorsys.type.error":`조회 유형을 선택하세요!`,
"label.industrialandcommercialverification.button.setup":`설정`,
"today":`오늘`,
"label.attendance.setting.position":`랜드마크 설정`,
"chatter.mynews":`나의 메시지`,
"label.recycle.dis.tip1":`시스템이 휴지통에 보류한 데이터를 15일 동안 저장합니다. 기록이 휴지통에 15일 저장된 후 영구 삭제됩니다.`,
"label.icon.81":`냉동`,
"label.customer.tab.page.prompt":``,
"label.globalselect.use":`전역 선택항목 리스트값 세트를 사용합니다`,
"template.report.customer.sales.order":``,
"vue_label_dashboard_lastruntime":`최후 운행 시간`,
"label.edit.ccpeakfolder":`클래스: 폴더 편집`,
"vue_label_lead_be_converted":`이미 전환된 상태이며 전환이 불가능합니다`,
"label.tabpage.filenamez":`파일 명칭`,
"label.please.click.add.products.":``,
"label.followup_emails":``,
"label.indochina.time":`인도 지나 시간`,
"message.error.task.email":`메일 업무에 이상 발생`,
"label.dynamic.copy":`동시에 실시간 레이아웃 규칙을 복사하기`,
"label.log.d":`검색 시간 범위 내의 감사 로그를 다운로드합니다 (Excel.csv 파일） >>`,
"pagecreator_layout_label_layoutname":`레이아웃 명칭`,
"template.chart.htsktj":``,
"label.appointment.wizard.subtitle4-2-5":`1일`,
"label.view_form":``,
"label.tablet":``,
"label.campaignmember.main.addcontact":`멤버 추가- 기존 연락담당자`,
"message.get.userinfo.error":`사용자 정보 가져오는 데 실패했습니다.`,
"label.department.username":`사용자명`,
"label.ems.verifysuccess":`메일 계정 인증 추가 성공!`,
"label.batchedit.copyValue":`본 열에 응용합니다`,
"label.trigger.triggerVersion":`버전`,
"label.mr.descreption.oneGroupReData5":`그룹 데이터가 처리되지 않았습니다.`,
"label.appointmentconfirmpage.wizard.subtitle5":`내용`,
"label.weixin.inbetween":`중복 선택`,
"label.salescloud.contactrole.relatelist.customnize":`이 리스트를 사용자 설정할 수 없습니다`,
"label.data.exp.please.nameanddes":`템플릿 명칭과 템플릿 내용을 입력하세요.`,
"label_partner_workspace_login":`로그인 페이지`,
"label.notification.approval7":`[피파견자 명칭] [제출자]가 요청한 [대상] [대상명]의 승인 신청을 대신 거절하였습니다.`,
"message.send.posts.image.error":``,
"message.fieldtrack.operateupdate":`변경됨`,
"label.sharerule.grantuselevelconstructureaccess":`등급 구조를 사용할 수 있는 접근 권한을 부여합니다`,
"label.translation.setup":`다국어설정`,
"PageLayout.Search.MultiSearch.003":`최소한 하나의 필드를 선택하세요.`,
"label.ccchat.person.emaildomain":`회사 메일 도메인`,
"pagecreator.systemstyle.label.bordercolor":`테두리 색깔`,
"label.submit":`제출`,
"UG.Lead.001":`고객 경로 어떻게 가져옵니까?`,
"label.icon.172":`지도`,
"label_chatter_owner":`소유인`,
"vue_label_systemSettings_Currency":``,
"page.layout.binfo":`기본 정보`,
"label.version.date":`{0}개 일자 필드`,
"label.data.is.woking":`작업 중`,
"label.customfields.searchrelation.dependobjectDefault.tip":`필드의 디폴트  값으로 관련 상대의 한개 기록을 선택할 수 있습니다`,
"label.partnerCloud.orderingPlatform.configuration":``,
"lable.currencyManage.Enabledadvcurrency":`고급 화폐 관리 사용하기`,
"label.event.moveup.3hour":`3시간을 앞당깁니다`,
"label.reportexport.object":`내보내기 대상`,
"front-dialog-module-v1-requestid":``,
"label.pw.symol":``,
"label_group_field":`그룹 필드 지정하기`,
"label.recallapprove":`승인 요청을 되돌려줍니다.`,
"vue_label_pool_deal_done":`거래 완료`,
"label.shangqing.description":`비즈니스 정보에 관한 내용입니다.`,
"label.view.allcansee":`<b>모든 사용자</b> 볼 수 있음`,
"chatter.poll.addOption":`더 많은 선택항목 추가`,
"label.icon.112":`음식`,
"label.ignorecase":`"ABC"와 "abc"를 중복값으로 간주합니다(대소문자 구별없음).`,
"label.email.track.edit":``,
"label_tabpage_erraddressz":`이메일 주소 형식이 잘못되었습니다. 이메일 주소를 정확히 입력해 주세요.`,
"label_tabpage_viewz":`현재 뷰 인쇄`,
"component.timeline.label.future":`후속 절차`,
"label.b_c_without":`"B"기록에 관련된 "C" 기록이 있거나 없다.`,
"label.version.autonumberfield":`자동 순번 필드`,
"label.appointmentdetail.wizard.title5":`초대 링크`,
"label.weixin.addoption":`선택항목 추가`,
"label.b.c":`B에서 C까지의 관계`,
"chatter.group.complete":`완성`,
"label.must.numeric.value":``,
"lable.edit.queue.memberdes":`이 대열에 멤버를 추가하고, 멤버 유형을 선택한 다음, "사용 가능한 멤버"에서 역할이나 사용자를 선택하고, "선택한 멤버"로 이동합니다."대열의 모든 대상의 공유 모드가 "공용 읽기/ 쓰기/ 이동"이면 모든 사용자가 그 대상의 기록에 접근할 수 있기 때문에 대열로 사용자를 분배할 필요가 없습니다.`,
"label.staticresource.chose.limit":`해당 형식의 파일이 지원되지 않으며 기능 완비되고 있어 기대해 주세요.`,
"vue_label_commonobjects_view_kanban_unset":`간판 뷰 설정에서 그룹 분류 근거를 선택하세요`,
"label.appexchange.download.merge.mes":`다음 충돌 구성요소를 병합으로 설치하기:`,
"label.sharerule.baseofowner":`기록 소유인을 바탕으로`,
"label.email.template.manage.SMS":``,
"label.imgfield.example.tip":`승인 상태에 승인이 통과되면 '초록색 이미지로 나타나고 아니면 빨간색 이미지로 나타납니다.'`,
"template.report.potential.customer.industry":``,
"component_hots_label_title":`인기 거래`,
"label_file_use_document":`저장공간 사용 상황`,
"label.input.path":`인용 경로를 입력합니다`,
"label.partnerCloud.financialSetup":``,
"label_tabpage_myz":`나의`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`삭제 후 이 메일을 통해 Email to CloudCC 기능을 사용할 수 없어 삭제하시겠습니까?`,
"label.customfields.fielddependency.sure":`제어 필드 값은 종속성이 있는 값을 포함하지 않습니다.저장하시겠습니까?`,
"label.project.task.date":``,
"Report.CantDelete.Info":`{0}보고서는 {1}대시보드에서 인용되며 삭제가 불가능합니다!`,
"label.assignment.setup.title":`분배 규칙`,
"image.pt.most.maxsize":`최대 파일 크기가 2M입니다.`,
"label.appupload.introduce":`소프트웨어 패킷에 응용프로그램, 대상, 메뉴, 트리거, 사용자 설정 페이지 등 구성요소가 포함됩니다. 이 소프트웨어 패킷을 업로드해서 Cloudcc.com AppExchange에서 공개 공유할 수 있습니다. 다음의 리스트는 조직이 생성한 모든 소프트웨어 패킷들입니다. 새 소프트웨어 패킷을 생성하려면 '새로 만들기'를 클릭하세요.`,
"label.import.page2.confirm":``,
"label.console.step2.introduce":`다음의 필드 정의 조작공간을 보완합니다.`,
"label.extendsfather":`상위에 종속`,
"front-homepageobject-module-v1-year":``,
"front-grasp-sales-opportunities":``,
"label.tab.oldpage":``,
"label.service.miniProgram.intro":``,
"label.data.import.setup.operate.insert":`기존 기록을 갱신하지 않고 새 기록만 삽입합니다`,
"label.ccpeak.direction.for.use":`CloudCC 플랫폼 클래스 사용설명 [2.0버전]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat 게시물 댓글`,
"label.campaignmember.main.importmember.contacts":`멤버 불러오기- 기존 연락담당자`,
"setup.mainpage.label.welcome20":`이메일, 문자 템플릿`,
"label.newbatcheditor.remark":`데이터 기록마다 다른 기록 유형이 존재할 경우, 시스템은 첫 번째 데이터 기록 유형을 기본으로 사용하는 행 레이아웃을 대량 편집의 페이지 레이아웃으로 합니다.`,
"label.step4.total7":`4단계, 총 7단계`,
"label.campagin.roi.tzhbl":`투자수익률`,
"label.emailmerge.mergepage.step3":`행사 기록`,
"label.marketsea.isrecyclecreatebyself":`생성 고객을 회수하시겠습니까`,
"message.mobilechooseatmost.five":``,
"label.icon.171":`호텔`,
"label.saveandnext":`저장 및 다음`,
"label.import.page1.selectcodingtype":`코드 유형 선택`,
"label.searchlayout.displaybutton":`보기 버튼`,
"label.approvalstep5":`5단계: 승인 페이지 레이아웃에서 나타나는 필드의 편집 속성을 선택하세요`,
"label.passwordPolicy.setup.enforcePswHis":`강제 비밀번호 이력`,
"vue_label_commonobjects_detail_contact_hierarchy":`연락담당자의 등급 구조`,
"front-kefu-moudle-v1-trythjzx-intelligent":``,
"label.select.statistical.indicators":``,
"label.callcenter.Tianrun.RONGTONG":``,
"label.file.library":`문서 라이브러리`,
"lable.completion.rate.color.setting":``,
"label.name.firstname":`명`,
"setup_layout_label_readonly":`읽기 전용`,
"label.chatter.recordcall":`통화 기록 완료`,
"label.service.appointmentList.service.empty":``,
"component_milestones_label_choicestate":`상태 확인`,
"label.approved.receiveApprovalEmail.option2":`내가 승인자일 때만`,
"label.marketseamemset.account.title":`고객풀 멤버 설정`,
"label.changemydisplay.list.custom":`사용자 설정 나의 메뉴`,
"label.emailtemplate.selecttype":`메일 템플릿 유형을 선택하기`,
"component_timeline_label_title":`시간축`,
"chatter.group.addRemoveMembers":`멤버 추가/삭제`,
"label.console.step6.width":`넓이`,
"pagecreator.systemstyle.message.delete.fail":`양식 삭제 실패`,
"label.partnerCloud.orderingPlatform.productPrice":``,
"label.h5.share":`공유`,
"label.schedulejob.setup.list.tip":`실행할 작업을 설정하고 매주 또는 매월 간격으로 자동 실행합니다.`,
"message.intheapproving":`이 기록이 이미 승인 프로세스에 있어 다시 제출할 수 없습니다.`,
"vue_label_commonobjects_detail_real_time":`가입한 후 해당 채팅이 채팅 리스트에 표시되어 채팅 상황이 실시간으로 전송됩니다.`,
"label.autoRegister.changepwd.setpwd.too.weak":`너무 짧습니다`,
"label.salescloud.forbiddenteamsales":`그룹 마케팅 사용 금지`,
"component.chatter.link.label.title":`링크`,
"label.layout.editsearchdistribute.page":`메뉴 페이지에 포함될 사용자 설정 페이지를 선택합니다.`,
"label.dashboard.show.value.percent":`값보기와 %보기 중에 최소 한개를 선택하세요`,
"label.everymonth":`매월`,
"label.campaign.channel.download.size1":`큰 사이즈: 1000*1000 화소`,
"permissionService.error2":``,
"button.partner.workspace.manage.memo":`파트너 클라우드를 관리해 파트너 클라우드 속성을 배치합니다.`,
"label.forecast.forehistory.commit.remark":`비고 제출`,
"six":`6`,
"label.datamanage.donot.export.object":`내보낼 수 없는 데이터 대상`,
"label.schedulejob.setup.schedule.execute":`실행`,
"lable.account.CurrentandPreviousCY":`현재와 지난 캘린더 연도`,
"label.temp.SMS":`문자 메시지 템플릿`,
"label_partner_all_state":`상태`,
"label.editdocument":`속성 편집`,
"front-epwechat-module-v1-ios-single":``,
"lable.redo":``,
"vue_label_SMS_alltemplates":`모든 템플릿`,
"label.allfolderreport":`모든 보고서 폴더`,
"label.layout.alltab":`전부 메뉴`,
"lable.account.Yesterday":`어제`,
"label.formula.to.evaluate":`공식 평가`,
"component_setup_label_setupsaveok":`구성요소 설정 저장 성공`,
"pagecreator_page_message_canntdelete":`현재 페이지에서 삭제할 수 없습니다`,
"label.tab.message.failtotp":`옵션 카드 상단 고정 실패`,
"label.h5.chatter.location":`위치 삽입`,
"vue_label_commonobjects_view_chart_gotodashboard":`대시보드로 이동`,
"label.data.exp.conf":`데이터를 내보내시겠습니까?`,
"label.currency.e":`화폐 유형 편집`,
"message.matrixReportSetupStage.column":`[열제목 지정] 소계 근거를 선택하시고, 두 소계 근거를 최소한 하나 이상 선택하세요.`,
"font-evaluate-module-v1-have-comment":``,
"chatter.feed.dao":`로`,
"label.import.index.notice":`주의:`,
"label.weixin.information":`상세 정보`,
"label.multilingual.tip5":``,
"label.appointment.wizard.subtitle3-7":`일요일`,
"label.emailobject.groupemail.fail.content":`존경하는 {0}:\r\n안녕하세요! 메일 모두 전송 실패의 메일 주소 :{1}                  \r\nCloudCC`,
"vue_label_notice_uploadavatar_fail":`프로필 업로드 실패`,
"chatter.group.myGroup":`나의 그룹`,
"label.ccpeak.object.fieldapi.name":`대상의 필드 API 명칭입니다`,
"lable.activeCurrency":`사용한 화폐 종류`,
"label.file.save.to.send":``,
"label.emailmerge.list.editfolder":`폴더 편집`,
"label.Path.Setting":``,
"label.validate.function.funcFormat.DATE":`일자(년, 월, 일)`,
"message.objapiexists":`대상 api 존재합니다`,
"label.sendmail.batch.confirm":`메일 대량 전송: 확인`,
"message.approval.cannotsubmit.detail":``,
"setup.layout.button.deleteitem":`선택 항목 제거`,
"label.end.loginipIP":`IP 종료 주소`,
"component_event_label_subject":`주제`,
"message.500":`서버 내부에 오류가 발생했습니나`,
"label.wei.polltype":`유형`,
"vue_label_norm_duplicate":`부본`,
"label.addcycletrigger":`주기성 트리거 추가`,
"DetailedInfo.Activity.EmailMessage.01":`{0}가 {1}에게 메일을 보냈습니다`,
"No.Activity":`행사 없음`,
"label.chat.topic.add.topic":`주제 추가하기`,
"label.schedulejob.setup.schedule.morning":`오전`,
"chatter.save.al":`변경 사항이 저장되었습니다.`,
"label.setsharerule.step3":`3단계: 공유할 역할을 선택하십시오`,
"label.tabpage.Sdfez":`일 전`,
"label_submit_forecast":`예측 사항 제출`,
"label.version.sum.formulafield":`개 공식 필드`,
"lable.weixin.you.invitation":`초대하신`,
"label.stacked.horizontalbar":`스택 도형- 수평 바`,
"label.file.anyone.can.link":`모든 이 링크를 보유한 사람이 파일을 보고 내려받을 수 있습니다.`,
"label.campaignmember.main.importmember.lead.desc":`이 마케팅 행사 잠재 고객에 이 파일의 데이터를 불러옵니다`,
"UG_activity_01":`고객/팀과의 소통을 어떻게 팔로우업하고 기록합니까?`,
"label.reason":`사유`,
"label.version.free.createmax":`2000개 기록을 생성 가능하며 상한에 도달했습니다!`,
"label.brief.thisweek":`이번주`,
"label.deleteobjinapprove":`주석을 입력하시고 승인 과정에서 이 대상을 삭제하세요`,
"calendar.tips.event":``,
"label.customerinfo.mailinfo":`회사 발송 메일 정보`,
"lable.electronic.signature":``,
"label_emailsync_addnewaccount":`새 계정 추가`,
"label.layout.exampleoftesgobj":`테스트 대상 예시`,
"label.happen_submit":``,
"label.forecast.customforecast.button.submit":`제출`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":``,
"lable.opppdt.selPdt.morecondtions":`더 많은 필터`,
"label_invalid_token":``,
"label_chatter_postup":`붙이기`,
"label.escalation.setup.newaction.step1":`1단계: 이 업그레이드 규칙의 시간 조건을 지정합니다`,
"label.sendmail.step3.dealoption2":`모든 메일 행사를 저장합니다`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":``,
"vue_label_appstore_enter_website":`공식 사이트로 이동`,
"label.when":``,
"label.linellae":`라인`,
"label_chatter_detailinfo":`상세 정보`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`대금 수령 업무율`,
"vue_label_homepage_dashboard_deleted":`대시보드가 삭제됨`,
"pagecreator.layout.button.vertical":`수직 분해`,
"label.redistribution1":`최대 5명을 선택할 수 있습니다`,
"pagecreator_page_label_modifypage":`페이지 에디터`,
"label.Service.Cloud.Setting":``,
"setup_layout_label_pagename":`페이지 레이아웃 명칭`,
"label.ems.send":`전송`,
"vue_label_commonobjects_view_kanban_notice1":`간판 뷰에는 앞의 200개 기록만 표시됩니다.`,
"lable.outlook.detail.maping":`필드 매핑`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`모바일기기 슬라이딩 메뉴 설정`,
"label.trigger.operation.email.template.param":``,
"front-objectTemplate-V1-Select-a-template":``,
"label.email.template.delete.template":``,
"label.reportsSubscription.cancel":`취소`,
"lable.quote.syncingfrom.firstsync.description":`업무기회 제품   견적명세서를 대체합니다`,
"label.weixin.no.pending.xsld.qin":`현재 세일즈 퍼널 데이터가 없습니다`,
"template.dashboard.sales.indicators":``,
"label.field.new":`사용자에게 평가와 채점 기능을 제공합니다.`,
"label.generatepage.title.desc1":`선택한 필드에 따라 모바일 버전 또는 PC 버전의 HTML 코드가 생성됩니다.사용자는 필요에 따라 코드를 수정할 수 있습니다.`,
"template.report.source.potential.customers":``,
"label.mr.title.queryData":`중복된 데이터 조회`,
"button_partner_workspace_enable":`파트너 클라우드 사용`,
"V":`자동 번호`,
"label.icon.19":`폴더`,
"vue_label_report_summaryformula":`합계 공식`,
"label.appointment.wizard.subtitle2":``,
"label.stdashbord.xsld.business.bjdzhl":`현 단계 전환율`,
"label.forecast.forehistory.deopportunity":`의 업무기회`,
"chatter.email.referredToMeLeaveMessage":`댓글에 나 소환할 때 (즉 @시)`,
"label.dategrouprelyon":`일자 그룹분류 근거`,
"label.sendmail.batch.finish":`메일 모두 전송: 완성`,
"label.weixin.allexpired":`모든 만료된 사항`,
"label.dashboardSetup.showdw.d4":`만`,
"message.duplication.label.masterRecord":`마스터 기록`,
"vue_label_calendar_availability":`가용성`,
"vue_label_chat_approval_message":`승인 정보`,
"vue_label_zhang_er":``,
"label.select.options":`선택 항목을 선택하세요.`,
"label.israel.daylight.time":`이스라엘 표준시`,
"front-sales-search-QB":``,
"vue_label_account_change_customer":`고객 소유인 변경`,
"label.integrations.mailchimp2":`Mailchimp와 CloudCC CRM에 관한 더 많은 정보 보기`,
"lable.product.pricebooks.onisu":`미사용한 가격매뉴얼`,
"front-electronic-signature-backfill-field":``,
"label.document.myself.folder":`나의 개인 폴더`,
"label.event.moveup.10hour":`10시간을 앞당깁니다`,
"report.label.report":`보고서`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`조회 실패했으며 사용자가 존재하지 않습니다`,
"front-epwechat-module-v1-input-EncodingAESKey":``,
"label.event.multi.view":`다자 뷰`,
"label.h5.similar.opportunity.setup":`유사 업무기회 설정`,
"label.setting.intergrationlist.button.install":`설치`,
"label.event.monthview":`월별 뷰`,
"label.version.weixin":`위쳇 버전`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP 인증 실패, 메일 주소와 암호를 다시 확인하세요`,
"UG.homepage.003":`360도 뷰`,
"vue_label_calendar_shared_calendar":`캘린더 공유`,
"label.select.hope.merge.num1.record":`하나의 기록에 병합할 기록을 선택하십시오 (한 번에 최대 3개까지)`,
"label.createnewprocess":`승인 과정을 새로 만듭니다`,
"font-trade-module-v1-invoice-status":``,
"label.customerinfo.introduce":`회사 프로필 정보`,
"label.objectname":`대상명`,
"label.chosen.field":`선택한 필드`,
"label_target_name":``,
"label.appointment.wizard.subtitle4-4-4":`한달`,
"label.emailobject.groupemail.msg1":`메일 주소 없음`,
"label_component_hotdeal_nopermission":`업무기회 관련 데이터를 보려면 CloudCC 관리자에게 연락하세요`,
"label.appointmentdetail.wizard.title13":`내용`,
"front-web-module-v1-detail-comment-title":``,
"label.visualpage.component.n1":`1. 호출 방식. &lt;component:Name /> Name은 구성요소의 구체적인 명칭입니다`,
"lable.outlook.mcto.erecord":`최초의 기록`,
"label.weixin.del.log":`일지 삭제`,
"setup_mainpage_label_welcome23":`안보성 설정`,
"label.selectreportline":`보고서 열을 선택하세요`,
"label.chatter.following":`팔로잉`,
"seven":`7`,
"message.error":`에러:`,
"label.mobile.phone.reporter":`보고자`,
"label.valadate.telphone.false":`입력한 핸드폰 번호가 잘못되어 점검하세요`,
"label.linkedin.setting":``,
"label.mobile.side.tab.success":`모바일기기 사이드 슬라이딩 메뉴 설정 저장 성공`,
"label.notification.approval3":`[대상] 승인이 [승인자]에게 [재승인자]로 재분배되었습니다`,
"label.channel.invites.employees":``,
"label.assignment.setup.detail.assigner":`로 분배`,
"label.campaignmember.main.updatecontactdesc":`모든 기존 연락담당자 상태를 한 번에 업데이트합니다`,
"label.permission.detail.app.fenpei":`응용프로그램 분배`,
"label.copydown":`아래로 복사`,
"label_emailsync_status_action":`조작`,
"lable.Please.switch":``,
"label_adjust_remark":`비고 조정`,
"label.weixin.newspaper.coverage.list":`위험 보고서`,
"label.datamanage.contact.field":`연락담당자 필드`,
"label.partner.workspace.login.headerfooter":`머리글과 바닥글`,
"lable.account.quarter.ovdate":`회계분기 종료일`,
"pagecreator.systemstyle.label.textcolor":`글씨 색깔`,
"label.industrialandcommercialverification.fieldmappingsettings":`필드 매핑 설정`,
"component_chatter_button_message":`댓글`,
"label.partnerCloud.enterAddress":``,
"label.email.template.recently.used":``,
"component.event.label.calendar":`캘린더 확인`,
"label.setup.mobile.offlinecache.setting":`모바일기기 오프라인 캐시 설정`,
"label.custom.PreviousCQ":`지난 사용자 설정 분기`,
"lable.total.of.payments":``,
"label.ccpeak.use.class.time.trigger":`트리거가 해당 클래스에 대한 호출이라면 CCService의 방법을 바로 사용해도 됩니다.`,
"label_tabpage_addresswrongz":`메일 주소 형식이 잘못되었습니다. 메일 주소를 정확히 입력하세요!`,
"vue_label_homepage_select_components":`구성 요소 선택`,
"front-kefu-moudle-v1-secretID-reinput":``,
"label.ccdocument.select.template.red":`템플릿`,
"vue_label_email_public_template":`공용 템플릿`,
"label.eowechat.openid":``,
"label.user.ip.notlogin.range":`IP는 로그인 범위에 있지 않습니다!`,
"chatter.email.reply.collection":`내가 저장한 게시물에 댓글이 있을 때`,
"label.integrations":`통합`,
"label.permission.modifyAppPermission.selectedapp":`선택한 응용프로그램`,
"label.privacystatement":`프라이버시 성명`,
"label.specificvalue":`특정치`,
"label.appointmentconfirmpage.wizard.subtitle2":`일자와 시간`,
"label.message.ispartner.delete":`연락담당자가 이미 협력 파트너 사용자와 관련되어 있기 때문에 고객 삭제는 불가합니다`,
"report_button_go":`이동`,
"label.h5.similar.opportunity":`유사 업무기회`,
"UG_Lead_005":`메일`,
"label.num.length.not.overstep":`숫자 길이는 18자리를 초과할 수 없습니다`,
"label.profile.mobile.setup.CEOandDirector":`CEO 및 마케팅 감독`,
"label.addfield":`필드 추가`,
"template.dashboard.institutional.overview":``,
"label_tabpage_datefield":`일자 필드는 '어제', '오늘', '내일', '지난달', '이달', '다음달', '지난주', '이번주', '다음주', 'YYYY-MM-DD, MM/DD/YYYY' 포맷을 사용할 수 있습니다.`,
"label.category.7":`여행`,
"UG_contact_02":`많은 채널로 연락담당자의 관심을 끕니다. 통화, 메일, SNS`,
"chatter.feed.menutype.feed.mecom":`나에 관한 업데이트`,
"vue_label_systemSettings_calltemplate":``,
"approval_process_errore":`저장하는 중 오류가 발생하였습니다. 시스템 관리자에게 연락하십시오.`,
"label.tabpage.choosefilez":`파일 선택`,
"label.changemydisplay.chagetab.cusapp":`사용자 설정 응용프로그램`,
"clearadvancedoption":`고급 선택항목 지우기`,
"front-epwechat-module-v1-binding-user":``,
"label.customfields.fielddependency.null":`미정의 필드 종속성`,
"label.enterprise":`기업 버전`,
"font-evaluate-module-v1-five-points":``,
"lable.Synchronize.from.QuickBook":``,
"front-gantt-module-v1-task-number":``,
"label.currency.edit.newexchagecurrency":`기한이 지난 환율`,
"label.partnerCloud.partnerSite":``,
"label_tabpage_unequalz":`같지 않음`,
"label.version.solutions":`솔루션`,
"label.setting.intergrationlist.button.installed":`설치완료`,
"label.h5.chatter.share":`파일 공유`,
"front-epwechat-module-v1-unbound-item4":``,
"label.textmessage.vonage.accessibility.setting":`사용 권한 설정`,
"font-evaluate-module-v1-evaluation-set":``,
"message.servicecrew.time.violation2":``,
"label.processinfo":`승인 과정 정보`,
"label.knowledgebase.last.modified":``,
"label.to.phone":``,
"label.baseoffirsttimereply":`<strong>최초</strong>회신에 기반한 승인 또는 거부입니다.`,
"label.projectManagement.startingEndingTime":``,
"label.licence.enable":`사용`,
"label.partnerCloud.basicSetting.cshua":``,
"APPIntegration.Dropbox.setting.03":`Dropbox를 사용하여 첨부 파일에서 dropbox 안의 파일을 바로 선택할 수 있습니다.`,
"label.account.contact":`고객 연락담당자 구조도`,
"label.many.dayline.tab":`표시`,
"label.weixin.input.username":`이름을 입력하세요`,
"label.logintime.pagecue.invalido":`종료시간도 하루 종일이어야 합니다`,
"label.icon.30":`책`,
"label_tabpage_advancedscreening":`고급 선별 조건`,
"lable.currencyManage.unEnabledadvcurrency.agree":`네. 고급 화폐 관리 사용을 금지하겠습니다.`,
"label.tab.web.new":`Web 메뉴 새로만들기`,
"label.bmap.tiananmen":`천안문`,
"label.disabled":`사용 불가`,
"error.currencyAdv.deleteprecodedate":`화폐 코드의 지난 일자 환율을 삭제할 수 없습니다`,
"message.error.view.checkbox.validerr":`오류: 참 또는 거짓을 사용합니다`,
"UG_ST_006":`직접 이동하기`,
"label.dongshifang.title":`DONG SHI FANG 문자 게이트웨이`,
"label.data.dataexpalltype.all.desc3":`3. 내보내기 성공한 데이터가 압축 파일로 생성되어 사용자가 메일의 정보에 따라 내보낸 파일 리스트 페이지에서 내보낸 파일을 다운로드할 수 있다.`,
"vue_label_pool_returnreason":`반환 원인`,
"label.list.userinterface.des":`다음 설정을 사용해 귀조직의 사용자 인터페이스를 수정합니다:`,
"label.notification.approval2":`님의 [대상] 승인 요청이 [승인자]에게 거절되었습니다.`,
"label.service.dispatchingUnits.the.level":``,
"front-email-payment-Invoice-preview-tips":``,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`에러: 구성요소에서 선택한 한개나 여러개 필드를 보고서에서 계속 사용할 수 없습니다.<br> 대시보드 구성요소 에디터를 사용해 사용 가능한 필드 한개를 선택합니다.`,
"label.import.step2.chooseidorother":``,
"label.customobjects.introduce":`사용자 설정 대상이 데이터 베이스 차트이며 CloudCC 에서 조직 데이터를 저장하는 데에 사용됩니다. 사용자 설정 대상을 사용해 CloudCC 기능을 확장하거나 새 응용프로그램 기능을 구축합니다.`,
"label.visualpage.oldsystem":``,
"label.icon.94":`책`,
"label.setup.log.desctiption":`조직 행동 팔로우업을 다운로드할 수 있습니다(Excel.xls파일).`,
"label.dynamicpage.layout":`실시간 페이지 레이아웃`,
"lable.list.queue.objct":`지원된 대상`,
"label.customfields.placeholder.tip":`예시 택스트가 입력창에 나타나 초점을 획득한 후 없어집니다`,
"label.ems.activationtime":`사용 시간`,
"label.detailinfo":`상세 정보`,
"label.icon.17":`보고`,
"label_emailtocloudcc_button_complete":`완성`,
"label.visualpage.component.n2":`2. 주의. component라벨을 <cc>라벨에 내포할 수 없습니다`,
"label.object.name.one":``,
"label.summaryreport.step2":`2단계: 통합할 정보를 선택합니다`,
"thisisanew":`새 내용!`,
"label.query.detail.editpartneruser":`협력 파트너 사용자 편집`,
"label.tabpage.newview":`뷰 새로 만들기`,
"label.partnerCloud.productSet.addNew":``,
"label.appupload.upload.new.remark":`새 구성요소입니다.`,
"label.case.ptext":``,
"lable.PowerProcess.name":``,
"label_tabpage_choosefilez":`파일 선택`,
"homepage.components.place":`구성요소 위치`,
"lable.Synchronization.failure":``,
"label.dashboard.snapshot.get.data":`회원님의 데이터를 확보합니다`,
"label.input.invalid.format":`합법적인 형식을 입력하세요`,
"label.quickbooks.view.openinvoices":`진행중인 인보이스`,
"label.weixin.seating":`좌석수`,
"label.searchlayout.remark":`다음의 검색 기능에서 보는 기준 및 사용자 설정 필드 선택 허용:`,
"label.escalation.setup.entrydetail.escalation.assiner":`분배`,
"vue_label_calendar_availability_view":`캘린더 - 가용성 뷰`,
"label.country":`국가`,
"label.campagin.roi.zl":`종람`,
"lable.currencyManage.advcurrencyEnabled":`고급 화폐 관리 사용`,
"label.projectManagement.project.task":``,
"label.appointmentpage.wizard.subtitle3-2":`메일`,
"label.input.invalid.date":`합법적인 일자를 입력해 주세요 (ISO)`,
"vue_label_chatter_my_followers":`나의 팔로워`,
"label.setupdevelop":`신규 응용프로그램 개발`,
"label.sendemail.send.checksend":`메일 전송 성공 여부를 테스트합니다`,
"label.eventfield":`이벤트 필드`,
"label.ccpeak.ccobject.put":`CCObject에 대입 시 put을 직접 사용합니다. 예:`,
"label.campaignmember.main.addMemberDesc":`기존 잠재고객 및 연락담당자를 검색하여 이 마케팅 행사에 추가할 수 있으며, 기존 멤버들에 대한 관리도 가능합니다.`,
"label.knowledge.setting.hint.eleven":``,
"label.knowledge.category.button.four":``,
"label.icon.27":`공부`,
"vue_label_chatter_certification":`{isStatus}"{titleName}" 확인하십니까?`,
"label.data.downpage.i.title.btn":`불러오기 페이지로 이동, 불러오기 시작`,
"label.campaign.channel.step6.pc":`컴퓨터 페이지 생성`,
"label.mr.caption.rule":`규칙: 한개나 여러개 중복율 검사 규칙을 선택해야 합니다`,
"label.service.gantt.resourcestype":``,
"label.searchfitconditions":`다음 조건에 맞는 것을 찾습니다`,
"label.partner.template.name":`템플릿 명칭`,
"setup.mainpage.label.welcome15":`CloudCC 클라우드 플랫폼 작업 흐름 규칙이 판매, 마케팅 등 각 대상자의 지원 과정을 자동화시킬 수 있다. 미리 설정된 규칙대로 기록을 자동으로 사용자에게 분배하거나 한 사용자에게 다른 사용자로 전환될 수 있다. 작업 흐름의 주요 장점은 기록을 업데이트 시 불필요한 작업을 없애 업무 효율을 제고한다. 업무 방법을 표준화시켜 작업 비용을 감소함으로써 업무 처리 수준, 관리 과정을 최적화시킨다. 모든 대상자의 무한 승인이 가능하며 이메일 알림, 문자 알림, 임무, 필드 업데이트 등 기능을 활성화시킬 수 있다.`,
"vue_label_commonobjects_view_chart":`차트`,
"label.salescloud.teamrole.choose":`그룹 역할 선택하세요`,
"lable.outlook.mcto.emailrel":`메일 연동`,
"front-invoice-online-payment-setup-describe":``,
"label.korean.standard.time":`한국 표준 시간`,
"label.lord.howe.standard.time":`로드 하우 서머타임`,
"setup_layout_group_button":`버튼`,
"label.editdefaultshare":`기본 공유 편집`,
"label_fiscal_year":``,
"label.appointmentdetail.wizard.title2":`소유인`,
"label.email":`메일`,
"label.city":`도시`,
"label.knowledgebase.data.recovery.failed":``,
"setup_mainpage_label_welcome6":`사용자가 프로그래밍 지식과 코드 개발 필요없이 CloudCC 시스템의 모든 대상에서 각종 유형의 필드를 생성할 수 있으며 이 중에 검색 관계, 택일형 선택, 두개 선택, 공식, 자동 순번, URL, 전화, 팩스, 메일, 체크 상자, 일자, 시간, 텍스트, 텍스트 에어리어, 옵션 리스트(택일형/다답형 선택), 화폐 등이 포함됩니다.`,
"label_emailtocloudcc_button_enable":`사용`,
"label.account.custom":`사용자 설정 회계 분기`,
"label.custompublish_time":``,
"label.dashboardSetup.selwz":`위치 선택`,
"component_todaytask_label_all":`모두 보기`,
"label.service.resource.group.tip":``,
"label.tianyancha.legalpersonname":`법인`,
"component.setup.label.titlefield":`제목 필드`,
"label.email.template.public.mail":``,
"front-template-V1-DeleteTempalte":``,
"pagecreator.layout.label.layoutdesc":`레이아웃 내용`,
"vue_label_file_singel_upload":`한 파일만 업로드 가능하며 파일을 교체하려면 이미 업로드된 파일을 삭제하세요`,
"label.view.hierarchy":`등급 구조 보기`,
"label.file.owner.settings":`소유인 설정`,
"label.sales.dashboard.name":`명`,
"label.offfer.filer.name":``,
"label.quickbooks.view.recentlypaid":`최근 지급`,
"label.step1.select.merge.records":`1단계: 병합할 기록을 선택하십시오`,
"message.recordtype.assignprofile.tip":`프로필에 '체크 상자' 사용을 선택해 신기록 유형을 해당 프로필에 사용할 수 있도록 합니다. 해당 프로필이 분배된 사용자가 이 기록 유형의 기록을 생성할 수 있거나 이 기록 유형을 기존 기록에 분배할 수 있습니다. 신기록 유형을 프로필의 기본 기록 유형으로 사용하려면 '기본으로 설정'체크 상자를 선택하세요.`,
"label.appointmentdetail.wizard.title9":`교통 시간`,
"label.group":`그룹`,
"label.deltorecycle":`휴지통으로 삭제`,
"label.import.index.numlimit":``,
"label.file.delete.desc":`파일을 삭제하면 첨부된 기록이나 게시물에서 제거됩니다.`,
"UG_activity_04":`Outlook/Gmail 메일함 메일 기록`,
"label.event.all.undealt":`모든 처리되지 않은 이벤트`,
"label.appupload.upload.install.error":`이 응용프로그램을 설치할 수 없습니다. 설치를 종료시키거나 시스템 내 API를 수정한 후 다시 설치하세요!`,
"template.chart.yqydcpsl":``,
"label.import.index.advancepreparation":`미리 준비`,
"label.eowechat.epdeptnamee":``,
"front-kefu-moudle-please-input-servernum":``,
"label.lookup.autocmp.nodata":`매칭한 데이터가 없습니다`,
"vue_label_pool_assign":`분배`,
"label.knowledge.timing.publish":``,
"label.selected.groups":``,
"front-epwechat-module-v1-removesele-desc":``,
"label.batchtransfer.type2":`이미 종료된 업무기회를 이전합니다`,
"label.richtext":`리치 텍스트 에어리어`,
"label.icon.174":`비행기`,
"vue.please.select.grouping.basis":``,
"label.matrixreport":`행렬식 보고서`,
"label.jiandangfenpei.leftlist":`미분배 프로필`,
"label_chatter_card":`카드`,
"label.file.enter.title":`제목을 입력하세요`,
"label.the.record.is.locked.and.cannot.be.selected.":``,
"label.partner.success":`성공! 도메인 네임을 사용할 수 있습니다`,
"label.selectreporttype":``,
"report.type.label.productPricebooks":`제품과 가격 매뉴얼`,
"label.texttemplate.mergefields.tip":``,
"label.publicgroup.detail.showallusers":`모든 사용자 보기`,
"label.brief.follow":`팔로우업`,
"label.forecast.settings.qijian.p":`분기별로 예측`,
"label.sms.url":`웹사이트`,
"setup_layout_group_custompage":`사용자 설정 페이지`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`님에게 새 메시지를 전송했습니다`,
"label.pc.layout":`PC 레이아웃`,
"label.currency.v":`신 화폐 종류로 데이터를 볼 때 나타나는 소수 자릿수(소수점 우측의 자릿수)를 입력하며 0-6의 정수여야 합니다`,
"label.projectManagement.kanbantask":``,
"component_recdetail_label_title":`상세 정보`,
"label.isremider":`알림 여부`,
"front-epwechat-module-v1-input-home-url":``,
"label.usefullife":`유효기간`,
"label.visualpage.ptype":`일반`,
"label.quote.name":`견적서 명칭`,
"vue_label_report_addtocomponent":`{name}를 구성 요소 베이스에 추가하시겠습니까?`,
"label.dashboardSetup.showdw.d1":`억`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical2,...)`,
"label.component.helper.potentialcustom":`오늘 분배된 잠재 고객`,
"label.autoRegister.changepwd.setpwd.tip.number":`최소 1개 숫자가 있어야 합니다`,
"label.data.setok.e.desc3":`내보낸 데이터를 다운로드합니다.`,
"label.data.downpage.e.title.num4":`4. 내보내는 파일 형식이 두가지가 있다: CSV와 압축 형태. 이 중에 압축 형태는 두가지가 있는데 하나는 자동으로 생성된 압축 파일 비밀 번호, 하나는 수동으로 압축 파일 비밀 번호를 입력한다.`,
"lable.quote.editqtpdt.description":`이 견적에 대해 가격매뉴얼을 선택합니다. 한개 가격 매뉴얼에서만 제품을 추가할 수 있습니다. 선택한 가격 매뉴얼을 변경하면 해당 견적서에 모든 기존 제품이 삭제됩니다.`,
"front-kefu-moudle-edit-userinfo":``,
"label.please.ChooseMinAndMax":``,
"label.knowledgebase.archive.an.article":``,
"label.multilang.customforcast.submit":`제{0} 회계연도 {1}부터 제{2} 회계연도 {3}까지의 예측을 제출하시겠습니까?`,
"label.import.index.filename":`파일 명`,
"front-console-no-reco-contact":``,
"label.quantity.greater.than0":``,
"label.codeNorm":``,
"label.average":`평균값`,
"label.multilang.page1":`번째`,
"label.data.exp.save.ok":`템플릿 저장 성공`,
"message.error.delete.record":`삭제할 기록이 없습니다!`,
"label.newvaluereplaceoldvalue":`이 페이지를 사용해 새값으로 전체 옵션 리스트의 기존값을 대체합니다. 옵션 리스트 상세 페이지에서 새값을 생생한 것을 확보합니다.`,
"label.tabpage.saveviewsuccess":`뷰 저장 성공`,
"label.partnerCloud.productSet.parentOptions":``,
"label.emailtemplate.availablemergefields":`사용 가능한 병합 필드`,
"label.data.import.setup":`데이터 불러오기 설정`,
"label.escalation.setup.entrydetail.escalation.action":`업그레이드 조작`,
"System.TimeField.Description":`사용자가 현지 시간 입력을 허용된다. 예를 들어 "2:40 PM"、"14:40"과 "14:40:00"은 현 필드의 유효 시간이다.`,
"front-additional-products":``,
"label.appointment.wizard.subtitle4-4-1":`1주일`,
"label.chatter.colleagues.list":`동료 리스트`,
"label.log.invalid.data":`불법 시간!`,
"label.file.preview.unconvert":`미리보기 정보가 생성되지 않아 미리보기 상세 정보를 클릭하세요`,
"label.customer.detailed":`이 새로운 메뉴를 위해 페이지를 선택하고 다른 자세한 정보를 작성합니다`,
"label.sendsms.content":`내용은 다음과 같다:`,
"label.exported_to":``,
"label.attendance.checkin":`출석`,
"Dashboard.NoAccessRightToSee.Warning":`설정된 기본 대시보드 열기 {0} 확인 권한이 없으며 다시 다른 값으로 설정해야 합니다.`,
"message.choosedelete":`삭제할 데이터를 선택하십시오`,
"label_tabpage_choosecontent":`값 내용을 선택하세요`,
"label.no_responses":``,
"report_type_label_customService":`고객 지원`,
"label.report.select.condition":`조건 선택하기`,
"label.umeng.activity.distributeevent":`님에게 이벤트가 분배되었습니다`,
"label.knowledge.language.portuguese":``,
"label.knowledgebase.published":``,
"UG_opportunity_001":`세일즈를 어떻게 모니터링하시겠습니까?`,
"label.mr.caption.scope":`범위: 선택하지 않으면 전체 데이터를 검색합니다`,
"message.login.mfaverification.to.pclogin":`조직에서 2차 인증을 사용하여 최초 로그인이 모바일기기를 연동시켜야 하면 컴퓨터로 로그인 연동을 진행하세요`,
"vue_label_dashboard_pleaseenterthecolorrange":`컬러 범위를 선택하세요`,
"label.emailsync.status.time":`시간`,
"chatter.putup":`파일 붙이기`,
"vue_label_report_drillcondition":`드릴 다운 조건`,
"label.emailobject.list.myemail":`나의 메일`,
"label_tabpage_andz":`및`,
"label.share_link":``,
"label.emailtocloudcc.exists2":`본 이메일은 이미 Email to Case로 설정되었으며 중복 설정 불가능합니다.`,
"label.icon.89":`컨설팅`,
"front-kefu-moudle-v1-qdygbzx-chat":``,
"label.approval.selectone":`최소한 한 가지 작업을 선택합니다.`,
"chatter.group.groupName":`그룹명`,
"label_chatter_relateitem":`관련 항목`,
"label.file.folder.delete1":`폴더를 삭제하시겠습니까?`,
"Pagelayout_Setup_003":`Name 필드는 꼭 선택해야 합니다`,
"setup_mainpage_label_welcome2":`사용자 설정 데이터 베이스(대상)`,
"pagecreator.systemstyle.label.linkcolor":`링크 색깔`,
"label.task.this.week":`이번주의 업무`,
"message.custom.field.donotdelete.report":`해당 필드가 보고서에 인용되었습니다`,
"pagecreator.layout.button.delete":`레이아웃 삭제`,
"label.reportsSubscriptionPage.condition.operator":`연산 기호`,
"label.location.display.type.degrees":`도수, 분수, 초수`,
"label.appupload.upload.url":`URL 설치`,
"label.logical.relation":`논리적 관계`,
"label.knowledge.publish.article":``,
"vue_label_commonobjects_detail_activity_commingtask":`곧 진행될 업무 보유`,
"vue_label_pool_reason":`{0}원인`,
"front-gantt-module-subtasks-cannot-subtasks":``,
"label_tabpage_filesizez":`파일 크기`,
"label.customfields.formula.returntype.monry.tip":`달러나 기타 화폐 금액을 계산하고 필드를 자동으로 화폐 금액 형식으로 전환합니다`,
"label.tabpage.allapplications":`모든 응용 프로그램`,
"message.duplication.label.matchcontainletters":`매칭 포함`,
"maintenanceplan.workorder.type.asset.workorderlineitem":``,
"label.preview_post":``,
"chatter.p.data":`발표 일자`,
"label.isnot.right.number":`정확한 숫자가 아닙니다`,
"label.contentsource":`콘텐츠 소스`,
"message.groupandsummaryconditionsame":`그룹분류 조건이 합계 조건과 달라야 합니다`,
"label.weixin.wdyj.nodata.qin":`{0}에 데이터가 없습니다.`,
"chatter.vote":`표`,
"label_partner_workspace_tab_option":`선택 가능한 메뉴`,
"chatter.changeVote":`투표 변경`,
"label.data.file.i_title.num2":`2. 불러오기 전에 우선 내보내세요. 내보낸 파일을 데이터 템플릿으로 데이터를 정리하고 불러오는 것을 권장합니다.(불러온 데이터에 쉼표가 있으면 '@' 기호로 대체하세요)`,
"label.relation.list.error":`오류가 발생했습니다`,
"label.validate.function.funcExplain.MILLISECOND":`일자/시간 필드의 밀리초로 돌아가기`,
"label.emailobject.emaildetail.button.relateto":`으로 관련하기`,
"label.dashboard.dataSource":`데이터 출처 보기`,
"label.marketseamemset.lead.title":`잠재 고객풀 멤버 설정`,
"label.appupload.addobj":`소프트웨어 패킷에 추가`,
"lable.outlook.mcto.domain":`형식이（gmail.com）이며, 제외한 도메인 리스트에서 추가합니다`,
"label.input.right.url":`정확한 URL을 입력하세요`,
"label.newprocessstep5.tip":`승인 페이지는 승인자가 실제 승인하거나 요청을 거절하는 곳입니다.다음의 선택항목을 사용해 이 페이지에 표시할 필드를 선택하십시오.`,
"label.schedulejob.setup.schedule.st4":`4번째`,
"label.emailsync.status.user":`사용자`,
"front-kefu-moudle-v1-jymm-reinput":``,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`채점 규칙 명칭`,
"label.mr.title.fieldName":`필드 명칭`,
"label.data.deriall":`모두 내보내기`,
"label.tianyancha.businessverify.step2":`공상 기업 데이터 인증 2단계 사용`,
"label.submissions":``,
"vue_label_calendar_removed_successfully":`캘린더 제거 성공`,
"label.eventrecordtype":`이벤트 기록 유형`,
"lable.outlook.detail.syndire":`방향 동기화`,
"label.mobile.bind.fail":``,
"label.notification.task2":`[피분배자]에게 분배한 업무가 확인되었습니다`,
"label.partnerCloud.orderingPlatform.paymentMethod":``,
"label.escalation.setup.newaction.step3":`3단계: 알림 필요한 사용자를 선택합니다`,
"label.summaryreport.selectsum":`통합 정보와 통합 유형을 선택합니다`,
"label.components.setup":`구성요소 설정`,
"label.taskevent.introduce":`다음은 업무와 이벤트 리스트입니다.`,
"label.assignment.setup.detail.conditon":`조건`,
"front-lightning-module-v1-details-page-chart-select-statements":``,
"lable.Song.typeface":``,
"label.formulassesstrue":`공식이 참으로 평가됩니다`,
"label_partner_common_setup":`일반 설정`,
"label_chatter_dateRange":`일자 범위`,
"label.partner.workspace.tab.mobile.using":`체크한 메뉴가 동시에 모바일 단말기에 나타납니다`,
"message.servicecrew.time.violation1":``,
"report_label_projectcount":`개 프로젝트, 보고서명으로 정렬합니다`,
"label.file.uploadfile":`파일 업로드`,
"vue_label_commonobjects_detail_correct_email_address":`정확한 메일 주소를 입력하세요`,
"lable.account.CurrentandNextCQr":`현재와 미래 3개 캘린더 분기`,
"setup.layout.label.order":`순서 배열 기준`,
"label.service.major.event.independent":``,
"label.icon.38":`포지셔닝`,
"label.knowledge.draft.record":``,
"label_quota_percentage":`정액 완성 퍼센트 비율 보기`,
"label.escalation.setup.entrydetail.escalation.minute":`분`,
"label.knowledgebase.edit.article.category":``,
"Homepage_News_003":`고객 데이터가 없어 뉴스를 볼 수 없으며 고객을 생성한 후 고객 뉴스를 볼 수 있습니다`,
"label.mr.descreption.oneGroupNote3":`개 기록.`,
"label.customsetting.touse.getListCustomSetting":`'리스트' 형식의 사용자 설정 데이터를 조회하고, apiName에 대한 모든 데이터로 반환합니다.Map map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`오류: 값을 입력해야 합니다`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`금요일`,
"message.error.view.badprevilege.qin":`{1}에 접근할 수 있는 권한이 없기 때문에 데이터가 없습니다.`,
"label.dashboard.distribution":``,
"label.field.value.save":`이 필드에는 기록을 저장하기 위한 한개 값이 항상 필요합니다`,
"label_custom_year":``,
"label.code.error":`코드에 허용되지 않는 명령과 함수가 포함됩니다. 예:`,
"label.appexchange.uninstallpage.message2":`이 구성요소에 대한 모든 설정을 영구 삭제합니다`,
"label.global.search.obj":`전체 검색 대상 설정`,
"label.emailobject.from":`발신자`,
"lable.opppdt.selPdt.byconditions":`필드대로 조건을 선별합니다`,
"chatter.p.note":`게시물의 주석`,
"label.hiddenformulaedit":`공식 에디터 숨기기`,
"label.editQuotation":``,
"label.notification.arketsea.collection":`{5}가 {2}{0}{0}:{1}를 수령하였습니다`,
"label.timzone.tip.info1":`데이터베이스에 (insert와 update) java.util.Date 형식의 데이터를 저장할 때 예, TpSysTask task=new TpSysTask();task.setBeginTime(new Date());......dbman.insert(task); 혹은 dbman.update(task); new Date()를 TimeUtil.getNowDate(userInfo)호출로 변경해 따라서 예시의 관련 문장은 task.setBeginTime(TimeUtil.getNowDate(userInfo))여야 합니다.`,
"label_tabpage_transformationsz":`전환`,
"front-kefu-moudle-IP-phone":``,
"label.emailobject.list.draft":`휴지통`,
"label.tianyancha.businessverify.readandconfirm":`저는 사용자 허가 협의를 확인하여 동의합니다.`,
"label.win.customers":`종료됨/고객 확득`,
"vue_label_commonobjects_view_switch_display":`기록 유형으로 그룹을 분류해 대응한 기록 유형 명칭을 클릭하여 정렬을 전환합니다.`,
"pagecreator_systemstyle_label_textcolor":`글씨 색깔`,
"label.autosearch.keywords":``,
"label.knowledge.setting.data.six":``,
"front-console-sort-field":``,
"label.bangladesh.time":`방글라데시 시간`,
"label.dashboardSetup.number":`수치`,
"lable.account.LastbDays":`지난 30일`,
"label.layout.searchdialog":`찾기 대화상자`,
"label.newprocessstep4.tip":`메일 템플릿을 선택함으로써 승인자에게 승인 요청이 분배된 것을 알립니다. 주의: 이 템플릿이 이 과정의 모든 절차에 적용됩니다.`,
"label.nousing":`미사용`,
"vue_label_report_detailline":`상세 정보행`,
"label.emailobject.template.message3":`메일 템플릿이 상한을 도달했습니다!`,
"label.c.d":`C부터 D까지의 관계`,
"message.report.error.fail":`로딩 실패하였으며 다시 시도하세요`,
"label.edit.ccdocument.content":`첨부파일을 수정했습니다`,
"label.textmessage.exceeded":`메시지 템플릿 수량이 최대치를 초과했습니다`,
"label.saveas":`다른 이름으로 저장`,
"label.visualpage.an.inline.style":`상세 페이지와 메뉴 페이지에 사용자 설정 페이지 유형을 삽입합니다`,
"label.pagelayout.remark2":`데이터. 페이지 레이아웃을 생성한 후 '페이지 레이아웃 분배'버튼을 클릭하여 사용자가 기본 상황에서 어느 페이지 레이아웃을 보는지를 제어합니다.`,
"label.notification.approval1":`님의 [대상] 승인 요청이 [승인자]에게 허락되었습니다.`,
"label.h5.chatter.image":`업로드한 이미지 형식이 잘못되었습니다`,
"vue_label_dashboard_displayunit":`단위를 선택하세요`,
"label.knowledge.default.language":``,
"label.chatter.publish":`발표`,
"label.companyprofile.serveraddress":`이번 동기화는 현재 서버에 대해 동기화됩니다`,
"label.chatter.groups":`그룹 단체`,
"label_set_successfully":``,
"label.quote.zongjia":`총가격`,
"label.project.notice.endingdatelater":`마감 일자가 시작 일자보다 늦거나 같아야 합니다!`,
"label.customfields.fielddependency.info":`이 페이지를 사용하면 필드 간의 종속 관계를 정의할 수 있습니다. (예를 들어 종속성이 있는 선택항목 리스트).`,
"vue_label_lead_successful_conversion":`전환 성공`,
"label.icon.93":`책`,
"shift.serviceresource.illegal":``,
"label.integrations.action.addnewlead":`잠재고객 신규 추가`,
"label_display_all_zeros":`0으로 표시된 행을 검색한다`,
"canlendaryear":`캘린더 연도`,
"label_tabpage_selrecordtypez":`기록 유형을 선택합니다`,
"vue_label_commonobjects_view_chart_funnel":`퍼널 차트`,
"label.layout3":`레이아웃3`,
"label.logintime.cue":`로그인 시간 미지정`,
"label.service.miniProgram.lastDate":``,
"label.emailobject.view.fromcrm":``,
"pagecreator.button.mobilepage":`모바일 단말기`,
"lable.oppt.jieduan.signcur":`현 단계로 표시함`,
"label.fullaccess":`방문 권한`,
"homepage.layout.pagename":`페이지 레이아웃 명칭`,
"label.appointment.wizard.subtitle4-2-3":`3시간`,
"label.knowledgebase.please.check.record":``,
"label.view.sortview.closepage":`페이지 닫기`,
"label_forecast_type":`예측 유형`,
"all.day":`전일`,
"label.view.sortview.printpage":`페이지 인쇄`,
"message.integration.configure":``,
"label.forecast.customforecast.foretype.close":`계약서 체결됨`,
"label_chatter_like":`좋아요`,
"template.report.folder.customer.potential":``,
"label.umeng.approval.dlsp.approve":`#approvalname 대신 승인한 #actorname 요청한 #objAPIName#recordname 승인 신청`,
"vue_label_normal_movedown":`밑으로 이동`,
"chatter.group.groupAccessPermissions":`그룹 방문 권한`,
"label.visualpage.tip":`여기에서 본인만의 페이지를 만들 수 있습니다.`,
"message.validation.isnotdate":`정확한 일자 형식을 입력합니다`,
"label.icon.173":`돛단배`,
"label.icon.124":`주사`,
"label.import.page2.csvfiled":`CSV 필드`,
"setup_layout_component_area":`구역`,
"label.visualpage.workability.standard":`페이지에서 사용할 수 있는 표준 Class`,
"label_emailtocloudcc_redmessage9":`데이터 베이스에 오류가 발생하여 관리자에게 연락하세요`,
"label_tabpage_contactsz":`연락담당자`,
"label.multilang.workflow.everydayinmonth":`{0}개월 {1}일 간격`,
"APPIntegration.Social.linkedinerror":`합법적인 linkedin.com의 URL이어야 한다`,
"button_partner_workspace_manage_memo":`파트너 클라우드를 관리하고 파트너 클라우드 속성을 배치합니다.`,
"template.chart.bnsrmb":``,
"chatter.follow.now":`팔로우업 중`,
"label.entitlement.process.condition.repeat":``,
"label.relationobject.isdl":`대리 여부`,
"label.lasttimemodifieralias":`지난 수정자 별명`,
"vue_label_commonobjects_detail_task_name":`업무 명칭 편집`,
"vue_label_homepage_quarterlyperformance":`분기별 실적`,
"pagecreator.layout.message.delete":`선정한 레이아웃을 삭제하시겠습니까?`,
"component_sendmail_label_cc":`참조`,
"vue_label_email_enable_signature":`서명 사용`,
"label.partnerCloud.financeSetting.create":``,
"label.data.file.i.title.num1":`1.불러올 파일은 CSV형식 파일이어야 하며 CSV파일은 제목이 필요하여 제목이 없으면 불러올 수 있습니다.`,
"label_efine_assessment":``,
"message.duplication.label.sectionTitle":`보류되는 값을 선택합니다`,
"front-electronic-export-buttonExport":``,
"message.submitpage.email":`축하합니다! 메일 전송 요청 성공했습니다!`,
"after":`보다 늦다`,
"label.version.nonsupport":`지원하지 않음`,
"label.icon.105":`일정`,
"label.quickcreate.titledesc":`빠른 새로 만들기를 사용해 조회 필드 입력 시 검색창에서 빠르게 새 기록을 생성합니다.`,
"label.quote.number":`수량을 입력합니다`,
"label.view.sortview.setdefault.prompt":`본 뷰 리스트를 기본 뷰로 설정합니다`,
"label.refertime":`제출 시간`,
"frame.personinfo.label.minipic":`생략도`,
"label.mobile.home.page.newopp":`최신 잠재고객`,
"label.address":`주소`,
"front-pay":``,
"label.chat.serviceAppointment":``,
"label.umeng.activity.eventviewed":`#name에게 분배한 이벤트가 열람되었습니다`,
"label.validate.function.funcExplain.DATE":`년, 월, 일을 통해 일자를 생성합니다`,
"label.commiterselectapprover":`제출인이 수동으로 승인자를 선택할 수 있도록 허용됩니다.`,
"label.appointmentconfirmpage.wizard.subtitle3":`장소`,
"vue_label_display_text_field":``,
"label.salescloud.teamrole":`소그룹 역할`,
"maintenanceplan.workorder.generate.limit":``,
"label.campaignmember.selectmember.description":`뷰를 하나 선택해 마케팅 행사에 선택한 멤버를 추가하며 멤버 상태는`,
"label.ismodify":`편집 허용 여부`,
"label.height":`높음`,
"label.tabpage.thevalurofz":`의 값`,
"label.create_successful":``,
"front-invoice-online-payment-setup-configure-dialog":``,
"label.customerinfo.smsEid":`문자 게이트웨이 EID`,
"label.visualpage.list.no":`사용자 설정 페이지 방문 권한 없음`,
"look.trigger.in":`사용 설명서 보기`,
"label.setting.disable":``,
"chatter.group.name":`그룹`,
"label.solutionadministrator":`솔루션 관리자`,
"label.vlidaterule.top":`페이지 헤더`,
"pagecreator.layout.message.save.fail":`레이아웃 저장 실패`,
"label.partnerCloud.orderingPlatform.noZero":``,
"label.customfields.suretodeleteprompt":`사용자 설정 필드 삭제 확인 안내`,
"button_partner_viewdetail":`보기`,
"label.icon.122":`주택`,
"label.customer.tab.step2.introduce":`이 중에서 사용하는 신 사용자 설정 메뉴의 사용자 프로필을 선택합니다. 프로필의 상세 정보와 편집 페이지에서 메뉴 보기 여부를 점검하거나 수정할 수 있습니다.`,
"label.task.delegated":`파견됨`,
"vue_label_salesadvance_averageamount":``,
"vue_label_chat_invitedtojoin":`“{invite}”이 님을 단체방에 초대했습니다.`,
"label.data.downpage.e_title.num1":`1. 내보내는 데이터의 대상을 선택하거나 모두 내보내기를 선택합니다.`,
"label_display_options":`선택지 보기`,
"vue_label_chatter_more_comments":`더 많은 댓글`,
"label.ggReleaseRange.publish":``,
"label.valuetype.notmate":`행 조건이 잘못되어 값 유형이 매칭되지 않습니다!`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`지난 동기화 활동:`,
"label.dataimport.duplication.filter":`중복 검사 필터 안내`,
"label.appdownload.uninstall":`소프트웨어 패킷 삭제`,
"message.error.task.add":`업무 생성에 이상 발생`,
"UG.Account.07":`고객 불러오기`,
"label_tabpage_lastone":`최소 1개 조작을 선택합니다`,
"front-console-holdTime":``,
"label.emailobject.schedule":`저의 일정입니다. 적당한 시간을 선택하세요.`,
"label.lookup.locked.data":``,
"label.assignment.setup.newentries.ifcondtions":`다음 조건을 부합하면 이 규칙을 실행합니다`,
"label.magadan.time":`페트로파블롭스크캄차츠키 시간`,
"message.error.serviceterritorymember":``,
"label_chatter_delete":`삭제`,
"label.partner.workspace.member.permission":`선택 가능한 권한 세트`,
"label.notification.task5":`님의 업무가 이미 만료되었습니다.`,
"mary":`5월`,
"label.homepagemodule":`홈페이지 구성요소`,
"label.compact.layout.frame.error1":`우측 스크린에 내용이 있어야 합니다`,
"chatter.error.refresherror":`새로 고칠 수 없습니다. 다시 시도하십시오.`,
"label.login.rememberPsd":`비밀번호 기억하기`,
"Lead.Scoring.Setting.Rule.Setup.01":`잠재 고객 채점 규칙 리스트`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`일요일`,
"label.visible":`볼 수 있음`,
"label.console.new":`조작공간 새로만들기`,
"label.mr.descreption.reDataList4":`밀리초. 각 페이지마다 표시`,
"vue_label_notice_uploadavatar_notice2":`프로필 이미지가  JPG/PNG/GIF  형식만 가능합니다`,
"label.operation.error":`조작이 실패하여 다시 시도하세요.`,
"label.sendsms.context":`문자 메시지 내용`,
"label.least.show.line":`(최소 4행이 나타나야함)`,
"label.tabpage.newWizardz":`기능 안내 메뉴 추가`,
"label.tippage.li2":`사용자 설정 보고서 데이터 소스에 온 모든 보고서 삭제`,
"label.customfields.new.step2.opration.unique":`유독`,
"label.listofshare.remark":`다음의 사용자가 이 기록의 정보를 볼 수 있습니다`,
"label.address_information":``,
"label.projectManagement.overdue.tasks":``,
"lable.account.PreviousCQ":`지난 캘린더 분기`,
"label.service.miniProgram.advertising":``,
"label.integrations.mailchimp.exportlead":`잠재고객을 Mailchimp로 내보내기`,
"label.payments.paytip3":`계산서 주소를 선택하세요`,
"label.mobile.phone.screen":`선별하기`,
"label.h5.tome":`나에 관해`,
"label.mobile.side.tab.remark1":`CloudCC 메뉴와 대상을 모바일기기 사이드  슬라이딩 메뉴에 추가합니다`,
"vue_label_calendar_choose_a_custom_color":`캘린더의 사용자 설정 컬러 선택하기`,
"label.lastname":`성`,
"vue_label_dashboard_selectreport":`보고서를 선택하세요`,
"label.lanxin.setting.appid":``,
"vue_label_report_information":`CloudCC에서 나타나는 방식으로 보고서를 불러오며 보고서 헤더, 그룹 및 선별 정보가 포함됩니다.`,
"label_chatter_default":`디폴트`,
"label.globalSearch.info":``,
"label.integrations.mailchimp.massage2":`잠재고객을 Mailchimp 로 내보내고 있으며 잠시후 Mailchimp 리스트에서 볼 수 있습니다.`,
"label.tabpage.addresswrongz":`메일 주소 형식 오류 발생, 정확한 메일 주소를 입력하세요!`,
"label.mobile.phone.customer.call":`고객 방문`,
"vue_label_email_linkrecordfail":`연동 기록 취소됨`,
"lable.account.LastfDays":`지난 90일`,
"label.cpq.order.status.delete":``,
"label.ccchat.notmember.active.group":`명칭에 포함된 것이 아님`,
"label.savepayset.failure":``,
"label.version.createlimitbyobject":`현 CloudCC 버전이 {0}이며 대상마다 {1}개 {2}만 생성할 수 있으며 한계에 도달했습니다! 필요하시면 CloudCC 버전을 업그레이드 하세요!`,
"approval.process.errore":`저장 과정에서 오류가 발생하여 관리자에게 연락하세요`,
"label.stdashbord.xsld.business.reportanalysis":`차트 분석`,
"label.login.verification.please.enter":`MFA 프로그램에서 얻은 보안 코드를 입력하십시오`,
"label.tabpage.cue":`정보 안내`,
"vue_label_salesadvance_converserate":``,
"label.marketsea.recyclereminddays1":`자동 회수 전`,
"label.import.page1.update":`업데이트`,
"label.document.folder":`파일 폴더`,
"label.h5.similar.opportunity.feature":`이 기능을 통해 사용자가 사용자의 업무기회와 공유한 공용 필드의 업무기회를 검색할 수 있습니다. 사용하면 '유사 업무기회'관련 리스트가 업무기회 기록에 나타납니다.`,
"label.myanmar.time":`미얀마 시간`,
"monday":`월요일`,
"vue_label_account_shareholder":``,
"button.partner.search":`조회`,
"label.partnerCloud.partnerAccount.topUpAmount":``,
"label.tabpage.refreshz":`새로 고침`,
"lable.PowerProcess.complete":``,
"front-kefu-moudle- normal-phone":``,
"label.user.unauthorized.organization":`권한 부여가 안된 조직이며 관리자에게 연락하세요!`,
"label.area.canot.save.nulldata":`빈 데이터를 저장할 수 없습니다`,
"label.version.role.management":`역할 관리`,
"label.recordtype.batchaddattachments.batch.remark":`1단계.파일을 선택합니다. 2단계. '업로드 시작'버튼을 클릭하여 파일을 업로드합니다. 3단계. '완성'버튼을 눌러 뒤로 이동합니다`,
"label_tabpage_contentz":`내용을 입력하세요`,
"label.partner.workspace.member.all":`모두`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`최소 한명 잠재 고객이나 연락담당자를 선택하세요`,
"label.appupload.install.error.choice5":`즉시 설치를 중지하고 충돌 구성 요소를 출력합니다`,
"label.version.lookupmdfield":`마스터 디테일 필드`,
"setup.layout.label.desc":`내림차순`,
"vue_label_report_addsummaryformula":`합계 공식 추가`,
"label.done":`실제`,
"label.input.samevalue":`같은 값을 입력합니다`,
"label.SMS.next":`이 알림 문자에 대해 대상을 선택해 '다음'을 클릭합니다. 알림 문자가 같은 유형의 업무 프로세스 규칙, 승인 과정과 관련시킬 수 있습니다.`,
"label.role.allunselectuser":`모든 미분배 사용자`,
"label.loginhistory":`로그인 이력`,
"vue_label_report_addpublicreportstofolder":`폴더에 공용 보고서를 추가하기`,
"label.email.track.no.attachment":`첨부 파일 없음`,
"label_network_connection_failure":``,
"vue_label_file_delete_lib_member":`파일 베이스 멤버 삭제`,
"label_partner_step1":`1단계: 템플릿을 선택합니다`,
"label.password":`비밀번호`,
"label.select.the.fields.around.code":``,
"label.file.share.limit":`공유의 상한에 도달해 새 공유를 추가할 수 없습니다!`,
"label.desktop":``,
"label.sendmail":`메일 전송`,
"label.quote.detail":`견적명세서`,
"label.approvalstep2":`2단계: 단계 조건을 지정합니다`,
"label_component_hotdeal_nodata":`업무기회 관련 데이터가 없음`,
"lable.reset":``,
"label.eventpagelayout":`이벤트 페이지 레이아웃`,
"label.icon.100":`문구`,
"UG.quota.03":`견적서 템플릿`,
"label.calendar.week.view":`주일 뷰`,
"component_chatter_file_button_save":`발표`,
"label.as":`이다`,
"template.chart.yqxypjz":``,
"UG.Contract.03":`계약서 새로 만들기`,
"label.projectManagement.gantt":``,
"label.forecast.edit.error0":`오류: 최소 하나의 회사 화폐 종류를 사용하십시오!`,
"label.ccpeak.delete.sharetab":`공유 차트 삭제`,
"label.account.contact.goback":`고객으로 반환하기`,
"vue_label_email_insert_field":`삽입 필드를 선택하세요`,
"setup_object_field_dependency_label_fieldvalueoptions":`선택 가능한 필드값`,
"label.salescloud.opportunity.contactrole.optionlist.main":`다음은 업무 기회 연락담당자 역할 필드의 선택항목 리스트값의 메인 리스트입니다`,
"label.huanxinconfig.tenantid.lost":``,
"label.mask.show.last_4":`마스크 끝자리 4자리 보기`,
"label.targer.name":``,
"vue_label_commonobjects_detail_unlocksuccess":`잠기기 해제 성공`,
"front-kefu-moudle-length-min":``,
"label.chat.topic.my.favorite":`내가 저장한 주제`,
"chatter.upload":`업로드`,
"message.cannotapproveit":`승인 요청을 처리할 수 없습니다`,
"label.weixin..xsld.order.by.jine":`계약서 금액으로 정렬합니다`,
"label.projectManagement.wait.test":``,
"template.report.customer.contact.list":``,
"label.empty.recycle.bin":`휴지통 비우기`,
"label.detail.approveprocess":`승인 과정 보기`,
"label.appexchange.uninstallpage.message4":`이 소프트웨어 패키지에 기반한 사용자 설정 대상의 보고서, 시도, 사용자 설정 메뉴를 영구적으로 삭제합니다`,
"label.weixin.linkreport":`관련→보고서`,
"label.tianyancha.orgnumber":`조직 기구 코드`,
"Q":`옵션 리스트(중복 선택)`,
"pagecreator_systemstyle_message_save_fail":`양식 저장 실패`,
"label.partner.new":`파트너 클라우드: 새로만들기`,
"label.ems.accounttype":`계정 유형（A）`,
"label.weixin.next":`다음`,
"label.weixin.coach.interpret":`AID-MAX는 이 위챗 서비스의 법률 범위 내의 개작권과 최종 해석권을 보류합니다`,
"label.some":`개`,
"label.currency.rate":`화폐 종류 편집: 환율`,
"label.emailobject.template.name":`템플릿 명칭`,
"UG.Campaign.001":`마케팅 행사 계획`,
"label.mr.descreption.reDataList3":`그룹, 조회 소모 시간`,
"label.project.hit.nine":``,
"lable.PowerProcess.golist":``,
"label.viewbuttonedit.remark":`프론트 뷰에 표시할 표준 버튼과 사용자 설정 버튼을 선택하십시오`,
"label.component.helper":`비서`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`계약서 체결 대금 수령`,
"chatter.group.userName":`사용자명`,
"label.mobile.phone.business":`비즈니스 기회`,
"label.quickbooks.payments":`지급`,
"label.step6.total7":`6단계, 총 7단계`,
"label.forecast.detailforecast.revenue":`수익 예측`,
"vue_label_commonobjects_view_chart_displayas":`로 보기`,
"label.recordeditoption":`편집 가능한 속성 기록하기`,
"label.sendemail.send.sendfailstandby":`메일 전송 실패했으며 관리자에게 연락하세요. (예비 보낸 메일함)`,
"label.knowledgebase.reset.filter":``,
"label.icon.111":`음식`,
"label.standard.buttonandlink.firstsetting":`우선 설정`,
"front-filter-module-v1-filter-description":``,
"label.showmore":`더 많이 보기`,
"UG_Lead_001":`고객 경로를 어떻게 끌어들입니까?`,
"label.exchange.sync.state.setting.m1":`제공한 Miscrosoft Exchange 서비스 계정:`,
"label.please.enter.channel.name":``,
"label.emailtocloudcc.edit":`편집`,
"label.layout.tabdialog":`메뉴`,
"label.Emoji":``,
"template.report.completed.tasks":``,
"label.tabpage.enterviewname":`1단계:뷰 명칭을 입력하세요`,
"label.mobile.phone.not.to.choose":`미선택`,
"label.datamanage.contact.namenull":`주의: "연락담당자 이름" 필드에 값을 부여하지 않았다면 연락담당자 기록을 불러오지 못합니다!`,
"LT":`지리적 포지션`,
"label.exchange.sync.state.task.m3":`마지막 24시간 동기화된 기록:`,
"lable.SalesCommitmentKanBan.contractOwner":`계약서 소유인`,
"vue_label_chatter_write_review":`댓글 작성`,
"label.h5.approval.enter.content":`승인 비고 내용을 입력하세요`,
"label.location.display.type":`위도와 경도 표시법`,
"label.numberscannotnull":`수량을 입력하세요`,
"label.icon.3":`화폐`,
"setup_object_field_dependency_label_linkedfieldvalue":`종속 필드값`,
"label.task.future":`곧 도착한 업무`,
"label.look.more.record":`더 많은 기록 보기`,
"vue_label_account_cases":`고객 소유인의 모든 개인안을 이동`,
"label.emailobject.emaildetail.title.ccaddress":`참조:`,
"label.setHistoryTrack":`이력 팔로우업 설정`,
"ObjectDetailed.ViewKeyInformation.Layout":`핵심 정보 편집`,
"label.layout.editsearchdistribute.tip":`이 검색 레이아웃에 포함될 필드를 선택합니다. 주의, 모든 선택이 검색 결과의 보기만 결정하며 실제로 검색된 필드에 영향 주지 않습니다`,
"label.emailtoall":`모든 사람에게 메일 전송`,
"label_partner_new":`파트너 클라우드: 새로 만들기`,
"label.direct.dashboard.me.not.approval":`나의 미승인 프로젝트`,
"label.platform.customize.customizeui":``,
"label.userinfo.pwderror.againinput":`두번 입력한 비밀번호가 일치하지 않으며 다시 입력하세요!`,
"label.customsetting.introduce":`사용자 설정을 통해 조직, 프로필과 사용자급 설정 데이터를 생성하고 관리합니다. 사용자 설정 데이터가 응용프로그램 캐시에 저장돼 있습니다. 이를 방문할 수 있어 중복 검색할 필요없는 것을 의미합니다.`,
"label.file.owner":`소유인`,
"label.icon.7":`사람`,
"label.document.query.button":`열람 버튼을 누르면 파일을 찾습니다`,
"label.tabpage.turnoffsz":``,
"message.error.appid.appsecret.failed":``,
"vue_label_commonobjects_view_to_display_fields":`최대 10개 디스플레이 필드만 선택할 수 있습니다.`,
"label.martrixreport.setlinetitle":`행 제목을 지정합니다`,
"vue_label_chatter_applycertification":`{name}의 그룹 가입을 동의하시겠습니까?`,
"front-electronic-export-success":``,
"label.emailsync.status.enable":`연동 시작`,
"label.c_d":`C에서 D로의 관계`,
"PageLayout_Search_MultiSearch_003":`최소 1개 필드를 선택하세요`,
"label.tabpage.newInterfacez":`새 버전 인터페이스`,
"label.cutomsummaryfieldedit":`사용자 설정 통계 필드 편집`,
"label.usermanage.view.field.notexist":`뷰와 대응하는 필드가 존재하지 않습니다`,
"label.list.userinterface.dashboard.setup":`대시보드 설정`,
"label.knowledgebase.delete.article":``,
"label.dataimport.type.update":`업데이트`,
"label.marketsea.new":`고객풀 새로 만들기`,
"label_tabpage_newlybuildz":`새로 만들기`,
"vue_label_helpcenter_report1":`1. 보고서 작성<br>    CloudCC 마케팅 관리 시스템의 Lightning 보고서는 기능이 많은 데이터 분석 툴이다. 그룹 분류, 선별 및 기록 통합으로 많은 마케팅 문제를 해결할 수 있다. 예를 들어:' 지난 분기에 회사의 새 비즈니스 기회에는 총 얼마의 수입을 창출했습니까:', 데이터 개요를 바탕으로 보고서 차트를 추가할 수 있다. 보고서를 완성한 후 운용을 클릭하여 데이터의 결과를 볼 수 있다. <br>    1단계: 보고서 옵션 카드에서 '보고서 새로 만들기'를 클릭한다. <br>    2단계: 보고서 데이터 소스를 선택하여 '다음'을 클릭한다. <br>    선택한 보고서 데이터 소스가 어떤 기록이나 필드가 보고서에서 사용할 수 있는지를 결정한다. 하나의 대상자를 선택해 메인 대상자로 삼아 최대한 4개 메인 대상자와 관련 있는 대상자를 선택할 수 있으며 대상자 간의 관계를 선택할 수 있다. <br>    3단계:보고서 편집 페이지로 들어가 데이터를 미리 보기 <br>    편집 모드에서 사용자가 보고서를 설정할 수 있으며 필드를 열로 보고서, 그룹 분류 행과 열에 추가할 수 있다, 필터로 보고서 데이터를 선별할 수 있으며 정확한 데이터가 나올 수 있도록 한다. <br>•열 순서 추가,제거 및 조정 <br>    열 추가: 보고서 편집 모드에서 페이지 좌측의 '개요'의 '열' 입력 박스를 클릭한다. 필드를 검색함으로써 드롭다운 필드 리스트를 선택하거나 끌어 원하는 필드의 방식으로 보고서 열을 추가한다. <br>    열 제거<br>    A.좌측의 '열' 리스트에서 삭제하고 싶은 '열'을 찾아 필드 박스의 '×'를 클릭한다. <br>    B.우측의 보고서 미리 보기 뷰에서 삭제하고 싶은 '열'을 찾아 '드롭다운'버튼을 클릭하여 '열 삭제'를 클릭한다.<br>    열을 보고서에서 제거하면 필드가 삭제되지 않는다. 열을 제거하고 회복하고 싶으면 다시 추가하면 된다.  <br>     열 순서 조정:죄측 '열'리스트의 '열'필드를 끌어 놓아 '열'의 배열 순서를 조정할 수 있다. <br>• 행 그룹 분류와 열 그룹 분류를 추가, 제거 <br>     행 분류 추가 : 페이지 좌측 '개요'의 '운용' 입력 상자를 클릭하여 필드 검색하거나 드롭다운 필드 리스트를 끌어 원하는 필드의 방식을 선택해 보고서 행 분류 필드를 추가하고 데이터를 선별한다.  <br>     열 분류를 추가하지 않는 경우에 최대한 3개 행 분류를 추가할 수 있다. <br>    열 분류 추가 : 행 분류가 있는 경우 열 분류를 추가할 수 있다. 페이지 좌측 '개요'의 '운용' 입력 상자를 클릭하여 필드 검색하거나 드롭다운 필드 리스트를 끌어 원하는 필드의 방식을 선택해 보고서 열 분류 필드를 추가하고 데이터를 선별한다. <br>    최대한 2개 열 분류를 추가할 수 있다.열 분류를 추가하는 경우에 최대한 2개 행 분류를 추가할 수 있다. 행 분류를 추가하는 필드에는 열 분류를 추가할 수 없다.<br>    `,
"label.notification.event1":`[분배자] 님에게 이벤트가 분배되었습니다`,
"chatter.field":`개 필드`,
"chatter.feed.menutype.feed.newscom":`내가 팔로잉한 모든 콘텐츠`,
"label.attendance.range":``,
"vue_label_calendar_deleteconfirm":`캘린더{name}를 삭제하시겠습니까?`,
"label.ems.createTask":``,
"label.visualpage.wgd":`미보관 사용자 설정 페이지`,
"label.multilang.product.deleterederect1":`<font style="font-weight:bold;">{0}</font>의 삭제 시도를 완료할 수 없습니다. 다음 기록과 연관되어 있기 때문입니다. 이 경우에는 사용 금지를 권장합니다.`,
"label_emailtocloudcc_filed_servertype":`서버 유형`,
"label.umeng.insert.approval.dlsp.approvenew":``,
"label.tabpage.queue":`대열`,
"label.approval.step":`승인 절차`,
"label.approvaldatamove.approvalprocessname":`과정 명칭`,
"label.actualapprovedpeople":`실제 승인자`,
"label.systemlog.f":`실패`,
"front-template-V1-addText":``,
"label.chat.like":`좋아요`,
"label.userinfo.oldpwd.notnull":`구 비밀번호는 비워둘 수 없습니다!`,
"label.service.all.done.major.event":``,
"label_chatter_to":`로`,
"message.toomuchlinecannotoutput":`선택한 보고서열 수가 한계를 초과해 보고서를 출력할 수 없습니다!`,
"maintenanceasset.assetid.maintenanceplanid.unique":``,
"lable.quote.syncing.firstsync.description":`견적서 명세  업무기회 제품을 대체할 겁니다`,
"lable.outlook.mcto.saveemail":`이메일 첨부파일을 반드시 저장하세요`,
"label.passwordPolicy.setup.pwdremember2":`2개 비밀번호를 기억하기`,
"label.project.hit.five":``,
"label.linkedin.setting.appid":``,
"label.dataimport.error.name.notnull":`에러 발생: name에 비어 있습니다.`,
"label.knowledge.case.field.selected":``,
"label.version.datetime":`{0}개 일자 시간 필드`,
"Dashboard_NoAccessRightToSee_Warning":`설정하신 기본 대시보드{0} 열기  현재 확인 권한이 없으며 다른 값으로 설정해야 합니다.`,
"label.login.access.permission":`방문 권한 부여`,
"label.operatedata.import.tip":`1. 불러오는 파일이 CSV형식의 파일이어야 하며 CSV 파일에 제목이 포함되어 제목이 없으면 불러올 수 없습니다. <br/>2. 불러오기 전에 내보내세요. 내보내는 파일을 데이터 템플릿으로 볼러올 데이터를 정리하여 불러옵니다. (불러올 데이터에 쉼표가 포함되면 "@"부호로 대체합니다 <br/>3. 시스템에서 불러올 데이터 파일을 서버에 미리 읽어부어 불러오기 프로그램을 작동해 불러오기 결과를 메일로 사용자에게 알립니다. 조작 페이지에서 기다릴 필요 없습니다.`,
"workflow.action.tasks.assignortype.rolename":`역할 명칭`,
"vue_label_account_quotations":`고객 소유인의 모든 견적서를 이동`,
"lable.account.CurrentCQ":`현재 캘린더 분기`,
"label.user.database.error":`데이터베이스 오류 발생!`,
"label_emailtocloudcc_titel":`CloudCC로 메일 보내기`,
"label_file_content":`본문 내용`,
"label.button.behavior":`모드`,
"message.recordtype.new.tip":`자세한 정보를 입력하십시오`,
"label.ccchat.message.new.error3":`에러: 선택한 수신인이 9개를 초과할 수 없습니다`,
"vue_label_commonobject_notice_lessthanwords":`파일명 글자수가 {FILE_NAME_COUNT}개를 초과하면 안됩니다!`,
"label.stacked.verticalline":`스택 도형-수직 열`,
"vue_label_SMS_messagebox":`메시지함`,
"label.appexchange.installedpage.message3":`설치된 패키지의 옆에 있는 링크에 따라 이 페이지에서 다른 작업을 실행할 수 있습니다.소프트웨어 패키지를 삭제하려면 <b>삭제</b>를 클릭합니다.소프트웨어 패키지 허가증을 관리하려면 <b>허가증 관리</b>를 클릭합니다`,
"label.unusedapproveprocess":`미사용한 승인 프로세스`,
"label.onlywithspecificconditions":`이 연산은 특정 조건을 부합한 기록만 포함됩니다`,
"lable.outlook.mcto.formaterror":`형식이 잘못되었습니다`,
"label.area.parent":`상급 구역`,
"vue_label_chat_activesuccess":`개설 성공`,
"label.setting.intergrationlist.button.upgrade":`업그레이드`,
"label.page_hidden":``,
"label.customsetting.manage.belong":`소유인 설정`,
"label.appointment.wizard.subtitle4-2-8":`7일`,
"template.chart.ydywjhxsje":``,
"label.multilang.currencylist.after":`{0} 후`,
"vue_label_commonobjects_view_chart_countby":`합계 근거`,
"label.week":`주일`,
"label.emailtemplate.name":`템플릿 명칭`,
"label.umeng.sign":`출석 완료`,
"label.appupload.upload.details":`상세 정보`,
"label.file.loading":`로딩중`,
"label.newdetail.orgTitle":`연락담당자 인맥`,
"label.salescloud.field.addoptionlist":`선택항목 리스트값 추가`,
"pagecreator.page.funcpath":`/빌더/페이지 리스트`,
"Account.News.Setting.001":`고객 설정`,
"label.marketsea.getnoconversiondays":`일 미전환(획득 후 미팔로우업한 일수보다 커야 함)`,
"message.error.event.add":`이벤트 생성에 이상 발생`,
"front-electronic-export-choseChimp":``,
"vue_label_report_personothers":`기타 인원`,
"label.hierarchy.diagram":`등급 구조도`,
"label.stdashbord.xsld.business.yqsr":`예상 수익`,
"label.chat.topic.max.count":`주제의 수량 상한에 도달했습니다.`,
"label.sendemail.send.sendfail":`메일 전송 실패하여 관리자에게 연락하세요.`,
"registration.page.body.title":``,
"label.userphoto.back":`취소`,
"label.service.without.timeslot":``,
"label.processsetting.remaining.quantity":``,
"label.sure.delete":`삭제 확인`,
"front-epwechat-module-v1-callback":``,
"front-email-payment-failed":``,
"label.icon.67":`기계`,
"UG_Forcast_01":`예측`,
"label.escalation.setup.newentries.step3":`3단계: 업그레이드 시간을 어떻게 설정할 지 지정합니다`,
"lable.account.NextCY":`다음 캘린더 연도`,
"report.type.label.quote":`견적`,
"label.area.name":`구역 명칭`,
"component.setup.label.object":`대상자`,
"label.customsetting.type":`유형 설정`,
"label.showdetail":`상세 정보 보기`,
"label.department.prev":`이전 페이지`,
"label.select.data.source.report":`데이터 소스 보고서를 선택하세요!`,
"UG_homepage_002":`통합화된 업무툴로 고객경로, 잠재고객, 마케팅 거래 퍼널과 고객정보를 관리합니다`,
"vue_label_report_notice_exprot1":`상세 정보행만 내보냅니다. 해당 데이터를 사용하여 더 많은 캘큐레이팅을 실시하거나 다른 시스템으로 업로드합니다. 페이지별로 내보내며 한 페이지에 최대 5000 개만 내보낼 수 있습니다.`,
"message.error.task.phonecreate":`전화 업무 생성에 이상 발생`,
"label_chatter_day":`일`,
"label.setinitialcommiter":`6단계 최초 제출인을 지정합니다`,
"message.huanxinconfig.notfound":``,
"label.customfields.file.count.tip":`이 필드에 입력할 수 있는 파일 개수를 입력하세요. 가본값은 1입니다.`,
"label.weixin.appmanage":`응용프로그램 관리`,
"label.approverautoconfirm":`승인자의 자동 확인 방식`,
"vue_label_CCChat_followers":`팔로워`,
"label.usermanage.notselect":`사용자를 선택하지 않았습니다`,
"label.item":`개`,
"label.sendemail.chat.linkurl":`링크 URL:`,
"label.sendmail.step3.deliveroptions":`교부 선택 항목`,
"homepage.components.creationtime":`최초생성시간`,
"label.pc.ui.2018.ccchat.setting":`CCChat 설정`,
"label.knowledge.search.result.highlight":``,
"label.data.downpage.e.title.num2":`2. 단일한 대상자의 데이터를 내보내려면 데이터를 내보내는 방식을 선택해야 한다. 데이터 내보내기 방식: 사용자 설정 내보내기, 템플릿대로 템플릿 내보내기.`,
"label.field.duplicate.error.msg1":`중복된 데이터가 존재하며 중복된 데이터를 처리한 후 특유 속성을 설정하세요.`,
"label.campaign.channel.input.number.error":`숫자 형식 오류 발생`,
"label.goto.dashboard":`대시보드로 이동`,
"com.cloudcc.login.error.message.invalid.ip":`IP가 등록 범위에 속하지 않습니다`,
"label.selectnewfieldvalue":`새 필드 값을 지정합니다`,
"label.appointmentdetail.wizard.title11":``,
"Opportunity_Detailed_Phase_Label_Popup_001":`진입 시간`,
"front-dynamiclayout-module-v1-readonly":``,
"vue_label_calendar_start_field":`스타트 필드`,
"label.weixin.recalculate.shared.failed":`대상 공유 규칙 다시 연산 실패`,
"label.sendmail.step3.dealoptions":`선택항목 처리`,
"setup_layout_label_modifypage":`페이지 편집`,
"homepage.components.select.wide":`나타나는 넓은식 구성요소를 선택합니다`,
"label.import.page1.laststep":`이전`,
"label.weixin.donot.permission":`이 작업을 실행할 수 있는 권한이 없습니다`,
"message.error.name.null":`name이 필수 요소입니다!`,
"label.salescloud.teamrole.optionlist":`그룹 역할 선택 항목 리스트값`,
"component_setup_label_titlefield":`제목 필드`,
"vue_label_commonobjects_detail_have_been":`로 됨`,
"label.textmessage.vonage.setup":`Vonage설정`,
"label.recordtype.profile.enableit":`프로필에 사용`,
"UG.product.04":`제품 생성`,
"label.knowledge.No.related.articles":``,
"label.chat.muted":`방해 금지`,
"registration.page.field.selection":``,
"label.project.hit.eleven":``,
"lable.newtabpage.advsearch":`고급 검색`,
"label.report.share.roleandsub":`역할 및 내부 산하`,
"component.salesperformance.label.nodata":`업무 기회를 추가하여 뒤로 이동하여 실적 차트 확인`,
"label.submitted_on":``,
"label.file.create.link":`링크 생성`,
"label.contact":`연락담당자`,
"label.tab.message.failtoopenleft":`좌측란 열기 및 병합 조작 실패`,
"label.replaces":`교체`,
"label.customcomponent.check.tag.startwith":`구성요소가 &lt;cc:component&gt; 라벨로 시작해야 합니다`,
"label.tab.web":`Web 메뉴`,
"message.success.task.add":`업무 정보 새로 만들기 저장 성공`,
"label.chatter.addresser":`발신자`,
"label.mobile.homepage":`시작 페이지`,
"label.data.imp.su.ok":`시스템에서 데이터를 불러오는 중입니다`,
"label.knowledge.category.hint.one":``,
"label.schedulejob.setup.schedule.weekly":`매주`,
"label.tag.manage.description":`{0}과 관련된 모든 라벨이 다음과 같습니다. 사용할 수 있는 라벨에 대해 재명명이나 삭제할 수 있습니다.`,
"label.tabcontrol":`메뉴`,
"label.field.duplicate3":`'ABC'와 'abc'가 중복값으로 간주합니다. (알파벳 대소문자 불구별)`,
"label.customsetting.type.list":`리스트`,
"lable.account.ovdate":`회계 분기 종료일`,
"label_chatter_pastSevenday":`지난 7일`,
"front-kefu-moudle-v1-lxndxsdb-free":``,
"label.termsforusage":`사용 조항`,
"label.forecast.settings.qijian.m":`월별 예측`,
"label_tabpage_viewname":`뷰 명칭`,
"label.report.action.addtodashboard1":`대시보드로 추가`,
"label_vue_create_edit_obj_create_event_dialog_desc":``,
"vue_label_report_standardfilter":`표준 필터`,
"label.umeng.approval.submit":`#applyer가 #obj 승인을 제출했습니다`,
"label.tab.mobile.sign":`모바일기기 아이콘`,
"vue_label_commonobjects_detail_check_the_content":`인증에 오류가 발생하여 입력한 내용을 확인하세요.`,
"UG_Campaign_001":`마케팅 행사 계획`,
"chatter.group.baseInformation":`기본 정보`,
"label.sendemail.send.noreceiver":`수신인이 없거나 수신인의 메일 주소가 비어 있습니다`,
"template.chart.yskje":``,
"label.textarea":`텍스트 에어리어`,
"vue_label_statistics_value":``,
"font-evaluate-module-v1-select-img":``,
"label.totalof":`총 선택은`,
"label.hangye":`업종`,
"label.partner.common.setup":`일반 설정`,
"label.icon.78":`농업`,
"lable.outlook.detail.addemail":`메일 추가`,
"label.ServiceCloud.fuwuquyu":``,
"label.gb2312encoding":`간체 한자(GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10분`,
"label_emailtocloudcc_reauthorization":`다시 권한을 부여하기`,
"label.approval.message":`승인 의견 최대 1000자까지 입력해 주세요`,
"label_component_helper":`비서`,
"label.editRate":`환율 편집`,
"label.setuptemplate":`자동화 템플릿`,
"label_emailsync_button_cancel":`취소`,
"label.marketseamemset.account.maxuser":`멤버의 최대 고객수`,
"label.someerror":`보안상의 이유로 CloudCC 세션이 시간이 곧 지납니다. <br><br>어떤 선택을 원하십니까?`,
"label_person_in_charge":``,
"label.visualpage.reference.standard.style":`플랫폼 표준 양식을 인용합니다. customize- 사용자 설정 양식`,
"errormessage_email_relatedorreceivermusthaveone_z":`수신인과 관련 항목을 최소 1개를 선택하세요`,
"label.insert.field.empty.continue":``,
"component.newrecords.label.title":`최근 기록`,
"template.detail_info_link":`상세 정보 링크`,
"component_setup_tabs_label_default":`기본 페이지`,
"label.emailobject.template.name.null":`메일 템플릿 명칭을 입력하세요`,
"label.knowledge.field.changed":``,
"homepage.components.select.narrow":`표시할 좁은 식 구성요소를 선택하십시오`,
"label.mobile.phone.week":`몇 주째`,
"component_chatter_button_like":`좋아요`,
"label.brief.won":`거래 성사`,
"label.setup.profile.replaceme":`나에 관해 교체`,
"label.knowledge.setting.enable.lightning":``,
"label.middle":`중`,
"label.icon.109":`사람`,
"vue_label_normal_activity_sf":`행사`,
"chatter.poll.option6":`선택 항목6`,
"label.lanxin.setting":``,
"label.stdashbord.xsld.business.totals":`업무 상황 종합`,
"label.emailobject.emaildetail.promptbutton1":`확인`,
"Opportunity.Detailed.Phase.Label.001":`단계`,
"label.customcomponent.params.info":`파라미터 사용 방법`,
"label.emailtocloudcc.button.next":`다음`,
"front-email-payment-billing-date":``,
"label.ems.with3day":`3일 내`,
"label.project.subtask.date":``,
"label.role.allunselectanduseduser":`모든 미분배 및 사용한 사용자`,
"front-kefu-moudle-yes-wantbuy":``,
"label.looking_for":``,
"page.404.label.noresource":`죄송합니다. 방문하실 내용이 없습니다.`,
"vue_label_ccchat_notice_deletecommentcertification":`댓글을 삭제하시겠습니까?`,
"label.data.setok.e.desc1":`내보내기 성공한 후 시스템에서의 알림 메일을 받으실 겁니다. 내보낸 데이터가 임시로 서버에 48시간만 저장되며 빠른 처리 필요합니다.`,
"label.weixin.confirm.delete":`이 데이터를 삭제하시겠습니까?`,
"A":`텍스트 에어리어 (리치 텍스트)`,
"template.report.sales.cycle":``,
"label.service.shift":``,
"label.visualpage.display.side.bar":`측면 메뉴 보기, false-측면 메뉴 안 보기`,
"label.list.userinterface.chatter.showall":`시작 페이지 CCChat에서 모든 게시물을 기본으로 표시합니다`,
"vue_label_systemSettings_set_course":``,
"label.icon.156":`사람`,
"label.marketsea.button.move":`이동`,
"front-email-payment-select-email":``,
"front-electronic-signature-service-provider":``,
"label.h5.add.checkin":`출석`,
"vue_label_amount_total":``,
"label.campaign.channel.new":`마케팅 행사: 마케팅 채널 새로만들기`,
"label.knowledgebase.restore.creates.draft":``,
"UG_Case_01":`개별안`,
"label.validate.function.funcExplain.CONTAINS":`텍스트에 특정 문자가 포함되는지 점검하며 포함되면 TRUE를 반환해 아니면 FALSE를 반환합니다.`,
"label.data.exp.savetemp":`템플릿으로 저장`,
"front-project-module-v1-template-newcreate":``,
"label.field.default.count":`기본 행 수`,
"page.note.acc":`비고와 첨부파일`,
"label.close":`닫기`,
"label.app.detailbeforeedit":`다음은 사용자 설정 응용 프로그램 정보입니다.편집을 누르면 "사용자 설정 응용 프로그램을 변경할 수 있습니다."`,
"label.profile.standardfieldsafety":`표준 필드급 안보성`,
"vue_label_report_notice_deletefilter":`고급 선별 조건부터 삭제하세요`,
"label.multilang.datamoveaction.movesuccess":`총 {0}개 기록 이동 성공!`,
"label.emailmerge.edittemplate.descirption":`메일 병합 템플릿의 정보를 입력합니다. 주의, 비고가 CloudCC에만 나타나며 Word에 나타나지 않습니다.`,
"label.visualpage.at.the.end":`종료처에 라벨로`,
"label.exchange.sync.state":`Exchange Sync 상태`,
"label.newdashboardpage.new":`행 신규 추가`,
"label.querydetailservice.profile.notsetup":`계정과 대응한 프로필을 설정하지 않았습니다`,
"label.escalation.setup.detail.description":`규칙 조항 생성을 통해 지정한 조건으로 개별안을 자동으로 업데이트됩니다. 규칙 조항을 생성한 후 이 페이지에서 다시 정렬할 수 있습니다.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`단말기가 H5를 사용해 새로 편집 여부`,
"vue_label_file_upload_tip_msg":`페이지 로딩 속도가 느려지지 않도록 30MB 미만의 파일을 업로드 하세요.`,
"label.eowechat.epdeptid":``,
"label.adminorapprover":`관리자<strong>또는</strong>현재 분배된 승인자는 승인 과정에서 기록을 편집할 수 있습니다.`,
"label_emailtocloudcc_email":`메일`,
"setup_main2018_label_norole":`시스템 관리 권한이 없습니다`,
"label.onlyone":`유일`,
"label.sso.saml.idp.config.nameidtype":`대상 유형`,
"vue_label_normal_campaign_sf":``,
"label.icon.61":`기중기`,
"label.datatype":`데이터 유형`,
"label.mobile.home.page.today.work":`나의 업무`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat 님의 댓글을 좋아합니다`,
"chatter.sel.p":`0명을 선택했습니다`,
"label.b_c":`B부터 C까지 관계`,
"label.tabcontrolnameandtaglib":`메뉴명과 라벨`,
"label.globaloperation.tip":`전체 조작 생성, 편집 및 보기, 이를 상세 정보 페이지에 적용할 수 있습니다`,
"R":`기록 유형`,
"label.initcommiteoperate":`최초 제출 조작`,
"front-kefu-moudle-v1-Operation-without0-permission":``,
"button_partner_create":`생성`,
"label.document.name.length.cannot.than":`파일 명칭 길이가 255를 초과할 수 없습니다`,
"label.area.donot.delete":`현 구역이 하급 구역이 있어 삭제할 수 없습니다`,
"label.currency.activation":`활성화`,
"label.connect":`&직렬연결`,
"button.partner.viewdetail":`보기`,
"setup_object_field_dependency_label_mustsetup":`필드 종속 관계를 설정하여 저장하세요`,
"label.SalesCommitmentKanBan.task":`업무액`,
"lable.quote.syncing.finishbutton":`완성`,
"label.weixin.group.type":`방문 유형`,
"vue_label_commonobjects_detail_relationship":`관계 정도`,
"vue_label_email_cc":`숨은 참조인`,
"setup.object.field.dependency.label.fieldvalueoptions":`선택 가능한 필드 값`,
"label.sso.lookAtTheKey":`비밀키 보기`,
"UG.opportunity.008":`업무 기회 그룹`,
"label.customfields.new.step1":`1단계. 필드 유형을 선택합니다`,
"lable.qrcodeOrbarcode.rule":``,
"vue_label_notice_nopermission_delete":`죄송합니다. 해당 데이터에 대해 삭제 권한이 없으며 시스템 관리자에게 연락하세요.`,
"label.customerobj.tab":`사용자 설정 대상 메뉴`,
"com.cloudcc.login.error.message.nolicens":`허용이 존재하지 않습니다`,
"label.sendsms.batch.confirm":`대량 메시지 보내기: 확인`,
"label.forecast.settings.sos":`수익과 수량`,
"label.calendar.addevent.notice.opencalendarfirst":`나의 캘린더나 기타 캘린더를 열어 이벤트를 추가하시오`,
"message.success.task.phonerecord":`전화 기록 업무 저장 성공`,
"label.knowledgebase.create.new.subtab":``,
"label.knowledge.article.recordid":``,
"Opportunity.Detailed.Phase.Label.Popup.003":`머문 일수`,
"homepage.layout.nowpage":`기존 페이지 레이아웃`,
"template.chart.khslph":``,
"front-epwechat-module-v1-android-single":``,
"serviceresource.assignedresource.islacksr.lack":``,
"label.email.only.display.info":`아래 상자에는 메일 주소가 저장된 연락담당자나 동료만 표시됩니다`,
"label.weixin..xsld.yjhtje":`예상 계약 금액`,
"label.permission.delete.permsets.error.prompt":`해당 권한 집합에 분배된 사용자가 있어 삭제할 수 없습니다!`,
"label.ccchat.enter.two.choices":`최소 2개 선택항목을 입력하세요`,
"label.edit.field.select.style2":`한 선택항목마다 한 행을 차지합니다`,
"vue_label_email_please_enter_email_subject":`메일 주제를 입력하세요`,
"batch.sendemail.f":`,메일 전송 실패.`,
"label.sms.senderr":``,
"label.batchadd.newbatchpage.save.em":`메일 형식이 잘못되었습니다`,
"label.icon.96":`컴퍼스`,
"message.recordtype.deleterecord.tip":`이 페이지를 사용해 기존 기록 유형을 신 기록 유형으로 교체합니다. 다음 상자에서 교체할 기록 유형을 선택해 모든 삭제될 기록 유형이 포함된 기록에 적용합니다. 기존 기록에서 해당 기록 유형만 삭제하고 신 기록 유형으로 교체하지 않으려면 '없음'을 선택하세요.`,
"label.field.edit.max":`최대 평점`,
"label.partnerCloud.orderingPlatform.preferential":``,
"label.callcenter.login.later":``,
"batch.change.owner":`소유인을 선택하세요`,
"label.version.allow.upload.size":`최대 업로드 파일 크기가`,
"setup.mainpage.label.welcome17":`권한 설정`,
"label.tag.sectionname":`라벨 정보`,
"label_partner_workspace_setup":`설정`,
"label.managecontrol":`관리 권한`,
"label.timetrigger.condition":`평가 조건을 매번 기록을 생성하거나 기록 편집 시를 설정합니다`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`요일`,
"front-verkoop-bywerking-error":``,
"label.allowcommittercallback":`제출인이 승인요청을 돌려보내기 허용`,
"vue_label_commonobjects_detail_lead_finishistatus":`완료된 상태로 표시함`,
"message.error.object.lookupmd":`대상에 마스터 디테일 관계를 구축했습니다`,
"label.stdashbord.xsld.business.img7":`가능성이 0%인 단계의 개수/ (가능성이 100%인 단계의 개수 가능성이 0%인 단계의 개수)`,
"label.checkruleofevent":`이벤트 인증 규칙`,
"front-epwechat-module-v1-single":``,
"label.tabpage.save":`저장`,
"label_emailtocloudcc_search":`검색`,
"label.tianyancha.h5.registeredPlace":`등록지(줄임말)`,
"label.field.addoptionlist":`선택항목 리스트값 추가: 선택항목 리스트`,
"label.schedule_anotherpost":``,
"label.customfields.searchrelation.tip":`이 대상이 다른 대상과 연결하는 관계를 생성합니다. 관계 필드가 사용자가 찾기 아이콘을 클릭하여 팝업 리스트에서 값을 선택하는 것을 허용합니다. 다른 대상은 리스트 값의 소스입니다.`,
"label.partnerCloud.partnerAccount.prepaidPhone":``,
"label.projectManagement.view.details":``,
"label.sendemail.chat.praiseFeed":`존경하는 #name:\n\n    안녕하세요！#userName이 님의 게시물에 좋아요를 눌렀습니다.`,
"label.validate.function.category.Text":`텍스트`,
"component.task.label.newevent":`임무 새로 만들기`,
"label.data.import.setup.operate":`기존 기록을 발견하면 어떤 조작을 원하십니까?`,
"label.salescloud.salesdashboard.clear.option":`옵션 삭제`,
"lable.account.PreviousCY":`전에 2개 캘린더 연도`,
"label.appointment.wizard.subtitle8":``,
"label_emailsync_status_viewlog":`일지 보기`,
"message.duplication.label.filtertitle":`중복률 검사 필터`,
"label.custom.quarter.description":`이 페이지에서 하나의 사용자 설정 분기 기록을 정의할 수 있습니다. 사용자 설정 분기의 일자가 다음의 선택대로 생성됩니다.`,
"label_tabpage_filenamez":`파일 명칭`,
"lable.currencyAdv.andbefordate":`및 전의 일자`,
"label.version.nonsupport.sharerule":`공유 규칙에 지원되지 않습니다!`,
"front-epwechat-module-v1-unbound":``,
"label.division":`지점`,
"label.data.import.setup.repeat":`중복 기록을 생성하는 것을 막으시겠습니까?`,
"label.callcenter.makesure.Amazon.connect":``,
"label.version.lead.control":`잠재고객 관리`,
"label.copying.reward.groups":``,
"#label.severalorone":`압축이나 한개 파일#`,
"label.mailinginfo":`우편주소`,
"component.telerecord.label.title":`기록 전화`,
"label.godocumentlist":`파일 리스트로 반환하기`,
"APPIntegration.Dropbox.setting.01":`작동`,
"label.tianyancha.website":`사이트`,
"label_tabpage_greaterequalz":`크거나 같음`,
"vue_label_campaign_influencedopportunity":`업무 기회에 영향을 준다`,
"message.save.param.null":`파라미터가 없어 저장 실패했습니다`,
"front-epwechat-module-v1-domain":``,
"label.allowreport":`보고서 허용`,
"label.service.major.event":``,
"label.import.index.selectobjectandfiles":`대상자 및 파일 선택`,
"label.chatter.task":`임무`,
"label.knowledge.setting.hint.twelve":``,
"lable.account.CurrentandPreviousFY":`현재와 지난 회계 연도`,
"label.martrixreport.step3":`3단계: 통합할 정보를 선택합니다`,
"front-console-select-cases":``,
"label.partnerCloud.partnerAccount.backHome":``,
"label.me.assign":`내가 분배한 것`,
"label.appointment.wizard.subtitle3":``,
"label.edit_columns":``,
"label.partnerCloud.orderingPlatform.useRebates:":``,
"label.projectManagement.enter.up.to.10.digits":``,
"label.integrations.description.mailchimp":`CloudCC와 MailChimp이 통합되어 시스템 내의 잠재고객과 연락담당자를 MailChimp로 불러온 후 각종 메일을 지정된 수신인에게 단체 전송할 수 있습니다. MailChimp에서 메일 운영의 통계 데이터를 확인할 수 있습니다.`,
"label.ccchat.person.error.requiredomain":`오류: 최소 한개의 도메인이 필요합니다`,
"label.projectManagement.Pleaseselectitem":``,
"label.netaccess":`인터넷 방문`,
"vue_label_SMS_searchobject":`검색 대상`,
"label.role.viewintree":`트리 뷰로 보기`,
"lable.SalesCommitmentKanBan.accountName":`고객 명칭`,
"label.please.contact.your.administrator":``,
"label.sso.saml.sp.idenitysource":`SAML 신원 위치`,
"label.queue.delete":`삭제`,
"label.service.miniProgram.jumpLink":``,
"label_set_ forecast_scope":`예측 범위 설정`,
"label.weixin.success.sign":`성공적으로 현장에 출석했습니다.`,
"front-dialog-module-v1-error-code":``,
"label.projectManagement.nodata.problem":``,
"label.myhomepage":`나의 시작 페이지`,
"label.exchange.sync.state.task.m1":`지난 동기화된 행사:`,
"label.pw.config":``,
"front-console-new-contact":``,
"label.customfields.fielddependency.editexplain":`<li>셀을 더블 클릭하여 열제목의 제어필드의 시각성을 전환합니다. </li><li>여러개 셀을 동시에 변경하려면 여러개 셀을 선택해 '포함값'이나 '제외값'버튼을 클릭하며 선택한 모든 셀의 시각성을 동시에 변경합니다. </li><li> Shift버튼을 눌러 서로 인접한 셀들을 선택합니다. Ctrl버튼을 눌러 여러개 인접하지 않는 셀들을 선택합니다. </li><li> '미리보기'버튼을 사용해 결과에 대해 테스트할 수 있습니다. </li>"`,
"setup_mainpage_label_welcome7":`조작 안내: 페이지 좌측 메뉴를 클릭하여→응용 프로그램 설정→생성→대상→대상명→사용자 설정 필드.`,
"message.validation.sum":`승인 페이지 레이아웃에 표시될 필드를 너무 많이 선택하였습니다. 최대 190개의 필드를 허용합니다.`,
"label.knowledge.attach.case":``,
"front-electronic-signature-custom-field-type":``,
"vue_label_pricebook_activated":`가격 매뉴얼이 사용됨`,
"vue.schedule.pre":``,
"Lead_Tools_BatchScoring":`잠재 고객 모두 평점`,
"front-lightning-module-v1-details-page-chart-screening-based-on":``,
"label.report.no.recently":`최근 기록 없음.`,
"label.service.gantt.dangerous.sum":``,
"label.main.field":``,
"label.weixin.optionfive":`선택항목5`,
"homepage.wide":`넓은 란(우측 란)`,
"vue_label_notice_confirmdelatehomepage":`홈페이지를 삭제하시겠습니까?`,
"vue_label_report_exportpages":`불러올 페이지 수: 페이지`,
"label.select_compaign":``,
"attachment.button.massdownload":`모두 다운로드`,
"label.chatter.incident":`이벤트`,
"label_partner_new_step1":`1단계: 원하는 템플릿을 선택합니다`,
"button.partner.workspace.saveas.memo":`현재 파트너 클라우드를 '템플릿'으로 저장합니다.`,
"vue_label_pricebook_edit":`가격 매뉴얼 편집`,
"label.weixin.privacy.rights":`프라이버시 관련 권한: 대충 위치(인터넷으로), 정확(GPS) 위치`,
"label.please.codeType":``,
"label.approveorrefuserequest":`요청 승인/거절`,
"message.error.sharemember":`전송할 sharemember가 없으며 전송 파라미터를 확인하세요!`,
"label.file.folder.edit":`폴더 편집`,
"label.data.import.setup.repeat.yes":`네- 중복된 기록을 만들 수 없습니다.주의: 기존 기록을 업데이트하려면 이 선택항목을 선택해야 합니다.`,
"label.approveBeforeTheOperation":`승인전의 작업`,
"vue_label_file_already_checked_file":`{checkedWork} 개 파일을 선택했으며 단번에 최대 10개 파일을 추가할 수 있습니다.`,
"vue_label_hidden_record_count":``,
"UG_product_01":`제품/서비스 열거하기`,
"label.tabpage.clearoptionsz":`고급 선택 항목 삭제`,
"label.partnercloud.num.overstep":``,
"label.tianyancha.businessverify.msg8":`이 기능은 현재 중국 대륙 지역에 등록한 공상기업에 대해서만 조회할 수 있으며, 적절한 지연이 있습니다.`,
"Lead_Scoring_DetailedPage_Popup_Title":`잠재고객 관찰`,
"label.emailtocloudcc.email":`이메일`,
"vue_label_pool_highcost":`제품 원가 높음`,
"label.callcenter.enterprise.configuration":``,
"label.view.edit.search.prompt":`키워드를 입력하세요`,
"label.ems.sms":`메시지 전송`,
"label.emailobject.list.new":`메일 쓰기`,
"label.salescloud.forenableteamsales":`그룹 세일즈 사용`,
"pagecreator.systemstyle.funcpath":`/빌더/브랜드화 양식 베이스`,
"label.partnerCloud.basicSetting.domain":``,
"label.projectManagement.Posttask":``,
"label.tianyancha.businessverify":`공상 기업 데이터 인증 사용`,
"label.tianyancha.h5.info":`기본 정보`,
"september":`9월`,
"chatter.poll.option9":`선택항목9`,
"label.department.firstpage":`첫 페이지입니다`,
"label.reportsSubscriptionPage.condition.button":`조건 추가`,
"label.exchange.sync.state.task":`업무`,
"pagecreator.layout.button.splitall":`모두 분해`,
"vue_label_calendar_please_select_the_start":`스타트 필드를 선택하세요`,
"label.tab.message.failtogettop":`상단 옵션 카드 열기 실패`,
"label.sharerule.organizationscopesetshare":`조직 범위 내에 공유 설정을 기본으로 합니다`,
"label.delete.rules":``,
"label.recordtype.tabname.detail":`'편집'버튼을 사용해 이 기록 유형의 속성을 변경합니다. '선택 항목 리스트값' 관련 리스트의 '편집'링크를 사용해 이 기록 유형의 기록에 사용 가능한 선택항목 리스트값을 선택합니다`,
"label.knowledge.setting.hint.ten":``,
"vue_label_norm_undone":`이 조작은 철회 불가능합니다.`,
"label.trigger.line":`행:`,
"lable.info.queue.reason":`멤버가 된 이유`,
"label.validate.function.funcExplain.HOUR":`일자/시간 필드의 시간수로 돌아가기, 0-11 간의 숫자임`,
"label.update.document.content":`파일 내용을 수정했습니다`,
"lable.Existing.template":``,
"label.summaryreport.step3":`3단계: 통합 정보의 그룹분류 방식을 선택합니다`,
"label.emailmerge.list.filetype":`파일 유형`,
"label.customfields.helptext.tip":`사용자가 이 필드 옆의 정보 아이콘에 호버하면 이 텍스트가 상세 정보 페이지와 편집 페이지에 나타납니다`,
"label.setting.intergrationlist.description":`정확 통합으로 CRM에서 나갈 필요 없이 업무 응용 프로그램 간의 데이터를 보고 공유할 수 있습니다. 일부 통합, 예,QuickBooks、Zapier는 권련 권한을 부여해야 사용자가 사용할 수 있습니다. 일부 통합, 예, Gmail、Outlook 등은 사용자마다 자신의 계정에서 배치할 수 있습니다.`,
"component_milestones_label_title":`이정표`,
"label.custom.AntiRevocation":``,
"label.mobile.app.new.task":`모바일기기에 업무 이벤트 새로만들기 App버전 사용 여부`,
"vue_label_opportunity_related_chooseproduct":`최소 한 제품을 선택해야 합니다`,
"label.standardguest":`표준 내빈`,
"label.icon.125":`측정 기구`,
"label.skipsomeset":`이것은 이동 기점 안내 메뉴로 CloudCC에서 자동으로 일부 설정을 선택합니다.`,
"label.forecast.shrepage.fmanager":`예측 책임자`,
"label.mobile.quickcreate.default.work":`업무를 합니다`,
"label.projectManagement.nodata.team.members":``,
"label_social_media_account_settings":``,
"UG.quota.05":`업무 기회와 상호 동기화`,
"label.partner.workspace.tab.selectedoption":`선택한 메뉴`,
"front-kefu-moudle-v1-clientID-reinput":``,
"label.mobile.home.page.contract.value":`계약서 금액 예상`,
"december":`12월`,
"label.campagin.roi.dcrs":`출석 인원수`,
"label.currency.edits":`화폐 종류 편집`,
"label.currency.company":`회사 화폐 종류`,
"label.customfields.newformula.nogrammererror":`표현식에 문법 오류가 없습니다.`,
"label.version.nonsupport.api":`인터페이스 API가 지원되지 않습니다!`,
"label.data.file.i.title.num2":`2. 불러오기 전에 먼저 내보내세요. 내보낸 파일을 데이터 템플릿으로 불러오는 데이터를 정리한 후 불러오세요. (불러오는 데이터에서 콤마가 있는 경우, '@'로 대체하세요)`,
"front-console-conversation-title":``,
"front-kefu-moudle-call":``,
"vue_label_systemSettings_pagefooter":``,
"label.newRule.successfully.added":``,
"label.trigger.direction.for.use":`플랫폼 트리거 사용 설명 [2.0버전]`,
"label.instrumentPanel.maxLabelname":``,
"label.same.month.report":``,
"label.knowledge.language.american":``,
"label.paging.totalof":`총 {0}개`,
"label.tianyancha.businessverify.enable.error":`공상 데이터 인증 사용 여부 확보 실패하여 시스템 관리자에게 연락하십시오!`,
"vue_label_commonobjects_detail_email_template":`메일 템플릿을 사용하기`,
"message.error.save.failed":``,
"advancedoptions":`고급 선택 항목`,
"setup_object_layout_message_selectedlayoutandrecordtype":`레이아웃과 기록 유형을 선택하세요`,
"label.sendemail.recycle.operatesuccess":`휴지통을 비우는 작업이 성공적으로 끝났습니다. 모두 #size개 데이터를 삭제했습니다!`,
"J":`텍스트 에어리어(긴 텍스트)`,
"message.validation.isnotmail":`정확한 메일 주소를 입력합니다`,
"label.timetrigger.before.lasttime":`마지막 수정시간 1시간보다 빠릅니다.`,
"label.tabpage.arecordtypez":`사용 가능한 기록 유형`,
"label.reportoption":`보고서 선택항목`,
"pagecreator.button.next":`다음`,
"assetbom.transferowner.notpermission":``,
"label.toptitle.lightning":``,
"label.copy.target":``,
"label.productsales.oppor.approach":`곧 다가온 업무기회`,
"label.email.template.select":`메일 템플릿 선택하세요`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":``,
"label.tabularreport.step3":`3단계: 보고서의 각 열의 순서를 정합니다.`,
"label.multilang.cchttpservice.signin":`존경하는{0} 초대하신 {1}행사의 손님{2} 현장에서 출석하셨습니다.`,
"label.appexchange.uninstallpage.message3":`이 소프트웨어 패키지의 모든 사용자 설정 대상을 위해 생성된 모든 데이터를 영구적으로 삭제합니다`,
"label_tabpage_ownedz":`총`,
"label.tabularreport.2018.step2":`2단계: 보고서 기준을 선택합니다`,
"label.object":`대상`,
"template.report.contracted.customers":``,
"label.field.remark3":`일부 사용자 설정 필드를 삭제하면 이 사용자 설정 필드를 사용하는 모든 필터가 삭제됩니다.사용자 설정 종속 필드 데이터의 분배나 업그레이드 규칙의 결과를 변경할 수 있습니다.`,
"label.eventview.issms":`문자 알림 여부`,
"label.knowledge.language.brazilian":``,
"vue_label_norm_viewfilter":`뷰 선별`,
"label.forecast.settings.qijian":`기간 예측`,
"label.startuploadfile.step.intruduce":`'파일 선택' 버튼을 누르면 파일을 찾고 선택한 파일을 아래 영역에 표시합니다.`,
"label.smstemplate":`메시지 템플릿`,
"vue_label_chatter_no_permission":`해당 파일의 방문 권한이 없습니다.`,
"label.callcenter.Incorrect.data.filling":``,
"label.tag.search.button":`라벨대로 선별하기`,
"label.multiplyselectoptions":`체크상자 옵션`,
"lable.outlook.detail.mutual":`쌍방향 동기화`,
"label.workflow.estimatecondition1":`생성이나 편집 기록이 규칙 조건에 부합하지 않는 경우`,
"label.validate.globalvariable.user.profileId":`프로필 ID`,
"UG.Campaign.003":`마케팅 행사 생성`,
"label.validate.function.funcExplain.ISNULL":`표현식이 비어 있는지(공백) 검사하고, 비어 있으면 TRUE(참)로 반환합니다.하나의 값을 포함하고 있으면 이 함수는 FALSE (거짓)로 반환합니다`,
"label.setting.intergrationlist.status0":`통합상태`,
"label.copy_error":``,
"label.connectOtherNone":`선택한 대상은 추가적으로 연관될 대상이 없습니다.`,
"label.bmap.beijing":`베이징`,
"front-kefu-moudle-v1-hxzxybsc-again":``,
"label.wei.pollsubject":`투표 주제`,
"APPIntegration_Social_twittererror":`합법적인 twitter.com의 URL이어야 됩니다.`,
"label.appupload.install.apicannotuse":`api 명칭을 사용할 수 없습니다`,
"label.returntolist":`리스트로 돌아가기`,
"label.translation.start2":`한개 설정 구성요소를 선택합니다.`,
"lable.edit.queue.alter":`대열이 지원된 대상을 선택하세요`,
"label.campaign.channel.step3":`3단계: 마케팅 채널 등록 페이지 필드를 선택합니다`,
"label.data.newtemplate.e.seltype":`데이터 내보내기 방식 선택하세요`,
"front-kefu-moudle-hangup":``,
"label.forecast.forecastroleuserpage.shre.managerandother":`관리자와 예측 책임자가 이 예측을 공유할 수 있습니다`,
"label.knowledgebase.mark.as.new.version":``,
"label.conditiontag.lookup":`조회`,
"label.import.page3.importsucceed":`불러오기 성공`,
"label.stdashbord.xsld.condtion":`조건 설정`,
"label_emailtocloudcc_redmessage10":`정보 기한이 만료되어 다시 로그인하세요`,
"label.event.moveup.1hour":`1시간을 앞당깁니다`,
"label.chat.topic.page.add.favorite":`회사동료그룹 페이지에 즐겨찾기로 저장`,
"label.icon.88":`컨설팅`,
"page_404_label_noresource":`죄송합니다. 방문하신 리소스가 없습니다.`,
"label.quickbooks.refresh":`새로고침`,
"front-kefu-moudle-which-getphone-case":``,
"label.objecttab.edit":`대상 메뉴 편집`,
"label.data.file.the.trigger":`트리거 실시`,
"frame.personinfo.label.personimage":`프로필 사진`,
"label_tabpage_turnoffsz":`닫기-전환됨`,
"label.sendmail.batch.chose":`메일 대량 발송: 수신인을 선택하십시오`,
"label.data.downpage.i_title":`데이터 불러오는 단계:`,
"label.recycle.clearconfirm":`비우시겠습니까?`,
"chatter.using":`여기까지`,
"label.batchadd.newbatchpage.list":`데이터 리스트 모두 신규 추가`,
"pagecreator.systemstyle.button.new":`양식 새로 만들기`,
"label.notification.serviceappointment.changestate":``,
"label.weixin.weipollname":`투표 명칭`,
"label.tabpage.skip":`넘어가기`,
"label.edit.field":``,
"label.edit.new.rule":``,
"label.approved.receiveApprovalEmail":`메일 수신 승인 요청`,
"label.dashboard.refreshNow":`바로 새로고침`,
"label.lookup.introduce":`필드를 입력함으로써 퍼지 검색할 수 있습니다`,
"homepage.components.newdes":`아래에 입력한 HTML코드의 유효하고 정확한 포맷을 확보해 주십시오.구성요소에 HTML 코드를 잘못 기록하면 전체 홈페이지 메뉴가 정확하게 표시되지 않을 수 있습니다.`,
"label.role.giveuserrole":`사용자에게 역할을 분배합니다`,
"lable.opppdt.selPbk.subtitle":`의 가격 매뉴얼`,
"setup_mainpage_label_welcome19":`조작 안내: 페이지 좌측 메뉴를 클릭하여→ 설정 관리→ 사용자 관리→ 사용자, 역할, 프로필`,
"setup.mainpage.label.welcome22":`작업 매뉴얼: 본 페이지 좌측 메뉴를 클릭하여→ 관리설정→ 통신 템플릿→ 이메일 템플릿`,
"label.tianyancha.h5.zipcode":`우편번호`,
"label_tabpage_allapplications":`모두 응용프로그램`,
"label.chatter.like":`좋아요`,
"label.licence.noremainder":`허가증 잔여 수량 부족`,
"lable.outlook.edit.dataset":`데이터 설정`,
"D":`일자`,
"label.detail":`보기`,
"label.globaloperation.operationtype.custom_page":`사용자 설정 페이지`,
"label.addattachment.down":`파일 다운로드`,
"label.data.exportall.all_btn":`모두 데이터 내보내기`,
"label.recordtypeselect.current":`현재 기록 유형`,
"label.tabpage.entercusnamez":`고객명을 입력하세요`,
"label.location.valunit.km":`킬로미터`,
"label.mobile.phone.week.plan":`다음주 계획`,
"vue_label_report_everyday":`매일`,
"label.weixin.broadcasting":`전송 중...`,
"label.input.search.string":`검색한 문자열을 입력하세요`,
"label.picandreporttype":`차트 유형`,
"label.setmulti":`여러개를`,
"label.visualpage.component.t":`구성요소 component 사용`,
"label.knowledge.designate":``,
"label.enable.barcode.only":``,
"vue_label_commonobjects_detail_a_group_strategy":`해당 데이터에 소유인이 부재하여 채팅을 개설하지 못합니다.`,
"setup.layout.group.button":`버튼`,
"label.mini.layout.remark":`포그라운드 호버 윈도우에 보는 레이아웃에 응용합니다`,
"setup.mainpage.label.welcome3":`CloudCC 클라우드 플랫폼에서는 설정된 데이터 베이스(대상자)를 구축함으로써 보고서를 작성한다. 사용자가 설정한 대상자는 일부의 데이터 베이스의 차트이며 귀사 특유의 데이터를 저장하는 데에 사용된다. 프로그램 개발 없이 차트 간의 관계를 구축한다.`,
"label.knowledge.draft.status":``,
"label.manageAll.sel.one1":`승인 대기중인 프로젝트`,
"label.campagin.roi.bhydkhywjh":`고객 업무기회 획득수`,
"label_partner_template_thumbnail":`썸네일`,
"label.loginip.setup":`로그인 Ip 범위`,
"label.data.downpage.e.title.e.btn":`내보내기 폐이지로 이동하여 내보내기 시작`,
"vue_label_appstore_project_management":``,
"assetbom.delete.notpermission":``,
"vue.dashboard.setdrill.inThe":``,
"label.mobile.more.savephoto":`이미지 저장`,
"label.customerinfo.PageTriggerFag":`사용자 설정 클래스, 트리거, 사용자 설정 페이지를 동기화합니다.`,
"label.commonobjects.Nopermission":``,
"label.searchlayout.opperationtab.xsldfield":`업무기회 메뉴 밑의 세일즈 퍼널 링크를 클릭하여  보는 뷰 필드.`,
"label.emailsync.form.disconnect":`연동 취소`,
"label.document.nofile.upload":`업로드할 파일이 없습니다.`,
"label.appointmentpage.wizard.subtitle3-3":`전화번호`,
"message.custom.field.donotdelete":`필드가 사용되어 삭제할 수 없습니다`,
"chatter.using0":`여기까지 {0}ms 사용했습니다`,
"label.tabpage.multiple":`중복 선택`,
"label.attendance.setting.sy.alert":`출석 체크에 적용 인원을 선택해야 합니다!`,
"label.refuse":`거부`,
"label.log.button":`사용자명으로 검색하기`,
"component_chatter_link_label_title":`링크`,
"template.report.contract.collection":``,
"label.campaignmember.selectmember.step1":`1단계: 마케팅 행사와 마케팅 행사 멤버 상태를 선택합니다`,
"label.datamanage.warn.owner":`경고: 이 불러오기 작업을 계속하면 님을 기록 소유인으로 모든 기록을 불러옵니다.`,
"label.a.b":`A부터 B까지의 관계`,
"label.app.step3.homeisfrist":`홈페이지가 첫 순위여야 합니다`,
"UG_Lead_003":`SNS`,
"label.partner.workspace.member.choice":`프로필 선택`,
"lable.outlook.detail.emaping":`이벤트 필드 매핑`,
"label.service.appointmentList.gantt.chart.shows":``,
"label.mr.caption.account.result":`중복률 검사 및 병합 : 고객 중복데이터 조회결과입니다`,
"vue_label_chatter_approve_members_join":`그룹 가입을 동의합니다.`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`일`,
"pagecreator.systemstyle.label.modifycolor":`색깔 편집`,
"label.tabpage.yesz":`네`,
"label.fieldtoolongmessage":`필드가 한도를 초과했습니다`,
"lable.account.year.name":`회계 연도 명칭`,
"label.mini.layout":`호버 페이지 레이아웃`,
"label.icon.97":`교육`,
"vue_label_chat_smart_assistant":`스마트 비서`,
"label.marketingmanagementuser":`마케팅 사용자`,
"label_emailtocloudcc_description2":`기업 메일과 연동시킵니다`,
"label.campaign.channel.input.name":`1. 마케팅 채널 명칭을 입력하세요:`,
"UG.homepage.007":`메일 발송 팔로우업부터 마케팅 활동 자동화까지 우리의 Blueprint 과학기술을 통해 작업 흐름을 만들어 맞춤형 매크로까지 일상 임무를 자동화시켜 관계를 구축하는 데에 초점을 둔다.`,
"label.share":`공유`,
"label.step2.total6":`2단계, 총 6단계`,
"label.sendemail.chat.addComentspraise":`존경하는 #name:\n\n    안녕하세요！#userName이 님이 좋아하는 게시물에 댓글을 달았습니다.`,
"label.icon.20":`파일`,
"label.service.gantt.absenteeism":``,
"message.error.color.nagatice":``,
"chatter.group.applyToJoin":`가입 신청`,
"pagecreator_layout_message_delete":`선택한 레이아웃을 삭제하시겠습니까?`,
"label.multilang.viewlist.count":`총 {0}개 기록`,
"message.notdesable.type":`다음의 프로필이 해당 기록 유형을 기본값으로 설정하여 이 기록 유형을 금지 사용할 수 없습니다.`,
"label.standard.time":`표준 시간`,
"label_chatter_newpost":`최신 게시물`,
"front-epwechat-module-v1-binding":``,
"label.recent":`최근`,
"label.globaloperation.createfeeditem":`요약 항목 새로만들기`,
"label_partner_common_roleNum":`역할 수량`,
"front-template-V1-quikSearch":``,
"label_tabpage_haschangedz":`잠재고객 전환됨`,
"label.service.work.order.line":``,
"label.lead.score.ok":`네`,
"Account_News_Setting_003":`일반 설정`,
"label.event.moveup.15minutes":`15분을 앞당깁니다`,
"vue_label_all_selected_objects":`모든 선택한 대상`,
"label.visualpage.an.inline.style.relatedlist":`관련 리스트에 사용자 설정 페이지 유형을 삽입합니다`,
"label.umeng.approval.approvaling":`#applyer가 승인을 요청하고 있습니다#obj#objname#owner`,
"lable.SalesCommitmentKanBan.digital":`숫자`,
"label.appupload.img.max.size":`업로드할 이미지 크기가 한계를 초과하여 최대 크기는 20K 입니다. 다시 업로드하세요.`,
"vue_label_normal_top":`최상위로 설정`,
"label.knowledge.language.traditional":``,
"homepage.layout.edit":`홈페이지 레이아웃 편집`,
"label.campagin.qrcode":`마케팅 행사 QR 코드`,
"label.emailmerge.merge.emailmerge":`메일 병합`,
"label.icon.18":`시계`,
"vue_label_homepage_taskview":`업무 뷰`,
"label.search.related.record":`관련 기록을 찾을 수 없습니다.`,
"label.report.reports":`보고서`,
"label.appointment.wizard.subtitle4-3-2":`15분`,
"label.forecast.condition":`예측 조건`,
"label.westem.indonesia.time":`서인도네시아 시간`,
"front-epwechat-module-v1-callback-desc":``,
"label.version.group":`그룹 버전`,
"label.allReportType":`모든 사용자 설정 보고서 데이터 소스`,
"label.trigger.lastmodifydate":`지난 수정 시간`,
"message.layout.unique.sectionfield":`페이지 레이아웃에서 필드의 유일 규정을 위반하였습니다, 확인 후 다시 저장해 주세요!`,
"vue_label_systemSettings_mobelbottonsetting":``,
"label.recordtype.selectonefield":`신규 추가할 필드를 선택해 최소 한개 필드를 선택해야 합니다.`,
"label.notification.group1":`[신청자] 공용 그룹 가입을 신청하고 있습니다`,
"component_todaytask_label_title":`오늘의 업무`,
"label.assignment.setup.list.description":`분배 규칙을 사용해 기록이 자동으로 대응한 사용자에게 전송됩니다. 분배 규칙이 기록에 정의한 조건과 여러개 규칙 조항으로 이루어집니다.`,
"label.project.resource.data":``,
"label.emailmerge.newtemplate.file":`파일`,
"label.notification.task1":`[분배자]가 님에게 업무를 분배했습니다`,
"label.ServiceCloud.Overlapping":``,
"label.globalselect.used":`필드 사용 위치`,
"setup_layout_button_layoutprop":`레이아웃 속성`,
"label.quickbooks.retrivingdata":`데이터 확보중...`,
"component.button.ok":`확인`,
"message.pleaseinputformula":`공식을 입력하세요`,
"label.h5.whatifollow":`팔로잉`,
"label.new.crew.target":``,
"label_chatter_task":`업무`,
"label.knowledge.setting.data.four":``,
"label.rule.not.enabled":``,
"label_in_scope":``,
"label.partnerCloud.orderingPlatform.bundle":``,
"label.emailtocloudcc.redmessage10":`정보 기한이 지나 다시 로그인하시오`,
"label.knowledgebase.data.assignment.succeeded":``,
"vue_label_commonobjects_view_nokanban":`생성된 간판 뷰가 없습니다.`,
"label.knowledgebase.article.cancelled.attaching.case":``,
"label.brief":`브리핑`,
"label.version.sum.app":`개 응용프로그램`,
"label.commoninfo":`일반 정보`,
"vue_label_SMS_nodata":`데이터가 없음`,
"label.icon.153":`메시지`,
"label.conditiontag.lookup.false":`거짓`,
"label.emailobject.view.unread":`모두 읽지 않음`,
"label.staticresource.useful":`어디에다 사용하시겠습니까?`,
"label.ems.connect.test":`검사`,
"vue_label_chat_group_assistant_notification":`단체방 비서 알림`,
"label.multipleactivity.total":`합계`,
"vue_label_report_addtocomponentlibrary":`구성 요소 베이스에 추가`,
"font-evaluate-module-v1-following-personnel":``,
"label.setup.mobile.bottombutton.change.fail":``,
"front-epwechat-module-v1-unbound-item5":``,
"label.customerinfo.smsUid":`문자 메시지 게이트웨이 UID`,
"label.list.isOpenApprovalQueue":``,
"label.leadscore.setup.scorenumber":`번`,
"label.workflow.selectobj.introduce":`해당 업무 프로세스 규칙의 응용 대상을 선택합니다`,
"label.visualpage.label.for.example":`페이지 라벨 예:`,
"label.appointmentdetail.wizard.title17":`목요일 시간 계획`,
"label.projectManagement.timeFrame":``,
"lable.product.pricebooks.list":`가격매뉴얼은 특별히 정의된 단가와 화폐 종류가 있는 제품 리스트입니다. 가격매뉴얼은 다화폐 종류를 대상으로 설정할 수 있습니다. 제품 조직을 가격매뉴얼에 넣을 때 업무 기회나 견적은 개별 가격매뉴얼의 제품만 포함할 수 있습니다. 가격매뉴얼에 있는 제품을 편집하려면 가격매뉴얼 이름을 클릭하십시오.`,
"font-trade-module-v1-delete-invoice":``,
"vue_label_salesadvance_winamount":``,
"component.salesperformance.label.nopermission":`시스템 관리자에게 연락하여 업무 기회 관련 데이터를 확인하세요.`,
"vue_label_report_formatreport_desc":`보고서를 내보낸다. 보고서 헤더, 그룹분류 및 선별 설정이 포함된다.`,
"label.enable.qrcode.only":``,
"label.smstemplate.edit":`메시지 템플릿 편집`,
"label.qrcodeSetting.detailed.information":``,
"label.event.moveup.1week":`1주일을 앞당깁니다`,
"label.customize.memory.function.sorting.disable":``,
"label.icon.195":`욕조`,
"label.compact.layout.assign":`중요 정보 레이아웃 분배`,
"label.icon.183":`주택`,
"front-kefu-moudle-v1-jchxzxzi-chat":``,
"label.mycontact":``,
"label.tabularreport.2018.step3":`3단계: 보고서 기준을 선택합니다`,
"chatter.group.uploadGroupPicture":`그룹 프로필 사진 업로드`,
"label.total.forecast.setup":`우선 예측하고 설정하기`,
"label.weixin.group.description":`비고`,
"label.edit_emailfooter":``,
"label.ems.create":`새로 만들기`,
"label.weixin.optionseven":`선택 항목7`,
"font-evaluate-module-v1-continue-work":``,
"label.close.multilingual":``,
"component.chatter.post.button.user":`인원 추가`,
"label.use_QRcode":``,
"label.operatedata.exportsuc":`내보내기 성공. 메일을 로그인하여 파일 내보내기 다운로드 주소를 확인합니다. 내보낸 파일이 48시간 동안 저장되며 최대한 빨리 다운로드하세요. 링크 주소를 잘 보호하여 다운로드 후 시스템에서 전송한 메일을 삭제하세요.`,
"label.page.step2.define.content":`2단계: 내용과 보기 속성을 정의합니다`,
"label_tabpage_groupingitem":`그룹 프로젝트`,
"label.customfields.placeholder":`예시 기입`,
"vue_label_commonobjects_detail_enter_subject":``,
"label.multilang.workflow.everyotherdayinmonth":`매{0}월 {1}일`,
"label.knowledgebase.data.archiving.failed":``,
"vue_label_notice_nopermission_view":`죄송합니다. 해당 데이터에 대해 확인 권한이 없으며 시스템 관리자에게 연락하세요.`,
"vue_label_calendar_calendar_view":`캘린더 뷰`,
"lable.outlook.edit.des":`만약 어느 Exchange 연락담당자가 여러 CloudCC.com 연락담당자와 매칭하면, 다음 조건에 맞는 CloudCC.com 연락담당자와 동기화합니다.`,
"label.custom.NextCQ":`다음 사용자 설정 분기`,
"label.emailsync.form.stutas":`작동 상태`,
"label.nameandintro":`명칭과 설명`,
"label.dashboardSetup.showdw":`표시 단위`,
"label.tianyancha.actualcapital":`실제납입자본금`,
"front-kefu-moudle-info-delete-calluser":``,
"label.emailobject.list.all":`모두 선택`,
"label.campaign.channel.step7.send":`메일 전송 인원을 선택합니다`,
"label.formulafield.type":`공식 반환 유형`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`목요일`,
"label.chosesubject.eat":`식사 자리 마련하기`,
"label.back":`뒤로가기`,
"label.h5.allcompany":`모든 클라우드 게시물`,
"label.location.display.type.digital":`숫자`,
"label.datamanage.error.csv":`잘못된 파일 형식입니다. 시스템은 일반적인 CSV 형식만 지원합니다. 다시 조작하십시오.`,
"label.emailobject.mark":`표시`,
"setup_mainpage_label_welcome9":`사용자가 코드 개발 필요없이 드래그 앤드 드롭 방식으로 페이지 요소 배열, 레이아웃 조절을 할 수 있습니다. 페이지에 필드의 읽기 전용 및 필수 기입 등 속성을 설정할 수 있습니다.`,
"label.icon.56":`측정기`,
"label.forecast.edit.fwcd":`범위 길이`,
"vue_label_email_Please_select_related_items_first":`관련 항목을 선택하세요`,
"label.icon.87":`책`,
"label.knowledgebase.recovery.was.successful":``,
"label.emailobject.emaildetail.promptcontent":`메일을 삭제하시겠습니까? 삭제 후 철회 불가능합니다`,
"label.delete.role":`역할 삭제`,
"label.multiselect":`중복 선택 가능한 선택항목 리스트`,
"label.customerinfo.mailisnull":`회사 메일을 설정하지 않았습니다`,
"label.waitforamoment":`페이지를 불러오는 중, 기다려 주십시오...`,
"lable.edit.queue.tip":`알림을 보낼 때(예를 들어 개별안을 이미 대열에 넣었을 때) 사용할 대열 이름과 이메일 주소를 입력하며 이메일 주소는 기입하지 않으면 알림이 없습니다.'멤버에게 메일 보내기'를 선택하면, 대열로 대상을 분배할 때 멤버에게 통지하고, 선택하지 않으면 알림이 없습니다.`,
"lable.custom.y.d":`이 페이지에서 사용자 설정 연도 기록을 만들 수 있습니다. 사용자 설정 연도의 일자가 다음의 선택으로 생성됩니다.`,
"chatter.feed.content.user.searchbutton":`검색`,
"label.data.downpage.i.list.desc3":`사용자가 다운로드한 후 파일의 마지막 열에서 불러오기 실패하는 구체적인 원인을 확인할 수 있다.`,
"label.tag.manage.createdby":`최초작성자`,
"label.h5.similar.opportunity.last.months3":`최근 3개월`,
"chatter.group.members":`명 멤버`,
"label.knowledgebase.data.translation.failed":``,
"label.log.look":`고객 경로 감사 설정 보기`,
"label.service.gantt.week.timescale":``,
"label.userLicence":`사용자 허가증`,
"label.file.library.managemembers.permission":`방문 권한`,
"label_emailtocloudcc_name":`명칭`,
"label.mr.mrSuccess":`병합 성공`,
"vue_label_commonobject_view_notice_selectadd":`추가하고 싶은 데이터를 선택하세요`,
"vue_label_commonobjects_detail_level":`등급`,
"CloudCCCRM_ST_Info_TypeIn_001":`입력하세요`,
"label_chatter_list":`리스트`,
"label_tabpage_optionsz":`선택 항목`,
"UG_homepage_008":`현재 업무 상태(세일즈 브리핑, 랭킹, 세일즈 퍼널 등)를 파악하여 문제가 있을 수 있는 업무기회를 확인하며 향후 실적 달성 상황을 예측하고 중요사항을 제때 처리하고 분배하며 현명한 결정을 내립니다.`,
"label.myselfdashboard":`나의 개인 대시보드`,
"label.globaloperation.operationtype.record_phone":`기록 전화`,
"label.field.standard":`표준 필드`,
"label.changemydisplay.appedit.check":`사용자의 개인 설정 응용프로그램 설정을 커버합니다`,
"label.tianyancha.h5.legalpersonnames":`법인 대표`,
"label.tabpage.sorttypez":`순서 배열 유형`,
"label.newdashboard.folder":`대시보드 폴더 새로만들기`,
"label.campaign.channel.step6":`6단계: 마케팅 채널 등록 페이지 생성합니다`,
"label.ems.composeemail":`메일 전송`,
"label.app.step4.tabcanuse":`사용 가능한 메뉴`,
"label.sendmail.batch":`메일 단체 전송`,
"label.process.execute.title":`승인중입니다`,
"lable.outlook.detail.lastup":`최후 업데이트`,
"label_emailtocloudcc_delete":`삭제`,
"lable.opppdt.selPdt.leastone":`최소 한 개를 선택하세요`,
"label.customfields.new.step2.opration.exid":`외부ID`,
"label.assignment.setup.newrule.description":`규칙 명칭을 입력한 다음 사용 가능 "체크 상자를 선택하십시오. 이 규칙은 자동 분배에 적용됩니다.이 규칙을 사용하면 현재의 분배 규칙을 사용하지 않습니다."`,
"label.campaign.channel.input.to.isactivity":`7. 마케팅 채널 사용 여부`,
"label.document.return":`파일 페이지로 반환하기`,
"label.data.downpage.i_title.num5":`5. 데이터의 정확성을 검토해 주십시오.`,
"label.taskinto":`사용자에게 자동으로 업무를 분배할 때, 업무는 업무 프로세스 규칙에 사용되는 템플릿입니다.`,
"label.customfields.formula.textexample":`Full Name（풀 네임）= LastName &amp; ", " &amp; FirstName`,
"label.appointmentpage.wizard.subtitle1-1":`다음주`,
"label.weixin.radio":`택일형`,
"vue_label_file_replace_reason_check":`교체 이유(선택 기입)`,
"label.sendemail.recycle.operateexception":`휴지통 비우기에 이상이 발생해 다시 시도하세요!`,
"label.vlidaterule.formulaerror":`'할인'이 30%를 넘으면 오류로 나타납니다.`,
"vue_label_campaign_existing_member_status":`현재 멤버 상태 유지`,
"label.service.miniProgram.fillSlideshowName":``,
"label_partner_workspace_login_headerfooter":`머리글과 마닥글`,
"label.quickbooks.viewlist.total2":`합계 {0}개 추산 항목, 총 {1} 입니다`,
"chatter.viewingResults":`결과 보기`,
"label_tabpage_allvisible":`모든 사용자 볼 수 있음`,
"label.quote":`견적서`,
"label.changemydisplay.list.des":`필요에 따라 메뉴를 배치합니다`,
"label.leadscore.notimes":`채점 횟수가 상한에 도달했습니다`,
"label.icon.51":`발전`,
"component.assistant.label.title":`비서`,
"label.emailobject.emailsent":`메일 전송 성공!`,
"label.group.nofile":`해당 그룹에 전송하는 파일이 없습니다`,
"label.foldervisitlimit2":`모든 사용자가 이 폴더를 볼 수 없습니다`,
"label.dataoperate":`데이터 조작`,
"label.addattachment.size":`크기`,
"label.not.double":`중복값이 허용되지 않습니다`,
"label.customfields.formula.number.tip":`숫자값을 계산합니다`,
"lable.opppdt.addpdt.table.description":`행 내용`,
"label.sms.isactivity":`사용 여부`,
"label.campaign.channel.input.owner":`4. 이 마케팅 채널로 등록된 잠재고객의 소유인은:`,
"label.visualpage.notfound.error":`에러가 발생했으며 관리자에게 연락하세요`,
"label.mr.title.button.group3":`개 기록`,
"label_tabpage_beginz":`시작`,
"label_tabpage_queue":`대열`,
"label.tabpage.advancedscreening":`고급 선별 조건`,
"nogreate":`적거나 같다`,
"chatter.fields":`의 필드`,
"button_partner_workspace_manage":`관리`,
"label.partnerCloud.orderingPlatform.search":``,
"message.password.isnull":`비밀번호가 비어 있을 수 없습니다!`,
"label.fenbeitong.title":`FENBEITONG 설정`,
"label.salescloud.contactrole.message.chooseatleastone":`최소 한명 연락담당자를 선택하세요`,
"label.knowledge.delete.election":``,
"front-console-status-hoided":``,
"label.lastmodifydate":`최후 수정 시간`,
"vue_label_chat_deleting_chat":`삭제 후 채팅 기록이 삭제되어 채팅 리스트에서 제거됩니다. 새 메시지가 도착할 때 다시 채팅 리스트에서 나타납니다.`,
"label.timeframe":`시간 프레임`,
"UG.opportunity.002":`판매 주기 설정, 단계 배정`,
"label.templates.merge":``,
"label.generatepage.c2":`최대 길이는 30입니다`,
"label.appointment.wizard.subtitle4-1-6":`2시간`,
"label.passwordPolicy.setup.pwdremember3":`3개 비밀번호 기억하기`,
"button.partner.workspace.enable":`파트너 클라우드 사용`,
"vue_label_pool_nopool_notice":`고객풀에 가입되지 않아 관리자에게 연락하여 고객풀을 생성하거나 가입하세요.`,
"label.layout.required.field.select":`필수 입력 필드를 선택했습니다`,
"label.loginhis.date":`시작시간과 종료시간을 입력하세요`,
"vue_label_commonobjects_detail_and_overdue":`곧 다가올 것과 이미 지나간 것`,
"label_tabpage_advancedsearch":`고급 검색`,
"label.custom.field.login.home.query":`시스템 홈페이지로 들어가 업무 상세 정보를 보십시오!`,
"page":`페이지`,
"label_tabpage_onlymevisible":`내게만 보이기`,
"label.weixin.optionfour":`선택 항목4`,
"label.confirm.to.remove":``,
"label.event.moveup.30minutes":`30분을 앞당깁니다`,
"label.mail.merge.template.finish":`메일 병합 템플릿이 완성되었습니다`,
"label.multilang.currencylist.before":`{0} 이전`,
"label.goback":`전 단계로 돌아가기`,
"label.unknown.prefix":`미지의 앞자리이며 정확한 앞자리를 입력하세요`,
"lable.account.CurrentandPreviousCYt":`현재와 지난 2개 캘린더 연도`,
"label.product.dent":`키워드와 필터링 조건을 입력하고 검색을 누르면 검색을 시작합니다.더 많은 필터를 눌러 "하나 이상의 필터를 사용합니다.검색 결과에는 입력한 키워드와 선별 조건에 맞는 모든 기록이 포함됩니다."`,
"label.ems.bcc":`숨은 참조 추가`,
"label.import.index.operation":`작업`,
"label.knowledge.setting.hint.eight":``,
"label.sso.saml.sp.idtype.fid":`성명에 사용자 대상에서 온 연맹 ID가 포함됩니다`,
"vue_label_chat_voice":``,
"label.config.pw":``,
"lable.newtabpage.closesearchresult":``,
"lable.account.NextWeek":`다음주`,
"label.ems.username":`사용자명（U）`,
"vue_label_email_emails_from_potential":`CRM의 잠재 고객과 연락담당자가 전송한 메일 및 수신자에서 그들이 포함된 메일이 여기서 보관됩니다.`,
"lable.approval.shared":`승인 공유`,
"label.tabpage.allz":`모두`,
"label.file.uploadfiles":`파일 업로드`,
"label.emailobject.text":`명칭`,
"label.version.allow.create":`생성 허용`,
"label.empty.field":``,
"label.emailsync.status.department":`부서`,
"label.pw.str":``,
"label.attendance":`출석 체크`,
"label_mobile_buttom_team":`채팅`,
"label.campaignmember.main.addcontactdesc":`한번에 현재 모든 연락담당자를 이 마케팅 행사에 추가합니다`,
"label.search.result":`검색 결과`,
"label.weixin.activity.account":`행사의 손님`,
"label_tabpage_clearoptionsz":`고급 선택항목 비우기`,
"UG.activity.01":`고객/그룹과의 교류를 어떻게 팔로우업하고 기록하시겠습니까?`,
"serviceappointment.new.status.limit":``,
"label.notice.higher":`상급 통지 여부`,
"label.passwordPolicy.setup.gletters":`개 문자`,
"label.data.exportsf.des":`내보내기 성공한 파일이 서버에 48시간 저장되어 48시간 후 자동 삭제됩니다.`,
"label.view.onlymecansee":`<b>나</b>만 보기`,
"UG.Lead.005":`메일`,
"label.umeng.approval.approvalfail":`제출 실패`,
"label.huanxinconfig.clientid.lost":``,
"label.campaignmember.main.updatecontactstatus":`상태 업데이트- 기존 연락담당자`,
"component_chatter_button_delete":`삭제`,
"label.weixin.no.pending.projects.qin":`현재 승인할 프로젝트가 없습니다`,
"front-electronic-signature-auto-fill-field":``,
"message.resetpw":`비밀번호를 다시 설정하시겠습니까?`,
"label.service.ganttBaiduMap.service.resourname":``,
"vue_label_pricebook_deleted":`가격 매뉴얼이 삭제됨`,
"label.icon.193":`욕조`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`도시`,
"label.pc.ui.2018.searchs":`검색 내용을 입력하세요`,
"label.yard":`초대번호`,
"label.data.downpage.i_title.btn":`불러오기 페이지로 이동해 불러오기 시작합니다`,
"label.useablereceivers":`사용 가능한 수령인`,
"label.cloudccsite.name.length":`웹사이트 명칭이 255개 문자를 초과할 수 없습니다`,
"label.secrecy":`기밀`,
"label.campagin.roi.ydkhywjhzz":`고객 업무기회 획득값`,
"vue_label_report_conditiondesc_one":`구독 외에 본 보고서에 조건을 설정할 수 있다. 조건에 부합할 때 알림 통지된다. 선택 가능함.`,
"label.datamanage.select.contactfield":`(연락담당자를 불러오기에 대응한 필드를 선택하십시오)`,
"label.emailtocloudcc.filed.action":`작업`,
"label.smstemplate.new":`메시지 템플릿 새로 만들기`,
"label.mobile.side.tab.app":`응용프로그램`,
"label.icon.118":`시계`,
"label.customfields.selectcontainfieldlayout.tip":`이 필드는 마지막 필드로 이 페이지 레이아웃 앞의 두개 열에 추가됩니다.레이아웃을 선택하지 않으면 이 필드는 어떤 페이지에도 표시되지 않습니다.`,
"Lead_Homepage_Tools_BatchScoring":`모두 채점`,
"lable.quote.syncing.quote":`견적서`,
"pagecreator.button.preview":`미리 보기`,
"label.ccchat.am":`오전`,
"chatter.feed.menutype.user.nullrecent":`최근 기록 없음`,
"lable.info.queue.showallmember":`대열 멤버 보기`,
"label.multilang.campaign.selelctmember.desc":`뷰를 선택한 후, 마케팅 행사에 추가하기 위해 멤버를 선택하십시오. 멤버 상태는 {0}입니다.`,
"label.notification.ccchat3":`님의 게시물에 1개 새 댓글이 있습니다.`,
"UG.product.03":`다종 화폐 가격 매뉴얼`,
"label.sso.saml.idp.config.pksize":`비밀키 크기`,
"label.defineCustomReportType":`사용자 설정 보고서 데이터 소스를 정의합니다`,
"component.timeline.button.filter":`선별`,
"label.mr.nextGroup":`이 그룹을 뛰어넘어 다음 그룹으로 이동`,
"label.quote.sprdz":`수취인 주소`,
"label.total.refuse.forecast.have.priority":`모든 예상 우선 순위 거부`,
"lable.product.peep":`유효 가격을 입력해 주십시오`,
"label.file.who.can.access":`방문 가능 인원`,
"label.page.last":`마지막 페이지`,
"label.icon.180":`사람`,
"font-evaluate-module-v1-enabled-successfully":``,
"label.appointment.wizard.subtitle4-2-2":`2시간`,
"label.passwordPolicy.setup.oneyear":`1년`,
"label.login.bound.mfadevice.title":`가상 MFA 장치 사용합니다`,
"vue_label_dashboard_statisticalvalue":`통계치를 선택하세요.`,
"label.ishistory":`의 이력`,
"component.timeline.label.title":`시간축`,
"label.page.step3.of.step5":`3단계, 총 5단계`,
"label.assignment.setup.detail.section":`규칙 상세 정보`,
"label.salescloud.opportunity.nothave.main.contactrole":`주요 연락담당자 없음`,
"label.import.page1.limitedcsv":`올리는 파일은 csv로만 가능함!`,
"label.icon.187":`망치`,
"label.emailobject.wizard.desc5":`서명을 맞춤 디자인하여 메일이 더 세련해 보일 겁니다.`,
"vue_label_report_notice_copy_success":`보고서 복사 성공!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`중복 검사 규칙을 선택하지 않았습니다.`,
"label.componentEditor.upper.limit":``,
"label.validate.function.funcExplain.ISNEW":`기록이 신기록인지를 검사합니다. 신기록인 경우 TRUE로 돌아가며 아닌 경우 FALSE로 돌아갑니다.`,
"label.postalCode":`우편번호`,
"label.dashboard.snapshot.enable.flag":`대시보드 스냅숏 사용`,
"vue_label_file_upload_type_size":`{fileType}파일만 업로드 가능하며 크기는 {size}Mb를 초과하면 안됩니다`,
"label.appointment.wizard.subtitle3-6":`토요일`,
"homepage.narrow":`좁은 메뉴(좌측 메뉴)`,
"chatter.addmute.confirm":`이 게시물에 방해 금지를 설정하시겠습니까?`,
"label.lookup.account":`고객 찾기`,
"message.lostthemanager":`이번 제출이 사용자의 책임자 승인이 필요하며 이 값이 비어 있습니다. 상세 정보에 관해 관리자에게 연락하세요.`,
"label.exchange.sync.state.contact.m3":`최후 24시간에 동기화된 기록:`,
"label.version.phone.app":`핸드폰 앱 버전`,
"label_tabpage_search":`검색`,
"vue_label_helpcenter_campaign":`상세 정보 페이지에서 마케팅 행서 옆의 계통수 버튼을 눌러 마케팅 행사의 구조도를 확인할 수 있어 마케팅 행사의 등급 관계를 파악한다. <br>마케팅 행사 멤버 관련 리스트를 통해 마케팅 행사에서 관련된 연락담당자나 잠재 고객을 관리한다.`,
"front-lightning-module-v1-dashborad-last-year":``,
"label.campaign.channel.value":`값`,
"vue_label_opportunity_contactrole_primarycontact_notice":`메인 연락담당자를 지정하시려면 저장한 후 '관리'에서 선택하세요.`,
"label.biaoqingfaxian.title":`입찰 및 낙찰 정보 발견`,
"label.approved":`승인 완료`,
"label.hong.kong.time":`홍콩 시간`,
"label.customfields.file.cannotopen":`해당 파일이 열릴 수 없습니다`,
"lable.New.tips":``,
"component.setup.tabs.label.add":`새로 만들기`,
"label.forecast.forehistory.replacebest":`수준 이상 실력 발휘가 대체되었습니다`,
"front-kefu-moudle-v1-jctrrt-call-serve":``,
"label.workflow.configrule":`2단계: 업무 프로세스 규칙을 배치합니다`,
"label.dashboard.snapshot.refresh.frequently":`대시보드 스냅숏 새로고침이 너무 잦으니, 잠시 후에 다시 시도해 주십시오`,
"label.ems.editsetting":`메일 설정 편집`,
"message.confirmdeleteAPP":`이 응용프로그램을 삭제하겠습니다.`,
"label_chatter_activity":`행사`,
"label.editsharerules":`공유 권한 편집`,
"label.loginservice.license.notuse.must":`허가증을 사용할 수 없습니다.`,
"label.import.step2.beforeexport":``,
"label.chat.mute":`방해 금지`,
"label.icon.128":`주택`,
"label.give":`&&및`,
"label.hide":``,
"label.relationobject.wpr":`파견인`,
"label.summation":`총계`,
"label.layout.availabletab.details":`상세 정보`,
"label.circle":`코일형`,
"vue_label_opportunity_contactrole_add":`연락담당자 역할 추가`,
"label.file.library.file2libsuccess":`파일을 해당 문서 라이브러리에 추가했습니다!`,
"label.weixin.report.reportgenerated":`보고서 생성됨`,
"label.icon.91":`사람`,
"report.label.pleaseinput":`검색 내용을 입력하세요`,
"label.escalation.setup.newaction.otheremail.tip":`최대 5개 전송할 메일을 입력할 수 있습니다. 주소 간에 쉼표로 간격을 줍니다.`,
"label.area.donot.have.data":`데이터 없음`,
"label.customcomponent.btn.reference":`구성요소 인용`,
"label.appointmentdetail.wizard.title7":``,
"label.ccchat.with":`보유`,
"label.file.size":`크기`,
"label.product.sort.beyond":``,
"label.ccchat.2018":`실시간`,
"label.report.select.column":`열 선택`,
"label.appointmentpage.wizard.subtitle1_1":`일자와 구체적인 시간을 선택하세요`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`알파벳 대소문자, 숫자와 부호가 포함되어야 합니다`,
"label_chatter_addressee":`수신인`,
"label.profile.remark2":`귀조직이 기록 유형을 사용하려면 다음의 '기록 유형 설정'의 '편집'링크를 사용해 해당 프로필의 사용자가 한개나 여러개 기록 유형을 사용할 수 있습니다.`,
"UG_Account_01":`고객이 누구십니까?`,
"label.dataimport.error.contact.notnull":`오류 발생: 연락담당자 이름이 비어 있을 수 없습니다.`,
"lable.account.CalenderQuarter":`캘린더 분기`,
"vue_label_commonobjects_detail_empty":`판매 가격은 필수입력 항목입니다.`,
"label.approveassigntemplate":`메일 템플릿 분배 승인`,
"label.objectRelationshipDescription1":`이 보고서 데이터 소스가 관련 생성될 것입니다`,
"vue_label_email_insertmergefield":`병합 필드 삽입하기`,
"label.mobile.home.page.check.team":`팀 보기`,
"lable.edit.queue.edit":`대열 편집`,
"label.campagin.roi.query":`마케팅 행사 ROI 조회`,
"label.dataimport.field.allow.access.to":`데이터 필드에 접근할 수 없습니다. 수동으로 대응한 기록을 삭제한 후 다시 시도하십시오.`,
"pagecreator.systemstyle.message.canntdelete":`현재 양식에 삭제가 불가능합니다`,
"label.searchkey":`키워드를 입력하세요`,
"chatter.showall":`모두 보기`,
"show":`보기`,
"label.quote.choseproduct":`제품 선택`,
"label.report.selected.field":`선택한 필드`,
"label.globaloperation.operationtype.create_data":`기록 생성`,
"label.knowledge.setting.data.seven":``,
"chatter.email.mentionOrMessage":`혹은 메시지 제출`,
"label_tabpage_exclusivez":`불포함`,
"chatter.en.userinfo":`님에 대한 정보를 입력하십시오`,
"label.log.orgid":`기구`,
"label.dataimport.insertdata.error.fieldrepeat.update":`이 기록의 $schemefield_name$필드를 데이터베이스에서 찾을 수 없어 업데이트를 할 수 없습니다. 해당 기록을 불러오는 것을 무시했습니다.`,
"vue_label_chatter_add_link_success":`링크 추가 성공`,
"label.sender_details":``,
"label.ccpeak.addwhere.condition":`where 조건 추가 가능`,
"label.datamove.total":`총`,
"label.tianyancha.businessverify.warning":`주의: 이 인증은 중국 대륙 지역에서 등록한 공상 기업 데이터만 지원됩니다.`,
"label.emailmainbody":`메일 본문`,
"label.justadmin":`관리자만 가능`,
"label.data.downpage.e.list.desc1":`본 페이지에서 볼 수 있는 데이터는 성공적으로 내보낸 파일이며 메일의 정보대로 내보낸 파일을 다운로드하세요.`,
"label.reportsSubscriptionPage.email.value":`가용값`,
"message.error.serviceappointment":``,
"label.textMessageObject.selectone":`문자의 수신자로 최소 1개 기록을 선택하세요`,
"label.schedulejob.setup.schedule.plan":`계획`,
"label.assignment.layout.field.isassigned":`유효한 분배 규칙을 이용하여 분배합니다`,
"label.captcha.error":``,
"mobel_web_not_more_data":``,
"label.emailsync.form.emailaddress":`메일 주소`,
"label.loginservice.error":`로그인 오류가 발생하여 관리자에게 연락하세요`,
"label.integrations.description":`CloudCC 계정을 기업 소프트웨어 생태 시스템의 다른 응용 프로스램과 연결시킵니다`,
"vue_label_homepage_notice_selectone":`최소 한 명의 잠재 고객이나 연락담당자를 선택하세요`,
"label.chatter.default":`기본값`,
"label.tabpage.datefield":`일자 필드가 '어제''오늘''내일''지난달''이번달'다음달''지난주''이번주''다음주'나 'YYYY-MM-DD, MM/DD/YYYY'양식을 사용할 수 있다.`,
"front-kefu-moudle-myzdhsc-file":``,
"label.createname":``,
"label.mobile.phone.enter.plan":`계획을 입력하세요`,
"report.label.highlevelreport":`고급 보고서는 최대한 4개 대상자 관련 보고서를 생성할 수 있다`,
"label.edit.select.label":`편집 방식`,
"label.partnerCloud.financeSetting.deduction":``,
"message.duplication.label.updateoption":`업데이트 시 조작`,
"label.custom.CurrentCQ":`현재 사용자 설정 분기`,
"front-kefu-moudle-wait":``,
"sunday":`일요일`,
"label.service.timezone":``,
"setup.layout.label.selectfield":`필드 선택`,
"label_emailtocloudcc_filed_action":`조작`,
"label.forecast.customforecast.mycommit":`나의 승낙액`,
"label.uploadsuc":`업로드 성공`,
"vue_label_commonobjects_view_notice_atleast1field":`최소 1개 필드를 선택하세요`,
"label.dataimport.khmc.length":`에러 발생: 고객 명칭 길이가 한계를 초과했습니다.`,
"label.isemailnotification":`메일 알림 여부`,
"label.addAPPexchange":`AppExchange응용프로그램 추가...`,
"label.partnerCloud.orderingPlatform.currency":``,
"UG_quota_02":`견적이 고객와 공급업체 간 지정된 시간에 지정된 가격으로 지정된 상품을 거래를 실시하는 법적 조항입니다.`,
"label.customer.tab.step2.same.option3":`메뉴 숨기기`,
"H":`전화`,
"label_tabpage_searchz":`검색`,
"vue_label_homepage_deleted":`삭제됨`,
"label.weixin.recent.view":`최근 뷰 보기`,
"template.report.opportunity.sales":``,
"label.customfields.new.step2.opration.unique.info.v1":`"ABC"와 "abc"가 중복값으로 간주합니다(대소문자 구분없음)`,
"savesuccess":`저장 성공`,
"label.partner.workspace.member.memo":`선정한 프로필, 권한 세트의 모든 사용자가 이 파트너 클라우드를 방문할 수 있습니다.`,
"label.icon.23":`의약품`,
"lable.batchadd.service.cfq.before":`트리거(Before Insert)`,
"label.instrumentPanel.breakpointTwoLabelname":``,
"message.selectgsummaryinformation":`통합 정보를 선택해 주세요`,
"label.tianyancha.businessverify.msg6":`본 기능은 제3자 서비스를 이용하는데 고병행 사용으로 인한 성능이 안정적이지 못해 서비스가 불가능한 경우가 있을 수 있으며, CloudCC는 이에 대해 어떠한 연대책임도 지지 않습니다.`,
"vue_label_helpcenter_report3":`3.A.필드 검색창 클릭하여 필드를 검색한 후 선택하거나 필드 리스트를 당긴 후 원하는 필드를 선택한다. 필드의 조작 부호를 선택해 값을 선택하거나 입력한다. 응용 프로그램을 클릭한 후 필드 필러가 발효된다. <br>&nbsp;&nbsp;&nbsp;&nbsp;B.필드 검색창 위의 ' ' 를 클릭한다. '조건 입력창 선택'에 숫자와 알파벳으로 조합된 고급 선택 조건을 입력한다. 예를 들어 （1 and 2）or3。<br>•편집 필러 <br>&nbsp;&nbsp;&nbsp;&nbsp;편집 필러 확인, 표준 필로 포함,필러를 클릭하면 된다. <br>•필러 삭제<br>&nbsp;&nbsp;&nbsp;&nbsp; 필러 위의 '×'를 클릭하면 필러가 삭제된다. <br>•운영 보고서<br>&nbsp;&nbsp;&nbsp;&nbsp; 편집 페이지 우상쪽의 '운용'버튼을 클릭하면 완전된 보고서 보고를 확인 가능하다. <br>•보고서가 '나의 개인 명의로 보고서 파일'과 '미 보관 공용 보고서 파일'로 자동 저장된다. <br>&nbsp;&nbsp;&nbsp;&nbsp; 1단계: 보고서 선택 카드에서 새 보고서 파일을 만든다. <br>&nbsp;&nbsp;&nbsp;&nbsp;2단계: 나오는 보고서 파일 새로 만들기 페이지에서 미보관 공용 파일 중의 보고서를 이 서류 파일로 이동할 수 있다. 선정된 유저가 이 파일의 방문 권한을 선택 가능하다. <br>3、보고서 확인<br>&nbsp;&nbsp;&nbsp;&nbsp;:1단계: 보고서 선택 카드에서 보고서 리스트 페이지로 이동해 '최근 확인' '나의 새로 만들기' '모든 보고서'나 보고서 파일에서 선택하여 원하는 보고서를 확인 가능하다.  <br>&nbsp;&nbsp;&nbsp;&nbsp; 2단계: 보고서 명칭을 클릭하여 보고서를 확인한다. 보고서 우측 ' 풀 다운 버튼'을 눌러 '운용'을 선택해 보고서를 확인 가능하다. <br>&nbsp;&nbsp;&nbsp;&nbsp; 관리자의 프로필이면 보고서 선택 카드에서 보고서 리스트 페이지로 이동해 '파일 새로 만들기' 버튼의 옆의 '기어'아이콘을 클릭하면 모든 파일의 보고서 리스트의 시작 부분의 필드를 선택할 수 있다.<br>4、보고서 내보내기 <br>&nbsp;&nbsp;&nbsp;&nbsp;1단계:보고서 선택 카드에서 보고서 리스트 폐이지로 이동해 원하는 보고서를 찾아 보고서 우측 '풀 다운 버튼'을 클릭한다. <br>&nbsp;&nbsp;&nbsp;&nbsp;2단계:유형 선택<br>&nbsp;&nbsp;&nbsp;&nbsp; 포맷 보고서: 보고서 시작 부분, 팀 나누기, 자세 정보 선택하기. <br>&nbsp;&nbsp;&nbsp;&nbsp;자세 정보 보고서에만 국한된다. 미 포맷 자세 정보.  <br>&nbsp;&nbsp;&nbsp;&nbsp;3단계:'내보내기'보튼을 클릭한다. 자세 정보 보고서에 국한된 보고서는 페이지별로 내보내야 하여 폐이지마다 데이터 2000개 내보낼 수 있다.`,
"label.batchdelete.success":``,
"label.newprocess5.seq":`순서`,
"label.knowledgebase.data.translated.successfully":``,
"label_enable_range":``,
"label.ccchat.and":`및`,
"label.assignment.setup.list.norule":`분배 규칙이 없음`,
"vue_label_report_summaryformulacolumn":`합계 공식열`,
"label.field.edit.change1":`최대 평점이 100을 초과할 수 없습니다`,
"syntaxerror":`문법이 틀렸습니다. 입력한 조건을 확인하십시오`,
"label.icon.116":`주택`,
"lable.asset.BOM.according.to.product":``,
"chatter.like.post":`이 게시물을 좋아하는 사용자`,
"label.trigger.page":`트리거 페이지`,
"vue_label_email_contact_adminstrator":``,
"label.workreport":`업무 보고`,
"vue_label_homepage_edit_card_view":`카드 뷰 편집`,
"label_emailsync_status_disabel":`금지 사용`,
"label.icon.54":`굴착기`,
"message.error.view.validerr.common":`인증 실패`,
"label.exchange.sync.account.username":`서비스 계정 사용자명(도메인 사용자명이나 UPN)：`,
"label.dataimport.error.date":`오류 발생: 일자`,
"label.orgname":`조직`,
"label.weixin.group.owner":`소유인`,
"vue_label_dashboard_colorrange":`색깔 범위`,
"label.forecast.shrepage.tableth":`방문 예측`,
"label.related.disabled":`관련 리스트가 활성화되지 않았습니다. 시스템 관리자에게 연락해 페이지 레이아웃에 관련 리스트를 활성화하십시오.`,
"label.version.product.management":`제품관리`,
"label.knowledge.new.article.published":``,
"label.sendsms.batch.step4":`4단계: 문자를 제출해 처리합니다`,
"vue_label_commonobjects_detail_and_tasks":`축하합니다. 미처리한 이벤트나 업무가 없습니다.`,
"label.salescloud.ci":`번`,
"label.ccpeak.getapi.name.time":`CCService 클래스의 방법을 사용하려면 예시화가 필요합니다`,
"label.escalation.setup.detail.conditon":`조건`,
"label.lbs.isUseLbs":`포지션 서비스 사용`,
"front-lightning-module-v1-dashborad-color-depth":``,
"date":`일자`,
"label.select.personnel":``,
"label.appointmentpage.wizard.notif3":`메일 주소를 기입하세요`,
"label.import.page1.pleaseselectwayofdealdata":`처리 방식을 선택하시오`,
"label.partner.all.memo":`리스트는 귀사의 모든 파트너 클라우드를 표시합니다.URL을 누르면 로그인 페이지로 바로 이동합니다.`,
"label.appointment.wizard.subtitle4-3-3":`30분`,
"component_telerecord_label_subject":`주제`,
"label.sendsms.batch.finish":`문자 단체 전송:완성`,
"label.login.access.myusername":`나의 사용자명`,
"label.weixin.wechatnumber":`위쳇 아이디`,
"label.eowechat.status":``,
"Lead_Scoring_Setting_Rule_Setup_Value":`평점`,
"label.appexchange.oldreport.noupload":`구 보고서-업로드하지 않음`,
"label.approverfieldediting":`승인자 필드와 기록 편집 가능성`,
"label_tabpage_customernamez":`고객명`,
"vue_label_dashboard_linkagesettings":`연동 설정`,
"vue_label_ccchart_notice_deletecomment":`댓글을 삭제하시겠습니까?`,
"label.allprofile":`모든 프로필`,
"label.campaignmember.main.addMember":`멤버 추가- 검색`,
"label.projectManagement.subtask.list":``,
"label.code.some.size":`코드 용량: 최대 200KB 문자, 약 200000 바이트를 지원합니다`,
"front-custom-service":``,
"label.SMS.det":`문자 알림 상세 정보`,
"setup_layout_label_nobutton":`선택 가능한 버튼이 없음`,
"vue_label_email_Could_not_save_template":`템플릿을 저장할 수 없습니다.`,
"label.imgfield.height":`높이`,
"label.leadscore":`잠재고객 채점`,
"setup_object_field_dependency_label_removefromlist":`선택된 값을 제거합니다`,
"message.error.code.null":``,
"label.tianyancha.businessscope":`경영 범위`,
"vue_label_chat_empty_message":`소식 비우기`,
"label.total":`총`,
"label.delerror.list":`미삭제 파일 리스트`,
"label.selectedreceivers":`선택한 수신인`,
"label.layout.availablepages":`사용 가능한 페이지`,
"label.pc.ui.2018.personalinfo":`개인 정보`,
"label.chat.topic.edit.detial":`상세 정보 편집`,
"label.mr.descreption.reDataList1":`에 있음`,
"label.document.value.too.long":`이 파일 크기가 5M을 초과했습니다!`,
"lable.opppdt.addpdt.table.listprice":`값을 매깁니다`,
"label.selectoperate":`조작 선택`,
"label.icon.5":`화폐`,
"label.icon.126":`병상`,
"label.hiddensearch":`검색 숨기기`,
"label.view.sortview.exportble":`내보낼 수 있습니다`,
"vue_label_homepage_noassignee":`분배자 없음`,
"label.knowledgebase.close.and.resolve":``,
"label.licence.used":`허가증 사용 수량`,
"label.newprocessstep5":`5단계 승인 페이지 레이아웃에 나타나는 필드를 선택합니다`,
"vue_label_appstore_all_applications":`모든 응용 프로그램`,
"label.no.edit.permission":``,
"vue_label_calendar_calendar_added_successfully":`캘린더 추가 성공`,
"report_line":`데이터 필드`,
"component.chatter.link.label.name":`링크 명칭`,
"label.data.expnode.e_desc1":`1. 사용자 설정 내보내기: 사용자가 필요에 따라 내보내는 필드와 선별 조건을 선택할 수 있습니다.`,
"label.tabularreport.step4":`4단계: 보고서 기준을 선택합니다`,
"Opportunity.Detailed.Phase.Change.Text.001":`업무 기회 단계 변경`,
"label.quickbooks.searchresault.action":`조작`,
"component_timeline_label_today":`오늘`,
"label.callboard.remark":`아래에 귀조직의 회사 공고를 입력합니다`,
"label.campagin.field.choose":`마케팅 행사 등록 페이지에 포함되는 필드를 선택합니다`,
"front-gantt-module-rolling-temporary-tasks":``,
"label.file.des":`내용`,
"Dashboard_View_RecentlyView":`최근 보기`,
"UG_Account_04":`피동 검색 고객 필터`,
"chatter.refresh":`새로고침`,
"label.tianyancha.companyorgtype":`회사 유형`,
"label.chatter.dateRange":`날짜 범위`,
"label.campagin.step3":`3단계: 페이지를 생성합니다`,
"label.appointmentdetail.wizard.title14":`월요일 시간 계획`,
"setup.object.field.dependency.button.setdependency":`종속 필드 설정`,
"serviceterritorymember.serviceterritory.isactive.notactive":``,
"template.chart.ygydyj":``,
"label.tag.edittags":`라벨 편집`,
"label.clone":`복사`,
"front-electronic-signature-setting-intro1":``,
"label_reach":``,
"label.tabpage.havez":`있음`,
"label.email.clearCase":``,
"label.customer.tab.all":`모든 메뉴`,
"label.direct.dashboard.day.report":`업무일보 새로 만들기`,
"label_tabpage_exportview":`뷰 내보내기`,
"label.passwordPolicy.setup.maxFailTimes":`최대 실패 시도 횟수`,
"label.processsetting.complete.enable":``,
"label.marketsea.memberfield":`멤버 뷰 필드`,
"label.report.export.format.title":`보고서 포맷하기`,
"label.recycle.execute.title":`휴지통 비우는 중`,
"label.file.use.most.user":`가장 많은 저장 공간을 사용한 사용자`,
"report_type_label_systemReport":`시스템 보고서`,
"label.customobjects.majorobject":`메인 대상`,
"label.file.delete.public.link":`공용 링크 삭제`,
"front-epwechat-module-v1-id":``,
"label.partner.common.roleNum":`역할 수량`,
"label.sendtonextapprover":`다음 승인자에게 전송합니다`,
"label.notification.tip3":`10개 더 보기`,
"label.tabpage.placeenterz":`입력하세요`,
"label.mobile.phone.cc.people":`참조인`,
"component_setup_iframe_label_inputurlmemo":`삽입할 URL 주소를 입력하세요`,
"label.umeng.activity.statuschange":`#name에게 분배한 업무상태가 #newstatus로 수정되었습니다`,
"label.step3.restricted.visibility":`3단계. 가시성을 제한합니다`,
"label.multilang.datadelete.approvedata":`승인중인 기록（{0}건）：`,
"label.reportsSubscription.save":`저장`,
"label.emailobject.template.visibility":`시각성`,
"label_partner_step3":`3단계: 기본 정보`,
"label.product.across":`각 가격매뉴얼을 뛰어넘기`,
"label.same.analyze.opportunity.name":`업무기회 명칭`,
"label.chatter.memotel":`기록 전화`,
"label.recentview.seloption2":`내가 최근 생성한 것`,
"label.ccchat.message.search.desc1":`찾을 수 없습니다`,
"label.reportexport":`내보내기`,
"label.service.gantt.drop.tip":``,
"label.australian.westem.standard.time":`서부 표준시(호주)`,
"label.emailobject.email":`메일`,
"Homepage_Contract_FieldMissed_DoesntSupport":`계약서 대상에 'qdrq'와 'htje' 필드가 없어 데이터를 볼 수 없습니다.`,
"label.email.cancel.upload.info":`이로 인해 진행중인 업로드 과정이 취소됩니다`,
"label.page.copy.merged.field.value":`병합 필드값 복사`,
"UG.ST.006":`바로 이동`,
"label.trigger.service.connot.access":`접근할 수 없는 구문`,
"label.projectManagement.new.tasks":``,
"lable.SalesCommitmentKanBan.receiptsRate":`대금 수령 달성률`,
"label.productsales.oppor.overdue":`만료된 업무기회`,
"vue_label_pool_convertedbyme":`내가 전환한 항목`,
"label.loginip.pagecue.invalidt":`종료 Internet 주소보다 시작 Internet 주소가 더 크거나 잘못된 Internet 주소입니다.`,
"label.campagin.roi.xyzj":`반응 통계`,
"label.visualpage.list.title":`이미 사용된 사용자 설정 페이지 방문`,
"chatter.feed.searchinitvalue":`명칭을 입력합니다...`,
"label.export_submission":``,
"this.season":`이번 분기`,
"label.forecast.settings.gx":`예측 데이터 공유`,
"label.tag.addtags.tagcolour":`라벨 컬러`,
"label.api":`API명칭`,
"label.bulk.delete":`모두 삭제(복구 불가)`,
"label.reportsSubscriptionPage.condition.emailoption":`메일 옵션`,
"vue_label_dashboard_newdashboardsuccessfully":`대시보드 새로 만들기 성공`,
"three":`3`,
"label.prompt":`안내`,
"label.same.analyze.contact.phone":`연락담당자 핸드폰`,
"label.icon.62":`파이프`,
"label.forecast.shrepage.tableth.isnable":`제출 허용`,
"label.multilang.polloption.vote":`{0}표`,
"label.customfields.totalsummary.selecttotaltype":`누적 유형 선택`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`대금 수령 승낙률`,
"label.areaAndSub":`구역 및 하급 구역`,
"vue_label_pool_recycle":`회수`,
"lable.outlook.detail.synset":`동기화 설정`,
"label.quote.detail.introduce":`키워드를 입력해 '검색'을 누른 후 검색이 시작됩니다. 검색한 후 '선택'을 클릭하여 다음으로 넘어갑니다`,
"label.profile.customappset":`사용자 설정 응용프로그램 설정`,
"label.changemylanguage":`언어 변경`,
"message.approval.plzcapppor":`승인자를 선택하세요`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`공공 캘린더와 리소스`,
"label.wtd.changefields.title.desc1":`페이지에서 사용할 필드를 선택하고 반환할 URL을 입력하며 생성 버튼을 클릭하여 페이지를 생성합니다.`,
"label.weixin.voting.not.empty":`투표 선택항목을 입력하세요`,
"label.campaign.channel.equal":`와 같다`,
"label.emailobject.emaildetail.button.back":`뒤로가기`,
"label.ccchat.person.invite.allowemails":`안보를 위하여 다음의 끝자리가 포함된 메일 주소만 입력하세요`,
"label.notEdit.message":``,
"label.layout.selectedfields.relatedlist":`필드/관련 리스트 선택`,
"label.weixin.voting.deadline":`투표 마감 시간`,
"label.document.upload":`업로드할 파일`,
"label.import.page2.notmatchfiled":``,
"label.data.exp.selzippwd":`입력하지 않으면 압축 비밀번호가 없는 것으로 됩니다`,
"label.user.step2.select.email.template":`2단계. 메일 템플릿을 선택합니다`,
"label.currency.effective":`유효 화폐 종류`,
"label.version.control.type":`버전 종류`,
"label.projectManagement.Taskorproblem":``,
"label.everyweek":`매주`,
"label.passwordPolicy.setup.pwdremember4":`비밀번호 4개 기억하기`,
"label.emailobject.groupemail":`단체 메일 발송`,
"label.approvepagelayout1":`모든 사용자가 같은 페이지 레이아웃 사용하기`,
"label.integrations.mailchimp.massage5":`시스템 내부의 잠재고객과 연락담당자를 MailChimp로 불러온 후 각종 메일을 지정된 수신인에게 단체 전송할 수 있습니다.`,
"label.icon.22":`추가`,
"Dashboard_View_All":`모든 대시보드`,
"label.import.page2.example":`예`,
"label.send.letter":`초대장 전송`,
"label.mobilesectionpart":`모바일 부분`,
"component_setup_tabs_label_title":`Tab 페이징`,
"label.knowledgebase.results":``,
"label.field.remark":`적용`,
"vue_label_systemSettings_url":``,
"vue_label_SMS_failed_find_view_list":`뷰 리스트 찾기 실패`,
"setup_layout_label_order":`정렬 기준`,
"label.customsetting.touse":`사용자 설정 customSetting 사용`,
"label.product.enter":`매칭하는 제품을 찾는 데에 사용할 키워드를 입력하십시오`,
"label.email.template.private.SMS":``,
"vue_label_homepage_chart_deleted":`차트나 대시보드가 이미 삭제됨`,
"label.conversion_pages":``,
"label.compact.layout.select":`중요 정보 레이아웃 필드를 선택합니다`,
"report_label_folderandreport":`보고서와 폴더`,
"label.product.entry":``,
"label.campaignmember.main.manageMember":`멤버 관리`,
"front-QBtoCC-changing":``,
"vue_label_pool_abandonreason":`폐기 사유`,
"template.report.customer.contract.statistics":``,
"label.invoice.message.sendsuccessully":`Invoice 전송 성공했습니다`,
"label.addcurrentoperate":`기존 조작 추가`,
"label.customerinfo.mailpwd":`전송 메일 비밀번호`,
"batch.nochange.owner":`데이터 소유인을 변경할 수 있는 권한이 없습니다!`,
"label_tabpage_uploadfailez":`업로드 실패했으며 다시 시도하세요.`,
"vue_label_systemSettings_mobelqrsetting":``,
"label.regular_field":``,
"label.tabpage.delsuccessz":`삭제 성공`,
"label.Days.Before.Horizontal.Date":``,
"label.evaluation.general":``,
"chatter.notlike.p":`게시물 좋아요 취소`,
"label.chatter.send":`발송`,
"label.emailsync.button.cancel":`취소`,
"label.notification.task4":`업무가 오늘 만료됩니다`,
"vue_label_helpcenter_detail1.2":`업무 상태의 빠른 변경: '기한을 넘긴 업무와 곧 다가올 업무'모듈의 중복 선택 상자를 체크하여 새로 고침 버튼을 클릭하면 업무 상태를 빠르게 '완료됨'으로 변경할 수 있다.   <br>    새로 고침 하기 전에 체크를 취소하면 생태가 변하지 않는다. <br>    우선 순위가 높은 업무가 행사 시간 라인에서 '빨간 깃발' 아이콘으로 표시된다. <br> 행사 시간 라인의 보기 순서 <br>    업무의 완료 일자, 기록 전화의 기한, 이벤트의 시작 일자, 이메일의 발송 시간, 문자의 발송 시간을 역순으로 배열한다. 만일 이상의 일자가 같을 때 기록을 만든 시간을 역순으로 배열된다. <br>?행사 시간 필터 <br>    행사 시간 라인 필터를 사용해 항목 보기의 범위를 축소해 중점 사항을 확인 및 찾을 수 있다. 시간 라인 필터에 일자 범위를 비롯해 행사, 행사 타입 3가지의 선별이 포함된다. <br>     표시되는 행사: 모든 행사, 나의 행사 <br>    행사 시간 라인 필터에서, 이 기능을 통해 행사의 보기 범위를 축소할 수 있다. <br>    나의 행사: 소유인이나 참여자로 참여하는 모든 행사가 표시된다. 예를 들어, 이메일을 발송하거나 행사 조직의 소유인인 경우. 예를 들어, 이메일을 참조 수신하거나 숨은 참조의 수신자라면 해당 행사의 참여자로 인식된다. <br>    `,
"component_chatter_post_label_title":`붙이기`,
"label.data.dataexptemplate.desc":`데이터 내보내기 템플릿은 사용자가 생성한 데이터 내보내기 템플릿이며 사용자의 내보내기 조작을 편하게 실행할 수 있도록 합니다.`,
"label.helptext":`도움말 텍스트`,
"vue_label_norm_removecomponent_certify":`구성 요소 삭제 확인`,
"front-template-V1-Click-new-template":``,
"label.optional_fields":``,
"label.delete_about":``,
"chatter.feed.initvalue":`무엇을 처리하고 계십니까?`,
"label.mail.configure":`고객과의 왕래 메일함을 배치함으로써 CloudCC 메일 홈페이지를 통해 메일을 전송하거나 받을 수 있으며 왕래 메일 이력을 잠재고객과 연락담당자와 동기화시킬 수 있습니다.`,
"label.project.hit.seven":``,
"label.button.upgrade":`구매 및 수정 버전`,
"lable.PowerProcess.event.name":``,
"label.weixin.confirm":`확인`,
"label.customfields.new.inputformula":`공식을 입력합니다`,
"label.standard.buttonandlink.edit":`표준 버튼이나 링크를 변경합니다`,
"workflow.action.tasks.assignortype.createdtype":`최초작성자 유형`,
"front-email-payment-paypal-describe":``,
"label.selectexistingoperate":`기존 조작 선택`,
"label.workflow":`업무 프로세스`,
"label.assignment.setup.detail.ruleentries":`규칙 조항`,
"label.data.file.i.title.num3":`3.시스템이 불러올 데이터 파일을 서버에서 미리 읽어둬 모두 불러오기 절차에 들어가 불러오는 결과는 메일로 사용자에게 알리며 작업 페이지에서 기다릴 필요 없습니다.`,
"label.use.view":`기존 뷰 사용`,
"label.forecast.settings.moren":`기본 제품 계열`,
"vue_label_calendar_add_share":`공유 추가`,
"label_tabpage_newview":`신 뷰 생성하기`,
"label.recycle":`휴지통`,
"UG_solution_03":`솔루션 생성`,
"label.customfields.formula.text.tip":`텍스트 문자열 생성합니다. 예, 다른 여러개 텍스트 필드를 직렬연결합니다.`,
"vue_label_file_single_file_size":`한 파일에 최대 지원`,
"label.a.b.least":`A"가록마다 최소한 하나의 관련 "B"기록이 있어야 한다.`,
"label.validate.function.addtoformula":`선택한 함수를 삽입하기`,
"label_tabpage_pleaseSelectz":`선택하세요`,
"label.account.NextFQ":`다음 회계 분기`,
"label.project.project.name":``,
"label.emailtocloudcc.filed.owner":`소유인 기록`,
"label.textmessage.template.message2":`문자에서 삽입한 필드가 관련된 기록과 매칭되지 않아 값을 취하는 데에 실패할 수 있습니다.`,
"label.icon.92":`책`,
"label.trailerpage":`마지막 페이지`,
"component_event_label_noevent":`오늘 업무를 다 완성하신 것 같습니다.`,
"label.trigger.tip":`트리거에 관해`,
"label.knowledge.case.field.usable":``,
"label.group.isusing.success":`사용 성공`,
"label.marketsea.nextnotfollowdays":`지난번 팔로우업한 후`,
"component.todaytask.label.choicestate":`상태 선택`,
"label.recordtype.main":`--메인--`,
"label.sendletter.step1":`1단계: 초대장 수신인을 지정합니다`,
"label_tabpage_saveviewfailed":`뷰 저장 실패`,
"vue_label_report_notiec_selectone":`상위 대상 기록마다 최소 한개 해당 대상 관련 기록이 있어야 합니다`,
"UG_opportunity_003":`마케팅 채널을 팔로우업합니다.  대시보드 생성`,
"#label.importsourcestep4":`단계 4: 파일을 불러옵니다.#`,
"front-kefu-moudle-v1-trrt-tip":``,
"UG.Forcast.09":`다음`,
"label.ggReleaseRange.subordinates":``,
"label.log.desctiption":`더 많은 내용이 포함된 조직 감사 팔로우업 파일을 다운로드할 수 있습니다(Excel.csv 파일).`,
"label.submitted":`제출 완료`,
"label.validate.function.funcExplain.BEGINS":`텍스트가 특정한 문자로 시작되었는지 확인하고 맞는 경우 TRUE로 돌아갑니다.그렇지 않으면 FALSE로 돌아갑니다.`,
"label.campaign.channel.code":`마케팅 행사 마케팅 채널 QR코드`,
"chatter.group.theLastActivityDate":`지난번 행사 일자`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`브레이크포인트 2 값을 입력하세요`,
"label.labeltranslation":`라벨 번역`,
"label.multilang.product.deleterederect":`다른 가격 매뉴얼의 기록과 관련되어 있기 때문에 {0}에 대한 삭제를 완료할 수 없습니다.관련 기록은 아래와 같습니다.`,
"lable.currencyManage.manageRate.dis":`귀사 기타 대상의 환율, 화폐 종류 추가, 화폐 종류 사용 및 금지, 회사 화폐 종류 변경을 관리하려면 '화폐 종류 관리'를 클릭하세요.`,
"setup.layout.label.modifypage":`페이지 편집`,
"label.import.page2.editforname":``,
"label.searchlayout":`검색 레이아웃`,
"label.chatter.loadmore":`더 많이 로딩 중`,
"label.trigger.folder.all":`모든 트리거 폴더`,
"label.export_submissions":``,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`계약서 체결 총업무율`,
"KeyInformationLayout_DefaultLayout_Name":`시스템 기본값`,
"label.h5.chatter.great":`개 '좋아요'`,
"label.call.center.configuration.enable":`다음 설정을 사용해서 귀사의 Call Center 기능이 활성화되어 있는지 수정합니다.`,
"label.overdate":`종료일`,
"chatter.poll":`투표`,
"label.login.input.verification.code":`보안 코드를 입력하세요:`,
"label.file.sharetype.cooperation":`협조자`,
"label.app.step5":`5단계. 프로필을 분배합니다`,
"front-gantt-module-save-order":``,
"label.globalselect.toallrecord":`신 선택 항목 리스트값을 이 전체 값세트를 사용한 모든 기록 유형에 추가합니다`,
"setup.mainpage.label.welcome24":`CloudCC 클라우드 플랫폼에서 시스템 내의 모든 대상자 데이터의 안보성 방문 설정을 제공해 각종 규칙, 조건을 설정함으로써 데이터 공유 및 방문 권한을 통제한다.`,
"homepage.layout.desctiption":`이 페이지에서 메인 홈페이지 메뉴에 대해 다른 메뉴 레이아웃을 생성할 수 있습니다.`,
"vue_label_SMS_notice_send_sussess":`문자 발송됨`,
"label.projectManagement.overdue":``,
"label.assignment.setup.list.lead.description":`잠재고객 분배 규칙을 사용해 잠재고객을 자동으로 관련된 사용자에게 전송합니다. 잠재고객 분배 규칙이 잠재고객을 정의한 조건과 여려개 규칙 조항으로 이루어집니다.`,
"label.list.projectSetting.des":`다음의 설정 수정 항목을 사용하여 메일을 전송하시겠습니까:`,
"setup.mainpage.label.welcome18":`CloudCC의 기업급 권한 설정은 데이터 및 모듈 처리할 때 각 사용자의 사용 권한을 통제할 수 있게 한다. 역할의 권한 설정에 사용자 직위, 조, 역할, 데이터 공유 규칙, 필드급 안보성 통제가 포함되어 업체간 다른 인원 및 부서간의 데이터 공유가 이루어진다.`,
"label.ratio":``,
"label.Xaxis":`X축`,
"label.google.map":``,
"Dashboard.SelectBoardToDisplay":`대시보드 선택 카드의 대시보드를 열어 주세요`,
"label.data.newtemplate.e_conditions":`내보내기 조건`,
"label.emailtocloudcc.description3":`기업 이메일을, 예를 들어 sales@company.com, info@company.com, support@company.com를 여기에 추가하여 시스템에서 받은 메일을 자동으로 잠재 고객이나 개인안 기록으로 생성하여 거래 고객을 팔로우업한다.`,
"label.page.select.profile":`이 중에서 사용하는 신 사용자 설정 메뉴의 사용자 프로필을 선택합니다. 프로필의 상세 정보와 편집 페이지에서 메뉴 보기 여부를 점검하거나 수정할 수 있습니다.`,
"label.chosen.button":`선택한 버튼`,
"front-epwechat-module-v1-info":``,
"label.translation.select":`필터링 조건을 선택합니다`,
"ten":`10`,
"label.barcode":``,
"lable.product.nextdel":`표시된 기록을 계속 삭제하거나 클릭합니다`,
"label.default":`기본`,
"label.chatter.theme":`주제`,
"vue_label_commonobjects_view_split_screen_view":`분할 화면 뷰`,
"label.ems.myemails":`나의 메일`,
"label.email.clearPersonalEmail":``,
"label.login.access.admin":`님의 회사 관리자`,
"label.emailobject.wizard.desc":``,
"label.passwordPolicy.setup.minpwdlength":`비밀번호 최소 자릿수`,
"choserow":`보는 열을 선택하세요`,
"front-epwechat-module-v1-role-binding":``,
"lable.outlook.edit.newdata":`생성 날짜가 가장 먼저`,
"label.schedulejob.setup.schedule.enddate":`종료일`,
"label.quickbooks.view":`뷰`,
"font-evaluate-module-v1-not-inform":``,
"chatter.poll.option3":`선택항목3`,
"setup_layout_label_selectfield":`필드 선택`,
"label.partner.common.roleSetup":`파트너 클라우드 역할과 사용자 설정`,
"label_partner_new_step3":`3단계: 명칭과 URL을 입력합니다`,
"label.transfer":`이동`,
"label.bmap.myaddress":`나의 위치`,
"label_tabpage_individual":`택일형 선택`,
"label.autoRegister.changepwd.setpwd.repassword":`비밀번호를 다시 입력하세요`,
"vue_label_commonobjects_detail_and_before":`이전 이력`,
"front-kefu-moudle-v1-single-Login-area":``,
"label.replacedocument":`파일 교체`,
"label.validate.function.category.Logical":`논리적`,
"label.companyprofile.syncsuccess":`동기화 성공`,
"template.chart.rwzthyxj":``,
"label.product.clearcondition":`조건 비우기`,
"component_task_label_person":`*피분배자`,
"label.tabpage.as":`예`,
"message.error.calendar.add":`해당 캘린더 이미 추가됨`,
"label.marketsea.isrecycleleadcreatebyself":`생성 잠재 고객을 회수하시겠습니까`,
"label.icon.57":`기압계`,
"UG.Lead.010":`혹은`,
"setup_object_field_dependency_label_configured":`내용이 배치됐습니다`,
"label.tianyancha.regnumber":`등록 계정`,
"front-kefu-moudle-v1-Opened-chats":``,
"label_tabpage_converstatez":`상태 전환 완료`,
"label.bmap.beijing.haidianqu":`베이징시 하이뎬구 상지 10번가`,
"label.startimport":`불러오기 시작`,
"label.knowledgebase.application.default.settings":``,
"lable.account.year.custom":`사용자 설정 회계 연도`,
"label.event.nextmonth":`다음달`,
"label.email.body":`본문`,
"setup.object.field.dependency.label.mustsetup":`필드 관련 관계를 설정하여 저장하세요`,
"label_tabpage_multiple":`중복 선택`,
"label.task.this.month":`이번달의 업무`,
"label.customfields.formula.moneyexample":`Gross Margin（총이익）= Amount - Cost__c`,
"label.tonewemailnotice":`이 업무에 대해 대상을 선택해 다음을 클릭합니다. 업무가 같은 유형의 업무프로세스 규칙, 승인 과정과 관련시킬 수 있습니다.`,
"setup.mainpage.label.welcome11":`사용자 설정 보고서`,
"label.layout.availabletab":`사용 가능한 메뉴`,
"label.data.importef":`불러오기에 실패한 파일`,
"label.appupload.upload.alert":`업로드하기 전에 이 소프트웨어 패키지에 대한 자세한 정보를 제공해 주십시오.이 설정은 이 패키지를 설치하는 데 필요한 요구 사항을 확인합니다.`,
"label.sales.accountteam.shared":``,
"lable.currency.addexchageRate":`환율 추가`,
"label.page.simplified.chinese":`간체 중문`,
"label.service.dispatchingUnits.search.service.area":``,
"lable.list.queue.name":`대열 명칭`,
"pagecreator.button.save":`저장`,
"label.ccpeak.support.function":`싱글시트 각종 함수를 지원합니다`,
"label.tianyancha.legalpersonid":`법인ID`,
"label.sendemail.chat.addPostmainPage":`존경하는 #name:\n\n    안녕하세요!#userName이 님의 CCChat 메인 홈페이지에서 게시물을 올렸습니다.`,
"batch.no.change":`이동 권한이 없는 데이터`,
"label.the.referenced":`에서 인용합니다`,
"label.input.webtab.information":`Web 메뉴에 대한 정보를 작성합니다.`,
"vue_label_systemSettings_subscription":``,
"label.login.access.title":`고객에게 방문 권한을 부여합니다`,
"label.schedulejob.setup.schedule.lastday":`마지막 날`,
"label.synchronize.department":`사용자 동기화`,
"label_tabpage_lessequalz":`작거나 같다`,
"label.file.library.successmanagemember":`관리 멤버 저장 성공`,
"label.service.major.event.oreder":``,
"label.desktopintegration":`바탕화면 통합`,
"label.a_b":`A에서 B로의 관계`,
"every":`매`,
"label.tabpage.bar":`개`,
"label.filecontentsnotnull":`파일 내용을 비워둘 수 없습니다`,
"label.layout.detailoftestobj":`테스트 대상 상세 정보`,
"label.summaryreport.2018.step3":`3단계: 보고서열을 선택합니다`,
"UG.Lead.002":`다양한 방법으로 제품과 서비스가 '잠재 고객'으로 인식되게 한다.`,
"label_partner_workspace_member_selectedprofile":`선택한 프로필`,
"label.newdescription":`비고 새로만들기`,
"vue_label_normal_moveup":`위로 이동`,
"label.mobile.quickcreate.default.logacall":`통화 기록`,
"userterritory.serviceterritory.user.unique":``,
"label.weixin.record":`기록`,
"front-kefu-moudle-connecting":``,
"label.monitorsys.recent.operation.log":`최근 조작 일지`,
"lable.outlook.detail.lmaping":`잠재고객 필드 매핑`,
"lable.account.year.ovdate":`회계 연도 종료일`,
"vue.homepage.auditcard.record":``,
"label.processsetting.delete.process.succeeded":``,
"label.customerinfo.smsPwd":`문자 게이트웨이 비밀번호`,
"label.tolead.object":`대상 불러오기`,
"label.data.downpage.i.list.desc2":`데이터를 불러온 후 불러오기 성공 여부 메일을 받으십니다.`,
"label.sharerule.ruletype":`규칙 유형`,
"label.reportsSubscriptionPage.email.toothers":`나와 다른 사용자에게 전송하기`,
"label.emailobject.templates":`템플릿 선택`,
"vue_label_checkduplicate_":`계약서 충돌 분석`,
"label.campaign.channel.lookup.example":`예시 보기`,
"label.login.verification.please.note":`주의하세요:`,
"label.version.charge":`유료`,
"label.ccdocument.show.trace":`표시 흔적`,
"label.sendemail.approval.submit":`안녕하세요 #name:\n     #actorname于#actordate 제출한 #objLabel-#recordname이 승인을 기다리고 있습니다，다음의 링크를 클릭하거나 CRM시스템에 로그인하여 승인 센터에서 승인하세요：\n  #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`사용자가 마우스로 클릭하여 프로그래밍 필요없이 시스템 안내의 절차에 따라 보고서를 작성한다. 시스템에서 리스트형 보고서, 결합 보고서, 행렬문 보고서를 선택할 수 있다. 동시에 모든 필드의 선택을 제공한다. 불필요한 필드 정보를 없앤다. 막대 차트, 꺾은선 차트, 도넛 차트, 퍼널 차트, 원형 차트 등을 선택할 수 있으며 한눈에 확인할 수 있다.`,
"UG_contact_06":`연락담당자 불러오기`,
"message.success.event.add":`이벤트 정보 새로 만들기 저장 성공`,
"report.line":`데이터 필드`,
"label.approvepagelayout2":`사용자마다 다른 페이지 레이아웃 사용하기`,
"vue_label_normal_contract_sf":`계약서`,
"label.tabpage.tpcustomersz":`잠재 고객 전환`,
"label.ccchat.message.new.error5":`오류가 발생하여 메시지는 10,000개 문자를 초과할 수 없습니다.`,
"label.severalorone":`한개 파일`,
"pagecreator_systemstyle_label_buttonfontcolor":`버튼 글자`,
"label.customer.tab.step3.introduce":`새 사용자 설정 메뉴를 사용할 응용프로그램을 선택하십시오.각 사용자 설정 응용 프로그램의 자세한 정보 페이지와 편집 페이지에서 메뉴 표시 여부를 점검하거나 수정할 수도 있습니다.`,
"chatter.group.groupEdit":`그룹 편집`,
"label.partnerCloud.partnerAccount.spending":``,
"label.slip":`개)`,
"label.field.master.class":`마스터 디테일 관계 등급이 3급을 초과했습니다`,
"label.sendemail.chat.addComentsmyFeed":`존경하는 #name:\n\n    안녕하세요！#userName이 님의 게시물에 답장을 보냈습니다.`,
"label.service.ganttBaiduMap.selectingDispatchTime":``,
"label.knowledgebase.remove.article":``,
"label.appupload.notmanaged":`관리받지 않음`,
"label.report.goto.step":`단계로 이동`,
"label.publicgroup.save.mustbeselect":`멤버를 선택해야 합니다`,
"label.data.expnode.e.desc2":`2. 템플릿대로 내보내기: 사용자가 템플릿을 선택해 데이터를 내보낼 수 있다.`,
"UG.product.02":`제품이 마케팅이나 구매한 제품이나 서비스를 참고한다`,
"label.sendemailtouser":`선정한 사용자에게 메일을 전송하시겠습니까?`,
"label.knowledge.setting.hint.nine":``,
"front-asset-module-v1-view-asset-bom":``,
"label_partner_all_enable":`사용`,
"label.processsetting.disable.process.successfully":``,
"label.call.center.enable":`Call Center 사용`,
"message.recordtype.applyitseparatly":`프로필마다 다른 페이지 레이아웃을 응용합니다`,
"label.weixin.report.customize":`사용자 설정`,
"label.file.mongdb.file.is.not.exist":`파일이 존재하지 않습니다`,
"label.chat.edit.topics":`주제 편집`,
"label.knowledge.delete.searchterm":``,
"label_emailtocloudcc_redmessage3":`서버 주소를 입력하세요`,
"use":`사용`,
"label.batchtransfer.transferfrom":`로부터 이동`,
"label.recycle.my":`나의 휴지통`,
"label_json_string_null":`공백`,
"label.version.lookupfield":`필드 찾기`,
"lable.tianyancha.h5.searchf":`찾을 수 없습니다`,
"label.validate.globalvariable.description":`$User.[필드 API]，예：$User.id <br>선택 가능한 필드값:id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`업무 기회 천재`,
"label.applt.copy":``,
"chatter.emailMessageOrReply":`게시물 올리거나 댓글 달기`,
"label.newreport.self":`선정한 필드`,
"label.visualpage.checkpinxie":`페이지 철자를 확인하세요.`,
"label.knowledgebase.article.attaching.case":``,
"label.dialogbox":`대화 상자`,
"label.summaryreport.step3.new":`3단계: 통계 정보를 선택합니다`,
"label.confirm":`확인`,
"label.mobile.buttom.team":`채팅`,
"label.quickbooks.action.link":`연동하기`,
"vue_label_commonobjects_view_support_to_datas":`해당 동작은 최대 10개 데이터에만 가능합니다`,
"vue_label_helpcenter_homepage":`사용자가 기본으로 두개 메인 홈페이지를 가지고 있으면 표준 홈페이지와 개인 홈페이지이다. 관리자가 사용자의 프로필에 따라 사용자에게 하나의 대응한 프로필 홈페이지를 분배할 수 있다. 주의: Lightning 버전의 홈페이지와 예전 버전의 홈페이지는 호환되지 않는다. <br>1. 표준 홈페이지 <br> 표준 홈페이지의 내용은 편집 불가능하다. 분기별 실적 구성 요소, 최근 확인 구성 요소, 승인 센터 구성 요소, 오늘 이벤트 구성 요소, 업무 구성 요소, 기한을 넘긴 업무 기회 구성 요소, 최근 30일 동안 연락 안된 업무 기회 구성요소, 곧 다가올 업무 기회 구성 요소가 포함된다 <br> 분기별 실적 구성 요소: 사용자가 본인의 분기 목표를 세울 수 있다. <br> 최근 확인 구성 요소: 최근 확인한 10개 대상자 기록 <br> 30일 동안 연락 안되는 업무 기회 구성 요소: 연락하지 않는 일수가 30일을 넘어 가능성이 0이나 100이 아닌 5개 업무 기회. <br>2. 개인 홈페이지 <br> 사용자마다 하나의 개인 홈페이지를 가지고 있으며 개인 홈페이지의 내용은 설정으로 구성 요소를 추가나 삭제할 수 있어 드래그 앤드 드롭으로 구성 요소의 위치와 크기를 조정할 수 있다. <br> 개인 홈페이지가 개설될 때 기본으로 브리핑 구성요소, 승인 센터 구성요소, 기한을 넘긴 업무기회 구성요소, 곧 다가올 업무기외 구성 요소가 있다. <br> 개인 홈페이지에 최대한 15개 구성요소가 설정될 수 있다. <br>3. 프로필 홈페이지 <br> 관리자가 사용자 설정한 홈페이지 프로필 홈페이지를 생성/ 편집/삭제할 수 있으며 다른 프로필에 대해 다른 홈페이지를 분배하며 다른 프로필을 사용하는 사용자가 다른 홈페이지의 효과를 볼 수 있도록 한다. <br>프로필 홈페이지에 최대한 15개 구성 요소가 설정될 수 있다 <br>4 구성 요소 추가 <br>  개인 홈페이지와 프로필 홈페이지에서 사용자 설정으로 구성 요소를 추가할 수 있으며 대시보드, 대시보드 내부 차트와 카드 뷰를 추가할 수 있다. <br> 대시보드 구성 요소: 시스템에서 대시보드를 홈페이지에서 추가해 대시보드 안에 포함한 구성 요소가 이 대시보드가 차지하고 있는 구성 요소의 소스를 의미한다.(홈페이지에서 최대한 15개 구성 요소를 지원한다). 추가한 후 대시보드의 데이터가 기존 대시보드와 연동되지 않는다, ( 즉 기존 대시보드를 삭제하더라도 이 대시보드 구성 요소가 여전히 작업 항목으로 유효하다. )<br>  대시보드 내부 차트 구성요소: 시스템에서의 대시보드의 한 차트 구성요소를 홈페이지에서 추가한다면 해당 구성 요소의 연동 기능이 무효된다. <br>  카드 뷰 구성 요소:한 대상자의 한 뷰를 선택해 데이터 소스로 홈페이지에서 추가할 수 있어 필드와 작업 항목을 사용자가 설정할 수 있다.  단, 카드 뷰의 데이터 소스 뷰가 삭제되면 카드 뷰의 데이터가 없어진다.`,
"label.usersandlimit":`사용자 및 권한`,
"label.sendmail.step3.introduce2":`명의 수신인이 이 메일을 받습니다.`,
"label.setupcustomfield":`사용자 설정 필드`,
"label.layout.last.notdel":`마지막 레이아웃을 삭제할 수 없습니다`,
"label.emailtocloudcc.redmessage7":`시스템 배치에 오류 발생, 관리자에게 연락하시오`,
"label.includedIn":``,
"label.permission.detail.app.pagesetting":`페이지 사용자 설정`,
"label.addfile.tips":``,
"label.fieldinformation":`필드 정보`,
"label.campagin.roi.sjcb":`실제 원가`,
"label.email.all.works.company":`회사의 모든 동료`,
"label.currencyDesc":`이 페이지를 사용해 귀조직이 사용하는 모든 화폐를 정의합니다. 회사 화폐를 회사 본부에서 수익 보고를 진행할 때 사용하는 화폐로 설정해야 합니다. 다른 화폐 종류를 회사 화폐로 지정하면 모든 환율이 이 변화에 따라 변경됩니다.`,
"label.file.details":`상세 정보`,
"label.foldervisitlimit3":`다음 사용자만 이 폴더를 방문할 수 있습니다:`,
"label.account.next.M":`다음 달`,
"label.oweralias":`소유인 별명`,
"label.projectManagement.entryname":``,
"label.customcomponent.page.add.title1":`구성요소 정보`,
"label.projectManagement.PleaseenterCreator":``,
"label.multipleactivity.memberselected":`선정된 멤버`,
"label_chatter_memotel":`기록 전화`,
"lable.Confirm.customers":``,
"front-email-payment-Invoice-number":``,
"label.not.appoint.validation":`인증 규칙에 대한 대상이 지정되지 않아 지정하십시오`,
"label.peru.time":`페루 시간`,
"label.setting.intergrationlist.status3":`QuickBooks 계정으로 로그인해야 합니다`,
"vue_label_display_number_field":``,
"label_productline_count":`제품 계열 수량`,
"label.data.downpage.i_title.num2":`2. 불러오기 전에 불러올 파일의 필드 이름과 CloudCC 시스템의 대상 필드 이름이 매칭하는지 확인하십시오.`,
"label.field.duplicate4":`'ABC'와 'abc'를 다른 값으로 봅니다. (케이스 센시티브)`,
"message.approval.step.validation.invalid.levels":`최소 등급이 1입니다`,
"label.tianyancha.businessverify.step1":`공상 데이터 인증 사용 첫번째 단계`,
"label.hidedetail":`상세 정보 숨기기`,
"UG_Lead_009":`APP 통화기록`,
"label.partnerCloud.newProductSeries":``,
"label.brief.opportunities":`기회 총수`,
"label.user.mfa.unbind.remind":`선택한 사용자에게 MFA 연동을 해제시킬 겁니다. 사용자가 다음에 로그인할 때 MFA 설비를 다시 연동해야 하며 확인하세요.`,
"vue_label_report_grouprow":`행 그룹`,
"setup.layout.label.newarea":`구역 새로 만들기`,
"label.nostart":`시작되지 않았음`,
"UG_Lead_010":`혹은`,
"label.emailmerge.mergepage.record.requeired":`병합할 기록을 선택하세요!`,
"label.appointmentpage.wizard.notif1btn1":`확인`,
"UG.Account.02":`일부 업체는 다른 업체에 서비스를 제공하고, 일부 업체는 최종 사용자와 협력을 하며 일부 업체는 NGO기구에 서비스를 제공한다.`,
"label.address.country":`국가나 지역`,
"label.userinfo.updatepwd":`비밀번호 변경`,
"label.salescloud.teamrole.optionlist.opportunity":`업무기회 그룹 멤버를 추가`,
"lable.account.Current.FY":`현 회계 연도`,
"chatter.coll.p":`게시물 저장`,
"label.setupsms":`문자`,
"label.atlantic.daylight.time":`대서양 서머타임`,
"label.recordslock":`기록 잠기기`,
"button_partner_search":`조회`,
"vue_label_salesfunnel_notice4":`가능성이 1%-99%인 업무 기회의 총금액`,
"vue_label_report_statistics":`통계`,
"label.ccchat.notmember.active.group0":`그룹명에 {0}이 포함된 활동 그룹의 멤버가 아닙니다`,
"label.tag.manage.newtag":`라벨 추가`,
"label.customfileds.formula.dateandtime.tip":`일자/시간을 계산합니다. 예, 다른 일자/시간에 일정한 시간이나 일수를 추가합니다`,
"label.weixin.mobile.fly.ios":`ios 모바일 공유`,
"vue_label_file_over_file_size":`file.name   '의 파일 크기가 시스템 설정된 값을 초과하였습니다!`,
"label.schedulejob.setup.schedule.last":`최후`,
"label.ccchat.whose.name.contains":`의 모든 행사 그룹 멤버`,
"label.project.milestone.name":``,
"message.passwordPolicy.validate.reuse":`오류: 이 암호를 다시 사용할 수 없습니다`,
"label.stdashbord.xsld.business.img3":`가능성이 1%-99%단계인 금액*가능성`,
"label.event.view.list":`뷰 리스트`,
"label.workflow.ruletriggertime":`규칙 촉발 시간`,
"label.campaign.channel":`마케팅 행사 마케팅 채널`,
"label.appexchange.emailnotice":`업무 프로세스 메일 알림`,
"label.icon.77":`농업`,
"label.visualpage.display.value":`나타나는 값을 입력하며 앞뒤에 빈칸이 없어야 합니다`,
"label.forecast.customforecast.type.user":`사용자로`,
"label_tabpage_lessz":`작다`,
"label.same.analyze.contact.email":`연락담당자 메일`,
"vue_label_report_range":`범위`,
"lable.product.pricebooks.nr":`아래 선택항목 리스트에서 선택하여 기존 가격 매뉴얼에서 내용을 복사할 수 있습니다`,
"label_mobile_buttom_team_setUp":`채팅 설정`,
"label.email.bcc.recipients":`숨긴 메일 참조 수신인`,
"vue_label_ccchat_notice_deletepostfail":`게시물 삭제 실패`,
"label_file_type":`파일 유형`,
"label.multilang.feedtrack.operateupdate":`한 개{0}기록을 변경했습니다`,
"label.contractmanager":`계약서 책임자`,
"front-gantt-module-drag-one-task-sorting":``,
"label.partner.step2":`2단계: 템플릿을 확인합니다`,
"front-epwechat-module-v1-again-binding":``,
"label.service.miniProgram.imageSize":``,
"setup_main2018_label_managesetup":`관리 설정`,
"component_salesperformance_label_nopermission":`업무 기회에 관한 데이터를 보려면 시스템 관리자에게 연락하십시오.`,
"lable.account.stadate":`회계 분기 시작일`,
"label.service.gantt.and.resourcestype":``,
"label.ems.attachfiles":`첨부파일 추가`,
"label.data.expnode.e.desc1":`1. 사용자 설정 내보내기:사용자가 필요에 따라 내보낼 필드와 선별 조건을 선택한다.`,
"vue_label_systemSettings_analyse":``,
"label.project.all.date":``,
"vue_label_commonobjects_view_summary_basis":`통계 근거`,
"template.chart.yywjhdschd":``,
"vue_label_pool_notmeet":`고객 요구와 부적합`,
"label.attendance.manager":`출석 체크 근무지 관리`,
"vue_labenl_normal_current":`현재`,
"label.projectManagement.completed.quantity":``,
"label.layout.testfield":`테스트 필드`,
"label.customfields.selectcontainrelatelistlayout":`관련 리스트가 표함될 페이지 레이아웃을 선택합니다`,
"label.fiji.time":`피지 시간`,
"message.error.domain.already.exists":``,
"label.accountandcontact":``,
"label.dashboardSetup.right":`우`,
"label.view.appliedMobile.xgry":`이 옵션을 선택하면, 관계자의 첫 화면 작업 공간에서 이 뷰를 볼 수 있습니다`,
"label.file.share.all":`회사 임의 사용자`,
"vue_label_pool_summary":`총 {0}개 데이터, {1}에서 새로 고침됨`,
"label.emailtemplate.new":`메일 템플릿 새로만들기`,
"label.tag.manage.button1":`라벨 추가`,
"label.data.exp.tempexppage":`데이터 내보내기 템플릿 페이지`,
"font-trade-module-v1-invoice-total":``,
"label.folder.sort":`폴더 정렬하기`,
"label.multilang.campaign.countnum":`{0}번`,
"label.homepagelayout":`메인 홈페이지 레이아웃`,
"setup_layout_button_cancel":`취소`,
"lable.Search.in.QuickBook":``,
"setup_fielddependency_label_pleaseclick":`'제어 필드'값을 클릭하여 편집하세요`,
"setup.fielddependency.label.pleaseclick":`'컨트롤 필드'값을 클릭하여 편집하세요`,
"label.version.sum.field":`개 사용자 설정 필드`,
"label.form.is.submitted.successful":``,
"label.campaignmember.main.batchaddmember":`마케팅 행사 멤버 모두 추가`,
"label.sendemail.activity.newevent":`존경하는 #belongtoidccname안녕하세요：\r\n  동료분 #createbyidccname이 #createdate에서 님에게 새 이벤트를 분배했으며 내용이 다음과 같습니다：\r\n  주제：#subject\r\n  시작일：#begintime\r\n  종료일：#endtime\r\n  관련 항목：#relatedstr\r\n  내용：#remark\r\n 상세 정보는 다음 링크를 방문하시길 바랍니다：\r\n #path\r\n                        #orgNameCRM시스템`,
"label.knowledgebase.select.target":``,
"setup.layout.label.buttonlist":`버튼 선택`,
"pagecreator.page.label.pagedesc":`폐이지 내용`,
"label.version.professional":`전문 버전`,
"UG.Forcast.10":`완료`,
"template.chart.schdyqsr":``,
"front-filter-module-v1-quick-filter":``,
"label.notification.group2":`공용 그룹 가입에 성공하였습니다`,
"label.ServiceCloud.statistics.by.serviceArea":``,
"label.validate.function.funcExplain.TIMENOW":`현재 시간으로 돌아가기 (시분초)`,
"label.brief.lastmonth":`지난달`,
"label.weixin.member.states":`회원 상태`,
"template.chart.ljxsje":``,
"label.eidt.queue.label.hasused2":`해당 대열 명칭이 사용되었습니다`,
"label.textmessage.nophonenumber":`해당 연락담당자가 기록된 핸드폰 정보가 없습니다`,
"label.task.new":`업무 새로만들기`,
"label.tabpage.grid":`그리드 컴퓨팅 보기`,
"label.workbanch.setup.viewname":`뷰 명칭`,
"front-gantt-module-temporary-tasks":``,
"label.reportTypeDescripe":`사용자 설정 보고서 데이터 소스에 따라 사용자가 예비 정의 대상, 대상 관계 및 지정된 필드를 통해 보고서를 생성할 수 있습니다.`,
"setup_layout_label_fieldlist":`사용 가능한 필드`,
"label.ggReleaseRange.searchforRole":``,
"label.datamanage.account.field":`고객 필드`,
"label_tabpage_groupingemptyz":`그룹분류 항목을 입력하세요`,
"label.permission.edit.insertinfo":`권한 세트 정보를 입력합니다`,
"label.back_forms":``,
"vue_label_calendar_step_2":`2단계: 표준이나 사용자 설정 대상을 선택해 캘린더를 생성합니다.`,
"lable.outlook.mcto.out":`제외한 도메인`,
"label.workflow.accessnext":`아래 조건을 만족시키면 이 단계에 들어갑니다`,
"label.data.exp.temppage":`데이터 내보내기 및 템플릿 제작 페이지`,
"label_tabpage_printview":`뷰 인쇄`,
"vue_label_report_preview":`최신 편집 확인하시겠습니까, 미리 보기 새로 고침.`,
"frame_personinfo_label_personimage":`프로필 사진`,
"component.chatter.button.like":`좋아요`,
"label.ems.drafts":`임시 보관함`,
"front-lightning-module-v1-details-page-chart-report-name":``,
"label.partner.workspace.login":`로그인 페이지`,
"include":`포함`,
"label_length_20":``,
"component_event_button_save":`저장`,
"label.weixin.recalculate.shared.success":`대상 공유 규칙 다시 계산 성공`,
"message.duplication.errorinscript.lessthan2":`병합할 기록을 최소 두 개 이상 선택해야 합니다!`,
"label_my_forecast":`나의 에측 사항`,
"label.ems.to":`수신인`,
"label_mobile_buttom_team_init":`채팅 사용자 초기 설정`,
"label.sendemail.send.codeerror":`코드 전환 실패, 정확한 코드를 사용하세요`,
"lable.quote.syncing.and":`및`,
"label.campaignmember.selectmember.step1oftotal":`1단계, 총 2단계`,
"label.ems.step3":`3단계`,
"lable.PowerProcess.detail.message":``,
"chatter.poll.option2":`선택 항목2`,
"front-view-module-v12-verify-number":``,
"label.setup.mobile.homepageshortcuts.savesuccess":`모바일기기 홈페이지 단축키 설정 저장 성공`,
"lable.outlook.edit.zdyoutfi":`사용자 설정 Exchange필드명`,
"label.assignment.setup.newentries.inputentries":`규칙 조항을 입력합니다`,
"label.customfields.money.tip":`사용자가 달러나 다른 화폐 금액을 입력할 수 있어 필드가 자동으로 화폐 금액 형식으로 전환됩니다. 이 기능이 데이터를 Excel이나 다른 차트로 내보낼 때 매우 유용합니다.`,
"label.service.appointmentList.cancelThePlan":``,
"label.chat.topic.suggest.add.topic":`건의 사항이 없으며 본인의 주제를 추가합니다.`,
"vue_label_commonobjects_detail_tips":`안내 말씀`,
"message.error.view.nameexists":`오류: 뷰의 유일한 명칭이 이미 존재합니다`,
"label_emailtocloudcc_step2_name":`배치 메일 소속`,
"label.field.validation.apiname":`반드시 알파벳으로 시작해야 하며 대소문자, 숫자, 밑줄, 최대 길이 50, 최소 2자리만 포함할 수 있으며 데이터베이스의 키워드가 될 수 없습니다`,
"page.field.masterinput.remark2":`예: 세일즈 주문을 새로 만들 때 같은 페이지에서 세일즈 주문 명세 항목을 입력해야 하며 이 기능을 사용하세요. (이 기능이 마스터 디테일 관계의 대상에 적합합니다)`,
"label.rule.enabled.successfully":``,
"label.role.createrolelist.tip":`다음은 귀조직의 역할 리스트입니다. 역할 링크를 클릭하여 상세 정보를 볼 수 있습니다.`,
"label.multilang.datamanage.dataimport.redundantmsg":`제목 길이가 &nbsp;{0}&nbsp;，하지만 데이터 길이는 &nbsp;{1}&nbsp;，시스템에서 어떤&nbsp;{2}&nbsp;개 필드가 필요없는지를 확인할 수 없습니다.`,
"label.visualpage.staticresource":`정적 리소스 도입`,
"chatter.group.members01":`멤버`,
"label.planned.workname":`과제 명칭`,
"label.service.dispatchingUnits.gantt.data":``,
"label.data.newtemplate.t.conditions":`템플릿 조건`,
"label.accmarketsea.edit.title":`고객풀 편집`,
"label_chatter_priority":`선순위`,
"label_mobile_buttom_team_open":`PC와 APP채팅 사용`,
"front-gantt-module-no-tasks-available":``,
"component.newrecords.label.type":`저장 종류`,
"label.version.ccdocument.and.remark":`첨부파일 및 비고`,
"label.martrixreport.step2":`2단계: 전체 정보를 계산할 그룹분류 방식을 선택하십시오`,
"label.projectManagement.Scheduleinformation":``,
"label.emailmerge.mergeFolder.description":`이 페이지에서 연락담당자 데이터를 포함하는 Microsoft Word 문서를 생성할 수 있습니다.메일 병합 템플릿을 선택하십시오. 최대 20개까지 선택 가능합니다.`,
"label.autoRegister.changepwd.setpwd.tip":`설정된 비밀번호는 다음의 몇 가지 조건을 만족시켜야 합니다`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":``,
"label.marketcloud_seminar":``,
"label.knowledgebase.no.results.knowledge.search":``,
"label.createdate":`생성 시간`,
"vue_label_systemSettings_bazaar":``,
"report_type_label_contractPayment":`계약서와 대금 수령`,
"label.myemailset":`나의 메일 설정`,
"label.emailtype":`메일 종류`,
"label.appexchange.uninstallpage.message5":`이 패키지의 사용자 설정 대상과 관련된 모든 관계와 리스트를 영구적으로 삭제합니다`,
"label.customerinfo.applicationlicencenum":``,
"label.product":`제품`,
"lable.opppdt.selPdt.subtitle":`제품 선택 사용은`,
"label_emailtocloudcc_step1_lead1":`잠재고객에게 메일 보내기`,
"label.multilang.recentview.query":`최신 {0} 보기`,
"label.cumstom":`사용자 설정`,
"lable.product.pep":`가격을 입력하세요`,
"label.suggestion":`의견`,
"vue_label_email_sentto":`됨`,
"label.email.cancel":``,
"component_timeline_label_1monthahead":`1개월 전`,
"setup_mainpage_label_welcome31":`조작 안내: 페이지 좌측 메뉴를 클릭하여 → 설정 관리 →생성 →응용 프로그램`,
"label.weixin.settlement.rate":`대금 회수 달성률`,
"front-lightning-module-v1-details-page-chart-add-report":``,
"label_related_list_types":``,
"label.tabpage.converstatez":`상태 전환 완료`,
"label.chatter.ok":`확인`,
"lable.SalesCommitmentKanBan.contractRate":`계약 달성률`,
"component.setup.label.setupsavefail":`구성 요소 설정 저장 실패`,
"label.email.form.text2":`【"HTML"로 전환됨】`,
"UG.Lead.009":`APP 통화 기록`,
"label.escalation.setup.newrule.title":`개별안 업데이트 규칙`,
"label.field.available.value":`선정 가능한 필드값이`,
"label.cannotuseaddtimetrigger":`<b>  시간 트리거 버튼 추가</b> 다음의 경우에 사용할 수 없습니다:<br/><ol><li>  규칙 조건이 매번 기록을 생성이나 편집할 때로 설정하여</li><li>  규칙이 사용되었습니다</li></ol>`,
"vue_label_chat_activefail":`개설 실패`,
"label.dashboard.show.total.percent":`총수 보기와 %보기 중에 최소 1개를 선택하세요`,
"label.schedulejob.setup.schedule.jobprg":`작업 프로그램`,
"label.select.email.type":``,
"chatter.group.allTheMembers":`모든 멤버`,
"label.webtab.validation.apiname":`알파벳으로 시작해야 하며 알파벳 대소문자, 숫자, 밑줄만 포함될 수 있어 최대 길이는 20, 최소 2 입니다`,
"label_partner_new_step3_name":`명칭`,
"vue_label_chatter_remove_member":`멤버 제거`,
"label.customobjects.majorobject.tip":`마스터 디테일 관계가 아닌 대상을 선택하면 통합 데이터는 권한으로 가지 않습니다`,
"label.forecast.edit.kjjd":`회계분기`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`셋째 주일`,
"label.weixin.senderror":`전송 실패`,
"label.visiturl":``,
"label.apply.img.error":`그림에 문자 입력이 잘못되었습니다.`,
"label.been.detained":``,
"vue_label_helpcenter_dashboard2":`새로 만든 대시 보드는 우선적으로 구성 요소를 추가해야 되어 보고서 데이터나 리스트 뷰 데이터 소스를 선택한다.확정된 차트 유형으로 관련된 그룹과 통계 데이터를 선택해 차트를 작성한다 <br>    구성 요소를 추가한 후 대시 보드의 '다시 배열하기'버튼을 통해 구성 요소의 위치와 사이즈를 조정한다 <br>     일부 구성 요소에 시간에 관한 조건을 설정하려면 '선택 조건 설정'을 클릭하여 구성 요소를 선택한다. 구성 요소의 시간 필드를 설정해 대시 보드의 시간으로 선별할 수 있다. 대응한 시간 범위로 선정된 데이터를 업데이트된다. <br>    주의: 한 대시 보드에 최대 구성 요소는 10개이다. <br>2、구성 요소의 침투 및 연동<br>     같은 대시 보드에 구성 요소 A가 같은 데이터 소스에서 온 구성 요소B와 구성 요소C와 연결해 연동 대상자로 설정 가능하다. 설정 후, 구성 요소A의 한 데이터 존을 클릭하여 구성 요소B와 구성요소C가 구성 요소A의 데이터 조건에 따라 다시 통계된다. <br>    주의,구성 요소B나 구성 요소C의 데이터 존을 클릭하면 구성 요소A의 데이터가 다시 통계되지 않는다. 같은 효과를 내려면 구성 요소B/C에서 구성요소A를 연동대상자로 설정해야 된다. <br>    모든 대시보드의 차트 구성 요소의 데이터는 뷰나 보고서에서 온다. 그래서 침투 기능을 제공한다. 즉, 구성 요소의 데이터 존을 클릭하면 대응한 보고서나 리스트 뷰로 이동 가능하다. 주의, 원래의 데이터 소스가 무효된다면 구성 요소도 무효되어 침투 기능도 무효된다. <br>    침투와 연동은 구성 요소의 데이터 존을 클릭하는 것이라서 2가지 동작이 동시에 가동 불가능하다. 구성 요소에 동시 침투와 연동 기능을 설정했다면 해당 구성 요소는 동시에 하나의 기능만 발효되며 연동 및 침투 상태를 전환함으로써 효과 기능이 변경된다.`,
"vue_label_commonobject_view_notice_delete_false":`{0}기록 삭제 실패, 원인은 {1} 입니다;`,
"label.weixin.newspaper.coverage.information":`보험 신고서 정보`,
"label.you.do.not.have.permission.to.operate.":``,
"label.checkfield.match":`매칭`,
"message.custom.field.donotdelete.ref":`해당 필드가 다른 필드에 인용되었습니다`,
"label.version.maxsum":`상한에 도달했습니다!`,
"System.ChangeUser.Info.001":`소유인 변경 성공, 관련 기록을 확인 권한이 없으며 클릭한 후 이전 페이지로 이동한다.`,
"label.target":`목표`,
"template.dashboard.behavior.analysis":``,
"label.login.verification.enter.prompt":`6자리 보안코드를 입력하세요`,
"label.am":`오전`,
"chatter.emailSetUp.remark":`CCChat 페이지가 사용자에 대한 팔로잉 및 게시물에 대한 조작에 적용해 메일 전송 여부의 설정을 선택합니다`,
"label.accmarketsea.grouplist.title":`고객풀 그룹 분류 설정`,
"label.stdashbord.xsld.business.danwei":`단위: 만 위안`,
"label.app.step1.error.namenull":`공용 그룹 명칭을 입력하세요`,
"label.login.button.verification":`인증 제출`,
"label_tabpage_newWizardz":`신규 기능 안내 메뉴`,
"label.addattachment.step1.intruduce":`파일 경로를 입력하거나 파일 찾기 버튼을 클릭합니다`,
"pagecreator.layout.funcpath":`/빌더/레이아웃 베이스`,
"fourth":`4번째`,
"label.timetrigger.after.lasttime":`최후 수정 시간보다 1일 늦었습니다`,
"vue_label_report_showme":`나에게 보여주기`,
"label.h5.similar.opportunity.end.date.in":`종료시간이 다음의 사간 안에 있습니다`,
"label.turntonextstep":`다음으로 이동`,
"label.icon.106":`일정`,
"label.user.receivenewsbulletin":`뉴스 브리핑 접수`,
"label.mask.card.number":`신용카드 번호`,
"setup.object.layout.label.profileoptions":`분배 가능한 프로필`,
"vue_label_systemSettings_obj":``,
"label.call.center.history.open":`통화 기록 페이지 자동 열기`,
"label.attendance.cityname":`도시명을 입력하세요`,
"label.newemailnotice.tip":`메일 알림을 생성해 한개나 여러개 업무 프로세스 규칙, 승인 과정과 연동시킵니다. 메일 알림을 변경하면 모든 수정이 관련된 모든 규칙, 승인에 적용됩니다.`,
"label.app.step1.error.labelnull":`오류: 라벨을 비워둘 수 없습니다`,
"front-kefu-moudle-connect-free-account":``,
"label.biaoqingfaxian.description":`입찰 및 낙찰 정보 발견을 체크 사용하여 앞부분에서 입찰 및 낙찰 정보 발견의 메뉴를 추가할 수 있어 관련 산업의 입찰 및 낙찰 정보를 확인할 수 있으며 입찰 및 낙찰 정보 데이터를 시스템 내부의 잠재 고객으로 전환할 수 있습니다.`,
"label.filter":``,
"label.data.downpage.e.title.num1":`1. 내보낼 데이터의 대상자를 선택하거나 모두 내보내기를 선택하세요.`,
"label.h5.similar.opportunity.last.months12":`최근 9-12개월`,
"label.chatter.name":`명칭`,
"vue_label_helpcenter_email":`1. 메일 전송<br> 시스템에서 떠나 메일로 연락담당자와 메일을 주고 받는 시간이 이미 지나갔다. CloudCC에서 개인 메일을 관련시켜 CloudCC에서 직접 메일을 전송할 수 있다. 수신자에서 메일 주소 및 명칭을 입력할 때 연락담당자나 잠재 고객의 기록을 모호 매칭시킨다. 메일 기록이 배치된 관련 기록을 연동시켜 기록 상세 정보 페이지에서 메일을 동기화시킨다. <br>2. 메일 전송의 4개 기능 <br> 메일을 전송할 때 메일 정문 밑에서의 4개 기능을 사용할 수 있어 업무에 도움이 된다. <br>메일 추적 <br> 메일 추적을 설정하면 해당 메일의 열기 횟수 및 최후 확인 시간을 모니터링 해준다. 마우스가 메일 발신함 리스트의 '눈'아이콘 위에 머무르면서 확인할 수 있다. <br>첨부 파일 업로드 <br> 업로드할 첨부 파일을 클릭하여 이미 시스템에서 업로드된 파일을 선택할 수 있거나 직접 파일을 업로드할 수 있다. 여러개 첨부 파일을 선택할 수 있어 첨부 파일의 최대 크기는 20M이다. <br>병합 필드 삽입<br> 메일에서 한 대상자 기록과 연동시키면 병합 필드를 삽입하거나 관련 대상자를 선택할 수 있어, 삽입하고 싶은 필드를 선택해 병합 필드의 콤마 뒤에 대체 텍스트를 입력한다. 예를 들어 {!Contact.FirstName,Sir or Madam}. 템플릿을 저장한 후 병합 필드가 템플릿의 메일 정문에서 나타난다. 병합 필드 개인 설정으로 메일 내용을 설계한다. 모든 병합 필드에서 대체 텍스트를 추가할 수 있다. 병합 기록이 해당 필드의 데이터가 포함하지 않을 때만 대체 택스트가 나타난다. <br>서명 편집 및 사용 <br> 업무 메일을 전송할 때 본인 신분을 대표할 수 있는 서명이 업무의 전문성을 제고시킨다. '서명 편집'버튼을 눌러 기본 정보를 편집할 수 있어 이미지도 추가 가능하다. '서명 사용'을 체크하면 메일 쓸 때마나 정문에서 서명이 붙인다. 언제든 서명 기능을 닫을 수 있다. <br>3. 수신함 선별 <br> 수신함에서 읽지 않는 메일을 선별해 업무를 처리한다. 메일을 통해 파일을 다운로드할 때 메일 수신함에서 첨부 파일이 있는 메일을 선별해 빠르게 메일을 찾을 수 있다. 이 외에, 닫지 않는 업무 기회의 메일이나 발신자가 잠재 고객이나 연락담당자인 메일을 선별할 수 있어 메일을 통해 시스템 내부 고객의 기록을 팔로우업한다. <br>4. 메일 단체 전송 <br> 잠재 고객, 연락담당자 리스트 우상측에 단체 메일 전송 버튼이 있어 메일 주소가 있는 잠재 고객이나 연락담당자에게 메일을 전송할 수 있다. 마케팅 행사 기록이 있을 때 마케팅 행사 멤버에게 단체 메일을 전송하여 편하게 행사 초대장을 전송한다.`,
"front-kefu-moudle-auto-callphone":``,
"label.fiscal.FQ":`회계 분기`,
"label_tabpage_groupsVisiblez":`일부 사용자 그룹만 볼 수 있음`,
"UG.product.01":`제품/서비스 열거한다`,
"vue_label_commonobjects_view_members":`선택 가능한 멤버`,
"label.organization.id":`조직 ID`,
"label.tyle_preview":``,
"label.campaign.channel.input.to.owner":`6. 소유인에 대한 멤버 출석 통지 여부를 설정하세요:`,
"label.appointmentconfirmpage.wizard.notif1":`예약이 취소되었습니다`,
"lable.tianyancha.maping":`필드 매핑`,
"front-kefu-moudle-v1-noadd-online-chats":``,
"vue_label_commonobjects_detail_group_strategy":`해당 고객 채팅을 가입하시겠습니까?`,
"vue_label_report_deletegrouprow":`행 그룹 삭제`,
"lable.account.y.d":`이 페이지에서 사용자 설정 회계 연도 기록을 정의할 수 있습니다. 사용자 설정 회계 연도의 일자는 다음의 선택으로 생성됩니다.`,
"label.visualpage.lllegal.definitions":`비합법적 정의`,
"label.tabpage.enterrecordnamez":`기록 소유인을 입력하세요`,
"vue_label_report_howmuchlines":`{length}행`,
"homepage.components.custom":`사용자 구성요소`,
"label.campaign.channel.upload.img":`이미지 업로드`,
"UG_Case_03":`개별안 자동 업드레이드`,
"label.approved.receiveApprovalEmail.option4":`절대 하지 않음`,
"System.Data.Import.Warning.MaxCount":`귀사에서 매번 데이터 {0}개만 불러오기 가능하며 지금 이미 초과하여 조정 후 다시 시도하세요.`,
"label.sent.sms":``,
"vue_label_dashboard_statistictype":`통계 유형`,
"label_report_last_year_same":``,
"lable.Examle":`예시`,
"label.customerinfo.PageTriggerFagTitle":`두시간 만에 동기화시킬 수 있습니다`,
"label.mobile.phone.read":`검토`,
"label.product.gopage":`이동`,
"label.a_b_without":`"A"기록에 관련된 "B"기록이 있거나 없을 수 있습니다.`,
"front-kefu-moudle-callin-missphone":``,
"label.sso.saml.sp.idsource.attrname":`속성 명칭`,
"label.h5.chatter.colleagues2":`동료`,
"label.approveprocess":`승인 과정`,
"label.dataimport.error.name.null":`오류 발생: name이 비어 있습니다.`,
"label.paging.countitems":`{0}개`,
"vue_label_report_notice_filter":`고급 선별을 사용하지 않을 때 다른 선별에 각 조건 관계는 '및' 이어 즉 1과 2의 공동 특징에 부합한 기록이 보고서에 나타납니다. 예를 들면: 1이 금액이 100만 위안을 넘는 업무 기회이며, 2가 예상 계약 일자가 이번 달인 경우, 보고서 결과는 이번달에 100만 위안을 넘는 업무 기회입니다.`,
"front-lightning-module-v1-dashborad-export-picture":``,
"label.activity.disabled":`행사가 활성화되지 않았습니다. 시스템 관리자에게 연락하여 페이지 레이아웃에서 행사 이력과 처리되지 않은 이벤트를 활성화하십시오.`,
"message_chooseatleastonefield":``,
"label.case.text":``,
"label.sendmail.step3.dealoption1":`모든 메일을 숨김 형식으로 나에게 참조 전송합니다`,
"label.forecast.settings.title.remark":`사용자에게 수입의 최적 추정치를 예측해줍니다. 이러한 예측은 사용자에게 완전한 업무 뷰를 제공할 수 있습니다.`,
"label.apply.youxiaotime.finish.opperation":`유효 시간 5분, 되도록 빠르게 작업을 완료해 주세요. 본인이 조작하지 않는다면, 본 문자를 무시하십시오.`,
"label.user":`사용자`,
"pagecreator.page.button.copy":`복사`,
"label.userinfo.pwdupdate.or.reset":`비밀번호의 변경이나 다시 설정`,
"label.fieldupdata":`필드 업데이트`,
"label.sendemail.chat.followsubject":`CloudCC CCChat 팔로워가 있습니다`,
"component_task_label_enddate":`만료 기간`,
"label.campaign.channel.step6.remark5":`잠재 고객 분배 규칙을 통해 다시 분배할 수 있습니다. 분배 규칙에 대해`,
"label.mr.title.mobilePhone":`핸드폰`,
"label.notice":`알림`,
"message.serviceappo.time.violation":``,
"label.account":`고객`,
"front-kefu-moudle-callcenter-user":``,
"label.usermanage.query.notexist":`검색한 사용자가 없습니다`,
"label.forecast.userinfo.isnable":`예측 허용`,
"label_partner_workspace_member":`멤버`,
"vue_label_dashboard_penetrationsetting":`침투 설정`,
"chatter.fieldtrack.operatecreate":`1개 생성했습니다`,
"label_tabpage_tpcustomersz":`잠재고객 전환`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP 인증 실패, 이메일 주소 및 비밀 번호를 다시 확인하세요`,
"label.customfields.file.upload":`업로드`,
"label.forecast.isforecast":`수익 예측 미사용`,
"label_benchmark":``,
"label.exchange.sync.state.system":`시스템 동기화 상태`,
"UG.opportunity.003":`마케팅 채널 팔로우업, 대시 보드 생성`,
"label.campaign.matchway.select.error":`데이터를 업데이트하려면 매칭하는 방법을 선택하십시오`,
"vue_label_dashboard_located":`대시보드가 소속한 폴더`,
"front-electronic-signature-enter-object":``,
"vue_label_systemSettings_mobelquick":``,
"lable.outlook.list":`Exchange Sync 배치`,
"label.sendemail.approval.dlsp":`안녕하세요. #dlspr：\n      #actorname于#actordate 제출한 #objAPIName-#recordname 전 승인자가 #spr 님을 대리 승인자로 설정해 님의 승인을 기다리고 있습니다. \n 다음의 링크를 클릭하거나 CRM 시스템에 로그인하여 승인 센터에서 승인을 진행하세요: \n#url\n감사합니다! \n#orgName`,
"label.service.deleteCustomView.wanttoremove.filter":``,
"component_task_label_newevent":`업무 새로만들기`,
"vue_label_commonobjects_view_chart_groupby":`그룹 분류 근거`,
"front-kefu-moudle-v1-edit-chats":``,
"pagecreator_page_message_delete_fail":`페이지를 삭제하는 데 실패했습니다.`,
"label.file.search":`파일 검색`,
"label.projectManagement.Addpredecessors":``,
"label_tabpage_norecordtypez":`사용 불가한 기록 유형`,
"label.come.recycle.bin":`휴지통으로 이동`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`상대`,
"label.customfields.address.tip":`사용자가 성, 시, 현 필드를 선택할 수 있어 구체 주소 정보를 입력할 수 있으며 경위도를 계산하는 데에 쓰입니다.`,
"label.weixin.optioneight":`선택항목8`,
"label.recordtypeselect.modify":`기록 유형 편집`,
"label.forecast.settings.future3":`미래 3개 주기`,
"label.rename":`리네임`,
"label.emailtocloudcc.button.complete":`완성`,
"chatter.new.at":`최신 행사`,
"component.setup.label.milestonesfield":`이정표 필드`,
"vue_label_commonobjects_detail_email_newaddress":``,
"lable.PowerProcess.big.event":``,
"label.appexchange.uninstallpage.confirm":`네. 이 소프트웨어 패키지를 삭제하고 관련된 구성 요소를 영구히 삭제하겠습니다.`,
"label_mobile_buttom_homepage":`메인 홈페이지`,
"label.sso.saml.idp.config.logouturl":`싱글 로그아웃 URL`,
"lable.quote.pdf.button.savetoquote":`견적서에 저장`,
"label.page.select.application":`새 사용자 설정 메뉴를 사용할 설정 응용프로그램을 선택하십시오.사용자 설정 응용 프로그램의 상세 정보와 편집 페이지에서 메뉴 표시 여부를 점검하거나 수정할 수 있습니다.`,
"chatter.down":`다운로드`,
"label.tabpage.searchz":`검색`,
"label.emailsync.form.action":`작업`,
"label.campaignmember.setup.campaignmember.field":`마케팅 행사 멤버 필드`,
"label.version.remark":`비고: 무료 버전이 5개 사용자를 제한하여 최대 2000개 기록을 새로 만들 수 있고 데이터를 불러오거나 내보낼 수 없습니다.`,
"label.selectoperateobject":`조작 대상을 선택합니다`,
"label.appointmentdetail.wizard.title12":``,
"label.submitforapproval":`대기 승인 제출`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":``,
"label.appupload.install.component.view":`구성요소 보기`,
"label.profile.customobjcontrol":`사용자 설정 대상 권한`,
"label.customfields.configprofilefieldsafety.tip":`필드급 보안성을 통해 이 필드에 대한 접근 편집 권한을 부여하는 프로필을 선택하십시오.이 필드를 필드급 보안성에 추가하지 않으면, 프로필에 표시되지 않습니다.`,
"label.service.gantt.service.resources":``,
"label.input.right.emailaddress":`정확한 메일 주소를 입력하세요`,
"label.ccdocument.folder.notedit":`해당 폴더 편집할 수 없습니다!`,
"label.data.choses.i.desc":`필요에 따라 불러올 단일한 대상자의 데이터를 선택하시오.`,
"label.icon.75":`자동차`,
"label.summaryreport.step4":`4단계: 보고서열을 선택합니다`,
"label.appupload.upload.install":`설치`,
"label.reportlist.newfolder":`보고서 폴더 새로만들기`,
"label.projectManagement.myproject":``,
"label.true":`참`,
"label.tabpage.reallproplez":`기록 소유인`,
"label.change.lead.share.error":`고객 편집 권한이 없습니다`,
"F":`일자/ 시간`,
"lable.account.CurrentandNextCQ":`현재와 다음 캘린더 분기`,
"UG.activity.06":`고객을 팔로우업한다`,
"UG.contact.03":`한 곳에서 연락담당자를 추적, 마케팅 신호`,
"label.field.duplicate.error.msg2":`특유 속성 설정 실패`,
"label.sales.dashboard.reality":`실제 대금 회수`,
"lable.PowerProcess.type":``,
"batch.selected.data":`선정한 데이터 개수`,
"#label.importsourcefilestep2":`2단계: 파일을 압축합니다(선택 가능)#`,
"label.emailtemplate.select":`원하는 메일 템플릿을 선택하세요`,
"chatter.most.w":`최대 500개 문자까지 입력 가능합니다!`,
"vue_label_calendar_new_object_calendar":`대상자 캘린더 새로 만들기`,
"label.aggregated_formsdata":``,
"label.knowledge.language.french":``,
"label.customfields.enc.tip":`사용자에게 모든 알파벳과 숫자 조합을 입력할 수 있도록 하며, 그들을 암호화 형식으로 저장하여 검색할 수 없습니다.`,
"label.icon.158":`클라우드`,
"font-evaluate-module-v1-bad-review ":``,
"UG_quota_03":`견적 템플릿`,
"label.eidt.queue.label.hasused":`해당 라벨이 사용되었습니다`,
"label.lookupfilter":`필터 찾기`,
"label.callcenter.Instance.name":``,
"label.commitertype":`제출인 유형`,
"vue_label_checkduplicate_any_one":`임의 한 조항에 적합하기`,
"label.campaign.channel.input.img":`컴퓨터에서 이미지를 선택해 감사 페이지를 제작합니다`,
"vue_label_dashboard_pleaseenterafoldername":`폴더 명칭을 입력하세요`,
"label.tianyancha.look":`보기`,
"label.tabpage.lastone":`최소한 하나의 작업을 선택하시오`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} 승인을 대기하고 있습니다`,
"label.chat.topic.delete.prompt1":`주제를 삭제하는 데 시간이 걸리며 완성될 때까지 주제가 계속 게시물과 기록에 남아 있습니다.`,
"component_setup_label_displaybutton":`보기 버튼`,
"label.partnerCloud.backgroundImage":``,
"label.mobile.phone.time.range":`시간 범위`,
"label.page.url.address.remark":`"링크 URL" 필드에 웹 주소를 입력하십시오.웹브라우저에 보여지는 양식과 같은 URL 주소를 간단하게 입력할 수도 있고, 한 개나 여러개 병합 필드를 사용해 조직의 특정 데이터를 CloudCC에서 URL 파라미터로 삽입할 수 있습니다. 브라우저 보안 설정이나 사이트가 프레임워크에 표시되는 것을 막기 때문에 Web 메뉴에서 일부 사이트가 잘못될 수 있습니다.`,
"label.h5.copyemail":`메일 주소가 복사되었습니다`,
"label.view.step3":`단계 3. 표시할 필드를 선택하십시오`,
"label.quickbooks.view.moneyreceived":`대금 수령`,
"label.emailobject.attachment.preview":`미리 보기`,
"label.selectapprover":`승인자 선택`,
"vue_label_normal_opportunity_sf":`업무 기회`,
"label_emailtocloudcc_filed_port":`포트`,
"mesage.errorinsaving":`저장 과정에 오류가 발생해 관리자에게 연락하세요`,
"label.partnerCloud.partnerCloudName":``,
"lable.edit.queue.checkemail":`에러: 무효한 메일 주소입니다.`,
"label_builder":`페이지 빌더`,
"component_setup_label_setupsavefail":`구성요소 설정 저장 실패`,
"label.icon.76":`자동차`,
"label.reportsSubscriptionPage.schedulereport.monthly":`매달`,
"message.nopermession":`권한 부족`,
"label.view.groupscansee":`일부 <b>사용자 그룹</b> 볼 수 있습니다`,
"label.leadscore.rule.new":`잠재고객 채점: 규칙 새로만들기`,
"label.new.ccpeakfolder.time":`타이머 클래스: 폴더 새로만들기`,
"label.record":`기록`,
"message.error.flabel":`필드 라벨에 영문 작은 따옴표와 큰 따옴표가 포함될 수 없습니다`,
"label.emailobject.emaildetail.promptbutton2":`취소`,
"label.h5.phone":`전화`,
"label.visualpage.error.deal.with":`에러가 발생했으며 관리자에게 연락하세요`,
"label.button.step1.select.field":`1단계: 필드를 선택합니다`,
"label.setsharerule.step1":`1단계: 설정할 규칙 유형을 선택합니다`,
"component.chatter.file.label.title":`파일 업로드`,
"front-epwechat-module-v1-appname":``,
"chatter.error.notsel":`오류: 업로드할 이미지를 먼저 선택하세요!`,
"label.updatevalue":`변경할 정확한 값`,
"label.chatter.sendEmailToGroupMember.subject.D":``,
"label_tabpage_grid":`그리드 보기`,
"homepage.components.standard":`표준 구성요소`,
"label.movable":`행사`,
"label.report.selected.field.cannot":`최대 50개 필드를 선택할 수 있습니다`,
"label.projectManagement.distribution.by.excess":``,
"addrow":`행 추가`,
"label.approvaldatamove.p":`다음의 선택항목을 사용해 여러개 승인 대기 요청을 관리합니다. 시작하려면 승인 요청 기록을 필터링하여 '찾기'를 클릭합니다. 결과 리스트가 나타날 때 실행할 조작을 지정합니다.`,
"label.passwordPolicy.setup.title":`비밀번호 전략`,
"label.appointmentpage.wizard.title1":`{0}（{1}）님을 초대합니다`,
"label.tippage.li1":`사용자 설정 보고서 데이터 소스 영구 삭제`,
"label.campagin.roi.dcl":`출석률`,
"label.h5.new.errorbody":`*표시된 필수 입력 필드를 모두 입력하세요`,
"label.cy.enable":`화폐 종류 사용`,
"label.currency.rate.e":`귀조직이 사용한 화폐 종류간의 환율을 편집합니다.`,
"or":`혹은`,
"lable.custom.Previous.CYt":`지난 2개 사용자 설정 연도`,
"front-epwechat-module-v1-unbound-desc":``,
"pagecreator_button_publish":`발표`,
"font-evaluate-module-v1-case-owners":``,
"label.pw.new":``,
"message.tabsearch.nokeywords":`최소 한 문자 길이의 키워드를 입력하십시오`,
"label.sendemail.send.erroruser":`잘못된 사용자`,
"label.personalinfo":`나의 개인 정보`,
"label.case":`개별안`,
"lable.product.pricebooks.now":`기존 가격매뉴얼`,
"label.ccpeak.take.notice":`주의: ID, 자동 번호, 작성자, 생성 시간 등 시스템 필드에 값을 부여할 필요없습니다!`,
"label.page.first":`첫 페이지`,
"label.icon.168":`관광지`,
"label.choices":``,
"label.is.delete.document":`파일을 삭제하시겠습니까?`,
"homepage.layout.custom":`사용자 설정 레이아웃`,
"label.emailobject.template.insert.field":`필드 삽입`,
"label.ccpeak.folder.all":`모든 종류 폴더`,
"front-console-conversation-btn3":``,
"label.ems.port":`포트 번호`,
"label.app.introduce":`응용프로그램은 한 단위로 기능을 제공하는 메뉴입니다. 사용자가 페이지의 우상측에서 드롭다운 리스트에서 응용프로그램을 선택할 수 있어 메뉴가 다른 응용프로그램에서 직접 변환합니다.`,
"label.file.library.managemembers.admin":`문서 라이브러리 관리자`,
"vue_label_salesadvance_win":``,
"label.email.click.complete.info":`'완성' 버튼을 누르면 이전 페이지로 돌아갑니다`,
"label.umeng.activity.event.willbegin":`님의 이벤트#event 곧 #time 후에 시작됩니다`,
"label.mobile.phone.week.summary":`이번주 총정리`,
"label.quickbooks.fieldlabel.terms":`조항`,
"lable.currencyManage.advcurrencyEnabled.dis":`화폐 환율을 특정한 일자 범위에 지난 환율에 매핑할 수 있습니다. 유통기한이 지난 환율은 업무기회, 업무기회제품과 이 두 대상에 관한 보고서에 적용됩니다.`,
"label.weixin.data.save.failed":`데이터 저장 실패`,
"label.service.gantt.filter.logic":``,
"vue_label_pool_adopt":`수령`,
"label.emailobject.markasunread":`읽지 않음`,
"label_please_select_a_member":``,
"label.salescloud.unit.ci":`단위(개)`,
"vue_label_pool_obsolete":`폐기됨`,
"label.cancelall":`모두 선택 취소`,
"label.exchange.sync.state.setting.m2":`CloudCC Exchange 배치를 사용한 사용자:`,
"vue_label_pool_claimtime":`수령 시간`,
"label.forecast.forehistory.history":`의 예측 이력`,
"label.knowledge.article.record":``,
"label.setting.intergrationlist.button.uninstall":`통합 삭제`,
"label_tabpage_gotit":`알겠습니다`,
"label.data.exp.csvform":`데이터 내보내기에만 유효합니다`,
"UG.Forcast.06":`예측 허용된 사용자를 선택하시오`,
"vue_label_report_savereport":`보고서 저장`,
"setup.object.field.dependency.label.mustone":`최소한 하나의 의뢰 필드 값을 설정하세요.`,
"label.batchadd.newbatchpage.des1":`기록의 name 필드가 필수 입력 항목이며 입력하지 않을 시 해당 데이터가 저장되지 않습니다`,
"lable.custom.CurrentandPreviousCYt":`현재 및 지난 2개 사용자 설정 연도`,
"label.versiontype.Professional":`전문 버전`,
"label.customfields.configprofilefieldsafety":`프로필 필드의 안보성을 배치합니다`,
"label.ccpeak.wgd.time":`미보관 타이머 클래스`,
"component.telerecord.label.subject":`주제`,
"label_year":``,
"pagecreator_layout_label_modifylayout":`레이아웃 에디터`,
"label.compact.layout.frame.splitline":`----좌우 화면분할선----`,
"lable.PowerProcess.enter.the.process":``,
"label.emailobject.cc":`참조:`,
"front-electronic-export-choseCount":``,
"label.setup.mobile.bottombutton.recovery.default.success":``,
"label.datamanage.import.accountfield":`다음 표에서, 불러온 파일에서 각 고객에 불러올 필드를 선택하십시오.작업을 완료한 후 다음을 누르십시오:`,
"vue_label_opportunity_related_list":`관련 리스트에 추가`,
"label.group.recent":`최근 보는 그룹`,
"vue_label_pool_finalclaimtime":`최후 수령 시간`,
"vue_label_homepage_30daysnocontact":`30일동안 미연락한 업무 기회`,
"label.tianyancha.field.error":`TIAN YAN CHA필드를 찾을 수 없어 시스템 관리자에게 연락해 초기 설정부터 실시하세요`,
"label.product.go":`보고서로 이동`,
"label.customsetting.manage.introduce":`사용자 설정이 리스트면 새로만들기를 클릭하여 새 데이터를 추가합니다.예를 들어 프로그램이 국가 코드 설정을 가지고 있으면 각 그룹에는 국가의 이름과 전화 코드가 포함될 수 있습니다.`,
"label.task.dateadd":`플러스`,
"label.email.recipients.select":`수신인을 선택하세요`,
"chatter.emailListMyChat":`나의 게시물이나 댓글에 '좋아요'를 받을 때`,
"label.batchadd.newbatchpage.save.name":`이름이 비어 있으면 시스템에서 이 기록을 추가하지 않습니다. 이름이 비어 있는지를 확인하시고 저장하십시오`,
"UG_Lead_011":`고객 경로 생성`,
"vue_label_salesfunnel_notice2":`진행 중인 기회의 총량`,
"APPIntegration_Social_linkedinerror":`합법적인 linkedin.com의 URL이어야 됩니다.`,
"label.industrialandcommercialverification.enablestatus2":`고객명 실시간 검색`,
"label.stdashbord.xsld.business.ajssx":`역할 선별`,
"lable.info.queue.showalluser":`모든 사용자 보기`,
"label.generatepage.c1":`알파벳으로 시작해야 하며 알파벳 대소문자, 숫자, 밑줄만 포함 가능합니다`,
"label.thenset":`다음은`,
"label.salescloud.salescloud.defaultteam":`사용자의 기본 업무기회 그룹`,
"label_partner_workspace_tab_selectedoption":`이미 선택한 메뉴`,
"label.tippage.li":`사용자 설정 보고서 데이터 소스를 삭제하면:`,
"lable.quote.syncingfrom.syncingto":`업무기회 제품이 견적명세서와 동기화되었습니다.`,
"label.emailobject.delete":`삭제`,
"label.data.selectimportobject":`불러올 대상을 선택합니다`,
"label.knowledge.language.dutch":``,
"message.campaign.page.overtime":`페이지의 기한이 지났습니다`,
"label.ccchat.message.search.desc4":`검색 키워드의 철자를 검사합니다.`,
"label.login.forgetPsd":`비밀번호 분실`,
"vue_label_title_order":`구매`,
"template.report.contract.follow.status":``,
"label.forecast.edit.kjnd":`회계 연도`,
"front-electronic-export-listTitle":``,
"label.dataimport.error.khmc.notnull":`오류 발생: 고객 명칭이 비어 있을 수 없습니다.`,
"label.testobject":`테스트 대상`,
"label_chatter_nextStep":`후속 절차`,
"label.file.public.link.share":`공용 링크 공유`,
"label.weixin.organization.name":`조직 명칭`,
"label.quote.email":`메일`,
"label.reg_field":``,
"font-evaluate-module-v1-response":``,
"label.chatter.sendmail":`메일 발송`,
"label.weixin.start.incorrect":`시작일 일자 형식이 잘못되었습니다`,
"component_chatter_link_label_url":`링크 URL`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`네. 고급 화폐 관리를 사용하겠습니다.`,
"label.east.africa.time":`동아프리카 시간`,
"label.product.proof.Three":``,
"label_emailtocloudcc_filed_password":`메일 암호`,
"component.task.label.person":`*피분배자`,
"pagecreator_systemstyle_label_buttonareacolor":`작업 공간 색깔`,
"label.clearrule":`규칙 비우기`,
"lable.customer.access":``,
"label.finish.wait":`요청이 처리되었습니다. 시스템 처리가 완료될 때까지 기다려야 합니다. 메일을 수시로 확인하십시오.`,
"label.weixin.appr.auditor":`승인자`,
"label.tabpage.systemz":`개 시스템`,
"label.file.nocan.process.desc":`요청을 처리할 수 없습니다. 내용 전달을 처리할 수 없습니다.`,
"label.relationobject.name":`관련 대상 명칭`,
"setup.layout.group.relatedlist":`관련 리스트`,
"label.generatepage.title":`Web to CloudCC 페이지`,
"label.page.step3.input.url.information":`3단계: URL 상세 정보를 입력하십시오`,
"label.change.to":`마케팅 행사 멤버 상태 변경`,
"label.validate.function.funcFormat.TIMEVALUE":`시간값(일자)`,
"label.partnerCloud.seriesSettings":``,
"component.timeline.label.1monthahead":`지난 한달`,
"label.batchadd.senumberpage.selnum":`추가 기록 수량을 선택합니다`,
"label.downloadapp":`App 다운로드`,
"label.dashboardSetup.showmainpage":`시작페이지에 표시`,
"label.h5.nophoneprompt":`해당 동료는 연락처를 입력하지 않았습니다.`,
"label.service.deleteCustomView.wanttoremove.theFilter":``,
"label.appupload.state1":`업로드 완료`,
"component_timeline_button_filter":`선별하기`,
"label.passwordPolicy.setup.subtitle":`모든 사용자의 암호 제한과 로그인 잠금 정책에 대한 적용을 설정합니다`,
"vue_label_normal_quote_sf":`견적서`,
"label.productsales.today.noevttskaddall":`오늘 미처리 이벤트나 만료된 업무가 없으며 우상측의 " "를 클릭하여 업무나 이벤트를 추가할 수 있습니다!`,
"label.projectManagement.no.end.date":``,
"label.sendmail.batch.chosetemplate":`메일 모두 전송: 템플릿 선택`,
"serviceterritorymember.serviceresource.isactive.notactive":``,
"label.notification.event.overlapEvent.continue":`계속 생성`,
"label.appupload.component.type.obj":`사용자 설정 대상`,
"label.partnerCloud.financeSetting.basicConfiguration":``,
"lable.outlook.detail.info":`Exchange Sync 배치 상세 정보`,
"vue_label_commonobjects_detail_activity_commingevents":`곧 진행될 이벤트 보유`,
"coderules.nullvalue2":``,
"label.version.sum.workflowrule":`개 업무프로세스 규칙`,
"label.sso.saml.idp.config.enable":`신원 제공자 사용`,
"label.temp.exp.conf":`템플릿을 내보내시겠습니까?`,
"label.department":`부서`,
"label.trigger.operation.email.template":``,
"label.page.content.frame.height":`콘텐츠 프레임 높이(픽셀)`,
"label.ServiceCloud.jinengyaoqiu":``,
"PageLayout.Search.MultiSearch.001":`최대한 3개 필드만 선택 가능합니다.`,
"label.error500":`앗! 오류가 발생했습니다...<br />시스템 관리자에게 연락하세요...`,
"label.appexchange.download.stop":`충돌 시 설치를 중단합니다`,
"label.service.dispatchingUnits.left.right.totalAll":``,
"label.tabpage.haschangedz":`해당 잠재 고객 이미 전환 완료`,
"label.industrialandcommercialverification.button.cancel":`취소`,
"label.edit.role":`역할 수정`,
"label.mr.descreption.condition2":`규칙-앞자리 여러개 문자부호대로: 숫자를 입력해 입력한 숫자 앞자리 여러개 같은 문자부호로 중복 데이터를 찾습니다.`,
"label.testgrammer":`문법 검사`,
"label.age":`나이`,
"lable.real.time.chat":``,
"vue_label_opportunity_selected":`{sum}개를 선택함`,
"label.weixin.optionone":`선택항목1`,
"label.file.delete.public.link.desc":`공용 링크를 삭제하면 아무도 해당 URL이 포함된 파일을 방문할 수 없습니다. 신 공용 링크를 생성하면 다른 URL로 됩니다.`,
"label_tabpage_cancel":`취소`,
"template.report.opportunity.analysis":``,
"label.escalation.setup.newrule.inputrule":`규칙명을 입력합니다`,
"label.ccpeak.getapi.name":`기록값을 획득 시 필드의 API명칭을 직접 get합니다:`,
"second":`2번째`,
"label_tabpage_uploadsz":`업로드`,
"label.description":`비고`,
"label.ccchat.person.invite.notsamepwd":`비밀번호가 일치하지 않습니다`,
"label.mobile.app.isEnableAblumWatermark":`출석 시 핸드폰 캘러리에서 선택한 사진에 워터 마크를 추가합니다`,
"vue_label_allsearch_searchable_items":`검색 가능 항목`,
"lable.outlook.detail.react":`최근 행사`,
"label.sales.team":`업무기회 소그룹`,
"label.guif.standard.time":`페르시아만 표준시`,
"label.emailobject.emaildetail.button.forward":`공유하기`,
"label.refused":`거절됨`,
"homepage.components.one":`단계 1: 사용자 설정 구성 요소 명칭을 작성합니다`,
"day":`일`,
"label.dataimport.error.number":`에러 발생: 숫자`,
"label.customer.tab.step2.same.option2":`기본 닫기`,
"component_button_ok":`확인`,
"label.allrecordmeetprocess":`모든 기록이 이 단계에 진입해야 합니다`,
"label.version.onefile.size":`한개 첨부파일 업로드 크기`,
"label.partnerCloud.orderingPlatform.allProducts":``,
"pagecreator.page.message.publish.success":`페이지 발표 성공`,
"lable.currencyAdv.exchagecurrency.rate.pro":`이전 범위`,
"label.attendance.persons":`적용 인력`,
"label.send.an.email":`메일 전송`,
"registration.page.browser.title":``,
"label.importfilestep3":`2단계: 파일을 선택하고 업로드합니다`,
"lable.currencyAdv.exchagecurrency.rate.next":`다음 범위`,
"label.ems.no.sync.msg":`메일 동기화 정보가 배치되지 않았습니다.`,
"label.total_views":``,
"label.knowledge.article.notnull":``,
"message.error.view.lastview.delete":`마지막 공공 리스트 뷰를 삭제할 수 없습니다</br>모든 사용자가 볼 수 있는 마지막 리스트 뷰를 삭제할 수 없습니다<br><br>`,
"label.integrations.second.half":``,
"vue_label_systemSettings_mobelparams":``,
"message.choose.maximum":`공유정보는 최대 150까지 선택하세요.현재 선택한`,
"vue_label_homepage_won&unprocessed":`수주계약 성공  미처리`,
"UG.contact.01":`연락담당자를 어떻게 충분히 활용하시겠습니까?`,
"label.data.import.setup.remark":`시스템 관리자는 인증 규칙, 트리거, 중복률 검사 필터 실행 여부 등을 포함하여 데이터를 불러올 때 실행되는 규칙을 설정할 수 있습니다.`,
"pagecreator_layout_message_delete_success":`레이아웃 삭제 성공`,
"lable.account.name":`회계 분기 명칭`,
"label.userinfo.must.updatepwd":`안보 원인으로 비밀번호를 변경해야 합니다.`,
"label.mobile.phone.subordinate.setup":`부하 포함 여부를 설정할 수 없습니다. 소유인을 선택하시고 그가 예측할 수 있도록 설정해 주십시오.`,
"label.monitorsys.delete.date":`일자`,
"label_emailsync_form_emailaddress":`메일 주소`,
"label.projectManagement.cancelled":``,
"label.partnerCloud.partnerAccount.rechargeAmount":``,
"label.select.relatedlist.approval.layout":`승인 페이지 레이아웃에서 보는 관련 리스트를 선택합니다`,
"label.userphoto.thumbnail":`섬네일`,
"label.assignment.setup.list.rulename":`규칙 명칭`,
"label.emailtemplate.usemergefields":`메일 템플릿에 병합 필드를 사용합니다`,
"label.tabpage.enabletomobile":`단말기로 사용 여부`,
"setup_layout_label_desc":`내림차순`,
"vue_label_pool_abandonreasondiscription":`폐기 사유 내용`,
"label.ems.outputmails":`메일 전송 서버（SMTP）`,
"font-evaluate-module-v1-evall":``,
"front-epwechat-module-v1-unbound-tips":``,
"label.weixin.number.data":`개 데이터`,
"front-objectTemplate-V1-UseObject":``,
"label.call.center.configuration":`콜 센터 설정`,
"vue_label_systemSettings_website":``,
"lable.currencyAdv.foreverdate":`영구 일자`,
"label.globalselect.view":`선택 항목 리스트값 세트 보기`,
"component_newrecords_label_title":`최근 기록`,
"component_assistant_label_title":`비서`,
"label.equals.deletebut.bulk.delete":`삭제 버튼을 포함하여 대량 삭제합니다 (휴지통)`,
"label.field.duplicate.error.msg4":`오류: 무효 데이터.`,
"label.input.right.date":`정확한 일자 형식으로 입력하세요`,
"file.error.notsel":`오류: 업로드할 파일을 선택하십시오`,
"label.customcomponent.page.add.title":`사용자 구성요소 새로 만들기`,
"message.chooseatleastthreefield":`최소 3개 필드를 선택합니다`,
"label.dataimport.system.unnecessary":`시스템에서 필요없는 부분을 확인할 수 없습니다`,
"message.login.wrong":`사용자명이나 비밀번호가 정확하지 않습니다!`,
"label.appupload.install.recheck":`재점검`,
"label.ems.option":`선택항목`,
"label.wei.subject.img":`주제 아이콘`,
"chatter.emailReceiveOrNotAccept":`체크 시 CCChat 알림을 수신하며 체크 취소 시 수신하지 않습니다.`,
"label.icon.46":`스토브`,
"label.newpw":`새 비밀번호`,
"font-evaluate-module-v1-praise":``,
"label.help.user":`사용자 매뉴얼`,
"label.callcenter.no.searchs":`관련된 검색 정보 없음`,
"UG_homepage_007":`메일 발송 팔로우업부터 세일즈 활동 자동화까지, 저희 LanTu 과기로 업무 프로세스 생성에서 맞춤형 매크로 발동, 일상 업무 자동화까지 관계를 구축하는 데에 공을 들이고 있습니다.`,
"label.saveandnew":`저장 및 새로만들기`,
"component_salesperformance_label_70finish":`완료-미처리（>70%）`,
"lable.account.dp":`이 페이지에서 회계연도 설정을 정의할 수 있습니다.`,
"label.notification.serviceappointment.injeopardy":``,
"label.workflow.edit.esimaterule":`에러: 해당 규칙이 관련된 시간 트리거가 있을 때 평가 조건을 '매번 기록 생성이나 편집 시'로 변경할 수 없습니다.`,
"label.partnerCloud.basicSetting.feature":``,
"label.sms.companyname.gm.infor":`CHUANG MING 인터넷 문자 인터페이스 정보`,
"vue_label_homepage_components":`구성 요소 선택하세요`,
"label_chatter_allactivity":`모든 행사`,
"label.quickcreate.title":`레이아웃 빠른 새로만들기`,
"label.tabpage.exclusivez":`미 포함`,
"front-service-cloud-transfer-desc":``,
"label.data.downpage.i.list.desc1":`불러오는 과정에서 데이터의 형식이 맞지 않거나 트리거나 검증 규칙으로 실패함. 불러오지 못한 데이터는 csv파일로 현재 페이지에서 나타나며 성공적으로 불러온 데이터는 현 페이지에서 나타나지 않는다.`,
"template.report.individual.case.status":``,
"label.report.export.file.format":`형식: Excel 형식.csv`,
"vue_label_filternotice1":`즉 모든 선별 조건을 동시에 만족시켜야 한다. 예, 1. 금액이 100만위안을 넘는 업무기회. 2. 계약 일자가 이번달에 있는 업무 기회. 선별 결과는 이번달의 100만위안을 넘는 업무 기회. <spanstyle="color:red">가 고급 선별을 사용할 때 수동으로 선별 조건을 고급 선별창에서 입력해야 합니다.`,
"label.lead.score.confirm1":`채점 과정에 시간이 오래 걸릴 수 있어 채점 완성 후 확인 메일을 받을 겁니다.`,
"label.scores":`분`,
"label.dashboard.message.mainnoset":`홈페이지에 대시보드가 배치되지 않음`,
"label.customfields.optionlist.fieldvaluelist":`다음에 선택 항목 리스트 필드에 값 한 열을 입력하여 한 값마다 한 행을 차지합니다`,
"label.autosearch.title":``,
"label.knowledge.setting.hint.seventeen":``,
"label_tabpage_closez":`닫기`,
"label.partnerCloud.orderingPlatform.shoppingCart":``,
"label.recalculate":`다시 계산`,
"label.umeng.approval.approvalmes4obj":``,
"label.appointment.wizard.subtitle2-2":`로`,
"label.validate.function.funcExplain.AND":`모든 파라미터가 참인지 점검하여 모든 파라미터가 참이면 TRUE를 반환합니다`,
"label.recordtype.batchaddattachments.remark":`1단계. 파일을 선택합니다. 2단계: 문서 보관 여부. 3단계.'업로드 시작'버튼을 클릭하여 파일을 업로드합니다. 4단게. '완성'버튼을 눌러 뒤로 이동합니다.`,
"label.reportlist.findreport":`보고서 조회`,
"label.partnerCloud.financeSetting.enterAppsecret":``,
"label.campagin.roi.query2":`마케팅 행사 마케팅 채널 ROI 검색`,
"label.sendmail.notice.immediately":`바로 메일로 통지 보내기`,
"label.file.library.managemembers1":`멤버 관리`,
"label.forecast.customforecast.foredis.yclb":`예측 종류`,
"label.no.target.model.available.":``,
"label.quote.contactname":`연락담당자 이름`,
"label.customer.tab.step2.same":`메뉴의 가시성을 모든 프로필에 적용합니다`,
"UG_product_03":`각국 화폐가 지원된 가격매뉴얼`,
"label.pc.system.prompt":`시스템 안내`,
"homepage.components.description":``,
"front-email-payment-safety-code":``,
"label.the.extra.reward.group.describes":``,
"label.isEnableVisualpage.new.rightlist":`이미 사용된 설정 폐이지`,
"label.icon.84":`변압기`,
"label.chat.message.to":`수신인`,
"lable.product.pricebooks.edit":`가격 매뉴얼 편집`,
"label.partner.workspace.member.belong":`소속`,
"pagecreator_systemstyle_message_delete_success":`양식 삭제 성공`,
"label.salescloud.teamrole.message.chooseatleastone":`사용자 최소 한 명을 선택해 주십시오`,
"label.knowledgebase.self.window":``,
"label.product.cost":`판매 최저 가격`,
"label.imgfield.remove":`이미지 제거`,
"label.event.lastweek":`지난주`,
"template.report.today.statistics":``,
"label.emailobject.recipients":`수신인 （{0}）：`,
"vue_label_commonobjects_view_successfully":`기본 뷰 설정 성공`,
"label.uploadfail.typeerror":`업로드 실패했으며 이미지 파일 형식이 잘못됐습니다!`,
"vue_label_lead_required_fields":`필수 기입 항목을 기입하세요`,
"front-console-reopen":``,
"message.layout.unique.relatedlist":`페이지 레이아웃 관련 리스트의 유일 약속을 위반해 확인한 후 다시 저장하세요!`,
"label.emailobject.emaildetail.nextactivity":`다음의 행사`,
"label.publicgroup.save.error":`에러: 다음의 한 그룹이 이 그룹의 상위급입니다`,
"label.editdefaultshare.tip":`아래에 있는 모든 조직의 공유 기본 설정을 편집합니다.이 기본 설정을 변경하면 모든 공유 규칙을 다시 계산합니다.귀 조직의 데이터 양에 따라 시스템 리소스와 시간이 많이 소요될 수 있습니다.`,
"label.icon.53":`차`,
"label.exchange.sync.state.setting.m3":`링크 연결된 Microsoft Exchange와 CloudCC 메일 주소를 보유한 사용자:`,
"label.currency.enable":`화폐 종류: 화폐 종류 사용`,
"component.timeline.label.past":`과거 활동`,
"workflow.action.tasks.assignortype.user":`사용자`,
"setup_layout_label_relatedlistsetup":`관련 리스트 설정`,
"label.systemadmin":`시스템 관리자`,
"label_tabpage_allz":`소유`,
"label.ems.subject":`주제`,
"message.recordtype.selectlayout.tip":`이 프로필을 보유한 사용자가 보는 이 유형의 기록 페이지 레이아웃을 선택합니다. 저장한 후 이 기록 유형을 선택하면 선택 항목 리스트값을 사용할 수 있습니다.`,
"label.current.version":`현재 프로그램 버전`,
"label.sourceoffile":`미번역한 언어 파일: 미번역한 언어 파일`,
"label.file.versionerror":`새 인터페이스에 파일 메뉴 기능을 사용하십시오`,
"label.validate.function.funcExplain.MINUTE":`일자/시간 필드의 분으로 돌아가기`,
"abel.setup.mobile.bottombutton.profile.setting":``,
"label.recycle.dis.tip3":`드롭다운 리스트에서 나의 휴지통을 선택해 삭제된 데이터를 볼 수 있습니다. 관리자 사용자가 모든 휴지통을 볼 수 있습니다.`,
"message.selectnothing":`선택된 내용이 없습니다`,
"label.develop":`개발`,
"label.tab.lightningpage":``,
"label.chat.micropost.share.info":`공유`,
"label.block.pricing.editor":``,
"label.ccchat.file.unavailable":`해당 파일을 사용할 수 없습니다`,
"label_component_helper_businesschange_0UntreatActivity":`미처리 행사의 업무기회가 없음`,
"label.search.setup.obj":`최대 100개 대상을 설정할 수 있습니다`,
"component.setup.button.cancel":`취소`,
"message.longtextareamaxlength":`길이가 32000를 초과할 수 없습니다`,
"vue_label_chat_removedby":`‘관리자'에게 단체 채팅방에서 강제퇴장 당했습니다.`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`8개 문자 이하일 수 없습니다`,
"label.informassigner":`피분배자에게 알리기`,
"font-evaluate-module-v1-not-received":``,
"label.trigger.triggertime":`트리거 촉발 시간`,
"label.attendance.cannot.make":`표시할 수 없음`,
"label.shouldallrecords":`이 연산은 모든 기록을 포함해야 합니다`,
"label.eidt.queue.alter1":`대열 멤버를 선택하세요`,
"L":`선택 항목 리스트`,
"label_emailtocloudcc_filed_email":`메일`,
"label.productsales.contract.badversion":`현재 버전이 계약서 대상에 지원되지 않아 계약서 실적을 볼 수 없습니다`,
"label.tabpage.operation":`작업`,
"label.file.copy.public.link":`이 공용 링크를 복사했습니다`,
"label.all.SMS":`모두 문자 알림`,
"UG_opportunity_008":`업무 기회 그룹`,
"UG.Campaign.002":`마케팅 행사의 효과를 게획, 집행 및 모니터링`,
"label.jiandangfenpei.title":`프로필 분배`,
"pagecreator.systemstyle.message.delete":`현재 선택한 양식을 삭제하시겠습니까?`,
"lable.outlook.mcto.repeat":`중복 기록을 찾으면, 메일과 연결시킵니다`,
"label.user.field":`사용자 필드`,
"vue_label_commonobjects_detail_market_hierarchy":`시장 등급 구조`,
"label.ems.emails":`메일`,
"label.tabpage.deleteviewfailed":`보기 삭제 실패`,
"label.data.exp.new.expobjtemp":`내보내기 대상 템플릿 제작하기`,
"label.useformulassetval":`공식을 통해 새 값을 설정합니다`,
"label.service.newBuildDialog.six.fields":``,
"error":`에러`,
"template.chart.sdyyfx":``,
"label.icon.191":`수염`,
"label.app.step3.tabused":`선정한 메뉴`,
"label.user.level":`사용자 등급`,
"label.custombutton.querydata.notexist":`검색한 데이터가 없습니다`,
"label.executestate.calculating":`연산 중...`,
"label.visualpage.folder.notdel2":`1. 해당 폴더에 파일이 포함돼 있어 삭제할 수 없습니다! 2. 해당 폴더에 숨김 파일이 포함돼 있어 삭제할 수 없습니다! 숨김 파일은 관련 삭제 대상(설정-생성-대상 밑의 삭제된 대상)에 따라 생성한 파일이며 해당 대상이 삭제되지 않아 해당 파일이 숨겨 있습니다.`,
"vue_label_report_conditiondesc_three":`모든 조건에 부합할 때 알림 통보된다`,
"approval.request.email.subect":`승인 요청`,
"label.log.user.value":`조회 사용자명을 입력하세요!`,
"label.isCompanyCurrency":`회사`,
"label.related.2018":`관련 리스트`,
"label.tonga.time":`통가 시간`,
"message.actionfailed":`조작 실패`,
"label.’s":`의`,
"label.custombutton.queryobj.notnull":`조회 대상 ID를 비워둘 수 없습니다`,
"label.list.userinterface.setup":`사용자 인터페이스 설정`,
"front-kefu-moudle-v1-yxgsbzq-reinput":``,
"label.chatter.content":`내용`,
"label.projectManagement.Addnotes":``,
"label.service.newBuildDialog.reservation":``,
"label.ccchat.pm":`오후`,
"vue_label_chat_cannot_invite_users":`단체방 개설자만 사용자를 단체방에 초대할 수 있습니다.`,
"label_partner_workspace_member_belong":`소속`,
"label.task.modify":`업무 편집`,
"label.tabpage.transformationsz":`전환`,
"label.new.password.no.indexof":``,
"label.ji.quarter":``,
"label.sso.isActiveNo":`아님`,
"label.mobile.phone.week.report":`주보`,
"label.email.template.please.select.folder":``,
"label.pc.ui.2018.tab.groups":`메뉴 그룹`,
"label.h5.approval.status":`승인 상태`,
"setup.mainpage.label.welcome27":`CloudCC 쿨라우드 플랫폼에서 시스템 내에 모든 대상자 데이터 불러오기, 내보내기, 데이터 대량 삭제, 대량 이동 등 기능을 제공한다.`,
"vue_label_systemSettings_setHomePage":``,
"label.select.button":`선택 가능한 버튼`,
"label_emailsync_status_enable":`연동 사용`,
"label.trigger.triggerVersion.detail":`이 필드를 편집할 수 없으며 트리거는 현재 두가지의 버전이 있으며 1.0과 2.0입니다. 새로만든 트리거는 모두 최신 버전인 2.0이며 1.0버전은 생성 금지되었습니다`,
"pagecreator_layout_message_save_fail":`레이아웃 저장 실패`,
"label.salescloud.salesdashboard.10big":`미래 3개월 10대 업무기회`,
"label.file.share.size":`각 파일의 최대 공유 및 공용 링크 수는`,
"label.page.simple":`쉬움`,
"pagecreator.page.message.delete":`선택한 폐이지를 삭제하시겠습니까?`,
"label.weixin.newspaper.coverage.detailinfo":`보험 신고서 상세 정보`,
"label.list.userinterface.chattersetup":`CCChat 설정`,
"lable.opppdt.addpdt.table.quantity":`수량`,
"label.product.description":``,
"button_partner_back":`뒤로가기`,
"label.user.current.loginuser.sessionid":`현재 로그인 사용자 SessionID는:`,
"label.otherreport":`기타 보고서`,
"pagecreator_button_mobilepage":`모바일기기`,
"label.mobile.phone.state":`검토 상태`,
"lable.currencyManage.unenableCurrencyAdv":`고급 화폐 관리 사용 금지`,
"lable.product.addp":`가격 추가`,
"label.field.validate.notpass":`인증이 통과되었습니다. 문법 오류가 발견되지 않았습니다.`,
"label.app.global.search.obj":`전역 검색에서 검색한 대상에 적용하여 최대 10개의 대상을 설정할 수 있습니다.`,
"label.group.archived":`문서 보관`,
"vue_label_approve_to_submit":`제출 대기중`,
"showfrom":`번째 보기`,
"chatter.emailNotification":`메일 알림`,
"label.callcenter.pleaseenter.enterprise.number":``,
"label.forecast.customforecast.forecastnumber":`숫자 예측`,
"label.vlidaterule.messagelocation":`잘못된 위치`,
"label.h5.similar.opportunity.step3.conment":`매칭 필드 수량이 나타난 관련 열 계속 보기`,
"label.ccchat.group.gd.setting.info":`CCChat 그룹 설정을 수정합니다`,
"label.knowledgebase.delete.article.succeeded":``,
"message.layout.edit":`페이지 레이아웃 관리는 별도의 충전 기능으로 귀하의 조직에서 이 기능 모듈을 구매했음을 확인하면, 시스템 관리자에게 비밀번호의 사용을 문의합니다.더 많은 문제는 CloudCC.com으로 문의하면 됩니다.`,
"label.case.create":``,
"label.icon.170":`쇼핑`,
"message.error.contact.null":`연락담당자가 필수 사항입니다`,
"label.appupload.install.error.hasinstalled":`이 소프트웨어 패키지는 귀 조직에 설치되었습니다.새 버전을 설치하기 전에 설치된 버전을 삭제해야 합니다.`,
"label.service.miniProgram.imageType":``,
"label.leadscore.rule.edit":`잠재고객 채점: 규칙 편집`,
"vue_label_commonobject_anytime":`임의 시점`,
"label.clearing.conditions":``,
"label.campagin.roi.ydkhjhze":`고객기회 총액 획득수`,
"Lead_Auto_Scoring_Setting_001":`잠재 고객을 저장하거나 편집할 때 자동으로 채점됩니다. (모두 불러오기와 인터페이스 생성이 불포함)`,
"pagecreator.systemstyle.label.buttonareacolor":`작업 공간 색깔`,
"label.batchregist.huanxinuser.finish":`모두 등록 사용자가 완성되었습니다`,
"UG_opportunity_006":`업무기회 천재`,
"message.serviceappo.violation":``,
"label.recordtypeselect.selectnew":`새 기록 유형을 선택하십시오`,
"Lead.Tools.BatchScoring":`잠재 고객 모두 채점`,
"label.partnerCloud.financeSetting.enterWechat":``,
"label.philippine.time":`필리핀 시간`,
"five":`5`,
"label_average_value":``,
"message.realdelete":`완전히 삭제하시겠습니까?`,
"label.currency.note":`새 화폐 종류 정보를 입력하세요. 주의: 화폐 종류를 사용한 후 삭제할 수 없습니다.`,
"label.projectManagement.delete.prompt":``,
"label.approval.present":`(현재)`,
"label.escalation.setup.newrule.name":`규칙 명칭`,
"label.edit.list":`편집 가능한 데이터 리스트`,
"label.partnerCloud.financeSetting.informationOne":``,
"label.customfields.numberText":`2. 입력한 숫자의 길이와 소수 자릿수가 18자리를 초과할 수 없습니다`,
"label.biaoqing.businessverify.relation.tip":``,
"label.icon.149":`로봇`,
"System.btn.SaveAndCommit":`저장 및 제출`,
"label.calendar.many":`여러 명`,
"label.ccchat.create.email":``,
"template.report.income.marketing.activities":``,
"label.ccchat.person.invite.needemail":`메일 주소를 입력합니다.`,
"template.report.open.amount":``,
"label.currentoperate":`존재한 조작`,
"label.finalapprove":`최종 승인`,
"label.emailmerge.mergepage.step2":`3. 최대 20개 병합할 템플릿을 선택할 수 있습니다:`,
"label_tabpage_sorttypez":`정렬 유형`,
"label.workbanch":`나의 작업공간`,
"font-evaluate-module-v1-disable":``,
"label.ServiceCloud.distributionMap":``,
"lable.Confirm.potential.customers":``,
"label.mobile.quickcreate.default.nearby":`근처`,
"label.isremider.noremider":`알림 안하기`,
"label.approval.select.step":`돌아갈 승인 절차를 선택하기`,
"chatter.error.pm":`에러: 올리는 이미지 파일 크기가 한계를 넘었습니다!`,
"UG_activity_08":`일정 예약`,
"label.marketsea.notwinopportunitydays":`일 거래가 없는 일수(업무 기회 미생성 일수보다 커야 함)`,
"label.selectpage":`기존 페이지를 선택합니다`,
"label.dashboard.dispalyOnTheHomePage":`보는 메인 홈페이지`,
"front-lightning-module-v1-details-page-chart-set-report":``,
"vue_label_pool_mydeal":`내가 성사시킨 거래`,
"vue_label_report_lastone":`마지막`,
"label.tabpage.potentialcustomersz":`잠재 고객`,
"font-evaluate-module-v1-more-satisfied":``,
"label.trigger.instructions":`<font color="red">주의：트리거 코드 최대 용량은 200KB 문자, 약 200000 바이트</font><font size=3 color="red"></font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`승낙 완성률`,
"label.umeng.approval.dlsp.approvenew":`대리 승인: #actorname이 #objAPIName#recordname에 대한 승인을 요청하고 있습니다`,
"label.edit.visualpagefolder":`사용자 설정 페이지: 폴더 편집`,
"label.pc.flash.teach":`동영상 교육`,
"label.showsearch":`검색 보기`,
"label.reportsSubscriptionPage.condition.title1":`모든 조건에 부합하면 알림을 받을 수 있습니다`,
"label.h5.search.result":`결과`,
"vue_label_commonobjects_view_chart_pie":`원형 차트`,
"label_please_enter_currency":``,
"chatter.share.to.profile":`님의 프로필`,
"label.mykeeptouchset":`나의 연락 유지 설정`,
"label.profile.mustcopyaprofile":`복사할 기존 프로필을 선택해야 합니다.`,
"label.managereport":`보고서 관리`,
"label.total.choice":``,
"label_emailtocloudcc_help":`정확한 메일 암호나 승인 번호를 입력하세요. 메일 서비스에 IMAP/SMTP 서비스를 사용해야 제3자 클라이언트에서 등록할 수 있으면 메일을 로그인한 후 설정으로 이동해 해당 서비스를 작동하고 관련 승인 번호를 복사하여 암호창에 입력해야 합니다.`,
"label.trigger.sel":`이 폴더의 트리거`,
"label.dashboardLookUp":`대시보드 보기`,
"label.batchadd.newbatchpage.save.emptytext":`필수 입력 항목이 입력되지 않아 다시 점검하세요`,
"setup.mainpage.label.welcome16":`작업 매뉴얼: 본 페이지 좌측 메뉴를 클릭하여→응용 프로그램 설정→새로 만들기→작업 흐름, 승인 과정, 임무, 이메일 알림, 필드 업데이트 등`,
"vue_label_email_mark as":``,
"label.customobjdel.cannot.delete.try":`다른 대상의 이하 관계와 관련이 있어 대상을 삭제할 수 없습니다`,
"label.customsetting.visible.public":`공용`,
"label.log.bit":`자릿수`,
"label.data.exportall.all.desc":`현재 사용자의 권한이 있는 대상자의 데이터 내보내기`,
"message.login.mfadevice.already.bound":`사용자가 MFA 장비를 연동했습니다`,
"label.campaign.channel.please.img":`이미지를 올려주세요`,
"assetbom.manage.notpermission":``,
"schedstarttime.schedendtime.time.illegal":``,
"label.referperson":`소유인`,
"front-email-payment-area":``,
"label.c.d.least":`'C'기록마다 최소한 하나의 관련 'D'기록이 있어야 한다.`,
"label.weixin.longitude.isnull":`경위도가 없거나 무효합니다`,
"setup.layout.button.ok":`확인`,
"vue_label_fiter_component_date_customdate":`사용자 설정 일자`,
"label.enable.case.createarticle":``,
"label.event.moveup.8hour":`8시간을 앞당깁니다`,
"label.input.most.string":`최대 {0}개 문자를 입력하세요`,
"lable.SalesCommitmentKanBan.contractEndDate":`계약 종료일`,
"label.visualpage.function.name":`방법명 명명:`,
"label_emailtocloudcc_redmessage1":`정확한 메일 주소를 입력하세요`,
"message.aliasnameinput":`에러: 유일한 명칭이 알파벳 숫자 문자만 포함되어 알파벳으로 시작하여 유일해야 합니다`,
"label.data.exp.selectedtemp":`데이터 내보내기에 필요한 템플릿을 선택하십시오`,
"label.import.page1.suitedwayoflinkman":`담당자 연락처 방식과 매칭함`,
"label.customsetting":`사용자 설정`,
"label.versiontype.Free":`무료버전`,
"setup.layout.label.norelatedlist":`관련 리스트 없음`,
"label.forecast.edittotal.de.leiji":`의 누계`,
"label.customfields.file.max":`업로드한 파일이 너무 크니 5M을 넘지 마십시오.`,
"label_partner_all_workspace":`업무공간`,
"label.searchrelation":`찾기 관계`,
"label.icon.185":`컨설팅`,
"label.service.gantt.effective":``,
"label.newreportstp1":`1단계: 보고서 형식을 선택합니다`,
"label.category.9":`생산 제조`,
"label.zuowei":`로서`,
"front-quotation-v1-select-quota":``,
"label.dashboard.refresh":`새로고침`,
"label.weixin.saveandnew.log":`일지 저장 및 새로만들기`,
"label.report.list":`보고서 리스트`,
"FL":`파일`,
"label.h5.followingcolleagues":`팔로잉 동료`,
"template.report.conversions.number":``,
"label.validate.function.funcFormat.MONTH":`월(일자)`,
"front-kefu-moudle-v1-tenant-ID":``,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`시간`,
"label.multilang.workflow.everyotherday":`{0}일 간격`,
"label.chat.message.send.message":`메시지 전송`,
"label.knowledgebase.fast.operation.error":``,
"label.multilang.dupicatecheck.dumplicatedata":`{0}개 기록에서 조건을 부합한 중복 데이터 {1}그룹을 조회하였으면 {2}밀리초가 걸립니다. 페이지마다 {2}그룹 데이터를 볼 수 있습니다.`,
"vue_label_report_addFile_detail_Information":``,
"label.ccchat.message.search.desc3":`검색 안내`,
"message.deletereport.prompt":`이 보고서를 삭제할 수 없습니다`,
"pagecreator.page.message.save.success":`페이지 저장 성공`,
"vue_label_rise":``,
"label.appupload.install.error.choicehead":`만약 시스템에 존재하는 구성 요소들이 설치하려는 구성 요소들과 충돌한다면 어떻게 처리할 것입니까?`,
"message.dispatch.violation":``,
"label.tool":`툴`,
"label.sso.saml.idp.downloadcert":`인증서 다운로드`,
"label.chatter.detailinfo":`상세 정보`,
"label.area.tree":`구역 등급 계통수`,
"label.partnerCloud.priceOfManual.notEnabled":``,
"label.chosesubject.call":`전화 하기`,
"label.leadscore.rule.detail":`잠재고객 채점: 규칙 상세 정보`,
"front-welcome-to-try":``,
"label.umeng.activity.event.willbegin1":`이벤트#event가 곧 #time 후에 시작됩니다`,
"component.event.label.noevent":`오늘 일을 마치셨나 봐요.`,
"label.document.templatesetof.folder":`템플릿 표시 폴더`,
"label.quickbooks.none":`매칭 데이터가 없어 수동으로 검색하거나 새로 만드세요`,
"label.assignment.setup.newrule.inputrule":`분배 규칙명을 입력합니다`,
"label.appointmentdetail.wizard.title4":`회사명`,
"label.malaysia.time":`말레이시아 시간`,
"label.partnerCloud.partnerAccount.way":``,
"label.roleoflinkman":`연락담당자 역할`,
"mesage.error.role.delate.user":`현재 사용자가 역할에 분배되어 있기 때문에 역할을 삭제할 수 없습니다.`,
"chatter.warning":`경고: 다른 대상을 선택하면 변경 사항을 저장하지 않습니다. 이 작업을 실행하시겠습니까?`,
"label.service.gantt.violations.sum":``,
"label.permission.objectpermission.recordfenpei1":`분배된 기록 유형`,
"label.mobile.phone.required.plan":`계획은 필수 입력 항목입니다`,
"label.after_leaving":``,
"label.cpq.opportunity.mainquote.trasnfer.order":``,
"component.setup.iframe.label.title":`사용자 설정 페이지`,
"visit.dispatchplatform.nopermission":``,
"label.validate.function.funcExplain.RIGHT":`텍스트 문자열 우측부터 계산하는 수량 실행한 문자로 반환합니다`,
"component.chatter.link.button.save":`발표`,
"label.knowledge.selection":``,
"chatter.email.homePage":`내 CCChat 메인 홈페이지에 게시물을 올릴 때`,
"vue_label_commonobjects_view_copy_view":`뷰 복사`,
"label.documentmessage":`파일 상세 정보`,
"label.emailtocloudcc.step1":`1단계`,
"label.user.mfa.unbind":`선정한 사용자에게 MFA 연동 해제`,
"label.stdashbord.xsld.business.sdzje":`계약 파기 총금액`,
"vue.please.select.the.total.method":``,
"label.stdashbord.xsld.business.img1":`가능성이 1%-99%인 단계의 개수`,
"label.reportsSubscriptionPage.condition.title":`구독 기능 외에, 보고서 결과에서 조건을 설정할 수 있습니다. 조건에 부합하면 알림을 받을 수 있습니다. 필수 기입 사항이 아닙니다.`,
"chatter.sel.field":`선택이 20개 필드가 넘습니다.`,
"label.login.access.year":`년`,
"label.dashboard.all":`모든 대시보드`,
"label.approver":`승인자`,
"Lead.Homepage.Tools.BatchScoring":`모두 채점`,
"lable.opppdt.selPdt.lesscondtions":`필터가 많지 않습니다`,
"label.integrations.action.export":`내보내기`,
"label.datamanage.lookupandsure":`(보기와 확인)`,
"label.email.attach.to.mail":`메일에 첨부하기`,
"message.nodataordeleted":`데이터가 존재하지 않거나 삭제됩니다`,
"component_newrecords_label_all":`모두 보기`,
"lable.currencyAdv.startdate.rate":`시작일이 다음 범위로 정의된 모든 환율 보이기`,
"label.callbackoperate":`돌려보내기 조작`,
"label.knowledge.setting.hint.eighteen":``,
"label.user.step4.submit.email":`4단계. 메일 전송 요청을 제출했습니다.`,
"label.appointment.wizard.subtitle4-1":``,
"component.assistant.button.newtask":`임무 새로 만들기`,
"label.icon.129":`카드`,
"label.relatedlist":`관련 리스트`,
"label.report.recently":`최근 보기`,
"label.batchadd":`대량 신규 추가`,
"front-template-V1-Delete-succeeded":``,
"label.appupload.upload.otherdetail":`다른 상세 정보`,
"label.emailobject.link":`링크`,
"label.quickbooks.createcustomer":`QuickBooks에서 신고객 생성`,
"report.label.projectcount":`개 항목, 보고서 리스트 명칭대로 순서를 배열한다`,
"vue_label_normal_contact_sf":`연락담당자`,
"chatter.group.groupActivities":`모든 그룹`,
"label_tabpage_addoptionsz":`선택항목 추가`,
"label.knowledgebase.submit.for.translation":``,
"vue_label_pool_notallowed":`업체성과 불일치`,
"label.icon.80":`제지`,
"label.readonlys":`읽기 전용`,
"label.recordsediting":`기록 편집 가능성`,
"label.mr.title.email":`메일`,
"label.partner.all.enable":`사용`,
"label.customsetting.manage.errmessage":`사용자 설정 필드를 관리한 후 데이터를 관리하세요`,
"label.cloudccclass.list.cls":`종류`,
"label.weixin.click.loadall":`전체 보기`,
"label.weixin.appr.initialtime":`초기 시간`,
"UG_ST_002":`확인`,
"setup_mainpage_label_welcome17":`권한 설정`,
"label.appupload.state0":`미업로드`,
"label.icon.115":`주택`,
"setup_mainpage_label_welcome5":`사용자 설정 필드`,
"lable.custom.year.ovdate":`사용자 설정 연도 종료일`,
"label_tabpage_findz":`찾기`,
"label.appupload.uploading":`소프트웨어 패킷 업로드 중...`,
"setup.mainpage.label.welcome1":`관련 권한이 필요함`,
"label.file.folder.delete2":`문서 라이브러리를 삭제하시겠습니까?`,
"2018UI_Homepage_DataNoAccess_Info":`해당 기록의 방문 권한이 없으며 클릭하여 뒤로 이동합니다.`,
"label.ems.google":`구글`,
"label.hawaii.aleutian.standard.time":`하와이 표준 시각대`,
"template.report.unfinished.tasks":``,
"vue_label_calendar_add_calendar":`캘린더 추가`,
"label.button.sel.useremail":`선택한 사용자에게 메일을 보냅니다`,
"user.email.template":``,
"label.forecast.settings.shouru":`수입 예측`,
"label.casesensitive":`ABC"와 "abc"를 다른 값으로 간주합니다(케이스 센시티브)`,
"message.pleaseinputrightdistanceweek":`정확한 간격 주일을 기입해 주세요.`,
"label.linellae-group":`라인- 그룹분류`,
"label.showdefault_times":``,
"label.smstemplate.finishmessagedetailinfo":`메시지의 상세정보 완성`,
"label.service.miniProgram.backgroundImage":``,
"label.recentview.news":`최신 기록`,
"label.reportType.chose.and.form":`보고서 데이터 소스 및 보고서 양식 선택`,
"setup.layout.button.additem":`선정한 항목 추가`,
"front-epwechat-module-v1-auto-mate":``,
"vue_label_helpcenter_contract&plan":`계약서는 각자 간의 서면 협의서이다. 많은 회사가 계약서를 통해 다른 회사와의 업무 거래 조항을 정의한다.  Cloud CC를 통해 고객과 업무 기화에 관련된 계약서를 구축해 이에 대해 프로필을 제공한다. 심의 프로세스를 통해 계약서를 팔로우업한다. <br> 대금 수령 계획을 통해 계약서 기능을 협조해 거래를 관리한다.`,
"label_mobile_version_nonsupport_feature":``,
"label.icon.44":`불`,
"label.data.downpage.i.title.num3":`3.불러오기 전에 관련된 모든 기록을 불러올 수 있도록 확보합니다. 예를 들어, 현재 불러올 대상자가 연락담당자와 관련 관계가 있으면 먼저 연락담당자를 불러오고 데이터를 불러오세요.`,
"label.mr.object.customer":`고객`,
"label.social.user.null":``,
"front-epwechat-module-v1-unbound-item2":``,
"label.partnerCloud.partnerAccount.noempty":``,
"label.weixin.myapproval":`나의 승인`,
"label.data.setok.e_desc1":`내보내기 성공한 후 시스템 메일 알림을 받습니다. 내보낸 데이터가 잠시 48시간 동안 서버에 저장되어 되도록 신속하게 처리하세요`,
"lable.batchadd.service.cfq.after":`트리거 (After Insert)`,
"label.umeng.activity.youhaveanevent":`1개 새 이벤트가 있습니다`,
"label_emailsync_status_connectaccounts":`메일 계정 연동하기`,
"label.multilang.shenpi.count":`총 {0}개 기록:`,
"pagecreator.page.message.delete.fail":`페이지 삭제 실패`,
"label.version.sum.lookupmdfield":`개 마스터 디테일 관계 필드`,
"vue_label_pool_clueduplication":`고객 경로 중복`,
"label.system.setup.log":`시스템 동작 일지`,
"label.globaloperation.operationtype.send.e-mail":`메일 발송`,
"vue_label_pricebook_entry":`가격 매뉴얼 항목 새로 만들기`,
"label.forecast.forehistory.submit.date":`제출 일자 시간`,
"chatter.handle":`무엇을 처리하고 있습니까?`,
"lable.SalesCommitmentKanBan.complete":`달성액`,
"label.weixin.upload.pictures":`이미지 업로드`,
"label.create.document":`파일 새로 추가`,
"vue_label_commonobjects_detail_unlockconfirm":`잠기기 해제하시겠습니까?`,
"label.customer.page":`사용자 설정 페이지 메뉴`,
"button.partner.workspace.saveas":`다른 이름으로 저장`,
"setup.layout.label.asc":`오름차순`,
"label.ccpeak.folder.time":`미보관 타이머 클래스 폴더`,
"label_tabpage_includez":`포함`,
"label.custom.button":`사용자 설정 버튼`,
"label.weixin.binding":`연동하기`,
"P":`백분율`,
"chatter.stop.n":`기록 팔로우업 중지`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`수요일`,
"template.report.revenue.marketing.activities":``,
"lable.SalesCommitmentKanBan.theActualReceipts":`실제 대금 수령액`,
"vue_label_popularresults":`인기 결과`,
"label.log.belongs":`소속 부분`,
"label.profile.remark":`이 프로필의 사용자가 다음의 권한과 페이지 레이아웃을 보유합니다. 관리자가 사용자의 개인 정보를 편집함으로써 프로필을 변경할 수 있습니다.`,
"label.appupload.component.type.button":`버튼`,
"label.partner.all.operate":`조작`,
"vue_label_notice_modify_fail":`수정 실패`,
"label.icon.137":`지구`,
"front-dialog-module-v1-nosupport-copy":``,
"label.integrations.mailchimp.massage3":`권한 부여 취소됨`,
"UG.opportunity.010":`거래 생성`,
"front-lightning-module-v1-details-page-chart-selecting-reports":``,
"System_btn_SaveAndCommit":`저장 및 제출`,
"vue_label_dashboard_statisticaltype":``,
"label.mr.object.opportunity":`업무기회`,
"label.area.detail.remark":`구역 사용자 미리보기`,
"label.view.sortview.index":`순번`,
"label.mobile.quickcreate.default.events":`이벤트`,
"label.product.price":`판매 가격`,
"label.leadmarketsea.edit.title":`잠재 고객풀 편집`,
"pagecreator.layout.button.edit":`레이아웃 편집`,
"label.addressee":`수신인`,
"label.movablesearchlayout":`행사 검색 레이아웃`,
"label.ems.confirm":`확인`,
"vue_label_file_save_to_file":`파일로 저장`,
"component_chatter_button_more":`더 많은 상세 정보 보기`,
"label.ccdocument.hidden.trace":`흔적 숨기기`,
"label.partnerCloud.maximumTwo":``,
"label.event.moveup.4hour":`4시간을 앞당깁니다`,
"label.batchadd.save":`공유 추가 실패`,
"label.passwordPolicy.setup.expireDate":`사용자 비밀번호 유효기간`,
"label.workflowrule":`업무 프로세스 규칙`,
"vue_label_notice_pleaseselecview":`뷰를 선택하세요`,
"label.h5.chatter.colleagues":`동료에 관해`,
"lable.opppdt.addpdt.subtitle":`제품 추가`,
"label.data.import.setup.repeat.no":`아니오-나의 불로온 파일에 모든 기록을 삽입합니다.`,
"label.changeCorporate":`회사 화폐 종류 변경`,
"label.customfields.dateandtime.tip":`사용자가 날짜와 시간을 입력하거나 팝업 캘린더에서 날짜를 선택할 수 있습니다.팝업 캘린더의 날짜를 클릭하면 해당 날짜와 현재 시간이 일자/시간 필드에 입력됩니다.`,
"label.integrations.mailchimp.massage1":`내보내는 최소 1개 기록을 선택하세요`,
"lable.PowerProcess.custom":``,
"label.service.editDialog.displays.service.appointmentsFordays":``,
"label.Receivables.ActualMoneyTime":`실제 대금 수령 시간`,
"label.matrixreport.intro":`행렬식 보고서가 그리드 형식으로 수평과 수직 방향의 조건에 따라 계산한 통계 데이터`,
"message.validation.isnotnumber":`정확한 숫자를 입력합니다`,
"label.partner.workspace.member.search":`검색`,
"label.customfields.deletewill":`해당 사용자 설정 필드를 삭제하면`,
"label.content":`내용`,
"component.setup.button.weburl":`외부 URL`,
"setup.mainpage.label.welcome28":`작업 매뉴얼: 본 페이지 좌측 메뉴를 클릭하여 → 관리 설정 → 데이터 관리 → 데이터 불러오기, 내보내기, 모두 이동, 모두 삭제`,
"label.related.setup":`업무 이벤트 관련 항목 배치`,
"label.weixin.sign":`출석하였으며 다시 체크할 필요없습니다`,
"label.norecord":`기록 없음`,
"label.emailmerge.detail.emailtempldatemerge":`메일 병합 템플릿`,
"label_emailsync_status_role":`역할`,
"label.mobileapp.modelsetting2":`실제 사용 시나리오에 따라 업무 수요에 부합한 모듈을 선택합니다 <br>사용: 체크한 후 모듈이 모바일기기의 '더 많이 보기'-'추천 기능'에서 나타납니다 <br> 금지사용:체크한 후 모듈이 모바일기기' 더 많이 보기'-'추천 기능'에서 나타나지 않습니다.`,
"component.sendmail.label.title":`메일 발송`,
"component_assistant_button_newevent":`이벤트 새로만들기`,
"label.chatter.input":`관련 내용을 입력하세요`,
"message.error.view.operate.rtnlink":`<a href='javascript:history.back();'>뒤로 이동하기</a>를 클릭하여 뒤로 돌아갑니다`,
"lable.new.profile":`프로필 새로만들기`,
"label.custom.field.null":`사용 가능한 내용 없음`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`토요일`,
"label.stdashbord.xsld.business.img4":`가능성이 100%인 단계의 총 금액`,
"pagecreator_layout_button_splitall":`모두 분할`,
"label.mobile.phone.total.amount":`총금액(만 위안)`,
"label.ratifyhistory":`승인 이력`,
"label.projectManagement.Antecedents":``,
"label.projectManagement.Newserviceappointment":``,
"label.delete.record.is.approval":`삭제할 기록은 승인중인 기록입니다.삭제하시겠습니까?`,
"front-gantt-module-no-tasks-describe":``,
"vue_label_visualize_data":``,
"UG.activity.02":`임무 분배`,
"label.field.duplicate2":`중복값 금지`,
"label.cloudccclass.list.tip":`개발자가 CloudCC.com 플랫폼에서 클래스를 개발할 수 있도록 하여 이러한 클래스는 사용자 설정 페이지 및 트리거에 사용할 수 있습니다.`,
"before":`보다 이르다`,
"UG.ST.001":`안내`,
"label_tabpage_userGuidez":`사용자 매뉴얼`,
"vue_label_account_looking_for":`검색 내용을 입력하세요`,
"vue_label_calendar_notice_timecantmove":`해당 캘린더 시간이 드래그 앤드 드롭으로 변경할 수 없습니다`,
"label.mobile.phone.enter.summary":`총정리 내용을 입력하세요`,
"label.object.api.existed":`대상 api 이름이 이미 존재합니다. api 이름을 바꾸십시오.`,
"label.weixin..xsld.order.by.time":`계약 체결 예정일대로 정렬하기`,
"label.h5.chatter.whether":`여부`,
"label.file.delete.success":`파일 삭제 성공`,
"label.imgfield.type.url.tip1":`사용자는 이미지 인용 링크를 입력하여 이미지 링크 후 &cimgSize=너비, 높이, 이미지 크기를 추가할 수 있습니다.`,
"label.tomanyrecords":`보고서에 항목이 5,000개를 초과했습니다.`,
"label.save.partnercloud":``,
"vue_label_homepage_fliteritems":`배치 항목 선별하기`,
"pagecreator_page_button_new":`페이지 새로 만들기`,
"label.sharerule.baseofcondition":`조건을 바탕으로`,
"label.dashboard.snapshot":`대시보드 스냅숏`,
"label.appointmentpage.wizard.subtitle1.1":`날짜와 구체적인 시간을 선택하시오.`,
"label.reportsSubscriptionPage.condition.emailsummary":`보고서만 전송하기`,
"chatter.group.showAll":`모두 표시`,
"label.tabpage.helpNavigationz":`도움말 및 안내 메뉴`,
"label.emailtocloudcc.button.back":`취소`,
"approval_request_email_subect":`승인 요청`,
"label.lookup.error":`찾는 동안 에러가 발생했습니다`,
"label.publicgroup.save.groupisnull":`저장 중에 그룹 데이터가 비어 있습니다. 다시 저장을 시도해 보십시오. 그래도 문제가 있으면 시스템 관리자에게 연락하십시오.`,
"label.pie":`원형 차트`,
"chatter.feed.is":``,
"label.customfields.file.max5m":`최대 파일 크기 5M`,
"com.cloudcc.login.error.message.vaildauthfail":`로그인 인증 무효`,
"label.profile.appsetuppermission":``,
"label.customfields.file.totalmax":`업로드될 파일 크기가 500M을 초과할 수 없습니다.`,
"label.sms.list":`문자 인터페이스 정보 리스트`,
"message.error.referencedcolumnIdnotexist":`보고서 인용 필드가 삭제되어 정상적으로 표시되지 않습니다. 시스템 관리자에게 연락하여 도움을 받으시기 바랍니다.`,
"front-lightning-module-v1-details-page-chart-setting-chart":``,
"label.recordtype.profile.enables":`현재 사용 가능한 기록 유형`,
"chatter.this.n":`이 기록`,
"label.only.upload.file":``,
"vue_label_lead_conversion_failed":`전환 실패`,
"label.file.share.file.success":`파일 공유 성공!`,
"label.processsetting.delete.process":``,
"message.uniquenamevalidate":`알파벳으로 시작해 알파벳, 숫자 문자와 밑줄만 사용 가능합니다`,
"label.group.archived.desc.info":`이 그룹은 보관됨으로 새 게시물을 만들거나 이 그룹과 파일을 공유할 수 없습니다.그룹을 사용하면 모든 기능을 사용할 수 있습니다.`,
"label.customer.maincontact":`주요 연락담당자`,
"label.appointment.wizard.subtitle1-9":`4시간`,
"label_productline_income":`제품 계열 수입`,
"label.dashboardSetup.tz.ybb":`대시보드로 이동`,
"label.recordowner":`기록 소유인`,
"message.approval.othersdoing":`다른 사용자가 이 프로세스를 조작하고 있어 새로고침으로 최신 정보를 확인하세요!`,
"Opportunity_Detailed_Phase_Label_002":`현재 상태에 {0}일째 머물러 있습니다`,
"label.field.validating.rule.isnot.passed":`인증 규칙 편역이 통과되지 않아 문법 다시 점검하세요`,
"label.textmessage.fieldskong":`일부 삽입한 필드값이 0이며 다시 편집하고 전송하세요`,
"com.cloudcc.login.error.message.islocked":`사용자가 잠겨 있습니다.`,
"label.forecast.customforecast.foredis.debfb":`할당 퍼센트`,
"lable.opppdt.selPbk.changepbk.worning":`이 업무기회의 가격매뉴얼을 수정하면 해당 업무기회와 관련된 업무기회 제품이 삭제됩니다. 계속하시겠습니까?`,
"label.mr.backLookReData":`반환하기, 중복 데이터 리스트 보기`,
"label.quickbooks.searchqb":`QuickBooks 검색`,
"label.service.gantt.searchSkills":``,
"label.account.Current.and.NexttFQ":`현재와 미래 3개 회계 분기`,
"customer.notopen.chat":``,
"vue_label_commonobjects_view_sum":`총 {total}개 데이터`,
"label.partnerCloud.orderingPlatform.adjust":``,
"label.emailmerge.mergeFolder.tips":``,
"vue_label_ccchat_notice_deletecommentfail":`댓글 삭제 실패`,
"label.emailsync.status":`사용자 이메일 상태 통계`,
"label.forecast.forecastroleuserpage.desc":`이 역할에 예측 매니저를 분배합니다.부하의 예측이 그의 매니저의 예측에 통계됩니다.`,
"label.step1.total4":`1단계, 총 4단계`,
"front-kefu-moudle-confirm-fjcase":``,
"label.icon.60":`기중기`,
"label.appointmentpage.wizard.subtitle3":`정보를 입력하세요`,
"label.loginservice.license.exceed.time":`허가증이 만료되었습니다`,
"label.customcomponent.check.tag.lastrow":`마지막 행은 반드시`,
"label.product.code":`제품 코드`,
"label.salescloud.salesdashboard.phone":`전화`,
"label_please_input_price_list_price":``,
"label.multilang.page3":`페이지`,
"label.file.lastmodifydate":``,
"label.icon.121":`컴퓨터`,
"message.error.system.service.unknow":`미지의 서비스이며 시스템 관리자에게 연락하세요!`,
"label.thesecond":`2번째 열`,
"vue_label_report_conditiondesc_two":`본 조고서에 조건을 추가함`,
"label.exchange.serverUrl":`서버 주소`,
"RL":`인용`,
"label.emailobject.emailsend.sendindividuallyprompt":`'개별 전송'이 사용자들에게 일대일로 전송합니다. 모든 사람이 개별로 메일을 받습니다. '개별 전송'하시겠습니까?`,
"label.appointmentconfirmpage.wizard.subtitle4":`참여자`,
"message.save.opportunity.team.save.failed":`업무기회 그룹 실패`,
"vue_labenl_normal_notice_share_success":`공유 성공`,
"label.triggerfolder":`트리거 폴더`,
"label.more":`더 많이 보기`,
"label.file.num":`수량`,
"label.dashboard.list.sortBy":`개 항목, 방문 시간대로 정렬합니다`,
"c":`화폐 종류`,
"label.weixin.detail.edit":`편집`,
"label.escalation.setup.newentries.step2":`2단계: 이 규칙의 항목 조건을 선택하십시오`,
"label.report.error.prompt":``,
"label.notification.new":`새 알림`,
"label_tabpage_releaseTourz":`안내메뉴 발표`,
"label.icon.41":`포지셔닝`,
"label.sendsms.hello.new":`안녕하세요: 새 알림이 있습니다`,
"label.custom.combination":``,
"label.project.hit.fifteen":``,
"label.campaign.channel.step6.mobile":`모바일기기 페이지 생성`,
"label.goback.N.step":`N단계로 돌아가기`,
"label_partner_all_name":`파트너 클라우드 명칭`,
"label.usermanage.loginusername.exist":`로그인 사용자명이 존재합니다!`,
"template.chart.cpxse":``,
"chatter.feed.deletecomments":`이 주석을 삭제하시겠습니까?`,
"label.list.userinterface.show.newrcords.enable":`최신 기록 금지 사용`,
"label.sso.saml.idp.config.enablelogout":`싱글 로그아웃 사용`,
"label.file.library.create":`문서 라이브러리 새로 만들기`,
"label.event.moveup.half.day":`0.5일을 앞당깁니다`,
"label.stdashbord.xsld.business.jhzje":`기회 총금액`,
"label.partnerCloud.orderingPlatform.unitPrice":``,
"label.recordtype.edit.attribute":`일반 속성`,
"front-template-V1-TemplatePreview":``,
"label.tabpage.personalCenterz":`개인 센터`,
"label.setuplookuplayout":`레이아웃 조회`,
"label.no.merge.records":`병합할 수 있는 기록이 없음`,
"label.attachementNew.set2":`2단계. 문서 보관 여부`,
"label.publicgroup.detail.showmembers":`그룹 멤버 보기`,
"UG.Forcast.03":`계획을 사용하여 업무 전략을 실시합니다. <br> 즐겁게 예측하세요!`,
"label.h5.manageprompt":`메뉴를 선택해서 홈페이지에 추가하거나 메뉴 아이콘을 클릭하여 메뉴를 엽니다`,
"label.icon.145":`연동`,
"label.select":`선택`,
"label.publicgroup":`공용 그룹`,
"label.customcomponent.usewhere.title":`이 구성요소의 사용 위치:`,
"label.custom.page.button.name":`버튼 명칭`,
"pagecreator_layout_button_vertical":`세로 분할`,
"label.marketsea.autorecyclerule":`자동 회수 규칙`,
"label.reportsSubscription.entrance.attachment":``,
"component_chatter_button_collect":`저장`,
"label.page.step2.of.step5":`2단계, 총 5단계`,
"label.reportsSubscription.addfile.helptext":``,
"label.oldpw":`구 비밀번호`,
"lable.SalesCommitmentKanBan.contractAmount":`계약 체결액`,
"lable.Bundle":``,
"label.weixin.unit.million":`단위(만 위안)`,
"label.app.choseprofile":`프로필 분배`,
"label_tabpage_editz":`편집`,
"label.email.attachement.size.info":`파일 최대 크기는`,
"label.chatter.pastSevenday":`지난 7일 동안`,
"label.weixin.end.later.start":`종료일이 시작일과 같거나 보다 커야 합니다`,
"label.passwordPolicy.setup.lockoutPeriod":`시간 잠그기`,
"pagecreator_page_funcpath":`/빌더/페이지 리스트`,
"label.emailobject.apperror":`사용할 수 있는 메일 서비스가 없으며 관리자에게 연락하세요`,
"label.custom.page.button.broadband":`버튼 너비 (픽셀)`,
"label.weixin.contract.rate":`계약서 달성률`,
"label.brief.payments":`대금 회수 금액`,
"lable.approvaldatamove.transfermsg":`신규 사용자에게 미완성 승인 요청을 전송합니다`,
"label.datamanage.account.namenull":`주의: "고객 명칭" 필드에 값을 부여하지 않았다면, 고객 기록을 불러오지 못합니다!`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`총 누적 대금 수령액`,
"Opportunity_Detailed_Phase_Label_001":`단계`,
"vue_label_helpcenter_calendar2":`<br>   대상자 캘린더:대상자로 만든 캘린더는 일자 피드에서 데이터를 캘린더 조항으로 기록되어 캘린더 뷰에서 나타난다. 대상자 캘린더를 편집 및 삭제할 수 있다. 대상자 캘린더마다 지정된 색깔로 설정 가능하다. <br>이벤트<br>   다음과 같은 두가지 방식으로 캘린더 뷰에서 이벤트를 생성할 수 있다. <br>    （1）캘린더 뷰 우상측의 '이벤트 새로 만들기'버튼을 눌러 이벤트를 새로 만들 수 있다. 이벤트 새로 만들기에서 '관련 항목'및 '명칭'필드에서 다른 대상자를 선택할 수 있다. 그러므로 이벤트와 다른 대상자, 예를 들어 업무 기회 등과 연동시킬 수 있다. 다른 대상자와 연동된 이벤트 기록이 다른 대상자 상세 정보 페이지'행사'모듈에 동기화된다. <br>    （2）캘린더 그리드를 클릭하여 이벤트를 새로 만들 수 있다.<br>대상자 캘린더 새로 만들기<br>    1단계: 메뉴 캘린더 옵션 카드를 클릭하여 캘린더 뷰 페이지로 이동한다.<br>   2단계:뷰 우측에서 나의 캘린더를 찾아 나의 캘린더 옆의 아이콘을 클릭하여 뜨는 '대상자 캘린더 새로 만들기'팝업창에서 작업한다. <br>    3단계: 새로 생성된 대상자 캘린더에 대해 명명한다. 캘린더 기초의 대상자를 선택해 캘린더에서 나타난 내용의 필드를 선택해 '시작 필드''뷰 필터''보기 필드'. 시작 필드는 데이터의 시간 범위를 결정하여 뷰 필터로 데이터를 걸러낼 수 있다. 보기 필터는 캘린더 조항에서의 보기 내용을 결정한다. <br>기타 캘린더<br>    기타 캘린더에는 다른 사용자의 캘린더 추가를 포함된다.부하를 추가하거나 공유된 인원의 캘린더를 추가 가능하다. 。<br>    나의 이벤트 캘린더 공유<br>    1단계: 메뉴 캘린더 옵션 카드를 클릭하여 캘린더 보기 페이지로 이동한다. <br>    2단계: 보기 우측에서 나의 캘린더를 찾아 나의 캘린더 옆의 아이콘을 클릭하여 '대상자 캘린더' 팝압창에서 작업이 가능하다. <br>   3단꼐:새로 만든 대상자 캘린더에 대해 명명한다. 캘린더 기초로 삼는 대상자를 찾아 캘린더 보기의 다른 사용자의 캘린더를 선택해 부하나 공유된 캘린더 인원의 캘린더를 추가할 수 있다. <br>    나의 이벤트 캘린더 공유한다. <br>    1단계:메뉴 캘린더 옵션 카드를 클릭하여 캘린더 보기 페이지로 이동한다. <br>    2단계:캘린더 보기 우측에서 나의 캘린더 밑에서 '나의 이벤트'를 찾아 '나의 이벤트'우측의 '드롭다운 버튼'을 클릭하여 캘린더 공유를 선택한다. <br>    3단계:'공유 캘린더' 팝업창에서 공유하고 싶은 캘린더의 사용자 및 방문 권한을 선택한다. 이 외에 '현재의 방문 권한자'를 클릭하여 공유 캘린더의 기록을 찾아 공유 기록 우측의 “×”아이콘을 클릭하여 공유 기록을 제거 가능하다. <br> 캘린더를 공유한 후 부하 동료가 당신의 이벤트 캘린더를 다른 캘린더에서 추가하여 확인 가능하다.<br>캘린더 추가 <br>   1단계:메뉴 캘린더 옵션 카드를 클릭하여 캘린더 보기 페이지로 이동한다. <br>   2단계:캘린더 보기 우측의 다른 캘린더의 '드롭다운' 버튼을 클릭하여 캘린더 추가를 선택한다. <br>    3단계: '캘린더 공유' 팝업창에서 추가하고 싶은 이벤트 캘린더를 선택한다. 부하의 이벤트 캘린더를 선택하거나 공유할 수 있다. 추가를 클릭하면 추가 성공한다. <br> 추가된 캘린더를 제거한다<br>   다른 캘린더 밑을 클릭하여 제거하고 싶은 캘린더 우측의 '드롭다운 버튼'을 눌러 '제거'를 선택한다.`,
"label.callcenter.Seat.number":``,
"vue_label_commonobjects_view_change_all_selected_records":`선택한 기록 변경`,
"label.user.notinuse":`사용자가 비활성화돼 있습니다. 관리자에게 연락하십시오`,
"label.usermanage.hasbeen.reached":`허가 사용자수의 최대치를 도달해 서비스 제공업체에게 연락해 더 많은 허가를 획득하세요!`,
"vue_label_help_list":`리스트 뷰`,
"label.infomation.edit":`기본 정보 편집`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`삭제 여부`,
"label.unique.identification.number":``,
"label.weixin.no.pending.projects":`승인 대기중인 프로젝트가 없습니다`,
"label.projectManagement.Pleaseenteramember":``,
"label.salescloud.salesdashboard.visit":`방문`,
"label.weixin.user.registered":`사용자 등록`,
"message.loginhistory.downloadcsv":`최근 6개월의 로그인 이력을 다운로드합니다.(Excel.csv파일)`,
"label.icon.37":`포지셔닝`,
"template.chart.schdyqyx":``,
"label.tel.ten":`최대 10개 알림 전송의 핸드폰 번호를 입력할 수 있어 번호 간에 ;로 "간격 주기".`,
"label.data.exp.objdata":`다음의 조건으로 이 대상의 데이터를 내보낼 수 있습니다`,
"label.loginservice.after.use":`후 사용할 수 있습니다.`,
"pagecreator_systemstyle_message_delete":`현재 선택한 양식을 삭제하시겠습니까?`,
"label.globalselect.deleteerror":`해당 선택 항목 리스트값 세트를 다음의 필드가 사용하고 있어 삭제할 수 없습니다.`,
"label.department.add":`부서 추가`,
"label.attendance.dingwei":`포지션`,
"label.workflow.editrule":`규칙 편집`,
"lable.product.pecm":`정확한 금액을 입력하세요!`,
"label.icon.182":`서류 가방`,
"label.help.release.notes":`안내 메뉴 발표`,
"UG.product.05":`제품 불러오기`,
"label.email2":`메일`,
"label.weekrepeat":`주일 중복`,
"label.mr.descreption.oneGroupReData2":`그룹`,
"chatter.at.d":`활약도`,
"label.mr.descreption.oneGroupReData1":`중복 검사 병합 진도: 총`,
"label.weixin.mobile.fly.android":`Android 모바일기기 공유`,
"label.brackets.right":`)우측 괄호`,
"message.recordtype.applytoAllProfiles":`한 페이지 레이아웃을 모든 프로필에 적용합니다`,
"label.customcomponent.page.index.tip":`기능이 프로그래밍 언어의 작업 방식이 비슷하여 사용자 설정 구성요소가 일반 디자인 모드를 캡슐화하는 것을 허용하며 한개나 여러개 사용자 설정 페이지에서 그 모드들을 다시 사용합니다.`,
"lable.List.properties":``,
"label.fieldinfo":`필드 정보`,
"label.ems.error.fail":`로딩에 실패했습니다. 다시 시도하거나 시스템 관리자에게 연락해 주십시오`,
"label_emailsync_form_email":`메일`,
"lable.currencyManage.button.manageRate":`화폐 관리`,
"component_salesperformance_label_100finish":`종료됨`,
"label.knowledgebase.data.assignment.failed":``,
"label.custom.buttonandlink.remark":`모드 선택:기존 윈도/ 새 윈도(기존 윈도: 현 윈도에서 열기, 새 윈도: 새 페이지 윈도를 다시 열기)`,
"label.list.userinterface.watermark.setup":`워터 마크 설정`,
"component_timeline_label_7daysahead":`지난 7일`,
"label.sendemail.chat.replyinchat":`위쳇 게시물 댓글:`,
"component.salesperformance.label.title":`판매 실적`,
"label.data.downpage.e.list.desc2":`데이터를 성공적으로 내보낸 후 데이터 내보내기 성공 메일을 받으십니다.`,
"vue_label_campaign_fromclosedopprotunities":`{sjcb}개 수주계약 업무 기회에서 옴`,
"label.umeng.activity.taskviewed":`#name에게 분배한 업무가 확인되었습니다`,
"vue_label_salesadvance_retentions":``,
"label.fieldtag":`필드 라벨`,
"label.quickbooks.button.searchinquickbooks":`QuickBooks에서 검색하기`,
"label.quickbooks.viewlist.action":`조작`,
"label.weixin.sysapp":`시스템 응용`,
"label.approval.examine.level":`사용자 등급별로 한 단계씩 승인합니다. 최대 사용자 등급은`,
"label.appupload.upload.error":`이 프로그램을 설치할 수 없습니다.설치를 종료하거나 시스템 내 API를 수정하여 다시 설치하십시오!`,
"label.emailtemplate":`메일 템플릿`,
"front-email-payment-Invoice-amount":``,
"label.viewselectedproducts":`선택된 제품 보기`,
"label.tianyancha.businessverify.openfirst":`먼저 공상 데이터 인증을 사용하십시오`,
"lable.SalesCommitmentKanBan.returnAList":`인원 리스트로 돌아가기`,
"label.knowledgebase.nopublished.draft.translations":``,
"vue_label_calendar_day_view":`캘린더 - 일 뷰`,
"label.globalselect.remark":`전역 선택항목 리스트값 세트를 통해 대상 간 값을 공유할 수 있도록 합니다.`,
"label.orderby":`정렬 방식`,
"lable.weixin.LastaDaysFinished":`지난 7일 완료됨`,
"lable.currencyManage.Enabledadvcurrency.discripation":`화폐 환율을 지정한 날짜의 범위 내에 기한이 지난 환율에 매핑할 수 있습니다. 기한이 지난 환율은 업무기회, 업무기회제품과 이 두 대상에 관한 보고서를 사용합니다.기한이 지난 환율은 다른 대상의 필드나 다른 유형의 보고서에는 사용할 수 없습니다. 예를 들어 1월 1일 환율은 1USD는 6.68CNY였지만 2월 6일 1USD는 6.70CNY로 바뀌었습니다.종료일이 1월 1일부터 2월 6일까지인 업무기회는 첫째 환율(1=6.68)을, 종료일이 2월 6일 이후인 업무기회는 둘째 환율(1=6.70)을 사용합니다.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`첫째 주일`,
"label.leadtoobjectfield":`잠재고객 필드 매핑 설정`,
"label.dashboardSetup.shujuyuan":`데이터 소스`,
"label.tabpage.userz":`사용자`,
"label.sms.companyname.dsf":`DONG SHI FANG 문자 메시지 인터페이스`,
"label.step2.total3":`2단계, 총 3단계`,
"front-gantt-module-Drag-dropt- reorder-tasks":``,
"label.dashboard.snapshot.no.enabled":`대시보드 스냅숏 기능 미사용`,
"label.dashboard.unit3":`단위: 정수 단위`,
"label.forecast.shrepage.desc2":`공유 방문을 보유한 사용자, 역할 및 구역.`,
"label.commonobjects.new":``,
"label.view.nameonlyone":`뷰의 유일한 명칭`,
"label.assignment.setup.newentries.user":`사용자`,
"label.otheremails":`다른 메일`,
"component_sendmail_button_send":`전송`,
"vue_label_accountpool":`고객풀`,
"label.h5.approval.actortime":`개시 시간`,
"message.approval.cannotsubmit":`승인 대기를 제출할 수 없습니다`,
"vue_label_pool_createdbyme":`내가 생성한 항목`,
"label.change.event":`이벤트 뷰로 전환`,
"vue_label_homepage_personalpage":`개인 홈페이지`,
"label.new.collect.target":``,
"label.ServiceCloud.zichanxuhao":``,
"label.product.userl":`모든 사용자에 사용된 열`,
"label.syslog":`시스템 일지`,
"label.reportcreatestatus":`보고서 생성 상태`,
"label.datamanage.account.novalue":`주의: 이번 불러오기 조작이 '고객 명칭'에 값을 부여하지 않았으며 고객 기록을 불러오지 않을 것입니다!`,
"label.letter.body":`초대장 본문`,
"label.select.please":`선택하세요`,
"label.escalation.setup.entrydetail.description":`1. 편집을 클릭하여 규칙 항목 속성을 변경합니다<br/>2. '새로 만들기'를 클릭하여 업그레이드 조작을 추가합니다.`,
"label.component.salesDashboard.nodata":`사용 중인 업무 기회를 추가한 다음 실적 보기 위해 다시 돌아옵니다.`,
"vue_label_helpcenter_account":`상세 정보에서 고객 옆의 계통수 버튼을 클릭하여 고객의 구조도를 볼 수 있어 관련 고객의 등급 관계를 보고 모든 고객의 일부 필드 정보를 볼 수 있다. <br>고객의 소유인을 변경할 때 해당 고객의 관련 업무 기회, 개인안 등 정보의 소유인을 동시에 변경할 수 있다.`,
"front-kefu-moudle-v1-awshjzx-intelligent":``,
"label.productby":`생성자`,
"label.operation.date":`조작 시간`,
"label.name.donot.delete":`이름을 제거할 수 없습니다`,
"label.validate.function.funcFormat.DATETIMEVALUE":`일자 시간 값(일자)`,
"label.escalation.setup.entrydetail.howescalationtime":`업데이트 시간을 어떻게 설정합니까?`,
"label.view.step2":`2단계. 필터링 조건을 지정합니다`,
"lable.outlook.edit.notnull":`필드명을 비워둘 수 없습니다`,
"label.knowledgebase.createnewbrowser":``,
"label.partner.all.name":`파트너 클라우드 명칭`,
"chatter.group.groupSetUp":`그룹 설정`,
"label.reportlist.findfolder":`폴더 찾기`,
"component.setup.tabs.label.title":`Tab 페이징`,
"label.passwordPolicy.setup.pswComplexReq":`비밀번호 복잡도 요구`,
"label.emaildocument":`메일로 파일을 보냅니다`,
"message.selectgsummaryconditon":`통합 조건을 선택하세요`,
"component_todaytask_label_notask":`오늘 만료된 업무가 없습니다- 시간이 있으시면 커피 한잔 하시죠.`,
"label.user.organization.notexists":`조직이 존재하지 않습니다!`,
"label.isEnableVisualpage.new.leftlist":`가용한 사용자 설정 페이지`,
"label.mobile.phone.write.week.report":`주보 쓰기`,
"label.emailmerge.edittemplate.edit":`메일 병합 템플릿 편집`,
"template.dashboard.folder.sales.manage":``,
"label.confirm.order.productsToassets":``,
"label.service.dispatchingUnits.leftRight.total":``,
"label.import.step1.chooseidorother":``,
"label_tabpage_completez":`선정한 상태를 완성으로 표시합니다`,
"chatter.c.adr":`연락 주소`,
"label.account.d":`이 페이지에서는 사용자 설정 회계 분기 기록을 정의할 수 있습니다.사용자 설정 회계 분기의 날짜는 아래의 선택에 따라 생성됩니다.`,
"label.tag.more50":`최다 50개 라벨을 생성할 수 있습니다`,
"setup.layout.label.areashow":`구역 명칭 위치`,
"label.partnerCloud.basicSetting.rebate":``,
"label.tabpage.greaterequalz":`보다 크거나 같거나`,
"vue.please.select.the.aggregate.basis":``,
"label.form":``,
"label.chatter.colleagues.list.beizhu":`사용`,
"label.priority":`선순위`,
"vue_label_checkduplicate_set_repeat_rules":`중복 규칙 설정`,
"label.share_form":``,
"label_relation_shareholder":``,
"label.project.hit.sixteen":``,
"label.service.miniProgram.imageFormat":``,
"label.summary.mode":`통합 방식`,
"vue_label_beforeverification":`인증 전`,
"label.data.newtemplate.desc":`사용자가 선정한 필드와 조건을 템플릿으로 저장하여 사용자가 반복 조작을 통해 직접 템플릿으로 내보낼 수 있습니다.`,
"lable.evaluation.badreview":``,
"label.total.tabs":`총 {0}개 {1}이 있습니다`,
"label.emailmerge.mergeFolder.foldertemplate":`이 폴더의 템플릿`,
"vue_label_normal_notice_repeated":`중복 추가 금지`,
"label.icon.140":`데이터`,
"label.fromonetoanother":`한 사용자에 다른 사용자로 이동`,
"label.user.list":`사용자 리스트`,
"label.file.prevent.share.operate":`다른 사람의 공유 및 공유 취소를 방지합니다`,
"label.app.detail":`응용프로그램 보기`,
"label.h5.similar.opportunity.correlation":`관련성`,
"label_emailtocloudcc_filed_username":`메일 사용자명`,
"vue_labe_account_shareholdingratio":``,
"label.data.dataexpalltype.all_desc3":`3. 내보낸 데이터는 압축 파일을 생성합니다. 메일에 있는 파일 정보를 바탕으로 내보낸 파일 리스트 페이지에서 내보낸 파일을 다운로드할 수 있습니다.`,
"label.callcenter.please.select .seatID":``,
"label.remark.length.cannot.than":`설명 길이가 255를 초과할 수 없습니다`,
"label.batchtransfer.dateandtimetype.tip":`일자/시간 필드의 경우 다음과 같은 형식으로 값을 입력합니다:`,
"label.component.helper.businesschange.0UntreatActivity":`미처리 행사의 업무 기회 없음`,
"front-project-module-v1-plase-input-start-time":``,
"label.event.moveup.6hour":`6시간을 앞당깁니다`,
"label.data.exp.tempexp":`템플릿으로 내보내기`,
"label.schedulejob.setup.schedule.afternoon":`오후`,
"label.ems.format":`형식`,
"label.objectHasBeenDeleted":`삭제된 대상`,
"label.ServiceCloud.chaxunchenggong":``,
"label.campaign.channel.input.notice.owner":`소유인에게 알리기`,
"label.bajisitan.time":`파키스탄 시간`,
"label.warnMes":`대상이 인용되었으며 삭제 살패했습니다!`,
"lable.Up.to.ten.fields":``,
"label.approverule":`승인 규칙`,
"message.error.specific":`구체적인 오류 안내로 돌아가기`,
"front-template-V1-saveUse":``,
"label.uploadfile.success":`업로드 성공했습니다`,
"label.tabname.donot.database.key":`메뉴명이 데이터베이스 키워드일 수 없습니다!`,
"message.recordtype.selectlayout.select":`--페이지 레이아웃 선택--`,
"front-detail-module-v1-list-cardview":``,
"label.product.maintenance":`유지`,
"vue_label_helpcenter_approve":`1. 승인 대기 중인 프로젝트 <br> 승인이 필요한 프로젝트를 열거한다. 승인 기록의 시작 일자, 마감 일자, 제출인, 기록 유형 및 관련 항목으로 승인 대기 목록을 검색한다. <br>단일한 기록 처리: 기록의 좌측 버튼을 클릭한다. <br> A. 승인 진행<br>1단계: '승인 진행'을 클릭하여 승인 요청 페이지로 이동한다 <br> 2단계: '동의'나 '거절'을 클릭하여 승인 작업이 완성된다. <br> 승인 절차 배치에서 다음 승인 절차가 수동으로 승인자를 선택해야 한다면 '동의'를 클릭한 후 3단계를 실시한다. <br>3단계: 다음 승인자를 선택해 승인 작업이 완성된다. <br> 승인 절차 배치에서 승인이 거절된 후 뒤로 돌아가기 절차를 선택해야 한다면 '거절' 후에 4단계를 실시한다.<br>4단계: 뒤로 돌아가는 승인 절차를 선택해 승인 작업이 완성된다.<br> B. 다시 분배 <br>1단계: '다시 분배'를 선택한다. <br> 다시 분배자를 검색한다. <br>3단계: '승인 요청 다시 분배'를 클릭하여 승인자의 다시 분배 작업이 완성된다. <br> 주의:한 기록의 대리 승인자라면 다시 분배 작업이 불가능하다. <br> 많은 기록을 대량 처리하기: 여러개 승인 대기 프로젝트를 선택해 리스트 위의 작업 버튼을 누른다. <br>C. 승인 진행 <br> 1단계: 여러개 승인 기록을 선택한다. <br>2단계:'승인 진행'을 클릭한다. <br>3단계: '동의'나 '거절'을 클릭하여 승인 작업이 완성된다. <br>승인 절차 배치에서 승인이 거절된 후 뒤로 돌아가기 절차를 선택해야 한다면 '거절' 후에 4단계를 실시한다. <br>4단계: 뒤로 돌아가는 승인 절차를 선택해 승인 작업이 완성된다. <br> D. 다시 분배 <br> 1단계: 여러개 승인 대기 중인 기록을 선택한다.<br>2단계: '다시 분배'를 클릭한다. <br>3단계: 새 분배자를 검색한다. <br>4단계: '승인 요청 다시 분배'를 클릭하여 승인자의 다시 분배 작업이 완성된다. <br> 2. 내가 제출한 프로젝트 <br> 제출한 모든 승인 프로젝트를 열거하여 승인 기록의 시작 일자, 마감 일자, 제출인, 기록 유형, 관련 항목과 승인 상태를 통해 기록을 찾을 수 있다. <br>3. 내가 동의한 프로젝트 <br> 모든 동의한 승인 프로젝트를 열거한다. 승인 기록의 시작 일자, 마감 일자, 제출인, 기록 유형, 관련 항목 및 승인 상태를 통해 기록을 찾을 수 있다. <br>4. 내가 거절한 프로젝트 <br>모든 거절한 승인 프로젝트를 열거한다. 승인 기록의 시작 일자, 마감 일자, 제출인, 기록 유형, 관련 항목 및 승인 상태를 통해 기록을 찾을 수 있다.`,
"label.knowledgebase.knowledge.article":``,
"march":`3월`,
"label.accraditation":`승인`,
"vue_label_pool_cantreach":`고객과 연락 두절`,
"label.service.appointmentList.startOf.maturityPeriod":``,
"message.huanxin.closed":``,
"label.implementation.time.operation":`타이머 작업 실행`,
"label.setting.intergrationlist.permissions":`통합 권한`,
"label.translation.norecord":`기록 없음`,
"label.lack.expression":`표현식 부재`,
"setup.layout.message.relatedlistfield":`관련 리스트에서 보는 필드를 선택하여 선택한 필드에 대해 순서를 다시 조정할 수 있습니다.`,
"label.group.file":`그룹 파일`,
"message.error.id.null":`해당 id정보가 없습니다`,
"label.a_b_least":`"A" 기록에 최소 한개 관련 "B" 기록이 있어야 합니다.`,
"label.addattachment.step3":`4단계. '완성'버튼을 클릭하여 전 페이지로 이동`,
"label.data.exportsf":`내보낸 파일`,
"label.callcenter.call.out":``,
"front-electronic-export-exportIntro":``,
"label.custombutton.deletedata.notnull":`삭제되는 데이터가 없습니다`,
"UG.homepage.002":`통합된 업무툴로 고객 경로, 잠재 고객, 세일즈 퍼널 및 고객 정보를 관리합니다.`,
"label.globaloperation":`전역 조작`,
"label.icon.58":`노동자`,
"vue_label_salesadvance_lostrate":``,
"chatter.from":`에서`,
"front-epwechat-module-v1-account-binding":``,
"label.list.userinterface.old.page.setup":`구버전 인터페이스`,
"label.forecast.settings.periods":`개 주기`,
"label.file.share.email.content":`#sharedBy가 #orgname에서 파일을 공유했습니다`,
"label.knowledge.category.hint.five":``,
"setup.layout.label.selectedfield":`필드 선택`,
"label_business_income":`업무 기회 수입`,
"vue_label_display_options_field":``,
"label.emailtocloudcc.set":`메일 정보 설정`,
"label.knowledge.setting.data.five":``,
"front-epwechat-module-v1-bound-enterprise":``,
"label.ccpeak.delete.recycle":`기록이 휴지통에 삭제됩니다.`,
"label.leadconvers.tip":`잠재고객은 고객, 연락담당자, 업무기회 및 후속 업무로 전환할 수 없으며, 잠재고객의 가치가 확인되어야만 해당 잠재고객을 전환할 수 있습니다.`,
"label.rsa.key.invalid":``,
"label.mobile.bind.success":``,
"label.emailtocloudcc.filed.servertype":`서버 유형`,
"label.user.new":`사용자 새로만들기`,
"label.setup.mobile.homepageshortcuts.remark":`각 조직이 업무 시나리오대로 조직의 홈페이지 상단 구역 단축키 배치를 설정할 수 있습니다.`,
"label_emailtocloudcc_select2":`표시 유형을 선택하세요`,
"page.send.email":`메일 전송`,
"label.service.newBuildDialog.field.display":``,
"vue_label_homepage_card_impending":`곧 다가올 업무 기회`,
"label.message.contactispartner.delete":`이 연락담당자와 연동된 협력 파트너 사용자가 있어 삭제할 수 없습니다`,
"label.attendance.checkout":`퇴장`,
"label.emailmerge.newtemplate.description":`메일 병합 템플릿과 관련된 정보를 입력합니다. 주의: 비고가 CloudCC에서만 볼 수 있어 Word에서 나타나지 않습니다.`,
"laebe.data.exp.success":`내보내기 성공한 후 시스템 메일 알림을 받습니다. 내보낸 데이터가 잠시 48시간 동안 서버에 저장되어 되도록 신속하게 내보낸 데이터 리스트 페이지에서 내보낸 데이터를 다운로드 하십시오.`,
"lable.Maximum.number":``,
"label.projectManagement.drag.and.drop.existing.tasks":``,
"label.forecast.tree.desc":`예측 등급 구조는 귀 조직에서 어떻게 예측치를 합계하고 누가 이를 살펴보고 조정할 수 있는지 결정합니다.이것은 역할 등급 구조에 따라 자동으로 만들어지지만 책임자, 판매 대표나 다른 사용자를 추가하거나 편집해야 합니다.개별 예측 사용자에게도 예측 공유를 사용할 수 있습니다.`,
"vue_label_chatter_upload_file_type":`파일 유형의 게시물 업로드를 선택함`,
"front-lightning-module-v1-dashborad-analysis-dimension":``,
"vue_label_homepage_custom_homepage":`사용자 설정 시작 페이지`,
"label.icon.39":`포지셔닝`,
"label.appointmentpage.wizard.notif1":`시간부터 선택하세요`,
"vue_label_report_filterby":`{screenCondition}대로 선별하기`,
"label.argentina.time":`아르헨티나 시간`,
"label.role.assign.notremove":`<b>선택된 사용자</b>리스트의 사용자를<b>미분배 및 사용한 모든 사용자</b>와<b>모든 미분배 사용자</b>두 가지 옵션으로 이동시킬 수 없습니다.`,
"label.sharerule.detailsetshare":`상세 공유 규칙`,
"label.file.publicview.error1":`파일이 삭제되었거나 공용 링크가 비활성화되었습니다`,
"label.data.downpage.e_title.num4":`4. 내보내는 파일 형식이 두가지가 있습니다: CSV형식과 압축 파일 형식.압축 파일 형식이 두가지가 있습니다: 하나는 자동으로 압축 파일 비밀번호를 생성합니다. 또 하나는 수동으로 압축 파일 비밀번호를 입력합니다.`,
"label.knowledge.case.article":``,
"label.data.newtemplate.e.conditions":`내보내기 조건`,
"front-object-change-owner":``,
"label.newdashboardpage.edittitle":``,
"label.datamove.end.query.no.record":`조회 완료, 조건에 부합하는 기록이 없습니다!`,
"lable.SalesCommitmentKanBan.receiptsTarget":`대금 수령 목표`,
"label.orderagain":`다시 정렬합니다`,
"vue_report_dashboard_transfer":``,
"label.view.sortview.default":`기본 뷰`,
"label.brasilia.time":`브라질리아 시간`,
"label.industrialandcommercialverification.instructions":`공상 데이터 인증을 통해 사용자가 업체 고객 자료를 입력할 때 정확한 고객 공상 등록 정보를 입력할 수 있도록 도와줍니다. 주의: 해당 기능이 중국 대륙 지역에 등록된 공상 업체 데이터만 검색 가능합니다.`,
"label.chatter":`클라우드 게시물`,
"label.sso.goBackToList":`리스트로 반환: 비밀키 관리`,
"label.mobile.side.tab.state":`사용자 설정 슬라이딩 메뉴 사용`,
"label.weixin.addbus":`차량 추가`,
"label.dropbox.description":`CloudCC에서 사용할 수 있도록 DropBox 계정을 연결시킵니다.`,
"label.service.newBuildDialog.available.tousers":``,
"label.knowledge.language.thai":``,
"label.passwordPolicy.setup.foreverlock":`영구(관리자가 잠금을 해제해야 함)`,
"label.bmap.unreported.location":`지리 위치 정보를 보고하지 않았습니다.위챗의 공식 계정에 설정해 주세요.`,
"label.tag.field":`라벨`,
"label.addyourlanguage":`'추가'를 클릭하여 귀조직이 지원되는 언어를 추가합니다.`,
"label.chat.topic.my.use":`내가 사용한 주제`,
"UG.contact.06":`연락담당자 불러오기`,
"label.embed_code":``,
"label.campaign.channel.input.chenben":`3. 실제 원가:`,
"label.quickbooks.estimates":`추산`,
"label.report.items.i.created":`내가 작성한 보고서`,
"label.forecast.edit.fwqd":`범위 시작점`,
"label.validate.function.funcExplain.DATEVALUE":`입력한 일자/시간 필드에 따라(년, 월, 일 및 GMT 시간 포함) 한 일자 필드(년,월,일 포함)로 돌아가기`,
"vue_label_helpcenter_calendar1.1":`이벤트는 고객 관계를 파악하고 거래를 성사시킬 수 있는 강한 툴이다. 이벤트와 업무 기회, 잠재 고객, 고객 및 연락담당자를 연동시킬 수 있다. 캘린더 뷰에서 주로 이벤트 기록을 표시한다. <br>1、캘린더 뷰와 리스트 뷰 <br>캘린더 보기<br> 메뉴 안내의 캘린더 옵션 카트를 클릭하여 캘린더 페이지를 방문한다. <br>캘린더 뷰<br> 캘린더의 종류: 캘린더 뷰는 월별 뷰, 요일 뷰, 일 뷰와 가용성 뷰. 다른 그리드 양식을 통해 다른 시간 범위의 기록 데이터를 볼 수 있다.이 중에 가용성 뷰는 나의 캘린더와 기타 캘린더를 포함한 모든 캘린더를 차원으로 하는 일일 기록 데이터를 볼 수 있다. 캘린더 페이지 우상측의 '캘린더 버튼' 아이콘을 클릭하여 뷰를 전환할 수 있다. <br>캘린더 뷰에서 볼 수 있는 내용: 캘린더에는 나의 캘린더와 기타 캘린더가 포함된다. 캘린더 뷰에서 나의 캘린더, 나의 이벤트 캘린더와 대상자 캘린더의 모든 기록 데이터를 볼 수 있다. 그런 기록들을 '캘린더 항목'이라고 부른다. <br>캘린더 뷰를 통해 모든 이벤트를 확인할 수 있다. 대상자로 생성한 캘린더는 일자 필드에서 그 데이터를 캘린더 항목으로 캘린더 뷰에서 볼 수 있다. 캘린더 뷰에서 기타 캘린더를 볼 수 있으며 즉 뷰에서 추가한 동료가 공유한 캘린더 항목을 볼 수 있다. <br>`,
"label.tabpage.rowsz":`행 삭제`,
"label.file.library.managemembers.memberlist":`현재 멤버`,
"label.report.action.addtodashboard4":`기존 대시보드로 추가`,
"label.chat.send.voice":`음성 메시지를 보냅니다`,
"label.home.dashboard.add":`홈페이지 대시보드 추가`,
"front-dialog-module-v1-copied-requestid":``,
"label.customfields.exportdata":`데이터를 내보냅니다""`,
"label.emailobject.signature":`서명 편집`,
"label.hide.source":`소스 코드 숨기기`,
"label.icon.71":`수리`,
"vue_label_help_whatslightning":`Lightning는 무엇인가?`,
"report.type.label.systemReport":`시스템 보고서`,
"front-kefu-moudle-v1-input-email":``,
"label.event.moveup.5minutes":`5분을 앞당깁니다`,
"message.error.postsid.null":``,
"UG.Account.05":`연락담당자 구조도`,
"label_emailtocloudcc_description3":`업체 메일을 예, sales@company.com, info@company.com, support@company.com를 여기에 추가하여 시스템이 받은 메일을 통해 잠재 고객이나 개별안 기록을 자동 생성하여 왕래 고객을 팔로우업할 수 있도록 확보합니다.`,
"report.label.searchresult":`검색 결과`,
"vue_label_report_detailsonly_desc":`자세 정보만 내보내기. 본 데이터를 통해 더 많은 캘큐레이팅을 진행하거나 다른 시스템으로 업로드한다.`,
"label.partnerCloud.partnerAccount.payment":``,
"vue_label_commonobjects_view_select_member":`멤버 선택`,
"label.emailtocloudcc.step1.lead1":`잠재 고객에게 메일 발송`,
"label.forecast.settings.current":`현재 주기`,
"label.canceluploadfile":`업로드 취소`,
"label.manual.shared":`수동 공유`,
"label.document.uniquename.length.cannot.than":`파일의 유일한 이름 길이는 255를 초과할 수 없습니다`,
"vue_label_lead_notcreateopportunity":`업무 기회를 생성하지 않기`,
"APPIntegration.Social.twittererror":`합법적인 twitter.com의 URL이어야 함.`,
"message.duplication.label.errormessage":`오류 정보`,
"label.file.img":`이미지`,
"label.tabpage.sum":`합계`,
"label.permission.systempermission.fenpei":`시스템 권한 분배`,
"template.dashboard.folder.data":``,
"label.sms.account":`사용자 계정`,
"label.product.filter":``,
"label.file.content":`정문 내용`,
"label.percent":`백분율`,
"label.single.attachment":`한 개`,
"label.processsetting.failed.enable.process":``,
"label.view.modify":`뷰 편집`,
"label.knowledgebase.enter.keywords.filter":``,
"label.tabpage.uploadfailez":`업로드 실패, 다시 시도하세요.`,
"label.please.enter.the.target.model.name":``,
"label.layout.availabletab.related":`관련`,
"label.label":`라벨`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`토요일`,
"label.addattachment.unit":`바이트`,
"vue_label_commonobjects_view_selected":``,
"label.view.sortview.printble":`인쇄 가능`,
"label.umeng.insert.approval.approvaling":``,
"label.forecast.customforecast.tztotal":`수정 후 총액`,
"label.ccchat.failtoset":`ccchat 설정에 오류 발생`,
"label.ccchat.message.new.error2":`의 Chat사용자`,
"label.validate.function.category.Advanced":`고급`,
"label.projectManagement.team.members":``,
"vue_label_report_clickcrosstofliter":`위 표의 교차점을 클릭하여 상세 정보를 선별합니다.`,
"lable.opppdt.selPdt.leasttwenty":`최대 25개를 선택할 수 있습니다`,
"label.campaign.channel.download":`고선명 QR코드 다운로드`,
"component_event_label_person":`피분배자`,
"vue_label_homepage_new_homepage":`홈페이지 새로 만들기`,
"label.version.sum.vlidaterule":`개 인증 규칙`,
"vue_label_chat_click_for_details":`상세 정보 보기`,
"label.fold":`접기`,
"label.readonly":`읽기 전용`,
"label.h5.similar.opportunity.result":`유사 업무기회 결과 열`,
"label.yourimportsuc":`불러오기 요청이 처리됐으며 메일을 확인하세요.`,
"label.report.line.yixuan":`선정된 보고서 리스트`,
"setup_layout_label_areaname":`구역 명칭`,
"label.forecast.edit.title":`목표`,
"label.chatter.allweather":`전천후`,
"label.service.ganttBaiduMap.scheduled.endtime":``,
"lable.create.new.list":``,
"label.emailobject.groupemail.msg3":`{0}명 수신인`,
"lable.opppdt.selPdt.description":`키워드와 필터일 조건을 입력한 다음 "검색"을 눌러 검색을 시작합니다."더 많은 필터" 를 클릭하여 하나 이상의 필터를 사용합니다. 검색 결과에는 입력한 키워드와 필터링 조건에 맞는 모든 기록이 포함됩니다.`,
"label.file.versionerror1":`아래 링크를 누르면 새 인터페이스의 파일 메뉴로 바꿀 수도 있고, 새 인터페이스로 수동 전환한 후 파일 메뉴를 사용할 수도 있습니다.`,
"label.under.approve.record":`승인중인 기록`,
"front-epwechat-module-v1-open":``,
"label.projectManagement.delete.task":``,
"label.reportforms":`보고서`,
"label.tabpage.onlymevisible":`나만 보기`,
"label.customer.tab.please.name":`메뉴명을 입력하세요`,
"label_emailsync_form_stutas":`사용 상태`,
"message.recordtype.nolist":`미정의 기록 유형`,
"label.version.forecasting.sales":`세일즈 예측`,
"chatter.sel.mostfield":`최대 선택`,
"label.data.derived":`데이터 내보내기`,
"label.component.helper.businesschange.expiredtask":`업무 기회에 기한을 넘긴 임무 포함됨`,
"label.cycle":`주기`,
"lable.product.standp":`표준 가격`,
"label.sendemail.batchapproval":`대량 승인 조작`,
"message.organization.not.open.mffverification":`소재 조직이 2차 인증 미사용`,
"label.icon.131":`우산`,
"UG.activity.08":`일정 예약`,
"label_partner_workspace_member_choicepermission":`권한 세트 선택`,
"label.reportTypeCategory":`보고서 데이터 소스`,
"label.exporttwotype":`두 가지 텍스트를 내보낼 수 있습니다.`,
"message.oppdt.selectpricebook":`가격매뉴얼부터 선택하세요`,
"vue_label_dashboard_generatefromlistview":`리스트 뷰에서 생성`,
"label.quote.title":`제목`,
"label.tianyancha.businessverify.cancel.sure":`공상 데이터 인증 사용 취소 후 고객 새로만들기/편집 시 공상 등록 정보를 다시 입력할 수 없어 취소하시겠습니까?`,
"label.save":`저장`,
"label.mobile.quickcreate.default.appstore":`앱 스토어`,
"label.partnerCloud.orderingPlatform.configure":``,
"front-epwechat-module-v1-unbound-role":``,
"label.partnerCloud.financeSetting.enterAlipay":``,
"label.validate.function.funcExplain.TODAY":`현재 날짜로 돌아가기`,
"label.visualpage.parameter.values":`파라미터 값을 페이지에 직접 표시합니다:`,
"label.version.task.and.activity":`업무와 행사 팔로우업`,
"label.audit.history":`승인 대기`,
"setup.object.field.dependency.label.addtolist":`선택한 값 추가`,
"vue_label_report_exportquantity":`내보내는 수량:`,
"label_tabpage_havez":`있음`,
"label.partnerCloud.partnerAccount.amountOfRebate":``,
"label.createralias":`최초작성자 별명`,
"label.created_followup":``,
"label_chatter_mygroups":`나의 소그룹`,
"label.chat.topic.no.display":`볼 수 있는 주제 없습니다`,
"vue_label_calendar_month_view":`캘린더 - 월별 뷰`,
"label.service.gantt.resources.assigned.work":``,
"UG_activity_07":`업무 생성`,
"label.quote.xsjg":`판매 가격`,
"message.toomanyrows":`조회 기록이 매우 많습니다!`,
"label.importsourcestep1":`1단계: 번역 파일을 준비합니다`,
"vue_label_normal_appointment_sf":`일정 예약`,
"lable.list.queue.message":`대열에 소속한 대상 기록이 존재하여 해당 대열을 삭제할 수 없습니다`,
"label.service.major.event.desc":``,
"label.ems.hostorport.null":`서버 주소와 포트 번호가 비워질 수 없습니다`,
"chatter.group.private":`전용`,
"label.icon.192":`비누`,
"vue_label_systemSettings_list":``,
"label.activity.saveobj.notnull":`저장할 대상을 입력하세요`,
"vue_label_chatter_current_no_people_approval":`현재 승인해야 할 인원이 없습니다.`,
"label.tianyancha.reglocation":`등록 주소`,
"UG_ST_005":`알겠습니다. 이 페이지를 더 이상 보지 않고 직접 이동합니다.`,
"label.vlidaterule.example.truetodisplay":`해당 메시지가 '오류조건'공식이 <b>진실</b>일 때 나타납니다`,
"label.icon.99":`필기`,
"label.whenselectmoreapprover":`여러개 승인자를 선택 시`,
"label.forecast.customforecast.directorbest":`직접 부하들의 뛰어난 능력 발휘`,
"label.customsetting.view.introduce":`사용자 설정에 필드를 생성해줍니다. 이 필드의 데이터가 프로그램으로 캐시에 넣어둡니다.`,
"label.there.are.no.unenabled.rules":``,
"front-project-module-v1-plase-selectemplat":``,
"label.campaignmember.selectmember.from":`부터`,
"setup_layout_button_quicksave":`빠른 저장`,
"label.setup.service.report":``,
"label.visualpage.direction.for.use":`플랫폼 사용자 설정 페이지 사용설명 [2.0 버전]`,
"message.modify":`수정하시겠습니까?`,
"label.sms.inside":``,
"label.category.3":`교육`,
"label.login.mfadevice.verification.title":`MFA 설비 인증`,
"UG_Forcast_08":`지난 단계`,
"label.projectManagement.unable.to.complete":``,
"front-kefu-moudle-all-missphone":``,
"font-evaluate-module-v1-emergency":``,
"label.sso.saml.sp.idsource.attr":`신분이 속성 요소에 있습니다.`,
"chatter.not.meg":`빈 메시지를 보낼 수 없습니다`,
"label.chatter.startDate":`시작 일자`,
"label.emailobject.track.times":`{0}번 열어보기`,
"label.customsetting.fieldhasbeendeleted":`삭제된 필드`,
"label.knowledge.setting.hint.thirteen":``,
"message.duplication.label.newfiltertitle":`중복률 검사 필터 새로만들기`,
"setup_object_field_dependency_label_selectedfieldvalue":`선택한 필드값`,
"vue_label_calendar_who_currently_has_access":`방문 권한 있는 사용자`,
"message.passwordPolicy.validate.minlengthe":`개 문자`,
"label.emailsync.status.disconnect":`연동 취소`,
"label.applt.down.one":``,
"label.manageAll.sel.one2":`나의 제출한 프로젝트`,
"message.error.SQLTimeout":`시스템이 복잡하여 잠시 후 시도하세요!`,
"label.global.search.obj.setup":`전역 검색 대상 설정`,
"vue_label_commonobjects_view_chat":`채팅`,
"vue_label_systemSettings_startSet":``,
"label.quickbooks.viewlist.balance":`잔금액`,
"message.error.fieldid.null":`fileinfoid가 필수 요소입니다! 파일 정보id`,
"label.replaceallnullvalue":`모든 공백값을 대체하기`,
"label.georgia.time":`조지아 시간`,
"label.hastransfer":`전환된 것을 포함합니다`,
"label.partner.all.description":`내용`,
"font-evaluate-module-v1-following-peopple":``,
"label_business_count":`업무 기회 수량`,
"vue_label_ccchat_closedetail":`게시물 접기`,
"label.partner.all.disable":`사용 금지`,
"label.view.relationship":`대상 관계`,
"label.noless":`>= 작지 않음`,
"label.sendsms.batch.step2":`2단계: 문자 메시지 템플릿이나 사용자 설정 문자 메시지 내용을 선택하십시오`,
"label.stdashbord.xsld.business.jieduan":`단계 명칭`,
"label.appupload.component.type.trigger":`트리거`,
"label.knowledge.setting.data.two":``,
"label.color.display.of.completion.rate":``,
"label.loginhis.default":`기본으로 최근 200개 이력을 볼 수 있습니다`,
"vue_label_pricebook_book":`현 가격 매뉴얼`,
"label.knowledgebase.data.deletion.failed":``,
"label_partner_workspace_member_permission":`선택 가능한 권한 세트`,
"label.list.userinterface.approval.setup":`승인 설정`,
"label.weixin.binding.effect":`binding이 무효되어 다시 로그인 후 다시 확보하세요`,
"label.appupload.install.newapicannotnull":`새 api 명칭을 입력하세요`,
"chatter.feed.menutype.feed.company":`모든 게시물`,
"label.assignment.setup.detail.email":`메일`,
"label_tabpage_selectcontentz":`내용을 선택하세요`,
"template.report.converted.leads.campaign":``,
"label.forecast.season":`이번 분기`,
"label.post":``,
"label.knowledge.setting.hint.fifteen":``,
"front-kefu-moudle-v1-Seats-name":``,
"label.weixin.leadname":`잠재고객 명칭`,
"label.account.quarter":`분기`,
"label.detail.field":`필드 보기`,
"label.icon.189":`화장품`,
"label.appointment.disable.reappointment":``,
"label.appointmentconfirmpage.wizard.subtitle1":`이벤트 명칭`,
"label.campaign.channel.step6.remark3":`시스템은 직원에게 유일한 초대 코드를 생성하여 직원은 이 코드로 초대할 수 있으며 개인별 성과에도 계산될 수 있습니다.`,
"System.AddressFieldType.Post":`우편 번호`,
"label_partner_new_step2":`2단계: 템플릿 확인`,
"vue_label_helpcenter_file":`파일의 확인 및 관리<br> 새 버전의 파일 대상자를 사용해 갖고 있거나 타인이 공유한 파일을 확인하고 관리한다. 온라인으로 일부 격식의 파일을 미리 볼 수 있다. <br> 파일 베이스 <br> 파일 베이스 기능을 사용해 그룹 지식 베이스를 구축하여 다른 관리자 및 멤버를 지정하며 관리한다. 폴더 기능을 사용해 파일을 분류하고 보관한다.`,
"label.locateddowncurrentvalue":`현재 값 아래에 위치한 값`,
"label.tianyancha.businessverify.msg5":`2: 서비스 신뢰성:`,
"label.setup.mobile.bottombutton.change.success":``,
"label.appointmentconfirmail.wizard.subtitle2":`시간`,
"label.email.address.lookup":`메일 주소 찾기`,
"setup.mainpage.label.welcome":`CloudCC PaaS 플랫폼을 사용하는 것을 환영합니다. 플랫폼의 주요 기능은 다음과 같습니다.`,
"label.icon.55":`불도저`,
"label_tabpage_enterrecordnamez":`기록 소유인을 입력해 주세요`,
"label.tabpage.andz":`및`,
"label.selectfiletoimport":`불러올 파일을 선택하십시오`,
"label.version.sum.trigger":`개 트리거`,
"label.multi.layout":`라인 레이아웃`,
"pagecreator.button.back":`이전`,
"label.imgfield.truetype":`정확한 이미지 유형을 업로드해 주세요`,
"front-kefu-moudle-v1-publicKey":``,
"label.data.exp.newtemp":`템플릿 제작`,
"label.martrixreport.2018.step4.new":`4단계: 보고서 열을 선택합니다`,
"label.sendemail.chat.addComentsatsubject":`CloudCC CCChat댓글에 나를 소환했습니다`,
"vue_label_applauncher_description_leadpool":`잠재 고개풀을 사용해 조직 내 잠재 고객의 팔로우업 상태를 관리하며 인력의 거래 성사를 격려한다.`,
"label.knowledgebase.archive.published.articles.without.drafts":``,
"label.projectManagement.bar.chart":``,
"label.ccpeak.condition.return.sort":`조건에 따라 돌아가 정렬합니다.`,
"label.salescloud.opportunity.contactrole":`업무기회 연락담당자 역할`,
"label.language":`언어`,
"message.error.view.badprevilege":`죄송합니다. 이 서비스에 대한 권한이 없어 시스템 관리자에게 연락하십시오!`,
"label.textmessage.managetemplates":`템플릿 관리`,
"message.error.type.null":``,
"setup.mainpage.label.welcome9":`사용자가 코드 개발 필요없이 마우스를 통해 이동하는 방식으로 모든 폐이지의 구성 요소의 분류, 레이아웃을 설정할 수 있다. 폐이지에서의 필드에 대한 읽기 전용 및 입력 필수 등을 설정할 수 있다.`,
"label.appupload.component.type.page":`사용자 설정 페이지`,
"label.textmessage.bookschedule":`다음의 링크를 클릭하여 나의 일정을 확인하고 예약하세요:`,
"component_chatter_post_button_save":`발표`,
"lable.oppt.jieduan.signcomplete":`{labelname}를 완성으로 표시합니다`,
"label.help.notes":`도움말과 안내메뉴`,
"label_tabpage_reallproplez":`기록 소유인`,
"label.obtain.authorization.failure":``,
"label.account.FiscalQuarter":`회계 분기`,
"label.customsetting.savecustomvalue":`해당 위치에 데이터가 있어 수정한 후 다시 저장하세요`,
"label.maximum":`최대치`,
"component_chatter_file_label_maxsize":`최대 파일 크기가 20M입니다`,
"c218":``,
"c875":``,
"c183":``,
"c366":``,
"c91":``,
"c184":``,
"c750":``,
"c619":``,
"c69":``,
"c675":``,
"c533":``,
"c167":``,
"c682":``,
"c960":``,
"c850":``,
"c343":``,
"c8":``,
"c157":``,
"c397":``,
"c556":``,
"c563":``,
"c179":``,
"c147":``,
"c303":``,
"c885":``,
"c808":``,
"c718":``,
"c414":``,
"c9":``,
"c15":``,
"c59":``,
"c504":``,
"c836":``,
"c187":``,
"c208":``,
"c952":``,
"c104":``,
"c346":``,
"c913":``,
"c571":``,
"c44":``,
"label.social.posts.content.null":``,
"c852":``,
"c561":``,
"obtain.contract.envelopeid.fail":``,
"c465":``,
"c982":``,
"c350":``,
"c352":``,
"c670":``,
"front-electronic-signature-given":``,
"c542":``,
"c314":``,
"c148":``,
"c47":``,
"c754":``,
"c326":``,
"c289":``,
"c196":``,
"c63":``,
"c769":``,
"c216":``,
"c842":``,
"c389":``,
"c7":``,
"c981":``,
"c143":``,
"c930":``,
"c515":``,
"c393":``,
"c357":``,
"c597":``,
"front-electronic-signature-cancelIntro1":``,
"c271":``,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":``,
"c424":``,
"c711":``,
"c197":``,
"front-electronic-signature-save-success":``,
"c765":``,
"c286":``,
"c145":``,
"c264":``,
"label.china":``,
"label.no.bind.mobile":``,
"c95":``,
"front-electronic-signature-open-signInfo1":``,
"c391":``,
"c106":``,
"c519":``,
"c528":``,
"c78":``,
"c41":``,
"c517":``,
"c774":``,
"c296":``,
"c757":``,
"front-electronic-signature-confirmintro":``,
"c446":``,
"c238":``,
"c980":``,
"c802":``,
"c387":``,
"c965":``,
"c480":``,
"c937":``,
"c632":``,
"c131":``,
"c680":``,
"c806":``,
"c649":``,
"c797":``,
"c616":``,
"c169":``,
"c21":``,
"c231":``,
"c555":``,
"c583":``,
"front-electronic-signature-open-signInfo2":``,
"c822":``,
"c600":``,
"c442":``,
"c762":``,
"label.user.not.permission":``,
"c35":``,
"c921":``,
"c305":``,
"c730":``,
"c525":``,
"c942":``,
"c780":``,
"c447":``,
"c369":``,
"c702":``,
"c22":``,
"c79":``,
"c785":``,
"label.insert.approval.reassign.error":``,
"c273":``,
"c3":``,
"c448":``,
"c495":``,
"c429":``,
"c16":``,
"c128":``,
"c955":``,
"c716":``,
"c638":``,
"c746":``,
"c534":``,
"c948":``,
"c317":``,
"c426":``,
"c457":``,
"c263":``,
"c372":``,
"c907":``,
"c771":``,
"c408":``,
"c12":``,
"c379":``,
"c410":``,
"c510":``,
"c701":``,
"c617":``,
"c213":``,
"c473":``,
"c975":``,
"c168":``,
"c121":``,
"label.send.invoice":``,
"c792":``,
"c686":``,
"c652":``,
"c136":``,
"c662":``,
"label.invoice.customer.is.error":``,
"c580":``,
"c894":``,
"c570":``,
"c133":``,
"c564":``,
"c854":``,
"c775":``,
"c105":``,
"c729":``,
"c491":``,
"c609":``,
"c611":``,
"c843":``,
"c933":``,
"c383":``,
"c186":``,
"c608":``,
"c149":``,
"c486":``,
"c598":``,
"c726":``,
"c645":``,
"label.verificationCode.is.invalid":``,
"c904":``,
"c594":``,
"c103":``,
"c188":``,
"c891":``,
"c902":``,
"c484":``,
"c421":``,
"c406":``,
"c739":``,
"c329":``,
"c351":``,
"c622":``,
"2":``,
"c463":``,
"c268":``,
"label.mobile.no.letter.blankcharacter":``,
"c438":``,
"c581":``,
"c953":``,
"c90":``,
"c2":``,
"c897":``,
"c444":``,
"c242":``,
"c135":``,
"c659":``,
"c773":``,
"c11":``,
"c799":``,
"c880":``,
"c890":``,
"c846":``,
"front-electronic-signature-sucessSign":``,
"c472":``,
"c963":``,
"c390":``,
"c248":``,
"c646":``,
"c308":``,
"c858":``,
"c152":``,
"c316":``,
"c435":``,
"c362":``,
"c800":``,
"c415":``,
"c735":``,
"c903":``,
"label.insert.approval.massreassign.error":``,
"c354":``,
"c409":``,
"c651":``,
"c582":``,
"c826":``,
"c781":``,
"c873":``,
"c837":``,
"label.diedirect.sale":``,
"c798":``,
"c368":``,
"c770":``,
"c882":``,
"front-setting-dialog-title-two":``,
"c535":``,
"front-electronic-signature-look-account":``,
"c19":``,
"c52":``,
"c388":``,
"c18":``,
"c820":``,
"c285":``,
"c478":``,
"c164":``,
"label.tip.excess.quota":``,
"c318":``,
"c698":``,
"c312":``,
"c110":``,
"c549":``,
"c845":``,
"c282":``,
"c270":``,
"c288":``,
"c878":``,
"c324":``,
"c129":``,
"c339":``,
"c405":``,
"c848":``,
"c345":``,
"c591":``,
"c180":``,
"c126":``,
"c311":``,
"c587":``,
"c37":``,
"c840":``,
"c241":``,
"c141":``,
"obtain.contract.fail":``,
"c945":``,
"c454":``,
"c34":``,
"c243":``,
"c548":``,
"c807":``,
"c590":``,
"c831":``,
"c198":``,
"c977":``,
"c66":``,
"label.twitter.title.setting":``,
"c922":``,
"front-email-payment-Invoice-Tips":``,
"c605":``,
"c403":``,
"c156":``,
"c635":``,
"c753":``,
"c647":``,
"c295":``,
"c915":``,
"front-electronic-signature-signStatus":``,
"c568":``,
"c744":``,
"c464":``,
"c385":``,
"c392":``,
"c418":``,
"c256":``,
"c690":``,
"c261":``,
"c62":``,
"c892":``,
"c909":``,
"c883":``,
"c134":``,
"c896":``,
"c974":``,
"c209":``,
"c185":``,
"c796":``,
"c60":``,
"c866":``,
"c666":``,
"c219":``,
"c732":``,
"c155":``,
"c511":``,
"c240":``,
"c468":``,
"c961":``,
"c404":``,
"c586":``,
"c694":``,
"c297":``,
"c860":``,
"c58":``,
"c920":``,
"c27":``,
"c94":``,
"c1":``,
"c557":``,
"c294":``,
"c970":``,
"c565":``,
"c668":``,
"c972":``,
"c660":``,
"c433":``,
"c443":``,
"c275":``,
"c691":``,
"c956":``,
"c910":``,
"c692":``,
"c355":``,
"c122":``,
"c395":``,
"c689":``,
"c344":``,
"c656":``,
"c943":``,
"front-electronic-signature-outerSinger":``,
"front-generate-v1-invoiceDetail":``,
"front-electronic-signature-open-vertify":``,
"c291":``,
"front-setting-phone-message":``,
"c559":``,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":``,
"c259":``,
"c488":``,
"c6":``,
"front-electronic-signature-signerInfo":``,
"c512":``,
"c507":``,
"c760":``,
"c756":``,
"c321":``,
"c817":``,
"c949":``,
"label.biaoqing.field.relation.tip":``,
"c382":``,
"c265":``,
"c417":``,
"c847":``,
"c494":``,
"c86":``,
"c776":``,
"c709":``,
"label.mobile.orVerificationCode.is.error":``,
"c579":``,
"c413":``,
"c950":``,
"c573":``,
"label.choose.is.tax":``,
"c768":``,
"c604":``,
"c160":``,
"c239":``,
"c834":``,
"c113":``,
"c146":``,
"c313":``,
"c140":``,
"c298":``,
"c681":``,
"c870":``,
"c551":``,
"c88":``,
"c175":``,
"c64":``,
"c319":``,
"label.pay.online":``,
"c941":``,
"c550":``,
"c365":``,
"c908":``,
"c260":``,
"c50":``,
"c869":``,
"c93":``,
"c280":``,
"c23":``,
"front-console-v1-see-contacts":``,
"c607":``,
"c229":``,
"front-filter-v1-filter-by-name":``,
"c125":``,
"c513":``,
"c80":``,
"c648":``,
"c521":``,
"c560":``,
"c973":``,
"c509":``,
"c685":``,
"c178":``,
"c436":``,
"front-electronic-signature-prepareTemplate":``,
"c749":``,
"c114":``,
"c898":``,
"c279":``,
"c232":``,
"c911":``,
"c901":``,
"c663":``,
"c541":``,
"c536":``,
"front-project-v1-batch-deletion-confirmation-information":``,
"c893":``,
"c623":``,
"c493":``,
"c327":``,
"c747":``,
"c728":``,
"front-reportlist-v1-optimizedReport":``,
"c741":``,
"c643":``,
"c537":``,
"front-electronic-signature-add-field":``,
"c626":``,
"c199":``,
"c917":``,
"c159":``,
"c640":``,
"c192":``,
"c978":``,
"c969":``,
"c871":``,
"c814":``,
"c235":``,
"c215":``,
"c425":``,
"c182":``,
"c194":``,
"c657":``,
"c855":``,
"c333":``,
"c338":``,
"c431":``,
"c374":``,
"c506":``,
"font-trade-module-invoice-totalMoney":``,
"c203":``,
"c962":``,
"c786":``,
"c469":``,
"c137":``,
"c483":``,
"c947":``,
"c190":``,
"c386":``,
"c803":``,
"c759":``,
"c823":``,
"c422":``,
"c782":``,
"c416":``,
"c758":``,
"c407":``,
"c51":``,
"c844":``,
"c361":``,
"c602":``,
"c191":``,
"c299":``,
"c432":``,
"c650":``,
"c531":``,
"c13":``,
"c162":``,
"c171":``,
"c230":``,
"c470":``,
"c367":``,
"c26":``,
"c705":``,
"c613":``,
"front-electronic-signature-openSign":``,
"c349":``,
"c683":``,
"c679":``,
"c914":``,
"c224":``,
"c220":``,
"c498":``,
"c566":``,
"front-electronic-signature-ContractTemplate":``,
"c540":``,
"c793":``,
"c293":``,
"front-invoice-online-pay-again":``,
"front-electronic-signature-open-password":``,
"front-v1-partner-background-tooltip":``,
"c449":``,
"c30":``,
"c245":``,
"c923":``,
"c24":``,
"c872":``,
"c886":``,
"c485":``,
"c101":``,
"c816":``,
"c445":``,
"c853":``,
"c398":``,
"c522":``,
"c287":``,
"c578":``,
"c40":``,
"c631":``,
"c489":``,
"c819":``,
"c935":``,
"c625":``,
"c471":``,
"front-electronic-signature-writen":``,
"c889":``,
"c201":``,
"c467":``,
"label.mobile.no.null":``,
"c307":``,
"front-kefu-moudle-wait-calling":``,
"c784":``,
"c490":``,
"c790":``,
"c336":``,
"c453":``,
"c530":``,
"c610":``,
"c359":``,
"c193":``,
"label.mobile.verificationCode.exceeded.times":``,
"c138":``,
"c821":``,
"c381":``,
"c761":``,
"c964":``,
"c585":``,
"c500":``,
"c214":``,
"c714":``,
"c552":``,
"c684":``,
"c54":``,
"c320":``,
"c236":``,
"c123":``,
"c654":``,
"c335":``,
"c267":``,
"c226":``,
"c102":``,
"c637":``,
"c633":``,
"c777":``,
"c223":``,
"c592":``,
"c315":``,
"c89":``,
"c108":``,
"c402":``,
"c748":``,
"c501":``,
"c269":``,
"front-electronic-signature-open-confirm":``,
"c584":``,
"c437":``,
"c738":``,
"c274":``,
"c83":``,
"c206":``,
"c309":``,
"c539":``,
"c304":``,
"c151":``,
"c639":``,
"c720":``,
"c801":``,
"c900":``,
"c695":``,
"c864":``,
"c881":``,
"c794":``,
"c543":``,
"c466":``,
"c867":``,
"c529":``,
"c742":``,
"c430":``,
"c553":``,
"c575":``,
"c124":``,
"c629":``,
"c554":``,
"c547":``,
"c599":``,
"c588":``,
"c703":``,
"c713":``,
"c142":``,
"c153":``,
"c253":``,
"c612":``,
"c400":``,
"c671":``,
"c20":``,
"c514":``,
"c946":``,
"c717":``,
"c174":``,
"c940":``,
"c743":``,
"c441":``,
"c423":``,
"c723":``,
"c664":``,
"c859":``,
"c356":``,
"c221":``,
"front-email-payment-Invoice-Tips1":``,
"c99":``,
"c278":``,
"c364":``,
"c572":``,
"c310":``,
"c247":``,
"c158":``,
"c325":``,
"c877":``,
"front-filter-v1-press":``,
"c505":``,
"c523":``,
"c727":``,
"front-electronic-signature-sended":``,
"c150":``,
"c700":``,
"c824":``,
"c710":``,
"c358":``,
"c544":``,
"c212":``,
"c165":``,
"c932":``,
"c888":``,
"c838":``,
"c98":``,
"c830":``,
"c661":``,
"c818":``,
"c861":``,
"c736":``,
"c204":``,
"c839":``,
"c456":``,
"c341":``,
"c724":``,
"c865":``,
"c332":``,
"c520":``,
"c906":``,
"c482":``,
"c49":``,
"c725":``,
"c76":``,
"c558":``,
"c876":``,
"front-invoices-v1-nofilles-tocreate":``,
"c779":``,
"c603":``,
"c455":``,
"c428":``,
"c55":``,
"c899":``,
"label.facebook.title":``,
"c487":``,
"label.social.posts.info":``,
"c704":``,
"c673":``,
"front-electronic-signature-singed":``,
"c722":``,
"c595":``,
"c120":``,
"c68":``,
"c479":``,
"front-electronic-signature-explain-mainTitle":``,
"c5":``,
"c976":``,
"c812":``,
"c532":``,
"c330":``,
"c249":``,
"c630":``,
"c958":``,
"c170":``,
"c810":``,
"c783":``,
"c968":``,
"c752":``,
"c439":``,
"c67":``,
"front-generate-v1-invoice":``,
"c477":``,
"c966":``,
"c764":``,
"c301":``,
"c61":``,
"c815":``,
"c827":``,
"c688":``,
"c33":``,
"c217":``,
"c721":``,
"c284":``,
"c939":``,
"c503":``,
"c492":``,
"c73":``,
"label.the.peoples.republic.of.china":``,
"c828":``,
"c36":``,
"c954":``,
"front-electronic-signature-innerSinger":``,
"c508":``,
"c833":``,
"c207":``,
"c31":``,
"c71":``,
"c373":``,
"c545":``,
"c77":``,
"label.lastcompiledate":``,
"c119":``,
"c281":``,
"c715":``,
"c127":``,
"c283":``,
"c919":``,
"c82":``,
"front-file-delete-intro":``,
"c606":``,
"c905":``,
"c644":``,
"c75":``,
"c884":``,
"c538":``,
"c322":``,
"c461":``,
"c825":``,
"c56":``,
"c931":``,
"c276":``,
"c334":``,
"c733":``,
"c384":``,
"c139":``,
"c957":``,
"front-electronic-signature-nosign":``,
"c419":``,
"c934":``,
"c677":``,
"c593":``,
"c272":``,
"c811":``,
"c451":``,
"c277":``,
"c244":``,
"c627":``,
"c601":``,
"c251":``,
"c202":``,
"font-social-prohibit-create":``,
"c394":``,
"c323":``,
"front-setting-dialog-title-one":``,
"front-electronic-signature-cancelIntro2":``,
"c353":``,
"c621":``,
"front-v1-partner-image-tooltip":``,
"c772":``,
"c734":``,
"c380":``,
"c979":``,
"c233":``,
"c458":``,
"c697":``,
"c476":``,
"c634":``,
"c144":``,
"c474":``,
"c371":``,
"c420":``,
"c620":``,
"c708":``,
"c100":``,
"c576":``,
"c751":``,
"c252":``,
"c699":``,
"c74":``,
"c805":``,
"c452":``,
"c740":``,
"c596":``,
"c832":``,
"c971":``,
"c262":``,
"c363":``,
"label.singleSignOn.is.invalid":``,
"c72":``,
"c292":``,
"c499":``,
"c574":``,
"c618":``,
"front-setting-phone-format":``,
"c460":``,
"c189":``,
"label.exe.supported.request.rejected":``,
"c835":``,
"c655":``,
"c45":``,
"c43":``,
"c481":``,
"c674":``,
"c266":``,
"c967":``,
"c154":``,
"c841":``,
"c615":``,
"c84":``,
"c401":``,
"c290":``,
"c205":``,
"c928":``,
"c195":``,
"1":``,
"c46":``,
"c459":``,
"c250":``,
"c399":``,
"c518":``,
"c396":``,
"c300":``,
"c789":``,
"c874":``,
"c38":``,
"c228":``,
"c342":``,
"c879":``,
"c173":``,
"c778":``,
"c211":``,
"c496":``,
"c427":``,
"c851":``,
"c32":``,
"c28":``,
"c163":``,
"c225":``,
"c569":``,
"c92":``,
"c412":``,
"c81":``,
"c653":``,
"c516":``,
"c918":``,
"c809":``,
"c181":``,
"c745":``,
"c669":``,
"c929":``,
"c117":``,
"c938":``,
"c112":``,
"c347":``,
"c795":``,
"c17":``,
"c787":``,
"c829":``,
"c161":``,
"c65":``,
"c665":``,
"c767":``,
"c87":``,
"c589":``,
"front-electronic-signature-newTime":``,
"c813":``,
"c85":``,
"c951":``,
"c29":``,
"c210":``,
"c39":``,
"c672":``,
"c97":``,
"c687":``,
"c916":``,
"c475":``,
"c628":``,
"c788":``,
"c177":``,
"c856":``,
"c70":``,
"c546":``,
"c331":``,
"label.order.paidamount.greater.than.total":``,
"c524":``,
"c246":``,
"label.parameter.is.incorrect":``,
"c667":``,
"c737":``,
"c48":``,
"c111":``,
"c755":``,
"c526":``,
"c450":``,
"front-electronic-export-reChoseChimp":``,
"label.invoice.paidamount.greater.than.total":``,
"c222":``,
"c849":``,
"c678":``,
"c502":``,
"c497":``,
"c200":``,
"c658":``,
"c434":``,
"c641":``,
"c944":``,
"c411":``,
"c624":``,
"label.twitter.title":``,
"c791":``,
"c306":``,
"c14":``,
"c176":``,
"c166":``,
"c731":``,
"c237":``,
"c887":``,
"c227":``,
"c257":``,
"c712":``,
"c107":``,
"c370":``,
"c895":``,
"c693":``,
"c763":``,
"c302":``,
"c577":``,
"c258":``,
"c676":``,
"c868":``,
"c53":``,
"c527":``,
"label.facebook.title.setting":``,
"c340":``,
"c706":``,
"label.mobile.used":``,
"c328":``,
"c337":``,
"c642":``
}